import * as Types from 'graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'graphql/hooks';
const defaultOptions = {} as const;
export const TipoEquipeFragmentDoc = gql`
    fragment TipoEquipe on Equipe {
  id
  tipoEquipe {
    id
    descricao
    nome
    sigla
    codigoMs
  }
}
    `;
export const CboFragmentDoc = gql`
    fragment Cbo on LotacaoOuEstagio {
  ... on Lotacao {
    id
    cbo {
      id
      nome
      cbo2002
      actions {
        cadastroDomiciliar {
          enabled
          hint
        }
        cadastroIndividual {
          enabled
          hint
        }
        atividadeColetiva {
          enabled
          hint
        }
      }
    }
  }
  ... on Estagio {
    cbo {
      id
      nome
      cbo2002
      actions {
        cadastroDomiciliar {
          enabled
          hint
        }
        cadastroIndividual {
          enabled
          hint
        }
        atividadeColetiva {
          enabled
          hint
        }
      }
    }
  }
}
    `;
export const AcessoAdministradorMunicipalFragmentDoc = gql`
    fragment AcessoAdministradorMunicipal on AdministradorMunicipal {
  id
  municipio {
    id
    nome
  }
}
    `;
export const AcessoGestorEstadualFragmentDoc = gql`
    fragment AcessoGestorEstadual on GestorEstadual {
  id
  uf {
    id
    nome
  }
}
    `;
export const AcessoGestorMunicipalFragmentDoc = gql`
    fragment AcessoGestorMunicipal on GestorMunicipal {
  id
  municipio {
    id
    nome
  }
}
    `;
export const AcessoLotacaoFragmentDoc = gql`
    fragment AcessoLotacao on Lotacao {
  id
  ...Cbo
  equipe {
    id
    nome
    ine
  }
  unidadeSaude {
    id
    nome
  }
}
    ${CboFragmentDoc}`;
export const AcessoEstagioFragmentDoc = gql`
    fragment AcessoEstagio on Estagio {
  id
  lotacaoSupervisora {
    id
    profissional {
      id
      nome
    }
  }
  ...Cbo
  equipe {
    id
    nome
    ine
  }
  unidadeSaude {
    id
    nome
  }
}
    ${CboFragmentDoc}`;
export const SessaoDataFragmentDoc = gql`
    fragment SessaoData on Sessao {
  id
  timeout
  expDateAccessTokenGovBr
  recursos
  sessionProvider
  acesso {
    id
    tipo
    moduloInicial
    municipio {
      id
      nome
      uf {
        id
        nome
        sigla
      }
    }
    perfis {
      id
      nome
    }
    ... on AdministradorMunicipal {
      autorizado
      habilitado
    }
    ... on Lotacao {
      unidadeSaude {
        id
        nome
        cnes
        tipo {
          id
          codigoMs
          isTipoAps
        }
        subtipo {
          id
          codigoMs
        }
        tipoEstabelecimento
        isEstabelecimentoAtencaoPrimaria
      }
      equipe {
        id
        nome
        ine
        ...TipoEquipe
      }
      ...Cbo
    }
    ... on Estagio {
      unidadeSaude {
        id
        nome
        cnes
        tipo {
          id
          codigoMs
          isTipoAps
        }
        subtipo {
          id
          codigoMs
        }
        tipoEstabelecimento
      }
      equipe {
        id
        nome
        ine
        ...TipoEquipe
      }
      ...Cbo
      lotacaoSupervisora {
        id
        __typename
        profissional {
          id
          nome
          numeroConselhoClasse
          conselhoClasse {
            id
            sigla
          }
          ufEmissoraConselhoClasse {
            id
            nome
            sigla
          }
        }
        municipio {
          id
          nome
          uf {
            id
            sigla
          }
        }
        unidadeSaude {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
    }
  }
  profissional {
    id
    cpf
    cns
    nome
    nomeSocial
    conselhoClasse {
      id
      sigla
      descricao
    }
    numeroConselhoClasse
    ufEmissoraConselhoClasse {
      id
      nome
      sigla
    }
    usuario {
      id
      aceitouTermosUso
      aceitouTermoTeleinterconsulta
      forcarTrocaSenha
      visualizouNovidades
      mostrarPesquisaSatisfacao
      notificaNovidadesVersao
      hashId
    }
    acessos {
      id
      tipo
      ... on AdministradorMunicipal {
        ...AcessoAdministradorMunicipal
      }
      ... on GestorEstadual {
        ...AcessoGestorEstadual
      }
      ... on GestorMunicipal {
        ...AcessoGestorMunicipal
      }
      ... on Lotacao {
        ...AcessoLotacao
      }
      ... on Estagio {
        ...AcessoEstagio
      }
    }
  }
}
    ${TipoEquipeFragmentDoc}
${CboFragmentDoc}
${AcessoAdministradorMunicipalFragmentDoc}
${AcessoGestorEstadualFragmentDoc}
${AcessoGestorMunicipalFragmentDoc}
${AcessoLotacaoFragmentDoc}
${AcessoEstagioFragmentDoc}`;
export const LotacaoAgendaSelectFragmentDoc = gql`
    fragment LotacaoAgendaSelect on Lotacao {
  id
  ativo
  importada
  hasConfiguracaoAgenda
  hasConfiguracaoAgendaOnline
  profissional {
    id
    nome
    nomeSocial
    cpf
    email
  }
  cbo {
    id
    nome
    cbo2002
  }
  equipe {
    id
    ine
    nome
    tipoEquipe {
      id
      descricao
    }
  }
}
    `;
export const CiapFragmentDoc = gql`
    fragment Ciap on Ciap {
  id
  codigo
  descricao
}
    `;
export const Cid10FragmentDoc = gql`
    fragment Cid10 on Cid10 {
  id
  codigo
  nome
}
    `;
export const Cid11FragmentDoc = gql`
    fragment Cid11 on Cid11 {
  id
  codigo
  nome
  ativo
}
    `;
export const ProblemaCondicaoFragmentDoc = gql`
    fragment ProblemaCondicao on Problema {
  id
  situacao
  ciap {
    ...Ciap
  }
  cid10 {
    ...Cid10
  }
  cid11 {
    ...Cid11
  }
  descricaoOutro
  ultimaEvolucao {
    id
    dataInicio
    dataFim
    situacao
    observacao
    atualizadoEm
  }
  evolucaoAvaliacaoCiapCid {
    id
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}
${Cid11FragmentDoc}`;
export const AlergiaFragmentDoc = gql`
    fragment Alergia on Alergia {
  id
  criticidade
  tipoReacao
  grauCerteza
  categoriaSubstanciaEspecificaLegado
  substanciaEspecificaLegado
}
    `;
export const CidadaoBasicoFragmentDoc = gql`
    fragment CidadaoBasico on CidadaoBasico {
  id
  nome
  nomeSocial
  nomeTradicional
  cpf
  cns
  nomeMae
  dataNascimento
  presenteListaAtendimento
}
    `;
export const EncaminhamentoExternoEspecializadoFragmentDoc = gql`
    fragment EncaminhamentoExternoEspecializado on EncaminhamentoExternoEspecializado {
  id
  motivoEncaminhamento
  classificacaoRiscoEncaminhamento
  complemento
  observacoes
  especialidadeSisreg {
    id
    descricao
  }
  hipoteseDiagnosticoCid10 {
    id
    codigo
    nome
  }
  hipoteseDiagnosticoCiap {
    id
    codigo
    descricao
  }
  atendimentoProfissional {
    id
    iniciadoEm
    lotacao {
      id
      profissional {
        id
      }
    }
  }
}
    `;
export const LotacaoAtendimentoCompartilhadoFragmentDoc = gql`
    fragment LotacaoAtendimentoCompartilhado on Lotacao {
  id
  profissional {
    id
    nome
    nomeSocial
    cpf
  }
  unidadeSaude {
    id
    nome
    cnes
  }
  cbo {
    id
    nome
    cbo2002
  }
  equipe {
    id
    ine
    nome
    isAD
  }
}
    `;
export const ProfissionalBasicoFragmentDoc = gql`
    fragment ProfissionalBasico on Profissional {
  id
  nome
  nomeSocial
  cpf
  cns
}
    `;
export const UnidadeSaudeBasicoFragmentDoc = gql`
    fragment UnidadeSaudeBasico on UnidadeSaude {
  id
  nome
  cnes
}
    `;
export const CboBasicoFragmentDoc = gql`
    fragment CboBasico on Cbo {
  id
  nome
  cbo2002
}
    `;
export const EquipeBasicoFragmentDoc = gql`
    fragment EquipeBasico on Equipe {
  id
  ine
  nome
}
    `;
export const LotacaoBasicoFragmentDoc = gql`
    fragment LotacaoBasico on Lotacao {
  id
  ativo
  profissional {
    ...ProfissionalBasico
  }
  unidadeSaude {
    ...UnidadeSaudeBasico
  }
  cbo {
    ...CboBasico
  }
  equipe {
    ...EquipeBasico
  }
}
    ${ProfissionalBasicoFragmentDoc}
${UnidadeSaudeBasicoFragmentDoc}
${CboBasicoFragmentDoc}
${EquipeBasicoFragmentDoc}`;
export const MunicipioFragmentDoc = gql`
    fragment Municipio on Municipio {
  id
  ibge
  nome
  uf {
    id
    nome
    sigla
  }
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  number
  size
  totalPages
  totalElements
  sort
  first
  last
  numberOfElements
}
    `;
export const PoloBaseFragmentDoc = gql`
    fragment PoloBase on PoloBase {
  id
  nome
  dsei {
    id
    nome
  }
}
    `;
export const ProcedimentoFragmentDoc = gql`
    fragment Procedimento on Procedimento {
  id
  descricao
  codigo
  ativo
  procedimentoReferencia {
    id
    descricao
    codigo
    ativo
  }
}
    `;
export const ResultadoExameFragmentDoc = gql`
    fragment ResultadoExame on ResultadoExame {
  id
  exame {
    ...Procedimento
  }
  solicitacao {
    id
    data
    atendimentoProfissional {
      id
      lotacao {
        id
        cbo {
          id
          nome
        }
        unidadeSaude {
          id
          nome
        }
        profissional {
          id
          nome
        }
      }
    }
  }
  especifico {
    id
    exameEspecificoEnum
    valor
    igDias
    igSemanas
    dpp
    resultadoExamePuericulturaEnum
    resultadoExameEstruturadoQualitativoEnum
  }
  dataResultado
  dataRealizacao
  dataSolicitacao
  conferido
  observacao
  resultado
  atendimentoProfissionalResultado {
    id
    lotacao {
      id
      cbo {
        id
        nome
      }
      unidadeSaude {
        id
        nome
      }
      profissional {
        id
        nome
      }
    }
  }
}
    ${ProcedimentoFragmentDoc}`;
export const SolicitacaoExameFragmentDoc = gql`
    fragment SolicitacaoExame on SolicitacaoExame {
  id
  data
  tipoExame
  justificativa
  observacoes
  exames {
    id
    conferido
    observacao
    solicitacao {
      id
      data
    }
    exame {
      ...Procedimento
    }
  }
  cid10 {
    ...Cid10
    ciapsRelacionadas {
      id
    }
  }
  atendimentoProfissional {
    id
    lotacao {
      id
      cbo {
        id
        nome
      }
      unidadeSaude {
        id
        nome
      }
      profissional {
        id
        nome
      }
    }
  }
  solicitacaoCitopatologico {
    id
    questoes {
      id
      pergunta
      resposta
    }
  }
  solicitacaoMamografia {
    id
    questoes {
      id
      pergunta
      resposta
    }
  }
}
    ${ProcedimentoFragmentDoc}
${Cid10FragmentDoc}`;
export const SubstanciaEspecificaAlergiaFragmentDoc = gql`
    fragment SubstanciaEspecificaAlergia on SubstanciaEspecificaAlergia {
  id
  coSubstanciaEspecifica
  coPrincipioAtivo
  categoria
  nome
}
    `;
export const BuscaCidadaoListagemProblemasFragmentDoc = gql`
    fragment BuscaCidadaoListagemProblemas on Prontuario {
  id
  problemas {
    id
    ultimaEvolucao {
      id
      situacao
    }
    ciap {
      id
      gruposCondicao {
        id
        grupo
      }
    }
    cid10 {
      id
      gruposCondicao {
        id
        grupo
      }
    }
  }
}
    `;
export const VacinacaoGrupoConsolidadoFragmentDoc = gql`
    fragment VacinacaoGrupoConsolidado on VacinacaoGrupoConsolidado {
  grupoImunobiologico
  vacinas {
    ordem
    dose
    dataAplicacao
    nome
    sigla
  }
}
    `;
export const AgendamentoFragmentDoc = gql`
    fragment Agendamento on Agendado {
  id
  horarioInicial
  horarioFinal
  dataCriacao
  origem
  observacao
  situacao
  situacaoSincronizacao
  isForaUbs
  isAtencaoDomiciliar
  tipoAgendamento
  cidadao {
    id
    nome
    nomeSocial
    contato {
      id
      email
    }
  }
  localAtendimento {
    id
    localAtendimentoExibicao
  }
  enviouEmailCidadao
}
    `;
export const LotacaoAssociadaAgendamentoFragmentDoc = gql`
    fragment LotacaoAssociadaAgendamento on Lotacao {
  id
  ativo
  profissional {
    id
    nome
    nomeSocial
  }
  cbo {
    id
    nome
    cbo2002
  }
  equipe {
    id
    nome
    ine
    tipoEquipe {
      id
      descricao
    }
  }
}
    `;
export const EstagioAssociadoAgendamentoFragmentDoc = gql`
    fragment EstagioAssociadoAgendamento on Estagio {
  id
  ativo
  profissional {
    id
    nome
    nomeSocial
  }
  cbo {
    id
    nome
    cbo2002
  }
  equipe {
    id
    nome
    ine
    tipoEquipe {
      id
      descricao
    }
  }
}
    `;
export const ResponsavelAtendimentoObservacaoFragmentDoc = gql`
    fragment ResponsavelAtendimentoObservacao on Lotacao {
  id
  profissional {
    id
    nome
    cpf
  }
}
    `;
export const AcompanhamentoPreNatalVacinaFragmentFragmentDoc = gql`
    fragment AcompanhamentoPreNatalVacinaFragment on AcompanhamentoPreNatalVacinacao {
  vacina {
    idImuno
    nomeImuno
    siglaDoseImuno
    dataRegistro
  }
  idadeGestacionalEmSemanasAplicacao
}
    `;
export const BeneficiarioBolsaFamiliaFragmentDoc = gql`
    fragment BeneficiarioBolsaFamilia on Cidadao {
  id
  beneficiarioBolsaFamilia {
    id
    isBeneficiario
    vigencia
  }
}
    `;
export const CuidadoCompartilhadoDwFragmentDoc = gql`
    fragment CuidadoCompartilhadoDw on Historico {
  ciapNome
  ciapCodigo
  cidNome
  cidCodigo
  classificacaoPrioridade
  reclassificacaoPrioridade
  conduta
  cnsSolicitante
  nomeSolicitante
  cboSolicitante
  ineSolicitante
  siglaEquipeSolicitante
  nomeUbsSolicitante
  cnsExecutante
  nomeExecutante
  cboExecutante
  ineExecutante
  siglaEquipeExecutante
  nomeUbsExecutante
}
    `;
export const HistoricoAntecedentesPecFragmentFragmentDoc = gql`
    fragment HistoricoAntecedentesPecFragment on AtendimentoProfissional {
  id
  antecedentes {
    id
    observacoes
    puericultura {
      tipoGravidez
      tipoParto
      idadeGestacionalDias
      idadeGestacionalSemanas
      apgarUm
      apgarCinco
      apgarDez
      peso
      comprimento
      perimetroCefalico
    }
    informacoesObstetricas {
      gestaPrevias
      abortos
      partos
      partosVaginais
      partosCesareas
      partosDomiciliares
      nascidosVivos
      natimortos
      recemNascidoAbaixo
      recemNascidoAcima
      filhosVivos
      obitoAntesPrimeiraSemana
      obitoAposPrimeiraSemana
      desfechoUltimaGestacao
    }
  }
  cirurgiasInternacoes {
    id
    descricao
    observacoes
    dataCirurgiaInternacao
  }
}
    `;
export const HistoricoAvaliacaoPecFragmentFragmentDoc = gql`
    fragment HistoricoAvaliacaoPecFragment on AtendimentoProfissional {
  id
  evolucaoAvaliacao {
    id
    descricao
    ciapsCids {
      id
      ciap {
        ...Ciap
      }
      cid10 {
        ...Cid10
      }
      cid11 {
        ...Cid11
      }
      nota
      isCiapCidNaListaDeProblemas
    }
  }
  evolucaoProblema {
    id
    problema {
      id
      cid10 {
        ...Cid10
      }
      cid11 {
        ...Cid11
      }
      ciap {
        ...Ciap
      }
      descricaoOutro
      situacao
    }
    dataInicio
    dataFim
    situacao
    observacao
    atualizadoEm
    possuiCid
    possuiCid11
    possuiCiap
  }
  alergiaEvolucao {
    id
    alergia {
      id
      substanciaEspecifica {
        id
        categoria
        nome
        sinonimos
        sigla
      }
      substanciaEspecificaLegado
      categoriaSubstanciaEspecificaLegado
    }
    criticidade
    dataInicio
    observacao
    tipoReacao
    grauCerteza
    manifestacoes {
      id
      nome
      sinonimo
    }
    manifestacoesLegado
    possuiSubstanciaEspecificaCbara
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}
${Cid11FragmentDoc}`;
export const HistoricoDesfechoPecFragmentFragmentDoc = gql`
    fragment HistoricoDesfechoPecFragment on AtendimentoProfissional {
  id
  racionalidadeSaude
  condutas
  procedimentosAtendimento {
    id
    procedimento {
      id
      codigo
      descricao
    }
  }
  notificacoesCasoSuspeito {
    id
    notificacao {
      id
      nomeNotificacao
    }
  }
}
    `;
export const HistoricoDesfechoOdontoPecFragmentFragmentDoc = gql`
    fragment HistoricoDesfechoOdontoPecFragment on AtendimentoProfissional {
  id
  ...HistoricoDesfechoPecFragment
  atendimentoProfissionalOdonto {
    id
    cdsTipoFornecimOdonto
    tipoConduta
  }
}
    ${HistoricoDesfechoPecFragmentFragmentDoc}`;
export const HistoricoDimensaoProcedimentoFragmentDoc = gql`
    fragment HistoricoDimensaoProcedimento on DimensaoProcedimento {
  id
  codigoProcedimento
  descricaoProcedimento
  dimensaoProcedimentoReferencia {
    id
    codigoProcedimento
    descricaoProcedimento
  }
}
    `;
export const HistoricoFinalizadorObservacaoFragmentFragmentDoc = gql`
    fragment HistoricoFinalizadorObservacaoFragment on AtendimentoProfissional {
  id
  atendimentoProfissionalObservacao {
    id
    atendimentoObservacao {
      id
      atendimentoProfissionalFinalizador {
        id
        lotacao {
          id
          profissional {
            id
            nome
            nomeCivil
            nomeSocial
          }
          unidadeSaude {
            id
            nome
            cnes
            tipoEstabelecimento
          }
          ...AcessoLotacao
        }
      }
    }
  }
}
    ${AcessoLotacaoFragmentDoc}`;
export const HistoricoInfoAdministrativasPecFragmentFragmentDoc = gql`
    fragment HistoricoInfoAdministrativasPecFragment on AtendimentoProfissional {
  id
  estagio {
    id
    profissional {
      id
      nome
      nomeCivil
      nomeSocial
    }
    cbo {
      id
      nome
    }
    equipe {
      id
      nome
      ine
    }
  }
  atendimento {
    id
    localAtendimento {
      id
      localAtendimentoExibicao
    }
    isRegistroTardio
    dataCriacaoRegistro
  }
  lotacao {
    id
    profissional {
      id
      nome
      nomeCivil
      nomeSocial
    }
    unidadeSaude {
      id
      nome
      cnes
      tipoEstabelecimento
    }
    ...AcessoLotacao
  }
  lotacaoAtendimentoCompartilhado {
    id
    profissional {
      id
      nome
      nomeCivil
      nomeSocial
    }
    unidadeSaude {
      id
      nome
      cnes
    }
    ...AcessoLotacao
  }
  tipoParticipacaoCidadao
  tipoParticipacaoProfissionalConvidado
  ...HistoricoFinalizadorObservacaoFragment
}
    ${AcessoLotacaoFragmentDoc}
${HistoricoFinalizadorObservacaoFragmentFragmentDoc}`;
export const MedicoesFragmentFragmentDoc = gql`
    fragment MedicoesFragment on Medicao {
  id
  valorPeso
  valorAltura
  valorFrequenciaCardiaca
  valorPressaoArterial
  valorPerimetroCefalico
  valorFrequenciaRespiratoria
  valorTemperatura
  valorSaturacaoO2
  valorGlicemia
  tipoGlicemia
  perimetroPanturrilha
  valorCircunferenciaAbdominal
  valorForcaMuscMaoDireita
  unidadeForcaMuscMaoDireita
  valorForcaMuscMaoEsquerda
  unidadeForcaMuscMaoEsquerda
  pele
  olhoDireito
  olhoEsquerdo
  ouvidoDireito
  ouvidoEsquerdo
  membroInferiorDireito
  membroInferiorEsquerdo
}
    `;
export const HistoricoObjetivoPecFragmentFragmentDoc = gql`
    fragment HistoricoObjetivoPecFragment on AtendimentoProfissional {
  id
  evolucaoObjetivo {
    id
    descricao
  }
  medicoes {
    ...MedicoesFragment
    valorImc
    dum
    valorVacinacaoEmDia
  }
  marcadorConsumoAlimentar {
    id
    categoria
    respostas {
      pergunta
      opcoesSelecionadas
    }
  }
  examesResultados {
    id
    exame {
      ...Procedimento
    }
    dataSolicitacao
    dataRealizacao
    dataResultado
    resultado
    especifico {
      id
      exameEspecificoEnum
      valor
      igDias
      igSemanas
      dpp
      resultadoExamePuericulturaEnum
      resultadoExameEstruturadoQualitativoEnum
    }
  }
  ivcf {
    id
    resultado
    dimensoesAlteradas
    riscoVulnerabilidade
  }
  arquivosAnexados {
    id
    titulo
    observacao
    categoria
    arquivo {
      id
      uuid
      formato
    }
    atendimentoProfissional {
      id
    }
  }
  mChats {
    id
    pontuacao
    risco
    aplicacao {
      id
      pergunta
      textoPergunta
      stPassou
      outros
      perguntaOpcao
    }
    isMchatRf
  }
}
    ${MedicoesFragmentFragmentDoc}
${ProcedimentoFragmentDoc}`;
export const HistoricoPlanoCuidadoFragmentFragmentDoc = gql`
    fragment HistoricoPlanoCuidadoFragment on AtendimentoProfissional {
  id
  planosDeCuidado {
    id
    descricao
    dataDescricao
  }
}
    `;
export const CboHistoricoCuidadoCompartilhadoHeaderFragmentDoc = gql`
    fragment CboHistoricoCuidadoCompartilhadoHeader on Cbo {
  id
  nome
}
    `;
export const UnidadeSaudeHistoricoCuidadoCompartilhadoHeaderFragmentDoc = gql`
    fragment UnidadeSaudeHistoricoCuidadoCompartilhadoHeader on UnidadeSaude {
  id
  nome
  cnes
}
    `;
export const LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc = gql`
    fragment LotacaoHistoricoCuidadoCompartilhadoHeader on Lotacao {
  id
  profissional {
    id
    cns
    nome
    nomeCivil
    nomeSocial
  }
  cbo {
    ...CboHistoricoCuidadoCompartilhadoHeader
  }
  equipe {
    id
    ine
    nome
  }
  unidadeSaude {
    ...UnidadeSaudeHistoricoCuidadoCompartilhadoHeader
  }
}
    ${CboHistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${UnidadeSaudeHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;
export const HistoricoPlanoPecCuidadoCompartilhadoFragmentDoc = gql`
    fragment HistoricoPlanoPecCuidadoCompartilhado on CuidadoCompartilhado {
  id
  discussao
  ciap {
    ...Ciap
  }
  cid10 {
    ...Cid10
  }
  cidadaoAceitaAtendTic
  primeiraEvolucao {
    id
    classificacaoPrioridade
    lotacaoExecutante {
      ...LotacaoHistoricoCuidadoCompartilhadoHeader
    }
    cboExecutante {
      ...CboHistoricoCuidadoCompartilhadoHeader
    }
    unidadeSaudeExecutante {
      ...UnidadeSaudeHistoricoCuidadoCompartilhadoHeader
    }
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}
${LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${CboHistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${UnidadeSaudeHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;
export const EspecialidadesEsusRegFragmentDoc = gql`
    fragment EspecialidadesEsusReg on EspecialidadeEsusReg {
  id
  nome
}
    `;
export const HistoricoPlanoPecGuiaEncaminhamentoFragmentDoc = gql`
    fragment HistoricoPlanoPecGuiaEncaminhamento on GuiaEncaminhamento {
  id
  discussao
  classificacaoPrioridade
  ciap {
    ...Ciap
  }
  cid10 {
    ...Cid10
  }
  cbo {
    id
    nome
  }
  especialidade {
    ...EspecialidadesEsusReg
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}
${EspecialidadesEsusRegFragmentDoc}`;
export const HistoricoPlanoPecFragmentFragmentDoc = gql`
    fragment HistoricoPlanoPecFragment on AtendimentoProfissional {
  id
  evolucaoPlano {
    id
    descricao
    intervencoesProcedimentos {
      id
      ciap {
        ...Ciap
      }
      procedimento {
        id
        descricao
        codigo
      }
      nota
    }
  }
  quantidadeAtestados
  quantidadeOrientacoes
  encaminhamentos
  encaminhamentosEspecializados {
    id
    observacoes
    motivoEncaminhamento
    hipoteseDiagnosticoCid10 {
      id
      codigo
      nome
    }
    hipoteseDiagnosticoCiap {
      id
      codigo
      descricao
    }
    complemento
    classificacaoRiscoEncaminhamento
    especialidadeSisreg {
      id
      descricao
    }
  }
  requisicoesExames {
    id
    justificativa
    observacoes
    tipoExame
    cid10 {
      id
      codigo
      nome
    }
    exames {
      id
      observacao
      exame {
        ...Procedimento
      }
    }
  }
  receitaMedicamento {
    id
    medicamento {
      id
      principioAtivo
      concentracao
      formaFarmaceutica {
        id
        nome
      }
    }
    aplicacaoMedicamento {
      id
      nome
    }
    quantidadeReceitada
    recomendacoes
    posologia
    dtInicioTratamento
    dtFimTratamento
    medidaTempoTratamento
    cid10 {
      ...Cid10
    }
    ciap {
      ...Ciap
    }
  }
  cuidadosCompartilhados {
    ...HistoricoPlanoPecCuidadoCompartilhado
  }
  guiasEncaminhamento {
    ...HistoricoPlanoPecGuiaEncaminhamento
  }
}
    ${CiapFragmentDoc}
${ProcedimentoFragmentDoc}
${Cid10FragmentDoc}
${HistoricoPlanoPecCuidadoCompartilhadoFragmentDoc}
${HistoricoPlanoPecGuiaEncaminhamentoFragmentDoc}`;
export const HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc = gql`
    fragment HistoricoRegistrosAnterioresVacinacaoFragment on AtendimentoProfissional {
  id
  vacinacao {
    id
    registrosVacinacao {
      id
      imunobiologico {
        id
        nome
      }
      doseImunobiologico {
        id
        sigla
      }
      dataAplicacao
      tipoRegistroVacinacao {
        id
        identificador
      }
      loteImunobiologico {
        id
        lote
        fabricante {
          id
          nome
        }
      }
      isRegistroAnterior
      isAplicadoExterior
      observacoes
      estrategiaVacinacao {
        id
        nome
      }
    }
  }
}
    `;
export const HistoricoSubjetivoPecFragmentFragmentDoc = gql`
    fragment HistoricoSubjetivoPecFragment on AtendimentoProfissional {
  id
  evolucaoSubjetivo {
    id
    descricao
    ciaps {
      id
      ciap {
        ...Ciap
      }
      nota
    }
  }
}
    ${CiapFragmentDoc}`;
export const SolicitacoesOciDwFragmentFragmentDoc = gql`
    fragment SolicitacoesOciDwFragment on FatoSolicitacaoOci {
  id
  dimensaoProcedimento {
    id
    codigoProcedimento
    descricaoProcedimento
  }
}
    `;
export const SolicitacoesOciHistoricoFragmentFragmentDoc = gql`
    fragment SolicitacoesOciHistoricoFragment on SolicitacaoExame {
  id
  justificativa
  observacoes
  tipoExame
  cid10 {
    id
    codigo
    nome
  }
  procedimentos: exames {
    id
    observacao
    procedimento: exame {
      ...Procedimento
    }
  }
}
    ${ProcedimentoFragmentDoc}`;
export const HistoricoCuidadoCompartilhadoEvolucaoHeaderFragmentDoc = gql`
    fragment HistoricoCuidadoCompartilhadoEvolucaoHeader on CuidadoCompartilhadoEvolucao {
  id
  conduta
  classificacaoPrioridade
  reclassificacaoPrioridade
  lotacaoExecutante {
    ...LotacaoHistoricoCuidadoCompartilhadoHeader
  }
  cboExecutante {
    ...CboHistoricoCuidadoCompartilhadoHeader
  }
  unidadeSaudeExecutante {
    ...UnidadeSaudeHistoricoCuidadoCompartilhadoHeader
  }
}
    ${LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${CboHistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${UnidadeSaudeHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;
export const HistoricoCuidadoCompartilhadoHeaderFragmentDoc = gql`
    fragment HistoricoCuidadoCompartilhadoHeader on CuidadoCompartilhado {
  id
  cid10 {
    ...Cid10
  }
  ciap {
    ...Ciap
  }
  lotacaoSolicitante {
    ...LotacaoHistoricoCuidadoCompartilhadoHeader
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}
${LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;
export const GrupoMedicoesCardFragmentDoc = gql`
    fragment GrupoMedicoesCard on GrupoMedicoesTipo {
  tipo
  medicoes {
    dataMedicao
    valor
    observacao
  }
}
    `;
export const LotacaoSugestaoAgendamentoFragmentDoc = gql`
    fragment LotacaoSugestaoAgendamento on Lotacao {
  id
  profissional {
    id
    nome
    cpf
  }
  cbo {
    id
    nome
    cbo2002
  }
  equipe {
    id
    ine
    nome
    tipoEquipe {
      id
      descricao
    }
  }
  ativo
  importada
}
    `;
export const UltimoMChatFragmentDoc = gql`
    fragment UltimoMChat on MChat {
  id
  pontuacao
  risco
  isMchatRf
  dataResultado
  aplicacao {
    id
    pergunta
    textoPergunta
    stPassou
    outros
    perguntaOpcao
  }
  atendimentoProfissional {
    id
    lotacao {
      id
      profissional {
        id
        nome
        nomeSocial
      }
      cbo {
        id
        nome
      }
    }
  }
}
    `;
export const CompartilhamentoCuidadoLotacaoFragmentDoc = gql`
    fragment CompartilhamentoCuidadoLotacao on Lotacao {
  id
  profissional {
    id
    nome
    nomeSocial
    cpf
    cns
  }
}
    `;
export const GuiasEncaminhamentoFragmentDoc = gql`
    fragment GuiasEncaminhamento on GuiaEncaminhamento {
  id
  cbo {
    ...CboBasico
  }
  cid10 {
    ...Cid10
  }
  ciap {
    ...Ciap
  }
  classificacaoPrioridade
  discussao
  especialidade {
    ...EspecialidadesEsusReg
  }
}
    ${CboBasicoFragmentDoc}
${Cid10FragmentDoc}
${CiapFragmentDoc}
${EspecialidadesEsusRegFragmentDoc}`;
export const ResponsavelAtendimentoCommonFragmentDoc = gql`
    fragment ResponsavelAtendimentoCommon on LotacaoOuEstagio {
  ... on Lotacao {
    id
    unidadeSaude {
      id
      nome
      cnes
    }
    equipe {
      id
      ine
      nome
      isAD
      tipoEquipe {
        id
        nome
        sigla
      }
    }
  }
  ... on Estagio {
    unidadeSaude {
      id
      nome
      cnes
    }
    equipe {
      id
      ine
      nome
      isAD
      tipoEquipe {
        id
        nome
        sigla
      }
    }
  }
}
    `;
export const ResponsavelAtendimentoLotacaoFragmentDoc = gql`
    fragment ResponsavelAtendimentoLotacao on Lotacao {
  id
  cbo {
    id
    nome
    cbo2002
  }
  ...ResponsavelAtendimentoCommon
}
    ${ResponsavelAtendimentoCommonFragmentDoc}`;
export const ResponsavelAtendimentoEstagioFragmentDoc = gql`
    fragment ResponsavelAtendimentoEstagio on Estagio {
  id
  cbo {
    id
    nome
    cbo2002
  }
  ...ResponsavelAtendimentoCommon
}
    ${ResponsavelAtendimentoCommonFragmentDoc}`;
export const FatoAtividadeColetivaFragmentFragmentDoc = gql`
    fragment FatoAtividadeColetivaFragment on FatoAtividadeColetiva {
  id
  dataRegistro
  nuParticipantes
  descricaoOutraLocalidade
  stPseEducacao
  stPseSaude
  dimensaoProfissional {
    id
    nome
  }
  dimensaoCbo {
    id
    nome
    cbo
  }
  dimensaoUnidadeSaude {
    id
    nome
    cnes
  }
  dimensaoEquipe {
    id
    nome
    ine
  }
  dimensaoTipoAtividade {
    id
    nuIdentificador
  }
  dimensaoTurno {
    id
    descricao
  }
  dimensaoUnddSadeAcdmSade {
    id
    nome
    cnes
  }
  fatoAtividadeColetivaProfissionalParticipante {
    id
    dimensaoProfissionalParticipante {
      id
      cns
      nome
    }
    dimensaoCboParticipante {
      id
      nome
      cbo
    }
  }
}
    `;
export const ImovelInativacaoFieldsFragmentDoc = gql`
    fragment ImovelInativacaoFields on ImovelDto {
  id
  tipoLogradouro {
    id
    nome
  }
  bairro
  logradouro
  numero
  cep
  complemento
  microarea
  dataUltimaAtualizacao
  unidadeSaude {
    id
    nome
    cnes
    ativo
  }
  equipe {
    id
    nome
    ine
    ativo
  }
  familias(
    input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true}
  ) {
    id
    responsavel {
      id
      nome
      nomeSocial
    }
  }
  permissaoReterritorializar {
    enabled
    hint
  }
}
    `;
export const CuidadoCompartilhadoEvolucaoGarantiaAcessoFragmentFragmentDoc = gql`
    fragment CuidadoCompartilhadoEvolucaoGarantiaAcessoFragment on CuidadoCompartilhadoEvolucao {
  id
  cuidadoCompartilhado {
    id
    lotacaoSolicitante {
      id
      equipe {
        id
        nome
        area
      }
      profissional {
        id
        nome
        email
      }
      cbo {
        id
        nome
      }
    }
    classificacaoPrioridadeAtual
  }
  lotacaoExecutante {
    id
    equipe {
      id
      nome
      area
    }
    profissional {
      id
      nome
      email
    }
    cbo {
      id
      nome
    }
  }
  condutaAgendamento: enviarGarantiaAcesso
}
    `;
export const ProfissionalDetailFragmentDoc = gql`
    fragment ProfissionalDetail on Profissional {
  cns
  conselhoClasse {
    id
    descricao
    sigla
  }
  cpf
  dataNascimento
  email
  endereco {
    bairro
    cep
    complemento
    logradouro
    numero
    pontoReferencia
    municipio {
      id
      ibge
      nome
      uf {
        id
        nome
        sigla
      }
    }
    semNumero
    tipoLogradouro {
      id
      nome
      numeroDne
    }
    uf {
      id
      nome
      sigla
    }
  }
  id
  nomeCivil
  nomeSocial
  numeroConselhoClasse
  sexo
  telefone
  ufEmissoraConselhoClasse {
    id
    nome
    sigla
  }
}
    `;
export const AnimaisDomicilioFragmentFragmentDoc = gql`
    fragment AnimaisDomicilioFragment on ImovelDto {
  id
  animaisImovel {
    id
    possuiAnimais
    possuiGato
    possuiCachorro
    possuiPassaro
    possuiMacaco
    possuiGalinha
    possuiPorco
    possuiRepteis
    possuiOutros
    quantidadeAnimais
  }
}
    `;
export const CondicoesMoradiaFragmentFragmentDoc = gql`
    fragment CondicoesMoradiaFragment on ImovelDto {
  id
  condicoesMoradia {
    id
    tipoAbastecimentoAgua
    tipoSituacaoMoradia
    tipoTratamentoAgua
    tipoPosseTerra
    tipoMaterialParede
    tipoLocalizacao
    tipoEscoamentoSanitario
    tipoDomicilio
    tipoDestinoLixo
    tipoAcessoDomicilio
    isEnergiaEletricaDisponivel
    tipoOrigemEnergiaEletrica
    numeroComodos
  }
}
    `;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    ...SessaoData
  }
}
    ${SessaoDataFragmentDoc}`;
export type LogoutMutationFn = Apollo.MutationFunction<Types.LogoutMutation, Types.LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.LogoutMutation, Types.LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<Types.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables>;
export const RecursosByAtorPapelIdDocument = gql`
    query RecursosByAtorPapelId($atorPapelId: ID!) {
  recursosByAtorPapelId(atorPapelId: $atorPapelId)
}
    `;

/**
 * __useRecursosByAtorPapelIdQuery__
 *
 * To run a query within a React component, call `useRecursosByAtorPapelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecursosByAtorPapelIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecursosByAtorPapelIdQuery({
 *   variables: {
 *      atorPapelId: // value for 'atorPapelId'
 *   },
 * });
 */
export function useRecursosByAtorPapelIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables> & ({ variables: Types.RecursosByAtorPapelIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>(RecursosByAtorPapelIdDocument, options);
      }
export function useRecursosByAtorPapelIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>(RecursosByAtorPapelIdDocument, options);
        }
export function useRecursosByAtorPapelIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>(RecursosByAtorPapelIdDocument, options);
        }
export type RecursosByAtorPapelIdQueryHookResult = ReturnType<typeof useRecursosByAtorPapelIdQuery>;
export type RecursosByAtorPapelIdLazyQueryHookResult = ReturnType<typeof useRecursosByAtorPapelIdLazyQuery>;
export type RecursosByAtorPapelIdSuspenseQueryHookResult = ReturnType<typeof useRecursosByAtorPapelIdSuspenseQuery>;
export type RecursosByAtorPapelIdQueryResult = Apollo.QueryResult<Types.RecursosByAtorPapelIdQuery, Types.RecursosByAtorPapelIdQueryVariables>;
export const SessaoDocument = gql`
    query Sessao {
  sessao {
    ...SessaoData
  }
}
    ${SessaoDataFragmentDoc}`;

/**
 * __useSessaoQuery__
 *
 * To run a query within a React component, call `useSessaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SessaoQuery, Types.SessaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SessaoQuery, Types.SessaoQueryVariables>(SessaoDocument, options);
      }
export function useSessaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SessaoQuery, Types.SessaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SessaoQuery, Types.SessaoQueryVariables>(SessaoDocument, options);
        }
export function useSessaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SessaoQuery, Types.SessaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SessaoQuery, Types.SessaoQueryVariables>(SessaoDocument, options);
        }
export type SessaoQueryHookResult = ReturnType<typeof useSessaoQuery>;
export type SessaoLazyQueryHookResult = ReturnType<typeof useSessaoLazyQuery>;
export type SessaoSuspenseQueryHookResult = ReturnType<typeof useSessaoSuspenseQuery>;
export type SessaoQueryResult = Apollo.QueryResult<Types.SessaoQuery, Types.SessaoQueryVariables>;
export const EnderecoDocument = gql`
    query Endereco($cep: String!) {
  endereco(cep: $cep) {
    municipio {
      id
      nome
    }
    uf {
      id
      nome
      sigla
    }
    logradouro
    tipoLogradouro {
      id
      nome
      numeroDne
    }
    bairro {
      id
      nome
    }
  }
}
    `;

/**
 * __useEnderecoQuery__
 *
 * To run a query within a React component, call `useEnderecoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnderecoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnderecoQuery({
 *   variables: {
 *      cep: // value for 'cep'
 *   },
 * });
 */
export function useEnderecoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EnderecoQuery, Types.EnderecoQueryVariables> & ({ variables: Types.EnderecoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EnderecoQuery, Types.EnderecoQueryVariables>(EnderecoDocument, options);
      }
export function useEnderecoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EnderecoQuery, Types.EnderecoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EnderecoQuery, Types.EnderecoQueryVariables>(EnderecoDocument, options);
        }
export function useEnderecoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EnderecoQuery, Types.EnderecoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EnderecoQuery, Types.EnderecoQueryVariables>(EnderecoDocument, options);
        }
export type EnderecoQueryHookResult = ReturnType<typeof useEnderecoQuery>;
export type EnderecoLazyQueryHookResult = ReturnType<typeof useEnderecoLazyQuery>;
export type EnderecoSuspenseQueryHookResult = ReturnType<typeof useEnderecoSuspenseQuery>;
export type EnderecoQueryResult = Apollo.QueryResult<Types.EnderecoQuery, Types.EnderecoQueryVariables>;
export const AldeiaSelectFieldDocument = gql`
    query AldeiaSelectField($input: AldeiaInput!) {
  aldeias(input: $input) {
    content {
      id
      nome
      poloBase {
        id
        nome
        dsei {
          id
          nome
        }
      }
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAldeiaSelectFieldQuery__
 *
 * To run a query within a React component, call `useAldeiaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAldeiaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAldeiaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAldeiaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables> & ({ variables: Types.AldeiaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>(AldeiaSelectFieldDocument, options);
      }
export function useAldeiaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>(AldeiaSelectFieldDocument, options);
        }
export function useAldeiaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>(AldeiaSelectFieldDocument, options);
        }
export type AldeiaSelectFieldQueryHookResult = ReturnType<typeof useAldeiaSelectFieldQuery>;
export type AldeiaSelectFieldLazyQueryHookResult = ReturnType<typeof useAldeiaSelectFieldLazyQuery>;
export type AldeiaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useAldeiaSelectFieldSuspenseQuery>;
export type AldeiaSelectFieldQueryResult = Apollo.QueryResult<Types.AldeiaSelectFieldQuery, Types.AldeiaSelectFieldQueryVariables>;
export const AlergiaSelectFieldDocument = gql`
    query AlergiaSelectField($filtro: AlergiasQueryInput!) {
  alergias(input: $filtro) {
    content {
      ...Alergia
      substanciaEspecifica {
        ...SubstanciaEspecificaAlergia
        sigla
      }
      ultimaEvolucao {
        id
        dataInicio
        manifestacoesLegado
        possuiSubstanciaEspecificaCbara
        manifestacoes {
          id
          nome
          sinonimo
        }
      }
    }
  }
}
    ${AlergiaFragmentDoc}
${SubstanciaEspecificaAlergiaFragmentDoc}`;

/**
 * __useAlergiaSelectFieldQuery__
 *
 * To run a query within a React component, call `useAlergiaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlergiaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlergiaSelectFieldQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useAlergiaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables> & ({ variables: Types.AlergiaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>(AlergiaSelectFieldDocument, options);
      }
export function useAlergiaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>(AlergiaSelectFieldDocument, options);
        }
export function useAlergiaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>(AlergiaSelectFieldDocument, options);
        }
export type AlergiaSelectFieldQueryHookResult = ReturnType<typeof useAlergiaSelectFieldQuery>;
export type AlergiaSelectFieldLazyQueryHookResult = ReturnType<typeof useAlergiaSelectFieldLazyQuery>;
export type AlergiaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useAlergiaSelectFieldSuspenseQuery>;
export type AlergiaSelectFieldQueryResult = Apollo.QueryResult<Types.AlergiaSelectFieldQuery, Types.AlergiaSelectFieldQueryVariables>;
export const BairroSelectFieldDocument = gql`
    query BairroSelectField($input: BairroInput!) {
  bairros(input: $input) {
    content {
      id
      nome
      municipio {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useBairroSelectFieldQuery__
 *
 * To run a query within a React component, call `useBairroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useBairroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBairroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBairroSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables> & ({ variables: Types.BairroSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>(BairroSelectFieldDocument, options);
      }
export function useBairroSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>(BairroSelectFieldDocument, options);
        }
export function useBairroSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>(BairroSelectFieldDocument, options);
        }
export type BairroSelectFieldQueryHookResult = ReturnType<typeof useBairroSelectFieldQuery>;
export type BairroSelectFieldLazyQueryHookResult = ReturnType<typeof useBairroSelectFieldLazyQuery>;
export type BairroSelectFieldSuspenseQueryHookResult = ReturnType<typeof useBairroSelectFieldSuspenseQuery>;
export type BairroSelectFieldQueryResult = Apollo.QueryResult<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>;
export const CategoriaProfissionalRelatorioGerencialSelectFieldDocument = gql`
    query CategoriaProfissionalRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  categoriasProfissionalRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useCategoriaProfissionalRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useCategoriaProfissionalRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaProfissionalRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaProfissionalRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useCategoriaProfissionalRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>(CategoriaProfissionalRelatorioGerencialSelectFieldDocument, options);
      }
export function useCategoriaProfissionalRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>(CategoriaProfissionalRelatorioGerencialSelectFieldDocument, options);
        }
export function useCategoriaProfissionalRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>(CategoriaProfissionalRelatorioGerencialSelectFieldDocument, options);
        }
export type CategoriaProfissionalRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useCategoriaProfissionalRelatorioGerencialSelectFieldQuery>;
export type CategoriaProfissionalRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useCategoriaProfissionalRelatorioGerencialSelectFieldLazyQuery>;
export type CategoriaProfissionalRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCategoriaProfissionalRelatorioGerencialSelectFieldSuspenseQuery>;
export type CategoriaProfissionalRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.CategoriaProfissionalRelatorioGerencialSelectFieldQuery, Types.CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables>;
export const CboRelatorioGerencialSelectFieldDocument = gql`
    query CboRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum, $input: String) {
  cbosRelatorioGerencial(tipoModulo: $tipoModulo, input: $input)
}
    `;

/**
 * __useCboRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>(CboRelatorioGerencialSelectFieldDocument, options);
      }
export function useCboRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>(CboRelatorioGerencialSelectFieldDocument, options);
        }
export function useCboRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>(CboRelatorioGerencialSelectFieldDocument, options);
        }
export type CboRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useCboRelatorioGerencialSelectFieldQuery>;
export type CboRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useCboRelatorioGerencialSelectFieldLazyQuery>;
export type CboRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCboRelatorioGerencialSelectFieldSuspenseQuery>;
export type CboRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.CboRelatorioGerencialSelectFieldQuery, Types.CboRelatorioGerencialSelectFieldQueryVariables>;
export const DiaDaSemanaRelatorioGerencialSelectFieldDocument = gql`
    query DiaDaSemanaRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  diasDaSemanaRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useDiaDaSemanaRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useDiaDaSemanaRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaDaSemanaRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaDaSemanaRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useDiaDaSemanaRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>(DiaDaSemanaRelatorioGerencialSelectFieldDocument, options);
      }
export function useDiaDaSemanaRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>(DiaDaSemanaRelatorioGerencialSelectFieldDocument, options);
        }
export function useDiaDaSemanaRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>(DiaDaSemanaRelatorioGerencialSelectFieldDocument, options);
        }
export type DiaDaSemanaRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useDiaDaSemanaRelatorioGerencialSelectFieldQuery>;
export type DiaDaSemanaRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useDiaDaSemanaRelatorioGerencialSelectFieldLazyQuery>;
export type DiaDaSemanaRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useDiaDaSemanaRelatorioGerencialSelectFieldSuspenseQuery>;
export type DiaDaSemanaRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.DiaDaSemanaRelatorioGerencialSelectFieldQuery, Types.DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables>;
export const EquipeRelatorioGerencialSelectFieldDocument = gql`
    query EquipeRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum, $input: String) {
  equipesRelatorioGerencial(tipoModulo: $tipoModulo, input: $input)
}
    `;

/**
 * __useEquipeRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>(EquipeRelatorioGerencialSelectFieldDocument, options);
      }
export function useEquipeRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>(EquipeRelatorioGerencialSelectFieldDocument, options);
        }
export function useEquipeRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>(EquipeRelatorioGerencialSelectFieldDocument, options);
        }
export type EquipeRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useEquipeRelatorioGerencialSelectFieldQuery>;
export type EquipeRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeRelatorioGerencialSelectFieldLazyQuery>;
export type EquipeRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEquipeRelatorioGerencialSelectFieldSuspenseQuery>;
export type EquipeRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.EquipeRelatorioGerencialSelectFieldQuery, Types.EquipeRelatorioGerencialSelectFieldQueryVariables>;
export const FaixaEtariaRelatorioGerencialSelectFieldDocument = gql`
    query FaixaEtariaRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  faixasEtariaRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useFaixaEtariaRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useFaixaEtariaRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaixaEtariaRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaixaEtariaRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useFaixaEtariaRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>(FaixaEtariaRelatorioGerencialSelectFieldDocument, options);
      }
export function useFaixaEtariaRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>(FaixaEtariaRelatorioGerencialSelectFieldDocument, options);
        }
export function useFaixaEtariaRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>(FaixaEtariaRelatorioGerencialSelectFieldDocument, options);
        }
export type FaixaEtariaRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useFaixaEtariaRelatorioGerencialSelectFieldQuery>;
export type FaixaEtariaRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useFaixaEtariaRelatorioGerencialSelectFieldLazyQuery>;
export type FaixaEtariaRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useFaixaEtariaRelatorioGerencialSelectFieldSuspenseQuery>;
export type FaixaEtariaRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.FaixaEtariaRelatorioGerencialSelectFieldQuery, Types.FaixaEtariaRelatorioGerencialSelectFieldQueryVariables>;
export const HorarioRelatorioGerencialSelectFieldDocument = gql`
    query HorarioRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  horariosRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useHorarioRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useHorarioRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorarioRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorarioRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useHorarioRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>(HorarioRelatorioGerencialSelectFieldDocument, options);
      }
export function useHorarioRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>(HorarioRelatorioGerencialSelectFieldDocument, options);
        }
export function useHorarioRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>(HorarioRelatorioGerencialSelectFieldDocument, options);
        }
export type HorarioRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useHorarioRelatorioGerencialSelectFieldQuery>;
export type HorarioRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useHorarioRelatorioGerencialSelectFieldLazyQuery>;
export type HorarioRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useHorarioRelatorioGerencialSelectFieldSuspenseQuery>;
export type HorarioRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.HorarioRelatorioGerencialSelectFieldQuery, Types.HorarioRelatorioGerencialSelectFieldQueryVariables>;
export const MesRelatorioGerencialSelectFieldDocument = gql`
    query MesRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  mesesRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useMesRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useMesRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMesRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMesRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useMesRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>(MesRelatorioGerencialSelectFieldDocument, options);
      }
export function useMesRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>(MesRelatorioGerencialSelectFieldDocument, options);
        }
export function useMesRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>(MesRelatorioGerencialSelectFieldDocument, options);
        }
export type MesRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useMesRelatorioGerencialSelectFieldQuery>;
export type MesRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useMesRelatorioGerencialSelectFieldLazyQuery>;
export type MesRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMesRelatorioGerencialSelectFieldSuspenseQuery>;
export type MesRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.MesRelatorioGerencialSelectFieldQuery, Types.MesRelatorioGerencialSelectFieldQueryVariables>;
export const MunicipioRelatorioGerencialSelectFieldDocument = gql`
    query MunicipioRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum, $input: String) {
  municipiosRelatorioGerencial(tipoModulo: $tipoModulo, input: $input)
}
    `;

/**
 * __useMunicipioRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useMunicipioRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipioRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipioRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipioRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>(MunicipioRelatorioGerencialSelectFieldDocument, options);
      }
export function useMunicipioRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>(MunicipioRelatorioGerencialSelectFieldDocument, options);
        }
export function useMunicipioRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>(MunicipioRelatorioGerencialSelectFieldDocument, options);
        }
export type MunicipioRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useMunicipioRelatorioGerencialSelectFieldQuery>;
export type MunicipioRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useMunicipioRelatorioGerencialSelectFieldLazyQuery>;
export type MunicipioRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMunicipioRelatorioGerencialSelectFieldSuspenseQuery>;
export type MunicipioRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.MunicipioRelatorioGerencialSelectFieldQuery, Types.MunicipioRelatorioGerencialSelectFieldQueryVariables>;
export const ProfissionalRelatorioGerencialSelectFieldDocument = gql`
    query ProfissionalRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum, $input: String) {
  profissionaisRelatorioGerencial(tipoModulo: $tipoModulo, input: $input)
}
    `;

/**
 * __useProfissionalRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useProfissionalRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>(ProfissionalRelatorioGerencialSelectFieldDocument, options);
      }
export function useProfissionalRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>(ProfissionalRelatorioGerencialSelectFieldDocument, options);
        }
export function useProfissionalRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>(ProfissionalRelatorioGerencialSelectFieldDocument, options);
        }
export type ProfissionalRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useProfissionalRelatorioGerencialSelectFieldQuery>;
export type ProfissionalRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useProfissionalRelatorioGerencialSelectFieldLazyQuery>;
export type ProfissionalRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useProfissionalRelatorioGerencialSelectFieldSuspenseQuery>;
export type ProfissionalRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.ProfissionalRelatorioGerencialSelectFieldQuery, Types.ProfissionalRelatorioGerencialSelectFieldQueryVariables>;
export const SexoRelatorioGerencialSelectFieldDocument = gql`
    query SexoRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  sexosRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useSexoRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useSexoRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSexoRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSexoRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useSexoRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>(SexoRelatorioGerencialSelectFieldDocument, options);
      }
export function useSexoRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>(SexoRelatorioGerencialSelectFieldDocument, options);
        }
export function useSexoRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>(SexoRelatorioGerencialSelectFieldDocument, options);
        }
export type SexoRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useSexoRelatorioGerencialSelectFieldQuery>;
export type SexoRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useSexoRelatorioGerencialSelectFieldLazyQuery>;
export type SexoRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useSexoRelatorioGerencialSelectFieldSuspenseQuery>;
export type SexoRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.SexoRelatorioGerencialSelectFieldQuery, Types.SexoRelatorioGerencialSelectFieldQueryVariables>;
export const SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument = gql`
    query SimNaoNaoInformadoRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  simNaoNaoInformadoRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>(SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument, options);
      }
export function useSimNaoNaoInformadoRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>(SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument, options);
        }
export function useSimNaoNaoInformadoRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>(SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument, options);
        }
export type SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useSimNaoNaoInformadoRelatorioGerencialSelectFieldQuery>;
export type SimNaoNaoInformadoRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useSimNaoNaoInformadoRelatorioGerencialSelectFieldLazyQuery>;
export type SimNaoNaoInformadoRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useSimNaoNaoInformadoRelatorioGerencialSelectFieldSuspenseQuery>;
export type SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery, Types.SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables>;
export const SimNaoRelatorioGerencialSelectFieldDocument = gql`
    query SimNaoRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  simNaoRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useSimNaoRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useSimNaoRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimNaoRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimNaoRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useSimNaoRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>(SimNaoRelatorioGerencialSelectFieldDocument, options);
      }
export function useSimNaoRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>(SimNaoRelatorioGerencialSelectFieldDocument, options);
        }
export function useSimNaoRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>(SimNaoRelatorioGerencialSelectFieldDocument, options);
        }
export type SimNaoRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useSimNaoRelatorioGerencialSelectFieldQuery>;
export type SimNaoRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useSimNaoRelatorioGerencialSelectFieldLazyQuery>;
export type SimNaoRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useSimNaoRelatorioGerencialSelectFieldSuspenseQuery>;
export type SimNaoRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.SimNaoRelatorioGerencialSelectFieldQuery, Types.SimNaoRelatorioGerencialSelectFieldQueryVariables>;
export const TipoProducaoRelatorioGerencialSelectFieldDocument = gql`
    query TipoProducaoRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  tiposProducaoRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useTipoProducaoRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoProducaoRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoProducaoRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoProducaoRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useTipoProducaoRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>(TipoProducaoRelatorioGerencialSelectFieldDocument, options);
      }
export function useTipoProducaoRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>(TipoProducaoRelatorioGerencialSelectFieldDocument, options);
        }
export function useTipoProducaoRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>(TipoProducaoRelatorioGerencialSelectFieldDocument, options);
        }
export type TipoProducaoRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useTipoProducaoRelatorioGerencialSelectFieldQuery>;
export type TipoProducaoRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoProducaoRelatorioGerencialSelectFieldLazyQuery>;
export type TipoProducaoRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoProducaoRelatorioGerencialSelectFieldSuspenseQuery>;
export type TipoProducaoRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.TipoProducaoRelatorioGerencialSelectFieldQuery, Types.TipoProducaoRelatorioGerencialSelectFieldQueryVariables>;
export const TurnoRelatorioGerencialSelectFieldDocument = gql`
    query TurnoRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum) {
  turnosRelatorioGerencial(tipoModulo: $tipoModulo)
}
    `;

/**
 * __useTurnoRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useTurnoRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTurnoRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTurnoRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useTurnoRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>(TurnoRelatorioGerencialSelectFieldDocument, options);
      }
export function useTurnoRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>(TurnoRelatorioGerencialSelectFieldDocument, options);
        }
export function useTurnoRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>(TurnoRelatorioGerencialSelectFieldDocument, options);
        }
export type TurnoRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useTurnoRelatorioGerencialSelectFieldQuery>;
export type TurnoRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useTurnoRelatorioGerencialSelectFieldLazyQuery>;
export type TurnoRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTurnoRelatorioGerencialSelectFieldSuspenseQuery>;
export type TurnoRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.TurnoRelatorioGerencialSelectFieldQuery, Types.TurnoRelatorioGerencialSelectFieldQueryVariables>;
export const UnidadeSaudeRelatorioGerencialSelectFieldDocument = gql`
    query UnidadeSaudeRelatorioGerencialSelectField($tipoModulo: TipoModuloEnum, $input: String) {
  unidadesSaudeRelatorioGerencial(tipoModulo: $tipoModulo, input: $input)
}
    `;

/**
 * __useUnidadeSaudeRelatorioGerencialSelectFieldQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeRelatorioGerencialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeRelatorioGerencialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeRelatorioGerencialSelectFieldQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeRelatorioGerencialSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>(UnidadeSaudeRelatorioGerencialSelectFieldDocument, options);
      }
export function useUnidadeSaudeRelatorioGerencialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>(UnidadeSaudeRelatorioGerencialSelectFieldDocument, options);
        }
export function useUnidadeSaudeRelatorioGerencialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>(UnidadeSaudeRelatorioGerencialSelectFieldDocument, options);
        }
export type UnidadeSaudeRelatorioGerencialSelectFieldQueryHookResult = ReturnType<typeof useUnidadeSaudeRelatorioGerencialSelectFieldQuery>;
export type UnidadeSaudeRelatorioGerencialSelectFieldLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeRelatorioGerencialSelectFieldLazyQuery>;
export type UnidadeSaudeRelatorioGerencialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useUnidadeSaudeRelatorioGerencialSelectFieldSuspenseQuery>;
export type UnidadeSaudeRelatorioGerencialSelectFieldQueryResult = Apollo.QueryResult<Types.UnidadeSaudeRelatorioGerencialSelectFieldQuery, Types.UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables>;
export const TempoEntreAgendamentoEConsultaSelectFieldDocument = gql`
    query TempoEntreAgendamentoEConsultaSelectField {
  tempoEntreAgendamentoEConsultaRelatorioGerencialAbsenteismo
}
    `;

/**
 * __useTempoEntreAgendamentoEConsultaSelectFieldQuery__
 *
 * To run a query within a React component, call `useTempoEntreAgendamentoEConsultaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempoEntreAgendamentoEConsultaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempoEntreAgendamentoEConsultaSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempoEntreAgendamentoEConsultaSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>(TempoEntreAgendamentoEConsultaSelectFieldDocument, options);
      }
export function useTempoEntreAgendamentoEConsultaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>(TempoEntreAgendamentoEConsultaSelectFieldDocument, options);
        }
export function useTempoEntreAgendamentoEConsultaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>(TempoEntreAgendamentoEConsultaSelectFieldDocument, options);
        }
export type TempoEntreAgendamentoEConsultaSelectFieldQueryHookResult = ReturnType<typeof useTempoEntreAgendamentoEConsultaSelectFieldQuery>;
export type TempoEntreAgendamentoEConsultaSelectFieldLazyQueryHookResult = ReturnType<typeof useTempoEntreAgendamentoEConsultaSelectFieldLazyQuery>;
export type TempoEntreAgendamentoEConsultaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTempoEntreAgendamentoEConsultaSelectFieldSuspenseQuery>;
export type TempoEntreAgendamentoEConsultaSelectFieldQueryResult = Apollo.QueryResult<Types.TempoEntreAgendamentoEConsultaSelectFieldQuery, Types.TempoEntreAgendamentoEConsultaSelectFieldQueryVariables>;
export const TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldDocument = gql`
    query TipoDeFaltaRelatorioGerencialAbsenteismoSelectField {
  tiposDeFaltaRelatorioGerencialAbsenteismo
}
    `;

/**
 * __useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>(TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldDocument, options);
      }
export function useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>(TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldDocument, options);
        }
export function useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>(TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldDocument, options);
        }
export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryHookResult = ReturnType<typeof useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery>;
export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldLazyQuery>;
export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldSuspenseQuery>;
export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery, Types.TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables>;
export const TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldDocument = gql`
    query TipoDeAtendimentoRelatorioGerencialAtendimentoSelectField {
  tiposDeAtendimentoRelatorioGerencialAtendimento
}
    `;

/**
 * __useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldDocument, options);
      }
export function useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldDocument, options);
        }
export function useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldDocument, options);
        }
export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery>;
export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldLazyQuery>;
export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldSuspenseQuery>;
export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables>;
export const TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldDocument = gql`
    query TipoDeConsultaRelatorioGerencialAtendimentoSelectField {
  tiposDeConsultaRelatorioGerencialAtendimento
}
    `;

/**
 * __useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldDocument, options);
      }
export function useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldDocument, options);
        }
export function useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>(TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldDocument, options);
        }
export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery>;
export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldLazyQuery>;
export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoDeConsultaRelatorioGerencialAtendimentoSelectFieldSuspenseQuery>;
export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery, Types.TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables>;
export const DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query DeficienciaRelatorioGerencialCadastroIndividualSelectField {
  deficienciasRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(DeficienciaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useDeficienciaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query EtniaRelatorioGerencialCadastroIndividualSelectField($input: String) {
  etniasRelatorioGerencialCadastroIndividual(input: $input)
}
    `;

/**
 * __useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useEtniaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useEtniaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(EtniaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useEtniaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type EtniaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useEtniaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type EtniaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEtniaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectField {
  frequenciasAlimentacaoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useFrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectField {
  identidadesGeneroRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useIdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectField($input: String) {
  municipiosNascimentoRelatorioGerencialCadastroIndividual(input: $input)
}
    `;

/**
 * __useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.MunicipioNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query NacionalidadeRelatorioGerencialCadastroIndividualSelectField {
  nacionalidadesRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useNacionalidadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query OcupacaoRelatorioGerencialCadastroIndividualSelectField($input: String) {
  ocupacoesRelatorioGerencialCadastroIndividual(input: $input)
}
    `;

/**
 * __useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OcupacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useOcupacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query OrientacaoSexualRelatorioGerencialCadastroIndividualSelectField {
  orientacoesSexuaisRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useOrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectField {
  origensAlimentacaoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useOrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query PaisNascimentoRelatorioGerencialCadastroIndividualSelectField($input: String) {
  paisesNascimentoRelatorioGerencialCadastroIndividual(input: $input)
}
    `;

/**
 * __usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.PaisNascimentoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query RacaCorRelatorioGerencialCadastroIndividualSelectField {
  racasCoresRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useRacaCorRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useRacaCorRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(RacaCorRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useRacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useRacaCorRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useRacaCorRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectField {
  responsaveisCriancaRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectField {
  situacoesTrabalhoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useSituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectField {
  temposAtendimentoSocioeducativoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectField {
  temposSituacaoRuaRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectField {
  tiposAtendimentoSocioeducativoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoAtendimentoSocioeducativoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectField {
  tiposCondicaoPesoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectField {
  tiposDoencaCardiacaRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectField {
  tiposDoencaRespiratoriaRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectField {
  tiposEscolaridadeRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectField {
  tiposHigienePessoalRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoParentescoRelatorioGerencialCadastroIndividualSelectField {
  tiposParentescoRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoParentescoRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument = gql`
    query TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectField {
  tiposProblemaRenalRelatorioGerencialCadastroIndividual
}
    `;

/**
 * __useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
      }
export function useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export function useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>(TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldDocument, options);
        }
export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryHookResult = ReturnType<typeof useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery>;
export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldLazyQuery>;
export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldSuspenseQuery>;
export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryResult = Apollo.QueryResult<Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery, Types.TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables>;
export const CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query CondutaRelatorioGerencialCuidadoCompartilhadoSelectField {
  condutasRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectField {
  primeirasRespostasRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectField {
  prioridadesRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectField {
  realizadoPorRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useRealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectField {
  temposDeEsperaRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument = gql`
    query TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectField {
  temposDeRespostaRelatorioGerencialCuidadoCompartilhado
}
    `;

/**
 * __useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>(TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery>;
export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldLazyQuery>;
export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery, Types.TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables>;
export const ExamesRelatorioGerencialExameSelectFieldDocument = gql`
    query ExamesRelatorioGerencialExameSelectField($input: String) {
  examesRelatorioGerencialExames(input: $input)
}
    `;

/**
 * __useExamesRelatorioGerencialExameSelectFieldQuery__
 *
 * To run a query within a React component, call `useExamesRelatorioGerencialExameSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamesRelatorioGerencialExameSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamesRelatorioGerencialExameSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamesRelatorioGerencialExameSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>(ExamesRelatorioGerencialExameSelectFieldDocument, options);
      }
export function useExamesRelatorioGerencialExameSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>(ExamesRelatorioGerencialExameSelectFieldDocument, options);
        }
export function useExamesRelatorioGerencialExameSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>(ExamesRelatorioGerencialExameSelectFieldDocument, options);
        }
export type ExamesRelatorioGerencialExameSelectFieldQueryHookResult = ReturnType<typeof useExamesRelatorioGerencialExameSelectFieldQuery>;
export type ExamesRelatorioGerencialExameSelectFieldLazyQueryHookResult = ReturnType<typeof useExamesRelatorioGerencialExameSelectFieldLazyQuery>;
export type ExamesRelatorioGerencialExameSelectFieldSuspenseQueryHookResult = ReturnType<typeof useExamesRelatorioGerencialExameSelectFieldSuspenseQuery>;
export type ExamesRelatorioGerencialExameSelectFieldQueryResult = Apollo.QueryResult<Types.ExamesRelatorioGerencialExameSelectFieldQuery, Types.ExamesRelatorioGerencialExameSelectFieldQueryVariables>;
export const OrigemRelatorioGerencialExameSelectFieldDocument = gql`
    query OrigemRelatorioGerencialExameSelectField {
  origensRelatorioGerencialExames
}
    `;

/**
 * __useOrigemRelatorioGerencialExameSelectFieldQuery__
 *
 * To run a query within a React component, call `useOrigemRelatorioGerencialExameSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrigemRelatorioGerencialExameSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrigemRelatorioGerencialExameSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrigemRelatorioGerencialExameSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>(OrigemRelatorioGerencialExameSelectFieldDocument, options);
      }
export function useOrigemRelatorioGerencialExameSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>(OrigemRelatorioGerencialExameSelectFieldDocument, options);
        }
export function useOrigemRelatorioGerencialExameSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>(OrigemRelatorioGerencialExameSelectFieldDocument, options);
        }
export type OrigemRelatorioGerencialExameSelectFieldQueryHookResult = ReturnType<typeof useOrigemRelatorioGerencialExameSelectFieldQuery>;
export type OrigemRelatorioGerencialExameSelectFieldLazyQueryHookResult = ReturnType<typeof useOrigemRelatorioGerencialExameSelectFieldLazyQuery>;
export type OrigemRelatorioGerencialExameSelectFieldSuspenseQueryHookResult = ReturnType<typeof useOrigemRelatorioGerencialExameSelectFieldSuspenseQuery>;
export type OrigemRelatorioGerencialExameSelectFieldQueryResult = Apollo.QueryResult<Types.OrigemRelatorioGerencialExameSelectFieldQuery, Types.OrigemRelatorioGerencialExameSelectFieldQueryVariables>;
export const CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument = gql`
    query CboPrescritorRelatorioGerencialVacinacaoSelectField($input: String) {
  cbosPrescritoresRelatorioGerencialVacinacao(input: $input)
}
    `;

/**
 * __useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>(CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument, options);
      }
export function useCboPrescritorRelatorioGerencialVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>(CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export function useCboPrescritorRelatorioGerencialVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>(CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useCboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery>;
export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useCboPrescritorRelatorioGerencialVacinacaoSelectFieldLazyQuery>;
export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCboPrescritorRelatorioGerencialVacinacaoSelectFieldSuspenseQuery>;
export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery, Types.CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables>;
export const Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument = gql`
    query Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectField($input: String) {
  cid10MotivosIndicacoesRelatorioGerencialVacinacao(input: $input)
}
    `;

/**
 * __useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument, options);
      }
export function useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export function useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery>;
export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldLazyQuery>;
export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery>;
export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery, Types.Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables>;
export const CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument = gql`
    query condicaoMaternalRelatorioGerencialVacinacaoSelectFieldQuery {
  condicaoMaternalRelatorioGerencialVacinacao
}
    `;

/**
 * __useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery__
 *
 * To run a query within a React component, call `useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
      }
export function useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export function useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryHookResult = ReturnType<typeof useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery>;
export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryLazyQueryHookResult = ReturnType<typeof useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery>;
export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQueryHookResult = ReturnType<typeof useCondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery>;
export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryResult = Apollo.QueryResult<Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>;
export const DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument = gql`
    query DoseImunobiologicoRelatorioGerencialVacinacaoSelectField($input: String) {
  dosesImunobiologicosRelatorioGerencialVacinacao(input: $input)
}
    `;

/**
 * __useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
      }
export function useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export function useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery>;
export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQuery>;
export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useDoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery>;
export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>;
export const EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument = gql`
    query EstrategiaRelatorioGerencialVacinacaoSelectField {
  estrategiasRelatorioGerencialVacinacao
}
    `;

/**
 * __useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>(EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument, options);
      }
export function useEstrategiaRelatorioGerencialVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>(EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export function useEstrategiaRelatorioGerencialVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>(EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export type EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useEstrategiaRelatorioGerencialVacinacaoSelectFieldQuery>;
export type EstrategiaRelatorioGerencialVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useEstrategiaRelatorioGerencialVacinacaoSelectFieldLazyQuery>;
export type EstrategiaRelatorioGerencialVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEstrategiaRelatorioGerencialVacinacaoSelectFieldSuspenseQuery>;
export type EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery, Types.EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables>;
export const ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument = gql`
    query ImunobiologicoRelatorioGerencialVacinacaoSelectField($input: String) {
  imunobiologicosRelatorioGerencialVacinacao(input: $input)
}
    `;

/**
 * __useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
      }
export function useImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export function useImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>(ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument, options);
        }
export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery>;
export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useImunobiologicoRelatorioGerencialVacinacaoSelectFieldLazyQuery>;
export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useImunobiologicoRelatorioGerencialVacinacaoSelectFieldSuspenseQuery>;
export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery, Types.ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables>;
export const LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument = gql`
    query LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQuery {
  localAplicacaoRelatorioGerencialVacinacao
}
    `;

/**
 * __useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery__
 *
 * To run a query within a React component, call `useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
      }
export function useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export function useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryHookResult = ReturnType<typeof useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery>;
export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQueryHookResult = ReturnType<typeof useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery>;
export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQueryHookResult = ReturnType<typeof useLocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery>;
export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryResult = Apollo.QueryResult<Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>;
export const ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument = gql`
    query ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQuery {
  viaAdministracaoRelatorioGerencialVacinacao
}
    `;

/**
 * __useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery__
 *
 * To run a query within a React component, call `useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
      }
export function useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export function useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>(ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument, options);
        }
export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryHookResult = ReturnType<typeof useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery>;
export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQueryHookResult = ReturnType<typeof useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryLazyQuery>;
export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQueryHookResult = ReturnType<typeof useViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQuerySuspenseQuery>;
export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryResult = Apollo.QueryResult<Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery, Types.ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables>;
export const CboCuidadoCompartilhadoSelectFieldDocument = gql`
    query CboCuidadoCompartilhadoSelectField($input: CbosCuidadoCompartilhadoQueryInput!) {
  cbosVinculacoesServico(input: $input) {
    content {
      cbo {
        id
        nome
        cbo2002
      }
      isVinculado
      isCuidado
      isGuia
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCboCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.CboCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>(CboCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useCboCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>(CboCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useCboCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>(CboCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type CboCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useCboCuidadoCompartilhadoSelectFieldQuery>;
export type CboCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useCboCuidadoCompartilhadoSelectFieldLazyQuery>;
export type CboCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCboCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type CboCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.CboCuidadoCompartilhadoSelectFieldQuery, Types.CboCuidadoCompartilhadoSelectFieldQueryVariables>;
export const CboSelectFieldDocument = gql`
    query CboSelectField($input: CbosQueryInput!) {
  cbos(input: $input) {
    content {
      cbo {
        id
        nome
        cbo2002
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCboSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables> & ({ variables: Types.CboSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>(CboSelectFieldDocument, options);
      }
export function useCboSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>(CboSelectFieldDocument, options);
        }
export function useCboSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>(CboSelectFieldDocument, options);
        }
export type CboSelectFieldQueryHookResult = ReturnType<typeof useCboSelectFieldQuery>;
export type CboSelectFieldLazyQueryHookResult = ReturnType<typeof useCboSelectFieldLazyQuery>;
export type CboSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCboSelectFieldSuspenseQuery>;
export type CboSelectFieldQueryResult = Apollo.QueryResult<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>;
export const CiapCid10SelectFieldDocument = gql`
    query CiapCid10SelectField($inputCiap: CiapQueryInput!, $inputCid10: Cid10QueryInput!) {
  ciaps(input: $inputCiap) {
    content {
      id
      codigo
      descricao
    }
    pageInfo {
      ...PageInfo
    }
  }
  cids(input: $inputCid10) {
    content {
      id
      codigo
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCiapCid10SelectFieldQuery__
 *
 * To run a query within a React component, call `useCiapCid10SelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiapCid10SelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiapCid10SelectFieldQuery({
 *   variables: {
 *      inputCiap: // value for 'inputCiap'
 *      inputCid10: // value for 'inputCid10'
 *   },
 * });
 */
export function useCiapCid10SelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables> & ({ variables: Types.CiapCid10SelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>(CiapCid10SelectFieldDocument, options);
      }
export function useCiapCid10SelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>(CiapCid10SelectFieldDocument, options);
        }
export function useCiapCid10SelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>(CiapCid10SelectFieldDocument, options);
        }
export type CiapCid10SelectFieldQueryHookResult = ReturnType<typeof useCiapCid10SelectFieldQuery>;
export type CiapCid10SelectFieldLazyQueryHookResult = ReturnType<typeof useCiapCid10SelectFieldLazyQuery>;
export type CiapCid10SelectFieldSuspenseQueryHookResult = ReturnType<typeof useCiapCid10SelectFieldSuspenseQuery>;
export type CiapCid10SelectFieldQueryResult = Apollo.QueryResult<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>;
export const AntecedenteCiapSelectFieldDocument = gql`
    query AntecedenteCiapSelectField($input: CiapQueryInput!) {
  ciaps(input: $input) {
    content {
      id
      codigo
      descricao
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAntecedenteCiapSelectFieldQuery__
 *
 * To run a query within a React component, call `useAntecedenteCiapSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAntecedenteCiapSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAntecedenteCiapSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAntecedenteCiapSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables> & ({ variables: Types.AntecedenteCiapSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>(AntecedenteCiapSelectFieldDocument, options);
      }
export function useAntecedenteCiapSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>(AntecedenteCiapSelectFieldDocument, options);
        }
export function useAntecedenteCiapSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>(AntecedenteCiapSelectFieldDocument, options);
        }
export type AntecedenteCiapSelectFieldQueryHookResult = ReturnType<typeof useAntecedenteCiapSelectFieldQuery>;
export type AntecedenteCiapSelectFieldLazyQueryHookResult = ReturnType<typeof useAntecedenteCiapSelectFieldLazyQuery>;
export type AntecedenteCiapSelectFieldSuspenseQueryHookResult = ReturnType<typeof useAntecedenteCiapSelectFieldSuspenseQuery>;
export type AntecedenteCiapSelectFieldQueryResult = Apollo.QueryResult<Types.AntecedenteCiapSelectFieldQuery, Types.AntecedenteCiapSelectFieldQueryVariables>;
export const CiapSelectFieldDocument = gql`
    query CiapSelectField($input: CiapQueryInput!, $fetchCID10Encaminhamento: Boolean!) {
  ciaps(input: $input) {
    content {
      id
      codigo
      descricao
      inclui
      exclui
      cid10Encaminhamento @include(if: $fetchCID10Encaminhamento) {
        id
        codigo
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCiapSelectFieldQuery__
 *
 * To run a query within a React component, call `useCiapSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiapSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiapSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *      fetchCID10Encaminhamento: // value for 'fetchCID10Encaminhamento'
 *   },
 * });
 */
export function useCiapSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables> & ({ variables: Types.CiapSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>(CiapSelectFieldDocument, options);
      }
export function useCiapSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>(CiapSelectFieldDocument, options);
        }
export function useCiapSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>(CiapSelectFieldDocument, options);
        }
export type CiapSelectFieldQueryHookResult = ReturnType<typeof useCiapSelectFieldQuery>;
export type CiapSelectFieldLazyQueryHookResult = ReturnType<typeof useCiapSelectFieldLazyQuery>;
export type CiapSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCiapSelectFieldSuspenseQuery>;
export type CiapSelectFieldQueryResult = Apollo.QueryResult<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>;
export const Cid11SelectFieldDocument = gql`
    query Cid11SelectField($input: Cid11QueryInput!) {
  cids11(input: $input) {
    content {
      ...Cid11
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid11FragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useCid11SelectFieldQuery__
 *
 * To run a query within a React component, call `useCid11SelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCid11SelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCid11SelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCid11SelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables> & ({ variables: Types.Cid11SelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>(Cid11SelectFieldDocument, options);
      }
export function useCid11SelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>(Cid11SelectFieldDocument, options);
        }
export function useCid11SelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>(Cid11SelectFieldDocument, options);
        }
export type Cid11SelectFieldQueryHookResult = ReturnType<typeof useCid11SelectFieldQuery>;
export type Cid11SelectFieldLazyQueryHookResult = ReturnType<typeof useCid11SelectFieldLazyQuery>;
export type Cid11SelectFieldSuspenseQueryHookResult = ReturnType<typeof useCid11SelectFieldSuspenseQuery>;
export type Cid11SelectFieldQueryResult = Apollo.QueryResult<Types.Cid11SelectFieldQuery, Types.Cid11SelectFieldQueryVariables>;
export const CidSelectFieldDocument = gql`
    query CidSelectField($input: Cid10QueryInput!, $fetchCiapsRelacionadas: Boolean!) {
  cids(input: $input) {
    content {
      id
      codigo
      nome
      ciapsRelacionadas @include(if: $fetchCiapsRelacionadas) {
        id
      }
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCidSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *      fetchCiapsRelacionadas: // value for 'fetchCiapsRelacionadas'
 *   },
 * });
 */
export function useCidSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables> & ({ variables: Types.CidSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>(CidSelectFieldDocument, options);
      }
export function useCidSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>(CidSelectFieldDocument, options);
        }
export function useCidSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>(CidSelectFieldDocument, options);
        }
export type CidSelectFieldQueryHookResult = ReturnType<typeof useCidSelectFieldQuery>;
export type CidSelectFieldLazyQueryHookResult = ReturnType<typeof useCidSelectFieldLazyQuery>;
export type CidSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidSelectFieldSuspenseQuery>;
export type CidSelectFieldQueryResult = Apollo.QueryResult<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>;
export const CidadaoAtendimentoPorCpfSelectFieldDocument = gql`
    query CidadaoAtendimentoPorCpfSelectField($input: CidadaosComboQueryInput!) {
  cidadaosComboByCpf(input: $input) {
    ...CidadaoBasico
  }
}
    ${CidadaoBasicoFragmentDoc}`;

/**
 * __useCidadaoAtendimentoPorCpfSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAtendimentoPorCpfSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtendimentoPorCpfSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtendimentoPorCpfSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAtendimentoPorCpfSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables> & ({ variables: Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>(CidadaoAtendimentoPorCpfSelectFieldDocument, options);
      }
export function useCidadaoAtendimentoPorCpfSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>(CidadaoAtendimentoPorCpfSelectFieldDocument, options);
        }
export function useCidadaoAtendimentoPorCpfSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>(CidadaoAtendimentoPorCpfSelectFieldDocument, options);
        }
export type CidadaoAtendimentoPorCpfSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorCpfSelectFieldQuery>;
export type CidadaoAtendimentoPorCpfSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorCpfSelectFieldLazyQuery>;
export type CidadaoAtendimentoPorCpfSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorCpfSelectFieldSuspenseQuery>;
export type CidadaoAtendimentoPorCpfSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoAtendimentoPorCpfSelectFieldQuery, Types.CidadaoAtendimentoPorCpfSelectFieldQueryVariables>;
export const CidadaoAtendimentoPorDataNascimentoSelectFieldDocument = gql`
    query CidadaoAtendimentoPorDataNascimentoSelectField($input: CidadaosComboQueryInput!) {
  cidadaosComboByDataNascimento(input: $input) {
    ...CidadaoBasico
  }
}
    ${CidadaoBasicoFragmentDoc}`;

/**
 * __useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables> & ({ variables: Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>(CidadaoAtendimentoPorDataNascimentoSelectFieldDocument, options);
      }
export function useCidadaoAtendimentoPorDataNascimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>(CidadaoAtendimentoPorDataNascimentoSelectFieldDocument, options);
        }
export function useCidadaoAtendimentoPorDataNascimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>(CidadaoAtendimentoPorDataNascimentoSelectFieldDocument, options);
        }
export type CidadaoAtendimentoPorDataNascimentoSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorDataNascimentoSelectFieldQuery>;
export type CidadaoAtendimentoPorDataNascimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorDataNascimentoSelectFieldLazyQuery>;
export type CidadaoAtendimentoPorDataNascimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorDataNascimentoSelectFieldSuspenseQuery>;
export type CidadaoAtendimentoPorDataNascimentoSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQuery, Types.CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables>;
export const CidadaoAtendimentoPorNomeSelectFieldDocument = gql`
    query CidadaoAtendimentoPorNomeSelectField($input: CidadaosComboQueryInput!) {
  cidadaosComboByNome(input: $input) {
    ...CidadaoBasico
  }
}
    ${CidadaoBasicoFragmentDoc}`;

/**
 * __useCidadaoAtendimentoPorNomeSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAtendimentoPorNomeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtendimentoPorNomeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtendimentoPorNomeSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAtendimentoPorNomeSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables> & ({ variables: Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>(CidadaoAtendimentoPorNomeSelectFieldDocument, options);
      }
export function useCidadaoAtendimentoPorNomeSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>(CidadaoAtendimentoPorNomeSelectFieldDocument, options);
        }
export function useCidadaoAtendimentoPorNomeSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>(CidadaoAtendimentoPorNomeSelectFieldDocument, options);
        }
export type CidadaoAtendimentoPorNomeSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorNomeSelectFieldQuery>;
export type CidadaoAtendimentoPorNomeSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorNomeSelectFieldLazyQuery>;
export type CidadaoAtendimentoPorNomeSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoAtendimentoPorNomeSelectFieldSuspenseQuery>;
export type CidadaoAtendimentoPorNomeSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoAtendimentoPorNomeSelectFieldQuery, Types.CidadaoAtendimentoPorNomeSelectFieldQueryVariables>;
export const CidadaoAtendimentoSelectFieldDocument = gql`
    query CidadaoAtendimentoSelectField($input: CidadaosComboQueryInput!, $emAtencaoDomiciliar: Boolean!, $equipeResponsavelId: ID, $retrieveContato: Boolean!) {
  cidadaosCombo(
    input: $input
    atencaoDomiciliar: $emAtencaoDomiciliar
    equipeResponsavelId: $equipeResponsavelId
  ) {
    ...CidadaoBasico
    isCidadaoAusente
    contato @include(if: $retrieveContato) {
      id
      telefoneCelular
      email
    }
  }
}
    ${CidadaoBasicoFragmentDoc}`;

/**
 * __useCidadaoAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtendimentoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *      emAtencaoDomiciliar: // value for 'emAtencaoDomiciliar'
 *      equipeResponsavelId: // value for 'equipeResponsavelId'
 *      retrieveContato: // value for 'retrieveContato'
 *   },
 * });
 */
export function useCidadaoAtendimentoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables> & ({ variables: Types.CidadaoAtendimentoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>(CidadaoAtendimentoSelectFieldDocument, options);
      }
export function useCidadaoAtendimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>(CidadaoAtendimentoSelectFieldDocument, options);
        }
export function useCidadaoAtendimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>(CidadaoAtendimentoSelectFieldDocument, options);
        }
export type CidadaoAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAtendimentoSelectFieldQuery>;
export type CidadaoAtendimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAtendimentoSelectFieldLazyQuery>;
export type CidadaoAtendimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoAtendimentoSelectFieldSuspenseQuery>;
export type CidadaoAtendimentoSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoAtendimentoSelectFieldQuery, Types.CidadaoAtendimentoSelectFieldQueryVariables>;
export const CidadaoSelectFieldDocument = gql`
    query CidadaoSelectField($input: CidadaosQueryInput!) {
  cidadaos(input: $input) {
    content {
      id
      nome
      nomeSocial
      nomeTradicional
      cpf
      cns
      nomeMae
      dataNascimento
      sexo
      identidadeGeneroDbEnum
      dataObito
      unificado
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCidadaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables> & ({ variables: Types.CidadaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>(CidadaoSelectFieldDocument, options);
      }
export function useCidadaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>(CidadaoSelectFieldDocument, options);
        }
export function useCidadaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>(CidadaoSelectFieldDocument, options);
        }
export type CidadaoSelectFieldQueryHookResult = ReturnType<typeof useCidadaoSelectFieldQuery>;
export type CidadaoSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoSelectFieldLazyQuery>;
export type CidadaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoSelectFieldSuspenseQuery>;
export type CidadaoSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>;
export const ConselhoClasseSelectDocument = gql`
    query ConselhoClasseSelect($input: ConselhoClasseQueryInput!) {
  conselhosClasse(input: $input) {
    content {
      id
      descricao
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useConselhoClasseSelectQuery__
 *
 * To run a query within a React component, call `useConselhoClasseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useConselhoClasseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConselhoClasseSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConselhoClasseSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables> & ({ variables: Types.ConselhoClasseSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>(ConselhoClasseSelectDocument, options);
      }
export function useConselhoClasseSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>(ConselhoClasseSelectDocument, options);
        }
export function useConselhoClasseSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>(ConselhoClasseSelectDocument, options);
        }
export type ConselhoClasseSelectQueryHookResult = ReturnType<typeof useConselhoClasseSelectQuery>;
export type ConselhoClasseSelectLazyQueryHookResult = ReturnType<typeof useConselhoClasseSelectLazyQuery>;
export type ConselhoClasseSelectSuspenseQueryHookResult = ReturnType<typeof useConselhoClasseSelectSuspenseQuery>;
export type ConselhoClasseSelectQueryResult = Apollo.QueryResult<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>;
export const DoseImunobiologicoVacinacaoSelectFieldDocument = gql`
    query DoseImunobiologicoVacinacaoSelectField($input: DoseImunobiologicoVacinacaoQueryInput!) {
  doseImunobiologicoVacinacao(input: $input) {
    content {
      id
      sigla
      nome
      nomeApresentacaoDose
      ordem
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useDoseImunobiologicoVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useDoseImunobiologicoVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoseImunobiologicoVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoseImunobiologicoVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoseImunobiologicoVacinacaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables> & ({ variables: Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoVacinacaoSelectFieldDocument, options);
      }
export function useDoseImunobiologicoVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoVacinacaoSelectFieldDocument, options);
        }
export function useDoseImunobiologicoVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>(DoseImunobiologicoVacinacaoSelectFieldDocument, options);
        }
export type DoseImunobiologicoVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useDoseImunobiologicoVacinacaoSelectFieldQuery>;
export type DoseImunobiologicoVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useDoseImunobiologicoVacinacaoSelectFieldLazyQuery>;
export type DoseImunobiologicoVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useDoseImunobiologicoVacinacaoSelectFieldSuspenseQuery>;
export type DoseImunobiologicoVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.DoseImunobiologicoVacinacaoSelectFieldQuery, Types.DoseImunobiologicoVacinacaoSelectFieldQueryVariables>;
export const DseiSelectFieldDocument = gql`
    query DseiSelectField($input: DseiInput!) {
  dseis(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useDseiSelectFieldQuery__
 *
 * To run a query within a React component, call `useDseiSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDseiSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDseiSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDseiSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables> & ({ variables: Types.DseiSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>(DseiSelectFieldDocument, options);
      }
export function useDseiSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>(DseiSelectFieldDocument, options);
        }
export function useDseiSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>(DseiSelectFieldDocument, options);
        }
export type DseiSelectFieldQueryHookResult = ReturnType<typeof useDseiSelectFieldQuery>;
export type DseiSelectFieldLazyQueryHookResult = ReturnType<typeof useDseiSelectFieldLazyQuery>;
export type DseiSelectFieldSuspenseQueryHookResult = ReturnType<typeof useDseiSelectFieldSuspenseQuery>;
export type DseiSelectFieldQueryResult = Apollo.QueryResult<Types.DseiSelectFieldQuery, Types.DseiSelectFieldQueryVariables>;
export const EquipeAdSelectFieldDocument = gql`
    query EquipeAdSelectField($input: EquipesAdQueryInput!) {
  equipesAD(input: $input) {
    content {
      id
      nome
      ine
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipeAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeAdSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables> & ({ variables: Types.EquipeAdSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>(EquipeAdSelectFieldDocument, options);
      }
export function useEquipeAdSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>(EquipeAdSelectFieldDocument, options);
        }
export function useEquipeAdSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>(EquipeAdSelectFieldDocument, options);
        }
export type EquipeAdSelectFieldQueryHookResult = ReturnType<typeof useEquipeAdSelectFieldQuery>;
export type EquipeAdSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeAdSelectFieldLazyQuery>;
export type EquipeAdSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEquipeAdSelectFieldSuspenseQuery>;
export type EquipeAdSelectFieldQueryResult = Apollo.QueryResult<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>;
export const EquipeSelectFieldDocument = gql`
    query EquipeSelectField($input: EquipesQueryInput!) {
  equipes(input: $input) {
    content {
      id
      nome
      ine
      ativo
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipeSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables> & ({ variables: Types.EquipeSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>(EquipeSelectFieldDocument, options);
      }
export function useEquipeSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>(EquipeSelectFieldDocument, options);
        }
export function useEquipeSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>(EquipeSelectFieldDocument, options);
        }
export type EquipeSelectFieldQueryHookResult = ReturnType<typeof useEquipeSelectFieldQuery>;
export type EquipeSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeSelectFieldLazyQuery>;
export type EquipeSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEquipeSelectFieldSuspenseQuery>;
export type EquipeSelectFieldQueryResult = Apollo.QueryResult<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>;
export const EspecialidadeSisregSelectFieldDocument = gql`
    query EspecialidadeSisregSelectField($input: EspecialidadeSisregQueryInput!) {
  especialidadesSisreg(input: $input) {
    content {
      id
      descricao
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEspecialidadeSisregSelectFieldQuery__
 *
 * To run a query within a React component, call `useEspecialidadeSisregSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEspecialidadeSisregSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEspecialidadeSisregSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEspecialidadeSisregSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables> & ({ variables: Types.EspecialidadeSisregSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>(EspecialidadeSisregSelectFieldDocument, options);
      }
export function useEspecialidadeSisregSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>(EspecialidadeSisregSelectFieldDocument, options);
        }
export function useEspecialidadeSisregSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>(EspecialidadeSisregSelectFieldDocument, options);
        }
export type EspecialidadeSisregSelectFieldQueryHookResult = ReturnType<typeof useEspecialidadeSisregSelectFieldQuery>;
export type EspecialidadeSisregSelectFieldLazyQueryHookResult = ReturnType<typeof useEspecialidadeSisregSelectFieldLazyQuery>;
export type EspecialidadeSisregSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEspecialidadeSisregSelectFieldSuspenseQuery>;
export type EspecialidadeSisregSelectFieldQueryResult = Apollo.QueryResult<Types.EspecialidadeSisregSelectFieldQuery, Types.EspecialidadeSisregSelectFieldQueryVariables>;
export const EspecialidadesEsusRegSelectFieldDocument = gql`
    query EspecialidadesEsusRegSelectField($input: EspecialidadesEsusQueryInput!) {
  especialidadesEsusReg(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEspecialidadesEsusRegSelectFieldQuery__
 *
 * To run a query within a React component, call `useEspecialidadesEsusRegSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEspecialidadesEsusRegSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEspecialidadesEsusRegSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEspecialidadesEsusRegSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables> & ({ variables: Types.EspecialidadesEsusRegSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>(EspecialidadesEsusRegSelectFieldDocument, options);
      }
export function useEspecialidadesEsusRegSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>(EspecialidadesEsusRegSelectFieldDocument, options);
        }
export function useEspecialidadesEsusRegSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>(EspecialidadesEsusRegSelectFieldDocument, options);
        }
export type EspecialidadesEsusRegSelectFieldQueryHookResult = ReturnType<typeof useEspecialidadesEsusRegSelectFieldQuery>;
export type EspecialidadesEsusRegSelectFieldLazyQueryHookResult = ReturnType<typeof useEspecialidadesEsusRegSelectFieldLazyQuery>;
export type EspecialidadesEsusRegSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEspecialidadesEsusRegSelectFieldSuspenseQuery>;
export type EspecialidadesEsusRegSelectFieldQueryResult = Apollo.QueryResult<Types.EspecialidadesEsusRegSelectFieldQuery, Types.EspecialidadesEsusRegSelectFieldQueryVariables>;
export const EstrategiaVacinacaoSelectFieldDocument = gql`
    query EstrategiaVacinacaoSelectField($input: EstrategiasVacinacaoQueryInput!) {
  estrategiasVacinacao(input: $input) {
    id
    codigo
    nome
    estrategiaVacinacaoDbEnum
  }
}
    `;

/**
 * __useEstrategiaVacinacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useEstrategiaVacinacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstrategiaVacinacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstrategiaVacinacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstrategiaVacinacaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables> & ({ variables: Types.EstrategiaVacinacaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>(EstrategiaVacinacaoSelectFieldDocument, options);
      }
export function useEstrategiaVacinacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>(EstrategiaVacinacaoSelectFieldDocument, options);
        }
export function useEstrategiaVacinacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>(EstrategiaVacinacaoSelectFieldDocument, options);
        }
export type EstrategiaVacinacaoSelectFieldQueryHookResult = ReturnType<typeof useEstrategiaVacinacaoSelectFieldQuery>;
export type EstrategiaVacinacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useEstrategiaVacinacaoSelectFieldLazyQuery>;
export type EstrategiaVacinacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEstrategiaVacinacaoSelectFieldSuspenseQuery>;
export type EstrategiaVacinacaoSelectFieldQueryResult = Apollo.QueryResult<Types.EstrategiaVacinacaoSelectFieldQuery, Types.EstrategiaVacinacaoSelectFieldQueryVariables>;
export const EtniaSelectFieldDocument = gql`
    query EtniaSelectField($input: EtniaQueryInput!) {
  etnias(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEtniaSelectFieldQuery__
 *
 * To run a query within a React component, call `useEtniaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEtniaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtniaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEtniaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables> & ({ variables: Types.EtniaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>(EtniaSelectFieldDocument, options);
      }
export function useEtniaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>(EtniaSelectFieldDocument, options);
        }
export function useEtniaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>(EtniaSelectFieldDocument, options);
        }
export type EtniaSelectFieldQueryHookResult = ReturnType<typeof useEtniaSelectFieldQuery>;
export type EtniaSelectFieldLazyQueryHookResult = ReturnType<typeof useEtniaSelectFieldLazyQuery>;
export type EtniaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEtniaSelectFieldSuspenseQuery>;
export type EtniaSelectFieldQueryResult = Apollo.QueryResult<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>;
export const FichaNotificacaoCasoSuspeitoSelectFieldDocument = gql`
    query FichaNotificacaoCasoSuspeitoSelectField($input: FichaNotificacaoQueryInput!) {
  fichasNotificacao(input: $input) {
    content {
      id
      nomeNotificacao
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useFichaNotificacaoCasoSuspeitoSelectFieldQuery__
 *
 * To run a query within a React component, call `useFichaNotificacaoCasoSuspeitoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFichaNotificacaoCasoSuspeitoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFichaNotificacaoCasoSuspeitoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFichaNotificacaoCasoSuspeitoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables> & ({ variables: Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>(FichaNotificacaoCasoSuspeitoSelectFieldDocument, options);
      }
export function useFichaNotificacaoCasoSuspeitoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>(FichaNotificacaoCasoSuspeitoSelectFieldDocument, options);
        }
export function useFichaNotificacaoCasoSuspeitoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>(FichaNotificacaoCasoSuspeitoSelectFieldDocument, options);
        }
export type FichaNotificacaoCasoSuspeitoSelectFieldQueryHookResult = ReturnType<typeof useFichaNotificacaoCasoSuspeitoSelectFieldQuery>;
export type FichaNotificacaoCasoSuspeitoSelectFieldLazyQueryHookResult = ReturnType<typeof useFichaNotificacaoCasoSuspeitoSelectFieldLazyQuery>;
export type FichaNotificacaoCasoSuspeitoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useFichaNotificacaoCasoSuspeitoSelectFieldSuspenseQuery>;
export type FichaNotificacaoCasoSuspeitoSelectFieldQueryResult = Apollo.QueryResult<Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery, Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables>;
export const FormaFarmaceuticaSelectFieldDocument = gql`
    query FormaFarmaceuticaSelectField($input: FormaFarmaceuticaQueryInput!) {
  formasFarmaceuticas(input: $input) {
    content {
      id
      nome
    }
  }
}
    `;

/**
 * __useFormaFarmaceuticaSelectFieldQuery__
 *
 * To run a query within a React component, call `useFormaFarmaceuticaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormaFarmaceuticaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormaFarmaceuticaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormaFarmaceuticaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables> & ({ variables: Types.FormaFarmaceuticaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>(FormaFarmaceuticaSelectFieldDocument, options);
      }
export function useFormaFarmaceuticaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>(FormaFarmaceuticaSelectFieldDocument, options);
        }
export function useFormaFarmaceuticaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>(FormaFarmaceuticaSelectFieldDocument, options);
        }
export type FormaFarmaceuticaSelectFieldQueryHookResult = ReturnType<typeof useFormaFarmaceuticaSelectFieldQuery>;
export type FormaFarmaceuticaSelectFieldLazyQueryHookResult = ReturnType<typeof useFormaFarmaceuticaSelectFieldLazyQuery>;
export type FormaFarmaceuticaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useFormaFarmaceuticaSelectFieldSuspenseQuery>;
export type FormaFarmaceuticaSelectFieldQueryResult = Apollo.QueryResult<Types.FormaFarmaceuticaSelectFieldQuery, Types.FormaFarmaceuticaSelectFieldQueryVariables>;
export const FuncaoSocialSelectFieldDocument = gql`
    query FuncaoSocialSelectField($input: FuncaoSocialQueryInput!) {
  funcoesSociais(input: $input) {
    content {
      id
      nome
    }
  }
}
    `;

/**
 * __useFuncaoSocialSelectFieldQuery__
 *
 * To run a query within a React component, call `useFuncaoSocialSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFuncaoSocialSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFuncaoSocialSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFuncaoSocialSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables> & ({ variables: Types.FuncaoSocialSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>(FuncaoSocialSelectFieldDocument, options);
      }
export function useFuncaoSocialSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>(FuncaoSocialSelectFieldDocument, options);
        }
export function useFuncaoSocialSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>(FuncaoSocialSelectFieldDocument, options);
        }
export type FuncaoSocialSelectFieldQueryHookResult = ReturnType<typeof useFuncaoSocialSelectFieldQuery>;
export type FuncaoSocialSelectFieldLazyQueryHookResult = ReturnType<typeof useFuncaoSocialSelectFieldLazyQuery>;
export type FuncaoSocialSelectFieldSuspenseQueryHookResult = ReturnType<typeof useFuncaoSocialSelectFieldSuspenseQuery>;
export type FuncaoSocialSelectFieldQueryResult = Apollo.QueryResult<Types.FuncaoSocialSelectFieldQuery, Types.FuncaoSocialSelectFieldQueryVariables>;
export const GrupoAtendimentoSelectFieldDocument = gql`
    query GrupoAtendimentoSelectField($inputQuery: String, $onlyAtivos: Boolean) {
  gruposAtendimento(inputQuery: $inputQuery, onlyAtivos: $onlyAtivos) {
    id
    nome
  }
}
    `;

/**
 * __useGrupoAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useGrupoAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoAtendimentoSelectFieldQuery({
 *   variables: {
 *      inputQuery: // value for 'inputQuery'
 *      onlyAtivos: // value for 'onlyAtivos'
 *   },
 * });
 */
export function useGrupoAtendimentoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>(GrupoAtendimentoSelectFieldDocument, options);
      }
export function useGrupoAtendimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>(GrupoAtendimentoSelectFieldDocument, options);
        }
export function useGrupoAtendimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>(GrupoAtendimentoSelectFieldDocument, options);
        }
export type GrupoAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useGrupoAtendimentoSelectFieldQuery>;
export type GrupoAtendimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useGrupoAtendimentoSelectFieldLazyQuery>;
export type GrupoAtendimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useGrupoAtendimentoSelectFieldSuspenseQuery>;
export type GrupoAtendimentoSelectFieldQueryResult = Apollo.QueryResult<Types.GrupoAtendimentoSelectFieldQuery, Types.GrupoAtendimentoSelectFieldQueryVariables>;
export const GrupoCondicaoSelectFieldDocument = gql`
    query GrupoCondicaoSelectField($inputGrupo: GrupoCondicaoQueryInput!) {
  grupos(input: $inputGrupo) {
    content {
      id
      grupo
      ciaps {
        id
        codigo
        descricao
      }
      cids {
        id
        codigo
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGrupoCondicaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useGrupoCondicaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoCondicaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoCondicaoSelectFieldQuery({
 *   variables: {
 *      inputGrupo: // value for 'inputGrupo'
 *   },
 * });
 */
export function useGrupoCondicaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables> & ({ variables: Types.GrupoCondicaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>(GrupoCondicaoSelectFieldDocument, options);
      }
export function useGrupoCondicaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>(GrupoCondicaoSelectFieldDocument, options);
        }
export function useGrupoCondicaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>(GrupoCondicaoSelectFieldDocument, options);
        }
export type GrupoCondicaoSelectFieldQueryHookResult = ReturnType<typeof useGrupoCondicaoSelectFieldQuery>;
export type GrupoCondicaoSelectFieldLazyQueryHookResult = ReturnType<typeof useGrupoCondicaoSelectFieldLazyQuery>;
export type GrupoCondicaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useGrupoCondicaoSelectFieldSuspenseQuery>;
export type GrupoCondicaoSelectFieldQueryResult = Apollo.QueryResult<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>;
export const HorarioAgendaSelectFieldDocument = gql`
    query HorarioAgendaSelectField($input: HorariosAgendaQueryInput!) {
  horariosAgenda(input: $input) {
    horario
    duracao
    isOcupado
    isReservadoAgendaOnline
  }
}
    `;

/**
 * __useHorarioAgendaSelectFieldQuery__
 *
 * To run a query within a React component, call `useHorarioAgendaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorarioAgendaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorarioAgendaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHorarioAgendaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables> & ({ variables: Types.HorarioAgendaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>(HorarioAgendaSelectFieldDocument, options);
      }
export function useHorarioAgendaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>(HorarioAgendaSelectFieldDocument, options);
        }
export function useHorarioAgendaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>(HorarioAgendaSelectFieldDocument, options);
        }
export type HorarioAgendaSelectFieldQueryHookResult = ReturnType<typeof useHorarioAgendaSelectFieldQuery>;
export type HorarioAgendaSelectFieldLazyQueryHookResult = ReturnType<typeof useHorarioAgendaSelectFieldLazyQuery>;
export type HorarioAgendaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useHorarioAgendaSelectFieldSuspenseQuery>;
export type HorarioAgendaSelectFieldQueryResult = Apollo.QueryResult<Types.HorarioAgendaSelectFieldQuery, Types.HorarioAgendaSelectFieldQueryVariables>;
export const InepSelectFieldDocument = gql`
    query InepSelectField($input: InepQueryInput!) {
  ineps(input: $input) {
    content {
      id
      dsInep
      nomeEstabelecimento
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useInepSelectFieldQuery__
 *
 * To run a query within a React component, call `useInepSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInepSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInepSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInepSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables> & ({ variables: Types.InepSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>(InepSelectFieldDocument, options);
      }
export function useInepSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>(InepSelectFieldDocument, options);
        }
export function useInepSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>(InepSelectFieldDocument, options);
        }
export type InepSelectFieldQueryHookResult = ReturnType<typeof useInepSelectFieldQuery>;
export type InepSelectFieldLazyQueryHookResult = ReturnType<typeof useInepSelectFieldLazyQuery>;
export type InepSelectFieldSuspenseQueryHookResult = ReturnType<typeof useInepSelectFieldSuspenseQuery>;
export type InepSelectFieldQueryResult = Apollo.QueryResult<Types.InepSelectFieldQuery, Types.InepSelectFieldQueryVariables>;
export const LocalAplicacaoSelectFieldDocument = gql`
    query LocalAplicacaoSelectField($input: LocalAplicacaoQueryInput!) {
  locaisAplicacao(input: $input) {
    id
    nome
  }
}
    `;

/**
 * __useLocalAplicacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useLocalAplicacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalAplicacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalAplicacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocalAplicacaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables> & ({ variables: Types.LocalAplicacaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>(LocalAplicacaoSelectFieldDocument, options);
      }
export function useLocalAplicacaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>(LocalAplicacaoSelectFieldDocument, options);
        }
export function useLocalAplicacaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>(LocalAplicacaoSelectFieldDocument, options);
        }
export type LocalAplicacaoSelectFieldQueryHookResult = ReturnType<typeof useLocalAplicacaoSelectFieldQuery>;
export type LocalAplicacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useLocalAplicacaoSelectFieldLazyQuery>;
export type LocalAplicacaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLocalAplicacaoSelectFieldSuspenseQuery>;
export type LocalAplicacaoSelectFieldQueryResult = Apollo.QueryResult<Types.LocalAplicacaoSelectFieldQuery, Types.LocalAplicacaoSelectFieldQueryVariables>;
export const LocalAtendimentoSelectFieldDocument = gql`
    query LocalAtendimentoSelectField($filtro: LocalAtendimentoQueryInput!) {
  localAtendimento(input: $filtro) {
    content {
      id
      localAtendimentoExibicao
    }
  }
}
    `;

/**
 * __useLocalAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useLocalAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalAtendimentoSelectFieldQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useLocalAtendimentoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables> & ({ variables: Types.LocalAtendimentoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>(LocalAtendimentoSelectFieldDocument, options);
      }
export function useLocalAtendimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>(LocalAtendimentoSelectFieldDocument, options);
        }
export function useLocalAtendimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>(LocalAtendimentoSelectFieldDocument, options);
        }
export type LocalAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useLocalAtendimentoSelectFieldQuery>;
export type LocalAtendimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useLocalAtendimentoSelectFieldLazyQuery>;
export type LocalAtendimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLocalAtendimentoSelectFieldSuspenseQuery>;
export type LocalAtendimentoSelectFieldQueryResult = Apollo.QueryResult<Types.LocalAtendimentoSelectFieldQuery, Types.LocalAtendimentoSelectFieldQueryVariables>;
export const LocalOcorrenciaSelectFieldDocument = gql`
    query LocalOcorrenciaSelectField($input: LocalOcorrenciaQueryInput!) {
  locaisOcorrencia(input: $input) {
    content {
      id
      nome
    }
  }
}
    `;

/**
 * __useLocalOcorrenciaSelectFieldQuery__
 *
 * To run a query within a React component, call `useLocalOcorrenciaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalOcorrenciaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalOcorrenciaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocalOcorrenciaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables> & ({ variables: Types.LocalOcorrenciaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>(LocalOcorrenciaSelectFieldDocument, options);
      }
export function useLocalOcorrenciaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>(LocalOcorrenciaSelectFieldDocument, options);
        }
export function useLocalOcorrenciaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>(LocalOcorrenciaSelectFieldDocument, options);
        }
export type LocalOcorrenciaSelectFieldQueryHookResult = ReturnType<typeof useLocalOcorrenciaSelectFieldQuery>;
export type LocalOcorrenciaSelectFieldLazyQueryHookResult = ReturnType<typeof useLocalOcorrenciaSelectFieldLazyQuery>;
export type LocalOcorrenciaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLocalOcorrenciaSelectFieldSuspenseQuery>;
export type LocalOcorrenciaSelectFieldQueryResult = Apollo.QueryResult<Types.LocalOcorrenciaSelectFieldQuery, Types.LocalOcorrenciaSelectFieldQueryVariables>;
export const LogradouroSelectFieldDocument = gql`
    query LogradouroSelectField($input: LogradouroInput!) {
  logradouros(input: $input) {
    content {
      id
      nome
      nomeExibicao
      tituloPatente {
        id
        nome
      }
      cep
      bairro {
        id
        nome
        municipio {
          id
          nome
          uf {
            id
            sigla
          }
        }
      }
      tipoLogradouro {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLogradouroSelectFieldQuery__
 *
 * To run a query within a React component, call `useLogradouroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogradouroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogradouroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogradouroSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables> & ({ variables: Types.LogradouroSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>(LogradouroSelectFieldDocument, options);
      }
export function useLogradouroSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>(LogradouroSelectFieldDocument, options);
        }
export function useLogradouroSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>(LogradouroSelectFieldDocument, options);
        }
export type LogradouroSelectFieldQueryHookResult = ReturnType<typeof useLogradouroSelectFieldQuery>;
export type LogradouroSelectFieldLazyQueryHookResult = ReturnType<typeof useLogradouroSelectFieldLazyQuery>;
export type LogradouroSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLogradouroSelectFieldSuspenseQuery>;
export type LogradouroSelectFieldQueryResult = Apollo.QueryResult<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>;
export const HasAgendaFixadaDocument = gql`
    query HasAgendaFixada {
  hasAgendaFixada
}
    `;

/**
 * __useHasAgendaFixadaQuery__
 *
 * To run a query within a React component, call `useHasAgendaFixadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAgendaFixadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAgendaFixadaQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasAgendaFixadaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>(HasAgendaFixadaDocument, options);
      }
export function useHasAgendaFixadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>(HasAgendaFixadaDocument, options);
        }
export function useHasAgendaFixadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>(HasAgendaFixadaDocument, options);
        }
export type HasAgendaFixadaQueryHookResult = ReturnType<typeof useHasAgendaFixadaQuery>;
export type HasAgendaFixadaLazyQueryHookResult = ReturnType<typeof useHasAgendaFixadaLazyQuery>;
export type HasAgendaFixadaSuspenseQueryHookResult = ReturnType<typeof useHasAgendaFixadaSuspenseQuery>;
export type HasAgendaFixadaQueryResult = Apollo.QueryResult<Types.HasAgendaFixadaQuery, Types.HasAgendaFixadaQueryVariables>;
export const IsAgendaFixadaDocument = gql`
    query IsAgendaFixada($lotacaoId: ID!) {
  isAgendaFixada(lotacaoId: $lotacaoId)
}
    `;

/**
 * __useIsAgendaFixadaQuery__
 *
 * To run a query within a React component, call `useIsAgendaFixadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAgendaFixadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAgendaFixadaQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useIsAgendaFixadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables> & ({ variables: Types.IsAgendaFixadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>(IsAgendaFixadaDocument, options);
      }
export function useIsAgendaFixadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>(IsAgendaFixadaDocument, options);
        }
export function useIsAgendaFixadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>(IsAgendaFixadaDocument, options);
        }
export type IsAgendaFixadaQueryHookResult = ReturnType<typeof useIsAgendaFixadaQuery>;
export type IsAgendaFixadaLazyQueryHookResult = ReturnType<typeof useIsAgendaFixadaLazyQuery>;
export type IsAgendaFixadaSuspenseQueryHookResult = ReturnType<typeof useIsAgendaFixadaSuspenseQuery>;
export type IsAgendaFixadaQueryResult = Apollo.QueryResult<Types.IsAgendaFixadaQuery, Types.IsAgendaFixadaQueryVariables>;
export const LotacaoAgendaSelectDocument = gql`
    query LotacaoAgendaSelect($id: ID!) {
  lotacao(id: $id) {
    ...LotacaoAgendaSelect
  }
}
    ${LotacaoAgendaSelectFragmentDoc}`;

/**
 * __useLotacaoAgendaSelectQuery__
 *
 * To run a query within a React component, call `useLotacaoAgendaSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoAgendaSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoAgendaSelectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLotacaoAgendaSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables> & ({ variables: Types.LotacaoAgendaSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>(LotacaoAgendaSelectDocument, options);
      }
export function useLotacaoAgendaSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>(LotacaoAgendaSelectDocument, options);
        }
export function useLotacaoAgendaSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>(LotacaoAgendaSelectDocument, options);
        }
export type LotacaoAgendaSelectQueryHookResult = ReturnType<typeof useLotacaoAgendaSelectQuery>;
export type LotacaoAgendaSelectLazyQueryHookResult = ReturnType<typeof useLotacaoAgendaSelectLazyQuery>;
export type LotacaoAgendaSelectSuspenseQueryHookResult = ReturnType<typeof useLotacaoAgendaSelectSuspenseQuery>;
export type LotacaoAgendaSelectQueryResult = Apollo.QueryResult<Types.LotacaoAgendaSelectQuery, Types.LotacaoAgendaSelectQueryVariables>;
export const LotacoesAgendaSelectDocument = gql`
    query LotacoesAgendaSelect($input: LotacoesAgendaInput!, $inputAgendaFixada: LotacoesAgendaFixadaInput!, $apenasFixadas: Boolean!, $semFixadas: Boolean!) {
  lotacoesAgenda(input: $input) @skip(if: $apenasFixadas) {
    content {
      ...LotacaoAgendaSelect
    }
    pageInfo {
      ...PageInfo
    }
  }
  lotacoesFixadasAgenda(input: $inputAgendaFixada) @skip(if: $semFixadas) {
    ...LotacaoAgendaSelect
  }
}
    ${LotacaoAgendaSelectFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useLotacoesAgendaSelectQuery__
 *
 * To run a query within a React component, call `useLotacoesAgendaSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacoesAgendaSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacoesAgendaSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *      inputAgendaFixada: // value for 'inputAgendaFixada'
 *      apenasFixadas: // value for 'apenasFixadas'
 *      semFixadas: // value for 'semFixadas'
 *   },
 * });
 */
export function useLotacoesAgendaSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables> & ({ variables: Types.LotacoesAgendaSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>(LotacoesAgendaSelectDocument, options);
      }
export function useLotacoesAgendaSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>(LotacoesAgendaSelectDocument, options);
        }
export function useLotacoesAgendaSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>(LotacoesAgendaSelectDocument, options);
        }
export type LotacoesAgendaSelectQueryHookResult = ReturnType<typeof useLotacoesAgendaSelectQuery>;
export type LotacoesAgendaSelectLazyQueryHookResult = ReturnType<typeof useLotacoesAgendaSelectLazyQuery>;
export type LotacoesAgendaSelectSuspenseQueryHookResult = ReturnType<typeof useLotacoesAgendaSelectSuspenseQuery>;
export type LotacoesAgendaSelectQueryResult = Apollo.QueryResult<Types.LotacoesAgendaSelectQuery, Types.LotacoesAgendaSelectQueryVariables>;
export const LotacaoAndEstagioSelectFieldDocument = gql`
    query LotacaoAndEstagioSelectField($input: LotacoesAndEstagiosInput!) {
  lotacoesAndEstagios(input: $input) {
    id
    ... on Lotacao {
      profissional {
        id
        nome
        nomeSocial
        cpf
        email
        cns
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      ...Cbo
      equipe {
        id
        ine
        nome
        isAD
      }
    }
    ... on Estagio {
      profissional {
        id
        nome
        nomeSocial
        cpf
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      ...Cbo
      equipe {
        id
        ine
        nome
      }
      lotacaoSupervisora {
        id
        profissional {
          id
          nome
          nomeSocial
          cpf
        }
      }
    }
  }
}
    ${CboFragmentDoc}`;

/**
 * __useLotacaoAndEstagioSelectFieldQuery__
 *
 * To run a query within a React component, call `useLotacaoAndEstagioSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoAndEstagioSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoAndEstagioSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotacaoAndEstagioSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables> & ({ variables: Types.LotacaoAndEstagioSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>(LotacaoAndEstagioSelectFieldDocument, options);
      }
export function useLotacaoAndEstagioSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>(LotacaoAndEstagioSelectFieldDocument, options);
        }
export function useLotacaoAndEstagioSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>(LotacaoAndEstagioSelectFieldDocument, options);
        }
export type LotacaoAndEstagioSelectFieldQueryHookResult = ReturnType<typeof useLotacaoAndEstagioSelectFieldQuery>;
export type LotacaoAndEstagioSelectFieldLazyQueryHookResult = ReturnType<typeof useLotacaoAndEstagioSelectFieldLazyQuery>;
export type LotacaoAndEstagioSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLotacaoAndEstagioSelectFieldSuspenseQuery>;
export type LotacaoAndEstagioSelectFieldQueryResult = Apollo.QueryResult<Types.LotacaoAndEstagioSelectFieldQuery, Types.LotacaoAndEstagioSelectFieldQueryVariables>;
export const LotacoesComRegulacoesSelectFieldDocument = gql`
    query LotacoesComRegulacoesSelectField($input: LotacoesComRegulacoesQueryInput!) {
  lotacoesComRegulacoes(input: $input) {
    id
    ativo
    profissional {
      id
      nome
      cpf
    }
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      ine
      nome
    }
  }
}
    `;

/**
 * __useLotacoesComRegulacoesSelectFieldQuery__
 *
 * To run a query within a React component, call `useLotacoesComRegulacoesSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacoesComRegulacoesSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacoesComRegulacoesSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotacoesComRegulacoesSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables> & ({ variables: Types.LotacoesComRegulacoesSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>(LotacoesComRegulacoesSelectFieldDocument, options);
      }
export function useLotacoesComRegulacoesSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>(LotacoesComRegulacoesSelectFieldDocument, options);
        }
export function useLotacoesComRegulacoesSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>(LotacoesComRegulacoesSelectFieldDocument, options);
        }
export type LotacoesComRegulacoesSelectFieldQueryHookResult = ReturnType<typeof useLotacoesComRegulacoesSelectFieldQuery>;
export type LotacoesComRegulacoesSelectFieldLazyQueryHookResult = ReturnType<typeof useLotacoesComRegulacoesSelectFieldLazyQuery>;
export type LotacoesComRegulacoesSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLotacoesComRegulacoesSelectFieldSuspenseQuery>;
export type LotacoesComRegulacoesSelectFieldQueryResult = Apollo.QueryResult<Types.LotacoesComRegulacoesSelectFieldQuery, Types.LotacoesComRegulacoesSelectFieldQueryVariables>;
export const LoteImunobiologicoSelectFieldDocument = gql`
    query LoteImunobiologicoSelectField($input: LoteImunobiologicoQueryInput!) {
  lotesImunobiologico(input: $input) {
    content {
      id
      lote
      fabricante {
        id
        nome
        codigoRnds
        sigla
      }
      validade
    }
  }
}
    `;

/**
 * __useLoteImunobiologicoSelectFieldQuery__
 *
 * To run a query within a React component, call `useLoteImunobiologicoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteImunobiologicoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteImunobiologicoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteImunobiologicoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables> & ({ variables: Types.LoteImunobiologicoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>(LoteImunobiologicoSelectFieldDocument, options);
      }
export function useLoteImunobiologicoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>(LoteImunobiologicoSelectFieldDocument, options);
        }
export function useLoteImunobiologicoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>(LoteImunobiologicoSelectFieldDocument, options);
        }
export type LoteImunobiologicoSelectFieldQueryHookResult = ReturnType<typeof useLoteImunobiologicoSelectFieldQuery>;
export type LoteImunobiologicoSelectFieldLazyQueryHookResult = ReturnType<typeof useLoteImunobiologicoSelectFieldLazyQuery>;
export type LoteImunobiologicoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLoteImunobiologicoSelectFieldSuspenseQuery>;
export type LoteImunobiologicoSelectFieldQueryResult = Apollo.QueryResult<Types.LoteImunobiologicoSelectFieldQuery, Types.LoteImunobiologicoSelectFieldQueryVariables>;
export const ManifestacaoAlergiaSelectFieldDocument = gql`
    query ManifestacaoAlergiaSelectField($filtro: ManifestacoesAlergiaQueryInput!) {
  manifestacoesAlergia(input: $filtro) {
    content {
      id
      nome
      sinonimo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useManifestacaoAlergiaSelectFieldQuery__
 *
 * To run a query within a React component, call `useManifestacaoAlergiaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useManifestacaoAlergiaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManifestacaoAlergiaSelectFieldQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useManifestacaoAlergiaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables> & ({ variables: Types.ManifestacaoAlergiaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>(ManifestacaoAlergiaSelectFieldDocument, options);
      }
export function useManifestacaoAlergiaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>(ManifestacaoAlergiaSelectFieldDocument, options);
        }
export function useManifestacaoAlergiaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>(ManifestacaoAlergiaSelectFieldDocument, options);
        }
export type ManifestacaoAlergiaSelectFieldQueryHookResult = ReturnType<typeof useManifestacaoAlergiaSelectFieldQuery>;
export type ManifestacaoAlergiaSelectFieldLazyQueryHookResult = ReturnType<typeof useManifestacaoAlergiaSelectFieldLazyQuery>;
export type ManifestacaoAlergiaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useManifestacaoAlergiaSelectFieldSuspenseQuery>;
export type ManifestacaoAlergiaSelectFieldQueryResult = Apollo.QueryResult<Types.ManifestacaoAlergiaSelectFieldQuery, Types.ManifestacaoAlergiaSelectFieldQueryVariables>;
export const MedicamentoCatmatSelectFieldDocument = gql`
    query MedicamentoCatmatSelectField($input: MedicamentoCatmatQueryInput!) {
  medicamentosCatmat(input: $input) {
    content {
      id
      volume
      medicamento {
        id
        principioAtivo
        unidadeFornecimento
        concentracao
        formaFarmaceutica {
          id
          nome
        }
      }
      codigoCatMat
      codigoObm
      codigoRename
      unidadeFornecimento {
        id
        nome
        nomePlural
      }
      principioAtivo {
        id
        nome
        listaMaterial {
          id
          tipo
          tipoReceita
        }
      }
      unidadeMedidaDose {
        id
        nome
        nomePlural
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useMedicamentoCatmatSelectFieldQuery__
 *
 * To run a query within a React component, call `useMedicamentoCatmatSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoCatmatSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoCatmatSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoCatmatSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables> & ({ variables: Types.MedicamentoCatmatSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>(MedicamentoCatmatSelectFieldDocument, options);
      }
export function useMedicamentoCatmatSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>(MedicamentoCatmatSelectFieldDocument, options);
        }
export function useMedicamentoCatmatSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>(MedicamentoCatmatSelectFieldDocument, options);
        }
export type MedicamentoCatmatSelectFieldQueryHookResult = ReturnType<typeof useMedicamentoCatmatSelectFieldQuery>;
export type MedicamentoCatmatSelectFieldLazyQueryHookResult = ReturnType<typeof useMedicamentoCatmatSelectFieldLazyQuery>;
export type MedicamentoCatmatSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMedicamentoCatmatSelectFieldSuspenseQuery>;
export type MedicamentoCatmatSelectFieldQueryResult = Apollo.QueryResult<Types.MedicamentoCatmatSelectFieldQuery, Types.MedicamentoCatmatSelectFieldQueryVariables>;
export const MedicamentosDocument = gql`
    query Medicamentos($input: MedicamentoQueryInput!) {
  medicamentos(input: $input) {
    content {
      id
      principioAtivo
      concentracao
      unidadeFornecimento
      formaFarmaceutica {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useMedicamentosQuery__
 *
 * To run a query within a React component, call `useMedicamentosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicamentosQuery, Types.MedicamentosQueryVariables> & ({ variables: Types.MedicamentosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>(MedicamentosDocument, options);
      }
export function useMedicamentosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>(MedicamentosDocument, options);
        }
export function useMedicamentosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>(MedicamentosDocument, options);
        }
export type MedicamentosQueryHookResult = ReturnType<typeof useMedicamentosQuery>;
export type MedicamentosLazyQueryHookResult = ReturnType<typeof useMedicamentosLazyQuery>;
export type MedicamentosSuspenseQueryHookResult = ReturnType<typeof useMedicamentosSuspenseQuery>;
export type MedicamentosQueryResult = Apollo.QueryResult<Types.MedicamentosQuery, Types.MedicamentosQueryVariables>;
export const MicroareaImovelSelectFieldDocument = gql`
    query MicroareaImovelSelectField($input: TerritorioEquipeQueryInput!) {
  microareasImoveis(input: $input)
}
    `;

/**
 * __useMicroareaImovelSelectFieldQuery__
 *
 * To run a query within a React component, call `useMicroareaImovelSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicroareaImovelSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicroareaImovelSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMicroareaImovelSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables> & ({ variables: Types.MicroareaImovelSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>(MicroareaImovelSelectFieldDocument, options);
      }
export function useMicroareaImovelSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>(MicroareaImovelSelectFieldDocument, options);
        }
export function useMicroareaImovelSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>(MicroareaImovelSelectFieldDocument, options);
        }
export type MicroareaImovelSelectFieldQueryHookResult = ReturnType<typeof useMicroareaImovelSelectFieldQuery>;
export type MicroareaImovelSelectFieldLazyQueryHookResult = ReturnType<typeof useMicroareaImovelSelectFieldLazyQuery>;
export type MicroareaImovelSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMicroareaImovelSelectFieldSuspenseQuery>;
export type MicroareaImovelSelectFieldQueryResult = Apollo.QueryResult<Types.MicroareaImovelSelectFieldQuery, Types.MicroareaImovelSelectFieldQueryVariables>;
export const MicroareasSelectFieldDocument = gql`
    query MicroareasSelectField($equipeResponsavelId: ID) {
  microareas(equipeResponsavelId: $equipeResponsavelId)
}
    `;

/**
 * __useMicroareasSelectFieldQuery__
 *
 * To run a query within a React component, call `useMicroareasSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicroareasSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicroareasSelectFieldQuery({
 *   variables: {
 *      equipeResponsavelId: // value for 'equipeResponsavelId'
 *   },
 * });
 */
export function useMicroareasSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>(MicroareasSelectFieldDocument, options);
      }
export function useMicroareasSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>(MicroareasSelectFieldDocument, options);
        }
export function useMicroareasSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>(MicroareasSelectFieldDocument, options);
        }
export type MicroareasSelectFieldQueryHookResult = ReturnType<typeof useMicroareasSelectFieldQuery>;
export type MicroareasSelectFieldLazyQueryHookResult = ReturnType<typeof useMicroareasSelectFieldLazyQuery>;
export type MicroareasSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMicroareasSelectFieldSuspenseQuery>;
export type MicroareasSelectFieldQueryResult = Apollo.QueryResult<Types.MicroareasSelectFieldQuery, Types.MicroareasSelectFieldQueryVariables>;
export const MunicipioSelectFieldDocument = gql`
    query MunicipioSelectField($input: MunicipiosQueryInput!) {
  municipios(input: $input) {
    content {
      id
      nome
      uf {
        id
        nome
        sigla
      }
      ibge
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useMunicipioSelectFieldQuery__
 *
 * To run a query within a React component, call `useMunicipioSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipioSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipioSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipioSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables> & ({ variables: Types.MunicipioSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>(MunicipioSelectFieldDocument, options);
      }
export function useMunicipioSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>(MunicipioSelectFieldDocument, options);
        }
export function useMunicipioSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>(MunicipioSelectFieldDocument, options);
        }
export type MunicipioSelectFieldQueryHookResult = ReturnType<typeof useMunicipioSelectFieldQuery>;
export type MunicipioSelectFieldLazyQueryHookResult = ReturnType<typeof useMunicipioSelectFieldLazyQuery>;
export type MunicipioSelectFieldSuspenseQueryHookResult = ReturnType<typeof useMunicipioSelectFieldSuspenseQuery>;
export type MunicipioSelectFieldQueryResult = Apollo.QueryResult<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>;
export const PaisSelectFieldDocument = gql`
    query PaisSelectField($input: PaisQueryInput!) {
  paises(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePaisSelectFieldQuery__
 *
 * To run a query within a React component, call `usePaisSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaisSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaisSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaisSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables> & ({ variables: Types.PaisSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>(PaisSelectFieldDocument, options);
      }
export function usePaisSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>(PaisSelectFieldDocument, options);
        }
export function usePaisSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>(PaisSelectFieldDocument, options);
        }
export type PaisSelectFieldQueryHookResult = ReturnType<typeof usePaisSelectFieldQuery>;
export type PaisSelectFieldLazyQueryHookResult = ReturnType<typeof usePaisSelectFieldLazyQuery>;
export type PaisSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePaisSelectFieldSuspenseQuery>;
export type PaisSelectFieldQueryResult = Apollo.QueryResult<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>;
export const PerfilSelectFieldDocument = gql`
    query PerfilSelectField($input: PerfisQueryInput!) {
  perfis(input: $input) {
    content {
      id
      nome
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePerfilSelectFieldQuery__
 *
 * To run a query within a React component, call `usePerfilSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerfilSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables> & ({ variables: Types.PerfilSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>(PerfilSelectFieldDocument, options);
      }
export function usePerfilSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>(PerfilSelectFieldDocument, options);
        }
export function usePerfilSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>(PerfilSelectFieldDocument, options);
        }
export type PerfilSelectFieldQueryHookResult = ReturnType<typeof usePerfilSelectFieldQuery>;
export type PerfilSelectFieldLazyQueryHookResult = ReturnType<typeof usePerfilSelectFieldLazyQuery>;
export type PerfilSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePerfilSelectFieldSuspenseQuery>;
export type PerfilSelectFieldQueryResult = Apollo.QueryResult<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>;
export const PoloBaseSelectFieldDocument = gql`
    query PoloBaseSelectField($input: PoloBaseInput!) {
  polosBases(input: $input) {
    content {
      id
      nome
      dsei {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePoloBaseSelectFieldQuery__
 *
 * To run a query within a React component, call `usePoloBaseSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoloBaseSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoloBaseSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePoloBaseSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables> & ({ variables: Types.PoloBaseSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>(PoloBaseSelectFieldDocument, options);
      }
export function usePoloBaseSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>(PoloBaseSelectFieldDocument, options);
        }
export function usePoloBaseSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>(PoloBaseSelectFieldDocument, options);
        }
export type PoloBaseSelectFieldQueryHookResult = ReturnType<typeof usePoloBaseSelectFieldQuery>;
export type PoloBaseSelectFieldLazyQueryHookResult = ReturnType<typeof usePoloBaseSelectFieldLazyQuery>;
export type PoloBaseSelectFieldSuspenseQueryHookResult = ReturnType<typeof usePoloBaseSelectFieldSuspenseQuery>;
export type PoloBaseSelectFieldQueryResult = Apollo.QueryResult<Types.PoloBaseSelectFieldQuery, Types.PoloBaseSelectFieldQueryVariables>;
export const ProcedimentoOdontoSelectFieldDocument = gql`
    query ProcedimentoOdontoSelectField($input: ProcedimentoOdontoQueryInput!) {
  procedimentosEvolucaoOdonto(input: $input) {
    content {
      ...Procedimento
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ProcedimentoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useProcedimentoOdontoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProcedimentoOdontoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentoOdontoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentoOdontoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcedimentoOdontoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables> & ({ variables: Types.ProcedimentoOdontoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>(ProcedimentoOdontoSelectFieldDocument, options);
      }
export function useProcedimentoOdontoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>(ProcedimentoOdontoSelectFieldDocument, options);
        }
export function useProcedimentoOdontoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>(ProcedimentoOdontoSelectFieldDocument, options);
        }
export type ProcedimentoOdontoSelectFieldQueryHookResult = ReturnType<typeof useProcedimentoOdontoSelectFieldQuery>;
export type ProcedimentoOdontoSelectFieldLazyQueryHookResult = ReturnType<typeof useProcedimentoOdontoSelectFieldLazyQuery>;
export type ProcedimentoOdontoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useProcedimentoOdontoSelectFieldSuspenseQuery>;
export type ProcedimentoOdontoSelectFieldQueryResult = Apollo.QueryResult<Types.ProcedimentoOdontoSelectFieldQuery, Types.ProcedimentoOdontoSelectFieldQueryVariables>;
export const ProcedimentoSelectFieldDocument = gql`
    query ProcedimentoSelectField($input: ProcedimentoQueryInput!) {
  procedimentos(input: $input) {
    content {
      ...Procedimento
      idadeMinima
      idadeMaxima
      idadeAplicavel
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ProcedimentoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useProcedimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProcedimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcedimentoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables> & ({ variables: Types.ProcedimentoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>(ProcedimentoSelectFieldDocument, options);
      }
export function useProcedimentoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>(ProcedimentoSelectFieldDocument, options);
        }
export function useProcedimentoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>(ProcedimentoSelectFieldDocument, options);
        }
export type ProcedimentoSelectFieldQueryHookResult = ReturnType<typeof useProcedimentoSelectFieldQuery>;
export type ProcedimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useProcedimentoSelectFieldLazyQuery>;
export type ProcedimentoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useProcedimentoSelectFieldSuspenseQuery>;
export type ProcedimentoSelectFieldQueryResult = Apollo.QueryResult<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>;
export const ProfissionaisRelatorioInconsistenciaDocument = gql`
    query ProfissionaisRelatorioInconsistencia($filtro: ProfissionaisRelatorioInconsistenciaQueryInput!) {
  profissionaisRelatorioInconsistencia(filtro: $filtro) {
    content {
      id
      responsavel
      cpfResponsavel
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProfissionaisRelatorioInconsistenciaQuery__
 *
 * To run a query within a React component, call `useProfissionaisRelatorioInconsistenciaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionaisRelatorioInconsistenciaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionaisRelatorioInconsistenciaQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProfissionaisRelatorioInconsistenciaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables> & ({ variables: Types.ProfissionaisRelatorioInconsistenciaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>(ProfissionaisRelatorioInconsistenciaDocument, options);
      }
export function useProfissionaisRelatorioInconsistenciaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>(ProfissionaisRelatorioInconsistenciaDocument, options);
        }
export function useProfissionaisRelatorioInconsistenciaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>(ProfissionaisRelatorioInconsistenciaDocument, options);
        }
export type ProfissionaisRelatorioInconsistenciaQueryHookResult = ReturnType<typeof useProfissionaisRelatorioInconsistenciaQuery>;
export type ProfissionaisRelatorioInconsistenciaLazyQueryHookResult = ReturnType<typeof useProfissionaisRelatorioInconsistenciaLazyQuery>;
export type ProfissionaisRelatorioInconsistenciaSuspenseQueryHookResult = ReturnType<typeof useProfissionaisRelatorioInconsistenciaSuspenseQuery>;
export type ProfissionaisRelatorioInconsistenciaQueryResult = Apollo.QueryResult<Types.ProfissionaisRelatorioInconsistenciaQuery, Types.ProfissionaisRelatorioInconsistenciaQueryVariables>;
export const ProfissionalAdSelectFieldDocument = gql`
    query ProfissionalAdSelectField($inputEquipe: EquipesAdQueryInput!, $inputProf: ProfissionaisAdQueryInput!) {
  profissionaisAD(equipeFilter: $inputEquipe, profissionalFilter: $inputProf) {
    content {
      id
      nome
      nomeSocial
      cpf
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProfissionalAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useProfissionalAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAdSelectFieldQuery({
 *   variables: {
 *      inputEquipe: // value for 'inputEquipe'
 *      inputProf: // value for 'inputProf'
 *   },
 * });
 */
export function useProfissionalAdSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables> & ({ variables: Types.ProfissionalAdSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>(ProfissionalAdSelectFieldDocument, options);
      }
export function useProfissionalAdSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>(ProfissionalAdSelectFieldDocument, options);
        }
export function useProfissionalAdSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>(ProfissionalAdSelectFieldDocument, options);
        }
export type ProfissionalAdSelectFieldQueryHookResult = ReturnType<typeof useProfissionalAdSelectFieldQuery>;
export type ProfissionalAdSelectFieldLazyQueryHookResult = ReturnType<typeof useProfissionalAdSelectFieldLazyQuery>;
export type ProfissionalAdSelectFieldSuspenseQueryHookResult = ReturnType<typeof useProfissionalAdSelectFieldSuspenseQuery>;
export type ProfissionalAdSelectFieldQueryResult = Apollo.QueryResult<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>;
export const ProfissionalSelectDocument = gql`
    query ProfissionalSelect($input: ProfissionaisQueryInput!) {
  profissionais(input: $input) {
    content {
      id
      nome
      nomeSocial
      cpf
      cns
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProfissionalSelectQuery__
 *
 * To run a query within a React component, call `useProfissionalSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables> & ({ variables: Types.ProfissionalSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>(ProfissionalSelectDocument, options);
      }
export function useProfissionalSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>(ProfissionalSelectDocument, options);
        }
export function useProfissionalSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>(ProfissionalSelectDocument, options);
        }
export type ProfissionalSelectQueryHookResult = ReturnType<typeof useProfissionalSelectQuery>;
export type ProfissionalSelectLazyQueryHookResult = ReturnType<typeof useProfissionalSelectLazyQuery>;
export type ProfissionalSelectSuspenseQueryHookResult = ReturnType<typeof useProfissionalSelectSuspenseQuery>;
export type ProfissionalSelectQueryResult = Apollo.QueryResult<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>;
export const ResponsavelFamiliarSelectFieldDocument = gql`
    query ResponsavelFamiliarSelectField($input: CidadaosComboQueryInput!) {
  cidadaosCombo(input: $input) {
    id
    nome
    nomeSocial
    cpf
    cns
    uuidUltimaFicha
    statusResponsavelFamiliar
  }
}
    `;

/**
 * __useResponsavelFamiliarSelectFieldQuery__
 *
 * To run a query within a React component, call `useResponsavelFamiliarSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponsavelFamiliarSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponsavelFamiliarSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponsavelFamiliarSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables> & ({ variables: Types.ResponsavelFamiliarSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>(ResponsavelFamiliarSelectFieldDocument, options);
      }
export function useResponsavelFamiliarSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>(ResponsavelFamiliarSelectFieldDocument, options);
        }
export function useResponsavelFamiliarSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>(ResponsavelFamiliarSelectFieldDocument, options);
        }
export type ResponsavelFamiliarSelectFieldQueryHookResult = ReturnType<typeof useResponsavelFamiliarSelectFieldQuery>;
export type ResponsavelFamiliarSelectFieldLazyQueryHookResult = ReturnType<typeof useResponsavelFamiliarSelectFieldLazyQuery>;
export type ResponsavelFamiliarSelectFieldSuspenseQueryHookResult = ReturnType<typeof useResponsavelFamiliarSelectFieldSuspenseQuery>;
export type ResponsavelFamiliarSelectFieldQueryResult = Apollo.QueryResult<Types.ResponsavelFamiliarSelectFieldQuery, Types.ResponsavelFamiliarSelectFieldQueryVariables>;
export const SubstanciaAlergiaSelectFieldDocument = gql`
    query SubstanciaAlergiaSelectField($filtro: SubstanciasCbaraAlergiaQueryInput!) {
  substanciasCbaraAlergia(input: $filtro) {
    content {
      id
      categoria
      nome
      sinonimos
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useSubstanciaAlergiaSelectFieldQuery__
 *
 * To run a query within a React component, call `useSubstanciaAlergiaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubstanciaAlergiaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubstanciaAlergiaSelectFieldQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useSubstanciaAlergiaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables> & ({ variables: Types.SubstanciaAlergiaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>(SubstanciaAlergiaSelectFieldDocument, options);
      }
export function useSubstanciaAlergiaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>(SubstanciaAlergiaSelectFieldDocument, options);
        }
export function useSubstanciaAlergiaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>(SubstanciaAlergiaSelectFieldDocument, options);
        }
export type SubstanciaAlergiaSelectFieldQueryHookResult = ReturnType<typeof useSubstanciaAlergiaSelectFieldQuery>;
export type SubstanciaAlergiaSelectFieldLazyQueryHookResult = ReturnType<typeof useSubstanciaAlergiaSelectFieldLazyQuery>;
export type SubstanciaAlergiaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useSubstanciaAlergiaSelectFieldSuspenseQuery>;
export type SubstanciaAlergiaSelectFieldQueryResult = Apollo.QueryResult<Types.SubstanciaAlergiaSelectFieldQuery, Types.SubstanciaAlergiaSelectFieldQueryVariables>;
export const TipoEventoSelectFieldDocument = gql`
    query TipoEventoSelectField {
  auditoriaTipoEvento {
    id
    nome
  }
}
    `;

/**
 * __useTipoEventoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoEventoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoEventoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoEventoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoEventoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>(TipoEventoSelectFieldDocument, options);
      }
export function useTipoEventoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>(TipoEventoSelectFieldDocument, options);
        }
export function useTipoEventoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>(TipoEventoSelectFieldDocument, options);
        }
export type TipoEventoSelectFieldQueryHookResult = ReturnType<typeof useTipoEventoSelectFieldQuery>;
export type TipoEventoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoEventoSelectFieldLazyQuery>;
export type TipoEventoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoEventoSelectFieldSuspenseQuery>;
export type TipoEventoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>;
export const TipoLogradouroSelectFieldDocument = gql`
    query TipoLogradouroSelectField($input: TipoLogradouroInput!) {
  tiposLogradouro(input: $input) {
    content {
      id
      nome
      numeroDne
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTipoLogradouroSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoLogradouroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoLogradouroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoLogradouroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoLogradouroSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables> & ({ variables: Types.TipoLogradouroSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>(TipoLogradouroSelectFieldDocument, options);
      }
export function useTipoLogradouroSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>(TipoLogradouroSelectFieldDocument, options);
        }
export function useTipoLogradouroSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>(TipoLogradouroSelectFieldDocument, options);
        }
export type TipoLogradouroSelectFieldQueryHookResult = ReturnType<typeof useTipoLogradouroSelectFieldQuery>;
export type TipoLogradouroSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoLogradouroSelectFieldLazyQuery>;
export type TipoLogradouroSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoLogradouroSelectFieldSuspenseQuery>;
export type TipoLogradouroSelectFieldQueryResult = Apollo.QueryResult<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>;
export const TipoRegistroAfetadoSelectFieldDocument = gql`
    query TipoRegistroAfetadoSelectField {
  auditoriaTipoRegistroAfetado {
    id
    nome
  }
}
    `;

/**
 * __useTipoRegistroAfetadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoRegistroAfetadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoRegistroAfetadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoRegistroAfetadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoRegistroAfetadoSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>(TipoRegistroAfetadoSelectFieldDocument, options);
      }
export function useTipoRegistroAfetadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>(TipoRegistroAfetadoSelectFieldDocument, options);
        }
export function useTipoRegistroAfetadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>(TipoRegistroAfetadoSelectFieldDocument, options);
        }
export type TipoRegistroAfetadoSelectFieldQueryHookResult = ReturnType<typeof useTipoRegistroAfetadoSelectFieldQuery>;
export type TipoRegistroAfetadoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoRegistroAfetadoSelectFieldLazyQuery>;
export type TipoRegistroAfetadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoRegistroAfetadoSelectFieldSuspenseQuery>;
export type TipoRegistroAfetadoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoRegistroAfetadoSelectFieldQuery, Types.TipoRegistroAfetadoSelectFieldQueryVariables>;
export const TipoRegistroSelectFieldDocument = gql`
    query TipoRegistroSelectField($input: TipoRegistroHistoricoClinicoQueryInput!) {
  tipoRegistroHistorico(input: $input)
}
    `;

/**
 * __useTipoRegistroSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoRegistroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoRegistroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoRegistroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoRegistroSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables> & ({ variables: Types.TipoRegistroSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>(TipoRegistroSelectFieldDocument, options);
      }
export function useTipoRegistroSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>(TipoRegistroSelectFieldDocument, options);
        }
export function useTipoRegistroSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>(TipoRegistroSelectFieldDocument, options);
        }
export type TipoRegistroSelectFieldQueryHookResult = ReturnType<typeof useTipoRegistroSelectFieldQuery>;
export type TipoRegistroSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoRegistroSelectFieldLazyQuery>;
export type TipoRegistroSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoRegistroSelectFieldSuspenseQuery>;
export type TipoRegistroSelectFieldQueryResult = Apollo.QueryResult<Types.TipoRegistroSelectFieldQuery, Types.TipoRegistroSelectFieldQueryVariables>;
export const TipoServicoSelectFieldDocument = gql`
    query TipoServicoSelectField($input: TipoServicoQueryInput!) {
  tiposServico(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTipoServicoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoServicoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables> & ({ variables: Types.TipoServicoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>(TipoServicoSelectFieldDocument, options);
      }
export function useTipoServicoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>(TipoServicoSelectFieldDocument, options);
        }
export function useTipoServicoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>(TipoServicoSelectFieldDocument, options);
        }
export type TipoServicoSelectFieldQueryHookResult = ReturnType<typeof useTipoServicoSelectFieldQuery>;
export type TipoServicoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoServicoSelectFieldLazyQuery>;
export type TipoServicoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTipoServicoSelectFieldSuspenseQuery>;
export type TipoServicoSelectFieldQueryResult = Apollo.QueryResult<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>;
export const TiposOrigemDadoTransporteSelectFieldDocument = gql`
    query TiposOrigemDadoTransporteSelectField {
  tiposOrigemDadoTransporte {
    id
    descricao
  }
}
    `;

/**
 * __useTiposOrigemDadoTransporteSelectFieldQuery__
 *
 * To run a query within a React component, call `useTiposOrigemDadoTransporteSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiposOrigemDadoTransporteSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiposOrigemDadoTransporteSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiposOrigemDadoTransporteSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>(TiposOrigemDadoTransporteSelectFieldDocument, options);
      }
export function useTiposOrigemDadoTransporteSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>(TiposOrigemDadoTransporteSelectFieldDocument, options);
        }
export function useTiposOrigemDadoTransporteSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>(TiposOrigemDadoTransporteSelectFieldDocument, options);
        }
export type TiposOrigemDadoTransporteSelectFieldQueryHookResult = ReturnType<typeof useTiposOrigemDadoTransporteSelectFieldQuery>;
export type TiposOrigemDadoTransporteSelectFieldLazyQueryHookResult = ReturnType<typeof useTiposOrigemDadoTransporteSelectFieldLazyQuery>;
export type TiposOrigemDadoTransporteSelectFieldSuspenseQueryHookResult = ReturnType<typeof useTiposOrigemDadoTransporteSelectFieldSuspenseQuery>;
export type TiposOrigemDadoTransporteSelectFieldQueryResult = Apollo.QueryResult<Types.TiposOrigemDadoTransporteSelectFieldQuery, Types.TiposOrigemDadoTransporteSelectFieldQueryVariables>;
export const UnidadeMedidaSelectFieldDocument = gql`
    query UnidadeMedidaSelectField($input: UnidadeMedidaQueryInput!) {
  unidadesMedida(input: $input) {
    content {
      id
      nome
      nomePlural
    }
  }
}
    `;

/**
 * __useUnidadeMedidaSelectFieldQuery__
 *
 * To run a query within a React component, call `useUnidadeMedidaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeMedidaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeMedidaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeMedidaSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables> & ({ variables: Types.UnidadeMedidaSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>(UnidadeMedidaSelectFieldDocument, options);
      }
export function useUnidadeMedidaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>(UnidadeMedidaSelectFieldDocument, options);
        }
export function useUnidadeMedidaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>(UnidadeMedidaSelectFieldDocument, options);
        }
export type UnidadeMedidaSelectFieldQueryHookResult = ReturnType<typeof useUnidadeMedidaSelectFieldQuery>;
export type UnidadeMedidaSelectFieldLazyQueryHookResult = ReturnType<typeof useUnidadeMedidaSelectFieldLazyQuery>;
export type UnidadeMedidaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useUnidadeMedidaSelectFieldSuspenseQuery>;
export type UnidadeMedidaSelectFieldQueryResult = Apollo.QueryResult<Types.UnidadeMedidaSelectFieldQuery, Types.UnidadeMedidaSelectFieldQueryVariables>;
export const UnidadesSaudeSelectFieldDocument = gql`
    query UnidadesSaudeSelectField($input: UnidadesSaudeQueryInput!) {
  unidadesSaude(input: $input) {
    content {
      id
      cnes
      nome
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useUnidadesSaudeSelectFieldQuery__
 *
 * To run a query within a React component, call `useUnidadesSaudeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadesSaudeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadesSaudeSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadesSaudeSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables> & ({ variables: Types.UnidadesSaudeSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>(UnidadesSaudeSelectFieldDocument, options);
      }
export function useUnidadesSaudeSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>(UnidadesSaudeSelectFieldDocument, options);
        }
export function useUnidadesSaudeSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>(UnidadesSaudeSelectFieldDocument, options);
        }
export type UnidadesSaudeSelectFieldQueryHookResult = ReturnType<typeof useUnidadesSaudeSelectFieldQuery>;
export type UnidadesSaudeSelectFieldLazyQueryHookResult = ReturnType<typeof useUnidadesSaudeSelectFieldLazyQuery>;
export type UnidadesSaudeSelectFieldSuspenseQueryHookResult = ReturnType<typeof useUnidadesSaudeSelectFieldSuspenseQuery>;
export type UnidadesSaudeSelectFieldQueryResult = Apollo.QueryResult<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>;
export const ViaAdministracaoSelectFieldDocument = gql`
    query ViaAdministracaoSelectField($input: AplicacaoMedicamentoQueryInput!) {
  aplicacoesMedicamento(input: $input) {
    content {
      id
      nome
    }
  }
}
    `;

/**
 * __useViaAdministracaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useViaAdministracaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useViaAdministracaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViaAdministracaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViaAdministracaoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables> & ({ variables: Types.ViaAdministracaoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>(ViaAdministracaoSelectFieldDocument, options);
      }
export function useViaAdministracaoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>(ViaAdministracaoSelectFieldDocument, options);
        }
export function useViaAdministracaoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>(ViaAdministracaoSelectFieldDocument, options);
        }
export type ViaAdministracaoSelectFieldQueryHookResult = ReturnType<typeof useViaAdministracaoSelectFieldQuery>;
export type ViaAdministracaoSelectFieldLazyQueryHookResult = ReturnType<typeof useViaAdministracaoSelectFieldLazyQuery>;
export type ViaAdministracaoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useViaAdministracaoSelectFieldSuspenseQuery>;
export type ViaAdministracaoSelectFieldQueryResult = Apollo.QueryResult<Types.ViaAdministracaoSelectFieldQuery, Types.ViaAdministracaoSelectFieldQueryVariables>;
export const ViaAdministracaoVacinaSelectFieldDocument = gql`
    query ViaAdministracaoVacinaSelectField($inputQuery: String) {
  viasAdministracaoVacina(inputQuery: $inputQuery) {
    id
    nome
  }
}
    `;

/**
 * __useViaAdministracaoVacinaSelectFieldQuery__
 *
 * To run a query within a React component, call `useViaAdministracaoVacinaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useViaAdministracaoVacinaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViaAdministracaoVacinaSelectFieldQuery({
 *   variables: {
 *      inputQuery: // value for 'inputQuery'
 *   },
 * });
 */
export function useViaAdministracaoVacinaSelectFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>(ViaAdministracaoVacinaSelectFieldDocument, options);
      }
export function useViaAdministracaoVacinaSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>(ViaAdministracaoVacinaSelectFieldDocument, options);
        }
export function useViaAdministracaoVacinaSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>(ViaAdministracaoVacinaSelectFieldDocument, options);
        }
export type ViaAdministracaoVacinaSelectFieldQueryHookResult = ReturnType<typeof useViaAdministracaoVacinaSelectFieldQuery>;
export type ViaAdministracaoVacinaSelectFieldLazyQueryHookResult = ReturnType<typeof useViaAdministracaoVacinaSelectFieldLazyQuery>;
export type ViaAdministracaoVacinaSelectFieldSuspenseQueryHookResult = ReturnType<typeof useViaAdministracaoVacinaSelectFieldSuspenseQuery>;
export type ViaAdministracaoVacinaSelectFieldQueryResult = Apollo.QueryResult<Types.ViaAdministracaoVacinaSelectFieldQuery, Types.ViaAdministracaoVacinaSelectFieldQueryVariables>;
export const CompartilharVideochamadaDocument = gql`
    mutation CompartilharVideochamada($input: CompartilharVideochamadaInput!) {
  compartilharVideochamada(input: $input)
}
    `;
export type CompartilharVideochamadaMutationFn = Apollo.MutationFunction<Types.CompartilharVideochamadaMutation, Types.CompartilharVideochamadaMutationVariables>;

/**
 * __useCompartilharVideochamadaMutation__
 *
 * To run a mutation, you first call `useCompartilharVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompartilharVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compartilharVideochamadaMutation, { data, loading, error }] = useCompartilharVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompartilharVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CompartilharVideochamadaMutation, Types.CompartilharVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CompartilharVideochamadaMutation, Types.CompartilharVideochamadaMutationVariables>(CompartilharVideochamadaDocument, options);
      }
export type CompartilharVideochamadaMutationHookResult = ReturnType<typeof useCompartilharVideochamadaMutation>;
export type CompartilharVideochamadaMutationResult = Apollo.MutationResult<Types.CompartilharVideochamadaMutation>;
export type CompartilharVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.CompartilharVideochamadaMutation, Types.CompartilharVideochamadaMutationVariables>;
export const FlagsDocument = gql`
    query Flags {
  info {
    id
    flags {
      id
      nome
      valor
    }
  }
}
    `;

/**
 * __useFlagsQuery__
 *
 * To run a query within a React component, call `useFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FlagsQuery, Types.FlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FlagsQuery, Types.FlagsQueryVariables>(FlagsDocument, options);
      }
export function useFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FlagsQuery, Types.FlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FlagsQuery, Types.FlagsQueryVariables>(FlagsDocument, options);
        }
export function useFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FlagsQuery, Types.FlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FlagsQuery, Types.FlagsQueryVariables>(FlagsDocument, options);
        }
export type FlagsQueryHookResult = ReturnType<typeof useFlagsQuery>;
export type FlagsLazyQueryHookResult = ReturnType<typeof useFlagsLazyQuery>;
export type FlagsSuspenseQueryHookResult = ReturnType<typeof useFlagsSuspenseQuery>;
export type FlagsQueryResult = Apollo.QueryResult<Types.FlagsQuery, Types.FlagsQueryVariables>;
export const AsyncProcessingStatusDocument = gql`
    query AsyncProcessingStatus($asyncProcessingName: AsyncProcessingNameEnum!) {
  asyncProcessingStatus(asyncProcessingName: $asyncProcessingName) {
    isStarted
    isFinished
    errorMessage
  }
}
    `;

/**
 * __useAsyncProcessingStatusQuery__
 *
 * To run a query within a React component, call `useAsyncProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsyncProcessingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsyncProcessingStatusQuery({
 *   variables: {
 *      asyncProcessingName: // value for 'asyncProcessingName'
 *   },
 * });
 */
export function useAsyncProcessingStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables> & ({ variables: Types.AsyncProcessingStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>(AsyncProcessingStatusDocument, options);
      }
export function useAsyncProcessingStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>(AsyncProcessingStatusDocument, options);
        }
export function useAsyncProcessingStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>(AsyncProcessingStatusDocument, options);
        }
export type AsyncProcessingStatusQueryHookResult = ReturnType<typeof useAsyncProcessingStatusQuery>;
export type AsyncProcessingStatusLazyQueryHookResult = ReturnType<typeof useAsyncProcessingStatusLazyQuery>;
export type AsyncProcessingStatusSuspenseQueryHookResult = ReturnType<typeof useAsyncProcessingStatusSuspenseQuery>;
export type AsyncProcessingStatusQueryResult = Apollo.QueryResult<Types.AsyncProcessingStatusQuery, Types.AsyncProcessingStatusQueryVariables>;
export const RemoverProcessoAssincronoDocument = gql`
    mutation RemoverProcessoAssincrono($asyncProcessingName: AsyncProcessingNameEnum!) {
  removerProcessoAssincrono(asyncProcessingName: $asyncProcessingName)
}
    `;
export type RemoverProcessoAssincronoMutationFn = Apollo.MutationFunction<Types.RemoverProcessoAssincronoMutation, Types.RemoverProcessoAssincronoMutationVariables>;

/**
 * __useRemoverProcessoAssincronoMutation__
 *
 * To run a mutation, you first call `useRemoverProcessoAssincronoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverProcessoAssincronoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerProcessoAssincronoMutation, { data, loading, error }] = useRemoverProcessoAssincronoMutation({
 *   variables: {
 *      asyncProcessingName: // value for 'asyncProcessingName'
 *   },
 * });
 */
export function useRemoverProcessoAssincronoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverProcessoAssincronoMutation, Types.RemoverProcessoAssincronoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverProcessoAssincronoMutation, Types.RemoverProcessoAssincronoMutationVariables>(RemoverProcessoAssincronoDocument, options);
      }
export type RemoverProcessoAssincronoMutationHookResult = ReturnType<typeof useRemoverProcessoAssincronoMutation>;
export type RemoverProcessoAssincronoMutationResult = Apollo.MutationResult<Types.RemoverProcessoAssincronoMutation>;
export type RemoverProcessoAssincronoMutationOptions = Apollo.BaseMutationOptions<Types.RemoverProcessoAssincronoMutation, Types.RemoverProcessoAssincronoMutationVariables>;
export const RemoverTodosProcessosAssincronosDocument = gql`
    mutation RemoverTodosProcessosAssincronos {
  removerTodosProcessosAssincronos
}
    `;
export type RemoverTodosProcessosAssincronosMutationFn = Apollo.MutationFunction<Types.RemoverTodosProcessosAssincronosMutation, Types.RemoverTodosProcessosAssincronosMutationVariables>;

/**
 * __useRemoverTodosProcessosAssincronosMutation__
 *
 * To run a mutation, you first call `useRemoverTodosProcessosAssincronosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverTodosProcessosAssincronosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerTodosProcessosAssincronosMutation, { data, loading, error }] = useRemoverTodosProcessosAssincronosMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoverTodosProcessosAssincronosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverTodosProcessosAssincronosMutation, Types.RemoverTodosProcessosAssincronosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverTodosProcessosAssincronosMutation, Types.RemoverTodosProcessosAssincronosMutationVariables>(RemoverTodosProcessosAssincronosDocument, options);
      }
export type RemoverTodosProcessosAssincronosMutationHookResult = ReturnType<typeof useRemoverTodosProcessosAssincronosMutation>;
export type RemoverTodosProcessosAssincronosMutationResult = Apollo.MutationResult<Types.RemoverTodosProcessosAssincronosMutation>;
export type RemoverTodosProcessosAssincronosMutationOptions = Apollo.BaseMutationOptions<Types.RemoverTodosProcessosAssincronosMutation, Types.RemoverTodosProcessosAssincronosMutationVariables>;
export const ConfiguracoesDocument = gql`
    query Configuracoes {
  info {
    id
    smtpConfigurado
    internetHabilitada
    govBREnabled
    versao
    buscaCidadaoPorPropriedadesEnabled
    oldPecConnected
    analytics {
      id
      enabled
      host
      websiteId
      sampleRate
    }
    ativado
    treinamento
    isDocumentosEnvioCidadaoEnabled
    isAssinaturaRegistrosEnabled
    isDocumentosRndsEnabled
    dataAtivacaoAssinaturaRegistros
    rocksdbEnabled
    tipoInstalacao
    cadastroDomiciliarViaCdsEnabled
    cadastroIndividualViaCdsEnabled
    anexoArquivosEnabled
    sentry {
      id
      enabled
      dsn
    }
    frontendLogLevel
    linkInstalacao
  }
}
    `;

/**
 * __useConfiguracoesQuery__
 *
 * To run a query within a React component, call `useConfiguracoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracoesQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracoesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>(ConfiguracoesDocument, options);
      }
export function useConfiguracoesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>(ConfiguracoesDocument, options);
        }
export function useConfiguracoesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>(ConfiguracoesDocument, options);
        }
export type ConfiguracoesQueryHookResult = ReturnType<typeof useConfiguracoesQuery>;
export type ConfiguracoesLazyQueryHookResult = ReturnType<typeof useConfiguracoesLazyQuery>;
export type ConfiguracoesSuspenseQueryHookResult = ReturnType<typeof useConfiguracoesSuspenseQuery>;
export type ConfiguracoesQueryResult = Apollo.QueryResult<Types.ConfiguracoesQuery, Types.ConfiguracoesQueryVariables>;
export const VerificaConexaoServidorDocument = gql`
    query VerificaConexaoServidor {
  serverTime
}
    `;

/**
 * __useVerificaConexaoServidorQuery__
 *
 * To run a query within a React component, call `useVerificaConexaoServidorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificaConexaoServidorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificaConexaoServidorQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerificaConexaoServidorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>(VerificaConexaoServidorDocument, options);
      }
export function useVerificaConexaoServidorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>(VerificaConexaoServidorDocument, options);
        }
export function useVerificaConexaoServidorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>(VerificaConexaoServidorDocument, options);
        }
export type VerificaConexaoServidorQueryHookResult = ReturnType<typeof useVerificaConexaoServidorQuery>;
export type VerificaConexaoServidorLazyQueryHookResult = ReturnType<typeof useVerificaConexaoServidorLazyQuery>;
export type VerificaConexaoServidorSuspenseQueryHookResult = ReturnType<typeof useVerificaConexaoServidorSuspenseQuery>;
export type VerificaConexaoServidorQueryResult = Apollo.QueryResult<Types.VerificaConexaoServidorQuery, Types.VerificaConexaoServidorQueryVariables>;
export const LembreteProfissionalByInputDocument = gql`
    query LembreteProfissionalByInput($input: LembreteProfissionalInput!) {
  lembreteProfissional(input: $input) {
    id
    visualizado
    dataExibirNovamente
    dataVisualizado
    identificadorLembrete
  }
}
    `;

/**
 * __useLembreteProfissionalByInputQuery__
 *
 * To run a query within a React component, call `useLembreteProfissionalByInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useLembreteProfissionalByInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLembreteProfissionalByInputQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLembreteProfissionalByInputQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables> & ({ variables: Types.LembreteProfissionalByInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>(LembreteProfissionalByInputDocument, options);
      }
export function useLembreteProfissionalByInputLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>(LembreteProfissionalByInputDocument, options);
        }
export function useLembreteProfissionalByInputSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>(LembreteProfissionalByInputDocument, options);
        }
export type LembreteProfissionalByInputQueryHookResult = ReturnType<typeof useLembreteProfissionalByInputQuery>;
export type LembreteProfissionalByInputLazyQueryHookResult = ReturnType<typeof useLembreteProfissionalByInputLazyQuery>;
export type LembreteProfissionalByInputSuspenseQueryHookResult = ReturnType<typeof useLembreteProfissionalByInputSuspenseQuery>;
export type LembreteProfissionalByInputQueryResult = Apollo.QueryResult<Types.LembreteProfissionalByInputQuery, Types.LembreteProfissionalByInputQueryVariables>;
export const MarcarVisualizadoLembreteProfissionalDocument = gql`
    mutation MarcarVisualizadoLembreteProfissional($id: ID!) {
  marcarVisualizadoLembreteProfissional(id: $id) {
    id
    visualizado
    dataExibirNovamente
    dataVisualizado
    identificadorLembrete
  }
}
    `;
export type MarcarVisualizadoLembreteProfissionalMutationFn = Apollo.MutationFunction<Types.MarcarVisualizadoLembreteProfissionalMutation, Types.MarcarVisualizadoLembreteProfissionalMutationVariables>;

/**
 * __useMarcarVisualizadoLembreteProfissionalMutation__
 *
 * To run a mutation, you first call `useMarcarVisualizadoLembreteProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarcarVisualizadoLembreteProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marcarVisualizadoLembreteProfissionalMutation, { data, loading, error }] = useMarcarVisualizadoLembreteProfissionalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarcarVisualizadoLembreteProfissionalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.MarcarVisualizadoLembreteProfissionalMutation, Types.MarcarVisualizadoLembreteProfissionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.MarcarVisualizadoLembreteProfissionalMutation, Types.MarcarVisualizadoLembreteProfissionalMutationVariables>(MarcarVisualizadoLembreteProfissionalDocument, options);
      }
export type MarcarVisualizadoLembreteProfissionalMutationHookResult = ReturnType<typeof useMarcarVisualizadoLembreteProfissionalMutation>;
export type MarcarVisualizadoLembreteProfissionalMutationResult = Apollo.MutationResult<Types.MarcarVisualizadoLembreteProfissionalMutation>;
export type MarcarVisualizadoLembreteProfissionalMutationOptions = Apollo.BaseMutationOptions<Types.MarcarVisualizadoLembreteProfissionalMutation, Types.MarcarVisualizadoLembreteProfissionalMutationVariables>;
export const ReagendarLembreteProfissionalDocument = gql`
    mutation ReagendarLembreteProfissional($input: ReagendarLembreteProfissionalInput!) {
  reagendarLembreteProfissional(input: $input) {
    id
    visualizado
    dataExibirNovamente
    dataVisualizado
    identificadorLembrete
  }
}
    `;
export type ReagendarLembreteProfissionalMutationFn = Apollo.MutationFunction<Types.ReagendarLembreteProfissionalMutation, Types.ReagendarLembreteProfissionalMutationVariables>;

/**
 * __useReagendarLembreteProfissionalMutation__
 *
 * To run a mutation, you first call `useReagendarLembreteProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReagendarLembreteProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reagendarLembreteProfissionalMutation, { data, loading, error }] = useReagendarLembreteProfissionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReagendarLembreteProfissionalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ReagendarLembreteProfissionalMutation, Types.ReagendarLembreteProfissionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ReagendarLembreteProfissionalMutation, Types.ReagendarLembreteProfissionalMutationVariables>(ReagendarLembreteProfissionalDocument, options);
      }
export type ReagendarLembreteProfissionalMutationHookResult = ReturnType<typeof useReagendarLembreteProfissionalMutation>;
export type ReagendarLembreteProfissionalMutationResult = Apollo.MutationResult<Types.ReagendarLembreteProfissionalMutation>;
export type ReagendarLembreteProfissionalMutationOptions = Apollo.BaseMutationOptions<Types.ReagendarLembreteProfissionalMutation, Types.ReagendarLembreteProfissionalMutationVariables>;
export const InscricoesTopicosNotificacaoDocument = gql`
    query InscricoesTopicosNotificacao($input: InscricoesTopicosNotificacaoQueryInput!) {
  inscricoesTopicosNotificacao(input: $input) {
    id
    tipoTopico
    codigoTopicoExterno
    statusNotificarLido
    statusNotificarVisto
    dataUltimaAtualizacao
  }
}
    `;

/**
 * __useInscricoesTopicosNotificacaoQuery__
 *
 * To run a query within a React component, call `useInscricoesTopicosNotificacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useInscricoesTopicosNotificacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInscricoesTopicosNotificacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInscricoesTopicosNotificacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables> & ({ variables: Types.InscricoesTopicosNotificacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>(InscricoesTopicosNotificacaoDocument, options);
      }
export function useInscricoesTopicosNotificacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>(InscricoesTopicosNotificacaoDocument, options);
        }
export function useInscricoesTopicosNotificacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>(InscricoesTopicosNotificacaoDocument, options);
        }
export type InscricoesTopicosNotificacaoQueryHookResult = ReturnType<typeof useInscricoesTopicosNotificacaoQuery>;
export type InscricoesTopicosNotificacaoLazyQueryHookResult = ReturnType<typeof useInscricoesTopicosNotificacaoLazyQuery>;
export type InscricoesTopicosNotificacaoSuspenseQueryHookResult = ReturnType<typeof useInscricoesTopicosNotificacaoSuspenseQuery>;
export type InscricoesTopicosNotificacaoQueryResult = Apollo.QueryResult<Types.InscricoesTopicosNotificacaoQuery, Types.InscricoesTopicosNotificacaoQueryVariables>;
export const DefinirModuloInicialDocument = gql`
    mutation DefinirModuloInicial($input: SelecionarModuloInicialInput!) {
  definirModuloInicial(input: $input) {
    id
    moduloInicial
  }
}
    `;
export type DefinirModuloInicialMutationFn = Apollo.MutationFunction<Types.DefinirModuloInicialMutation, Types.DefinirModuloInicialMutationVariables>;

/**
 * __useDefinirModuloInicialMutation__
 *
 * To run a mutation, you first call `useDefinirModuloInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefinirModuloInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [definirModuloInicialMutation, { data, loading, error }] = useDefinirModuloInicialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefinirModuloInicialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DefinirModuloInicialMutation, Types.DefinirModuloInicialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DefinirModuloInicialMutation, Types.DefinirModuloInicialMutationVariables>(DefinirModuloInicialDocument, options);
      }
export type DefinirModuloInicialMutationHookResult = ReturnType<typeof useDefinirModuloInicialMutation>;
export type DefinirModuloInicialMutationResult = Apollo.MutationResult<Types.DefinirModuloInicialMutation>;
export type DefinirModuloInicialMutationOptions = Apollo.BaseMutationOptions<Types.DefinirModuloInicialMutation, Types.DefinirModuloInicialMutationVariables>;
export const AcompanhamentoCidadaosVinculadosDocument = gql`
    query AcompanhamentoCidadaosVinculados($input: AcompanhamentoCidadaosVinculadosFilterInput!) {
  acompanhamentoCidadaosVinculados(input: $input) {
    content {
      id
      nomeCidadao
      dataNascimentoCidadao
      sexoIdentidadeGeneroCidadao
      cpfCidadao
      cnsCidadao
      telefoneCelular
      telefoneContato
      dataUltimaAtualizacaoCidadao
      telefoneResidencial
      idade
      endereco
      equipe
      microarea
      origem
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoCidadaosVinculadosQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoCidadaosVinculadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoCidadaosVinculadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoCidadaosVinculadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoCidadaosVinculadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables> & ({ variables: Types.AcompanhamentoCidadaosVinculadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>(AcompanhamentoCidadaosVinculadosDocument, options);
      }
export function useAcompanhamentoCidadaosVinculadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>(AcompanhamentoCidadaosVinculadosDocument, options);
        }
export function useAcompanhamentoCidadaosVinculadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>(AcompanhamentoCidadaosVinculadosDocument, options);
        }
export type AcompanhamentoCidadaosVinculadosQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosQuery>;
export type AcompanhamentoCidadaosVinculadosLazyQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosLazyQuery>;
export type AcompanhamentoCidadaosVinculadosSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosSuspenseQuery>;
export type AcompanhamentoCidadaosVinculadosQueryResult = Apollo.QueryResult<Types.AcompanhamentoCidadaosVinculadosQuery, Types.AcompanhamentoCidadaosVinculadosQueryVariables>;
export const AcompanhamentoCidadaosVinculadosProcessamentoDocument = gql`
    query AcompanhamentoCidadaosVinculadosProcessamento {
  processamentoStatus
}
    `;

/**
 * __useAcompanhamentoCidadaosVinculadosProcessamentoQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoCidadaosVinculadosProcessamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoCidadaosVinculadosProcessamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoCidadaosVinculadosProcessamentoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcompanhamentoCidadaosVinculadosProcessamentoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>(AcompanhamentoCidadaosVinculadosProcessamentoDocument, options);
      }
export function useAcompanhamentoCidadaosVinculadosProcessamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>(AcompanhamentoCidadaosVinculadosProcessamentoDocument, options);
        }
export function useAcompanhamentoCidadaosVinculadosProcessamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>(AcompanhamentoCidadaosVinculadosProcessamentoDocument, options);
        }
export type AcompanhamentoCidadaosVinculadosProcessamentoQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosProcessamentoQuery>;
export type AcompanhamentoCidadaosVinculadosProcessamentoLazyQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosProcessamentoLazyQuery>;
export type AcompanhamentoCidadaosVinculadosProcessamentoSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVinculadosProcessamentoSuspenseQuery>;
export type AcompanhamentoCidadaosVinculadosProcessamentoQueryResult = Apollo.QueryResult<Types.AcompanhamentoCidadaosVinculadosProcessamentoQuery, Types.AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables>;
export const AuditCancelarBuscaCidadaoListagemDocument = gql`
    mutation AuditCancelarBuscaCidadaoListagem($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  auditCancelarAcompanhamentoCondicaoSaude(input: $input)
}
    `;
export type AuditCancelarBuscaCidadaoListagemMutationFn = Apollo.MutationFunction<Types.AuditCancelarBuscaCidadaoListagemMutation, Types.AuditCancelarBuscaCidadaoListagemMutationVariables>;

/**
 * __useAuditCancelarBuscaCidadaoListagemMutation__
 *
 * To run a mutation, you first call `useAuditCancelarBuscaCidadaoListagemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditCancelarBuscaCidadaoListagemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditCancelarBuscaCidadaoListagemMutation, { data, loading, error }] = useAuditCancelarBuscaCidadaoListagemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditCancelarBuscaCidadaoListagemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AuditCancelarBuscaCidadaoListagemMutation, Types.AuditCancelarBuscaCidadaoListagemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AuditCancelarBuscaCidadaoListagemMutation, Types.AuditCancelarBuscaCidadaoListagemMutationVariables>(AuditCancelarBuscaCidadaoListagemDocument, options);
      }
export type AuditCancelarBuscaCidadaoListagemMutationHookResult = ReturnType<typeof useAuditCancelarBuscaCidadaoListagemMutation>;
export type AuditCancelarBuscaCidadaoListagemMutationResult = Apollo.MutationResult<Types.AuditCancelarBuscaCidadaoListagemMutation>;
export type AuditCancelarBuscaCidadaoListagemMutationOptions = Apollo.BaseMutationOptions<Types.AuditCancelarBuscaCidadaoListagemMutation, Types.AuditCancelarBuscaCidadaoListagemMutationVariables>;
export const BuscaCidadaoListagemDesenvolvimentoInfantilDocument = gql`
    query BuscaCidadaoListagemDesenvolvimentoInfantil($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimaVisitaDomiciliar
      dataUltimoAtendimentoOdontologico
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      desenvolvimentoInfantil {
        qtdMedicoesPesoAltura
        visitasDomiciliares {
          dataPrimeiraVisita
          dataSegundaVisita
          qtdVisitasDomiciliares
        }
        consultas {
          qtdConsultas
          dataPrimeiraConsulta
        }
        vacinas {
          ...VacinacaoGrupoConsolidado
        }
        suplementacaoVitaminaA {
          dataUltimaSuplementacao
          dosesDe6a11Meses
          dosesDe12a23Meses
          dosesDe24a59Meses
        }
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${VacinacaoGrupoConsolidadoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemDesenvolvimentoInfantilQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemDesenvolvimentoInfantilQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemDesenvolvimentoInfantilQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemDesenvolvimentoInfantilQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemDesenvolvimentoInfantilQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables> & ({ variables: Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>(BuscaCidadaoListagemDesenvolvimentoInfantilDocument, options);
      }
export function useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>(BuscaCidadaoListagemDesenvolvimentoInfantilDocument, options);
        }
export function useBuscaCidadaoListagemDesenvolvimentoInfantilSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>(BuscaCidadaoListagemDesenvolvimentoInfantilDocument, options);
        }
export type BuscaCidadaoListagemDesenvolvimentoInfantilQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDesenvolvimentoInfantilQuery>;
export type BuscaCidadaoListagemDesenvolvimentoInfantilLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery>;
export type BuscaCidadaoListagemDesenvolvimentoInfantilSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDesenvolvimentoInfantilSuspenseQuery>;
export type BuscaCidadaoListagemDesenvolvimentoInfantilQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemDesenvolvimentoInfantilQuery, Types.BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables>;
export const BuscaCidadaoListagemDiabetesDocument = gql`
    query BuscaCidadaoListagemDiabetes($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      ultimaMedicaoPressaoArterial
      dataUltimaMedicaoPressaoArterial
      cidadao {
        id
        prontuario {
          ...BuscaCidadaoListagemProblemas
        }
      }
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      diabetes {
        visitasDomiciliaresReportDto {
          dataUltimasVisitasDomiciliares
          qtdVisitasDomiciliares
        }
        dataUltimaConsulta
        qtdConsultas
        valorExameHemoglobinaGlicada
        dataExameHemoglobinaGlicada
        dataSolicitacaoHemoglobinaGlicada
        dataAvaliacaoPes
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${BuscaCidadaoListagemProblemasFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemDiabetesQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemDiabetesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemDiabetesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemDiabetesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemDiabetesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables> & ({ variables: Types.BuscaCidadaoListagemDiabetesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>(BuscaCidadaoListagemDiabetesDocument, options);
      }
export function useBuscaCidadaoListagemDiabetesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>(BuscaCidadaoListagemDiabetesDocument, options);
        }
export function useBuscaCidadaoListagemDiabetesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>(BuscaCidadaoListagemDiabetesDocument, options);
        }
export type BuscaCidadaoListagemDiabetesQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDiabetesQuery>;
export type BuscaCidadaoListagemDiabetesLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDiabetesLazyQuery>;
export type BuscaCidadaoListagemDiabetesSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemDiabetesSuspenseQuery>;
export type BuscaCidadaoListagemDiabetesQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemDiabetesQuery, Types.BuscaCidadaoListagemDiabetesQueryVariables>;
export const BuscaCidadaoListagemGeralDocument = gql`
    query BuscaCidadaoListagemGeral($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemGeralQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemGeralQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemGeralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemGeralQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemGeralQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables> & ({ variables: Types.BuscaCidadaoListagemGeralQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>(BuscaCidadaoListagemGeralDocument, options);
      }
export function useBuscaCidadaoListagemGeralLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>(BuscaCidadaoListagemGeralDocument, options);
        }
export function useBuscaCidadaoListagemGeralSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>(BuscaCidadaoListagemGeralDocument, options);
        }
export type BuscaCidadaoListagemGeralQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGeralQuery>;
export type BuscaCidadaoListagemGeralLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGeralLazyQuery>;
export type BuscaCidadaoListagemGeralSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGeralSuspenseQuery>;
export type BuscaCidadaoListagemGeralQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemGeralQuery, Types.BuscaCidadaoListagemGeralQueryVariables>;
export const BuscaCidadaoListagemGestantePuerperaDocument = gql`
    query BuscaCidadaoListagemGestantePuerpera($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      preNatalPuerperio {
        altoRiscoGestacional
        idadeGestacionalEcograficaEmDias
        idadeGestacionalCronologicaEmDias
        ultimaDum
        dppCronologica
        dppEcografica
        fonteIdadeGestacional
        medicoesPreNatal {
          qtdMedicoesPressaoArterial
          qtdMedicoesPesoAltura
          qtdMedicoesAlturaUterina
        }
        atendimentosPreNatalPuerperio {
          consultasPrimeirasDozeSemanas
          consultasPreNatalGestacao
          consultasOdontologicasGestacao
          consultasPuerperio
          dataUltimaConsultaPreNatal
          dataUltimaConsultaPuerperio
        }
        examesRealizadosPreNatal {
          sifilisPrimeiroTrimestre
          sifilisTerceiroTrimestre
          hivPrimeiroTrimestre
          hivTerceiroTrimestre
          hepatiteBPrimeiroTrimestre
          hepatiteCPrimeiroTrimestre
        }
        visitasDomiciliares {
          visitasDomiciliaresPreNatal
          visitasDomiciliaresPuerperio
        }
        vacinas {
          ...VacinacaoGrupoConsolidado
        }
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${VacinacaoGrupoConsolidadoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemGestantePuerperaQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemGestantePuerperaQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemGestantePuerperaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemGestantePuerperaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemGestantePuerperaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables> & ({ variables: Types.BuscaCidadaoListagemGestantePuerperaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>(BuscaCidadaoListagemGestantePuerperaDocument, options);
      }
export function useBuscaCidadaoListagemGestantePuerperaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>(BuscaCidadaoListagemGestantePuerperaDocument, options);
        }
export function useBuscaCidadaoListagemGestantePuerperaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>(BuscaCidadaoListagemGestantePuerperaDocument, options);
        }
export type BuscaCidadaoListagemGestantePuerperaQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGestantePuerperaQuery>;
export type BuscaCidadaoListagemGestantePuerperaLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGestantePuerperaLazyQuery>;
export type BuscaCidadaoListagemGestantePuerperaSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemGestantePuerperaSuspenseQuery>;
export type BuscaCidadaoListagemGestantePuerperaQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemGestantePuerperaQuery, Types.BuscaCidadaoListagemGestantePuerperaQueryVariables>;
export const BuscaCidadaoListagemHipertensaoDocument = gql`
    query BuscaCidadaoListagemHipertensao($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      ultimaMedicaoPressaoArterial
      dataUltimaMedicaoPressaoArterial
      cidadao {
        id
        prontuario {
          ...BuscaCidadaoListagemProblemas
        }
      }
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      hipertensao {
        visitasDomiciliaresReportDto {
          dataUltimasVisitasDomiciliares
          qtdVisitasDomiciliares
        }
        qtdMedicoesPressaoArterial
        qtdConsultas
        dataUltimaConsulta
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${BuscaCidadaoListagemProblemasFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemHipertensaoQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemHipertensaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemHipertensaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemHipertensaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemHipertensaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables> & ({ variables: Types.BuscaCidadaoListagemHipertensaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>(BuscaCidadaoListagemHipertensaoDocument, options);
      }
export function useBuscaCidadaoListagemHipertensaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>(BuscaCidadaoListagemHipertensaoDocument, options);
        }
export function useBuscaCidadaoListagemHipertensaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>(BuscaCidadaoListagemHipertensaoDocument, options);
        }
export type BuscaCidadaoListagemHipertensaoQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemHipertensaoQuery>;
export type BuscaCidadaoListagemHipertensaoLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemHipertensaoLazyQuery>;
export type BuscaCidadaoListagemHipertensaoSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemHipertensaoSuspenseQuery>;
export type BuscaCidadaoListagemHipertensaoQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemHipertensaoQuery, Types.BuscaCidadaoListagemHipertensaoQueryVariables>;
export const BuscaCidadaoListagemPessoaIdosaDocument = gql`
    query BuscaCidadaoListagemPessoaIdosa($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ivcf {
        riscoVulnerabilidade
        dataResultado
        pontuacao
        subgrupo
      }
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      cidadao {
        id
        identidadeGeneroDbEnum
      }
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      pessoaIdosa {
        visitasDomiciliaresReportDto {
          dataUltimasVisitasDomiciliares
          qtdVisitasDomiciliares
        }
        quantidadeMedicoesSimultaneasPesoAltura
        vacinas {
          ...VacinacaoGrupoConsolidado
        }
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${VacinacaoGrupoConsolidadoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemPessoaIdosaQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemPessoaIdosaQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemPessoaIdosaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemPessoaIdosaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemPessoaIdosaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables> & ({ variables: Types.BuscaCidadaoListagemPessoaIdosaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>(BuscaCidadaoListagemPessoaIdosaDocument, options);
      }
export function useBuscaCidadaoListagemPessoaIdosaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>(BuscaCidadaoListagemPessoaIdosaDocument, options);
        }
export function useBuscaCidadaoListagemPessoaIdosaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>(BuscaCidadaoListagemPessoaIdosaDocument, options);
        }
export type BuscaCidadaoListagemPessoaIdosaQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemPessoaIdosaQuery>;
export type BuscaCidadaoListagemPessoaIdosaLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemPessoaIdosaLazyQuery>;
export type BuscaCidadaoListagemPessoaIdosaSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemPessoaIdosaSuspenseQuery>;
export type BuscaCidadaoListagemPessoaIdosaQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemPessoaIdosaQuery, Types.BuscaCidadaoListagemPessoaIdosaQueryVariables>;
export const BuscaCidadaoListagemSaudeBucalDocument = gql`
    query BuscaCidadaoListagemSaudeBucal($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimoAtendimentoOdontologico
      dataUltimaVisitaDomiciliar
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      cidadao {
        id
        identidadeGeneroDbEnum
      }
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      saudeBucal {
        ultimoAtendimentoPrimeiraConsultaProgramada
        ultimoAtendimentoTratamentoConcluido
        escovacaoSupervisionadaEmAc
        ultimoTratamentoRestauradorAtraumatico
        procedimentoPreventivos
        exodontiasDentesRealizadas
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemSaudeBucalQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemSaudeBucalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemSaudeBucalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemSaudeBucalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemSaudeBucalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables> & ({ variables: Types.BuscaCidadaoListagemSaudeBucalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>(BuscaCidadaoListagemSaudeBucalDocument, options);
      }
export function useBuscaCidadaoListagemSaudeBucalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>(BuscaCidadaoListagemSaudeBucalDocument, options);
        }
export function useBuscaCidadaoListagemSaudeBucalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>(BuscaCidadaoListagemSaudeBucalDocument, options);
        }
export type BuscaCidadaoListagemSaudeBucalQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemSaudeBucalQuery>;
export type BuscaCidadaoListagemSaudeBucalLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemSaudeBucalLazyQuery>;
export type BuscaCidadaoListagemSaudeBucalSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemSaudeBucalSuspenseQuery>;
export type BuscaCidadaoListagemSaudeBucalQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemSaudeBucalQuery, Types.BuscaCidadaoListagemSaudeBucalQueryVariables>;
export const BuscaCidadaoListagemTematicaSaudeMulherDocument = gql`
    query BuscaCidadaoListagemTematicaSaudeMulher($input: AcompanhamentoCondicaoSaudeQueryInput!) {
  acompanhamentoCondicaoSaude(input: $input) {
    content {
      cidadaoId
      dataNascimentoCidadao
      nomeCidadao
      nomeSocialCidadao
      cpfCidadao
      cnsCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      microarea
      ultimaMedicaoPressaoArterial
      dataUltimoAtendimentoMedico
      dataUltimoAtendimentoEnfermagem
      dataUltimaVisitaDomiciliar
      dataUltimoAtendimentoOdontologico
      ultimaMedicaoPeso
      ultimaMedicaoAltura
      dataUltimaMedicaoPeso
      dataUltimaMedicaoAltura
      dataUltimaMedicaoPressaoArterial
      sexoCidadao
      identidadeGeneroCidadao
      racaCorCidadao
      bolsaFamilia {
        id
        isBeneficiario
        vigencia
      }
      saudeMulher {
        hiv
        sifilis
        hepatiteB
        hepatiteC
        ultimaConsulta
        ultimaAvaliacaoCancerMama
        ultimaSolicitacaoCancerMama
        ultimaAvaliacaoCancerColoUtero
        ultimaAvaliacaoCancerColoUteroNome
        ultimaSolicitacaoCancerColoUtero
        ultimaSolicitacaoCancerColoUteroNome
        vacinas {
          ...VacinacaoGrupoConsolidado
        }
      }
    }
    cidsConsiderados
    ciapsConsiderados
    pageInfo {
      ...PageInfo
    }
  }
}
    ${VacinacaoGrupoConsolidadoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaCidadaoListagemTematicaSaudeMulherQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemTematicaSaudeMulherQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemTematicaSaudeMulherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemTematicaSaudeMulherQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemTematicaSaudeMulherQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables> & ({ variables: Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>(BuscaCidadaoListagemTematicaSaudeMulherDocument, options);
      }
export function useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>(BuscaCidadaoListagemTematicaSaudeMulherDocument, options);
        }
export function useBuscaCidadaoListagemTematicaSaudeMulherSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>(BuscaCidadaoListagemTematicaSaudeMulherDocument, options);
        }
export type BuscaCidadaoListagemTematicaSaudeMulherQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemTematicaSaudeMulherQuery>;
export type BuscaCidadaoListagemTematicaSaudeMulherLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery>;
export type BuscaCidadaoListagemTematicaSaudeMulherSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemTematicaSaudeMulherSuspenseQuery>;
export type BuscaCidadaoListagemTematicaSaudeMulherQueryResult = Apollo.QueryResult<Types.BuscaCidadaoListagemTematicaSaudeMulherQuery, Types.BuscaCidadaoListagemTematicaSaudeMulherQueryVariables>;
export const SalvarApoioEmapEmadDocument = gql`
    mutation SalvarApoioEmapEmad($input: ConfigAtendimentoDomInput!) {
  salvarConfigAtendimentoDomTipoApoio(input: $input) {
    id
  }
}
    `;
export type SalvarApoioEmapEmadMutationFn = Apollo.MutationFunction<Types.SalvarApoioEmapEmadMutation, Types.SalvarApoioEmapEmadMutationVariables>;

/**
 * __useSalvarApoioEmapEmadMutation__
 *
 * To run a mutation, you first call `useSalvarApoioEmapEmadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarApoioEmapEmadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarApoioEmapEmadMutation, { data, loading, error }] = useSalvarApoioEmapEmadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarApoioEmapEmadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarApoioEmapEmadMutation, Types.SalvarApoioEmapEmadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarApoioEmapEmadMutation, Types.SalvarApoioEmapEmadMutationVariables>(SalvarApoioEmapEmadDocument, options);
      }
export type SalvarApoioEmapEmadMutationHookResult = ReturnType<typeof useSalvarApoioEmapEmadMutation>;
export type SalvarApoioEmapEmadMutationResult = Apollo.MutationResult<Types.SalvarApoioEmapEmadMutation>;
export type SalvarApoioEmapEmadMutationOptions = Apollo.BaseMutationOptions<Types.SalvarApoioEmapEmadMutation, Types.SalvarApoioEmapEmadMutationVariables>;
export const SalvarPodeAtenderEmadDocument = gql`
    mutation SalvarPodeAtenderEmad($input: ConfigAtendimentoDomInput!) {
  salvarConfigAtendimentoDomTipoPodeAtender(input: $input) {
    id
  }
}
    `;
export type SalvarPodeAtenderEmadMutationFn = Apollo.MutationFunction<Types.SalvarPodeAtenderEmadMutation, Types.SalvarPodeAtenderEmadMutationVariables>;

/**
 * __useSalvarPodeAtenderEmadMutation__
 *
 * To run a mutation, you first call `useSalvarPodeAtenderEmadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarPodeAtenderEmadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarPodeAtenderEmadMutation, { data, loading, error }] = useSalvarPodeAtenderEmadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarPodeAtenderEmadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarPodeAtenderEmadMutation, Types.SalvarPodeAtenderEmadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarPodeAtenderEmadMutation, Types.SalvarPodeAtenderEmadMutationVariables>(SalvarPodeAtenderEmadDocument, options);
      }
export type SalvarPodeAtenderEmadMutationHookResult = ReturnType<typeof useSalvarPodeAtenderEmadMutation>;
export type SalvarPodeAtenderEmadMutationResult = Apollo.MutationResult<Types.SalvarPodeAtenderEmadMutation>;
export type SalvarPodeAtenderEmadMutationOptions = Apollo.BaseMutationOptions<Types.SalvarPodeAtenderEmadMutation, Types.SalvarPodeAtenderEmadMutationVariables>;
export const ConfiguracoesAtencaoDomDocument = gql`
    query ConfiguracoesAtencaoDom($input: ConfiguracoesAtendimentosDomInput) {
  configuracoesAtencaoDom {
    duracao
    emadsAtendemEmads(input: $input) {
      content {
        id
        identificadorNacionalEquipePai {
          id
          nome
          ine
        }
        identificadorNacionalEquipeFilho {
          id
          nome
          ine
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
    emapsApoiamEmads(input: $input) {
      content {
        id
        identificadorNacionalEquipePai {
          id
          nome
          ine
        }
        identificadorNacionalEquipeFilho {
          id
          nome
          ine
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useConfiguracoesAtencaoDomQuery__
 *
 * To run a query within a React component, call `useConfiguracoesAtencaoDomQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracoesAtencaoDomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracoesAtencaoDomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfiguracoesAtencaoDomQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>(ConfiguracoesAtencaoDomDocument, options);
      }
export function useConfiguracoesAtencaoDomLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>(ConfiguracoesAtencaoDomDocument, options);
        }
export function useConfiguracoesAtencaoDomSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>(ConfiguracoesAtencaoDomDocument, options);
        }
export type ConfiguracoesAtencaoDomQueryHookResult = ReturnType<typeof useConfiguracoesAtencaoDomQuery>;
export type ConfiguracoesAtencaoDomLazyQueryHookResult = ReturnType<typeof useConfiguracoesAtencaoDomLazyQuery>;
export type ConfiguracoesAtencaoDomSuspenseQueryHookResult = ReturnType<typeof useConfiguracoesAtencaoDomSuspenseQuery>;
export type ConfiguracoesAtencaoDomQueryResult = Apollo.QueryResult<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>;
export const EquipesAtencaoDomDocument = gql`
    query EquipesAtencaoDom($input: EquipeADInput) {
  equipesAtencaoDom(input: $input) {
    content {
      id
      nome
      ine
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipesAtencaoDomQuery__
 *
 * To run a query within a React component, call `useEquipesAtencaoDomQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipesAtencaoDomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipesAtencaoDomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipesAtencaoDomQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>(EquipesAtencaoDomDocument, options);
      }
export function useEquipesAtencaoDomLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>(EquipesAtencaoDomDocument, options);
        }
export function useEquipesAtencaoDomSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>(EquipesAtencaoDomDocument, options);
        }
export type EquipesAtencaoDomQueryHookResult = ReturnType<typeof useEquipesAtencaoDomQuery>;
export type EquipesAtencaoDomLazyQueryHookResult = ReturnType<typeof useEquipesAtencaoDomLazyQuery>;
export type EquipesAtencaoDomSuspenseQueryHookResult = ReturnType<typeof useEquipesAtencaoDomSuspenseQuery>;
export type EquipesAtencaoDomQueryResult = Apollo.QueryResult<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>;
export const ExcluirConfigAtendimentoDomDocument = gql`
    mutation ExcluirConfigAtendimentoDom($idConfig: ID!) {
  excluirConfigAtendimentoDom(idConfig: $idConfig)
}
    `;
export type ExcluirConfigAtendimentoDomMutationFn = Apollo.MutationFunction<Types.ExcluirConfigAtendimentoDomMutation, Types.ExcluirConfigAtendimentoDomMutationVariables>;

/**
 * __useExcluirConfigAtendimentoDomMutation__
 *
 * To run a mutation, you first call `useExcluirConfigAtendimentoDomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfigAtendimentoDomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfigAtendimentoDomMutation, { data, loading, error }] = useExcluirConfigAtendimentoDomMutation({
 *   variables: {
 *      idConfig: // value for 'idConfig'
 *   },
 * });
 */
export function useExcluirConfigAtendimentoDomMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirConfigAtendimentoDomMutation, Types.ExcluirConfigAtendimentoDomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirConfigAtendimentoDomMutation, Types.ExcluirConfigAtendimentoDomMutationVariables>(ExcluirConfigAtendimentoDomDocument, options);
      }
export type ExcluirConfigAtendimentoDomMutationHookResult = ReturnType<typeof useExcluirConfigAtendimentoDomMutation>;
export type ExcluirConfigAtendimentoDomMutationResult = Apollo.MutationResult<Types.ExcluirConfigAtendimentoDomMutation>;
export type ExcluirConfigAtendimentoDomMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirConfigAtendimentoDomMutation, Types.ExcluirConfigAtendimentoDomMutationVariables>;
export const SalvarDuracaoAgendamentoAdDocument = gql`
    mutation SalvarDuracaoAgendamentoAD($input: DuracaoAgendamentoAtencaoDomInput!) {
  salvarDuracaoAgendamentoAtencaoDom(input: $input) {
    duracaoAgendamento
  }
}
    `;
export type SalvarDuracaoAgendamentoAdMutationFn = Apollo.MutationFunction<Types.SalvarDuracaoAgendamentoAdMutation, Types.SalvarDuracaoAgendamentoAdMutationVariables>;

/**
 * __useSalvarDuracaoAgendamentoAdMutation__
 *
 * To run a mutation, you first call `useSalvarDuracaoAgendamentoAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarDuracaoAgendamentoAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarDuracaoAgendamentoAdMutation, { data, loading, error }] = useSalvarDuracaoAgendamentoAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarDuracaoAgendamentoAdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarDuracaoAgendamentoAdMutation, Types.SalvarDuracaoAgendamentoAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarDuracaoAgendamentoAdMutation, Types.SalvarDuracaoAgendamentoAdMutationVariables>(SalvarDuracaoAgendamentoAdDocument, options);
      }
export type SalvarDuracaoAgendamentoAdMutationHookResult = ReturnType<typeof useSalvarDuracaoAgendamentoAdMutation>;
export type SalvarDuracaoAgendamentoAdMutationResult = Apollo.MutationResult<Types.SalvarDuracaoAgendamentoAdMutation>;
export type SalvarDuracaoAgendamentoAdMutationOptions = Apollo.BaseMutationOptions<Types.SalvarDuracaoAgendamentoAdMutation, Types.SalvarDuracaoAgendamentoAdMutationVariables>;
export const CidadaoAdLoadDocument = gql`
    query CidadaoADLoad($input: ID!) {
  cidadaoAD(input: $input) {
    id
    cidadao {
      id
      nome
      dataNascimento
      nomeMae
      nomeSocial
      nomeResponsavel
      dtNascimentoResponsavel
      cpfCnsResponsavel
      naoPossuiCuidador
      cpfCnsCuidador
      nomeCuidador
      dtNascimentoCuidador
      tipoCuidador
      sexo
      identidadeGeneroDbEnum
      dataObito
    }
    cidadaoAdEmObito {
      id
      cidadao {
        id
        nome
        nomeSocial
        dataNascimento
        dataObito
      }
    }
    cidadaosAdEmPosObito {
      id
      cidadao {
        id
        nome
        nomeSocial
        cpf
        cns
      }
    }
    modalidade
    procedencia
    procedenciaEspecificacao
    cid10Principal {
      id
      nome
      codigo
    }
    cid10Secundario1 {
      id
      nome
      codigo
    }
    cid10Secundario2 {
      id
      nome
      codigo
    }
    condutaDesfecho
    dataAdmissao
    dataSaida
    dataObito
    dataAgendado
    dataUltimaVisita
    numeroDocumentoObito
    actions {
      permissaoEditarAD {
        enabled
        hint
      }
    }
  }
}
    `;

/**
 * __useCidadaoAdLoadQuery__
 *
 * To run a query within a React component, call `useCidadaoAdLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAdLoadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdLoadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables> & ({ variables: Types.CidadaoAdLoadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>(CidadaoAdLoadDocument, options);
      }
export function useCidadaoAdLoadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>(CidadaoAdLoadDocument, options);
        }
export function useCidadaoAdLoadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>(CidadaoAdLoadDocument, options);
        }
export type CidadaoAdLoadQueryHookResult = ReturnType<typeof useCidadaoAdLoadQuery>;
export type CidadaoAdLoadLazyQueryHookResult = ReturnType<typeof useCidadaoAdLoadLazyQuery>;
export type CidadaoAdLoadSuspenseQueryHookResult = ReturnType<typeof useCidadaoAdLoadSuspenseQuery>;
export type CidadaoAdLoadQueryResult = Apollo.QueryResult<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>;
export const CidadaoAdSaveDocument = gql`
    mutation CidadaoADSave($input: AtencaoDomiciliarCidadaoInput!) {
  salvarCidadaoAtencaoDomiciliar(input: $input) {
    id
  }
}
    `;
export type CidadaoAdSaveMutationFn = Apollo.MutationFunction<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>;

/**
 * __useCidadaoAdSaveMutation__
 *
 * To run a mutation, you first call `useCidadaoAdSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cidadaoAdSaveMutation, { data, loading, error }] = useCidadaoAdSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>(CidadaoAdSaveDocument, options);
      }
export type CidadaoAdSaveMutationHookResult = ReturnType<typeof useCidadaoAdSaveMutation>;
export type CidadaoAdSaveMutationResult = Apollo.MutationResult<Types.CidadaoAdSaveMutation>;
export type CidadaoAdSaveMutationOptions = Apollo.BaseMutationOptions<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>;
export const EquipeCidadaoAdListaDocument = gql`
    query EquipeCidadaoADLista($input: CidadaosAdQueryInput!) {
  cidadaosAD(input: $input) {
    content {
      id
      cidadao {
        id
      }
      equipe {
        id
        nome
        ine
      }
    }
  }
}
    `;

/**
 * __useEquipeCidadaoAdListaQuery__
 *
 * To run a query within a React component, call `useEquipeCidadaoAdListaQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeCidadaoAdListaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeCidadaoAdListaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeCidadaoAdListaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables> & ({ variables: Types.EquipeCidadaoAdListaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>(EquipeCidadaoAdListaDocument, options);
      }
export function useEquipeCidadaoAdListaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>(EquipeCidadaoAdListaDocument, options);
        }
export function useEquipeCidadaoAdListaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>(EquipeCidadaoAdListaDocument, options);
        }
export type EquipeCidadaoAdListaQueryHookResult = ReturnType<typeof useEquipeCidadaoAdListaQuery>;
export type EquipeCidadaoAdListaLazyQueryHookResult = ReturnType<typeof useEquipeCidadaoAdListaLazyQuery>;
export type EquipeCidadaoAdListaSuspenseQueryHookResult = ReturnType<typeof useEquipeCidadaoAdListaSuspenseQuery>;
export type EquipeCidadaoAdListaQueryResult = Apollo.QueryResult<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>;
export const CidadaoAdExcluirDocument = gql`
    mutation CidadaoADExcluir($id: ID!) {
  excluirCidadaoAtendimentoDomiciliar(id: $id)
}
    `;
export type CidadaoAdExcluirMutationFn = Apollo.MutationFunction<Types.CidadaoAdExcluirMutation, Types.CidadaoAdExcluirMutationVariables>;

/**
 * __useCidadaoAdExcluirMutation__
 *
 * To run a mutation, you first call `useCidadaoAdExcluirMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdExcluirMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cidadaoAdExcluirMutation, { data, loading, error }] = useCidadaoAdExcluirMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoAdExcluirMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CidadaoAdExcluirMutation, Types.CidadaoAdExcluirMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CidadaoAdExcluirMutation, Types.CidadaoAdExcluirMutationVariables>(CidadaoAdExcluirDocument, options);
      }
export type CidadaoAdExcluirMutationHookResult = ReturnType<typeof useCidadaoAdExcluirMutation>;
export type CidadaoAdExcluirMutationResult = Apollo.MutationResult<Types.CidadaoAdExcluirMutation>;
export type CidadaoAdExcluirMutationOptions = Apollo.BaseMutationOptions<Types.CidadaoAdExcluirMutation, Types.CidadaoAdExcluirMutationVariables>;
export const ListaAdTableDocument = gql`
    query ListaADTable($input: CidadaosAdQueryInput!) {
  cidadaosAD(input: $input) {
    content {
      id
      cidadao {
        id
        nome
        cpf
        cns
        nomeSocial
        prontuario {
          id
        }
      }
      equipe {
        id
        nome
      }
      modalidade
      condutaDesfecho
      dataAgendado
      dataUltimaVisita
      actions {
        permissaoEditarAD {
          enabled
          hint
        }
        adEncerrado {
          enabled
          hint
        }
        permissaoExcluirAD {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useListaAdTableQuery__
 *
 * To run a query within a React component, call `useListaAdTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaAdTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaAdTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaAdTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables> & ({ variables: Types.ListaAdTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>(ListaAdTableDocument, options);
      }
export function useListaAdTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>(ListaAdTableDocument, options);
        }
export function useListaAdTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>(ListaAdTableDocument, options);
        }
export type ListaAdTableQueryHookResult = ReturnType<typeof useListaAdTableQuery>;
export type ListaAdTableLazyQueryHookResult = ReturnType<typeof useListaAdTableLazyQuery>;
export type ListaAdTableSuspenseQueryHookResult = ReturnType<typeof useListaAdTableSuspenseQuery>;
export type ListaAdTableQueryResult = Apollo.QueryResult<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>;
export const CidadaoAdSelectFieldDocument = gql`
    query CidadaoADSelectField($input: CidadaosAdQueryInput!) {
  cidadaosAD(input: $input) {
    content {
      id
      cidadao {
        id
        nome
        cpf
        cns
        nomeSocial
        dataNascimento
        nomeMae
        dataObito
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCidadaoAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables> & ({ variables: Types.CidadaoAdSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>(CidadaoAdSelectFieldDocument, options);
      }
export function useCidadaoAdSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>(CidadaoAdSelectFieldDocument, options);
        }
export function useCidadaoAdSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>(CidadaoAdSelectFieldDocument, options);
        }
export type CidadaoAdSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAdSelectFieldQuery>;
export type CidadaoAdSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAdSelectFieldLazyQuery>;
export type CidadaoAdSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoAdSelectFieldSuspenseQuery>;
export type CidadaoAdSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>;
export const CidadaoListaAdDocument = gql`
    query CidadaoListaAD($id: ID!) {
  cidadao(id: $id) {
    id
    nome
    nomeSocial
    cpf
    cns
    nomeMae
    dataNascimento
    sexo
    identidadeGeneroDbEnum
  }
}
    `;

/**
 * __useCidadaoListaAdQuery__
 *
 * To run a query within a React component, call `useCidadaoListaAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListaAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListaAdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoListaAdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables> & ({ variables: Types.CidadaoListaAdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>(CidadaoListaAdDocument, options);
      }
export function useCidadaoListaAdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>(CidadaoListaAdDocument, options);
        }
export function useCidadaoListaAdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>(CidadaoListaAdDocument, options);
        }
export type CidadaoListaAdQueryHookResult = ReturnType<typeof useCidadaoListaAdQuery>;
export type CidadaoListaAdLazyQueryHookResult = ReturnType<typeof useCidadaoListaAdLazyQuery>;
export type CidadaoListaAdSuspenseQueryHookResult = ReturnType<typeof useCidadaoListaAdSuspenseQuery>;
export type CidadaoListaAdQueryResult = Apollo.QueryResult<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>;
export const CidadaoListaAdSelectFieldDocument = gql`
    query CidadaoListaADSelectField($input: CidadaosComboQueryInput!, $emAtencaoDomiciliar: Boolean!) {
  cidadaosCombo(input: $input, atencaoDomiciliar: $emAtencaoDomiciliar) {
    id
    nome
    nomeSocial
    cpf
    cns
    nomeMae
    dataNascimento
    sexo
    identidadeGeneroDbEnum
    equipeAtendimentoAd {
      id
      nome
      ine
    }
  }
}
    `;

/**
 * __useCidadaoListaAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoListaAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListaAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListaAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *      emAtencaoDomiciliar: // value for 'emAtencaoDomiciliar'
 *   },
 * });
 */
export function useCidadaoListaAdSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables> & ({ variables: Types.CidadaoListaAdSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>(CidadaoListaAdSelectFieldDocument, options);
      }
export function useCidadaoListaAdSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>(CidadaoListaAdSelectFieldDocument, options);
        }
export function useCidadaoListaAdSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>(CidadaoListaAdSelectFieldDocument, options);
        }
export type CidadaoListaAdSelectFieldQueryHookResult = ReturnType<typeof useCidadaoListaAdSelectFieldQuery>;
export type CidadaoListaAdSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoListaAdSelectFieldLazyQuery>;
export type CidadaoListaAdSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCidadaoListaAdSelectFieldSuspenseQuery>;
export type CidadaoListaAdSelectFieldQueryResult = Apollo.QueryResult<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>;
export const AgendamentosDiaLotacaoDocument = gql`
    query AgendamentosDiaLotacao($input: AgendadosQueryInput!) {
  agendados(input: $input) {
    content {
      ...Agendamento
      tipoAgendamento
      cidadao {
        id
        nome
        nomeSocial
        contato {
          id
          telefoneResidencial
          telefoneCelular
          telefoneContato
        }
      }
      atendimento {
        id
        statusAtendimento
        possuiAtendimentosProfissionais
      }
      isAtencaoDomiciliar
      motivoReserva
      outroMotivoReserva
      agendamentoPrincipal {
        id
        lotacaoAgendada {
          id
          profissional {
            id
            email
            nome
          }
        }
      }
      lotacaoParticipante {
        id
        profissional {
          id
          nome
          email
        }
      }
      videochamada {
        id
        uuid
      }
    }
  }
}
    ${AgendamentoFragmentDoc}`;

/**
 * __useAgendamentosDiaLotacaoQuery__
 *
 * To run a query within a React component, call `useAgendamentosDiaLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendamentosDiaLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendamentosDiaLotacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendamentosDiaLotacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables> & ({ variables: Types.AgendamentosDiaLotacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>(AgendamentosDiaLotacaoDocument, options);
      }
export function useAgendamentosDiaLotacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>(AgendamentosDiaLotacaoDocument, options);
        }
export function useAgendamentosDiaLotacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>(AgendamentosDiaLotacaoDocument, options);
        }
export type AgendamentosDiaLotacaoQueryHookResult = ReturnType<typeof useAgendamentosDiaLotacaoQuery>;
export type AgendamentosDiaLotacaoLazyQueryHookResult = ReturnType<typeof useAgendamentosDiaLotacaoLazyQuery>;
export type AgendamentosDiaLotacaoSuspenseQueryHookResult = ReturnType<typeof useAgendamentosDiaLotacaoSuspenseQuery>;
export type AgendamentosDiaLotacaoQueryResult = Apollo.QueryResult<Types.AgendamentosDiaLotacaoQuery, Types.AgendamentosDiaLotacaoQueryVariables>;
export const ConfiguracaoHorariosAgendaLotacaoDocument = gql`
    query ConfiguracaoHorariosAgendaLotacao($lotacaoId: ID!, $isAtencaoDomiciliar: Boolean!, $isAgendaAtiva: Boolean!) {
  lotacao(id: $lotacaoId) {
    id
    configuracaoAgenda {
      duracaoAgendamento(isAtencaoDomiciliar: $isAtencaoDomiciliar)
      configuracaoHorarioAgenda @include(if: $isAgendaAtiva) {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            horarioInicial
            horarioFinal
          }
        }
      }
    }
    gradeConfiguracaoAgendaOnline @include(if: $isAgendaAtiva) {
      configuracoesSemana {
        diaSemana
        configuracoes {
          horario
          ativo
        }
      }
      diasLiberacaoReserva
    }
  }
  conexao @include(if: $isAgendaAtiva) {
    agendaOnline {
      ativa
    }
  }
}
    `;

/**
 * __useConfiguracaoHorariosAgendaLotacaoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoHorariosAgendaLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoHorariosAgendaLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoHorariosAgendaLotacaoQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *      isAtencaoDomiciliar: // value for 'isAtencaoDomiciliar'
 *      isAgendaAtiva: // value for 'isAgendaAtiva'
 *   },
 * });
 */
export function useConfiguracaoHorariosAgendaLotacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables> & ({ variables: Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>(ConfiguracaoHorariosAgendaLotacaoDocument, options);
      }
export function useConfiguracaoHorariosAgendaLotacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>(ConfiguracaoHorariosAgendaLotacaoDocument, options);
        }
export function useConfiguracaoHorariosAgendaLotacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>(ConfiguracaoHorariosAgendaLotacaoDocument, options);
        }
export type ConfiguracaoHorariosAgendaLotacaoQueryHookResult = ReturnType<typeof useConfiguracaoHorariosAgendaLotacaoQuery>;
export type ConfiguracaoHorariosAgendaLotacaoLazyQueryHookResult = ReturnType<typeof useConfiguracaoHorariosAgendaLotacaoLazyQuery>;
export type ConfiguracaoHorariosAgendaLotacaoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoHorariosAgendaLotacaoSuspenseQuery>;
export type ConfiguracaoHorariosAgendaLotacaoQueryResult = Apollo.QueryResult<Types.ConfiguracaoHorariosAgendaLotacaoQuery, Types.ConfiguracaoHorariosAgendaLotacaoQueryVariables>;
export const FechamentoAgendaDiaDocument = gql`
    query FechamentoAgendaDia($input: FechamentoAgendaDiaQueryInput!) {
  fechamentoDia(input: $input) {
    id
    dataInicial
    dataFinal
    motivo
    especifique
  }
}
    `;

/**
 * __useFechamentoAgendaDiaQuery__
 *
 * To run a query within a React component, call `useFechamentoAgendaDiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFechamentoAgendaDiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFechamentoAgendaDiaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFechamentoAgendaDiaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables> & ({ variables: Types.FechamentoAgendaDiaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>(FechamentoAgendaDiaDocument, options);
      }
export function useFechamentoAgendaDiaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>(FechamentoAgendaDiaDocument, options);
        }
export function useFechamentoAgendaDiaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>(FechamentoAgendaDiaDocument, options);
        }
export type FechamentoAgendaDiaQueryHookResult = ReturnType<typeof useFechamentoAgendaDiaQuery>;
export type FechamentoAgendaDiaLazyQueryHookResult = ReturnType<typeof useFechamentoAgendaDiaLazyQuery>;
export type FechamentoAgendaDiaSuspenseQueryHookResult = ReturnType<typeof useFechamentoAgendaDiaSuspenseQuery>;
export type FechamentoAgendaDiaQueryResult = Apollo.QueryResult<Types.FechamentoAgendaDiaQuery, Types.FechamentoAgendaDiaQueryVariables>;
export const AgendaAuthorizationDocument = gql`
    query AgendaAuthorization($equipeId: ID!, $isAd: Boolean!) {
  equipe(id: $equipeId) {
    id
    emapsApoio @include(if: $isAd) {
      id
    }
    equipesVinculadas {
      id
    }
  }
}
    `;

/**
 * __useAgendaAuthorizationQuery__
 *
 * To run a query within a React component, call `useAgendaAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaAuthorizationQuery({
 *   variables: {
 *      equipeId: // value for 'equipeId'
 *      isAd: // value for 'isAd'
 *   },
 * });
 */
export function useAgendaAuthorizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables> & ({ variables: Types.AgendaAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>(AgendaAuthorizationDocument, options);
      }
export function useAgendaAuthorizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>(AgendaAuthorizationDocument, options);
        }
export function useAgendaAuthorizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>(AgendaAuthorizationDocument, options);
        }
export type AgendaAuthorizationQueryHookResult = ReturnType<typeof useAgendaAuthorizationQuery>;
export type AgendaAuthorizationLazyQueryHookResult = ReturnType<typeof useAgendaAuthorizationLazyQuery>;
export type AgendaAuthorizationSuspenseQueryHookResult = ReturnType<typeof useAgendaAuthorizationSuspenseQuery>;
export type AgendaAuthorizationQueryResult = Apollo.QueryResult<Types.AgendaAuthorizationQuery, Types.AgendaAuthorizationQueryVariables>;
export const AgendamentosConflitantesDocument = gql`
    query AgendamentosConflitantes($input: AgendamentoConflitanteInput!) {
  nomesOutrosProfissionaisAgendamentosConflitantes(input: $input) {
    nomesProfissionais
    horarioAgendamentoConflitante
  }
  possuiAgendamentoMesmoProfissionalDataFutura(input: $input) {
    profissionalId
    dataFutura
  }
}
    `;

/**
 * __useAgendamentosConflitantesQuery__
 *
 * To run a query within a React component, call `useAgendamentosConflitantesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendamentosConflitantesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendamentosConflitantesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendamentosConflitantesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables> & ({ variables: Types.AgendamentosConflitantesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>(AgendamentosConflitantesDocument, options);
      }
export function useAgendamentosConflitantesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>(AgendamentosConflitantesDocument, options);
        }
export function useAgendamentosConflitantesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>(AgendamentosConflitantesDocument, options);
        }
export type AgendamentosConflitantesQueryHookResult = ReturnType<typeof useAgendamentosConflitantesQuery>;
export type AgendamentosConflitantesLazyQueryHookResult = ReturnType<typeof useAgendamentosConflitantesLazyQuery>;
export type AgendamentosConflitantesSuspenseQueryHookResult = ReturnType<typeof useAgendamentosConflitantesSuspenseQuery>;
export type AgendamentosConflitantesQueryResult = Apollo.QueryResult<Types.AgendamentosConflitantesQuery, Types.AgendamentosConflitantesQueryVariables>;
export const CidadaoCadastroAgendamentoDocument = gql`
    query CidadaoCadastroAgendamento($id: ID!) {
  cidadao(id: $id) {
    id
    nome
    nomeSocial
    cpf
    cns
    nomeMae
    dataNascimento
    sexo
    identidadeGeneroDbEnum
    telefoneCelular
    email
    faleceu
  }
}
    `;

/**
 * __useCidadaoCadastroAgendamentoQuery__
 *
 * To run a query within a React component, call `useCidadaoCadastroAgendamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoCadastroAgendamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoCadastroAgendamentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoCadastroAgendamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables> & ({ variables: Types.CidadaoCadastroAgendamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>(CidadaoCadastroAgendamentoDocument, options);
      }
export function useCidadaoCadastroAgendamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>(CidadaoCadastroAgendamentoDocument, options);
        }
export function useCidadaoCadastroAgendamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>(CidadaoCadastroAgendamentoDocument, options);
        }
export type CidadaoCadastroAgendamentoQueryHookResult = ReturnType<typeof useCidadaoCadastroAgendamentoQuery>;
export type CidadaoCadastroAgendamentoLazyQueryHookResult = ReturnType<typeof useCidadaoCadastroAgendamentoLazyQuery>;
export type CidadaoCadastroAgendamentoSuspenseQueryHookResult = ReturnType<typeof useCidadaoCadastroAgendamentoSuspenseQuery>;
export type CidadaoCadastroAgendamentoQueryResult = Apollo.QueryResult<Types.CidadaoCadastroAgendamentoQuery, Types.CidadaoCadastroAgendamentoQueryVariables>;
export const EditarAgendadoDocument = gql`
    query EditarAgendado($id: ID!) {
  agendado(id: $id) {
    id
    horarioInicial
    horarioFinal
    lotacaoAgendada {
      ...LotacaoAssociadaAgendamento
    }
    motivoReserva
    outroMotivoReserva
    observacao
    localAtendimento {
      id
      localAtendimentoExibicao
    }
    cidadao {
      id
      nome
      nomeSocial
      contato {
        id
        email
        telefoneCelular
      }
    }
    agendamentoParticipante {
      id
      lotacaoAgendada {
        ...LotacaoAgendaSelect
      }
    }
    videochamada {
      id
      uuid
    }
  }
}
    ${LotacaoAssociadaAgendamentoFragmentDoc}
${LotacaoAgendaSelectFragmentDoc}`;

/**
 * __useEditarAgendadoQuery__
 *
 * To run a query within a React component, call `useEditarAgendadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditarAgendadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditarAgendadoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditarAgendadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables> & ({ variables: Types.EditarAgendadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>(EditarAgendadoDocument, options);
      }
export function useEditarAgendadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>(EditarAgendadoDocument, options);
        }
export function useEditarAgendadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>(EditarAgendadoDocument, options);
        }
export type EditarAgendadoQueryHookResult = ReturnType<typeof useEditarAgendadoQuery>;
export type EditarAgendadoLazyQueryHookResult = ReturnType<typeof useEditarAgendadoLazyQuery>;
export type EditarAgendadoSuspenseQueryHookResult = ReturnType<typeof useEditarAgendadoSuspenseQuery>;
export type EditarAgendadoQueryResult = Apollo.QueryResult<Types.EditarAgendadoQuery, Types.EditarAgendadoQueryVariables>;
export const EditarAgendamentoConsultaCompartilhadaDocument = gql`
    mutation EditarAgendamentoConsultaCompartilhada($input: EditarAgendamentoConsultaCompartilhadaInput!) {
  editarAgendamentoConsultaCompartilhada(input: $input)
}
    `;
export type EditarAgendamentoConsultaCompartilhadaMutationFn = Apollo.MutationFunction<Types.EditarAgendamentoConsultaCompartilhadaMutation, Types.EditarAgendamentoConsultaCompartilhadaMutationVariables>;

/**
 * __useEditarAgendamentoConsultaCompartilhadaMutation__
 *
 * To run a mutation, you first call `useEditarAgendamentoConsultaCompartilhadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarAgendamentoConsultaCompartilhadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarAgendamentoConsultaCompartilhadaMutation, { data, loading, error }] = useEditarAgendamentoConsultaCompartilhadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarAgendamentoConsultaCompartilhadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarAgendamentoConsultaCompartilhadaMutation, Types.EditarAgendamentoConsultaCompartilhadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarAgendamentoConsultaCompartilhadaMutation, Types.EditarAgendamentoConsultaCompartilhadaMutationVariables>(EditarAgendamentoConsultaCompartilhadaDocument, options);
      }
export type EditarAgendamentoConsultaCompartilhadaMutationHookResult = ReturnType<typeof useEditarAgendamentoConsultaCompartilhadaMutation>;
export type EditarAgendamentoConsultaCompartilhadaMutationResult = Apollo.MutationResult<Types.EditarAgendamentoConsultaCompartilhadaMutation>;
export type EditarAgendamentoConsultaCompartilhadaMutationOptions = Apollo.BaseMutationOptions<Types.EditarAgendamentoConsultaCompartilhadaMutation, Types.EditarAgendamentoConsultaCompartilhadaMutationVariables>;
export const EditarAgendamentoConsultaDocument = gql`
    mutation EditarAgendamentoConsulta($input: EditarAgendamentoConsultaInput!) {
  editarAgendamentoConsulta(input: $input)
}
    `;
export type EditarAgendamentoConsultaMutationFn = Apollo.MutationFunction<Types.EditarAgendamentoConsultaMutation, Types.EditarAgendamentoConsultaMutationVariables>;

/**
 * __useEditarAgendamentoConsultaMutation__
 *
 * To run a mutation, you first call `useEditarAgendamentoConsultaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarAgendamentoConsultaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarAgendamentoConsultaMutation, { data, loading, error }] = useEditarAgendamentoConsultaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarAgendamentoConsultaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarAgendamentoConsultaMutation, Types.EditarAgendamentoConsultaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarAgendamentoConsultaMutation, Types.EditarAgendamentoConsultaMutationVariables>(EditarAgendamentoConsultaDocument, options);
      }
export type EditarAgendamentoConsultaMutationHookResult = ReturnType<typeof useEditarAgendamentoConsultaMutation>;
export type EditarAgendamentoConsultaMutationResult = Apollo.MutationResult<Types.EditarAgendamentoConsultaMutation>;
export type EditarAgendamentoConsultaMutationOptions = Apollo.BaseMutationOptions<Types.EditarAgendamentoConsultaMutation, Types.EditarAgendamentoConsultaMutationVariables>;
export const EditarAgendamentoReservaDocument = gql`
    mutation EditarAgendamentoReserva($input: EditarAgendamentoReservaInput!) {
  editarAgendamentoReserva(input: $input)
}
    `;
export type EditarAgendamentoReservaMutationFn = Apollo.MutationFunction<Types.EditarAgendamentoReservaMutation, Types.EditarAgendamentoReservaMutationVariables>;

/**
 * __useEditarAgendamentoReservaMutation__
 *
 * To run a mutation, you first call `useEditarAgendamentoReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarAgendamentoReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarAgendamentoReservaMutation, { data, loading, error }] = useEditarAgendamentoReservaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarAgendamentoReservaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarAgendamentoReservaMutation, Types.EditarAgendamentoReservaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarAgendamentoReservaMutation, Types.EditarAgendamentoReservaMutationVariables>(EditarAgendamentoReservaDocument, options);
      }
export type EditarAgendamentoReservaMutationHookResult = ReturnType<typeof useEditarAgendamentoReservaMutation>;
export type EditarAgendamentoReservaMutationResult = Apollo.MutationResult<Types.EditarAgendamentoReservaMutation>;
export type EditarAgendamentoReservaMutationOptions = Apollo.BaseMutationOptions<Types.EditarAgendamentoReservaMutation, Types.EditarAgendamentoReservaMutationVariables>;
export const SalvarAgendamentoConsultaCompartilhadaDocument = gql`
    mutation SalvarAgendamentoConsultaCompartilhada($input: CriarAgendamentoConsultaCompartilhadaInput!) {
  salvarAgendamentoConsultaCompartilhada(input: $input)
}
    `;
export type SalvarAgendamentoConsultaCompartilhadaMutationFn = Apollo.MutationFunction<Types.SalvarAgendamentoConsultaCompartilhadaMutation, Types.SalvarAgendamentoConsultaCompartilhadaMutationVariables>;

/**
 * __useSalvarAgendamentoConsultaCompartilhadaMutation__
 *
 * To run a mutation, you first call `useSalvarAgendamentoConsultaCompartilhadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAgendamentoConsultaCompartilhadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAgendamentoConsultaCompartilhadaMutation, { data, loading, error }] = useSalvarAgendamentoConsultaCompartilhadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAgendamentoConsultaCompartilhadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAgendamentoConsultaCompartilhadaMutation, Types.SalvarAgendamentoConsultaCompartilhadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAgendamentoConsultaCompartilhadaMutation, Types.SalvarAgendamentoConsultaCompartilhadaMutationVariables>(SalvarAgendamentoConsultaCompartilhadaDocument, options);
      }
export type SalvarAgendamentoConsultaCompartilhadaMutationHookResult = ReturnType<typeof useSalvarAgendamentoConsultaCompartilhadaMutation>;
export type SalvarAgendamentoConsultaCompartilhadaMutationResult = Apollo.MutationResult<Types.SalvarAgendamentoConsultaCompartilhadaMutation>;
export type SalvarAgendamentoConsultaCompartilhadaMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAgendamentoConsultaCompartilhadaMutation, Types.SalvarAgendamentoConsultaCompartilhadaMutationVariables>;
export const SalvarAgendamentoConsultaDocument = gql`
    mutation SalvarAgendamentoConsulta($input: CriarAgendamentoConsultaInput!) {
  salvarAgendamentoConsulta(input: $input)
}
    `;
export type SalvarAgendamentoConsultaMutationFn = Apollo.MutationFunction<Types.SalvarAgendamentoConsultaMutation, Types.SalvarAgendamentoConsultaMutationVariables>;

/**
 * __useSalvarAgendamentoConsultaMutation__
 *
 * To run a mutation, you first call `useSalvarAgendamentoConsultaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAgendamentoConsultaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAgendamentoConsultaMutation, { data, loading, error }] = useSalvarAgendamentoConsultaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAgendamentoConsultaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAgendamentoConsultaMutation, Types.SalvarAgendamentoConsultaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAgendamentoConsultaMutation, Types.SalvarAgendamentoConsultaMutationVariables>(SalvarAgendamentoConsultaDocument, options);
      }
export type SalvarAgendamentoConsultaMutationHookResult = ReturnType<typeof useSalvarAgendamentoConsultaMutation>;
export type SalvarAgendamentoConsultaMutationResult = Apollo.MutationResult<Types.SalvarAgendamentoConsultaMutation>;
export type SalvarAgendamentoConsultaMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAgendamentoConsultaMutation, Types.SalvarAgendamentoConsultaMutationVariables>;
export const SalvarAgendamentoReservaDocument = gql`
    mutation SalvarAgendamentoReserva($input: CriarAgendamentoReservaInput!) {
  salvarAgendamentoReserva(input: $input)
}
    `;
export type SalvarAgendamentoReservaMutationFn = Apollo.MutationFunction<Types.SalvarAgendamentoReservaMutation, Types.SalvarAgendamentoReservaMutationVariables>;

/**
 * __useSalvarAgendamentoReservaMutation__
 *
 * To run a mutation, you first call `useSalvarAgendamentoReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAgendamentoReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAgendamentoReservaMutation, { data, loading, error }] = useSalvarAgendamentoReservaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAgendamentoReservaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAgendamentoReservaMutation, Types.SalvarAgendamentoReservaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAgendamentoReservaMutation, Types.SalvarAgendamentoReservaMutationVariables>(SalvarAgendamentoReservaDocument, options);
      }
export type SalvarAgendamentoReservaMutationHookResult = ReturnType<typeof useSalvarAgendamentoReservaMutation>;
export type SalvarAgendamentoReservaMutationResult = Apollo.MutationResult<Types.SalvarAgendamentoReservaMutation>;
export type SalvarAgendamentoReservaMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAgendamentoReservaMutation, Types.SalvarAgendamentoReservaMutationVariables>;
export const AgendamentosCidadaoPagedDocument = gql`
    query AgendamentosCidadaoPaged($input: AgendadosQueryInput!) {
  agendados(input: $input) {
    content {
      ...Agendamento
      lotacaoAgendada {
        ...LotacaoAssociadaAgendamento
        unidadeSaude {
          id
          nome
        }
      }
      responsavelCriador {
        ... on Lotacao {
          ...LotacaoAssociadaAgendamento
        }
        ... on Estagio {
          ...EstagioAssociadoAgendamento
        }
      }
      justificativaCancelamento {
        id
        justificativa
        data
        responsavel {
          ... on Lotacao {
            ...LotacaoAssociadaAgendamento
          }
          ... on Estagio {
            ...EstagioAssociadoAgendamento
          }
        }
      }
      agendamentoPrincipal {
        id
        lotacaoAgendada {
          ...LotacaoAssociadaAgendamento
        }
      }
      lotacaoParticipante {
        ...LotacaoAssociadaAgendamento
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
  conexao {
    agendaOnline {
      ativa
    }
  }
}
    ${AgendamentoFragmentDoc}
${LotacaoAssociadaAgendamentoFragmentDoc}
${EstagioAssociadoAgendamentoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useAgendamentosCidadaoPagedQuery__
 *
 * To run a query within a React component, call `useAgendamentosCidadaoPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendamentosCidadaoPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendamentosCidadaoPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendamentosCidadaoPagedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables> & ({ variables: Types.AgendamentosCidadaoPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>(AgendamentosCidadaoPagedDocument, options);
      }
export function useAgendamentosCidadaoPagedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>(AgendamentosCidadaoPagedDocument, options);
        }
export function useAgendamentosCidadaoPagedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>(AgendamentosCidadaoPagedDocument, options);
        }
export type AgendamentosCidadaoPagedQueryHookResult = ReturnType<typeof useAgendamentosCidadaoPagedQuery>;
export type AgendamentosCidadaoPagedLazyQueryHookResult = ReturnType<typeof useAgendamentosCidadaoPagedLazyQuery>;
export type AgendamentosCidadaoPagedSuspenseQueryHookResult = ReturnType<typeof useAgendamentosCidadaoPagedSuspenseQuery>;
export type AgendamentosCidadaoPagedQueryResult = Apollo.QueryResult<Types.AgendamentosCidadaoPagedQuery, Types.AgendamentosCidadaoPagedQueryVariables>;
export const LotacaoConfiguracaoAgendaDocument = gql`
    query LotacaoConfiguracaoAgenda($id: ID!) {
  hasConfiguracaoAgenda(lotacaoId: $id)
}
    `;

/**
 * __useLotacaoConfiguracaoAgendaQuery__
 *
 * To run a query within a React component, call `useLotacaoConfiguracaoAgendaQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoConfiguracaoAgendaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoConfiguracaoAgendaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLotacaoConfiguracaoAgendaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables> & ({ variables: Types.LotacaoConfiguracaoAgendaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>(LotacaoConfiguracaoAgendaDocument, options);
      }
export function useLotacaoConfiguracaoAgendaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>(LotacaoConfiguracaoAgendaDocument, options);
        }
export function useLotacaoConfiguracaoAgendaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>(LotacaoConfiguracaoAgendaDocument, options);
        }
export type LotacaoConfiguracaoAgendaQueryHookResult = ReturnType<typeof useLotacaoConfiguracaoAgendaQuery>;
export type LotacaoConfiguracaoAgendaLazyQueryHookResult = ReturnType<typeof useLotacaoConfiguracaoAgendaLazyQuery>;
export type LotacaoConfiguracaoAgendaSuspenseQueryHookResult = ReturnType<typeof useLotacaoConfiguracaoAgendaSuspenseQuery>;
export type LotacaoConfiguracaoAgendaQueryResult = Apollo.QueryResult<Types.LotacaoConfiguracaoAgendaQuery, Types.LotacaoConfiguracaoAgendaQueryVariables>;
export const CancelarAgendamentoDocument = gql`
    mutation CancelarAgendamento($input: CancelarAgendamentoInput!) {
  cancelarAgendamento(input: $input)
}
    `;
export type CancelarAgendamentoMutationFn = Apollo.MutationFunction<Types.CancelarAgendamentoMutation, Types.CancelarAgendamentoMutationVariables>;

/**
 * __useCancelarAgendamentoMutation__
 *
 * To run a mutation, you first call `useCancelarAgendamentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarAgendamentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarAgendamentoMutation, { data, loading, error }] = useCancelarAgendamentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelarAgendamentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelarAgendamentoMutation, Types.CancelarAgendamentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelarAgendamentoMutation, Types.CancelarAgendamentoMutationVariables>(CancelarAgendamentoDocument, options);
      }
export type CancelarAgendamentoMutationHookResult = ReturnType<typeof useCancelarAgendamentoMutation>;
export type CancelarAgendamentoMutationResult = Apollo.MutationResult<Types.CancelarAgendamentoMutation>;
export type CancelarAgendamentoMutationOptions = Apollo.BaseMutationOptions<Types.CancelarAgendamentoMutation, Types.CancelarAgendamentoMutationVariables>;
export const DataCriacaoAgendadoDocument = gql`
    query DataCriacaoAgendado($id: ID!) {
  agendado(id: $id) {
    id
    dataCriacao
  }
}
    `;

/**
 * __useDataCriacaoAgendadoQuery__
 *
 * To run a query within a React component, call `useDataCriacaoAgendadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCriacaoAgendadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCriacaoAgendadoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataCriacaoAgendadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables> & ({ variables: Types.DataCriacaoAgendadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>(DataCriacaoAgendadoDocument, options);
      }
export function useDataCriacaoAgendadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>(DataCriacaoAgendadoDocument, options);
        }
export function useDataCriacaoAgendadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>(DataCriacaoAgendadoDocument, options);
        }
export type DataCriacaoAgendadoQueryHookResult = ReturnType<typeof useDataCriacaoAgendadoQuery>;
export type DataCriacaoAgendadoLazyQueryHookResult = ReturnType<typeof useDataCriacaoAgendadoLazyQuery>;
export type DataCriacaoAgendadoSuspenseQueryHookResult = ReturnType<typeof useDataCriacaoAgendadoSuspenseQuery>;
export type DataCriacaoAgendadoQueryResult = Apollo.QueryResult<Types.DataCriacaoAgendadoQuery, Types.DataCriacaoAgendadoQueryVariables>;
export const FixarAgendaDocument = gql`
    mutation FixarAgenda($lotacaoId: ID!) {
  fixarAgenda(lotacaoId: $lotacaoId)
}
    `;
export type FixarAgendaMutationFn = Apollo.MutationFunction<Types.FixarAgendaMutation, Types.FixarAgendaMutationVariables>;

/**
 * __useFixarAgendaMutation__
 *
 * To run a mutation, you first call `useFixarAgendaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixarAgendaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixarAgendaMutation, { data, loading, error }] = useFixarAgendaMutation({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useFixarAgendaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.FixarAgendaMutation, Types.FixarAgendaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.FixarAgendaMutation, Types.FixarAgendaMutationVariables>(FixarAgendaDocument, options);
      }
export type FixarAgendaMutationHookResult = ReturnType<typeof useFixarAgendaMutation>;
export type FixarAgendaMutationResult = Apollo.MutationResult<Types.FixarAgendaMutation>;
export type FixarAgendaMutationOptions = Apollo.BaseMutationOptions<Types.FixarAgendaMutation, Types.FixarAgendaMutationVariables>;
export const InformarFaltaCidadaoDocument = gql`
    mutation InformarFaltaCidadao($agendamentoId: ID!) {
  informarFaltaCidadao(agendamentoId: $agendamentoId)
}
    `;
export type InformarFaltaCidadaoMutationFn = Apollo.MutationFunction<Types.InformarFaltaCidadaoMutation, Types.InformarFaltaCidadaoMutationVariables>;

/**
 * __useInformarFaltaCidadaoMutation__
 *
 * To run a mutation, you first call `useInformarFaltaCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInformarFaltaCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [informarFaltaCidadaoMutation, { data, loading, error }] = useInformarFaltaCidadaoMutation({
 *   variables: {
 *      agendamentoId: // value for 'agendamentoId'
 *   },
 * });
 */
export function useInformarFaltaCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InformarFaltaCidadaoMutation, Types.InformarFaltaCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InformarFaltaCidadaoMutation, Types.InformarFaltaCidadaoMutationVariables>(InformarFaltaCidadaoDocument, options);
      }
export type InformarFaltaCidadaoMutationHookResult = ReturnType<typeof useInformarFaltaCidadaoMutation>;
export type InformarFaltaCidadaoMutationResult = Apollo.MutationResult<Types.InformarFaltaCidadaoMutation>;
export type InformarFaltaCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.InformarFaltaCidadaoMutation, Types.InformarFaltaCidadaoMutationVariables>;
export const InserirListaAtendimentoDocument = gql`
    mutation InserirListaAtendimento($input: AtendimentoInput!) {
  salvarAtendimento(input: $input) {
    id
  }
}
    `;
export type InserirListaAtendimentoMutationFn = Apollo.MutationFunction<Types.InserirListaAtendimentoMutation, Types.InserirListaAtendimentoMutationVariables>;

/**
 * __useInserirListaAtendimentoMutation__
 *
 * To run a mutation, you first call `useInserirListaAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInserirListaAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inserirListaAtendimentoMutation, { data, loading, error }] = useInserirListaAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInserirListaAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InserirListaAtendimentoMutation, Types.InserirListaAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InserirListaAtendimentoMutation, Types.InserirListaAtendimentoMutationVariables>(InserirListaAtendimentoDocument, options);
      }
export type InserirListaAtendimentoMutationHookResult = ReturnType<typeof useInserirListaAtendimentoMutation>;
export type InserirListaAtendimentoMutationResult = Apollo.MutationResult<Types.InserirListaAtendimentoMutation>;
export type InserirListaAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.InserirListaAtendimentoMutation, Types.InserirListaAtendimentoMutationVariables>;
export const RemoverAgendaFixadaDocument = gql`
    mutation RemoverAgendaFixada($lotacaoId: ID!) {
  removerAgendaFixada(lotacaoId: $lotacaoId)
}
    `;
export type RemoverAgendaFixadaMutationFn = Apollo.MutationFunction<Types.RemoverAgendaFixadaMutation, Types.RemoverAgendaFixadaMutationVariables>;

/**
 * __useRemoverAgendaFixadaMutation__
 *
 * To run a mutation, you first call `useRemoverAgendaFixadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverAgendaFixadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerAgendaFixadaMutation, { data, loading, error }] = useRemoverAgendaFixadaMutation({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useRemoverAgendaFixadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverAgendaFixadaMutation, Types.RemoverAgendaFixadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverAgendaFixadaMutation, Types.RemoverAgendaFixadaMutationVariables>(RemoverAgendaFixadaDocument, options);
      }
export type RemoverAgendaFixadaMutationHookResult = ReturnType<typeof useRemoverAgendaFixadaMutation>;
export type RemoverAgendaFixadaMutationResult = Apollo.MutationResult<Types.RemoverAgendaFixadaMutation>;
export type RemoverAgendaFixadaMutationOptions = Apollo.BaseMutationOptions<Types.RemoverAgendaFixadaMutation, Types.RemoverAgendaFixadaMutationVariables>;
export const RemoverFaltaCidadaoMutationDocument = gql`
    mutation RemoverFaltaCidadaoMutation($agendamentoId: ID!) {
  removerFaltaCidadao(agendamentoId: $agendamentoId)
}
    `;
export type RemoverFaltaCidadaoMutationMutationFn = Apollo.MutationFunction<Types.RemoverFaltaCidadaoMutationMutation, Types.RemoverFaltaCidadaoMutationMutationVariables>;

/**
 * __useRemoverFaltaCidadaoMutationMutation__
 *
 * To run a mutation, you first call `useRemoverFaltaCidadaoMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverFaltaCidadaoMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerFaltaCidadaoMutationMutation, { data, loading, error }] = useRemoverFaltaCidadaoMutationMutation({
 *   variables: {
 *      agendamentoId: // value for 'agendamentoId'
 *   },
 * });
 */
export function useRemoverFaltaCidadaoMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverFaltaCidadaoMutationMutation, Types.RemoverFaltaCidadaoMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverFaltaCidadaoMutationMutation, Types.RemoverFaltaCidadaoMutationMutationVariables>(RemoverFaltaCidadaoMutationDocument, options);
      }
export type RemoverFaltaCidadaoMutationMutationHookResult = ReturnType<typeof useRemoverFaltaCidadaoMutationMutation>;
export type RemoverFaltaCidadaoMutationMutationResult = Apollo.MutationResult<Types.RemoverFaltaCidadaoMutationMutation>;
export type RemoverFaltaCidadaoMutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoverFaltaCidadaoMutationMutation, Types.RemoverFaltaCidadaoMutationMutationVariables>;
export const RemoverListaAtendimentoDocument = gql`
    mutation RemoverListaAtendimento($atendimentoId: ID!) {
  excluirAtendimento(atendimento: $atendimentoId)
}
    `;
export type RemoverListaAtendimentoMutationFn = Apollo.MutationFunction<Types.RemoverListaAtendimentoMutation, Types.RemoverListaAtendimentoMutationVariables>;

/**
 * __useRemoverListaAtendimentoMutation__
 *
 * To run a mutation, you first call `useRemoverListaAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverListaAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerListaAtendimentoMutation, { data, loading, error }] = useRemoverListaAtendimentoMutation({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useRemoverListaAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverListaAtendimentoMutation, Types.RemoverListaAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverListaAtendimentoMutation, Types.RemoverListaAtendimentoMutationVariables>(RemoverListaAtendimentoDocument, options);
      }
export type RemoverListaAtendimentoMutationHookResult = ReturnType<typeof useRemoverListaAtendimentoMutation>;
export type RemoverListaAtendimentoMutationResult = Apollo.MutationResult<Types.RemoverListaAtendimentoMutation>;
export type RemoverListaAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.RemoverListaAtendimentoMutation, Types.RemoverListaAtendimentoMutationVariables>;
export const MesAgendaDocument = gql`
    query MesAgenda($input: MesAgendaQueryInput!) {
  mesAgenda(input: $input) {
    id
    dias {
      data
      status
    }
  }
}
    `;

/**
 * __useMesAgendaQuery__
 *
 * To run a query within a React component, call `useMesAgendaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMesAgendaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMesAgendaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMesAgendaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MesAgendaQuery, Types.MesAgendaQueryVariables> & ({ variables: Types.MesAgendaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>(MesAgendaDocument, options);
      }
export function useMesAgendaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>(MesAgendaDocument, options);
        }
export function useMesAgendaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>(MesAgendaDocument, options);
        }
export type MesAgendaQueryHookResult = ReturnType<typeof useMesAgendaQuery>;
export type MesAgendaLazyQueryHookResult = ReturnType<typeof useMesAgendaLazyQuery>;
export type MesAgendaSuspenseQueryHookResult = ReturnType<typeof useMesAgendaSuspenseQuery>;
export type MesAgendaQueryResult = Apollo.QueryResult<Types.MesAgendaQuery, Types.MesAgendaQueryVariables>;
export const LotacaoAgendaActionsDocument = gql`
    query LotacaoAgendaActions($acessoId: ID!, $lotacaoId: ID!) {
  lotacao(id: $acessoId) {
    id
    actions {
      permissaoConfigurarAgenda {
        enabled
        hint
      }
      permissaoConfigurarAgendaOnline {
        enabled
        hint
      }
      permissaoFecharAgenda {
        enabled
        hint
      }
    }
  }
  lotacaoSelecionada: lotacao(id: $lotacaoId) {
    id
    hasAgendamentoFuturo
  }
}
    `;

/**
 * __useLotacaoAgendaActionsQuery__
 *
 * To run a query within a React component, call `useLotacaoAgendaActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoAgendaActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoAgendaActionsQuery({
 *   variables: {
 *      acessoId: // value for 'acessoId'
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useLotacaoAgendaActionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables> & ({ variables: Types.LotacaoAgendaActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>(LotacaoAgendaActionsDocument, options);
      }
export function useLotacaoAgendaActionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>(LotacaoAgendaActionsDocument, options);
        }
export function useLotacaoAgendaActionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>(LotacaoAgendaActionsDocument, options);
        }
export type LotacaoAgendaActionsQueryHookResult = ReturnType<typeof useLotacaoAgendaActionsQuery>;
export type LotacaoAgendaActionsLazyQueryHookResult = ReturnType<typeof useLotacaoAgendaActionsLazyQuery>;
export type LotacaoAgendaActionsSuspenseQueryHookResult = ReturnType<typeof useLotacaoAgendaActionsSuspenseQuery>;
export type LotacaoAgendaActionsQueryResult = Apollo.QueryResult<Types.LotacaoAgendaActionsQuery, Types.LotacaoAgendaActionsQueryVariables>;
export const DetalhesAgendamentoDocument = gql`
    query DetalhesAgendamento($id: ID!) {
  agendado(id: $id) {
    id
    agendamentoPrincipal {
      id
      cidadao {
        id
        nome
        nomeSocial
        cpf
        cns
        dataNascimento
        contato {
          id
          telefoneResidencial
          telefoneCelular
          telefoneContato
        }
      }
      lotacaoAgendada {
        id
        cbo {
          id
          nome
        }
        equipe {
          id
          ine
          nome
        }
        profissional {
          id
          nome
          email
        }
      }
    }
    cidadao {
      id
      nome
      nomeSocial
      cpf
      cns
      dataNascimento
      contato {
        id
        telefoneResidencial
        telefoneCelular
        telefoneContato
      }
    }
    lotacaoParticipante {
      id
      profissional {
        id
        nome
      }
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        ine
        nome
      }
    }
    videochamada {
      id
      uuid
    }
    dataCriacao
    responsavelCriador {
      ... on Lotacao {
        ...LotacaoAssociadaAgendamento
      }
      ... on Estagio {
        ...EstagioAssociadoAgendamento
      }
    }
    lotacaoAgendada {
      ...LotacaoAssociadaAgendamento
    }
  }
}
    ${LotacaoAssociadaAgendamentoFragmentDoc}
${EstagioAssociadoAgendamentoFragmentDoc}`;

/**
 * __useDetalhesAgendamentoQuery__
 *
 * To run a query within a React component, call `useDetalhesAgendamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetalhesAgendamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetalhesAgendamentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetalhesAgendamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables> & ({ variables: Types.DetalhesAgendamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>(DetalhesAgendamentoDocument, options);
      }
export function useDetalhesAgendamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>(DetalhesAgendamentoDocument, options);
        }
export function useDetalhesAgendamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>(DetalhesAgendamentoDocument, options);
        }
export type DetalhesAgendamentoQueryHookResult = ReturnType<typeof useDetalhesAgendamentoQuery>;
export type DetalhesAgendamentoLazyQueryHookResult = ReturnType<typeof useDetalhesAgendamentoLazyQuery>;
export type DetalhesAgendamentoSuspenseQueryHookResult = ReturnType<typeof useDetalhesAgendamentoSuspenseQuery>;
export type DetalhesAgendamentoQueryResult = Apollo.QueryResult<Types.DetalhesAgendamentoQuery, Types.DetalhesAgendamentoQueryVariables>;
export const AlterarSenhaDocument = gql`
    mutation AlterarSenha($input: AlterarSenhaAtualInput!) {
  alterarSenhaAtual(input: $input) {
    id
    forcarTrocaSenha
  }
}
    `;
export type AlterarSenhaMutationFn = Apollo.MutationFunction<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>;

/**
 * __useAlterarSenhaMutation__
 *
 * To run a mutation, you first call `useAlterarSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarSenhaMutation, { data, loading, error }] = useAlterarSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarSenhaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>(AlterarSenhaDocument, options);
      }
export type AlterarSenhaMutationHookResult = ReturnType<typeof useAlterarSenhaMutation>;
export type AlterarSenhaMutationResult = Apollo.MutationResult<Types.AlterarSenhaMutation>;
export type AlterarSenhaMutationOptions = Apollo.BaseMutationOptions<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>;
export const DataLimiteAlterarSenhaDocument = gql`
    query DataLimiteAlterarSenha($login: String) {
  dataLimiteAlterarSenha(login: $login)
}
    `;

/**
 * __useDataLimiteAlterarSenhaQuery__
 *
 * To run a query within a React component, call `useDataLimiteAlterarSenhaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataLimiteAlterarSenhaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataLimiteAlterarSenhaQuery({
 *   variables: {
 *      login: // value for 'login'
 *   },
 * });
 */
export function useDataLimiteAlterarSenhaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>(DataLimiteAlterarSenhaDocument, options);
      }
export function useDataLimiteAlterarSenhaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>(DataLimiteAlterarSenhaDocument, options);
        }
export function useDataLimiteAlterarSenhaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>(DataLimiteAlterarSenhaDocument, options);
        }
export type DataLimiteAlterarSenhaQueryHookResult = ReturnType<typeof useDataLimiteAlterarSenhaQuery>;
export type DataLimiteAlterarSenhaLazyQueryHookResult = ReturnType<typeof useDataLimiteAlterarSenhaLazyQuery>;
export type DataLimiteAlterarSenhaSuspenseQueryHookResult = ReturnType<typeof useDataLimiteAlterarSenhaSuspenseQuery>;
export type DataLimiteAlterarSenhaQueryResult = Apollo.QueryResult<Types.DataLimiteAlterarSenhaQuery, Types.DataLimiteAlterarSenhaQueryVariables>;
export const ArquivosTemporariosPagedDocument = gql`
    query ArquivosTemporariosPaged($input: ArquivoTemporarioPagingQueryInput!) {
  arquivosTemporarios(input: $input) {
    content {
      id
      dataInicioGerado
      status
      identificador
      formato
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useArquivosTemporariosPagedQuery__
 *
 * To run a query within a React component, call `useArquivosTemporariosPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useArquivosTemporariosPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArquivosTemporariosPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArquivosTemporariosPagedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables> & ({ variables: Types.ArquivosTemporariosPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>(ArquivosTemporariosPagedDocument, options);
      }
export function useArquivosTemporariosPagedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>(ArquivosTemporariosPagedDocument, options);
        }
export function useArquivosTemporariosPagedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>(ArquivosTemporariosPagedDocument, options);
        }
export type ArquivosTemporariosPagedQueryHookResult = ReturnType<typeof useArquivosTemporariosPagedQuery>;
export type ArquivosTemporariosPagedLazyQueryHookResult = ReturnType<typeof useArquivosTemporariosPagedLazyQuery>;
export type ArquivosTemporariosPagedSuspenseQueryHookResult = ReturnType<typeof useArquivosTemporariosPagedSuspenseQuery>;
export type ArquivosTemporariosPagedQueryResult = Apollo.QueryResult<Types.ArquivosTemporariosPagedQuery, Types.ArquivosTemporariosPagedQueryVariables>;
export const UltimoArquivoTemporarioProntoEmProcessamentoDocument = gql`
    query UltimoArquivoTemporarioProntoEmProcessamento($input: ArquivoTemporarioQueryInput!) {
  ultimoArquivoTemporarioProntoEmProcessamento(input: $input) {
    id
    dataInicioGerado
    status
    identificador
    formato
  }
}
    `;

/**
 * __useUltimoArquivoTemporarioProntoEmProcessamentoQuery__
 *
 * To run a query within a React component, call `useUltimoArquivoTemporarioProntoEmProcessamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoArquivoTemporarioProntoEmProcessamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoArquivoTemporarioProntoEmProcessamentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimoArquivoTemporarioProntoEmProcessamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables> & ({ variables: Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>(UltimoArquivoTemporarioProntoEmProcessamentoDocument, options);
      }
export function useUltimoArquivoTemporarioProntoEmProcessamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>(UltimoArquivoTemporarioProntoEmProcessamentoDocument, options);
        }
export function useUltimoArquivoTemporarioProntoEmProcessamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>(UltimoArquivoTemporarioProntoEmProcessamentoDocument, options);
        }
export type UltimoArquivoTemporarioProntoEmProcessamentoQueryHookResult = ReturnType<typeof useUltimoArquivoTemporarioProntoEmProcessamentoQuery>;
export type UltimoArquivoTemporarioProntoEmProcessamentoLazyQueryHookResult = ReturnType<typeof useUltimoArquivoTemporarioProntoEmProcessamentoLazyQuery>;
export type UltimoArquivoTemporarioProntoEmProcessamentoSuspenseQueryHookResult = ReturnType<typeof useUltimoArquivoTemporarioProntoEmProcessamentoSuspenseQuery>;
export type UltimoArquivoTemporarioProntoEmProcessamentoQueryResult = Apollo.QueryResult<Types.UltimoArquivoTemporarioProntoEmProcessamentoQuery, Types.UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables>;
export const UltimosCincoArquivosTemporariosDocument = gql`
    query UltimosCincoArquivosTemporarios($input: ArquivoTemporarioIdentificadorEnum!) {
  ultimosCincoArquivosTemporarios(arquivoIdentificador: $input) {
    id
    dataInicioGerado
    status
    identificador
    formato
  }
}
    `;

/**
 * __useUltimosCincoArquivosTemporariosQuery__
 *
 * To run a query within a React component, call `useUltimosCincoArquivosTemporariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimosCincoArquivosTemporariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimosCincoArquivosTemporariosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimosCincoArquivosTemporariosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables> & ({ variables: Types.UltimosCincoArquivosTemporariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>(UltimosCincoArquivosTemporariosDocument, options);
      }
export function useUltimosCincoArquivosTemporariosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>(UltimosCincoArquivosTemporariosDocument, options);
        }
export function useUltimosCincoArquivosTemporariosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>(UltimosCincoArquivosTemporariosDocument, options);
        }
export type UltimosCincoArquivosTemporariosQueryHookResult = ReturnType<typeof useUltimosCincoArquivosTemporariosQuery>;
export type UltimosCincoArquivosTemporariosLazyQueryHookResult = ReturnType<typeof useUltimosCincoArquivosTemporariosLazyQuery>;
export type UltimosCincoArquivosTemporariosSuspenseQueryHookResult = ReturnType<typeof useUltimosCincoArquivosTemporariosSuspenseQuery>;
export type UltimosCincoArquivosTemporariosQueryResult = Apollo.QueryResult<Types.UltimosCincoArquivosTemporariosQuery, Types.UltimosCincoArquivosTemporariosQueryVariables>;
export const AtendimentosFinalizadosDocument = gql`
    query AtendimentosFinalizados($input: AtendimentosFinalizadosInput!) {
  atendimentosFinalizados(input: $input) {
    content {
      id
      tipo
      atendimento {
        id
        cidadao {
          id
          nome
          nomeSocial
          cpf
          cns
          dataNascimento
        }
      }
      finalizadoEm
      assinaturaEletronicaAtend {
        id
        dtAssinatura
        status
      }
      isAtendRecente
      atendimentoProfissionalObservacao {
        id
        atendimentoObservacao {
          id
          isFinalizado
        }
      }
      codigoUnicoRegistro
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAtendimentosFinalizadosQuery__
 *
 * To run a query within a React component, call `useAtendimentosFinalizadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentosFinalizadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentosFinalizadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtendimentosFinalizadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables> & ({ variables: Types.AtendimentosFinalizadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>(AtendimentosFinalizadosDocument, options);
      }
export function useAtendimentosFinalizadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>(AtendimentosFinalizadosDocument, options);
        }
export function useAtendimentosFinalizadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>(AtendimentosFinalizadosDocument, options);
        }
export type AtendimentosFinalizadosQueryHookResult = ReturnType<typeof useAtendimentosFinalizadosQuery>;
export type AtendimentosFinalizadosLazyQueryHookResult = ReturnType<typeof useAtendimentosFinalizadosLazyQuery>;
export type AtendimentosFinalizadosSuspenseQueryHookResult = ReturnType<typeof useAtendimentosFinalizadosSuspenseQuery>;
export type AtendimentosFinalizadosQueryResult = Apollo.QueryResult<Types.AtendimentosFinalizadosQuery, Types.AtendimentosFinalizadosQueryVariables>;
export const AgendadoAtendimentoFormDocument = gql`
    query AgendadoAtendimentoForm($id: ID!) {
  agendado(id: $id) {
    id
    lotacaoAgendada {
      id
      cbo {
        id
        cbo2002
      }
      profissional {
        id
        nome
      }
      equipe {
        id
        nome
        ine
        tipoEquipe {
          id
          nome
          sigla
        }
      }
    }
  }
}
    `;

/**
 * __useAgendadoAtendimentoFormQuery__
 *
 * To run a query within a React component, call `useAgendadoAtendimentoFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendadoAtendimentoFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendadoAtendimentoFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgendadoAtendimentoFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables> & ({ variables: Types.AgendadoAtendimentoFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>(AgendadoAtendimentoFormDocument, options);
      }
export function useAgendadoAtendimentoFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>(AgendadoAtendimentoFormDocument, options);
        }
export function useAgendadoAtendimentoFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>(AgendadoAtendimentoFormDocument, options);
        }
export type AgendadoAtendimentoFormQueryHookResult = ReturnType<typeof useAgendadoAtendimentoFormQuery>;
export type AgendadoAtendimentoFormLazyQueryHookResult = ReturnType<typeof useAgendadoAtendimentoFormLazyQuery>;
export type AgendadoAtendimentoFormSuspenseQueryHookResult = ReturnType<typeof useAgendadoAtendimentoFormSuspenseQuery>;
export type AgendadoAtendimentoFormQueryResult = Apollo.QueryResult<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>;
export const AgendamentosDiaDocument = gql`
    query AgendamentosDia($input: AgendadosQueryInput!) {
  agendados(input: $input) {
    content {
      id
      horarioInicial
      lotacaoAgendada {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        cbo {
          id
          nome
        }
      }
      lotacaoParticipante {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        cbo {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useAgendamentosDiaQuery__
 *
 * To run a query within a React component, call `useAgendamentosDiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendamentosDiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendamentosDiaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendamentosDiaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables> & ({ variables: Types.AgendamentosDiaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>(AgendamentosDiaDocument, options);
      }
export function useAgendamentosDiaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>(AgendamentosDiaDocument, options);
        }
export function useAgendamentosDiaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>(AgendamentosDiaDocument, options);
        }
export type AgendamentosDiaQueryHookResult = ReturnType<typeof useAgendamentosDiaQuery>;
export type AgendamentosDiaLazyQueryHookResult = ReturnType<typeof useAgendamentosDiaLazyQuery>;
export type AgendamentosDiaSuspenseQueryHookResult = ReturnType<typeof useAgendamentosDiaSuspenseQuery>;
export type AgendamentosDiaQueryResult = Apollo.QueryResult<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>;
export const AtendimentoIndividualViewDocument = gql`
    query AtendimentoIndividualView($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    tipo
    tipoAtendimento
    iniciadoEm
    finalizadoEm
    estagio {
      id
    }
    rascunho
    lotacao {
      id
      profissional {
        id
        nome
        nomeSocial
        cns
        cpf
        numeroConselhoClasse
        conselhoClasse {
          id
          sigla
          descricao
        }
        ufEmissoraConselhoClasse {
          id
          nome
          sigla
        }
      }
      cbo {
        id
        nome
        cbo2002
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      equipe {
        id
        nome
        tipoEquipe {
          id
          isExibeProblemasObrigatoriosAdicionarLPC
        }
      }
    }
    atendimentoProfissionalObservacao {
      id
      atendimentoObservacao {
        id
        responsaveis {
          id
          responsavel {
            ...ResponsavelAtendimentoObservacao
          }
          atendeuComoResponsavel
        }
        ultimoResponsavelObservacao {
          ...ResponsavelAtendimentoObservacao
        }
      }
    }
    atendimento {
      id
      isRegistroTardio
      iniciadoEm
      statusRevisaoAtendimento
      localAtendimento {
        id
        localAtendimentoExibicao
      }
      agendado {
        id
        lotacaoAgendada {
          id
        }
        lotacaoParticipante {
          id
          cbo {
            id
            nome
            cbo2002
          }
          unidadeSaude {
            id
            nome
            cnes
          }
          profissional {
            id
            nome
            cpf
          }
        }
        agendamentoPrincipal {
          id
          lotacaoAgendada {
            id
            profissional {
              id
              nome
              cpf
            }
          }
        }
        videochamada {
          id
        }
      }
      tiposServico {
        id
      }
      cidadao {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        sexo
        nomeMae
        area
        microArea
        desejaInformarIdentidadeGenero
        identidadeGeneroDbEnum
        stCompartilhaProntuario
        ultimaDum {
          dum
          registradoEm
        }
        contato {
          id
          email
        }
      }
      prontuario {
        id
        gestacoes {
          id
          inicio
          fim
        }
        preNatalAtivo {
          id
          gravidezPlanejada
          ultimaDum
          tipoGravidez {
            id
            descricao
            tipoGravidez
          }
          altoRisco
          problema {
            id
            ultimaEvolucao {
              id
              dataInicio
            }
          }
          fonteIdadeGestacional
        }
        puerpera
      }
    }
  }
}
    ${ResponsavelAtendimentoObservacaoFragmentDoc}`;

/**
 * __useAtendimentoIndividualViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoIndividualViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoIndividualViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoIndividualViewQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoIndividualViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables> & ({ variables: Types.AtendimentoIndividualViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>(AtendimentoIndividualViewDocument, options);
      }
export function useAtendimentoIndividualViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>(AtendimentoIndividualViewDocument, options);
        }
export function useAtendimentoIndividualViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>(AtendimentoIndividualViewDocument, options);
        }
export type AtendimentoIndividualViewQueryHookResult = ReturnType<typeof useAtendimentoIndividualViewQuery>;
export type AtendimentoIndividualViewLazyQueryHookResult = ReturnType<typeof useAtendimentoIndividualViewLazyQuery>;
export type AtendimentoIndividualViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoIndividualViewSuspenseQuery>;
export type AtendimentoIndividualViewQueryResult = Apollo.QueryResult<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>;
export const CiapCidAtendimentoDocument = gql`
    query CiapCidAtendimento($inputCiap: CiapQueryInput!, $inputCid10: Cid10QueryInput!) {
  ciaps(input: $inputCiap) {
    content {
      id
      codigo
      descricao
      inclui
      exclui
    }
  }
  cids(input: $inputCid10) {
    content {
      id
      codigo
      nome
    }
  }
}
    `;

/**
 * __useCiapCidAtendimentoQuery__
 *
 * To run a query within a React component, call `useCiapCidAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiapCidAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiapCidAtendimentoQuery({
 *   variables: {
 *      inputCiap: // value for 'inputCiap'
 *      inputCid10: // value for 'inputCid10'
 *   },
 * });
 */
export function useCiapCidAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables> & ({ variables: Types.CiapCidAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>(CiapCidAtendimentoDocument, options);
      }
export function useCiapCidAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>(CiapCidAtendimentoDocument, options);
        }
export function useCiapCidAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>(CiapCidAtendimentoDocument, options);
        }
export type CiapCidAtendimentoQueryHookResult = ReturnType<typeof useCiapCidAtendimentoQuery>;
export type CiapCidAtendimentoLazyQueryHookResult = ReturnType<typeof useCiapCidAtendimentoLazyQuery>;
export type CiapCidAtendimentoSuspenseQueryHookResult = ReturnType<typeof useCiapCidAtendimentoSuspenseQuery>;
export type CiapCidAtendimentoQueryResult = Apollo.QueryResult<Types.CiapCidAtendimentoQuery, Types.CiapCidAtendimentoQueryVariables>;
export const ProcedimentosAutomaticosDocument = gql`
    query ProcedimentosAutomaticos {
  procedimentosAutomaticos {
    ...Procedimento
    idadeMinima
    idadeMaxima
    sexo
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useProcedimentosAutomaticosQuery__
 *
 * To run a query within a React component, call `useProcedimentosAutomaticosQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentosAutomaticosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentosAutomaticosQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcedimentosAutomaticosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>(ProcedimentosAutomaticosDocument, options);
      }
export function useProcedimentosAutomaticosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>(ProcedimentosAutomaticosDocument, options);
        }
export function useProcedimentosAutomaticosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>(ProcedimentosAutomaticosDocument, options);
        }
export type ProcedimentosAutomaticosQueryHookResult = ReturnType<typeof useProcedimentosAutomaticosQuery>;
export type ProcedimentosAutomaticosLazyQueryHookResult = ReturnType<typeof useProcedimentosAutomaticosLazyQuery>;
export type ProcedimentosAutomaticosSuspenseQueryHookResult = ReturnType<typeof useProcedimentosAutomaticosSuspenseQuery>;
export type ProcedimentosAutomaticosQueryResult = Apollo.QueryResult<Types.ProcedimentosAutomaticosQuery, Types.ProcedimentosAutomaticosQueryVariables>;
export const ProcedimentosObrigatoriedadeParticipacaoDocument = gql`
    query ProcedimentosObrigatoriedadeParticipacao {
  procedimentosObrigatoriedadeParticipacao {
    sigtapsCidadaoObrigatorio
    sigtapsProfissionalObrigatorio
    sigtapsCidadaoEProfissionalObrigatorios
  }
}
    `;

/**
 * __useProcedimentosObrigatoriedadeParticipacaoQuery__
 *
 * To run a query within a React component, call `useProcedimentosObrigatoriedadeParticipacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentosObrigatoriedadeParticipacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentosObrigatoriedadeParticipacaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcedimentosObrigatoriedadeParticipacaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>(ProcedimentosObrigatoriedadeParticipacaoDocument, options);
      }
export function useProcedimentosObrigatoriedadeParticipacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>(ProcedimentosObrigatoriedadeParticipacaoDocument, options);
        }
export function useProcedimentosObrigatoriedadeParticipacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>(ProcedimentosObrigatoriedadeParticipacaoDocument, options);
        }
export type ProcedimentosObrigatoriedadeParticipacaoQueryHookResult = ReturnType<typeof useProcedimentosObrigatoriedadeParticipacaoQuery>;
export type ProcedimentosObrigatoriedadeParticipacaoLazyQueryHookResult = ReturnType<typeof useProcedimentosObrigatoriedadeParticipacaoLazyQuery>;
export type ProcedimentosObrigatoriedadeParticipacaoSuspenseQueryHookResult = ReturnType<typeof useProcedimentosObrigatoriedadeParticipacaoSuspenseQuery>;
export type ProcedimentosObrigatoriedadeParticipacaoQueryResult = Apollo.QueryResult<Types.ProcedimentosObrigatoriedadeParticipacaoQuery, Types.ProcedimentosObrigatoriedadeParticipacaoQueryVariables>;
export const RegistroAvaliacaoPuericulturaDocument = gql`
    query RegistroAvaliacaoPuericultura {
  registroAvaliacaoPuericultura {
    ciap {
      ...Ciap
    }
    cid10 {
      ...Cid10
    }
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}`;

/**
 * __useRegistroAvaliacaoPuericulturaQuery__
 *
 * To run a query within a React component, call `useRegistroAvaliacaoPuericulturaQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistroAvaliacaoPuericulturaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistroAvaliacaoPuericulturaQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistroAvaliacaoPuericulturaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>(RegistroAvaliacaoPuericulturaDocument, options);
      }
export function useRegistroAvaliacaoPuericulturaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>(RegistroAvaliacaoPuericulturaDocument, options);
        }
export function useRegistroAvaliacaoPuericulturaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>(RegistroAvaliacaoPuericulturaDocument, options);
        }
export type RegistroAvaliacaoPuericulturaQueryHookResult = ReturnType<typeof useRegistroAvaliacaoPuericulturaQuery>;
export type RegistroAvaliacaoPuericulturaLazyQueryHookResult = ReturnType<typeof useRegistroAvaliacaoPuericulturaLazyQuery>;
export type RegistroAvaliacaoPuericulturaSuspenseQueryHookResult = ReturnType<typeof useRegistroAvaliacaoPuericulturaSuspenseQuery>;
export type RegistroAvaliacaoPuericulturaQueryResult = Apollo.QueryResult<Types.RegistroAvaliacaoPuericulturaQuery, Types.RegistroAvaliacaoPuericulturaQueryVariables>;
export const SalvarAtendimentoIndividualDocument = gql`
    mutation SalvarAtendimentoIndividual($input: AtendimentoIndividualInput!) {
  salvarAtendimentoIndividual(input: $input) {
    atendProf {
      id
    }
    agendamentosCriadosIds
  }
}
    `;
export type SalvarAtendimentoIndividualMutationFn = Apollo.MutationFunction<Types.SalvarAtendimentoIndividualMutation, Types.SalvarAtendimentoIndividualMutationVariables>;

/**
 * __useSalvarAtendimentoIndividualMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoIndividualMutation, { data, loading, error }] = useSalvarAtendimentoIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoIndividualMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtendimentoIndividualMutation, Types.SalvarAtendimentoIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtendimentoIndividualMutation, Types.SalvarAtendimentoIndividualMutationVariables>(SalvarAtendimentoIndividualDocument, options);
      }
export type SalvarAtendimentoIndividualMutationHookResult = ReturnType<typeof useSalvarAtendimentoIndividualMutation>;
export type SalvarAtendimentoIndividualMutationResult = Apollo.MutationResult<Types.SalvarAtendimentoIndividualMutation>;
export type SalvarAtendimentoIndividualMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtendimentoIndividualMutation, Types.SalvarAtendimentoIndividualMutationVariables>;
export const SalvarAtendimentoIndividualParaAprovacaoDocument = gql`
    mutation SalvarAtendimentoIndividualParaAprovacao($input: AtendimentoIndividualAprovacaoInput!) {
  salvarAtendimentoIndividualParaAprovacao(input: $input)
}
    `;
export type SalvarAtendimentoIndividualParaAprovacaoMutationFn = Apollo.MutationFunction<Types.SalvarAtendimentoIndividualParaAprovacaoMutation, Types.SalvarAtendimentoIndividualParaAprovacaoMutationVariables>;

/**
 * __useSalvarAtendimentoIndividualParaAprovacaoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoIndividualParaAprovacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoIndividualParaAprovacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoIndividualParaAprovacaoMutation, { data, loading, error }] = useSalvarAtendimentoIndividualParaAprovacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoIndividualParaAprovacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtendimentoIndividualParaAprovacaoMutation, Types.SalvarAtendimentoIndividualParaAprovacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtendimentoIndividualParaAprovacaoMutation, Types.SalvarAtendimentoIndividualParaAprovacaoMutationVariables>(SalvarAtendimentoIndividualParaAprovacaoDocument, options);
      }
export type SalvarAtendimentoIndividualParaAprovacaoMutationHookResult = ReturnType<typeof useSalvarAtendimentoIndividualParaAprovacaoMutation>;
export type SalvarAtendimentoIndividualParaAprovacaoMutationResult = Apollo.MutationResult<Types.SalvarAtendimentoIndividualParaAprovacaoMutation>;
export type SalvarAtendimentoIndividualParaAprovacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtendimentoIndividualParaAprovacaoMutation, Types.SalvarAtendimentoIndividualParaAprovacaoMutationVariables>;
export const AtendimentoObservacaoViewDocument = gql`
    query AtendimentoObservacaoView($atendimentoId: ID!) {
  atendimento(id: $atendimentoId) {
    id
    atendimentoProfissional {
      id
      atestados {
        id
        descricao
        tipo
        assinadoDigitalmente
      }
      encaminhamentos
      encaminhamentosEspecializados {
        ...EncaminhamentoExternoEspecializado
      }
      guiasEncaminhamento {
        ...GuiasEncaminhamento
      }
      orientacoes {
        id
        descricao
      }
      requisicoesExames {
        ...SolicitacaoExame
      }
      solicitacoesOci {
        ...SolicitacaoExame
      }
      examesResultados {
        ...ResultadoExame
      }
      receitaMedicamento {
        id
        quantidadeReceitada
        recomendacoes
        qtDose
        unidadeMedidaDose {
          id
          nome
          nomePlural
        }
        frequenciaDose
        posologia
        tipoFrequenciaDose
        qtPeriodoFrequencia
        medidaTempoFrequencia
        qtDuracaoTratamento
        medidaTempoTratamento
        usoContinuo
        registroManual
        doseUnica
        tipoReceita
        tratamentoInterrompido
        justificativaInterrupcao
        dtInterrupcao
        receitaUsoContinuoGrupo {
          id
          dtInicioTratamento
        }
        cid10 {
          ...Cid10
          ativo
        }
        ciap {
          ...Ciap
        }
        codigoPrescricaoDigital
        aplicacaoMedicamento {
          id
          nome
        }
        medicamento {
          id
          concentracao
          principioAtivo
          principioAtivoFiltro
          unidadeFornecimento
          formaFarmaceutica {
            id
            nome
            ativo
          }
          medicamentoCatmat {
            id
            ativo
            volume
            codigoCatMat
            codigoRename
            unidadeFornecimento {
              id
              nome
              nomePlural
            }
            principioAtivo {
              id
              nome
              listaMaterial {
                id
                tipo
                tipoReceita
              }
            }
          }
        }
      }
      evolucaoProblema {
        id
        situacao
        observacao
        possuiCid
        possuiCiap
        dataInicio
        dataFim
        atualizadoEm
        problema {
          ...ProblemaCondicao
        }
      }
      evolucaoSubjetivo {
        id
        descricao
        ciaps {
          id
          ciap {
            ...Ciap
          }
          nota
        }
      }
      evolucaoAvaliacao {
        id
        descricao
        ciapsCids {
          id
          nota
          isCiapCidNaListaDeProblemas
          ciap {
            ...Ciap
          }
          cid10 {
            ...Cid10
          }
          cid11 {
            ...Cid11
          }
        }
      }
      evolucaoObjetivo {
        id
        descricao
      }
      evolucaoPlano {
        id
        descricao
        intervencoesProcedimentos {
          id
          nota
          ciap {
            ...Ciap
          }
          procedimento {
            ...Procedimento
          }
        }
      }
      tipoAtendimento
      condutas
      racionalidadeSaude
      tipoParticipacaoCidadao
      tipoParticipacaoProfissionalConvidado
      notificacoesCasoSuspeito {
        id
        notificacao {
          id
          nomeNotificacao
        }
      }
      lotacaoAtendimentoCompartilhado {
        ...LotacaoAtendimentoCompartilhado
      }
      procedimentosAtendimento {
        id
        procedimento {
          id
          descricao
          codigo
        }
        automatico
      }
      marcadorConsumoAlimentar {
        id
        categoria
        respostas {
          pergunta
          opcoesSelecionadas
        }
      }
    }
  }
}
    ${EncaminhamentoExternoEspecializadoFragmentDoc}
${GuiasEncaminhamentoFragmentDoc}
${SolicitacaoExameFragmentDoc}
${ResultadoExameFragmentDoc}
${Cid10FragmentDoc}
${CiapFragmentDoc}
${ProblemaCondicaoFragmentDoc}
${Cid11FragmentDoc}
${ProcedimentoFragmentDoc}
${LotacaoAtendimentoCompartilhadoFragmentDoc}`;

/**
 * __useAtendimentoObservacaoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoObservacaoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoObservacaoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoObservacaoViewQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useAtendimentoObservacaoViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables> & ({ variables: Types.AtendimentoObservacaoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>(AtendimentoObservacaoViewDocument, options);
      }
export function useAtendimentoObservacaoViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>(AtendimentoObservacaoViewDocument, options);
        }
export function useAtendimentoObservacaoViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>(AtendimentoObservacaoViewDocument, options);
        }
export type AtendimentoObservacaoViewQueryHookResult = ReturnType<typeof useAtendimentoObservacaoViewQuery>;
export type AtendimentoObservacaoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoObservacaoViewLazyQuery>;
export type AtendimentoObservacaoViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoObservacaoViewSuspenseQuery>;
export type AtendimentoObservacaoViewQueryResult = Apollo.QueryResult<Types.AtendimentoObservacaoViewQuery, Types.AtendimentoObservacaoViewQueryVariables>;
export const SalvarAtendimentoVacinacaoParaAprovacaoDocument = gql`
    mutation SalvarAtendimentoVacinacaoParaAprovacao($input: AtendimentoVacinacaoAprovacaoInput!) {
  salvarAtendimentoVacinacaoParaAprovacao(input: $input)
}
    `;
export type SalvarAtendimentoVacinacaoParaAprovacaoMutationFn = Apollo.MutationFunction<Types.SalvarAtendimentoVacinacaoParaAprovacaoMutation, Types.SalvarAtendimentoVacinacaoParaAprovacaoMutationVariables>;

/**
 * __useSalvarAtendimentoVacinacaoParaAprovacaoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoVacinacaoParaAprovacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoVacinacaoParaAprovacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoVacinacaoParaAprovacaoMutation, { data, loading, error }] = useSalvarAtendimentoVacinacaoParaAprovacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoVacinacaoParaAprovacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtendimentoVacinacaoParaAprovacaoMutation, Types.SalvarAtendimentoVacinacaoParaAprovacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtendimentoVacinacaoParaAprovacaoMutation, Types.SalvarAtendimentoVacinacaoParaAprovacaoMutationVariables>(SalvarAtendimentoVacinacaoParaAprovacaoDocument, options);
      }
export type SalvarAtendimentoVacinacaoParaAprovacaoMutationHookResult = ReturnType<typeof useSalvarAtendimentoVacinacaoParaAprovacaoMutation>;
export type SalvarAtendimentoVacinacaoParaAprovacaoMutationResult = Apollo.MutationResult<Types.SalvarAtendimentoVacinacaoParaAprovacaoMutation>;
export type SalvarAtendimentoVacinacaoParaAprovacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtendimentoVacinacaoParaAprovacaoMutation, Types.SalvarAtendimentoVacinacaoParaAprovacaoMutationVariables>;
export const AtendimentoVacinacaoViewDocument = gql`
    query AtendimentoVacinacaoView($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    tipo
    iniciadoEm
    rascunho
    estagio {
      id
    }
    lotacao {
      id
      profissional {
        id
        cpf
        cns
        nome
      }
      cbo {
        id
        nome
        cbo2002
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
    }
    atendimento {
      id
      iniciadoEm
      statusAtendimento
      statusRevisaoAtendimento
      agendado {
        id
        lotacaoAgendada {
          id
        }
      }
      isRegistroTardio
      cidadao {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        sexo
        nomeMae
        area
        microArea
        identidadeGeneroDbEnum
        stCompartilhaProntuario
      }
      tiposServico {
        id
      }
      prontuario {
        id
        gestacoes {
          id
          inicio
          fim
        }
        preNatalAtivo {
          id
          ultimaDum
        }
        puerpera
      }
    }
  }
}
    `;

/**
 * __useAtendimentoVacinacaoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoVacinacaoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoVacinacaoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoVacinacaoViewQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoVacinacaoViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables> & ({ variables: Types.AtendimentoVacinacaoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>(AtendimentoVacinacaoViewDocument, options);
      }
export function useAtendimentoVacinacaoViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>(AtendimentoVacinacaoViewDocument, options);
        }
export function useAtendimentoVacinacaoViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>(AtendimentoVacinacaoViewDocument, options);
        }
export type AtendimentoVacinacaoViewQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoViewQuery>;
export type AtendimentoVacinacaoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoViewLazyQuery>;
export type AtendimentoVacinacaoViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoViewSuspenseQuery>;
export type AtendimentoVacinacaoViewQueryResult = Apollo.QueryResult<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>;
export const EsquemaCalendarioVacinalDocument = gql`
    query EsquemaCalendarioVacinal($input: EsquemaCalendarioVacinalQueryInput!) {
  esquemaCalendarioVacinal(input: $input) {
    id
    descricaoImunobiologico
    idadeRecomendada
    mostrarNoCalendarioDoGrupo
    imunobiologico {
      id
      sigla
      nome
    }
    dose {
      id
      nomeApresentacaoDose
      sigla
      nome
      ordem
    }
    faixaEtaria {
      id
      diasInicio
      diasFim
      descricao
    }
    ordemImuno
  }
}
    `;

/**
 * __useEsquemaCalendarioVacinalQuery__
 *
 * To run a query within a React component, call `useEsquemaCalendarioVacinalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsquemaCalendarioVacinalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsquemaCalendarioVacinalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEsquemaCalendarioVacinalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables> & ({ variables: Types.EsquemaCalendarioVacinalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>(EsquemaCalendarioVacinalDocument, options);
      }
export function useEsquemaCalendarioVacinalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>(EsquemaCalendarioVacinalDocument, options);
        }
export function useEsquemaCalendarioVacinalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>(EsquemaCalendarioVacinalDocument, options);
        }
export type EsquemaCalendarioVacinalQueryHookResult = ReturnType<typeof useEsquemaCalendarioVacinalQuery>;
export type EsquemaCalendarioVacinalLazyQueryHookResult = ReturnType<typeof useEsquemaCalendarioVacinalLazyQuery>;
export type EsquemaCalendarioVacinalSuspenseQueryHookResult = ReturnType<typeof useEsquemaCalendarioVacinalSuspenseQuery>;
export type EsquemaCalendarioVacinalQueryResult = Apollo.QueryResult<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>;
export const FaixaEtariaVacinacaoDocument = gql`
    query FaixaEtariaVacinacao($input: FaixaEtariaVacinacaoQueryInput!) {
  faixaEtariaVacinacao(input: $input) {
    id
    diasInicio
    diasFim
    descricao
  }
}
    `;

/**
 * __useFaixaEtariaVacinacaoQuery__
 *
 * To run a query within a React component, call `useFaixaEtariaVacinacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaixaEtariaVacinacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaixaEtariaVacinacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFaixaEtariaVacinacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables> & ({ variables: Types.FaixaEtariaVacinacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>(FaixaEtariaVacinacaoDocument, options);
      }
export function useFaixaEtariaVacinacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>(FaixaEtariaVacinacaoDocument, options);
        }
export function useFaixaEtariaVacinacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>(FaixaEtariaVacinacaoDocument, options);
        }
export type FaixaEtariaVacinacaoQueryHookResult = ReturnType<typeof useFaixaEtariaVacinacaoQuery>;
export type FaixaEtariaVacinacaoLazyQueryHookResult = ReturnType<typeof useFaixaEtariaVacinacaoLazyQuery>;
export type FaixaEtariaVacinacaoSuspenseQueryHookResult = ReturnType<typeof useFaixaEtariaVacinacaoSuspenseQuery>;
export type FaixaEtariaVacinacaoQueryResult = Apollo.QueryResult<Types.FaixaEtariaVacinacaoQuery, Types.FaixaEtariaVacinacaoQueryVariables>;
export const HasVacinaAtrasadaDocument = gql`
    query HasVacinaAtrasada($input: VacinacaoUltimaVacinaInput!) {
  hasVacinaAtrasada(input: $input)
}
    `;

/**
 * __useHasVacinaAtrasadaQuery__
 *
 * To run a query within a React component, call `useHasVacinaAtrasadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasVacinaAtrasadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasVacinaAtrasadaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasVacinaAtrasadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables> & ({ variables: Types.HasVacinaAtrasadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>(HasVacinaAtrasadaDocument, options);
      }
export function useHasVacinaAtrasadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>(HasVacinaAtrasadaDocument, options);
        }
export function useHasVacinaAtrasadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>(HasVacinaAtrasadaDocument, options);
        }
export type HasVacinaAtrasadaQueryHookResult = ReturnType<typeof useHasVacinaAtrasadaQuery>;
export type HasVacinaAtrasadaLazyQueryHookResult = ReturnType<typeof useHasVacinaAtrasadaLazyQuery>;
export type HasVacinaAtrasadaSuspenseQueryHookResult = ReturnType<typeof useHasVacinaAtrasadaSuspenseQuery>;
export type HasVacinaAtrasadaQueryResult = Apollo.QueryResult<Types.HasVacinaAtrasadaQuery, Types.HasVacinaAtrasadaQueryVariables>;
export const ProximaDoseAprazamentoDocument = gql`
    query ProximaDoseAprazamento($input: ProximaDoseAprazamentoQueryInput!) {
  proximaDoseAprazamentoAutomatico(input: $input) {
    diasAprazamento
    proximaDoseId
    proximaDoseSigla
    proximaDoseNome
  }
}
    `;

/**
 * __useProximaDoseAprazamentoQuery__
 *
 * To run a query within a React component, call `useProximaDoseAprazamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProximaDoseAprazamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProximaDoseAprazamentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProximaDoseAprazamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables> & ({ variables: Types.ProximaDoseAprazamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>(ProximaDoseAprazamentoDocument, options);
      }
export function useProximaDoseAprazamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>(ProximaDoseAprazamentoDocument, options);
        }
export function useProximaDoseAprazamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>(ProximaDoseAprazamentoDocument, options);
        }
export type ProximaDoseAprazamentoQueryHookResult = ReturnType<typeof useProximaDoseAprazamentoQuery>;
export type ProximaDoseAprazamentoLazyQueryHookResult = ReturnType<typeof useProximaDoseAprazamentoLazyQuery>;
export type ProximaDoseAprazamentoSuspenseQueryHookResult = ReturnType<typeof useProximaDoseAprazamentoSuspenseQuery>;
export type ProximaDoseAprazamentoQueryResult = Apollo.QueryResult<Types.ProximaDoseAprazamentoQuery, Types.ProximaDoseAprazamentoQueryVariables>;
export const RegistrosAplicadosVacinacaoDocument = gql`
    query RegistrosAplicadosVacinacao($input: RegistrosAplicadosVacinacaoInput!) {
  registrosAplicadosVacinacao(input: $input) {
    imunobiologicoId
    imunobiologicoSigla
    imunobiologicoNome
    doseId
    doseNomeApresentacao
    doseNome
    doseSigla
    dataAprazamento
    dataAplicacao
    quantidadeAplicacoes
    dataRegistroAprazamento
    estrategiaId
    isRegistroAnterior
  }
}
    `;

/**
 * __useRegistrosAplicadosVacinacaoQuery__
 *
 * To run a query within a React component, call `useRegistrosAplicadosVacinacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrosAplicadosVacinacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrosAplicadosVacinacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrosAplicadosVacinacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables> & ({ variables: Types.RegistrosAplicadosVacinacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>(RegistrosAplicadosVacinacaoDocument, options);
      }
export function useRegistrosAplicadosVacinacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>(RegistrosAplicadosVacinacaoDocument, options);
        }
export function useRegistrosAplicadosVacinacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>(RegistrosAplicadosVacinacaoDocument, options);
        }
export type RegistrosAplicadosVacinacaoQueryHookResult = ReturnType<typeof useRegistrosAplicadosVacinacaoQuery>;
export type RegistrosAplicadosVacinacaoLazyQueryHookResult = ReturnType<typeof useRegistrosAplicadosVacinacaoLazyQuery>;
export type RegistrosAplicadosVacinacaoSuspenseQueryHookResult = ReturnType<typeof useRegistrosAplicadosVacinacaoSuspenseQuery>;
export type RegistrosAplicadosVacinacaoQueryResult = Apollo.QueryResult<Types.RegistrosAplicadosVacinacaoQuery, Types.RegistrosAplicadosVacinacaoQueryVariables>;
export const RetificarAtendimentoVacinacaoDocument = gql`
    mutation RetificarAtendimentoVacinacao($input: RetificacaoAtendimentoVacinacaoInput!) {
  retificarAtendimentoVacinacao(input: $input)
}
    `;
export type RetificarAtendimentoVacinacaoMutationFn = Apollo.MutationFunction<Types.RetificarAtendimentoVacinacaoMutation, Types.RetificarAtendimentoVacinacaoMutationVariables>;

/**
 * __useRetificarAtendimentoVacinacaoMutation__
 *
 * To run a mutation, you first call `useRetificarAtendimentoVacinacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetificarAtendimentoVacinacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retificarAtendimentoVacinacaoMutation, { data, loading, error }] = useRetificarAtendimentoVacinacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetificarAtendimentoVacinacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RetificarAtendimentoVacinacaoMutation, Types.RetificarAtendimentoVacinacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RetificarAtendimentoVacinacaoMutation, Types.RetificarAtendimentoVacinacaoMutationVariables>(RetificarAtendimentoVacinacaoDocument, options);
      }
export type RetificarAtendimentoVacinacaoMutationHookResult = ReturnType<typeof useRetificarAtendimentoVacinacaoMutation>;
export type RetificarAtendimentoVacinacaoMutationResult = Apollo.MutationResult<Types.RetificarAtendimentoVacinacaoMutation>;
export type RetificarAtendimentoVacinacaoMutationOptions = Apollo.BaseMutationOptions<Types.RetificarAtendimentoVacinacaoMutation, Types.RetificarAtendimentoVacinacaoMutationVariables>;
export const SalvarAtendimentoVacinacaoDocument = gql`
    mutation SalvarAtendimentoVacinacao($input: AtendimentoVacinacaoInput!) {
  salvarAtendimentoVacinacao(input: $input) {
    id
    atendimentoProfissional {
      id
    }
  }
}
    `;
export type SalvarAtendimentoVacinacaoMutationFn = Apollo.MutationFunction<Types.SalvarAtendimentoVacinacaoMutation, Types.SalvarAtendimentoVacinacaoMutationVariables>;

/**
 * __useSalvarAtendimentoVacinacaoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoVacinacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoVacinacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoVacinacaoMutation, { data, loading, error }] = useSalvarAtendimentoVacinacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoVacinacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtendimentoVacinacaoMutation, Types.SalvarAtendimentoVacinacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtendimentoVacinacaoMutation, Types.SalvarAtendimentoVacinacaoMutationVariables>(SalvarAtendimentoVacinacaoDocument, options);
      }
export type SalvarAtendimentoVacinacaoMutationHookResult = ReturnType<typeof useSalvarAtendimentoVacinacaoMutation>;
export type SalvarAtendimentoVacinacaoMutationResult = Apollo.MutationResult<Types.SalvarAtendimentoVacinacaoMutation>;
export type SalvarAtendimentoVacinacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtendimentoVacinacaoMutation, Types.SalvarAtendimentoVacinacaoMutationVariables>;
export const UltimaVacinaAprazadaDocument = gql`
    query UltimaVacinaAprazada($input: VacinacaoUltimaVacinaInput!) {
  ultimaVacinaAprazada(input: $input) {
    imunobiologicoNome
    dataAprazamento
    doseNomeApresentacao
  }
}
    `;

/**
 * __useUltimaVacinaAprazadaQuery__
 *
 * To run a query within a React component, call `useUltimaVacinaAprazadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimaVacinaAprazadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimaVacinaAprazadaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimaVacinaAprazadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables> & ({ variables: Types.UltimaVacinaAprazadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>(UltimaVacinaAprazadaDocument, options);
      }
export function useUltimaVacinaAprazadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>(UltimaVacinaAprazadaDocument, options);
        }
export function useUltimaVacinaAprazadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>(UltimaVacinaAprazadaDocument, options);
        }
export type UltimaVacinaAprazadaQueryHookResult = ReturnType<typeof useUltimaVacinaAprazadaQuery>;
export type UltimaVacinaAprazadaLazyQueryHookResult = ReturnType<typeof useUltimaVacinaAprazadaLazyQuery>;
export type UltimaVacinaAprazadaSuspenseQueryHookResult = ReturnType<typeof useUltimaVacinaAprazadaSuspenseQuery>;
export type UltimaVacinaAprazadaQueryResult = Apollo.QueryResult<Types.UltimaVacinaAprazadaQuery, Types.UltimaVacinaAprazadaQueryVariables>;
export const UltimasTresVacinasAplicadasDocument = gql`
    query UltimasTresVacinasAplicadas($input: VacinacaoUltimaVacinaInput!) {
  ultimasTresVacinasAplicadas(input: $input) {
    imunobiologicoNome
    dataAplicacao
    doseNomeApresentacao
  }
}
    `;

/**
 * __useUltimasTresVacinasAplicadasQuery__
 *
 * To run a query within a React component, call `useUltimasTresVacinasAplicadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimasTresVacinasAplicadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimasTresVacinasAplicadasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimasTresVacinasAplicadasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables> & ({ variables: Types.UltimasTresVacinasAplicadasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>(UltimasTresVacinasAplicadasDocument, options);
      }
export function useUltimasTresVacinasAplicadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>(UltimasTresVacinasAplicadasDocument, options);
        }
export function useUltimasTresVacinasAplicadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>(UltimasTresVacinasAplicadasDocument, options);
        }
export type UltimasTresVacinasAplicadasQueryHookResult = ReturnType<typeof useUltimasTresVacinasAplicadasQuery>;
export type UltimasTresVacinasAplicadasLazyQueryHookResult = ReturnType<typeof useUltimasTresVacinasAplicadasLazyQuery>;
export type UltimasTresVacinasAplicadasSuspenseQueryHookResult = ReturnType<typeof useUltimasTresVacinasAplicadasSuspenseQuery>;
export type UltimasTresVacinasAplicadasQueryResult = Apollo.QueryResult<Types.UltimasTresVacinasAplicadasQuery, Types.UltimasTresVacinasAplicadasQueryVariables>;
export const MedicoesPacEmAtendimentoObservacaoDocument = gql`
    query MedicoesPacEmAtendimentoObservacao($id: ID!) {
  atendimentoIndividual(id: $id) {
    id
    medicoes {
      id
      pele
      olhoDireito
      olhoEsquerdo
      ouvidoDireito
      ouvidoEsquerdo
      valorForcaMuscMaoDireita
      unidadeForcaMuscMaoDireita
      valorForcaMuscMaoEsquerda
      unidadeForcaMuscMaoEsquerda
      membroInferiorDireito
      membroInferiorEsquerdo
      medicaoAnterior
    }
  }
}
    `;

/**
 * __useMedicoesPacEmAtendimentoObservacaoQuery__
 *
 * To run a query within a React component, call `useMedicoesPacEmAtendimentoObservacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesPacEmAtendimentoObservacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesPacEmAtendimentoObservacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicoesPacEmAtendimentoObservacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables> & ({ variables: Types.MedicoesPacEmAtendimentoObservacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>(MedicoesPacEmAtendimentoObservacaoDocument, options);
      }
export function useMedicoesPacEmAtendimentoObservacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>(MedicoesPacEmAtendimentoObservacaoDocument, options);
        }
export function useMedicoesPacEmAtendimentoObservacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>(MedicoesPacEmAtendimentoObservacaoDocument, options);
        }
export type MedicoesPacEmAtendimentoObservacaoQueryHookResult = ReturnType<typeof useMedicoesPacEmAtendimentoObservacaoQuery>;
export type MedicoesPacEmAtendimentoObservacaoLazyQueryHookResult = ReturnType<typeof useMedicoesPacEmAtendimentoObservacaoLazyQuery>;
export type MedicoesPacEmAtendimentoObservacaoSuspenseQueryHookResult = ReturnType<typeof useMedicoesPacEmAtendimentoObservacaoSuspenseQuery>;
export type MedicoesPacEmAtendimentoObservacaoQueryResult = Apollo.QueryResult<Types.MedicoesPacEmAtendimentoObservacaoQuery, Types.MedicoesPacEmAtendimentoObservacaoQueryVariables>;
export const AcessoConectesusRndsDocument = gql`
    mutation acessoConectesusRnds($input: AcessoConecteSusInput!) {
  acessoConecteSus(input: $input)
}
    `;
export type AcessoConectesusRndsMutationFn = Apollo.MutationFunction<Types.AcessoConectesusRndsMutation, Types.AcessoConectesusRndsMutationVariables>;

/**
 * __useAcessoConectesusRndsMutation__
 *
 * To run a mutation, you first call `useAcessoConectesusRndsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcessoConectesusRndsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acessoConectesusRndsMutation, { data, loading, error }] = useAcessoConectesusRndsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcessoConectesusRndsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AcessoConectesusRndsMutation, Types.AcessoConectesusRndsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AcessoConectesusRndsMutation, Types.AcessoConectesusRndsMutationVariables>(AcessoConectesusRndsDocument, options);
      }
export type AcessoConectesusRndsMutationHookResult = ReturnType<typeof useAcessoConectesusRndsMutation>;
export type AcessoConectesusRndsMutationResult = Apollo.MutationResult<Types.AcessoConectesusRndsMutation>;
export type AcessoConectesusRndsMutationOptions = Apollo.BaseMutationOptions<Types.AcessoConectesusRndsMutation, Types.AcessoConectesusRndsMutationVariables>;
export const AtendimentoProfissionalViewDocument = gql`
    query AtendimentoProfissionalView($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    tipo
    lotacao {
      id
    }
    estagio {
      id
    }
    atendimento {
      id
      statusAtendimento
      isRegistroTardio
    }
  }
}
    `;

/**
 * __useAtendimentoProfissionalViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoProfissionalViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoProfissionalViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoProfissionalViewQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoProfissionalViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables> & ({ variables: Types.AtendimentoProfissionalViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>(AtendimentoProfissionalViewDocument, options);
      }
export function useAtendimentoProfissionalViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>(AtendimentoProfissionalViewDocument, options);
        }
export function useAtendimentoProfissionalViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>(AtendimentoProfissionalViewDocument, options);
        }
export type AtendimentoProfissionalViewQueryHookResult = ReturnType<typeof useAtendimentoProfissionalViewQuery>;
export type AtendimentoProfissionalViewLazyQueryHookResult = ReturnType<typeof useAtendimentoProfissionalViewLazyQuery>;
export type AtendimentoProfissionalViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoProfissionalViewSuspenseQuery>;
export type AtendimentoProfissionalViewQueryResult = Apollo.QueryResult<Types.AtendimentoProfissionalViewQuery, Types.AtendimentoProfissionalViewQueryVariables>;
export const AtendimentoViewDocument = gql`
    query AtendimentoView($id: ID!) {
  atendimento(id: $id) {
    id
    statusAtendimento
    isRegistroTardio
    atendimentoProfissional {
      id
      tipo
      lotacao {
        id
      }
      estagio {
        id
      }
    }
  }
}
    `;

/**
 * __useAtendimentoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentoViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables> & ({ variables: Types.AtendimentoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>(AtendimentoViewDocument, options);
      }
export function useAtendimentoViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>(AtendimentoViewDocument, options);
        }
export function useAtendimentoViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>(AtendimentoViewDocument, options);
        }
export type AtendimentoViewQueryHookResult = ReturnType<typeof useAtendimentoViewQuery>;
export type AtendimentoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoViewLazyQuery>;
export type AtendimentoViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoViewSuspenseQuery>;
export type AtendimentoViewQueryResult = Apollo.QueryResult<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>;
export const CancelarAtendimentoDocument = gql`
    mutation CancelarAtendimento($atendimentoId: ID!) {
  cancelarAtendimento(atendimento: $atendimentoId) {
    id
  }
}
    `;
export type CancelarAtendimentoMutationFn = Apollo.MutationFunction<Types.CancelarAtendimentoMutation, Types.CancelarAtendimentoMutationVariables>;

/**
 * __useCancelarAtendimentoMutation__
 *
 * To run a mutation, you first call `useCancelarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarAtendimentoMutation, { data, loading, error }] = useCancelarAtendimentoMutation({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useCancelarAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelarAtendimentoMutation, Types.CancelarAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelarAtendimentoMutation, Types.CancelarAtendimentoMutationVariables>(CancelarAtendimentoDocument, options);
      }
export type CancelarAtendimentoMutationHookResult = ReturnType<typeof useCancelarAtendimentoMutation>;
export type CancelarAtendimentoMutationResult = Apollo.MutationResult<Types.CancelarAtendimentoMutation>;
export type CancelarAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.CancelarAtendimentoMutation, Types.CancelarAtendimentoMutationVariables>;
export const RascunhoAtendimentoDocument = gql`
    query RascunhoAtendimento($id: ID!) {
  atendimento(id: $id) {
    id
    atendimentoProfissional {
      id
      rascunho
    }
  }
}
    `;

/**
 * __useRascunhoAtendimentoQuery__
 *
 * To run a query within a React component, call `useRascunhoAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRascunhoAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRascunhoAtendimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRascunhoAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables> & ({ variables: Types.RascunhoAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>(RascunhoAtendimentoDocument, options);
      }
export function useRascunhoAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>(RascunhoAtendimentoDocument, options);
        }
export function useRascunhoAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>(RascunhoAtendimentoDocument, options);
        }
export type RascunhoAtendimentoQueryHookResult = ReturnType<typeof useRascunhoAtendimentoQuery>;
export type RascunhoAtendimentoLazyQueryHookResult = ReturnType<typeof useRascunhoAtendimentoLazyQuery>;
export type RascunhoAtendimentoSuspenseQueryHookResult = ReturnType<typeof useRascunhoAtendimentoSuspenseQuery>;
export type RascunhoAtendimentoQueryResult = Apollo.QueryResult<Types.RascunhoAtendimentoQuery, Types.RascunhoAtendimentoQueryVariables>;
export const RegistrosDoseVacinacaoDocument = gql`
    query RegistrosDoseVacinacao($input: RegistrosDoseVacinacaoInput!) {
  registrosDoseVacinacao(input: $input) {
    lote
    viaAdministracao
    localAplicacao
    doseNome
    doseSigla
    estrategia
    estrategiaId
    dataAplicacao
    dataAprazamento
    dataRegistro
    dataValidadeLote
    profissional
    grupoAtendimento
    descricao
    fabricante
    codigoRndsFabricante
    siglaFabricante
    cbo
    condicaoMaternal
    isViajante
    isComunicanteHanseniase
    unidadeSaude
    origemDados
    isRegistroAnterior
    isAplicadoExterior
    isAplicacaoEquivalente
    cid10MotivoIndicacao
    cid10MotivoIndicacaoCodigoCid
    cboPrescritor
    isPesquisaClinica
    anvisaProtocoloEstudo
    anvisaProtocoloVersao
    anvisaNumeroRegistro
  }
}
    `;

/**
 * __useRegistrosDoseVacinacaoQuery__
 *
 * To run a query within a React component, call `useRegistrosDoseVacinacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrosDoseVacinacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrosDoseVacinacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrosDoseVacinacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables> & ({ variables: Types.RegistrosDoseVacinacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>(RegistrosDoseVacinacaoDocument, options);
      }
export function useRegistrosDoseVacinacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>(RegistrosDoseVacinacaoDocument, options);
        }
export function useRegistrosDoseVacinacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>(RegistrosDoseVacinacaoDocument, options);
        }
export type RegistrosDoseVacinacaoQueryHookResult = ReturnType<typeof useRegistrosDoseVacinacaoQuery>;
export type RegistrosDoseVacinacaoLazyQueryHookResult = ReturnType<typeof useRegistrosDoseVacinacaoLazyQuery>;
export type RegistrosDoseVacinacaoSuspenseQueryHookResult = ReturnType<typeof useRegistrosDoseVacinacaoSuspenseQuery>;
export type RegistrosDoseVacinacaoQueryResult = Apollo.QueryResult<Types.RegistrosDoseVacinacaoQuery, Types.RegistrosDoseVacinacaoQueryVariables>;
export const AcompanhamentoPreNatalCidadaoDocument = gql`
    query AcompanhamentoPreNatalCidadao($id: ID!) {
  cidadao(id: $id) {
    id
    prontuario {
      id
      preNatalAtivo {
        id
        altoRisco
        fonteIdadeGestacional
        tipoGravidez {
          id
          descricao
        }
        gravidezPlanejada
        ultimaDum
      }
      gestacoes {
        id
        inicio
        fim
      }
    }
    tipoSanguineoEnum
  }
}
    `;

/**
 * __useAcompanhamentoPreNatalCidadaoQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPreNatalCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPreNatalCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPreNatalCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcompanhamentoPreNatalCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables> & ({ variables: Types.AcompanhamentoPreNatalCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>(AcompanhamentoPreNatalCidadaoDocument, options);
      }
export function useAcompanhamentoPreNatalCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>(AcompanhamentoPreNatalCidadaoDocument, options);
        }
export function useAcompanhamentoPreNatalCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>(AcompanhamentoPreNatalCidadaoDocument, options);
        }
export type AcompanhamentoPreNatalCidadaoQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCidadaoQuery>;
export type AcompanhamentoPreNatalCidadaoLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCidadaoLazyQuery>;
export type AcompanhamentoPreNatalCidadaoSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCidadaoSuspenseQuery>;
export type AcompanhamentoPreNatalCidadaoQueryResult = Apollo.QueryResult<Types.AcompanhamentoPreNatalCidadaoQuery, Types.AcompanhamentoPreNatalCidadaoQueryVariables>;
export const AcompanhamentoPreNatalExamesDocument = gql`
    query AcompanhamentoPreNatalExames($input: ExamesPreNatalInput!) {
  acompanhamentoPreNatalExames(input: $input) {
    procedimentoId
    nomeProcedimento
    codigoProcedimento
    ultimaDataResultado
    status
    registrosNoTrimestre
  }
}
    `;

/**
 * __useAcompanhamentoPreNatalExamesQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPreNatalExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPreNatalExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPreNatalExamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoPreNatalExamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables> & ({ variables: Types.AcompanhamentoPreNatalExamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>(AcompanhamentoPreNatalExamesDocument, options);
      }
export function useAcompanhamentoPreNatalExamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>(AcompanhamentoPreNatalExamesDocument, options);
        }
export function useAcompanhamentoPreNatalExamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>(AcompanhamentoPreNatalExamesDocument, options);
        }
export type AcompanhamentoPreNatalExamesQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalExamesQuery>;
export type AcompanhamentoPreNatalExamesLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalExamesLazyQuery>;
export type AcompanhamentoPreNatalExamesSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalExamesSuspenseQuery>;
export type AcompanhamentoPreNatalExamesQueryResult = Apollo.QueryResult<Types.AcompanhamentoPreNatalExamesQuery, Types.AcompanhamentoPreNatalExamesQueryVariables>;
export const AcompanhamentoPreNatalVacinacaoDocument = gql`
    query AcompanhamentoPreNatalVacinacao($input: AcompanhamentosVacinacaoInput!) {
  acompanhamentoPreNatalVacinacao(input: $input) {
    vacinasAplicadas {
      ...AcompanhamentoPreNatalVacinaFragment
    }
    vacinasAprazadas {
      ...AcompanhamentoPreNatalVacinaFragment
    }
    ultimaVacinaAplicadaCovid {
      ...AcompanhamentoPreNatalVacinaFragment
    }
    proximaVacinaAprazadaCovid {
      ...AcompanhamentoPreNatalVacinaFragment
    }
  }
}
    ${AcompanhamentoPreNatalVacinaFragmentFragmentDoc}`;

/**
 * __useAcompanhamentoPreNatalVacinacaoQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPreNatalVacinacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPreNatalVacinacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPreNatalVacinacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoPreNatalVacinacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables> & ({ variables: Types.AcompanhamentoPreNatalVacinacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>(AcompanhamentoPreNatalVacinacaoDocument, options);
      }
export function useAcompanhamentoPreNatalVacinacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>(AcompanhamentoPreNatalVacinacaoDocument, options);
        }
export function useAcompanhamentoPreNatalVacinacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>(AcompanhamentoPreNatalVacinacaoDocument, options);
        }
export type AcompanhamentoPreNatalVacinacaoQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalVacinacaoQuery>;
export type AcompanhamentoPreNatalVacinacaoLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalVacinacaoLazyQuery>;
export type AcompanhamentoPreNatalVacinacaoSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalVacinacaoSuspenseQuery>;
export type AcompanhamentoPreNatalVacinacaoQueryResult = Apollo.QueryResult<Types.AcompanhamentoPreNatalVacinacaoQuery, Types.AcompanhamentoPreNatalVacinacaoQueryVariables>;
export const AcompanhamentoUltimosContatosDocument = gql`
    query AcompanhamentoUltimosContatos($input: HistoricoQueryInput!) {
  historico(input: $input) {
    content {
      codigoUnicoRegistro
      origemAtendimento
      dataAtendimento
      tipoAtendProf
      tipoApresentacao
      isAtendRecente
      idAtendRecente
      hasMarcadorConsumoAlimentar
      profissional {
        id
        nome
        nomeCivil
        nomeSocial
      }
      cbo {
        id
        nome
      }
      equipe {
        ...EquipeBasico
      }
      hasObservacao
      cuidadoCompartilhado {
        ...HistoricoCuidadoCompartilhadoHeader
      }
      cuidadoCompartilhadoEvolucao {
        ...HistoricoCuidadoCompartilhadoEvolucaoHeader
      }
      ...CuidadoCompartilhadoDw
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${EquipeBasicoFragmentDoc}
${HistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${HistoricoCuidadoCompartilhadoEvolucaoHeaderFragmentDoc}
${CuidadoCompartilhadoDwFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoUltimosContatosQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoUltimosContatosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoUltimosContatosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoUltimosContatosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoUltimosContatosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables> & ({ variables: Types.AcompanhamentoUltimosContatosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>(AcompanhamentoUltimosContatosDocument, options);
      }
export function useAcompanhamentoUltimosContatosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>(AcompanhamentoUltimosContatosDocument, options);
        }
export function useAcompanhamentoUltimosContatosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>(AcompanhamentoUltimosContatosDocument, options);
        }
export type AcompanhamentoUltimosContatosQueryHookResult = ReturnType<typeof useAcompanhamentoUltimosContatosQuery>;
export type AcompanhamentoUltimosContatosLazyQueryHookResult = ReturnType<typeof useAcompanhamentoUltimosContatosLazyQuery>;
export type AcompanhamentoUltimosContatosSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoUltimosContatosSuspenseQuery>;
export type AcompanhamentoUltimosContatosQueryResult = Apollo.QueryResult<Types.AcompanhamentoUltimosContatosQuery, Types.AcompanhamentoUltimosContatosQueryVariables>;
export const AcompanhamentoPuerperioAtividadesColetivasDocument = gql`
    query AcompanhamentoPuerperioAtividadesColetivas($input: AtividadeColetivaQueryInput!, $cidadaoId: Long!) {
  atividadesColetivas(input: $input) {
    content {
      id
      uuid
      dataAtividade
      tipoAtividade
      turno
      lotacaoResponsavel {
        id
        profissional {
          id
          nome
          nomeSocial
        }
      }
      participante(cidadaoId: $cidadaoId) {
        id
        cidadao {
          id
          cpf
          cns
          nomeSocial
        }
      }
      observacao(cidadaoId: $cidadaoId) {
        id
        cidadao {
          id
          cpf
          cns
          nomeSocial
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoPuerperioAtividadesColetivasQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPuerperioAtividadesColetivasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPuerperioAtividadesColetivasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPuerperioAtividadesColetivasQuery({
 *   variables: {
 *      input: // value for 'input'
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useAcompanhamentoPuerperioAtividadesColetivasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables> & ({ variables: Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>(AcompanhamentoPuerperioAtividadesColetivasDocument, options);
      }
export function useAcompanhamentoPuerperioAtividadesColetivasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>(AcompanhamentoPuerperioAtividadesColetivasDocument, options);
        }
export function useAcompanhamentoPuerperioAtividadesColetivasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>(AcompanhamentoPuerperioAtividadesColetivasDocument, options);
        }
export type AcompanhamentoPuerperioAtividadesColetivasQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioAtividadesColetivasQuery>;
export type AcompanhamentoPuerperioAtividadesColetivasLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioAtividadesColetivasLazyQuery>;
export type AcompanhamentoPuerperioAtividadesColetivasSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioAtividadesColetivasSuspenseQuery>;
export type AcompanhamentoPuerperioAtividadesColetivasQueryResult = Apollo.QueryResult<Types.AcompanhamentoPuerperioAtividadesColetivasQuery, Types.AcompanhamentoPuerperioAtividadesColetivasQueryVariables>;
export const AcompanhamentoPuerperioExamesDocument = gql`
    query AcompanhamentoPuerperioExames($input: AcompanhamentosProntuarioInput!) {
  acompanhamentoPuerperioExames(input: $input) {
    content {
      procedimentoId
      nomeProcedimento
      codigoProcedimento
      ultimaDataRealizacao
      registros
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoPuerperioExamesQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPuerperioExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPuerperioExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPuerperioExamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoPuerperioExamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables> & ({ variables: Types.AcompanhamentoPuerperioExamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>(AcompanhamentoPuerperioExamesDocument, options);
      }
export function useAcompanhamentoPuerperioExamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>(AcompanhamentoPuerperioExamesDocument, options);
        }
export function useAcompanhamentoPuerperioExamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>(AcompanhamentoPuerperioExamesDocument, options);
        }
export type AcompanhamentoPuerperioExamesQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioExamesQuery>;
export type AcompanhamentoPuerperioExamesLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioExamesLazyQuery>;
export type AcompanhamentoPuerperioExamesSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioExamesSuspenseQuery>;
export type AcompanhamentoPuerperioExamesQueryResult = Apollo.QueryResult<Types.AcompanhamentoPuerperioExamesQuery, Types.AcompanhamentoPuerperioExamesQueryVariables>;
export const AcompanhamentoPuerperioMedicoesDocument = gql`
    query AcompanhamentoPuerperioMedicoes($prontuarioId: ID!, $ultimoRegistroComPeso: Boolean) {
  medicoes(
    input: {prontuarioId: $prontuarioId, ultimoRegistroComPeso: $ultimoRegistroComPeso}
  ) {
    id
    dataMedicao
    valorPeso
    valorAltura
    valorPressaoArterial
    atendimentoProfissional {
      id
      iniciadoEm
      lotacao {
        id
        profissional {
          id
          nome
        }
      }
    }
    medicaoAnterior
  }
}
    `;

/**
 * __useAcompanhamentoPuerperioMedicoesQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPuerperioMedicoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPuerperioMedicoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPuerperioMedicoesQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      ultimoRegistroComPeso: // value for 'ultimoRegistroComPeso'
 *   },
 * });
 */
export function useAcompanhamentoPuerperioMedicoesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables> & ({ variables: Types.AcompanhamentoPuerperioMedicoesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>(AcompanhamentoPuerperioMedicoesDocument, options);
      }
export function useAcompanhamentoPuerperioMedicoesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>(AcompanhamentoPuerperioMedicoesDocument, options);
        }
export function useAcompanhamentoPuerperioMedicoesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>(AcompanhamentoPuerperioMedicoesDocument, options);
        }
export type AcompanhamentoPuerperioMedicoesQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioMedicoesQuery>;
export type AcompanhamentoPuerperioMedicoesLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioMedicoesLazyQuery>;
export type AcompanhamentoPuerperioMedicoesSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioMedicoesSuspenseQuery>;
export type AcompanhamentoPuerperioMedicoesQueryResult = Apollo.QueryResult<Types.AcompanhamentoPuerperioMedicoesQuery, Types.AcompanhamentoPuerperioMedicoesQueryVariables>;
export const AcompanhamentoPuerperioVisitasDomiciliaresDocument = gql`
    query AcompanhamentoPuerperioVisitasDomiciliares($input: AcompanhamentosVisitasDomiciliaresInput!) {
  acompanhamentoPuerperioVisitasDomiciliares(input: $input) {
    content {
      id
      nuUuidFicha
      dataVisita
      cpfCidadao
      cnsCidadao
      origem
      turno {
        id
        descricao
      }
      dimensaoDesfechoVisita {
        id
        descricao
      }
      dimensaoProfissional {
        id
        nome
      }
      dimensaoCbo {
        id
        nome
      }
      dimensaoEquipe {
        id
        nome
        ine
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoPuerperioVisitasDomiciliaresQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPuerperioVisitasDomiciliaresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPuerperioVisitasDomiciliaresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPuerperioVisitasDomiciliaresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoPuerperioVisitasDomiciliaresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables> & ({ variables: Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>(AcompanhamentoPuerperioVisitasDomiciliaresDocument, options);
      }
export function useAcompanhamentoPuerperioVisitasDomiciliaresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>(AcompanhamentoPuerperioVisitasDomiciliaresDocument, options);
        }
export function useAcompanhamentoPuerperioVisitasDomiciliaresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>(AcompanhamentoPuerperioVisitasDomiciliaresDocument, options);
        }
export type AcompanhamentoPuerperioVisitasDomiciliaresQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioVisitasDomiciliaresQuery>;
export type AcompanhamentoPuerperioVisitasDomiciliaresLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioVisitasDomiciliaresLazyQuery>;
export type AcompanhamentoPuerperioVisitasDomiciliaresSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPuerperioVisitasDomiciliaresSuspenseQuery>;
export type AcompanhamentoPuerperioVisitasDomiciliaresQueryResult = Apollo.QueryResult<Types.AcompanhamentoPuerperioVisitasDomiciliaresQuery, Types.AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables>;
export const InformacoesPuerperioDocument = gql`
    query InformacoesPuerperio($prontuarioId: ID!) {
  informacoesPuerperio(prontuarioId: $prontuarioId) {
    dataInicioGestacao
    preNatal {
      id
      altoRisco
      tipoGravidez {
        id
        descricao
      }
      dataDesfecho
      ultimaDum
      fonteIdadeGestacional
    }
  }
}
    `;

/**
 * __useInformacoesPuerperioQuery__
 *
 * To run a query within a React component, call `useInformacoesPuerperioQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformacoesPuerperioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformacoesPuerperioQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useInformacoesPuerperioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables> & ({ variables: Types.InformacoesPuerperioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>(InformacoesPuerperioDocument, options);
      }
export function useInformacoesPuerperioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>(InformacoesPuerperioDocument, options);
        }
export function useInformacoesPuerperioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>(InformacoesPuerperioDocument, options);
        }
export type InformacoesPuerperioQueryHookResult = ReturnType<typeof useInformacoesPuerperioQuery>;
export type InformacoesPuerperioLazyQueryHookResult = ReturnType<typeof useInformacoesPuerperioLazyQuery>;
export type InformacoesPuerperioSuspenseQueryHookResult = ReturnType<typeof useInformacoesPuerperioSuspenseQuery>;
export type InformacoesPuerperioQueryResult = Apollo.QueryResult<Types.InformacoesPuerperioQuery, Types.InformacoesPuerperioQueryVariables>;
export const AlergiasModalDocument = gql`
    query AlergiasModal($filtro: AlergiasQueryInput!) {
  alergias(input: $filtro) {
    content {
      ...Alergia
      substanciaEspecifica {
        ...SubstanciaEspecificaAlergia
        sigla
      }
      ultimaEvolucao {
        id
        dataInicio
        manifestacoesLegado
        possuiSubstanciaEspecificaCbara
        atualizadoEm
        manifestacoes {
          id
          nome
          sinonimo
        }
      }
      evolucoes {
        id
        tipoReacao
        criticidade
        grauCerteza
        dataInicio
        manifestacoes {
          id
          nome
        }
        manifestacoesLegado
        atualizadoEm
        observacao
        atendimentoProfissional {
          id
          lotacao {
            id
            cbo {
              id
              nome
            }
            profissional {
              id
              nome
            }
          }
        }
        possuiSubstanciaEspecificaCbara
      }
    }
  }
}
    ${AlergiaFragmentDoc}
${SubstanciaEspecificaAlergiaFragmentDoc}`;

/**
 * __useAlergiasModalQuery__
 *
 * To run a query within a React component, call `useAlergiasModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlergiasModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlergiasModalQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useAlergiasModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables> & ({ variables: Types.AlergiasModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>(AlergiasModalDocument, options);
      }
export function useAlergiasModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>(AlergiasModalDocument, options);
        }
export function useAlergiasModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>(AlergiasModalDocument, options);
        }
export type AlergiasModalQueryHookResult = ReturnType<typeof useAlergiasModalQuery>;
export type AlergiasModalLazyQueryHookResult = ReturnType<typeof useAlergiasModalLazyQuery>;
export type AlergiasModalSuspenseQueryHookResult = ReturnType<typeof useAlergiasModalSuspenseQuery>;
export type AlergiasModalQueryResult = Apollo.QueryResult<Types.AlergiasModalQuery, Types.AlergiasModalQueryVariables>;
export const LembretesModalDocument = gql`
    query LembretesModal($lembretesQueryInput: LembretesQueryInput!) {
  lembretes(input: $lembretesQueryInput) {
    id
    historicoLembrete {
      id
      visibilidadeLembrete
      ativo
      descricao
      data
      lotacao {
        id
        profissional {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
    }
    profissionalCriador {
      id
    }
  }
}
    `;

/**
 * __useLembretesModalQuery__
 *
 * To run a query within a React component, call `useLembretesModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLembretesModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLembretesModalQuery({
 *   variables: {
 *      lembretesQueryInput: // value for 'lembretesQueryInput'
 *   },
 * });
 */
export function useLembretesModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LembretesModalQuery, Types.LembretesModalQueryVariables> & ({ variables: Types.LembretesModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>(LembretesModalDocument, options);
      }
export function useLembretesModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>(LembretesModalDocument, options);
        }
export function useLembretesModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>(LembretesModalDocument, options);
        }
export type LembretesModalQueryHookResult = ReturnType<typeof useLembretesModalQuery>;
export type LembretesModalLazyQueryHookResult = ReturnType<typeof useLembretesModalLazyQuery>;
export type LembretesModalSuspenseQueryHookResult = ReturnType<typeof useLembretesModalSuspenseQuery>;
export type LembretesModalQueryResult = Apollo.QueryResult<Types.LembretesModalQuery, Types.LembretesModalQueryVariables>;
export const ExisteProblemaResolvidoDocument = gql`
    query ExisteProblemaResolvido($prontuarioId: ID!) {
  existeProblemaResolvido(input: $prontuarioId)
}
    `;

/**
 * __useExisteProblemaResolvidoQuery__
 *
 * To run a query within a React component, call `useExisteProblemaResolvidoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExisteProblemaResolvidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExisteProblemaResolvidoQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useExisteProblemaResolvidoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables> & ({ variables: Types.ExisteProblemaResolvidoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>(ExisteProblemaResolvidoDocument, options);
      }
export function useExisteProblemaResolvidoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>(ExisteProblemaResolvidoDocument, options);
        }
export function useExisteProblemaResolvidoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>(ExisteProblemaResolvidoDocument, options);
        }
export type ExisteProblemaResolvidoQueryHookResult = ReturnType<typeof useExisteProblemaResolvidoQuery>;
export type ExisteProblemaResolvidoLazyQueryHookResult = ReturnType<typeof useExisteProblemaResolvidoLazyQuery>;
export type ExisteProblemaResolvidoSuspenseQueryHookResult = ReturnType<typeof useExisteProblemaResolvidoSuspenseQuery>;
export type ExisteProblemaResolvidoQueryResult = Apollo.QueryResult<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>;
export const ProblemasModalDocument = gql`
    query ProblemasModal($filtro: ProblemaQueryInput!, $cid11Enable: Boolean! = false) {
  problemas(input: $filtro) {
    content {
      id
      situacao
      ciap {
        ...Ciap
      }
      cid10 {
        ...Cid10
      }
      cid11 @include(if: $cid11Enable) {
        ...Cid11
      }
      descricaoOutro
      ultimaEvolucao {
        id
        dataInicio
        dataFim
        atualizadoEm
        situacao
        observacao
      }
      evolucaoAvaliacaoCiapCid {
        id
      }
      evolucoes {
        id
        dataInicio
        dataFim
        situacao
        observacao
        atualizadoEm
        possuiCiap
        possuiCid
        possuiCid11
        atendimentoProfissional {
          id
          lotacao {
            id
            cbo {
              id
              nome
            }
            profissional {
              id
              nome
            }
          }
        }
      }
    }
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}
${Cid11FragmentDoc}`;

/**
 * __useProblemasModalQuery__
 *
 * To run a query within a React component, call `useProblemasModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemasModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemasModalQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *      cid11Enable: // value for 'cid11Enable'
 *   },
 * });
 */
export function useProblemasModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables> & ({ variables: Types.ProblemasModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>(ProblemasModalDocument, options);
      }
export function useProblemasModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>(ProblemasModalDocument, options);
        }
export function useProblemasModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>(ProblemasModalDocument, options);
        }
export type ProblemasModalQueryHookResult = ReturnType<typeof useProblemasModalQuery>;
export type ProblemasModalLazyQueryHookResult = ReturnType<typeof useProblemasModalLazyQuery>;
export type ProblemasModalSuspenseQueryHookResult = ReturnType<typeof useProblemasModalSuspenseQuery>;
export type ProblemasModalQueryResult = Apollo.QueryResult<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>;
export const ProblemasModalSimplificadoDocument = gql`
    query ProblemasModalSimplificado($filtro: ProblemaQueryInput!) {
  problemas(input: $filtro) {
    content {
      ...ProblemaCondicao
    }
  }
}
    ${ProblemaCondicaoFragmentDoc}`;

/**
 * __useProblemasModalSimplificadoQuery__
 *
 * To run a query within a React component, call `useProblemasModalSimplificadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemasModalSimplificadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemasModalSimplificadoQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProblemasModalSimplificadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables> & ({ variables: Types.ProblemasModalSimplificadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>(ProblemasModalSimplificadoDocument, options);
      }
export function useProblemasModalSimplificadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>(ProblemasModalSimplificadoDocument, options);
        }
export function useProblemasModalSimplificadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>(ProblemasModalSimplificadoDocument, options);
        }
export type ProblemasModalSimplificadoQueryHookResult = ReturnType<typeof useProblemasModalSimplificadoQuery>;
export type ProblemasModalSimplificadoLazyQueryHookResult = ReturnType<typeof useProblemasModalSimplificadoLazyQuery>;
export type ProblemasModalSimplificadoSuspenseQueryHookResult = ReturnType<typeof useProblemasModalSimplificadoSuspenseQuery>;
export type ProblemasModalSimplificadoQueryResult = Apollo.QueryResult<Types.ProblemasModalSimplificadoQuery, Types.ProblemasModalSimplificadoQueryVariables>;
export const MedicamentoUsoModalDocument = gql`
    query MedicamentoUsoModal($input: ListaMedicamentoAtivoConcluidoQueryInput!) {
  listaMedicamento(input: $input) {
    content {
      id
      medicamento {
        id
        principioAtivo
        principioAtivoFiltro
        concentracao
        medicamentoCatmat {
          id
          codigoCatMat
          codigoRename
          volume
          unidadeFornecimento {
            id
            nome
            nomePlural
          }
          principioAtivo {
            id
            nome
            listaMaterial {
              id
              tipoReceita
              tipo
            }
          }
        }
        unidadeFornecimento
        formaFarmaceutica {
          id
          nome
        }
      }
      aplicacaoMedicamento {
        id
        nome
      }
      usoContinuo
      posologia
      dtInicioTratamento
      dtFimTratamento
      medidaTempoTratamento
      tipoReceita
      recomendacoes
      tratamentoInterrompido
      justificativaInterrupcao
      dtInterrupcao
      atendProf {
        id
        iniciadoEm
        versaoAnterior
        lotacao {
          id
          profissional {
            id
            nome
          }
        }
      }
      receitaUsoContinuoGrupo {
        id
        dtInicioTratamento
      }
      cid10 {
        ...Cid10
        ativo
      }
      ciap {
        ...Ciap
      }
      registroManual
      doseUnica
      dose
      qtDose
      qtDoseManha
      qtDoseTarde
      qtDoseNoite
      unidadeMedidaDose {
        id
        nome
        nomePlural
      }
      tipoFrequenciaDose
      frequenciaDose
      qtPeriodoFrequencia
      medidaTempoFrequencia
      qtDuracaoTratamento
      quantidadeReceitada
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useMedicamentoUsoModalQuery__
 *
 * To run a query within a React component, call `useMedicamentoUsoModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoUsoModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoUsoModalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoUsoModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables> & ({ variables: Types.MedicamentoUsoModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>(MedicamentoUsoModalDocument, options);
      }
export function useMedicamentoUsoModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>(MedicamentoUsoModalDocument, options);
        }
export function useMedicamentoUsoModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>(MedicamentoUsoModalDocument, options);
        }
export type MedicamentoUsoModalQueryHookResult = ReturnType<typeof useMedicamentoUsoModalQuery>;
export type MedicamentoUsoModalLazyQueryHookResult = ReturnType<typeof useMedicamentoUsoModalLazyQuery>;
export type MedicamentoUsoModalSuspenseQueryHookResult = ReturnType<typeof useMedicamentoUsoModalSuspenseQuery>;
export type MedicamentoUsoModalQueryResult = Apollo.QueryResult<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>;
export const MedicoesAnterioresImcDocument = gql`
    query MedicoesAnterioresImc($prontuarioId: ID!) {
  medicoes(input: {prontuarioId: $prontuarioId}) {
    id
    dataMedicao
    valorPeso
    valorAltura
  }
}
    `;

/**
 * __useMedicoesAnterioresImcQuery__
 *
 * To run a query within a React component, call `useMedicoesAnterioresImcQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesAnterioresImcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesAnterioresImcQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useMedicoesAnterioresImcQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables> & ({ variables: Types.MedicoesAnterioresImcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>(MedicoesAnterioresImcDocument, options);
      }
export function useMedicoesAnterioresImcLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>(MedicoesAnterioresImcDocument, options);
        }
export function useMedicoesAnterioresImcSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>(MedicoesAnterioresImcDocument, options);
        }
export type MedicoesAnterioresImcQueryHookResult = ReturnType<typeof useMedicoesAnterioresImcQuery>;
export type MedicoesAnterioresImcLazyQueryHookResult = ReturnType<typeof useMedicoesAnterioresImcLazyQuery>;
export type MedicoesAnterioresImcSuspenseQueryHookResult = ReturnType<typeof useMedicoesAnterioresImcSuspenseQuery>;
export type MedicoesAnterioresImcQueryResult = Apollo.QueryResult<Types.MedicoesAnterioresImcQuery, Types.MedicoesAnterioresImcQueryVariables>;
export const MedicoesAtendimentosAnterioresDocument = gql`
    query MedicoesAtendimentosAnteriores($prontuarioId: ID!, $ultimoRegistroComPeso: Boolean) {
  medicoes(
    input: {prontuarioId: $prontuarioId, ultimoRegistroComPeso: $ultimoRegistroComPeso}
  ) {
    id
    dataMedicao
    dum
    valorPeso
    valorAltura
    valorFrequenciaCardiaca
    valorPressaoArterial
    valorPerimetroCefalico
    valorFrequenciaRespiratoria
    valorTemperatura
    valorSaturacaoO2
    valorGlicemia
    tipoGlicemia
    atendimentoProfissional {
      id
      iniciadoEm
      lotacao {
        id
        profissional {
          id
          nome
        }
      }
    }
    valorImc
    perimetroPanturrilha
    valorCircunferenciaAbdominal
    medicaoAnterior
    valorAlturaUterina
    valorForcaMuscMaoDireita
    unidadeForcaMuscMaoDireita
    valorForcaMuscMaoEsquerda
    unidadeForcaMuscMaoEsquerda
  }
  medicoesNoNascimento: antecedente(prontuarioId: $prontuarioId) {
    id
    peso
    altura
    perimetroCefalico
    dataUltimaAtualizacao: dataUltimaAtualizacaoPuericultura
  }
}
    `;

/**
 * __useMedicoesAtendimentosAnterioresQuery__
 *
 * To run a query within a React component, call `useMedicoesAtendimentosAnterioresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesAtendimentosAnterioresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesAtendimentosAnterioresQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      ultimoRegistroComPeso: // value for 'ultimoRegistroComPeso'
 *   },
 * });
 */
export function useMedicoesAtendimentosAnterioresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables> & ({ variables: Types.MedicoesAtendimentosAnterioresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>(MedicoesAtendimentosAnterioresDocument, options);
      }
export function useMedicoesAtendimentosAnterioresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>(MedicoesAtendimentosAnterioresDocument, options);
        }
export function useMedicoesAtendimentosAnterioresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>(MedicoesAtendimentosAnterioresDocument, options);
        }
export type MedicoesAtendimentosAnterioresQueryHookResult = ReturnType<typeof useMedicoesAtendimentosAnterioresQuery>;
export type MedicoesAtendimentosAnterioresLazyQueryHookResult = ReturnType<typeof useMedicoesAtendimentosAnterioresLazyQuery>;
export type MedicoesAtendimentosAnterioresSuspenseQueryHookResult = ReturnType<typeof useMedicoesAtendimentosAnterioresSuspenseQuery>;
export type MedicoesAtendimentosAnterioresQueryResult = Apollo.QueryResult<Types.MedicoesAtendimentosAnterioresQuery, Types.MedicoesAtendimentosAnterioresQueryVariables>;
export const AcompanhamentoPreNatalDocument = gql`
    query acompanhamentoPreNatal($input: ID!, $onlyProblemaAtivo: Boolean) {
  atendimentosProfUltimaGestacao(
    prontuarioId: $input
    onlyProblemaAtivo: $onlyProblemaAtivo
  ) {
    id
    iniciadoEm
    atendimentoProfissionalPreNatal {
      id
      movimentacaoFetal
      tipoEdema
    }
    medicoes {
      id
      dataMedicao
      valorBatimentoCardiacoFetal
      valorBatimentoCardiacoFetal2
      dum
      valorAlturaUterina
      valorPressaoArterial
      valorPeso
      valorGlicemia
      medicaoAnterior
    }
  }
}
    `;

/**
 * __useAcompanhamentoPreNatalQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPreNatalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPreNatalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPreNatalQuery({
 *   variables: {
 *      input: // value for 'input'
 *      onlyProblemaAtivo: // value for 'onlyProblemaAtivo'
 *   },
 * });
 */
export function useAcompanhamentoPreNatalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables> & ({ variables: Types.AcompanhamentoPreNatalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>(AcompanhamentoPreNatalDocument, options);
      }
export function useAcompanhamentoPreNatalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>(AcompanhamentoPreNatalDocument, options);
        }
export function useAcompanhamentoPreNatalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>(AcompanhamentoPreNatalDocument, options);
        }
export type AcompanhamentoPreNatalQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalQuery>;
export type AcompanhamentoPreNatalLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalLazyQuery>;
export type AcompanhamentoPreNatalSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalSuspenseQuery>;
export type AcompanhamentoPreNatalQueryResult = Apollo.QueryResult<Types.AcompanhamentoPreNatalQuery, Types.AcompanhamentoPreNatalQueryVariables>;
export const HistoricoResultadosExamesDocument = gql`
    query HistoricoResultadosExames($input: ResultadosExameQueryInput!) {
  resultadosExame(input: $input) {
    content {
      id
      exame {
        ...Procedimento
      }
      resultado
      solicitacao {
        id
        data
        atendimentoProfissional {
          id
          lotacao {
            id
            cbo {
              id
              nome
            }
            profissional {
              id
              nome
            }
          }
        }
      }
      dataRealizacao
      dataResultado
      dataSolicitacao
      conferido
      especifico {
        id
        exameEspecificoEnum
        valor
        igDias
        igSemanas
        dpp
        resultadoExamePuericulturaEnum
        resultadoExameEstruturadoQualitativoEnum
      }
      atendimentoProfissionalResultado {
        id
        iniciadoEm
        lotacao {
          id
          cbo {
            id
            nome
          }
          profissional {
            id
            nome
          }
        }
      }
    }
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useHistoricoResultadosExamesQuery__
 *
 * To run a query within a React component, call `useHistoricoResultadosExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoResultadosExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoResultadosExamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoResultadosExamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables> & ({ variables: Types.HistoricoResultadosExamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>(HistoricoResultadosExamesDocument, options);
      }
export function useHistoricoResultadosExamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>(HistoricoResultadosExamesDocument, options);
        }
export function useHistoricoResultadosExamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>(HistoricoResultadosExamesDocument, options);
        }
export type HistoricoResultadosExamesQueryHookResult = ReturnType<typeof useHistoricoResultadosExamesQuery>;
export type HistoricoResultadosExamesLazyQueryHookResult = ReturnType<typeof useHistoricoResultadosExamesLazyQuery>;
export type HistoricoResultadosExamesSuspenseQueryHookResult = ReturnType<typeof useHistoricoResultadosExamesSuspenseQuery>;
export type HistoricoResultadosExamesQueryResult = Apollo.QueryResult<Types.HistoricoResultadosExamesQuery, Types.HistoricoResultadosExamesQueryVariables>;
export const IsBeneficiarioBolsaFamiliaDocument = gql`
    query IsBeneficiarioBolsaFamilia($cidadaoId: ID!) {
  cidadao(id: $cidadaoId) {
    id
    beneficiarioBolsaFamilia {
      id
      isBeneficiario
    }
  }
}
    `;

/**
 * __useIsBeneficiarioBolsaFamiliaQuery__
 *
 * To run a query within a React component, call `useIsBeneficiarioBolsaFamiliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsBeneficiarioBolsaFamiliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsBeneficiarioBolsaFamiliaQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useIsBeneficiarioBolsaFamiliaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables> & ({ variables: Types.IsBeneficiarioBolsaFamiliaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>(IsBeneficiarioBolsaFamiliaDocument, options);
      }
export function useIsBeneficiarioBolsaFamiliaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>(IsBeneficiarioBolsaFamiliaDocument, options);
        }
export function useIsBeneficiarioBolsaFamiliaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>(IsBeneficiarioBolsaFamiliaDocument, options);
        }
export type IsBeneficiarioBolsaFamiliaQueryHookResult = ReturnType<typeof useIsBeneficiarioBolsaFamiliaQuery>;
export type IsBeneficiarioBolsaFamiliaLazyQueryHookResult = ReturnType<typeof useIsBeneficiarioBolsaFamiliaLazyQuery>;
export type IsBeneficiarioBolsaFamiliaSuspenseQueryHookResult = ReturnType<typeof useIsBeneficiarioBolsaFamiliaSuspenseQuery>;
export type IsBeneficiarioBolsaFamiliaQueryResult = Apollo.QueryResult<Types.IsBeneficiarioBolsaFamiliaQuery, Types.IsBeneficiarioBolsaFamiliaQueryVariables>;
export const DadosEscutaPreAtendimentoDocument = gql`
    query DadosEscutaPreAtendimento($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    finalizadoEm
    classificacaoRisco
    evolucaoSubjetivo {
      id
      descricao
      ciaps {
        id
        ciap {
          ...Ciap
        }
        nota
      }
    }
    procedimentosAtendimento {
      id
      procedimento {
        id
        descricao
        codigo
        tipoProcedimento
      }
    }
    lotacao {
      id
      cbo {
        id
        nome
      }
      profissional {
        id
        nome
      }
      equipe {
        id
        nome
      }
    }
  }
}
    ${CiapFragmentDoc}`;

/**
 * __useDadosEscutaPreAtendimentoQuery__
 *
 * To run a query within a React component, call `useDadosEscutaPreAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDadosEscutaPreAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDadosEscutaPreAtendimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDadosEscutaPreAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables> & ({ variables: Types.DadosEscutaPreAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>(DadosEscutaPreAtendimentoDocument, options);
      }
export function useDadosEscutaPreAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>(DadosEscutaPreAtendimentoDocument, options);
        }
export function useDadosEscutaPreAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>(DadosEscutaPreAtendimentoDocument, options);
        }
export type DadosEscutaPreAtendimentoQueryHookResult = ReturnType<typeof useDadosEscutaPreAtendimentoQuery>;
export type DadosEscutaPreAtendimentoLazyQueryHookResult = ReturnType<typeof useDadosEscutaPreAtendimentoLazyQuery>;
export type DadosEscutaPreAtendimentoSuspenseQueryHookResult = ReturnType<typeof useDadosEscutaPreAtendimentoSuspenseQuery>;
export type DadosEscutaPreAtendimentoQueryResult = Apollo.QueryResult<Types.DadosEscutaPreAtendimentoQuery, Types.DadosEscutaPreAtendimentoQueryVariables>;
export const EscutaPreAtendimentoMaisRecenteDocument = gql`
    query EscutaPreAtendimentoMaisRecente($input: EscutaOrPreAtendimentoOfAtendimentoInput!) {
  escutaOrPreAtendimentoOfAtendimento(input: $input)
}
    `;

/**
 * __useEscutaPreAtendimentoMaisRecenteQuery__
 *
 * To run a query within a React component, call `useEscutaPreAtendimentoMaisRecenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEscutaPreAtendimentoMaisRecenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEscutaPreAtendimentoMaisRecenteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscutaPreAtendimentoMaisRecenteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables> & ({ variables: Types.EscutaPreAtendimentoMaisRecenteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>(EscutaPreAtendimentoMaisRecenteDocument, options);
      }
export function useEscutaPreAtendimentoMaisRecenteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>(EscutaPreAtendimentoMaisRecenteDocument, options);
        }
export function useEscutaPreAtendimentoMaisRecenteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>(EscutaPreAtendimentoMaisRecenteDocument, options);
        }
export type EscutaPreAtendimentoMaisRecenteQueryHookResult = ReturnType<typeof useEscutaPreAtendimentoMaisRecenteQuery>;
export type EscutaPreAtendimentoMaisRecenteLazyQueryHookResult = ReturnType<typeof useEscutaPreAtendimentoMaisRecenteLazyQuery>;
export type EscutaPreAtendimentoMaisRecenteSuspenseQueryHookResult = ReturnType<typeof useEscutaPreAtendimentoMaisRecenteSuspenseQuery>;
export type EscutaPreAtendimentoMaisRecenteQueryResult = Apollo.QueryResult<Types.EscutaPreAtendimentoMaisRecenteQuery, Types.EscutaPreAtendimentoMaisRecenteQueryVariables>;
export const DadosUltimosContatosDocument = gql`
    query DadosUltimosContatos($input: HistoricoQueryInput!) {
  historico(input: $input) {
    content {
      codigoUnicoRegistro
      origemAtendimento
      dataAtendimento
      turno
      tipoAtendProf
      tipoApresentacao
      isCancelado
      coSubtipoAtendimento
      classificacaoRisco
      idadeGestacional {
        dias
        semanas
      }
      dadosClinicos
      condicoesAvaliadas
      examesRealizadosZika
      tipoConsultaOdonto
      isAtendRecente
      idAtendRecente
      idAtividadeColetiva
      idCidadao
      cpfCnsCidadao
      hasObservacao
      hasCuidadoCompartilhado
      hasErrata
      hasNotaComplementar
      cuidadoCompartilhado {
        ...HistoricoCuidadoCompartilhadoHeader
      }
      cuidadoCompartilhadoEvolucao {
        ...HistoricoCuidadoCompartilhadoEvolucaoHeader
      }
      ...CuidadoCompartilhadoDw
    }
  }
}
    ${HistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${HistoricoCuidadoCompartilhadoEvolucaoHeaderFragmentDoc}
${CuidadoCompartilhadoDwFragmentDoc}`;

/**
 * __useDadosUltimosContatosQuery__
 *
 * To run a query within a React component, call `useDadosUltimosContatosQuery` and pass it any options that fit your needs.
 * When your component renders, `useDadosUltimosContatosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDadosUltimosContatosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDadosUltimosContatosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables> & ({ variables: Types.DadosUltimosContatosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>(DadosUltimosContatosDocument, options);
      }
export function useDadosUltimosContatosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>(DadosUltimosContatosDocument, options);
        }
export function useDadosUltimosContatosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>(DadosUltimosContatosDocument, options);
        }
export type DadosUltimosContatosQueryHookResult = ReturnType<typeof useDadosUltimosContatosQuery>;
export type DadosUltimosContatosLazyQueryHookResult = ReturnType<typeof useDadosUltimosContatosLazyQuery>;
export type DadosUltimosContatosSuspenseQueryHookResult = ReturnType<typeof useDadosUltimosContatosSuspenseQuery>;
export type DadosUltimosContatosQueryResult = Apollo.QueryResult<Types.DadosUltimosContatosQuery, Types.DadosUltimosContatosQueryVariables>;
export const VideochamadaAtendimentoDocument = gql`
    query VideochamadaAtendimento($atendimentoId: ID!) {
  atendimento(id: $atendimentoId) {
    id
    agendado {
      id
      lotacaoAgendada {
        id
      }
      lotacaoParticipante {
        id
        profissional {
          id
          nome
          email
        }
        equipe {
          id
          nome
          ine
        }
        cbo {
          id
          nome
        }
      }
      videochamada {
        id
        uuid
      }
    }
  }
}
    `;

/**
 * __useVideochamadaAtendimentoQuery__
 *
 * To run a query within a React component, call `useVideochamadaAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideochamadaAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideochamadaAtendimentoQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useVideochamadaAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables> & ({ variables: Types.VideochamadaAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>(VideochamadaAtendimentoDocument, options);
      }
export function useVideochamadaAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>(VideochamadaAtendimentoDocument, options);
        }
export function useVideochamadaAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>(VideochamadaAtendimentoDocument, options);
        }
export type VideochamadaAtendimentoQueryHookResult = ReturnType<typeof useVideochamadaAtendimentoQuery>;
export type VideochamadaAtendimentoLazyQueryHookResult = ReturnType<typeof useVideochamadaAtendimentoLazyQuery>;
export type VideochamadaAtendimentoSuspenseQueryHookResult = ReturnType<typeof useVideochamadaAtendimentoSuspenseQuery>;
export type VideochamadaAtendimentoQueryResult = Apollo.QueryResult<Types.VideochamadaAtendimentoQuery, Types.VideochamadaAtendimentoQueryVariables>;
export const FolhaRostoVulnerabilidadeFamiliarDocument = gql`
    query FolhaRostoVulnerabilidadeFamiliar($input: CidadaosQueryInput!) {
  cidadaos(input: $input) {
    content {
      id
      familias {
        id
        vulnerabilidadeFamiliar {
          id
          classificacao
          grauSugestivo
          escore
          classificacaoSubestimada
          criterios {
            criteriosInequivocos
            criteriosSugestivos
            criteriosPontuados {
              id
              descricao
              numeroMoradores
              peso
              resultado
            }
          }
        }
        imovel {
          id
          possuiInconsistencia
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useFolhaRostoVulnerabilidadeFamiliarQuery__
 *
 * To run a query within a React component, call `useFolhaRostoVulnerabilidadeFamiliarQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolhaRostoVulnerabilidadeFamiliarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolhaRostoVulnerabilidadeFamiliarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFolhaRostoVulnerabilidadeFamiliarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables> & ({ variables: Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>(FolhaRostoVulnerabilidadeFamiliarDocument, options);
      }
export function useFolhaRostoVulnerabilidadeFamiliarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>(FolhaRostoVulnerabilidadeFamiliarDocument, options);
        }
export function useFolhaRostoVulnerabilidadeFamiliarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>(FolhaRostoVulnerabilidadeFamiliarDocument, options);
        }
export type FolhaRostoVulnerabilidadeFamiliarQueryHookResult = ReturnType<typeof useFolhaRostoVulnerabilidadeFamiliarQuery>;
export type FolhaRostoVulnerabilidadeFamiliarLazyQueryHookResult = ReturnType<typeof useFolhaRostoVulnerabilidadeFamiliarLazyQuery>;
export type FolhaRostoVulnerabilidadeFamiliarSuspenseQueryHookResult = ReturnType<typeof useFolhaRostoVulnerabilidadeFamiliarSuspenseQuery>;
export type FolhaRostoVulnerabilidadeFamiliarQueryResult = Apollo.QueryResult<Types.FolhaRostoVulnerabilidadeFamiliarQuery, Types.FolhaRostoVulnerabilidadeFamiliarQueryVariables>;
export const AlertasSdcDocument = gql`
    query AlertasSdc($input: SdcInput!) {
  eventosSdc(input: $input) {
    ... on CondutaSdc {
      id
      titulo
      subtitulo
      diferencial
      tipo
      observacao
      prescricoes {
        titulo
        medicamentos {
          posologia
          medidaTempoFrequencia
          medicamentoCatmat {
            id
            volume
            medicamento {
              id
              principioAtivo
              unidadeFornecimento
              concentracao
              formaFarmaceutica {
                id
                nome
              }
            }
            codigoCatMat
            codigoRename
            unidadeFornecimento {
              id
              nome
              nomePlural
            }
            principioAtivo {
              id
              nome
              listaMaterial {
                id
                tipo
                tipoReceita
              }
            }
            unidadeMedidaDose {
              id
              nome
              nomePlural
            }
          }
          aplicacaoMedicamento {
            id
            nome
          }
          quantidadeReceitada
          recomendacoes
          quantidadeDose
          unidadeMedidaDose {
            id
            nome
            nomePlural
          }
          tipoFrequenciaDose
          intervaloFrequencia
          duracaoTratamentoEmDias
          prescrever
          motivoRestricaoPrescricao
          tipoMotivoPrescricao
          idMotivoPrescricao
          codigoMotivoPrescricao
          nomeMotivoPrescricao
        }
      }
      examesSdc {
        tipoExame
        gruposProcedimentosSdcDto {
          titulo
          procedimentosSdcDto {
            exameSolicitado {
              ...Procedimento
            }
            observacao
            previamentePrescrito
          }
        }
        cid10 {
          ...Cid10
        }
        justificativa
      }
      atestadosSdc {
        tipoAtestado
        dias
        cid10 {
          ...Cid10
        }
      }
      grupoDengue
    }
    ... on AlertaSdc {
      id
      titulo
      subtitulo
      acompanhamento
      exames
      tituloMedicamentos
      medicamentos
      recomendacoes
      tituloRetorno
      retorno
      tituloOrientacoes
      orientacoes
      conteudoPersonalizado
      tituloReferencias
      referencias
      notificar
      conjuntoFatoresSdc {
        fatoresVerificadosSdc {
          descricao
          fatores {
            fatorRisco
            ondeSistemaVerifica
          }
        }
        fatoresNaoVerificadosSdc
      }
      riscos {
        estratificacao
        origem
        descricaoOrigem
        grupo
      }
    }
  }
}
    ${ProcedimentoFragmentDoc}
${Cid10FragmentDoc}`;

/**
 * __useAlertasSdcQuery__
 *
 * To run a query within a React component, call `useAlertasSdcQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertasSdcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertasSdcQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlertasSdcQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables> & ({ variables: Types.AlertasSdcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>(AlertasSdcDocument, options);
      }
export function useAlertasSdcLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>(AlertasSdcDocument, options);
        }
export function useAlertasSdcSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>(AlertasSdcDocument, options);
        }
export type AlertasSdcQueryHookResult = ReturnType<typeof useAlertasSdcQuery>;
export type AlertasSdcLazyQueryHookResult = ReturnType<typeof useAlertasSdcLazyQuery>;
export type AlertasSdcSuspenseQueryHookResult = ReturnType<typeof useAlertasSdcSuspenseQuery>;
export type AlertasSdcQueryResult = Apollo.QueryResult<Types.AlertasSdcQuery, Types.AlertasSdcQueryVariables>;
export const AtendimentoHeaderCidadaoDocument = gql`
    query AtendimentoHeaderCidadao($cidadaoId: ID!, $fetchCidadaoVinculacaoEquipeAndTelefones: Boolean!) {
  cidadao(id: $cidadaoId) {
    id
    cpf
    cns
    nome
    nomeSocial
    nomeTradicional
    dataNascimento
    sexo
    nomeMae
    telefoneResidencial @include(if: $fetchCidadaoVinculacaoEquipeAndTelefones)
    telefoneCelular @include(if: $fetchCidadaoVinculacaoEquipeAndTelefones)
    telefoneContato @include(if: $fetchCidadaoVinculacaoEquipeAndTelefones)
    identidadeGeneroDbEnum
    ativo
    faleceu
    unificado
    unificacaoBase
    cidadaoVinculacaoEquipe @include(if: $fetchCidadaoVinculacaoEquipeAndTelefones) {
      id
      unidadeSaude {
        id
        nome
      }
    }
  }
}
    `;

/**
 * __useAtendimentoHeaderCidadaoQuery__
 *
 * To run a query within a React component, call `useAtendimentoHeaderCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoHeaderCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoHeaderCidadaoQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *      fetchCidadaoVinculacaoEquipeAndTelefones: // value for 'fetchCidadaoVinculacaoEquipeAndTelefones'
 *   },
 * });
 */
export function useAtendimentoHeaderCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables> & ({ variables: Types.AtendimentoHeaderCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>(AtendimentoHeaderCidadaoDocument, options);
      }
export function useAtendimentoHeaderCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>(AtendimentoHeaderCidadaoDocument, options);
        }
export function useAtendimentoHeaderCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>(AtendimentoHeaderCidadaoDocument, options);
        }
export type AtendimentoHeaderCidadaoQueryHookResult = ReturnType<typeof useAtendimentoHeaderCidadaoQuery>;
export type AtendimentoHeaderCidadaoLazyQueryHookResult = ReturnType<typeof useAtendimentoHeaderCidadaoLazyQuery>;
export type AtendimentoHeaderCidadaoSuspenseQueryHookResult = ReturnType<typeof useAtendimentoHeaderCidadaoSuspenseQuery>;
export type AtendimentoHeaderCidadaoQueryResult = Apollo.QueryResult<Types.AtendimentoHeaderCidadaoQuery, Types.AtendimentoHeaderCidadaoQueryVariables>;
export const ConfiguracaoRndsDocument = gql`
    query configuracaoRnds {
  conexao {
    internet {
      habilitado
    }
  }
  configuracaoCertificadoHabilitado {
    id
    rndsHabilitado
  }
}
    `;

/**
 * __useConfiguracaoRndsQuery__
 *
 * To run a query within a React component, call `useConfiguracaoRndsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoRndsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoRndsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoRndsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>(ConfiguracaoRndsDocument, options);
      }
export function useConfiguracaoRndsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>(ConfiguracaoRndsDocument, options);
        }
export function useConfiguracaoRndsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>(ConfiguracaoRndsDocument, options);
        }
export type ConfiguracaoRndsQueryHookResult = ReturnType<typeof useConfiguracaoRndsQuery>;
export type ConfiguracaoRndsLazyQueryHookResult = ReturnType<typeof useConfiguracaoRndsLazyQuery>;
export type ConfiguracaoRndsSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoRndsSuspenseQuery>;
export type ConfiguracaoRndsQueryResult = Apollo.QueryResult<Types.ConfiguracaoRndsQuery, Types.ConfiguracaoRndsQueryVariables>;
export const ConfiguracaoSistemasExternosAtendimentoDocument = gql`
    query configuracaoSistemasExternosAtendimento($input: IframesQueryInput) {
  hasIframes(input: $input)
}
    `;

/**
 * __useConfiguracaoSistemasExternosAtendimentoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoSistemasExternosAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoSistemasExternosAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoSistemasExternosAtendimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfiguracaoSistemasExternosAtendimentoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>(ConfiguracaoSistemasExternosAtendimentoDocument, options);
      }
export function useConfiguracaoSistemasExternosAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>(ConfiguracaoSistemasExternosAtendimentoDocument, options);
        }
export function useConfiguracaoSistemasExternosAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>(ConfiguracaoSistemasExternosAtendimentoDocument, options);
        }
export type ConfiguracaoSistemasExternosAtendimentoQueryHookResult = ReturnType<typeof useConfiguracaoSistemasExternosAtendimentoQuery>;
export type ConfiguracaoSistemasExternosAtendimentoLazyQueryHookResult = ReturnType<typeof useConfiguracaoSistemasExternosAtendimentoLazyQuery>;
export type ConfiguracaoSistemasExternosAtendimentoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoSistemasExternosAtendimentoSuspenseQuery>;
export type ConfiguracaoSistemasExternosAtendimentoQueryResult = Apollo.QueryResult<Types.ConfiguracaoSistemasExternosAtendimentoQuery, Types.ConfiguracaoSistemasExternosAtendimentoQueryVariables>;
export const BuscaListagemHistoricoClinicoDocument = gql`
    query BuscaListagemHistoricoClinico($input: HistoricoQueryInput!) {
  historico(input: $input) {
    content {
      idAtendRecente
      idAtendProcessado
      codigoUnicoRegistro
      dataAtendimento
      dataInativacao
      dataUltimaRetificacao
      turno
      tipoApresentacao
      tipoAtendProf
      isCancelado
      isInativo
      isRetificado
      coSubtipoAtendimento
      origemAtendimento
      cpfCnsCidadao
      classificacaoRisco
      idAtividadeColetiva
      idCidadao
      idadeGestacional {
        dias
        semanas
      }
      isAtendRecente
      condicoesAvaliadas
      examesRealizadosZika
      profissional {
        id
        nome
        nomeCivil
        nomeSocial
      }
      cbo {
        id
        nome
        cbo2002
      }
      estagiario {
        id
        nome
        nomeCivil
        nomeSocial
      }
      cboEstagio {
        id
        nome
        cbo2002
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      equipe {
        id
        ine
        nome
      }
      cnsProfissional
      isVersaoFichaRetificavel
      hasPrescricaoMedicamento
      hasOrientacao
      hasAtestado
      hasLembrete
      hasAlergia
      hasSolicitacaoExame
      hasResultadoExame
      hasEncaminhamento
      hasEncaminhamentoEspecializado
      hasProcedimentoClinico
      hasMarcadorConsumoAlimentar
      hasCuidadoCompartilhado
      hasGuiasEncaminhamentos
      hasIvcf
      hasAnexoArquivo
      hasMchat
      hasErrata
      hasNotaComplementar
      atingiuLimiteErratasNotasComplementares
      dadosClinicos
      condicoesVacinacao {
        idAtend
        isViajante
        condicaoMaternal
        isComunicanteHanseniase
      }
      tipoConsultaOdonto
      fichasConcatenadas {
        uuidProcedimento
        uuidZika
      }
      hasObservacao
      isAtendObsFinalizado
      inicioAtendimentoObservacao
      fimAtendimentoObservacao
      cuidadoCompartilhadoEvolucao {
        ...HistoricoCuidadoCompartilhadoEvolucaoHeader
      }
      cuidadoCompartilhado {
        ...HistoricoCuidadoCompartilhadoHeader
      }
      nomeFinalizadorObservacao
      cnsFinalizadorObservacao
      cboFinalizadorObservacao
      ubsFinalizadorObservacao
      ineFinalizadorObservacao
      ...CuidadoCompartilhadoDw
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${HistoricoCuidadoCompartilhadoEvolucaoHeaderFragmentDoc}
${HistoricoCuidadoCompartilhadoHeaderFragmentDoc}
${CuidadoCompartilhadoDwFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBuscaListagemHistoricoClinicoQuery__
 *
 * To run a query within a React component, call `useBuscaListagemHistoricoClinicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaListagemHistoricoClinicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaListagemHistoricoClinicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaListagemHistoricoClinicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables> & ({ variables: Types.BuscaListagemHistoricoClinicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>(BuscaListagemHistoricoClinicoDocument, options);
      }
export function useBuscaListagemHistoricoClinicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>(BuscaListagemHistoricoClinicoDocument, options);
        }
export function useBuscaListagemHistoricoClinicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>(BuscaListagemHistoricoClinicoDocument, options);
        }
export type BuscaListagemHistoricoClinicoQueryHookResult = ReturnType<typeof useBuscaListagemHistoricoClinicoQuery>;
export type BuscaListagemHistoricoClinicoLazyQueryHookResult = ReturnType<typeof useBuscaListagemHistoricoClinicoLazyQuery>;
export type BuscaListagemHistoricoClinicoSuspenseQueryHookResult = ReturnType<typeof useBuscaListagemHistoricoClinicoSuspenseQuery>;
export type BuscaListagemHistoricoClinicoQueryResult = Apollo.QueryResult<Types.BuscaListagemHistoricoClinicoQuery, Types.BuscaListagemHistoricoClinicoQueryVariables>;
export const HistoricoAtendimentoDomiciliarAdDocument = gql`
    query HistoricoAtendimentoDomiciliarAD($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    evolucaoObjetivo {
      id
      descricao
    }
    ...HistoricoSubjetivoPecFragment
    medicoes {
      id
      valorPeso
      valorAltura
      valorFrequenciaCardiaca
      valorPressaoArterial
      valorPerimetroCefalico
      valorFrequenciaRespiratoria
      valorTemperatura
      valorSaturacaoO2
      valorGlicemia
      tipoGlicemia
      valorImc
      perimetroPanturrilha
      valorCircunferenciaAbdominal
      dum
      valorVacinacaoEmDia
      medicaoAnterior
      dataMedicao
    }
    evolucaoAvaliacao {
      id
      descricao
      ciapsCids {
        id
        ciap {
          ...Ciap
        }
        cid10 {
          ...Cid10
        }
        cid11 {
          ...Cid11
        }
        nota
        isCiapCidNaListaDeProblemas
      }
    }
    evolucaoPlano {
      id
      descricao
      intervencoesProcedimentos {
        id
        ciap {
          ...Ciap
        }
        procedimento {
          id
          descricao
          codigo
        }
        nota
      }
    }
    atendimentoProfissionalAD {
      id
      origem
      modalidade
      cid10Principal {
        id
        codigo
        nome
      }
      cid10Secundario1 {
        id
        codigo
        nome
      }
      cid10Secundario2 {
        id
        codigo
        nome
      }
      condicoesAvaliadasAD {
        id
        questao {
          id
          descricao
        }
        situacaoAtiva
      }
      conduta
    }
    cidadaoAD {
      id
      dataObito
      numeroDocumentoObito
    }
    procedimentosAtendimento {
      id
      procedimento {
        id
        descricao
        codigo
      }
      cid10Principal {
        id
        codigo
        nome
      }
    }
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${CiapFragmentDoc}
${Cid10FragmentDoc}
${Cid11FragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoAtendimentoDomiciliarAdQuery__
 *
 * To run a query within a React component, call `useHistoricoAtendimentoDomiciliarAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtendimentoDomiciliarAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtendimentoDomiciliarAdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtendimentoDomiciliarAdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables> & ({ variables: Types.HistoricoAtendimentoDomiciliarAdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>(HistoricoAtendimentoDomiciliarAdDocument, options);
      }
export function useHistoricoAtendimentoDomiciliarAdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>(HistoricoAtendimentoDomiciliarAdDocument, options);
        }
export function useHistoricoAtendimentoDomiciliarAdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>(HistoricoAtendimentoDomiciliarAdDocument, options);
        }
export type HistoricoAtendimentoDomiciliarAdQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarAdQuery>;
export type HistoricoAtendimentoDomiciliarAdLazyQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarAdLazyQuery>;
export type HistoricoAtendimentoDomiciliarAdSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarAdSuspenseQuery>;
export type HistoricoAtendimentoDomiciliarAdQueryResult = Apollo.QueryResult<Types.HistoricoAtendimentoDomiciliarAdQuery, Types.HistoricoAtendimentoDomiciliarAdQueryVariables>;
export const HistoricoAtendimentoDomiciliarDwDocument = gql`
    query HistoricoAtendimentoDomiciliarDw($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoDomiciliar(input: $input) {
    id
    fatosAtendDomProblemaCondicao {
      id
      dimensaoCiap {
        id
        codigoCiap
        nomeCiap
      }
      dimensaoCid10 {
        id
        codigoCid10
        nomeCid10
      }
      dimensaoSituacaoProblema {
        id
        identificador
        descricao
      }
      dataInicioProblema
      dataFimProblema
    }
    dimensaoProfissional1 {
      id
      nome
    }
    dimensaoProfissional2 {
      id
      nome
    }
    dimensaoCbo1 {
      id
      nome
    }
    dimensaoCbo2 {
      id
      nome
    }
    dimensaoUnidadeSaude1 {
      id
      nome
      cnes
    }
    dimensaoUnidadeSaude2 {
      id
      nome
      cnes
    }
    dimensaoEquipe1 {
      id
      nome
      ine
    }
    dimensaoEquipe2 {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
    dimensaoModalidadeAD {
      id
      descricao
    }
    dimensaoCondutaAD {
      id
      conduta
    }
    condicoesAvaliadas
    procedimentos {
      id
      dimensaoProcedimento {
        id
        codigoProcedimento
        descricaoProcedimento
      }
    }
  }
}
    `;

/**
 * __useHistoricoAtendimentoDomiciliarDwQuery__
 *
 * To run a query within a React component, call `useHistoricoAtendimentoDomiciliarDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtendimentoDomiciliarDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtendimentoDomiciliarDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtendimentoDomiciliarDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables> & ({ variables: Types.HistoricoAtendimentoDomiciliarDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>(HistoricoAtendimentoDomiciliarDwDocument, options);
      }
export function useHistoricoAtendimentoDomiciliarDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>(HistoricoAtendimentoDomiciliarDwDocument, options);
        }
export function useHistoricoAtendimentoDomiciliarDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>(HistoricoAtendimentoDomiciliarDwDocument, options);
        }
export type HistoricoAtendimentoDomiciliarDwQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarDwQuery>;
export type HistoricoAtendimentoDomiciliarDwLazyQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarDwLazyQuery>;
export type HistoricoAtendimentoDomiciliarDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtendimentoDomiciliarDwSuspenseQuery>;
export type HistoricoAtendimentoDomiciliarDwQueryResult = Apollo.QueryResult<Types.HistoricoAtendimentoDomiciliarDwQuery, Types.HistoricoAtendimentoDomiciliarDwQueryVariables>;
export const HistoricoConsultaPecDocument = gql`
    query HistoricoConsultaPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    medicoes {
      id
      medicaoAnterior
      dataMedicao
    }
    solicitacoesOci {
      ...SolicitacoesOciHistoricoFragment
    }
    ...HistoricoPlanoCuidadoFragment
    ...HistoricoAvaliacaoPecFragment
    ...HistoricoPlanoPecFragment
    ...HistoricoAntecedentesPecFragment
    ...HistoricoRegistrosAnterioresVacinacaoFragment
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${SolicitacoesOciHistoricoFragmentFragmentDoc}
${HistoricoPlanoCuidadoFragmentFragmentDoc}
${HistoricoAvaliacaoPecFragmentFragmentDoc}
${HistoricoPlanoPecFragmentFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoConsultaPecQuery__
 *
 * To run a query within a React component, call `useHistoricoConsultaPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoConsultaPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoConsultaPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoConsultaPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables> & ({ variables: Types.HistoricoConsultaPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>(HistoricoConsultaPecDocument, options);
      }
export function useHistoricoConsultaPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>(HistoricoConsultaPecDocument, options);
        }
export function useHistoricoConsultaPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>(HistoricoConsultaPecDocument, options);
        }
export type HistoricoConsultaPecQueryHookResult = ReturnType<typeof useHistoricoConsultaPecQuery>;
export type HistoricoConsultaPecLazyQueryHookResult = ReturnType<typeof useHistoricoConsultaPecLazyQuery>;
export type HistoricoConsultaPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoConsultaPecSuspenseQuery>;
export type HistoricoConsultaPecQueryResult = Apollo.QueryResult<Types.HistoricoConsultaPecQuery, Types.HistoricoConsultaPecQueryVariables>;
export const HistoricoAtendimentoIndividualDwDocument = gql`
    query HistoricoAtendimentoIndividualDw($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoIndividualDw(input: $input) {
    id
    stFicouEmObservacao
    stVacinacaoEmDia
    nuPeso
    nuAltura
    nuImc
    nuPerimetroCefalico
    dum
    stGravidezPlanejada
    nuIdadeGestacional
    nuGestasPrevias
    nuPartos
    dimensaoAleitamento {
      id
      descricao
    }
    dimensaoModalidadeAd {
      id
      descricao
    }
    dimensaoRacionalidadeSaude {
      id
      descricao
    }
    examesSolicitados {
      id
      codigoProcedimento
      descricaoProcedimento
    }
    examesAvaliados {
      id
      codigoProcedimento
      descricaoProcedimento
      dimensaoProcedimentoReferencia {
        id
        codigoProcedimento
        descricaoProcedimento
      }
    }
    resultadosExamesEspecificos {
      id
      dataSolicitacao
      dataRealizacao
      dataResultado
      dataResultadoData
      nuResultadoValor
      nuResultadoDia
      nuResultadoSemana
      dimensaoProcedimento {
        ...HistoricoDimensaoProcedimento
      }
      resultadoPuericultura
      resultadoExameEstruturadoQualitativo
    }
    nasfPolo
    stNasf
    condutaDesfecho
    encaminhamentos
    encaminhamentoServicoEspecializado
    dimensaoProfissional1 {
      id
      nome
    }
    dimensaoProfissional2 {
      id
      nome
    }
    dimensaoCbo1 {
      id
      nome
    }
    dimensaoCbo2 {
      id
      nome
    }
    dimensaoUnidadeSaude1 {
      id
      nome
      cnes
    }
    dimensaoUnidadeSaude2 {
      id
      nome
      cnes
    }
    dimensaoEquipe1 {
      id
      nome
      ine
    }
    dimensaoEquipe2 {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
    dimProfFinalizadorObs {
      id
      nome
    }
    dimCboFinalizadorObs {
      id
      nome
    }
    dimUbsFinalizadorObs {
      id
      nome
      cnes
    }
    dimEquipeFinalizadorObs {
      id
      nome
      ine
    }
    dimTipoParticipacaoCidadao {
      id
      descricao
    }
    dimTipoParticipacaoProfConvidado {
      id
      descricao
    }
    nuCircAbdominal
    nuPerimPanturrilha
    nuPressaoSistolica
    nuPressaoDiastolica
    nuFreqRespiratoria
    nuFreqCardiaca
    nuTemperatura
    nuSaturacaoO2
    nuGlicemia
    dimensaoTipoGlicemia
    medicamentos {
      id
      unidadeMedidaDuracao
      unidadeFrequenciaDose
      tipoFrequencia
      duracao
      quantidade
      dataInicioTratamento
      dose
      doseUnica
      usoContinuo
      doseFrequencia
      frequenciaDose
      qtDoseManha
      qtDoseTarde
      qtDoseNoite
      dimensaoCatmat {
        id
        principioAtivo
        concentracao
        dimensaoFormaFarmaceutica {
          id
          identificador
          nome
          valido
        }
      }
      dimensaoViaAdministracao {
        id
        nome
      }
    }
    problemas {
      id
      dimensaoCiap {
        id
        codigoCiap
        nomeCiap
      }
      dimensaoCid10 {
        id
        codigoCid10
        nomeCid10
      }
      dimensaoSituacaoProblema {
        id
        identificador
        descricao
      }
      dataInicioProblema
      dataFimProblema
    }
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dimensaoGrauVulnerabilidadeIvcf {
        id
        descricao
      }
    }
    solicitacoesOci {
      ...SolicitacoesOciDwFragment
    }
    mchatPontuacao
    mchatRfPontuacao
    dimensaoMchatRisco {
      id
      descricao
    }
    dimensaoMchatRfRisco {
      id
      descricao
    }
    filtroCiapPlano
    filtroCiapMotivoConsulta
    fatoAppAtendimento {
      id
      campoAbertoSubjetivo
      campoAbertoObjetivo
      campoAbertoAvaliacao
      campoAbertoPlano
    }
    encaminhamentosEspecializados {
      id
      dimensaoCid10 {
        id
        codigoCid10
        nomeCid10
      }
      dimensaoCiap {
        id
        codigoCiap
        nomeCiap
      }
      dimensaoClassificacaoRiscoEncaminhamento {
        id
        nome
        identificador
      }
      dimensaoCboGuiaEncaminhamento {
        id
        cbo
        nome
      }
      dimensaoPrioridadeCuidado {
        id
        descricao
        nuIdentificador
      }
      especialidadeSisreg {
        id
        descricao
      }
    }
  }
}
    ${HistoricoDimensaoProcedimentoFragmentDoc}
${SolicitacoesOciDwFragmentFragmentDoc}`;

/**
 * __useHistoricoAtendimentoIndividualDwQuery__
 *
 * To run a query within a React component, call `useHistoricoAtendimentoIndividualDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtendimentoIndividualDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtendimentoIndividualDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtendimentoIndividualDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables> & ({ variables: Types.HistoricoAtendimentoIndividualDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>(HistoricoAtendimentoIndividualDwDocument, options);
      }
export function useHistoricoAtendimentoIndividualDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>(HistoricoAtendimentoIndividualDwDocument, options);
        }
export function useHistoricoAtendimentoIndividualDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>(HistoricoAtendimentoIndividualDwDocument, options);
        }
export type HistoricoAtendimentoIndividualDwQueryHookResult = ReturnType<typeof useHistoricoAtendimentoIndividualDwQuery>;
export type HistoricoAtendimentoIndividualDwLazyQueryHookResult = ReturnType<typeof useHistoricoAtendimentoIndividualDwLazyQuery>;
export type HistoricoAtendimentoIndividualDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtendimentoIndividualDwSuspenseQuery>;
export type HistoricoAtendimentoIndividualDwQueryResult = Apollo.QueryResult<Types.HistoricoAtendimentoIndividualDwQuery, Types.HistoricoAtendimentoIndividualDwQueryVariables>;
export const HistoricoCiapFiltroDocument = gql`
    query HistoricoCiapFiltro($input: CiapByCodigosQueryInput!) {
  ciapsByCodigos(input: $input) {
    ...Ciap
  }
}
    ${CiapFragmentDoc}`;

/**
 * __useHistoricoCiapFiltroQuery__
 *
 * To run a query within a React component, call `useHistoricoCiapFiltroQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoCiapFiltroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoCiapFiltroQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoCiapFiltroQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables> & ({ variables: Types.HistoricoCiapFiltroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>(HistoricoCiapFiltroDocument, options);
      }
export function useHistoricoCiapFiltroLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>(HistoricoCiapFiltroDocument, options);
        }
export function useHistoricoCiapFiltroSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>(HistoricoCiapFiltroDocument, options);
        }
export type HistoricoCiapFiltroQueryHookResult = ReturnType<typeof useHistoricoCiapFiltroQuery>;
export type HistoricoCiapFiltroLazyQueryHookResult = ReturnType<typeof useHistoricoCiapFiltroLazyQuery>;
export type HistoricoCiapFiltroSuspenseQueryHookResult = ReturnType<typeof useHistoricoCiapFiltroSuspenseQuery>;
export type HistoricoCiapFiltroQueryResult = Apollo.QueryResult<Types.HistoricoCiapFiltroQuery, Types.HistoricoCiapFiltroQueryVariables>;
export const HistoricoConcatenadaProcedimentoDocument = gql`
    query HistoricoConcatenadaProcedimento($input: HistoricoDetailQueryInput!) {
  historicoProcedimentoDw(input: $input) {
    id
    procedimentos {
      id
      codigoProcedimento
      descricaoProcedimento
    }
  }
}
    `;

/**
 * __useHistoricoConcatenadaProcedimentoQuery__
 *
 * To run a query within a React component, call `useHistoricoConcatenadaProcedimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoConcatenadaProcedimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoConcatenadaProcedimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoConcatenadaProcedimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables> & ({ variables: Types.HistoricoConcatenadaProcedimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>(HistoricoConcatenadaProcedimentoDocument, options);
      }
export function useHistoricoConcatenadaProcedimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>(HistoricoConcatenadaProcedimentoDocument, options);
        }
export function useHistoricoConcatenadaProcedimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>(HistoricoConcatenadaProcedimentoDocument, options);
        }
export type HistoricoConcatenadaProcedimentoQueryHookResult = ReturnType<typeof useHistoricoConcatenadaProcedimentoQuery>;
export type HistoricoConcatenadaProcedimentoLazyQueryHookResult = ReturnType<typeof useHistoricoConcatenadaProcedimentoLazyQuery>;
export type HistoricoConcatenadaProcedimentoSuspenseQueryHookResult = ReturnType<typeof useHistoricoConcatenadaProcedimentoSuspenseQuery>;
export type HistoricoConcatenadaProcedimentoQueryResult = Apollo.QueryResult<Types.HistoricoConcatenadaProcedimentoQuery, Types.HistoricoConcatenadaProcedimentoQueryVariables>;
export const HistoricoConcatenadaZikaDocument = gql`
    query HistoricoConcatenadaZika($input: HistoricoDetailQueryInput!) {
  historicoZikaDetail(input: $input) {
    examesDeImagem {
      id
      nome
      resultado
      dataRealizacao
    }
    outrosExames {
      id
      nome
      resultado
      dataRealizacao
    }
  }
}
    `;

/**
 * __useHistoricoConcatenadaZikaQuery__
 *
 * To run a query within a React component, call `useHistoricoConcatenadaZikaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoConcatenadaZikaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoConcatenadaZikaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoConcatenadaZikaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables> & ({ variables: Types.HistoricoConcatenadaZikaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>(HistoricoConcatenadaZikaDocument, options);
      }
export function useHistoricoConcatenadaZikaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>(HistoricoConcatenadaZikaDocument, options);
        }
export function useHistoricoConcatenadaZikaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>(HistoricoConcatenadaZikaDocument, options);
        }
export type HistoricoConcatenadaZikaQueryHookResult = ReturnType<typeof useHistoricoConcatenadaZikaQuery>;
export type HistoricoConcatenadaZikaLazyQueryHookResult = ReturnType<typeof useHistoricoConcatenadaZikaLazyQuery>;
export type HistoricoConcatenadaZikaSuspenseQueryHookResult = ReturnType<typeof useHistoricoConcatenadaZikaSuspenseQuery>;
export type HistoricoConcatenadaZikaQueryResult = Apollo.QueryResult<Types.HistoricoConcatenadaZikaQuery, Types.HistoricoConcatenadaZikaQueryVariables>;
export const HistoricoProcedimentoByCodigosDwDocument = gql`
    query HistoricoProcedimentoByCodigosDw($codigos: [String!]!) {
  procedimentosByCodigos(codigos: $codigos) {
    id
    descricao
    codigo
    tipoProcedimento
  }
}
    `;

/**
 * __useHistoricoProcedimentoByCodigosDwQuery__
 *
 * To run a query within a React component, call `useHistoricoProcedimentoByCodigosDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoProcedimentoByCodigosDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoProcedimentoByCodigosDwQuery({
 *   variables: {
 *      codigos: // value for 'codigos'
 *   },
 * });
 */
export function useHistoricoProcedimentoByCodigosDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables> & ({ variables: Types.HistoricoProcedimentoByCodigosDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>(HistoricoProcedimentoByCodigosDwDocument, options);
      }
export function useHistoricoProcedimentoByCodigosDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>(HistoricoProcedimentoByCodigosDwDocument, options);
        }
export function useHistoricoProcedimentoByCodigosDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>(HistoricoProcedimentoByCodigosDwDocument, options);
        }
export type HistoricoProcedimentoByCodigosDwQueryHookResult = ReturnType<typeof useHistoricoProcedimentoByCodigosDwQuery>;
export type HistoricoProcedimentoByCodigosDwLazyQueryHookResult = ReturnType<typeof useHistoricoProcedimentoByCodigosDwLazyQuery>;
export type HistoricoProcedimentoByCodigosDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoProcedimentoByCodigosDwSuspenseQuery>;
export type HistoricoProcedimentoByCodigosDwQueryResult = Apollo.QueryResult<Types.HistoricoProcedimentoByCodigosDwQuery, Types.HistoricoProcedimentoByCodigosDwQueryVariables>;
export const HistoricoPreNatalPecDocument = gql`
    query HistoricoPreNatalPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    medicoes {
      id
      valorAlturaUterina
      valorBatimentoCardiacoFetal
      valorBatimentoCardiacoFetal2
      medicaoAnterior
      dataMedicao
    }
    ...HistoricoPlanoCuidadoFragment
    atendimentoProfissionalPreNatal {
      id
      gravidezPlanejada
      movimentacaoFetal
      tipoEdema
    }
    ...HistoricoAvaliacaoPecFragment
    ...HistoricoPlanoPecFragment
    ...HistoricoAntecedentesPecFragment
    ...HistoricoRegistrosAnterioresVacinacaoFragment
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
    solicitacoesOci {
      ...SolicitacoesOciHistoricoFragment
    }
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${HistoricoPlanoCuidadoFragmentFragmentDoc}
${HistoricoAvaliacaoPecFragmentFragmentDoc}
${HistoricoPlanoPecFragmentFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}
${SolicitacoesOciHistoricoFragmentFragmentDoc}`;

/**
 * __useHistoricoPreNatalPecQuery__
 *
 * To run a query within a React component, call `useHistoricoPreNatalPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPreNatalPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPreNatalPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPreNatalPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables> & ({ variables: Types.HistoricoPreNatalPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>(HistoricoPreNatalPecDocument, options);
      }
export function useHistoricoPreNatalPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>(HistoricoPreNatalPecDocument, options);
        }
export function useHistoricoPreNatalPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>(HistoricoPreNatalPecDocument, options);
        }
export type HistoricoPreNatalPecQueryHookResult = ReturnType<typeof useHistoricoPreNatalPecQuery>;
export type HistoricoPreNatalPecLazyQueryHookResult = ReturnType<typeof useHistoricoPreNatalPecLazyQuery>;
export type HistoricoPreNatalPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoPreNatalPecSuspenseQuery>;
export type HistoricoPreNatalPecQueryResult = Apollo.QueryResult<Types.HistoricoPreNatalPecQuery, Types.HistoricoPreNatalPecQueryVariables>;
export const HistoricoPuericulturaPecDocument = gql`
    query HistoricoPuericulturaPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    medicoes {
      id
      valorAlturaUterina
      valorBatimentoCardiacoFetal
      valorBatimentoCardiacoFetal2
      medicaoAnterior
      dataMedicao
    }
    ...HistoricoPlanoCuidadoFragment
    atendimentoProfissionalPuericultura {
      id
      aleitamentoMaterno
      neuroAlteracaoFenotipica {
        id
        statusAvaliacao
        alteracaoFenotipicaDetalhe {
          id
          descricao
        }
      }
      neuroFatorRisco {
        id
        statusAvaliacao
        fatorRiscoDetalhe {
          id
          descricao
        }
      }
      neuroMarco {
        id
        statusAvaliacao
        marcoDetalhe {
          id
          titulo
          faixaEtaria {
            id
            descricao
          }
        }
        anosIdadeRegistro
        mesesIdadeRegistro
      }
    }
    ...HistoricoAvaliacaoPecFragment
    ...HistoricoPlanoPecFragment
    ...HistoricoAntecedentesPecFragment
    ...HistoricoRegistrosAnterioresVacinacaoFragment
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
    solicitacoesOci {
      ...SolicitacoesOciHistoricoFragment
    }
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${HistoricoPlanoCuidadoFragmentFragmentDoc}
${HistoricoAvaliacaoPecFragmentFragmentDoc}
${HistoricoPlanoPecFragmentFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}
${SolicitacoesOciHistoricoFragmentFragmentDoc}`;

/**
 * __useHistoricoPuericulturaPecQuery__
 *
 * To run a query within a React component, call `useHistoricoPuericulturaPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPuericulturaPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPuericulturaPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPuericulturaPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables> & ({ variables: Types.HistoricoPuericulturaPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>(HistoricoPuericulturaPecDocument, options);
      }
export function useHistoricoPuericulturaPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>(HistoricoPuericulturaPecDocument, options);
        }
export function useHistoricoPuericulturaPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>(HistoricoPuericulturaPecDocument, options);
        }
export type HistoricoPuericulturaPecQueryHookResult = ReturnType<typeof useHistoricoPuericulturaPecQuery>;
export type HistoricoPuericulturaPecLazyQueryHookResult = ReturnType<typeof useHistoricoPuericulturaPecLazyQuery>;
export type HistoricoPuericulturaPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoPuericulturaPecSuspenseQuery>;
export type HistoricoPuericulturaPecQueryResult = Apollo.QueryResult<Types.HistoricoPuericulturaPecQuery, Types.HistoricoPuericulturaPecQueryVariables>;
export const HistoricoPuerperioPecDocument = gql`
    query HistoricoPuerperioPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    medicoes {
      id
      medicaoAnterior
      dataMedicao
    }
    ...HistoricoPlanoCuidadoFragment
    ...HistoricoAvaliacaoPecFragment
    ...HistoricoPlanoPecFragment
    ...HistoricoAntecedentesPecFragment
    ...HistoricoRegistrosAnterioresVacinacaoFragment
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
    solicitacoesOci {
      ...SolicitacoesOciHistoricoFragment
    }
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${HistoricoPlanoCuidadoFragmentFragmentDoc}
${HistoricoAvaliacaoPecFragmentFragmentDoc}
${HistoricoPlanoPecFragmentFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}
${SolicitacoesOciHistoricoFragmentFragmentDoc}`;

/**
 * __useHistoricoPuerperioPecQuery__
 *
 * To run a query within a React component, call `useHistoricoPuerperioPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPuerperioPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPuerperioPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPuerperioPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables> & ({ variables: Types.HistoricoPuerperioPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>(HistoricoPuerperioPecDocument, options);
      }
export function useHistoricoPuerperioPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>(HistoricoPuerperioPecDocument, options);
        }
export function useHistoricoPuerperioPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>(HistoricoPuerperioPecDocument, options);
        }
export type HistoricoPuerperioPecQueryHookResult = ReturnType<typeof useHistoricoPuerperioPecQuery>;
export type HistoricoPuerperioPecLazyQueryHookResult = ReturnType<typeof useHistoricoPuerperioPecLazyQuery>;
export type HistoricoPuerperioPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoPuerperioPecSuspenseQuery>;
export type HistoricoPuerperioPecQueryResult = Apollo.QueryResult<Types.HistoricoPuerperioPecQuery, Types.HistoricoPuerperioPecQueryVariables>;
export const HistoricoAtendimentoOdontologicoDwDocument = gql`
    query HistoricoAtendimentoOdontologicoDw($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoOdontoDw(input: $input) {
    id
    isPacienteNecessidadesEspeciais
    isGestante
    vigilanciaSaudeBucal
    fornecimento
    conduta
    encaminhamento
    procedimentos {
      id
      dimensaoProcedimento {
        id
        codigoProcedimento
        descricaoProcedimento
      }
      quantidadeProcedimentos
    }
    dimensaoProfissional1 {
      id
      nome
    }
    dimensaoProfissional2 {
      id
      nome
    }
    dimensaoCbo1 {
      id
      nome
    }
    dimensaoCbo2 {
      id
      nome
    }
    dimensaoUnidadeSaude1 {
      id
      nome
      cnes
    }
    dimensaoUnidadeSaude2 {
      id
      nome
      cnes
    }
    dimensaoEquipe1 {
      id
      nome
      ine
    }
    dimensaoEquipe2 {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
    dimTipoParticipacaoCidadao {
      id
      descricao
    }
    dimTipoParticipacaoProfConvidado {
      id
      descricao
    }
    nuPeso
    nuAltura
    nuPerimetroCefalico
    nuCircAbdominal
    nuPerimPanturrilha
    nuPressaoSistolica
    nuPressaoDiastolica
    nuFreqRespiratoria
    nuFreqCardiaca
    nuTemperatura
    nuSaturacaoO2
    nuImc
    nuGlicemia
    dimensaoTipoGlicemia
    medicamentos {
      id
      unidadeMedidaDuracao
      unidadeFrequenciaDose
      tipoFrequencia
      duracao
      quantidade
      dataInicioTratamento
      dose
      doseUnica
      usoContinuo
      doseFrequencia
      frequenciaDose
      qtDoseManha
      qtDoseTarde
      qtDoseNoite
      dimensaoCatmat {
        id
        principioAtivo
        concentracao
        dimensaoFormaFarmaceutica {
          id
          identificador
          nome
          valido
        }
      }
      dimensaoViaAdministracao {
        id
        nome
      }
    }
    problemas {
      id
      dimensaoCiap {
        id
        codigoCiap
        nomeCiap
      }
      dimensaoCid10 {
        id
        codigoCid10
        nomeCid10
      }
      dimensaoSituacaoProblema {
        id
        identificador
        descricao
      }
      dataInicioProblema
      dataFimProblema
    }
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dimensaoGrauVulnerabilidadeIvcf {
        id
        descricao
      }
    }
    exames {
      id
      dataSolicitacao
      dataRealizacao
      dataResultado
      dataResultadoData
      nuResultadoValor
      nuResultadoDia
      nuResultadoSemana
      dimensaoProcedimentoAvaliado {
        ...HistoricoDimensaoProcedimento
      }
      dimensaoProcedimentoSolicitado {
        ...HistoricoDimensaoProcedimento
      }
      resultadoPuericultura
      resultadoExameEstruturadoQualitativo
    }
    solicitacoesOci {
      ...SolicitacoesOciDwFragment
    }
    encaminhamentosEspecializados {
      id
      dimensaoCid10 {
        id
        codigoCid10
        nomeCid10
      }
      dimensaoCiap {
        id
        codigoCiap
        nomeCiap
      }
      dimensaoClassificacaoRiscoEncaminhamento {
        id
        nome
        identificador
      }
      dimensaoCboGuiaEncaminhamento {
        id
        cbo
        nome
      }
      dimensaoPrioridadeCuidado {
        id
        descricao
        nuIdentificador
      }
      especialidadeSisreg {
        id
        descricao
      }
    }
  }
}
    ${HistoricoDimensaoProcedimentoFragmentDoc}
${SolicitacoesOciDwFragmentFragmentDoc}`;

/**
 * __useHistoricoAtendimentoOdontologicoDwQuery__
 *
 * To run a query within a React component, call `useHistoricoAtendimentoOdontologicoDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtendimentoOdontologicoDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtendimentoOdontologicoDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtendimentoOdontologicoDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables> & ({ variables: Types.HistoricoAtendimentoOdontologicoDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>(HistoricoAtendimentoOdontologicoDwDocument, options);
      }
export function useHistoricoAtendimentoOdontologicoDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>(HistoricoAtendimentoOdontologicoDwDocument, options);
        }
export function useHistoricoAtendimentoOdontologicoDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>(HistoricoAtendimentoOdontologicoDwDocument, options);
        }
export type HistoricoAtendimentoOdontologicoDwQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontologicoDwQuery>;
export type HistoricoAtendimentoOdontologicoDwLazyQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontologicoDwLazyQuery>;
export type HistoricoAtendimentoOdontologicoDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontologicoDwSuspenseQuery>;
export type HistoricoAtendimentoOdontologicoDwQueryResult = Apollo.QueryResult<Types.HistoricoAtendimentoOdontologicoDwQuery, Types.HistoricoAtendimentoOdontologicoDwQueryVariables>;
export const HistoricoAtendimentoOdontoPecDocument = gql`
    query HistoricoAtendimentoOdontoPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    evolucaoObjetivo {
      id
      descricao
      necessidadesEspeciais
    }
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    medicoes {
      id
      medicaoAnterior
      dataMedicao
    }
    ...HistoricoAvaliacaoPecFragment
    evolucaoAvaliacao {
      id
      necessidadeDeProtese
      tiposVigilanciaBucal
    }
    ...HistoricoPlanoPecFragment
    atendimentoProfissionalOdonto {
      id
      odontograma {
        id
        proteseTotalInferior
        proteseTotalSuperior
        contencao
        aparelho
      }
      evolucoes {
        id
        procedimentos {
          id
          descricao
          codigo
        }
        partesBucais {
          id
          tipoParteBucal
          descricao
          parteBucalEnum
        }
        descricaoParteBucal
        observacao
      }
      periogramaSimplificado {
        id
        avaliacaoSextante1
        avaliacaoSextante2
        avaliacaoSextante3
        avaliacaoSextante4
        avaliacaoSextante5
        avaliacaoSextante6
        observacao
      }
      periogramaCompleto {
        id
        dente {
          id
          parteBucalEnum
        }
        excluido
        profundidadeVestibular
        recessaoVestibular
        profundidadeInterna
        recessaoInterna
        placaDVestibular
        placaVVestibular
        placaMVestibular
        sangramentoDVestibular
        sangramentoVVestibular
        sangramentoMVestibular
        placaDInterna
        placaVInterna
        placaMInterna
        sangramentoDInterna
        sangramentoVInterna
        sangramentoMInterna
        mobilidade
        lesaoDeFurca
      }
      observacaoRPC
      tecidosMoles {
        id
        descricaoSintomatologia
        parteBucal {
          id
          descricao
        }
        cid10 {
          ...Cid10
        }
        caracteristicasLesao {
          id
          caracteristicaLesao
        }
        evolucaoProcedimentoOdonto {
          id
          procedimentos {
            id
            descricao
            codigo
          }
          observacao
        }
      }
    }
    solicitacoesOci {
      ...SolicitacoesOciHistoricoFragment
    }
    ...HistoricoAntecedentesPecFragment
    ...HistoricoRegistrosAnterioresVacinacaoFragment
    ...HistoricoDesfechoOdontoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${HistoricoAvaliacaoPecFragmentFragmentDoc}
${HistoricoPlanoPecFragmentFragmentDoc}
${Cid10FragmentDoc}
${SolicitacoesOciHistoricoFragmentFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoRegistrosAnterioresVacinacaoFragmentFragmentDoc}
${HistoricoDesfechoOdontoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoAtendimentoOdontoPecQuery__
 *
 * To run a query within a React component, call `useHistoricoAtendimentoOdontoPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtendimentoOdontoPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtendimentoOdontoPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtendimentoOdontoPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables> & ({ variables: Types.HistoricoAtendimentoOdontoPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>(HistoricoAtendimentoOdontoPecDocument, options);
      }
export function useHistoricoAtendimentoOdontoPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>(HistoricoAtendimentoOdontoPecDocument, options);
        }
export function useHistoricoAtendimentoOdontoPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>(HistoricoAtendimentoOdontoPecDocument, options);
        }
export type HistoricoAtendimentoOdontoPecQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontoPecQuery>;
export type HistoricoAtendimentoOdontoPecLazyQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontoPecLazyQuery>;
export type HistoricoAtendimentoOdontoPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtendimentoOdontoPecSuspenseQuery>;
export type HistoricoAtendimentoOdontoPecQueryResult = Apollo.QueryResult<Types.HistoricoAtendimentoOdontoPecQuery, Types.HistoricoAtendimentoOdontoPecQueryVariables>;
export const HistoricoAtividadeColetivaDocument = gql`
    query HistoricoAtividadeColetiva($input: HistoricoDetailQueryInput!) {
  historicoAtividadeColetiva(input: $input) {
    id
    nuUuidFicha
    stAvaliacaoAlterada
    nuPesoParticipante
    nuAlturaParticipante
    nuImcParticipante
    stPnctAbandonouGrupo
    stPnctCessouHabitoFumar
    fatoAtividadeColetiva {
      id
      dimensaoProcedimento {
        id
        descricaoProcedimento
        codigoProcedimento
      }
      dimensaoProfissional {
        id
        cns
        nome
      }
      dimensaoCbo {
        id
        nome
      }
      dimensaoUnidadeSaude {
        id
        nome
        cnes
      }
      dimensaoEquipe {
        id
        nome
        ine
      }
      dimensaoTipoAtividade {
        id
        descricaoTipoAtividade
      }
      dimensaoInep {
        id
        nuIdentificador
        noEstabelecimento
      }
      dimensaoUnddSadeAcdmSade {
        id
        nome
        cnes
      }
      descricaoOutraLocalidade
      nuAvaliacoesAlteradas
      stPseEducacao
      stPseSaude
      temasSaude
      praticasSaude
      publicoAlvo
    }
  }
}
    `;

/**
 * __useHistoricoAtividadeColetivaQuery__
 *
 * To run a query within a React component, call `useHistoricoAtividadeColetivaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtividadeColetivaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtividadeColetivaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAtividadeColetivaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables> & ({ variables: Types.HistoricoAtividadeColetivaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>(HistoricoAtividadeColetivaDocument, options);
      }
export function useHistoricoAtividadeColetivaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>(HistoricoAtividadeColetivaDocument, options);
        }
export function useHistoricoAtividadeColetivaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>(HistoricoAtividadeColetivaDocument, options);
        }
export type HistoricoAtividadeColetivaQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaQuery>;
export type HistoricoAtividadeColetivaLazyQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaLazyQuery>;
export type HistoricoAtividadeColetivaSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaSuspenseQuery>;
export type HistoricoAtividadeColetivaQueryResult = Apollo.QueryResult<Types.HistoricoAtividadeColetivaQuery, Types.HistoricoAtividadeColetivaQueryVariables>;
export const HistoricoAtividadeColetivaReuniaoDocument = gql`
    query HistoricoAtividadeColetivaReuniao($atividadeColetivaId: Long!, $cidadaoId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    tipoAtividade
    temasReuniao
    lotacaoResponsavel {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
    }
    inepLocalAtividade {
      id
      nomeEstabelecimento
      dsInep
    }
    unidadeSaudeLocalAtividade {
      id
      cnes
      nome
    }
    outraLocalidade
    observacaoCidadao: observacao(cidadaoId: $cidadaoId) {
      id
      observacao
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useHistoricoAtividadeColetivaReuniaoQuery__
 *
 * To run a query within a React component, call `useHistoricoAtividadeColetivaReuniaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtividadeColetivaReuniaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtividadeColetivaReuniaoQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useHistoricoAtividadeColetivaReuniaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables> & ({ variables: Types.HistoricoAtividadeColetivaReuniaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>(HistoricoAtividadeColetivaReuniaoDocument, options);
      }
export function useHistoricoAtividadeColetivaReuniaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>(HistoricoAtividadeColetivaReuniaoDocument, options);
        }
export function useHistoricoAtividadeColetivaReuniaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>(HistoricoAtividadeColetivaReuniaoDocument, options);
        }
export type HistoricoAtividadeColetivaReuniaoQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaReuniaoQuery>;
export type HistoricoAtividadeColetivaReuniaoLazyQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaReuniaoLazyQuery>;
export type HistoricoAtividadeColetivaReuniaoSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaReuniaoSuspenseQuery>;
export type HistoricoAtividadeColetivaReuniaoQueryResult = Apollo.QueryResult<Types.HistoricoAtividadeColetivaReuniaoQuery, Types.HistoricoAtividadeColetivaReuniaoQueryVariables>;
export const HistoricoAtividadeColetivaSaudeDocument = gql`
    query HistoricoAtividadeColetivaSaude($atividadeColetivaId: Long!, $cidadaoId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    tipoAtividade
    temasSaude
    praticasSaude
    publicoAlvo
    procedimento {
      id
      descricao
      codigo
    }
    lotacaoResponsavel {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
    }
    inepLocalAtividade {
      id
      nomeEstabelecimento
      dsInep
    }
    unidadeSaudeLocalAtividade {
      id
      cnes
      nome
    }
    outraLocalidade
    anotacoes
    atividadeEducacaoPse
    atividadeSaudePse
    participante(cidadaoId: $cidadaoId) {
      id
      atividadeColetivaId
      peso
      altura
      avaliacaoAlterada
      pnctAbandonouGrupo
      pnctCessouHabitoFumar
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useHistoricoAtividadeColetivaSaudeQuery__
 *
 * To run a query within a React component, call `useHistoricoAtividadeColetivaSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAtividadeColetivaSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAtividadeColetivaSaudeQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useHistoricoAtividadeColetivaSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables> & ({ variables: Types.HistoricoAtividadeColetivaSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>(HistoricoAtividadeColetivaSaudeDocument, options);
      }
export function useHistoricoAtividadeColetivaSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>(HistoricoAtividadeColetivaSaudeDocument, options);
        }
export function useHistoricoAtividadeColetivaSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>(HistoricoAtividadeColetivaSaudeDocument, options);
        }
export type HistoricoAtividadeColetivaSaudeQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaSaudeQuery>;
export type HistoricoAtividadeColetivaSaudeLazyQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaSaudeLazyQuery>;
export type HistoricoAtividadeColetivaSaudeSuspenseQueryHookResult = ReturnType<typeof useHistoricoAtividadeColetivaSaudeSuspenseQuery>;
export type HistoricoAtividadeColetivaSaudeQueryResult = Apollo.QueryResult<Types.HistoricoAtividadeColetivaSaudeQuery, Types.HistoricoAtividadeColetivaSaudeQueryVariables>;
export const HistoricoAvaliacaoElegibilidadeAdDocument = gql`
    query HistoricoAvaliacaoElegibilidadeAD($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    atendimentoProfissionalAD {
      id
      origem
      modalidade
      elegivel
      conclusao
      cid10Principal {
        id
        codigo
        nome
      }
      cid10Secundario1 {
        id
        codigo
        nome
      }
      cid10Secundario2 {
        id
        codigo
        nome
      }
      condicoesAvaliadasElegibilidade {
        id
        situacaoAtiva
        descricao
      }
      conduta
    }
    cidadaoAD {
      id
      dataObito
      numeroDocumentoObito
    }
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoAvaliacaoElegibilidadeAdQuery__
 *
 * To run a query within a React component, call `useHistoricoAvaliacaoElegibilidadeAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAvaliacaoElegibilidadeAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAvaliacaoElegibilidadeAdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAvaliacaoElegibilidadeAdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables> & ({ variables: Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>(HistoricoAvaliacaoElegibilidadeAdDocument, options);
      }
export function useHistoricoAvaliacaoElegibilidadeAdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>(HistoricoAvaliacaoElegibilidadeAdDocument, options);
        }
export function useHistoricoAvaliacaoElegibilidadeAdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>(HistoricoAvaliacaoElegibilidadeAdDocument, options);
        }
export type HistoricoAvaliacaoElegibilidadeAdQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeAdQuery>;
export type HistoricoAvaliacaoElegibilidadeAdLazyQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeAdLazyQuery>;
export type HistoricoAvaliacaoElegibilidadeAdSuspenseQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeAdSuspenseQuery>;
export type HistoricoAvaliacaoElegibilidadeAdQueryResult = Apollo.QueryResult<Types.HistoricoAvaliacaoElegibilidadeAdQuery, Types.HistoricoAvaliacaoElegibilidadeAdQueryVariables>;
export const HistoricoAvaliacaoElegibilidadeDwDocument = gql`
    query HistoricoAvaliacaoElegibilidadeDw($input: HistoricoDetailQueryInput!) {
  historicoElegibilidadeDetail(input: $input) {
    id
    nuUuidFicha
    dimensaoCid10Principal {
      id
      codigoCid10
      nomeCid10
    }
    dimensaoCid10SecundarioUm {
      id
      codigoCid10
      nomeCid10
    }
    dimensaoCid10SecundarioDois {
      id
      codigoCid10
      nomeCid10
    }
    procedenciaOrigem
    dimensaoProfissional1 {
      id
      cns
      nome
    }
    dimensaoCbo1 {
      id
      cbo
      nome
    }
    dimensaoUnidadeSaude1 {
      id
      nome
      cnes
    }
    dimensaoEquipe1 {
      id
      nome
      ine
    }
    dimensaoProfissional2 {
      id
      cns
      nome
    }
    dimensaoCbo2 {
      id
      cbo
      nome
    }
    dimensaoUnidadeSaude2 {
      id
      nome
      cnes
    }
    dimensaoEquipe2 {
      id
      nome
      ine
    }
    dimensaoCuidador {
      id
      descricao
    }
    dimensaoModalidadeAD {
      id
      descricao
    }
    condicoesAvaliadas
    conclusao
    isElegivel
    cpfCuidador
    cnsCuidador
  }
}
    `;

/**
 * __useHistoricoAvaliacaoElegibilidadeDwQuery__
 *
 * To run a query within a React component, call `useHistoricoAvaliacaoElegibilidadeDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAvaliacaoElegibilidadeDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAvaliacaoElegibilidadeDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAvaliacaoElegibilidadeDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables> & ({ variables: Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>(HistoricoAvaliacaoElegibilidadeDwDocument, options);
      }
export function useHistoricoAvaliacaoElegibilidadeDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>(HistoricoAvaliacaoElegibilidadeDwDocument, options);
        }
export function useHistoricoAvaliacaoElegibilidadeDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>(HistoricoAvaliacaoElegibilidadeDwDocument, options);
        }
export type HistoricoAvaliacaoElegibilidadeDwQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeDwQuery>;
export type HistoricoAvaliacaoElegibilidadeDwLazyQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeDwLazyQuery>;
export type HistoricoAvaliacaoElegibilidadeDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoAvaliacaoElegibilidadeDwSuspenseQuery>;
export type HistoricoAvaliacaoElegibilidadeDwQueryResult = Apollo.QueryResult<Types.HistoricoAvaliacaoElegibilidadeDwQuery, Types.HistoricoAvaliacaoElegibilidadeDwQueryVariables>;
export const HistoricoCuidadoCompartilhadoDwDetalhesDocument = gql`
    query HistoricoCuidadoCompartilhadoDwDetalhes($input: HistoricoDetailQueryInput!) {
  historicoCuidadoCompartilhadoDw(input: $input) {
    id
    dataCriacaoCuidado
    codigoSequencialEvolucao
    isExecutante
    dimProfissionalSolicitante {
      id
      nome
    }
    dimCboSolicitante {
      id
      nome
    }
    dimUnidadeSaudeSolicitante {
      id
      nome
      cnes
    }
    dimEquipeSolicitante {
      id
      nome
      ine
    }
    dimProfissionalExecutante {
      id
      nome
    }
    dimCboExecutante {
      id
      nome
    }
    dimUnidadeSaudeExecutante {
      id
      nome
      cnes
    }
    dimEquipeExecutante {
      id
      nome
      ine
    }
    dimensaoCondutaCuidado {
      id
      nuIdentificador
    }
    dimensaoCid10 {
      id
      codigoCid10
      nomeCid10
    }
    dimensaoCiap {
      id
      codigoCiap
      nomeCiap
    }
    dimensaoPrioridadeCuidado {
      id
      descricao
    }
    dimReclassificacaoPrioridade {
      id
      descricao
    }
  }
}
    `;

/**
 * __useHistoricoCuidadoCompartilhadoDwDetalhesQuery__
 *
 * To run a query within a React component, call `useHistoricoCuidadoCompartilhadoDwDetalhesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoCuidadoCompartilhadoDwDetalhesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoCuidadoCompartilhadoDwDetalhesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoCuidadoCompartilhadoDwDetalhesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables> & ({ variables: Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoDwDetalhesDocument, options);
      }
export function useHistoricoCuidadoCompartilhadoDwDetalhesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoDwDetalhesDocument, options);
        }
export function useHistoricoCuidadoCompartilhadoDwDetalhesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoDwDetalhesDocument, options);
        }
export type HistoricoCuidadoCompartilhadoDwDetalhesQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoDwDetalhesQuery>;
export type HistoricoCuidadoCompartilhadoDwDetalhesLazyQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoDwDetalhesLazyQuery>;
export type HistoricoCuidadoCompartilhadoDwDetalhesSuspenseQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoDwDetalhesSuspenseQuery>;
export type HistoricoCuidadoCompartilhadoDwDetalhesQueryResult = Apollo.QueryResult<Types.HistoricoCuidadoCompartilhadoDwDetalhesQuery, Types.HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables>;
export const HistoricoCuidadoCompartilhadoEvolucaoDetalhesDocument = gql`
    query HistoricoCuidadoCompartilhadoEvolucaoDetalhes($id: ID!) {
  cuidadoCompartilhadoEvolucao(id: $id) {
    id
    conduta
    dataEvolucao
    descricao
    codigoSequencialEvolucao
    classificacaoPrioridade
    reclassificacaoPrioridade
    enviarGarantiaAcesso
    lotacao {
      ...LotacaoHistoricoCuidadoCompartilhadoHeader
    }
    cuidadoCompartilhado {
      id
      iniciadoEm
      discussao
      atendimentoProfissional {
        id
        atendimento {
          id
          localAtendimento {
            id
            localAtendimentoExibicao
          }
          unidadeSaude {
            id
            nome
            cnes
          }
        }
      }
    }
    agenda {
      id
      horarioInicial
      observacao
      situacao
    }
  }
}
    ${LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;

/**
 * __useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery__
 *
 * To run a query within a React component, call `useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables> & ({ variables: Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoEvolucaoDetalhesDocument, options);
      }
export function useHistoricoCuidadoCompartilhadoEvolucaoDetalhesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoEvolucaoDetalhesDocument, options);
        }
export function useHistoricoCuidadoCompartilhadoEvolucaoDetalhesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>(HistoricoCuidadoCompartilhadoEvolucaoDetalhesDocument, options);
        }
export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery>;
export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesLazyQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoEvolucaoDetalhesLazyQuery>;
export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesSuspenseQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoEvolucaoDetalhesSuspenseQuery>;
export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryResult = Apollo.QueryResult<Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery, Types.HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables>;
export const HistoricoCuidadoCompartilhadoLotacaoAfetadaDocument = gql`
    query HistoricoCuidadoCompartilhadoLotacaoAfetada($id: ID!) {
  cuidadoCompartilhadoEvolucao(id: $id) {
    id
    lotacaoAfetada {
      ...LotacaoHistoricoCuidadoCompartilhadoHeader
    }
  }
}
    ${LotacaoHistoricoCuidadoCompartilhadoHeaderFragmentDoc}`;

/**
 * __useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery__
 *
 * To run a query within a React component, call `useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables> & ({ variables: Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>(HistoricoCuidadoCompartilhadoLotacaoAfetadaDocument, options);
      }
export function useHistoricoCuidadoCompartilhadoLotacaoAfetadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>(HistoricoCuidadoCompartilhadoLotacaoAfetadaDocument, options);
        }
export function useHistoricoCuidadoCompartilhadoLotacaoAfetadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>(HistoricoCuidadoCompartilhadoLotacaoAfetadaDocument, options);
        }
export type HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery>;
export type HistoricoCuidadoCompartilhadoLotacaoAfetadaLazyQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoLotacaoAfetadaLazyQuery>;
export type HistoricoCuidadoCompartilhadoLotacaoAfetadaSuspenseQueryHookResult = ReturnType<typeof useHistoricoCuidadoCompartilhadoLotacaoAfetadaSuspenseQuery>;
export type HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryResult = Apollo.QueryResult<Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery, Types.HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables>;
export const HistoricoEscutaInicialDocument = gql`
    query HistoricoEscutaInicial($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    evolucaoSubjetivo {
      id
      acompanhadoEspecialidade
    }
    classificacaoRisco
    medicoes {
      ...MedicoesFragment
      valorImc
    }
    procedimentosAtendimento {
      id
      procedimento {
        id
        descricao
        codigo
        tipoProcedimento
      }
      obrigatorio
      automatico
    }
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${MedicoesFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoEscutaInicialQuery__
 *
 * To run a query within a React component, call `useHistoricoEscutaInicialQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoEscutaInicialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoEscutaInicialQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoEscutaInicialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables> & ({ variables: Types.HistoricoEscutaInicialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>(HistoricoEscutaInicialDocument, options);
      }
export function useHistoricoEscutaInicialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>(HistoricoEscutaInicialDocument, options);
        }
export function useHistoricoEscutaInicialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>(HistoricoEscutaInicialDocument, options);
        }
export type HistoricoEscutaInicialQueryHookResult = ReturnType<typeof useHistoricoEscutaInicialQuery>;
export type HistoricoEscutaInicialLazyQueryHookResult = ReturnType<typeof useHistoricoEscutaInicialLazyQuery>;
export type HistoricoEscutaInicialSuspenseQueryHookResult = ReturnType<typeof useHistoricoEscutaInicialSuspenseQuery>;
export type HistoricoEscutaInicialQueryResult = Apollo.QueryResult<Types.HistoricoEscutaInicialQuery, Types.HistoricoEscutaInicialQueryVariables>;
export const HistoricoMarcadoresConsumoAlimentarDocument = gql`
    query HistoricoMarcadoresConsumoAlimentar($input: HistoricoDetailQueryInput!) {
  historicoConsumoAlimentarDetail(input: $input) {
    id
    subtitle
    questionario
    perguntasRespostas {
      pergunta
      respostas
    }
    perguntasRespostasOntem {
      pergunta
      respostas
    }
    dimensaoProfissional {
      id
      nome
    }
    dimensaoCbo {
      id
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
  }
}
    `;

/**
 * __useHistoricoMarcadoresConsumoAlimentarQuery__
 *
 * To run a query within a React component, call `useHistoricoMarcadoresConsumoAlimentarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoMarcadoresConsumoAlimentarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoMarcadoresConsumoAlimentarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoMarcadoresConsumoAlimentarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables> & ({ variables: Types.HistoricoMarcadoresConsumoAlimentarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>(HistoricoMarcadoresConsumoAlimentarDocument, options);
      }
export function useHistoricoMarcadoresConsumoAlimentarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>(HistoricoMarcadoresConsumoAlimentarDocument, options);
        }
export function useHistoricoMarcadoresConsumoAlimentarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>(HistoricoMarcadoresConsumoAlimentarDocument, options);
        }
export type HistoricoMarcadoresConsumoAlimentarQueryHookResult = ReturnType<typeof useHistoricoMarcadoresConsumoAlimentarQuery>;
export type HistoricoMarcadoresConsumoAlimentarLazyQueryHookResult = ReturnType<typeof useHistoricoMarcadoresConsumoAlimentarLazyQuery>;
export type HistoricoMarcadoresConsumoAlimentarSuspenseQueryHookResult = ReturnType<typeof useHistoricoMarcadoresConsumoAlimentarSuspenseQuery>;
export type HistoricoMarcadoresConsumoAlimentarQueryResult = Apollo.QueryResult<Types.HistoricoMarcadoresConsumoAlimentarQuery, Types.HistoricoMarcadoresConsumoAlimentarQueryVariables>;
export const HistoricoProcedimentoDwDocument = gql`
    query HistoricoProcedimentoDw($input: HistoricoDetailQueryInput!) {
  historicoProcedimentoDw(input: $input) {
    id
    procedimentos {
      id
      codigoProcedimento
      descricaoProcedimento
    }
    dimensaoProfissional {
      id
      nome
    }
    dimensaoCbo {
      id
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
    nuPeso
    nuAltura
    nuPerimetroCefalico
    nuCircAbdominal
    nuPerimPanturrilha
    nuPressaoSistolica
    nuPressaoDiastolica
    nuFreqRespiratoria
    nuFreqCardiaca
    nuTemperatura
    nuSaturacaoO2
    nuImc
    nuGlicemia
    dimensaoTipoGlicemia
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dimensaoGrauVulnerabilidadeIvcf {
        id
        descricao
      }
    }
    filtroCiapPlano
    filtroCiapMotivoConsulta
    fatoAppAtendimento {
      id
      campoAbertoSubjetivo
      campoAbertoObjetivo
      campoAbertoAvaliacao
      campoAbertoPlano
    }
  }
}
    `;

/**
 * __useHistoricoProcedimentoDwQuery__
 *
 * To run a query within a React component, call `useHistoricoProcedimentoDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoProcedimentoDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoProcedimentoDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoProcedimentoDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables> & ({ variables: Types.HistoricoProcedimentoDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>(HistoricoProcedimentoDwDocument, options);
      }
export function useHistoricoProcedimentoDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>(HistoricoProcedimentoDwDocument, options);
        }
export function useHistoricoProcedimentoDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>(HistoricoProcedimentoDwDocument, options);
        }
export type HistoricoProcedimentoDwQueryHookResult = ReturnType<typeof useHistoricoProcedimentoDwQuery>;
export type HistoricoProcedimentoDwLazyQueryHookResult = ReturnType<typeof useHistoricoProcedimentoDwLazyQuery>;
export type HistoricoProcedimentoDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoProcedimentoDwSuspenseQuery>;
export type HistoricoProcedimentoDwQueryResult = Apollo.QueryResult<Types.HistoricoProcedimentoDwQuery, Types.HistoricoProcedimentoDwQueryVariables>;
export const HistoricoProcedimentoPecDocument = gql`
    query HistoricoProcedimentoPec($input: HistoricoDetailQueryInput!) {
  historicoAtendimentoPec(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    ...HistoricoObjetivoPecFragment
    evolucaoPlano {
      id
      descricao
      intervencoesProcedimentos {
        id
        ciap {
          ...Ciap
        }
        procedimento {
          id
          descricao
          codigo
        }
        nota
      }
    }
    planosDeCuidado {
      id
      descricao
      dataDescricao
    }
    quantidadeOrientacoes
    ...HistoricoAntecedentesPecFragment
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${HistoricoObjetivoPecFragmentFragmentDoc}
${CiapFragmentDoc}
${HistoricoAntecedentesPecFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoProcedimentoPecQuery__
 *
 * To run a query within a React component, call `useHistoricoProcedimentoPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoProcedimentoPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoProcedimentoPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoProcedimentoPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables> & ({ variables: Types.HistoricoProcedimentoPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>(HistoricoProcedimentoPecDocument, options);
      }
export function useHistoricoProcedimentoPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>(HistoricoProcedimentoPecDocument, options);
        }
export function useHistoricoProcedimentoPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>(HistoricoProcedimentoPecDocument, options);
        }
export type HistoricoProcedimentoPecQueryHookResult = ReturnType<typeof useHistoricoProcedimentoPecQuery>;
export type HistoricoProcedimentoPecLazyQueryHookResult = ReturnType<typeof useHistoricoProcedimentoPecLazyQuery>;
export type HistoricoProcedimentoPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoProcedimentoPecSuspenseQuery>;
export type HistoricoProcedimentoPecQueryResult = Apollo.QueryResult<Types.HistoricoProcedimentoPecQuery, Types.HistoricoProcedimentoPecQueryVariables>;
export const HistoricoVacinacaoDwDocument = gql`
    query HistoricoVacinacaoDw($input: HistoricoDetailQueryInput!) {
  historicoVacinacaoDw(input: $input) {
    id
    dimensaoCondicaoMaternal {
      id
      descricao
      identificador
    }
    viajante
    comunicanteHanseniase
    dataRegistro
    fatosVacinacaoVacina {
      id
      siglaFabricante
      nomeLote
      dimensaoImunobiologico {
        id
        nome
      }
      dimensaoEstrategiaVacinacao {
        id
        nome
      }
      dimensaoDoseImunobiologico {
        id
        nome
      }
      dimensaoViaAdministracao {
        id
        nome
      }
      dimensaoLocalAplicacao {
        id
        nome
      }
      isRegistroAnterior
      dataRegistroVacinaAplicada
      dataRegistro
      dimensaoCboPrescritor {
        id
        cbo
      }
      dimensaoCid10MotivoIndicacao {
        id
        codigoCid10
        nomeCid10
      }
      isPesquisaClinica
      anvisaProtocoloEstudo
      anvisaProtocoloVersao
      anvisaNumeroRegistro
    }
    dimensaoProfissional {
      id
      nome
    }
    dimensaoCbo {
      id
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
    dimensaoLocalAtendimento {
      id
      descricao
    }
  }
}
    `;

/**
 * __useHistoricoVacinacaoDwQuery__
 *
 * To run a query within a React component, call `useHistoricoVacinacaoDwQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoVacinacaoDwQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoVacinacaoDwQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoVacinacaoDwQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables> & ({ variables: Types.HistoricoVacinacaoDwQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>(HistoricoVacinacaoDwDocument, options);
      }
export function useHistoricoVacinacaoDwLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>(HistoricoVacinacaoDwDocument, options);
        }
export function useHistoricoVacinacaoDwSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>(HistoricoVacinacaoDwDocument, options);
        }
export type HistoricoVacinacaoDwQueryHookResult = ReturnType<typeof useHistoricoVacinacaoDwQuery>;
export type HistoricoVacinacaoDwLazyQueryHookResult = ReturnType<typeof useHistoricoVacinacaoDwLazyQuery>;
export type HistoricoVacinacaoDwSuspenseQueryHookResult = ReturnType<typeof useHistoricoVacinacaoDwSuspenseQuery>;
export type HistoricoVacinacaoDwQueryResult = Apollo.QueryResult<Types.HistoricoVacinacaoDwQuery, Types.HistoricoVacinacaoDwQueryVariables>;
export const HistoricoVacinacaoPecDocument = gql`
    query HistoricoVacinacaoPec($input: HistoricoDetailQueryInput!) {
  historicoVacinacaoPec(input: $input) {
    id
    condicaoMaternal
    isViajante
    isComunicanteHanseniase
    atendimentoProfissional {
      id
      finalizadoEm
      ...HistoricoDesfechoPecFragment
      ...HistoricoInfoAdministrativasPecFragment
    }
    registrosVacinacao {
      id
      isRegistroAnterior
      isAplicadoExterior
      imunobiologico {
        id
        nome
      }
      estrategiaVacinacao {
        id
        nome
      }
      grupoAtendimento {
        id
        nome
      }
      tipoRegistroVacinacao {
        id
        identificador
      }
      dataAplicacao
      doseImunobiologico {
        id
        nome
      }
      loteImunobiologico {
        id
        lote
        fabricante {
          id
          codigoRnds
          sigla
          nome
        }
        validade
      }
      viaAdministracao {
        id
        nome
      }
      localAplicacaoVacinacao {
        id
        nome
      }
      cboPrescritor {
        id
        cbo2002
      }
      cid10MotivoIndicacao {
        id
        codigo
        nome
      }
      isPesquisaClinica
      anvisaProtocoloEstudo
      anvisaProtocoloVersao
      anvisaNumeroRegistro
      observacoes
    }
  }
}
    ${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useHistoricoVacinacaoPecQuery__
 *
 * To run a query within a React component, call `useHistoricoVacinacaoPecQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoVacinacaoPecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoVacinacaoPecQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoVacinacaoPecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables> & ({ variables: Types.HistoricoVacinacaoPecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>(HistoricoVacinacaoPecDocument, options);
      }
export function useHistoricoVacinacaoPecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>(HistoricoVacinacaoPecDocument, options);
        }
export function useHistoricoVacinacaoPecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>(HistoricoVacinacaoPecDocument, options);
        }
export type HistoricoVacinacaoPecQueryHookResult = ReturnType<typeof useHistoricoVacinacaoPecQuery>;
export type HistoricoVacinacaoPecLazyQueryHookResult = ReturnType<typeof useHistoricoVacinacaoPecLazyQuery>;
export type HistoricoVacinacaoPecSuspenseQueryHookResult = ReturnType<typeof useHistoricoVacinacaoPecSuspenseQuery>;
export type HistoricoVacinacaoPecQueryResult = Apollo.QueryResult<Types.HistoricoVacinacaoPecQuery, Types.HistoricoVacinacaoPecQueryVariables>;
export const HistoricoVisitaDomiciliarDocument = gql`
    query HistoricoVisitaDomiciliar($input: HistoricoDetailQueryInput!) {
  historicoVisitaDomiciliar(input: $input) {
    id
    nuUuidFicha
    cpfCidadao
    cnsCidadao
    motivoVisita
    buscaAtiva
    acompanhamento
    controleAmbiental
    anotacoes
    tipoVisita
    dimensaoDesfechoVisita {
      id
      numeroIdentificador
      descricao
    }
    dimensaoTipoGlicemia {
      id
      descricao
    }
    dimensaoProfissional {
      id
      nome
    }
    dimensaoCbo {
      id
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
    peso
    altura
    temperatura
    medicaoGlicemia
    medicaoPressaoArterial
    stVisitaCompartilhada
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dimensaoGrauVulnerabilidadeIvcf {
        id
        descricao
      }
    }
  }
}
    `;

/**
 * __useHistoricoVisitaDomiciliarQuery__
 *
 * To run a query within a React component, call `useHistoricoVisitaDomiciliarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoVisitaDomiciliarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoVisitaDomiciliarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoVisitaDomiciliarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables> & ({ variables: Types.HistoricoVisitaDomiciliarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>(HistoricoVisitaDomiciliarDocument, options);
      }
export function useHistoricoVisitaDomiciliarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>(HistoricoVisitaDomiciliarDocument, options);
        }
export function useHistoricoVisitaDomiciliarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>(HistoricoVisitaDomiciliarDocument, options);
        }
export type HistoricoVisitaDomiciliarQueryHookResult = ReturnType<typeof useHistoricoVisitaDomiciliarQuery>;
export type HistoricoVisitaDomiciliarLazyQueryHookResult = ReturnType<typeof useHistoricoVisitaDomiciliarLazyQuery>;
export type HistoricoVisitaDomiciliarSuspenseQueryHookResult = ReturnType<typeof useHistoricoVisitaDomiciliarSuspenseQuery>;
export type HistoricoVisitaDomiciliarQueryResult = Apollo.QueryResult<Types.HistoricoVisitaDomiciliarQuery, Types.HistoricoVisitaDomiciliarQueryVariables>;
export const HistoricoZikaDetailDocument = gql`
    query HistoricoZikaDetail($input: HistoricoDetailQueryInput!) {
  historicoZikaDetail(input: $input) {
    examesDeImagem {
      id
      nome
      resultado
      dataRealizacao
    }
    outrosExames {
      id
      nome
      resultado
      dataRealizacao
    }
    dimensaoProfissional {
      id
      nome
    }
    dimensaoCbo {
      id
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
  }
}
    `;

/**
 * __useHistoricoZikaDetailQuery__
 *
 * To run a query within a React component, call `useHistoricoZikaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoZikaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoZikaDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoZikaDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables> & ({ variables: Types.HistoricoZikaDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>(HistoricoZikaDetailDocument, options);
      }
export function useHistoricoZikaDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>(HistoricoZikaDetailDocument, options);
        }
export function useHistoricoZikaDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>(HistoricoZikaDetailDocument, options);
        }
export type HistoricoZikaDetailQueryHookResult = ReturnType<typeof useHistoricoZikaDetailQuery>;
export type HistoricoZikaDetailLazyQueryHookResult = ReturnType<typeof useHistoricoZikaDetailLazyQuery>;
export type HistoricoZikaDetailSuspenseQueryHookResult = ReturnType<typeof useHistoricoZikaDetailSuspenseQuery>;
export type HistoricoZikaDetailQueryResult = Apollo.QueryResult<Types.HistoricoZikaDetailQuery, Types.HistoricoZikaDetailQueryVariables>;
export const DisponibilidadeDadosClinicosHistoricoDocument = gql`
    query DisponibilidadeDadosClinicosHistorico {
  disponibilidadeDadosClinicosHistorico {
    statusProcessamento
  }
}
    `;

/**
 * __useDisponibilidadeDadosClinicosHistoricoQuery__
 *
 * To run a query within a React component, call `useDisponibilidadeDadosClinicosHistoricoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisponibilidadeDadosClinicosHistoricoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisponibilidadeDadosClinicosHistoricoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisponibilidadeDadosClinicosHistoricoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>(DisponibilidadeDadosClinicosHistoricoDocument, options);
      }
export function useDisponibilidadeDadosClinicosHistoricoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>(DisponibilidadeDadosClinicosHistoricoDocument, options);
        }
export function useDisponibilidadeDadosClinicosHistoricoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>(DisponibilidadeDadosClinicosHistoricoDocument, options);
        }
export type DisponibilidadeDadosClinicosHistoricoQueryHookResult = ReturnType<typeof useDisponibilidadeDadosClinicosHistoricoQuery>;
export type DisponibilidadeDadosClinicosHistoricoLazyQueryHookResult = ReturnType<typeof useDisponibilidadeDadosClinicosHistoricoLazyQuery>;
export type DisponibilidadeDadosClinicosHistoricoSuspenseQueryHookResult = ReturnType<typeof useDisponibilidadeDadosClinicosHistoricoSuspenseQuery>;
export type DisponibilidadeDadosClinicosHistoricoQueryResult = Apollo.QueryResult<Types.DisponibilidadeDadosClinicosHistoricoQuery, Types.DisponibilidadeDadosClinicosHistoricoQueryVariables>;
export const ProntuarioFamiliarAcompVulnerabilidadeDocument = gql`
    query ProntuarioFamiliarAcompVulnerabilidade($input: CidadaosQueryInput!) {
  cidadaos(input: $input) {
    content {
      id
      familias {
        id
        vulnerabilidadeFamiliar {
          id
          classificacao
          grauSugestivo
          escore
          classificacaoSubestimada
          criterios {
            criteriosInequivocos
            criteriosSugestivos
            criteriosPontuados {
              id
              descricao
              numeroMoradores
              peso
              resultado
            }
          }
        }
        imovel {
          id
          possuiInconsistencia
        }
      }
      dataNascimento
      dataRegistroRiscoInsegurancaAlimentar
      beneficiarioBolsaFamilia {
        id
        isBeneficiario
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProntuarioFamiliarAcompVulnerabilidadeQuery__
 *
 * To run a query within a React component, call `useProntuarioFamiliarAcompVulnerabilidadeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProntuarioFamiliarAcompVulnerabilidadeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProntuarioFamiliarAcompVulnerabilidadeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProntuarioFamiliarAcompVulnerabilidadeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables> & ({ variables: Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>(ProntuarioFamiliarAcompVulnerabilidadeDocument, options);
      }
export function useProntuarioFamiliarAcompVulnerabilidadeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>(ProntuarioFamiliarAcompVulnerabilidadeDocument, options);
        }
export function useProntuarioFamiliarAcompVulnerabilidadeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>(ProntuarioFamiliarAcompVulnerabilidadeDocument, options);
        }
export type ProntuarioFamiliarAcompVulnerabilidadeQueryHookResult = ReturnType<typeof useProntuarioFamiliarAcompVulnerabilidadeQuery>;
export type ProntuarioFamiliarAcompVulnerabilidadeLazyQueryHookResult = ReturnType<typeof useProntuarioFamiliarAcompVulnerabilidadeLazyQuery>;
export type ProntuarioFamiliarAcompVulnerabilidadeSuspenseQueryHookResult = ReturnType<typeof useProntuarioFamiliarAcompVulnerabilidadeSuspenseQuery>;
export type ProntuarioFamiliarAcompVulnerabilidadeQueryResult = Apollo.QueryResult<Types.ProntuarioFamiliarAcompVulnerabilidadeQuery, Types.ProntuarioFamiliarAcompVulnerabilidadeQueryVariables>;
export const ProntuarioFamiliarDocument = gql`
    query ProntuarioFamiliar($cidadaoId: ID!) {
  cidadao(id: $cidadaoId) {
    id
    cidadaoNucleoFamiliar {
      id
      mudouSe
    }
    familias(
      input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true, isResponsavelAindaReside: true, isResponsavelCadastrado: true, isResponsavelDeclarado: true, isResponsavelUnico: true, isResponsavelVivo: true}
    ) {
      cnes
      ine
      equipe {
        id
        nome
      }
      id
      resideDesde
      numeroProntuarioFamiliar
      rendaFamiliar
      cpfCnsResponsavel
      isResponsavelCadastrado
      isResponsavelDeclarado
      isResponsavelVivo
      isResponsavelUnico
      isResponsavelAindaReside
      isFamiliaAindaReside
      isInformacaoSuficiente
      isDomicilioAtivo
      numeroMembros
      cidadaosTerritorioBasico(input: {mostrarInconsistentes: false}) {
        id
        nome
        nomeSocial
        sexo
        dataNascimento
        cpf
        cns
        ultimaFichaCadastrada {
          id
          isProcessado
        }
        cidadaoNucleoFamiliar {
          id
          grauParentescoResponsavelFamiliar
        }
        prontuario {
          id
        }
      }
      imovel {
        id
        tipoEndereco
        complemento
        pontoReferencia
        cep
        telefoneContato
        telefoneResidencial
        microarea
        numero
        bairro
        logradouro
        numeroMoradores
        tipoLogradouro {
          id
          nome
        }
        tipoImovel
        municipio {
          id
          nome
          uf {
            id
            sigla
          }
        }
        aldeia {
          id
          nome
        }
        poloBase {
          id
          nome
        }
        dsei {
          id
          nome
        }
        latitude
        longitude
        numeroResidenciaIndigena
        ...CondicoesMoradiaFragment
        ...AnimaisDomicilioFragment
      }
    }
  }
}
    ${CondicoesMoradiaFragmentFragmentDoc}
${AnimaisDomicilioFragmentFragmentDoc}`;

/**
 * __useProntuarioFamiliarQuery__
 *
 * To run a query within a React component, call `useProntuarioFamiliarQuery` and pass it any options that fit your needs.
 * When your component renders, `useProntuarioFamiliarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProntuarioFamiliarQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useProntuarioFamiliarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables> & ({ variables: Types.ProntuarioFamiliarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>(ProntuarioFamiliarDocument, options);
      }
export function useProntuarioFamiliarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>(ProntuarioFamiliarDocument, options);
        }
export function useProntuarioFamiliarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>(ProntuarioFamiliarDocument, options);
        }
export type ProntuarioFamiliarQueryHookResult = ReturnType<typeof useProntuarioFamiliarQuery>;
export type ProntuarioFamiliarLazyQueryHookResult = ReturnType<typeof useProntuarioFamiliarLazyQuery>;
export type ProntuarioFamiliarSuspenseQueryHookResult = ReturnType<typeof useProntuarioFamiliarSuspenseQuery>;
export type ProntuarioFamiliarQueryResult = Apollo.QueryResult<Types.ProntuarioFamiliarQuery, Types.ProntuarioFamiliarQueryVariables>;
export const ProntuarioFamiliarVisitasDomiciliaresDocument = gql`
    query ProntuarioFamiliarVisitasDomiciliares($input: VisitasQueryInput!) {
  visitas(input: $input) {
    content {
      id
      dataVisita
      dimensaoProfissional {
        id
        nome
      }
      dimensaoEquipe {
        id
        nome
        ine
      }
      dimensaoCbo {
        id
        nome
        cbo
      }
      motivoVisita
      buscaAtiva
      acompanhamento
      controleAmbiental
      tipoVisita
      anotacoes
      turno {
        id
        descricao
      }
      cidadaoPec {
        id
        nome
        nomeSocial
        cpf
        cns
      }
    }
  }
}
    `;

/**
 * __useProntuarioFamiliarVisitasDomiciliaresQuery__
 *
 * To run a query within a React component, call `useProntuarioFamiliarVisitasDomiciliaresQuery` and pass it any options that fit your needs.
 * When your component renders, `useProntuarioFamiliarVisitasDomiciliaresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProntuarioFamiliarVisitasDomiciliaresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProntuarioFamiliarVisitasDomiciliaresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables> & ({ variables: Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>(ProntuarioFamiliarVisitasDomiciliaresDocument, options);
      }
export function useProntuarioFamiliarVisitasDomiciliaresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>(ProntuarioFamiliarVisitasDomiciliaresDocument, options);
        }
export function useProntuarioFamiliarVisitasDomiciliaresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>(ProntuarioFamiliarVisitasDomiciliaresDocument, options);
        }
export type ProntuarioFamiliarVisitasDomiciliaresQueryHookResult = ReturnType<typeof useProntuarioFamiliarVisitasDomiciliaresQuery>;
export type ProntuarioFamiliarVisitasDomiciliaresLazyQueryHookResult = ReturnType<typeof useProntuarioFamiliarVisitasDomiciliaresLazyQuery>;
export type ProntuarioFamiliarVisitasDomiciliaresSuspenseQueryHookResult = ReturnType<typeof useProntuarioFamiliarVisitasDomiciliaresSuspenseQuery>;
export type ProntuarioFamiliarVisitasDomiciliaresQueryResult = Apollo.QueryResult<Types.ProntuarioFamiliarVisitasDomiciliaresQuery, Types.ProntuarioFamiliarVisitasDomiciliaresQueryVariables>;
export const GerarLinkSistemaExternoDocument = gql`
    mutation gerarLinkSistemaExterno($input: GerarLinkSistemaExternoInput!) {
  gerarLinkSistemaExterno(input: $input)
}
    `;
export type GerarLinkSistemaExternoMutationFn = Apollo.MutationFunction<Types.GerarLinkSistemaExternoMutation, Types.GerarLinkSistemaExternoMutationVariables>;

/**
 * __useGerarLinkSistemaExternoMutation__
 *
 * To run a mutation, you first call `useGerarLinkSistemaExternoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarLinkSistemaExternoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarLinkSistemaExternoMutation, { data, loading, error }] = useGerarLinkSistemaExternoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGerarLinkSistemaExternoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GerarLinkSistemaExternoMutation, Types.GerarLinkSistemaExternoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GerarLinkSistemaExternoMutation, Types.GerarLinkSistemaExternoMutationVariables>(GerarLinkSistemaExternoDocument, options);
      }
export type GerarLinkSistemaExternoMutationHookResult = ReturnType<typeof useGerarLinkSistemaExternoMutation>;
export type GerarLinkSistemaExternoMutationResult = Apollo.MutationResult<Types.GerarLinkSistemaExternoMutation>;
export type GerarLinkSistemaExternoMutationOptions = Apollo.BaseMutationOptions<Types.GerarLinkSistemaExternoMutation, Types.GerarLinkSistemaExternoMutationVariables>;
export const IframesAtendimentoDocument = gql`
    query IframesAtendimento($input: IframesQueryInput) {
  iframes(input: $input) {
    id
    providerId
    nome
  }
}
    `;

/**
 * __useIframesAtendimentoQuery__
 *
 * To run a query within a React component, call `useIframesAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIframesAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIframesAtendimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIframesAtendimentoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>(IframesAtendimentoDocument, options);
      }
export function useIframesAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>(IframesAtendimentoDocument, options);
        }
export function useIframesAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>(IframesAtendimentoDocument, options);
        }
export type IframesAtendimentoQueryHookResult = ReturnType<typeof useIframesAtendimentoQuery>;
export type IframesAtendimentoLazyQueryHookResult = ReturnType<typeof useIframesAtendimentoLazyQuery>;
export type IframesAtendimentoSuspenseQueryHookResult = ReturnType<typeof useIframesAtendimentoSuspenseQuery>;
export type IframesAtendimentoQueryResult = Apollo.QueryResult<Types.IframesAtendimentoQuery, Types.IframesAtendimentoQueryVariables>;
export const HasProblemasGestacaoDocument = gql`
    query HasProblemasGestacao($id: Long!) {
  hasProblemasGestacao(id: $id)
}
    `;

/**
 * __useHasProblemasGestacaoQuery__
 *
 * To run a query within a React component, call `useHasProblemasGestacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasProblemasGestacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasProblemasGestacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHasProblemasGestacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables> & ({ variables: Types.HasProblemasGestacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>(HasProblemasGestacaoDocument, options);
      }
export function useHasProblemasGestacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>(HasProblemasGestacaoDocument, options);
        }
export function useHasProblemasGestacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>(HasProblemasGestacaoDocument, options);
        }
export type HasProblemasGestacaoQueryHookResult = ReturnType<typeof useHasProblemasGestacaoQuery>;
export type HasProblemasGestacaoLazyQueryHookResult = ReturnType<typeof useHasProblemasGestacaoLazyQuery>;
export type HasProblemasGestacaoSuspenseQueryHookResult = ReturnType<typeof useHasProblemasGestacaoSuspenseQuery>;
export type HasProblemasGestacaoQueryResult = Apollo.QueryResult<Types.HasProblemasGestacaoQuery, Types.HasProblemasGestacaoQueryVariables>;
export const HasPuericulturaDocument = gql`
    query HasPuericultura($prontuarioId: ID!) {
  hasPuericultura(prontuarioId: $prontuarioId)
}
    `;

/**
 * __useHasPuericulturaQuery__
 *
 * To run a query within a React component, call `useHasPuericulturaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasPuericulturaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasPuericulturaQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useHasPuericulturaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables> & ({ variables: Types.HasPuericulturaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>(HasPuericulturaDocument, options);
      }
export function useHasPuericulturaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>(HasPuericulturaDocument, options);
        }
export function useHasPuericulturaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>(HasPuericulturaDocument, options);
        }
export type HasPuericulturaQueryHookResult = ReturnType<typeof useHasPuericulturaQuery>;
export type HasPuericulturaLazyQueryHookResult = ReturnType<typeof useHasPuericulturaLazyQuery>;
export type HasPuericulturaSuspenseQueryHookResult = ReturnType<typeof useHasPuericulturaSuspenseQuery>;
export type HasPuericulturaQueryResult = Apollo.QueryResult<Types.HasPuericulturaQuery, Types.HasPuericulturaQueryVariables>;
export const LoadAntecedentesDocument = gql`
    query LoadAntecedentes($id: ID!) {
  antecedente(prontuarioId: $id) {
    id
    observacoes
    dataUltimaAtualizacaoPessoal
    gestacoesPrevias
    qtPartos
    qtAbortos
    qtCesareas
    partosVaginais
    partosDomiciliares
    desfechoUltimaGestacao
    nascidosVivos
    natimortos
    obitoAntesPrimeiraSemana
    obitoAposPrimeiraSemana
    filhosVivos
    recemNascidosAcima
    recemNascidosAbaixo
    dataUltimoParto
    dataUltimaAtualizacaoGestacional
    peso
    altura
    perimetroCefalico
    apgarUm
    apgarCinco
    apgarDez
    tipoGravidez
    tipoParto
    idadeGestacionalSemanas
    idadeGestacionalDias
    dataUltimaAtualizacaoPuericultura
    antecedentesFamiliaresCiap {
      id
      idCiap
      codigoCiap
      descricao
      cid10 {
        id
        codigo
        nome
        ativo
        ciapsRelacionadas {
          id
          codigo
          descricao
        }
      }
      observacao
    }
    cirurgiasInternacoes {
      id
      descricao
      observacoes
      dataCirurgiaInternacao
    }
  }
}
    `;

/**
 * __useLoadAntecedentesQuery__
 *
 * To run a query within a React component, call `useLoadAntecedentesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAntecedentesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAntecedentesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAntecedentesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables> & ({ variables: Types.LoadAntecedentesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>(LoadAntecedentesDocument, options);
      }
export function useLoadAntecedentesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>(LoadAntecedentesDocument, options);
        }
export function useLoadAntecedentesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>(LoadAntecedentesDocument, options);
        }
export type LoadAntecedentesQueryHookResult = ReturnType<typeof useLoadAntecedentesQuery>;
export type LoadAntecedentesLazyQueryHookResult = ReturnType<typeof useLoadAntecedentesLazyQuery>;
export type LoadAntecedentesSuspenseQueryHookResult = ReturnType<typeof useLoadAntecedentesSuspenseQuery>;
export type LoadAntecedentesQueryResult = Apollo.QueryResult<Types.LoadAntecedentesQuery, Types.LoadAntecedentesQueryVariables>;
export const AcompanhamentoIdosoCardDocument = gql`
    query AcompanhamentoIdosoCard($prontuarioId: ID!, $cidadaoId: ID!) {
  ultimaAvaliacaoMultidimensional(
    input: {prontuarioId: $prontuarioId, cidadaoId: $cidadaoId}
  )
}
    `;

/**
 * __useAcompanhamentoIdosoCardQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoIdosoCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoIdosoCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoIdosoCardQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useAcompanhamentoIdosoCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables> & ({ variables: Types.AcompanhamentoIdosoCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>(AcompanhamentoIdosoCardDocument, options);
      }
export function useAcompanhamentoIdosoCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>(AcompanhamentoIdosoCardDocument, options);
        }
export function useAcompanhamentoIdosoCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>(AcompanhamentoIdosoCardDocument, options);
        }
export type AcompanhamentoIdosoCardQueryHookResult = ReturnType<typeof useAcompanhamentoIdosoCardQuery>;
export type AcompanhamentoIdosoCardLazyQueryHookResult = ReturnType<typeof useAcompanhamentoIdosoCardLazyQuery>;
export type AcompanhamentoIdosoCardSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoIdosoCardSuspenseQuery>;
export type AcompanhamentoIdosoCardQueryResult = Apollo.QueryResult<Types.AcompanhamentoIdosoCardQuery, Types.AcompanhamentoIdosoCardQueryVariables>;
export const UltimoIvcfDocument = gql`
    query UltimoIvcf($prontuarioId: ID!, $cidadaoId: ID!) {
  ultimoIvcf(input: {prontuarioId: $prontuarioId, cidadaoId: $cidadaoId}) {
    id
    ivcf {
      id
      resultado
      dimensoesAlteradas
      riscoVulnerabilidade
      dataResultado
      atendimentoProfissional {
        id
        lotacao {
          id
          profissional {
            id
            nome
          }
          cbo {
            id
            nome
          }
        }
      }
    }
    fatoIvcf {
      id
      resultado
      dimensoesAlteradas
      riscoVulnerabilidade
      dataResultado
      dimensaoCbo {
        id
        nome
      }
      dimensaoProfissional {
        id
        nome
      }
    }
  }
}
    `;

/**
 * __useUltimoIvcfQuery__
 *
 * To run a query within a React component, call `useUltimoIvcfQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoIvcfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoIvcfQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useUltimoIvcfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables> & ({ variables: Types.UltimoIvcfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>(UltimoIvcfDocument, options);
      }
export function useUltimoIvcfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>(UltimoIvcfDocument, options);
        }
export function useUltimoIvcfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>(UltimoIvcfDocument, options);
        }
export type UltimoIvcfQueryHookResult = ReturnType<typeof useUltimoIvcfQuery>;
export type UltimoIvcfLazyQueryHookResult = ReturnType<typeof useUltimoIvcfLazyQuery>;
export type UltimoIvcfSuspenseQueryHookResult = ReturnType<typeof useUltimoIvcfSuspenseQuery>;
export type UltimoIvcfQueryResult = Apollo.QueryResult<Types.UltimoIvcfQuery, Types.UltimoIvcfQueryVariables>;
export const AcompanhamentoPuericulturaCardDocument = gql`
    query AcompanhamentoPuericulturaCard($prontuarioId: ID!, $dataReferencia: LocalDate!) {
  ultimoAtendimentoPuericultura(prontuarioId: $prontuarioId) {
    id
    dataInicio
    nomeProfissional
  }
  tipoAleitamentoMaterno(prontuarioId: $prontuarioId) {
    id
    tipo
    dataInicioAtendimento
  }
  preNatalPartoNascimento: antecedente(prontuarioId: $prontuarioId) {
    id
    tipoGravidez
    tipoParto
    idadeGestacionalSemanas
    idadeGestacionalDias
    apgarUm
    apgarCinco
    apgarDez
    peso
    altura
    perimetroCefalico
  }
  alteracoesFenotipicas(prontuarioId: $prontuarioId) {
    id
    descricao
    status
    dataAvaliacao
  }
  fatoresRisco(prontuarioId: $prontuarioId) {
    id
    descricao
    status
    dataAvaliacao
  }
  marcosDesenvolvimento(
    input: {prontuarioId: $prontuarioId, dataReferencia: $dataReferencia}
  ) {
    id
    descricao
    hint
    status
    dataAvaliacao
    alcancadoComMeses
    alcancadoComAnos
    faixaEtariaEnum
    faixaEtariaFim
    descricaoFaixaEtaria
  }
  medicoesAnteriores: medicoes(input: {prontuarioId: $prontuarioId}) {
    id
    dataMedicao
    valorVacinacaoEmDia
    valorPerimetroCefalico
  }
  antecedente(prontuarioId: $prontuarioId) {
    id
    perimetroCefalico
  }
  registrosMChat(prontuarioId: $prontuarioId) {
    ...UltimoMChat
  }
}
    ${UltimoMChatFragmentDoc}`;

/**
 * __useAcompanhamentoPuericulturaCardQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPuericulturaCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPuericulturaCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPuericulturaCardQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      dataReferencia: // value for 'dataReferencia'
 *   },
 * });
 */
export function useAcompanhamentoPuericulturaCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables> & ({ variables: Types.AcompanhamentoPuericulturaCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>(AcompanhamentoPuericulturaCardDocument, options);
      }
export function useAcompanhamentoPuericulturaCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>(AcompanhamentoPuericulturaCardDocument, options);
        }
export function useAcompanhamentoPuericulturaCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>(AcompanhamentoPuericulturaCardDocument, options);
        }
export type AcompanhamentoPuericulturaCardQueryHookResult = ReturnType<typeof useAcompanhamentoPuericulturaCardQuery>;
export type AcompanhamentoPuericulturaCardLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPuericulturaCardLazyQuery>;
export type AcompanhamentoPuericulturaCardSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPuericulturaCardSuspenseQuery>;
export type AcompanhamentoPuericulturaCardQueryResult = Apollo.QueryResult<Types.AcompanhamentoPuericulturaCardQuery, Types.AcompanhamentoPuericulturaCardQueryVariables>;
export const AcompanhamentoVulnerabilidadeCardDocument = gql`
    query AcompanhamentoVulnerabilidadeCard($cidadaoId: ID!) {
  cidadao(id: $cidadaoId) {
    id
    dataNascimento
    dataRegistroRiscoInsegurancaAlimentar
    familias(
      input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true, isResponsavelAindaReside: true, isResponsavelCadastrado: true, isResponsavelDeclarado: true, isResponsavelUnico: true, isResponsavelVivo: true}
    ) {
      id
      cidadaos {
        id
        dataNascimento
      }
    }
  }
}
    `;

/**
 * __useAcompanhamentoVulnerabilidadeCardQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoVulnerabilidadeCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoVulnerabilidadeCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoVulnerabilidadeCardQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useAcompanhamentoVulnerabilidadeCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables> & ({ variables: Types.AcompanhamentoVulnerabilidadeCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>(AcompanhamentoVulnerabilidadeCardDocument, options);
      }
export function useAcompanhamentoVulnerabilidadeCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>(AcompanhamentoVulnerabilidadeCardDocument, options);
        }
export function useAcompanhamentoVulnerabilidadeCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>(AcompanhamentoVulnerabilidadeCardDocument, options);
        }
export type AcompanhamentoVulnerabilidadeCardQueryHookResult = ReturnType<typeof useAcompanhamentoVulnerabilidadeCardQuery>;
export type AcompanhamentoVulnerabilidadeCardLazyQueryHookResult = ReturnType<typeof useAcompanhamentoVulnerabilidadeCardLazyQuery>;
export type AcompanhamentoVulnerabilidadeCardSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoVulnerabilidadeCardSuspenseQuery>;
export type AcompanhamentoVulnerabilidadeCardQueryResult = Apollo.QueryResult<Types.AcompanhamentoVulnerabilidadeCardQuery, Types.AcompanhamentoVulnerabilidadeCardQueryVariables>;
export const AcompanhamentoCidadaosVulnerabilidadeAlimentarDocument = gql`
    query AcompanhamentoCidadaosVulnerabilidadeAlimentar($input: CidadaosQueryInput!) {
  cidadaos(input: $input) {
    content {
      id
      dataNascimento
      dataRegistroRiscoInsegurancaAlimentar
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables> & ({ variables: Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>(AcompanhamentoCidadaosVulnerabilidadeAlimentarDocument, options);
      }
export function useAcompanhamentoCidadaosVulnerabilidadeAlimentarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>(AcompanhamentoCidadaosVulnerabilidadeAlimentarDocument, options);
        }
export function useAcompanhamentoCidadaosVulnerabilidadeAlimentarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>(AcompanhamentoCidadaosVulnerabilidadeAlimentarDocument, options);
        }
export type AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVulnerabilidadeAlimentarQuery>;
export type AcompanhamentoCidadaosVulnerabilidadeAlimentarLazyQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVulnerabilidadeAlimentarLazyQuery>;
export type AcompanhamentoCidadaosVulnerabilidadeAlimentarSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoCidadaosVulnerabilidadeAlimentarSuspenseQuery>;
export type AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryResult = Apollo.QueryResult<Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery, Types.AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables>;
export const AlergiasCardDocument = gql`
    query AlergiasCard($filtro: AlergiasQueryInput!, $prontuarioId: ID!) {
  alergias(input: $filtro) {
    content {
      id
      categoriaSubstanciaEspecificaLegado
      substanciaEspecificaLegado
      tipoReacao
      substanciaEspecifica {
        ...SubstanciaEspecificaAlergia
      }
      criticidade
      grauCerteza
    }
  }
  existemAlergiasResolvidasRefutadas(prontuarioId: $prontuarioId)
}
    ${SubstanciaEspecificaAlergiaFragmentDoc}`;

/**
 * __useAlergiasCardQuery__
 *
 * To run a query within a React component, call `useAlergiasCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlergiasCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlergiasCardQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useAlergiasCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables> & ({ variables: Types.AlergiasCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>(AlergiasCardDocument, options);
      }
export function useAlergiasCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>(AlergiasCardDocument, options);
        }
export function useAlergiasCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>(AlergiasCardDocument, options);
        }
export type AlergiasCardQueryHookResult = ReturnType<typeof useAlergiasCardQuery>;
export type AlergiasCardLazyQueryHookResult = ReturnType<typeof useAlergiasCardLazyQuery>;
export type AlergiasCardSuspenseQueryHookResult = ReturnType<typeof useAlergiasCardSuspenseQuery>;
export type AlergiasCardQueryResult = Apollo.QueryResult<Types.AlergiasCardQuery, Types.AlergiasCardQueryVariables>;
export const LembretesCardDocument = gql`
    query LembretesCard($lembretesQueryInput: LembretesQueryInput!) {
  lembretes(input: $lembretesQueryInput) {
    id
    ultimoLembrete {
      id
      descricao
      ativo
      data
      lotacao {
        id
        profissional {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useLembretesCardQuery__
 *
 * To run a query within a React component, call `useLembretesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLembretesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLembretesCardQuery({
 *   variables: {
 *      lembretesQueryInput: // value for 'lembretesQueryInput'
 *   },
 * });
 */
export function useLembretesCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LembretesCardQuery, Types.LembretesCardQueryVariables> & ({ variables: Types.LembretesCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>(LembretesCardDocument, options);
      }
export function useLembretesCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>(LembretesCardDocument, options);
        }
export function useLembretesCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>(LembretesCardDocument, options);
        }
export type LembretesCardQueryHookResult = ReturnType<typeof useLembretesCardQuery>;
export type LembretesCardLazyQueryHookResult = ReturnType<typeof useLembretesCardLazyQuery>;
export type LembretesCardSuspenseQueryHookResult = ReturnType<typeof useLembretesCardSuspenseQuery>;
export type LembretesCardQueryResult = Apollo.QueryResult<Types.LembretesCardQuery, Types.LembretesCardQueryVariables>;
export const MedicamentoUsoBarraLateralDocument = gql`
    query MedicamentoUsoBarraLateral($input: ListaMedicamentoAtivoConcluidoQueryInput!) {
  listaMedicamento(input: $input) {
    content {
      id
      dtInicioTratamento
      dtFimTratamento
      registroManual
      tipoReceita
      medicamento {
        id
        principioAtivo
        concentracao
        medicamentoCatmat {
          id
          codigoCatMat
          principioAtivo {
            id
            nome
            listaMaterial {
              id
              tipoReceita
            }
          }
        }
      }
      usoContinuo
      posologia
      qtDuracaoTratamento
      medidaTempoTratamento
      quantidadeReceitada
      atendProf {
        id
        iniciadoEm
        versaoAnterior
        atendimento {
          id
        }
      }
      receitaUsoContinuoGrupo {
        id
        dtInicioTratamento
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useMedicamentoUsoBarraLateralQuery__
 *
 * To run a query within a React component, call `useMedicamentoUsoBarraLateralQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoUsoBarraLateralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoUsoBarraLateralQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoUsoBarraLateralQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables> & ({ variables: Types.MedicamentoUsoBarraLateralQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>(MedicamentoUsoBarraLateralDocument, options);
      }
export function useMedicamentoUsoBarraLateralLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>(MedicamentoUsoBarraLateralDocument, options);
        }
export function useMedicamentoUsoBarraLateralSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>(MedicamentoUsoBarraLateralDocument, options);
        }
export type MedicamentoUsoBarraLateralQueryHookResult = ReturnType<typeof useMedicamentoUsoBarraLateralQuery>;
export type MedicamentoUsoBarraLateralLazyQueryHookResult = ReturnType<typeof useMedicamentoUsoBarraLateralLazyQuery>;
export type MedicamentoUsoBarraLateralSuspenseQueryHookResult = ReturnType<typeof useMedicamentoUsoBarraLateralSuspenseQuery>;
export type MedicamentoUsoBarraLateralQueryResult = Apollo.QueryResult<Types.MedicamentoUsoBarraLateralQuery, Types.MedicamentoUsoBarraLateralQueryVariables>;
export const PossuiTratamentoConcluidoDocument = gql`
    query PossuiTratamentoConcluido($input: PossuiTratamentoConcluidoQueryInput!) {
  possuiTratamentoConcluido(input: $input)
}
    `;

/**
 * __usePossuiTratamentoConcluidoQuery__
 *
 * To run a query within a React component, call `usePossuiTratamentoConcluidoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossuiTratamentoConcluidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossuiTratamentoConcluidoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePossuiTratamentoConcluidoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables> & ({ variables: Types.PossuiTratamentoConcluidoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>(PossuiTratamentoConcluidoDocument, options);
      }
export function usePossuiTratamentoConcluidoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>(PossuiTratamentoConcluidoDocument, options);
        }
export function usePossuiTratamentoConcluidoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>(PossuiTratamentoConcluidoDocument, options);
        }
export type PossuiTratamentoConcluidoQueryHookResult = ReturnType<typeof usePossuiTratamentoConcluidoQuery>;
export type PossuiTratamentoConcluidoLazyQueryHookResult = ReturnType<typeof usePossuiTratamentoConcluidoLazyQuery>;
export type PossuiTratamentoConcluidoSuspenseQueryHookResult = ReturnType<typeof usePossuiTratamentoConcluidoSuspenseQuery>;
export type PossuiTratamentoConcluidoQueryResult = Apollo.QueryResult<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>;
export const MedicoesCardDocument = gql`
    query MedicoesCard($prontuarioId: ID!, $fetchMedicoesAnteriores: Boolean!, $dataReferencia: Instant) {
  ultimasMedicoesDoDia(
    filtro: {prontuarioId: $prontuarioId, data: $dataReferencia}
  ) {
    ...GrupoMedicoesCard
  }
  ultimasMedicoesDiasAnteriores(
    filtro: {prontuarioId: $prontuarioId, data: $dataReferencia}
  ) @include(if: $fetchMedicoesAnteriores) {
    ...GrupoMedicoesCard
  }
  medicoesNoNascimento: antecedente(prontuarioId: $prontuarioId) {
    id
    peso
    altura
    perimetroCefalico
  }
}
    ${GrupoMedicoesCardFragmentDoc}`;

/**
 * __useMedicoesCardQuery__
 *
 * To run a query within a React component, call `useMedicoesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesCardQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      fetchMedicoesAnteriores: // value for 'fetchMedicoesAnteriores'
 *      dataReferencia: // value for 'dataReferencia'
 *   },
 * });
 */
export function useMedicoesCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables> & ({ variables: Types.MedicoesCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>(MedicoesCardDocument, options);
      }
export function useMedicoesCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>(MedicoesCardDocument, options);
        }
export function useMedicoesCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>(MedicoesCardDocument, options);
        }
export type MedicoesCardQueryHookResult = ReturnType<typeof useMedicoesCardQuery>;
export type MedicoesCardLazyQueryHookResult = ReturnType<typeof useMedicoesCardLazyQuery>;
export type MedicoesCardSuspenseQueryHookResult = ReturnType<typeof useMedicoesCardSuspenseQuery>;
export type MedicoesCardQueryResult = Apollo.QueryResult<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>;
export const AcompanhamentoPreNatalCardDocument = gql`
    query acompanhamentoPreNatalCard($input: ID!) {
  atendimentosProfUltimaGestacao(prontuarioId: $input) {
    id
    iniciadoEm
    atendimentoProfissionalPreNatal {
      id
      preNatal {
        id
        altoRisco
        fonteIdadeGestacional
        tipoGravidez {
          id
          descricao
        }
      }
    }
    medicoes {
      id
      dataMedicao
      dum
      medicaoAnterior
    }
  }
}
    `;

/**
 * __useAcompanhamentoPreNatalCardQuery__
 *
 * To run a query within a React component, call `useAcompanhamentoPreNatalCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcompanhamentoPreNatalCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcompanhamentoPreNatalCardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcompanhamentoPreNatalCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables> & ({ variables: Types.AcompanhamentoPreNatalCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>(AcompanhamentoPreNatalCardDocument, options);
      }
export function useAcompanhamentoPreNatalCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>(AcompanhamentoPreNatalCardDocument, options);
        }
export function useAcompanhamentoPreNatalCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>(AcompanhamentoPreNatalCardDocument, options);
        }
export type AcompanhamentoPreNatalCardQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCardQuery>;
export type AcompanhamentoPreNatalCardLazyQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCardLazyQuery>;
export type AcompanhamentoPreNatalCardSuspenseQueryHookResult = ReturnType<typeof useAcompanhamentoPreNatalCardSuspenseQuery>;
export type AcompanhamentoPreNatalCardQueryResult = Apollo.QueryResult<Types.AcompanhamentoPreNatalCardQuery, Types.AcompanhamentoPreNatalCardQueryVariables>;
export const DataUltimaConsultaOdontoGestanteDocument = gql`
    query dataUltimaConsultaOdontoGestante($input: DataUltimaConsultaOdontoGestanteQueryInput!) {
  dataUltimaConsultaOdontoGestante(filter: $input)
}
    `;

/**
 * __useDataUltimaConsultaOdontoGestanteQuery__
 *
 * To run a query within a React component, call `useDataUltimaConsultaOdontoGestanteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataUltimaConsultaOdontoGestanteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataUltimaConsultaOdontoGestanteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataUltimaConsultaOdontoGestanteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables> & ({ variables: Types.DataUltimaConsultaOdontoGestanteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>(DataUltimaConsultaOdontoGestanteDocument, options);
      }
export function useDataUltimaConsultaOdontoGestanteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>(DataUltimaConsultaOdontoGestanteDocument, options);
        }
export function useDataUltimaConsultaOdontoGestanteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>(DataUltimaConsultaOdontoGestanteDocument, options);
        }
export type DataUltimaConsultaOdontoGestanteQueryHookResult = ReturnType<typeof useDataUltimaConsultaOdontoGestanteQuery>;
export type DataUltimaConsultaOdontoGestanteLazyQueryHookResult = ReturnType<typeof useDataUltimaConsultaOdontoGestanteLazyQuery>;
export type DataUltimaConsultaOdontoGestanteSuspenseQueryHookResult = ReturnType<typeof useDataUltimaConsultaOdontoGestanteSuspenseQuery>;
export type DataUltimaConsultaOdontoGestanteQueryResult = Apollo.QueryResult<Types.DataUltimaConsultaOdontoGestanteQuery, Types.DataUltimaConsultaOdontoGestanteQueryVariables>;
export const PeriodoGestacionalDocument = gql`
    query PeriodoGestacional($input: PeriodoGestacionalQueryInput!) {
  periodoGestacional(input: $input) {
    dataInicioGestacao
    dataProvavelPartoEcografica
    idadeGestacionalCronologicaEmDias
    idadeGestacionalEcograficaEmDias
    hasIgEcoChanged
    hasDppEcoChanged
    fonteIdadeGestacional
  }
}
    `;

/**
 * __usePeriodoGestacionalQuery__
 *
 * To run a query within a React component, call `usePeriodoGestacionalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodoGestacionalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodoGestacionalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePeriodoGestacionalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables> & ({ variables: Types.PeriodoGestacionalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>(PeriodoGestacionalDocument, options);
      }
export function usePeriodoGestacionalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>(PeriodoGestacionalDocument, options);
        }
export function usePeriodoGestacionalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>(PeriodoGestacionalDocument, options);
        }
export type PeriodoGestacionalQueryHookResult = ReturnType<typeof usePeriodoGestacionalQuery>;
export type PeriodoGestacionalLazyQueryHookResult = ReturnType<typeof usePeriodoGestacionalLazyQuery>;
export type PeriodoGestacionalSuspenseQueryHookResult = ReturnType<typeof usePeriodoGestacionalSuspenseQuery>;
export type PeriodoGestacionalQueryResult = Apollo.QueryResult<Types.PeriodoGestacionalQuery, Types.PeriodoGestacionalQueryVariables>;
export const RiscosDocument = gql`
    query Riscos($input: RiscoInput!) {
  riscos(input: $input) {
    estratificacao
    origem
    descricaoOrigem
    grupo
  }
}
    `;

/**
 * __useRiscosQuery__
 *
 * To run a query within a React component, call `useRiscosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiscosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiscosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRiscosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RiscosQuery, Types.RiscosQueryVariables> & ({ variables: Types.RiscosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RiscosQuery, Types.RiscosQueryVariables>(RiscosDocument, options);
      }
export function useRiscosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RiscosQuery, Types.RiscosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RiscosQuery, Types.RiscosQueryVariables>(RiscosDocument, options);
        }
export function useRiscosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RiscosQuery, Types.RiscosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RiscosQuery, Types.RiscosQueryVariables>(RiscosDocument, options);
        }
export type RiscosQueryHookResult = ReturnType<typeof useRiscosQuery>;
export type RiscosLazyQueryHookResult = ReturnType<typeof useRiscosLazyQuery>;
export type RiscosSuspenseQueryHookResult = ReturnType<typeof useRiscosSuspenseQuery>;
export type RiscosQueryResult = Apollo.QueryResult<Types.RiscosQuery, Types.RiscosQueryVariables>;
export const ResultadosExamesCardDocument = gql`
    query ResultadosExamesCard($input: ResultadosExameQueryInput!) {
  resultadosExame(input: $input) {
    content {
      id
      exame {
        ...Procedimento
      }
      resultado
      dataSolicitacao
      dataRealizacao
      dataResultado
      observacao
      conferido
      especifico {
        id
        exameEspecificoEnum
        valor
        igDias
        igSemanas
        dpp
        resultadoExamePuericulturaEnum
        resultadoExameEstruturadoQualitativoEnum
      }
      atendimentoProfissionalResultado {
        id
        iniciadoEm
      }
    }
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useResultadosExamesCardQuery__
 *
 * To run a query within a React component, call `useResultadosExamesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultadosExamesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultadosExamesCardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResultadosExamesCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables> & ({ variables: Types.ResultadosExamesCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>(ResultadosExamesCardDocument, options);
      }
export function useResultadosExamesCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>(ResultadosExamesCardDocument, options);
        }
export function useResultadosExamesCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>(ResultadosExamesCardDocument, options);
        }
export type ResultadosExamesCardQueryHookResult = ReturnType<typeof useResultadosExamesCardQuery>;
export type ResultadosExamesCardLazyQueryHookResult = ReturnType<typeof useResultadosExamesCardLazyQuery>;
export type ResultadosExamesCardSuspenseQueryHookResult = ReturnType<typeof useResultadosExamesCardSuspenseQuery>;
export type ResultadosExamesCardQueryResult = Apollo.QueryResult<Types.ResultadosExamesCardQuery, Types.ResultadosExamesCardQueryVariables>;
export const EvolucoesProblemasAtendObservacaoDocument = gql`
    query EvolucoesProblemasAtendObservacao($atendimentoId: ID!) {
  atendimento(id: $atendimentoId) {
    id
    atendimentoProfissional {
      id
      evolucaoProblema {
        id
        problema {
          ...ProblemaCondicao
        }
      }
    }
  }
}
    ${ProblemaCondicaoFragmentDoc}`;

/**
 * __useEvolucoesProblemasAtendObservacaoQuery__
 *
 * To run a query within a React component, call `useEvolucoesProblemasAtendObservacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvolucoesProblemasAtendObservacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvolucoesProblemasAtendObservacaoQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useEvolucoesProblemasAtendObservacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables> & ({ variables: Types.EvolucoesProblemasAtendObservacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>(EvolucoesProblemasAtendObservacaoDocument, options);
      }
export function useEvolucoesProblemasAtendObservacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>(EvolucoesProblemasAtendObservacaoDocument, options);
        }
export function useEvolucoesProblemasAtendObservacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>(EvolucoesProblemasAtendObservacaoDocument, options);
        }
export type EvolucoesProblemasAtendObservacaoQueryHookResult = ReturnType<typeof useEvolucoesProblemasAtendObservacaoQuery>;
export type EvolucoesProblemasAtendObservacaoLazyQueryHookResult = ReturnType<typeof useEvolucoesProblemasAtendObservacaoLazyQuery>;
export type EvolucoesProblemasAtendObservacaoSuspenseQueryHookResult = ReturnType<typeof useEvolucoesProblemasAtendObservacaoSuspenseQuery>;
export type EvolucoesProblemasAtendObservacaoQueryResult = Apollo.QueryResult<Types.EvolucoesProblemasAtendObservacaoQuery, Types.EvolucoesProblemasAtendObservacaoQueryVariables>;
export const GrupoCondicaoDocument = gql`
    query GrupoCondicao($input: GrupoCondicaoEnum!) {
  grupoByEnum(input: $input) {
    id
    ciaps {
      id
      codigo
      descricao
    }
    cids {
      id
      codigo
      nome
    }
  }
}
    `;

/**
 * __useGrupoCondicaoQuery__
 *
 * To run a query within a React component, call `useGrupoCondicaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoCondicaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoCondicaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrupoCondicaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables> & ({ variables: Types.GrupoCondicaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>(GrupoCondicaoDocument, options);
      }
export function useGrupoCondicaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>(GrupoCondicaoDocument, options);
        }
export function useGrupoCondicaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>(GrupoCondicaoDocument, options);
        }
export type GrupoCondicaoQueryHookResult = ReturnType<typeof useGrupoCondicaoQuery>;
export type GrupoCondicaoLazyQueryHookResult = ReturnType<typeof useGrupoCondicaoLazyQuery>;
export type GrupoCondicaoSuspenseQueryHookResult = ReturnType<typeof useGrupoCondicaoSuspenseQuery>;
export type GrupoCondicaoQueryResult = Apollo.QueryResult<Types.GrupoCondicaoQuery, Types.GrupoCondicaoQueryVariables>;
export const ProblemasFaltantesLpcDocument = gql`
    query ProblemasFaltantesLPC($prontuarioId: ID!) {
  problemasFaltantesLPC(prontuarioId: $prontuarioId) {
    ciap {
      inclui
      exclui
      ...Ciap
    }
    cid10 {
      ...Cid10
    }
    dataRegistroProblema
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}`;

/**
 * __useProblemasFaltantesLpcQuery__
 *
 * To run a query within a React component, call `useProblemasFaltantesLpcQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemasFaltantesLpcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemasFaltantesLpcQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useProblemasFaltantesLpcQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables> & ({ variables: Types.ProblemasFaltantesLpcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>(ProblemasFaltantesLpcDocument, options);
      }
export function useProblemasFaltantesLpcLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>(ProblemasFaltantesLpcDocument, options);
        }
export function useProblemasFaltantesLpcSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>(ProblemasFaltantesLpcDocument, options);
        }
export type ProblemasFaltantesLpcQueryHookResult = ReturnType<typeof useProblemasFaltantesLpcQuery>;
export type ProblemasFaltantesLpcLazyQueryHookResult = ReturnType<typeof useProblemasFaltantesLpcLazyQuery>;
export type ProblemasFaltantesLpcSuspenseQueryHookResult = ReturnType<typeof useProblemasFaltantesLpcSuspenseQuery>;
export type ProblemasFaltantesLpcQueryResult = Apollo.QueryResult<Types.ProblemasFaltantesLpcQuery, Types.ProblemasFaltantesLpcQueryVariables>;
export const SugestaoDatasAgendamentoDocument = gql`
    query SugestaoDatasAgendamento($input: SugestoesDatasInput!) {
  sugestoesDatas(input: $input) {
    preNatal
    odontologica
  }
}
    `;

/**
 * __useSugestaoDatasAgendamentoQuery__
 *
 * To run a query within a React component, call `useSugestaoDatasAgendamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSugestaoDatasAgendamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSugestaoDatasAgendamentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSugestaoDatasAgendamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables> & ({ variables: Types.SugestaoDatasAgendamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>(SugestaoDatasAgendamentoDocument, options);
      }
export function useSugestaoDatasAgendamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>(SugestaoDatasAgendamentoDocument, options);
        }
export function useSugestaoDatasAgendamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>(SugestaoDatasAgendamentoDocument, options);
        }
export type SugestaoDatasAgendamentoQueryHookResult = ReturnType<typeof useSugestaoDatasAgendamentoQuery>;
export type SugestaoDatasAgendamentoLazyQueryHookResult = ReturnType<typeof useSugestaoDatasAgendamentoLazyQuery>;
export type SugestaoDatasAgendamentoSuspenseQueryHookResult = ReturnType<typeof useSugestaoDatasAgendamentoSuspenseQuery>;
export type SugestaoDatasAgendamentoQueryResult = Apollo.QueryResult<Types.SugestaoDatasAgendamentoQuery, Types.SugestaoDatasAgendamentoQueryVariables>;
export const SugestaoProfissionaisAgendamentoDocument = gql`
    query SugestaoProfissionaisAgendamento($prontuarioId: ID!) {
  sugestoesProfissionais(prontuarioId: $prontuarioId) {
    preNatal {
      ...LotacaoSugestaoAgendamento
    }
    odontologico {
      ...LotacaoSugestaoAgendamento
    }
  }
}
    ${LotacaoSugestaoAgendamentoFragmentDoc}`;

/**
 * __useSugestaoProfissionaisAgendamentoQuery__
 *
 * To run a query within a React component, call `useSugestaoProfissionaisAgendamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSugestaoProfissionaisAgendamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSugestaoProfissionaisAgendamentoQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useSugestaoProfissionaisAgendamentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables> & ({ variables: Types.SugestaoProfissionaisAgendamentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>(SugestaoProfissionaisAgendamentoDocument, options);
      }
export function useSugestaoProfissionaisAgendamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>(SugestaoProfissionaisAgendamentoDocument, options);
        }
export function useSugestaoProfissionaisAgendamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>(SugestaoProfissionaisAgendamentoDocument, options);
        }
export type SugestaoProfissionaisAgendamentoQueryHookResult = ReturnType<typeof useSugestaoProfissionaisAgendamentoQuery>;
export type SugestaoProfissionaisAgendamentoLazyQueryHookResult = ReturnType<typeof useSugestaoProfissionaisAgendamentoLazyQuery>;
export type SugestaoProfissionaisAgendamentoSuspenseQueryHookResult = ReturnType<typeof useSugestaoProfissionaisAgendamentoSuspenseQuery>;
export type SugestaoProfissionaisAgendamentoQueryResult = Apollo.QueryResult<Types.SugestaoProfissionaisAgendamentoQuery, Types.SugestaoProfissionaisAgendamentoQueryVariables>;
export const IvcfEmAtendimentoObservacaoDocument = gql`
    query IvcfEmAtendimentoObservacao($id: ID!) {
  atendimentoIndividual(id: $id) {
    id
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dataResultado
      riscoVulnerabilidade
      aplicacao {
        id
        pergunta
        resposta
      }
    }
  }
}
    `;

/**
 * __useIvcfEmAtendimentoObservacaoQuery__
 *
 * To run a query within a React component, call `useIvcfEmAtendimentoObservacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvcfEmAtendimentoObservacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvcfEmAtendimentoObservacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIvcfEmAtendimentoObservacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables> & ({ variables: Types.IvcfEmAtendimentoObservacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>(IvcfEmAtendimentoObservacaoDocument, options);
      }
export function useIvcfEmAtendimentoObservacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>(IvcfEmAtendimentoObservacaoDocument, options);
        }
export function useIvcfEmAtendimentoObservacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>(IvcfEmAtendimentoObservacaoDocument, options);
        }
export type IvcfEmAtendimentoObservacaoQueryHookResult = ReturnType<typeof useIvcfEmAtendimentoObservacaoQuery>;
export type IvcfEmAtendimentoObservacaoLazyQueryHookResult = ReturnType<typeof useIvcfEmAtendimentoObservacaoLazyQuery>;
export type IvcfEmAtendimentoObservacaoSuspenseQueryHookResult = ReturnType<typeof useIvcfEmAtendimentoObservacaoSuspenseQuery>;
export type IvcfEmAtendimentoObservacaoQueryResult = Apollo.QueryResult<Types.IvcfEmAtendimentoObservacaoQuery, Types.IvcfEmAtendimentoObservacaoQueryVariables>;
export const PreNatalEmAtendimentoObservacaoDocument = gql`
    query PreNatalEmAtendimentoObservacao($id: ID!) {
  atendimentoIndividual(id: $id) {
    id
    medicoes {
      id
      valorAlturaUterina
      valorBatimentoCardiacoFetal
      valorBatimentoCardiacoFetal2
      medicaoAnterior
    }
    atendimentoProfissionalPreNatal {
      id
      gravidezPlanejada
      movimentacaoFetal
      tipoEdema
      preNatal {
        id
        altoRisco
        fonteIdadeGestacional
        tipoGravidez {
          id
          descricao
          tipoGravidez
        }
      }
    }
  }
}
    `;

/**
 * __usePreNatalEmAtendimentoObservacaoQuery__
 *
 * To run a query within a React component, call `usePreNatalEmAtendimentoObservacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreNatalEmAtendimentoObservacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreNatalEmAtendimentoObservacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreNatalEmAtendimentoObservacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables> & ({ variables: Types.PreNatalEmAtendimentoObservacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>(PreNatalEmAtendimentoObservacaoDocument, options);
      }
export function usePreNatalEmAtendimentoObservacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>(PreNatalEmAtendimentoObservacaoDocument, options);
        }
export function usePreNatalEmAtendimentoObservacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>(PreNatalEmAtendimentoObservacaoDocument, options);
        }
export type PreNatalEmAtendimentoObservacaoQueryHookResult = ReturnType<typeof usePreNatalEmAtendimentoObservacaoQuery>;
export type PreNatalEmAtendimentoObservacaoLazyQueryHookResult = ReturnType<typeof usePreNatalEmAtendimentoObservacaoLazyQuery>;
export type PreNatalEmAtendimentoObservacaoSuspenseQueryHookResult = ReturnType<typeof usePreNatalEmAtendimentoObservacaoSuspenseQuery>;
export type PreNatalEmAtendimentoObservacaoQueryResult = Apollo.QueryResult<Types.PreNatalEmAtendimentoObservacaoQuery, Types.PreNatalEmAtendimentoObservacaoQueryVariables>;
export const ExamesSolicitadosDocument = gql`
    query ExamesSolicitados($input: ResultadosExameQueryInput!) {
  resultadosExame(input: $input) {
    content {
      id
      dataSolicitacao
      exame {
        id
        descricao
        codigo
      }
      atendimentoProfissionalSolicitacao {
        id
        lotacao {
          id
          profissional {
            id
            nome
          }
          unidadeSaude {
            id
            nome
          }
          cbo {
            id
            nome
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExamesSolicitadosQuery__
 *
 * To run a query within a React component, call `useExamesSolicitadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamesSolicitadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamesSolicitadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamesSolicitadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables> & ({ variables: Types.ExamesSolicitadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>(ExamesSolicitadosDocument, options);
      }
export function useExamesSolicitadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>(ExamesSolicitadosDocument, options);
        }
export function useExamesSolicitadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>(ExamesSolicitadosDocument, options);
        }
export type ExamesSolicitadosQueryHookResult = ReturnType<typeof useExamesSolicitadosQuery>;
export type ExamesSolicitadosLazyQueryHookResult = ReturnType<typeof useExamesSolicitadosLazyQuery>;
export type ExamesSolicitadosSuspenseQueryHookResult = ReturnType<typeof useExamesSolicitadosSuspenseQuery>;
export type ExamesSolicitadosQueryResult = Apollo.QueryResult<Types.ExamesSolicitadosQuery, Types.ExamesSolicitadosQueryVariables>;
export const ArquivosAnexadosNoProntuarioDocument = gql`
    query ArquivosAnexadosNoProntuario($prontuarioId: Long!) {
  arquivosAnexadosNoProntuario(prontuarioId: $prontuarioId) {
    id
    titulo
    observacao
    categoria
    arquivo {
      id
      uuid
      dataCriacao
    }
    atendimentoProfissional {
      id
      lotacao {
        id
        profissional {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useArquivosAnexadosNoProntuarioQuery__
 *
 * To run a query within a React component, call `useArquivosAnexadosNoProntuarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useArquivosAnexadosNoProntuarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArquivosAnexadosNoProntuarioQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useArquivosAnexadosNoProntuarioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables> & ({ variables: Types.ArquivosAnexadosNoProntuarioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>(ArquivosAnexadosNoProntuarioDocument, options);
      }
export function useArquivosAnexadosNoProntuarioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>(ArquivosAnexadosNoProntuarioDocument, options);
        }
export function useArquivosAnexadosNoProntuarioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>(ArquivosAnexadosNoProntuarioDocument, options);
        }
export type ArquivosAnexadosNoProntuarioQueryHookResult = ReturnType<typeof useArquivosAnexadosNoProntuarioQuery>;
export type ArquivosAnexadosNoProntuarioLazyQueryHookResult = ReturnType<typeof useArquivosAnexadosNoProntuarioLazyQuery>;
export type ArquivosAnexadosNoProntuarioSuspenseQueryHookResult = ReturnType<typeof useArquivosAnexadosNoProntuarioSuspenseQuery>;
export type ArquivosAnexadosNoProntuarioQueryResult = Apollo.QueryResult<Types.ArquivosAnexadosNoProntuarioQuery, Types.ArquivosAnexadosNoProntuarioQueryVariables>;
export const UltimoAtendimentoProfissionalComMcaByProntuarioIdDocument = gql`
    query UltimoAtendimentoProfissionalComMCAByProntuarioId($prontuarioId: ID!) {
  ultimoAtendimentoProfissionalComMCAByProntuarioId(prontuarioId: $prontuarioId) {
    id
    iniciadoEm
  }
}
    `;

/**
 * __useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery__
 *
 * To run a query within a React component, call `useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables> & ({ variables: Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>(UltimoAtendimentoProfissionalComMcaByProntuarioIdDocument, options);
      }
export function useUltimoAtendimentoProfissionalComMcaByProntuarioIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>(UltimoAtendimentoProfissionalComMcaByProntuarioIdDocument, options);
        }
export function useUltimoAtendimentoProfissionalComMcaByProntuarioIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>(UltimoAtendimentoProfissionalComMcaByProntuarioIdDocument, options);
        }
export type UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalComMcaByProntuarioIdQuery>;
export type UltimoAtendimentoProfissionalComMcaByProntuarioIdLazyQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalComMcaByProntuarioIdLazyQuery>;
export type UltimoAtendimentoProfissionalComMcaByProntuarioIdSuspenseQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalComMcaByProntuarioIdSuspenseQuery>;
export type UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryResult = Apollo.QueryResult<Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery, Types.UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables>;
export const PuericulturaDocument = gql`
    query Puericultura($prontuarioId: ID!, $dataReferencia: LocalDate!) {
  hasPuericultura(prontuarioId: $prontuarioId)
  alteracoesFenotipicas(prontuarioId: $prontuarioId) {
    id
    descricao
    status
    dataAvaliacao
  }
  fatoresRisco(prontuarioId: $prontuarioId) {
    id
    descricao
    status
    dataAvaliacao
  }
  marcosDesenvolvimento(
    input: {prontuarioId: $prontuarioId, dataReferencia: $dataReferencia}
  ) {
    id
    descricao
    hint
    status
    dataAvaliacao
    alcancadoComMeses
    alcancadoComAnos
    faixaEtariaEnum
    faixaEtariaFim
    descricaoFaixaEtaria
  }
  medicoesAnteriores: medicoes(input: {prontuarioId: $prontuarioId}) {
    id
    dataMedicao
    valorPerimetroCefalico
  }
  antecedente(prontuarioId: $prontuarioId) {
    id
    perimetroCefalico
  }
}
    `;

/**
 * __usePuericulturaQuery__
 *
 * To run a query within a React component, call `usePuericulturaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePuericulturaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePuericulturaQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      dataReferencia: // value for 'dataReferencia'
 *   },
 * });
 */
export function usePuericulturaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PuericulturaQuery, Types.PuericulturaQueryVariables> & ({ variables: Types.PuericulturaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>(PuericulturaDocument, options);
      }
export function usePuericulturaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>(PuericulturaDocument, options);
        }
export function usePuericulturaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>(PuericulturaDocument, options);
        }
export type PuericulturaQueryHookResult = ReturnType<typeof usePuericulturaQuery>;
export type PuericulturaLazyQueryHookResult = ReturnType<typeof usePuericulturaLazyQuery>;
export type PuericulturaSuspenseQueryHookResult = ReturnType<typeof usePuericulturaSuspenseQuery>;
export type PuericulturaQueryResult = Apollo.QueryResult<Types.PuericulturaQuery, Types.PuericulturaQueryVariables>;
export const UltimoMChatDocument = gql`
    query UltimoMChat($prontuarioId: ID!) {
  ultimoMChatR(prontuarioId: $prontuarioId) {
    ...UltimoMChat
  }
  ultimoMChatRf(prontuarioId: $prontuarioId) {
    ...UltimoMChat
  }
}
    ${UltimoMChatFragmentDoc}`;

/**
 * __useUltimoMChatQuery__
 *
 * To run a query within a React component, call `useUltimoMChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoMChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoMChatQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useUltimoMChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables> & ({ variables: Types.UltimoMChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>(UltimoMChatDocument, options);
      }
export function useUltimoMChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>(UltimoMChatDocument, options);
        }
export function useUltimoMChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>(UltimoMChatDocument, options);
        }
export type UltimoMChatQueryHookResult = ReturnType<typeof useUltimoMChatQuery>;
export type UltimoMChatLazyQueryHookResult = ReturnType<typeof useUltimoMChatLazyQuery>;
export type UltimoMChatSuspenseQueryHookResult = ReturnType<typeof useUltimoMChatSuspenseQuery>;
export type UltimoMChatQueryResult = Apollo.QueryResult<Types.UltimoMChatQuery, Types.UltimoMChatQueryVariables>;
export const RegistrosMChatDocument = gql`
    query RegistrosMChat($prontuarioId: ID!) {
  registrosMChat(prontuarioId: $prontuarioId) {
    id
    risco
    dataResultado
    isMchatRf
  }
}
    `;

/**
 * __useRegistrosMChatQuery__
 *
 * To run a query within a React component, call `useRegistrosMChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrosMChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrosMChatQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useRegistrosMChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables> & ({ variables: Types.RegistrosMChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>(RegistrosMChatDocument, options);
      }
export function useRegistrosMChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>(RegistrosMChatDocument, options);
        }
export function useRegistrosMChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>(RegistrosMChatDocument, options);
        }
export type RegistrosMChatQueryHookResult = ReturnType<typeof useRegistrosMChatQuery>;
export type RegistrosMChatLazyQueryHookResult = ReturnType<typeof useRegistrosMChatLazyQuery>;
export type RegistrosMChatSuspenseQueryHookResult = ReturnType<typeof useRegistrosMChatSuspenseQuery>;
export type RegistrosMChatQueryResult = Apollo.QueryResult<Types.RegistrosMChatQuery, Types.RegistrosMChatQueryVariables>;
export const SolicitacoesExamesPagedDocument = gql`
    query SolicitacoesExamesPaged($input: SolicitacoesExameQueryInput!) {
  solicitacoesExamePaged(input: $input) {
    content {
      id
      data
      tipoExame
      observacoes
      justificativa
      exames {
        id
        conferido
        observacao
        solicitacao {
          id
          data
        }
        exame {
          ...Procedimento
        }
        atendimentoProfissionalResultado {
          id
        }
      }
      cid10 {
        ...Cid10
        sexo
      }
      atendimentoProfissional {
        id
        iniciadoEm
        lotacao {
          id
          cbo {
            id
            nome
          }
          unidadeSaude {
            id
            nome
          }
          profissional {
            id
            nome
          }
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ProcedimentoFragmentDoc}
${Cid10FragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useSolicitacoesExamesPagedQuery__
 *
 * To run a query within a React component, call `useSolicitacoesExamesPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitacoesExamesPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitacoesExamesPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitacoesExamesPagedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables> & ({ variables: Types.SolicitacoesExamesPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>(SolicitacoesExamesPagedDocument, options);
      }
export function useSolicitacoesExamesPagedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>(SolicitacoesExamesPagedDocument, options);
        }
export function useSolicitacoesExamesPagedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>(SolicitacoesExamesPagedDocument, options);
        }
export type SolicitacoesExamesPagedQueryHookResult = ReturnType<typeof useSolicitacoesExamesPagedQuery>;
export type SolicitacoesExamesPagedLazyQueryHookResult = ReturnType<typeof useSolicitacoesExamesPagedLazyQuery>;
export type SolicitacoesExamesPagedSuspenseQueryHookResult = ReturnType<typeof useSolicitacoesExamesPagedSuspenseQuery>;
export type SolicitacoesExamesPagedQueryResult = Apollo.QueryResult<Types.SolicitacoesExamesPagedQuery, Types.SolicitacoesExamesPagedQueryVariables>;
export const SolicitacoesExameUnpagedDocument = gql`
    query SolicitacoesExameUnpaged($input: SolicitacoesExameQueryInput!) {
  solicitacoesExame(input: $input) {
    content {
      ...SolicitacaoExame
    }
  }
}
    ${SolicitacaoExameFragmentDoc}`;

/**
 * __useSolicitacoesExameUnpagedQuery__
 *
 * To run a query within a React component, call `useSolicitacoesExameUnpagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitacoesExameUnpagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitacoesExameUnpagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitacoesExameUnpagedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables> & ({ variables: Types.SolicitacoesExameUnpagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>(SolicitacoesExameUnpagedDocument, options);
      }
export function useSolicitacoesExameUnpagedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>(SolicitacoesExameUnpagedDocument, options);
        }
export function useSolicitacoesExameUnpagedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>(SolicitacoesExameUnpagedDocument, options);
        }
export type SolicitacoesExameUnpagedQueryHookResult = ReturnType<typeof useSolicitacoesExameUnpagedQuery>;
export type SolicitacoesExameUnpagedLazyQueryHookResult = ReturnType<typeof useSolicitacoesExameUnpagedLazyQuery>;
export type SolicitacoesExameUnpagedSuspenseQueryHookResult = ReturnType<typeof useSolicitacoesExameUnpagedSuspenseQuery>;
export type SolicitacoesExameUnpagedQueryResult = Apollo.QueryResult<Types.SolicitacoesExameUnpagedQuery, Types.SolicitacoesExameUnpagedQueryVariables>;
export const AtestadoModelosLoadDocument = gql`
    query AtestadoModelosLoad {
  atestadoModelos {
    id
    nome
  }
}
    `;

/**
 * __useAtestadoModelosLoadQuery__
 *
 * To run a query within a React component, call `useAtestadoModelosLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtestadoModelosLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtestadoModelosLoadQuery({
 *   variables: {
 *   },
 * });
 */
export function useAtestadoModelosLoadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>(AtestadoModelosLoadDocument, options);
      }
export function useAtestadoModelosLoadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>(AtestadoModelosLoadDocument, options);
        }
export function useAtestadoModelosLoadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>(AtestadoModelosLoadDocument, options);
        }
export type AtestadoModelosLoadQueryHookResult = ReturnType<typeof useAtestadoModelosLoadQuery>;
export type AtestadoModelosLoadLazyQueryHookResult = ReturnType<typeof useAtestadoModelosLoadLazyQuery>;
export type AtestadoModelosLoadSuspenseQueryHookResult = ReturnType<typeof useAtestadoModelosLoadSuspenseQuery>;
export type AtestadoModelosLoadQueryResult = Apollo.QueryResult<Types.AtestadoModelosLoadQuery, Types.AtestadoModelosLoadQueryVariables>;
export const LoadAtestadoByIdDocument = gql`
    query LoadAtestadoById($id: ID!) {
  atestado(id: $id) {
    id
    descricao
    atendimentoProfissional {
      id
      lotacao {
        id
        profissional {
          id
          nome
          numeroConselhoClasse
          conselhoClasse {
            id
            sigla
          }
          ufEmissoraConselhoClasse {
            id
            nome
            sigla
          }
        }
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
        unidadeSaude {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
      iniciadoEm
    }
  }
}
    `;

/**
 * __useLoadAtestadoByIdQuery__
 *
 * To run a query within a React component, call `useLoadAtestadoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAtestadoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAtestadoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAtestadoByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables> & ({ variables: Types.LoadAtestadoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>(LoadAtestadoByIdDocument, options);
      }
export function useLoadAtestadoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>(LoadAtestadoByIdDocument, options);
        }
export function useLoadAtestadoByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>(LoadAtestadoByIdDocument, options);
        }
export type LoadAtestadoByIdQueryHookResult = ReturnType<typeof useLoadAtestadoByIdQuery>;
export type LoadAtestadoByIdLazyQueryHookResult = ReturnType<typeof useLoadAtestadoByIdLazyQuery>;
export type LoadAtestadoByIdSuspenseQueryHookResult = ReturnType<typeof useLoadAtestadoByIdSuspenseQuery>;
export type LoadAtestadoByIdQueryResult = Apollo.QueryResult<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>;
export const LoadAtestadosDocument = gql`
    query LoadAtestados($input: AtestadoQueryInput!) {
  atestados(input: $input) {
    content {
      id
      tipo
      atendimentoProfissional {
        id
        iniciadoEm
        lotacao {
          id
          profissional {
            id
            nome
            numeroConselhoClasse
            conselhoClasse {
              id
              sigla
            }
            ufEmissoraConselhoClasse {
              id
              nome
              sigla
            }
          }
          cbo {
            id
            nome
          }
          unidadeSaude {
            id
            nome
          }
          municipio {
            id
            nome
            uf {
              id
              nome
              sigla
            }
          }
        }
      }
      assinadoDigitalmente
    }
  }
}
    `;

/**
 * __useLoadAtestadosQuery__
 *
 * To run a query within a React component, call `useLoadAtestadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAtestadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAtestadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadAtestadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables> & ({ variables: Types.LoadAtestadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>(LoadAtestadosDocument, options);
      }
export function useLoadAtestadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>(LoadAtestadosDocument, options);
        }
export function useLoadAtestadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>(LoadAtestadosDocument, options);
        }
export type LoadAtestadosQueryHookResult = ReturnType<typeof useLoadAtestadosQuery>;
export type LoadAtestadosLazyQueryHookResult = ReturnType<typeof useLoadAtestadosLazyQuery>;
export type LoadAtestadosSuspenseQueryHookResult = ReturnType<typeof useLoadAtestadosSuspenseQuery>;
export type LoadAtestadosQueryResult = Apollo.QueryResult<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>;
export const AtestadoModeloByIdDocument = gql`
    query AtestadoModeloById($id: ID!) {
  atestadoModelo(id: $id) {
    id
    nome
    descricao
  }
}
    `;

/**
 * __useAtestadoModeloByIdQuery__
 *
 * To run a query within a React component, call `useAtestadoModeloByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtestadoModeloByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtestadoModeloByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtestadoModeloByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables> & ({ variables: Types.AtestadoModeloByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>(AtestadoModeloByIdDocument, options);
      }
export function useAtestadoModeloByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>(AtestadoModeloByIdDocument, options);
        }
export function useAtestadoModeloByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>(AtestadoModeloByIdDocument, options);
        }
export type AtestadoModeloByIdQueryHookResult = ReturnType<typeof useAtestadoModeloByIdQuery>;
export type AtestadoModeloByIdLazyQueryHookResult = ReturnType<typeof useAtestadoModeloByIdLazyQuery>;
export type AtestadoModeloByIdSuspenseQueryHookResult = ReturnType<typeof useAtestadoModeloByIdSuspenseQuery>;
export type AtestadoModeloByIdQueryResult = Apollo.QueryResult<Types.AtestadoModeloByIdQuery, Types.AtestadoModeloByIdQueryVariables>;
export const AtestadoModeloDeleteDocument = gql`
    mutation AtestadoModeloDelete($id: ID!) {
  excluirAtestadoModelo(idModelo: $id)
}
    `;
export type AtestadoModeloDeleteMutationFn = Apollo.MutationFunction<Types.AtestadoModeloDeleteMutation, Types.AtestadoModeloDeleteMutationVariables>;

/**
 * __useAtestadoModeloDeleteMutation__
 *
 * To run a mutation, you first call `useAtestadoModeloDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtestadoModeloDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atestadoModeloDeleteMutation, { data, loading, error }] = useAtestadoModeloDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtestadoModeloDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtestadoModeloDeleteMutation, Types.AtestadoModeloDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtestadoModeloDeleteMutation, Types.AtestadoModeloDeleteMutationVariables>(AtestadoModeloDeleteDocument, options);
      }
export type AtestadoModeloDeleteMutationHookResult = ReturnType<typeof useAtestadoModeloDeleteMutation>;
export type AtestadoModeloDeleteMutationResult = Apollo.MutationResult<Types.AtestadoModeloDeleteMutation>;
export type AtestadoModeloDeleteMutationOptions = Apollo.BaseMutationOptions<Types.AtestadoModeloDeleteMutation, Types.AtestadoModeloDeleteMutationVariables>;
export const AtestadoModeloSaveDocument = gql`
    mutation AtestadoModeloSave($input: AtestadoModeloInput!) {
  salvarAtestadoModelo(input: $input) {
    id
  }
}
    `;
export type AtestadoModeloSaveMutationFn = Apollo.MutationFunction<Types.AtestadoModeloSaveMutation, Types.AtestadoModeloSaveMutationVariables>;

/**
 * __useAtestadoModeloSaveMutation__
 *
 * To run a mutation, you first call `useAtestadoModeloSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtestadoModeloSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atestadoModeloSaveMutation, { data, loading, error }] = useAtestadoModeloSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtestadoModeloSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtestadoModeloSaveMutation, Types.AtestadoModeloSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtestadoModeloSaveMutation, Types.AtestadoModeloSaveMutationVariables>(AtestadoModeloSaveDocument, options);
      }
export type AtestadoModeloSaveMutationHookResult = ReturnType<typeof useAtestadoModeloSaveMutation>;
export type AtestadoModeloSaveMutationResult = Apollo.MutationResult<Types.AtestadoModeloSaveMutation>;
export type AtestadoModeloSaveMutationOptions = Apollo.BaseMutationOptions<Types.AtestadoModeloSaveMutation, Types.AtestadoModeloSaveMutationVariables>;
export const CompartilhamentoCuidadoPlanoDocument = gql`
    query CompartilhamentoCuidadoPlano($compartilhamentoCuidadoPlanoQueryInput: CompartilhamentoCuidadoPlanoQueryInput!) {
  compartilhamentosCuidadoPlano(input: $compartilhamentoCuidadoPlanoQueryInput) {
    id
    atendimentoProfissional {
      id
    }
    lotacaoSolicitante {
      ...CompartilhamentoCuidadoLotacao
      cbo {
        id
        nome
      }
    }
    lotacaoExecutanteAtual {
      ...CompartilhamentoCuidadoLotacao
    }
    cbo {
      id
      nome
      cbo2002
    }
    unidadeSaude {
      id
      nome
      cnes
    }
    dataInicio
    cid10 {
      ...Cid10
    }
    ciap {
      ...Ciap
    }
    classificacaoPrioridadeAtual
    discussao
    cidadaoAceitaAtendTic
    isEncaminhamento
    especialidade {
      ...EspecialidadesEsusReg
    }
  }
}
    ${CompartilhamentoCuidadoLotacaoFragmentDoc}
${Cid10FragmentDoc}
${CiapFragmentDoc}
${EspecialidadesEsusRegFragmentDoc}`;

/**
 * __useCompartilhamentoCuidadoPlanoQuery__
 *
 * To run a query within a React component, call `useCompartilhamentoCuidadoPlanoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompartilhamentoCuidadoPlanoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompartilhamentoCuidadoPlanoQuery({
 *   variables: {
 *      compartilhamentoCuidadoPlanoQueryInput: // value for 'compartilhamentoCuidadoPlanoQueryInput'
 *   },
 * });
 */
export function useCompartilhamentoCuidadoPlanoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables> & ({ variables: Types.CompartilhamentoCuidadoPlanoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>(CompartilhamentoCuidadoPlanoDocument, options);
      }
export function useCompartilhamentoCuidadoPlanoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>(CompartilhamentoCuidadoPlanoDocument, options);
        }
export function useCompartilhamentoCuidadoPlanoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>(CompartilhamentoCuidadoPlanoDocument, options);
        }
export type CompartilhamentoCuidadoPlanoQueryHookResult = ReturnType<typeof useCompartilhamentoCuidadoPlanoQuery>;
export type CompartilhamentoCuidadoPlanoLazyQueryHookResult = ReturnType<typeof useCompartilhamentoCuidadoPlanoLazyQuery>;
export type CompartilhamentoCuidadoPlanoSuspenseQueryHookResult = ReturnType<typeof useCompartilhamentoCuidadoPlanoSuspenseQuery>;
export type CompartilhamentoCuidadoPlanoQueryResult = Apollo.QueryResult<Types.CompartilhamentoCuidadoPlanoQuery, Types.CompartilhamentoCuidadoPlanoQueryVariables>;
export const AcessoHasCbosDisponiveisVinculacaoEquipeDocument = gql`
    query acessoHasCbosDisponiveisVinculacaoEquipe {
  acessoHasCbosDisponiveisVinculacaoEquipe
}
    `;

/**
 * __useAcessoHasCbosDisponiveisVinculacaoEquipeQuery__
 *
 * To run a query within a React component, call `useAcessoHasCbosDisponiveisVinculacaoEquipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoHasCbosDisponiveisVinculacaoEquipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoHasCbosDisponiveisVinculacaoEquipeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcessoHasCbosDisponiveisVinculacaoEquipeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>(AcessoHasCbosDisponiveisVinculacaoEquipeDocument, options);
      }
export function useAcessoHasCbosDisponiveisVinculacaoEquipeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>(AcessoHasCbosDisponiveisVinculacaoEquipeDocument, options);
        }
export function useAcessoHasCbosDisponiveisVinculacaoEquipeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>(AcessoHasCbosDisponiveisVinculacaoEquipeDocument, options);
        }
export type AcessoHasCbosDisponiveisVinculacaoEquipeQueryHookResult = ReturnType<typeof useAcessoHasCbosDisponiveisVinculacaoEquipeQuery>;
export type AcessoHasCbosDisponiveisVinculacaoEquipeLazyQueryHookResult = ReturnType<typeof useAcessoHasCbosDisponiveisVinculacaoEquipeLazyQuery>;
export type AcessoHasCbosDisponiveisVinculacaoEquipeSuspenseQueryHookResult = ReturnType<typeof useAcessoHasCbosDisponiveisVinculacaoEquipeSuspenseQuery>;
export type AcessoHasCbosDisponiveisVinculacaoEquipeQueryResult = Apollo.QueryResult<Types.AcessoHasCbosDisponiveisVinculacaoEquipeQuery, Types.AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables>;
export const AcessoHasVinculacaoEquipeNasfDocument = gql`
    query acessoHasVinculacaoEquipeNasf {
  acessoHasVinculacaoEquipeNasf
}
    `;

/**
 * __useAcessoHasVinculacaoEquipeNasfQuery__
 *
 * To run a query within a React component, call `useAcessoHasVinculacaoEquipeNasfQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoHasVinculacaoEquipeNasfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoHasVinculacaoEquipeNasfQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcessoHasVinculacaoEquipeNasfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>(AcessoHasVinculacaoEquipeNasfDocument, options);
      }
export function useAcessoHasVinculacaoEquipeNasfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>(AcessoHasVinculacaoEquipeNasfDocument, options);
        }
export function useAcessoHasVinculacaoEquipeNasfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>(AcessoHasVinculacaoEquipeNasfDocument, options);
        }
export type AcessoHasVinculacaoEquipeNasfQueryHookResult = ReturnType<typeof useAcessoHasVinculacaoEquipeNasfQuery>;
export type AcessoHasVinculacaoEquipeNasfLazyQueryHookResult = ReturnType<typeof useAcessoHasVinculacaoEquipeNasfLazyQuery>;
export type AcessoHasVinculacaoEquipeNasfSuspenseQueryHookResult = ReturnType<typeof useAcessoHasVinculacaoEquipeNasfSuspenseQuery>;
export type AcessoHasVinculacaoEquipeNasfQueryResult = Apollo.QueryResult<Types.AcessoHasVinculacaoEquipeNasfQuery, Types.AcessoHasVinculacaoEquipeNasfQueryVariables>;
export const EstabelecimentosCuidadoCompartilhadoSelectFieldDocument = gql`
    query EstabelecimentosCuidadoCompartilhadoSelectField($input: EstabelecimentosCuidadoCompartilhadoByCboIdQueryInput!) {
  estabelecimentosCuidadoCompartilhado(input: $input) {
    content {
      id
      cnes
      nome
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>(EstabelecimentosCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useEstabelecimentosCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>(EstabelecimentosCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useEstabelecimentosCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>(EstabelecimentosCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type EstabelecimentosCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useEstabelecimentosCuidadoCompartilhadoSelectFieldQuery>;
export type EstabelecimentosCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useEstabelecimentosCuidadoCompartilhadoSelectFieldLazyQuery>;
export type EstabelecimentosCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEstabelecimentosCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type EstabelecimentosCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQuery, Types.EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables>;
export const LotacoesCuidadoCompartilhadoSelectFieldDocument = gql`
    query LotacoesCuidadoCompartilhadoSelectField($input: LotacoesCuidadoCompartilhadoByEstabelecimentoIdQueryInput!, $date: LocalDate!) {
  lotacoesCuidadoCompartilhado(input: $input) {
    content {
      ...LotacaoBasico
      hasAgendaFechada(date: $date)
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${LotacaoBasicoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useLotacoesCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useLotacoesCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacoesCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacoesCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLotacoesCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>(LotacoesCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useLotacoesCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>(LotacoesCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useLotacoesCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>(LotacoesCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type LotacoesCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useLotacoesCuidadoCompartilhadoSelectFieldQuery>;
export type LotacoesCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useLotacoesCuidadoCompartilhadoSelectFieldLazyQuery>;
export type LotacoesCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useLotacoesCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type LotacoesCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.LotacoesCuidadoCompartilhadoSelectFieldQuery, Types.LotacoesCuidadoCompartilhadoSelectFieldQueryVariables>;
export const CuidadosCompartilhadoPlanoDocument = gql`
    query CuidadosCompartilhadoPlano($input: CuidadosCompartilhadoQueryInput!) {
  cuidadosCompartilhado(input: $input) {
    content {
      id
      iniciadoEm
      discussao
      cidadaoAceitaAtendTic
      classificacaoPrioridadeAtual
      lotacaoExecutanteAtual {
        id
        profissional {
          id
          nome
          nomeSocial
        }
      }
      cboExecutanteAtual {
        id
        nome
      }
      lotacaoSolicitante {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        cbo {
          id
          nome
        }
      }
      cid10 {
        ...Cid10
      }
      ciap {
        ...Ciap
      }
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}`;

/**
 * __useCuidadosCompartilhadoPlanoQuery__
 *
 * To run a query within a React component, call `useCuidadosCompartilhadoPlanoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuidadosCompartilhadoPlanoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuidadosCompartilhadoPlanoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCuidadosCompartilhadoPlanoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables> & ({ variables: Types.CuidadosCompartilhadoPlanoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>(CuidadosCompartilhadoPlanoDocument, options);
      }
export function useCuidadosCompartilhadoPlanoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>(CuidadosCompartilhadoPlanoDocument, options);
        }
export function useCuidadosCompartilhadoPlanoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>(CuidadosCompartilhadoPlanoDocument, options);
        }
export type CuidadosCompartilhadoPlanoQueryHookResult = ReturnType<typeof useCuidadosCompartilhadoPlanoQuery>;
export type CuidadosCompartilhadoPlanoLazyQueryHookResult = ReturnType<typeof useCuidadosCompartilhadoPlanoLazyQuery>;
export type CuidadosCompartilhadoPlanoSuspenseQueryHookResult = ReturnType<typeof useCuidadosCompartilhadoPlanoSuspenseQuery>;
export type CuidadosCompartilhadoPlanoQueryResult = Apollo.QueryResult<Types.CuidadosCompartilhadoPlanoQuery, Types.CuidadosCompartilhadoPlanoQueryVariables>;
export const AuditGerarDeclaracaoComparecimentoDocument = gql`
    mutation AuditGerarDeclaracaoComparecimento($atendimento: ID!) {
  auditGerarDeclaracaoComparecimento(atendimentoId: $atendimento)
}
    `;
export type AuditGerarDeclaracaoComparecimentoMutationFn = Apollo.MutationFunction<Types.AuditGerarDeclaracaoComparecimentoMutation, Types.AuditGerarDeclaracaoComparecimentoMutationVariables>;

/**
 * __useAuditGerarDeclaracaoComparecimentoMutation__
 *
 * To run a mutation, you first call `useAuditGerarDeclaracaoComparecimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditGerarDeclaracaoComparecimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditGerarDeclaracaoComparecimentoMutation, { data, loading, error }] = useAuditGerarDeclaracaoComparecimentoMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useAuditGerarDeclaracaoComparecimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AuditGerarDeclaracaoComparecimentoMutation, Types.AuditGerarDeclaracaoComparecimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AuditGerarDeclaracaoComparecimentoMutation, Types.AuditGerarDeclaracaoComparecimentoMutationVariables>(AuditGerarDeclaracaoComparecimentoDocument, options);
      }
export type AuditGerarDeclaracaoComparecimentoMutationHookResult = ReturnType<typeof useAuditGerarDeclaracaoComparecimentoMutation>;
export type AuditGerarDeclaracaoComparecimentoMutationResult = Apollo.MutationResult<Types.AuditGerarDeclaracaoComparecimentoMutation>;
export type AuditGerarDeclaracaoComparecimentoMutationOptions = Apollo.BaseMutationOptions<Types.AuditGerarDeclaracaoComparecimentoMutation, Types.AuditGerarDeclaracaoComparecimentoMutationVariables>;
export const AtendimentoProfissionalEncaminhamentoByIdDocument = gql`
    query AtendimentoProfissionalEncaminhamentoById($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    lotacao {
      id
      profissional {
        id
        nome
        cpf
        cns
      }
      cbo {
        id
        nome
        cbo2002
      }
    }
  }
}
    `;

/**
 * __useAtendimentoProfissionalEncaminhamentoByIdQuery__
 *
 * To run a query within a React component, call `useAtendimentoProfissionalEncaminhamentoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoProfissionalEncaminhamentoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoProfissionalEncaminhamentoByIdQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoProfissionalEncaminhamentoByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables> & ({ variables: Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>(AtendimentoProfissionalEncaminhamentoByIdDocument, options);
      }
export function useAtendimentoProfissionalEncaminhamentoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>(AtendimentoProfissionalEncaminhamentoByIdDocument, options);
        }
export function useAtendimentoProfissionalEncaminhamentoByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>(AtendimentoProfissionalEncaminhamentoByIdDocument, options);
        }
export type AtendimentoProfissionalEncaminhamentoByIdQueryHookResult = ReturnType<typeof useAtendimentoProfissionalEncaminhamentoByIdQuery>;
export type AtendimentoProfissionalEncaminhamentoByIdLazyQueryHookResult = ReturnType<typeof useAtendimentoProfissionalEncaminhamentoByIdLazyQuery>;
export type AtendimentoProfissionalEncaminhamentoByIdSuspenseQueryHookResult = ReturnType<typeof useAtendimentoProfissionalEncaminhamentoByIdSuspenseQuery>;
export type AtendimentoProfissionalEncaminhamentoByIdQueryResult = Apollo.QueryResult<Types.AtendimentoProfissionalEncaminhamentoByIdQuery, Types.AtendimentoProfissionalEncaminhamentoByIdQueryVariables>;
export const EncaminhamentoEspecializadoByIdDocument = gql`
    query EncaminhamentoEspecializadoById($id: ID!) {
  encaminhamentoEspecializado(id: $id) {
    id
    atendimentoProfissional {
      id
      lotacao {
        id
        profissional {
          id
          nome
          cpf
          cns
        }
        cbo {
          id
          nome
          cbo2002
        }
      }
      iniciadoEm
    }
    especialidadeSisreg {
      id
      descricao
    }
    hipoteseDiagnosticoCiap {
      id
      descricao
      codigo
    }
    hipoteseDiagnosticoCid10 {
      id
      nome
      codigo
    }
    classificacaoRiscoEncaminhamento
    complemento
    motivoEncaminhamento
    observacoes
  }
}
    `;

/**
 * __useEncaminhamentoEspecializadoByIdQuery__
 *
 * To run a query within a React component, call `useEncaminhamentoEspecializadoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEncaminhamentoEspecializadoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEncaminhamentoEspecializadoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEncaminhamentoEspecializadoByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables> & ({ variables: Types.EncaminhamentoEspecializadoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>(EncaminhamentoEspecializadoByIdDocument, options);
      }
export function useEncaminhamentoEspecializadoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>(EncaminhamentoEspecializadoByIdDocument, options);
        }
export function useEncaminhamentoEspecializadoByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>(EncaminhamentoEspecializadoByIdDocument, options);
        }
export type EncaminhamentoEspecializadoByIdQueryHookResult = ReturnType<typeof useEncaminhamentoEspecializadoByIdQuery>;
export type EncaminhamentoEspecializadoByIdLazyQueryHookResult = ReturnType<typeof useEncaminhamentoEspecializadoByIdLazyQuery>;
export type EncaminhamentoEspecializadoByIdSuspenseQueryHookResult = ReturnType<typeof useEncaminhamentoEspecializadoByIdSuspenseQuery>;
export type EncaminhamentoEspecializadoByIdQueryResult = Apollo.QueryResult<Types.EncaminhamentoEspecializadoByIdQuery, Types.EncaminhamentoEspecializadoByIdQueryVariables>;
export const EncaminhamentosExternosEspecializadosDocument = gql`
    query EncaminhamentosExternosEspecializados($prontuarioId: ID!, $editAtendProfId: ID) {
  encaminhamentosEspecializados(
    input: {prontuarioId: $prontuarioId, editAtendProfId: $editAtendProfId}
  ) {
    content {
      ...EncaminhamentoExternoEspecializado
    }
  }
}
    ${EncaminhamentoExternoEspecializadoFragmentDoc}`;

/**
 * __useEncaminhamentosExternosEspecializadosQuery__
 *
 * To run a query within a React component, call `useEncaminhamentosExternosEspecializadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEncaminhamentosExternosEspecializadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEncaminhamentosExternosEspecializadosQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      editAtendProfId: // value for 'editAtendProfId'
 *   },
 * });
 */
export function useEncaminhamentosExternosEspecializadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables> & ({ variables: Types.EncaminhamentosExternosEspecializadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>(EncaminhamentosExternosEspecializadosDocument, options);
      }
export function useEncaminhamentosExternosEspecializadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>(EncaminhamentosExternosEspecializadosDocument, options);
        }
export function useEncaminhamentosExternosEspecializadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>(EncaminhamentosExternosEspecializadosDocument, options);
        }
export type EncaminhamentosExternosEspecializadosQueryHookResult = ReturnType<typeof useEncaminhamentosExternosEspecializadosQuery>;
export type EncaminhamentosExternosEspecializadosLazyQueryHookResult = ReturnType<typeof useEncaminhamentosExternosEspecializadosLazyQuery>;
export type EncaminhamentosExternosEspecializadosSuspenseQueryHookResult = ReturnType<typeof useEncaminhamentosExternosEspecializadosSuspenseQuery>;
export type EncaminhamentosExternosEspecializadosQueryResult = Apollo.QueryResult<Types.EncaminhamentosExternosEspecializadosQuery, Types.EncaminhamentosExternosEspecializadosQueryVariables>;
export const EncaminhamentosExternosDocument = gql`
    query EncaminhamentosExternos($prontuarioId: ID!, $editAtendProfId: ID) {
  encaminhamentos(
    input: {prontuarioId: $prontuarioId, editAtendProfId: $editAtendProfId}
  ) {
    atendimentoProfissional {
      id
      iniciadoEm
      lotacao {
        id
        profissional {
          id
        }
      }
    }
    tipo
  }
}
    `;

/**
 * __useEncaminhamentosExternosQuery__
 *
 * To run a query within a React component, call `useEncaminhamentosExternosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEncaminhamentosExternosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEncaminhamentosExternosQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      editAtendProfId: // value for 'editAtendProfId'
 *   },
 * });
 */
export function useEncaminhamentosExternosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables> & ({ variables: Types.EncaminhamentosExternosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>(EncaminhamentosExternosDocument, options);
      }
export function useEncaminhamentosExternosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>(EncaminhamentosExternosDocument, options);
        }
export function useEncaminhamentosExternosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>(EncaminhamentosExternosDocument, options);
        }
export type EncaminhamentosExternosQueryHookResult = ReturnType<typeof useEncaminhamentosExternosQuery>;
export type EncaminhamentosExternosLazyQueryHookResult = ReturnType<typeof useEncaminhamentosExternosLazyQuery>;
export type EncaminhamentosExternosSuspenseQueryHookResult = ReturnType<typeof useEncaminhamentosExternosSuspenseQuery>;
export type EncaminhamentosExternosQueryResult = Apollo.QueryResult<Types.EncaminhamentosExternosQuery, Types.EncaminhamentosExternosQueryVariables>;
export const PartesBucaisDocument = gql`
    query PartesBucais($input: PartesBucaisQueryInput!) {
  partesBucais(input: $input) {
    content {
      id
      descricao
      parteBucalEnum
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePartesBucaisQuery__
 *
 * To run a query within a React component, call `usePartesBucaisQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartesBucaisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartesBucaisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartesBucaisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables> & ({ variables: Types.PartesBucaisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>(PartesBucaisDocument, options);
      }
export function usePartesBucaisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>(PartesBucaisDocument, options);
        }
export function usePartesBucaisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>(PartesBucaisDocument, options);
        }
export type PartesBucaisQueryHookResult = ReturnType<typeof usePartesBucaisQuery>;
export type PartesBucaisLazyQueryHookResult = ReturnType<typeof usePartesBucaisLazyQuery>;
export type PartesBucaisSuspenseQueryHookResult = ReturnType<typeof usePartesBucaisSuspenseQuery>;
export type PartesBucaisQueryResult = Apollo.QueryResult<Types.PartesBucaisQuery, Types.PartesBucaisQueryVariables>;
export const OdontogramaProcedimentosDocument = gql`
    query OdontogramaProcedimentos($input: EvolucoesProcedimentoOdontoInput!) {
  evolucoesProcedimentoOdonto(input: $input) {
    content {
      id
      descricaoParteBucal
      observacao
      atendimentoProfissionalOdonto {
        id
      }
      partesBucais {
        id
        tipoParteBucal
        descricao
      }
      procedimentos {
        ...Procedimento
      }
    }
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useOdontogramaProcedimentosQuery__
 *
 * To run a query within a React component, call `useOdontogramaProcedimentosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramaProcedimentosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramaProcedimentosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOdontogramaProcedimentosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables> & ({ variables: Types.OdontogramaProcedimentosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>(OdontogramaProcedimentosDocument, options);
      }
export function useOdontogramaProcedimentosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>(OdontogramaProcedimentosDocument, options);
        }
export function useOdontogramaProcedimentosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>(OdontogramaProcedimentosDocument, options);
        }
export type OdontogramaProcedimentosQueryHookResult = ReturnType<typeof useOdontogramaProcedimentosQuery>;
export type OdontogramaProcedimentosLazyQueryHookResult = ReturnType<typeof useOdontogramaProcedimentosLazyQuery>;
export type OdontogramaProcedimentosSuspenseQueryHookResult = ReturnType<typeof useOdontogramaProcedimentosSuspenseQuery>;
export type OdontogramaProcedimentosQueryResult = Apollo.QueryResult<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>;
export const OdontogramaDocument = gql`
    query Odontograma($id: ID!) {
  odontograma(id: $id) {
    id
    evolucoesDente {
      id
      dente {
        id
        numero
      }
      situacoesFace
      situacoesRaiz
      situacaoCoroaCima
      situacaoCoroaBaixo
      situacaoCoroaEsquerda
      situacaoCoroaDireita
      situacaoCoroaCentro
    }
    proteseTotalInferior
    proteseTotalSuperior
    contencao
    aparelho
  }
}
    `;

/**
 * __useOdontogramaQuery__
 *
 * To run a query within a React component, call `useOdontogramaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOdontogramaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.OdontogramaQuery, Types.OdontogramaQueryVariables> & ({ variables: Types.OdontogramaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>(OdontogramaDocument, options);
      }
export function useOdontogramaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>(OdontogramaDocument, options);
        }
export function useOdontogramaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>(OdontogramaDocument, options);
        }
export type OdontogramaQueryHookResult = ReturnType<typeof useOdontogramaQuery>;
export type OdontogramaLazyQueryHookResult = ReturnType<typeof useOdontogramaLazyQuery>;
export type OdontogramaSuspenseQueryHookResult = ReturnType<typeof useOdontogramaSuspenseQuery>;
export type OdontogramaQueryResult = Apollo.QueryResult<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>;
export const OdontogramasDocument = gql`
    query Odontogramas($input: OdontogramasQueryInput!) {
  odontogramas(input: $input) {
    content {
      id
      evolucoesDente {
        id
        dente {
          id
          numero
        }
        situacoesRaiz
        situacoesFace
        situacaoCoroaCima
        situacaoCoroaDireita
        situacaoCoroaEsquerda
        situacaoCoroaBaixo
        situacaoCoroaCentro
      }
      proteseTotalSuperior
      proteseTotalInferior
      contencao
      aparelho
    }
  }
}
    `;

/**
 * __useOdontogramasQuery__
 *
 * To run a query within a React component, call `useOdontogramasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOdontogramasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.OdontogramasQuery, Types.OdontogramasQueryVariables> & ({ variables: Types.OdontogramasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>(OdontogramasDocument, options);
      }
export function useOdontogramasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>(OdontogramasDocument, options);
        }
export function useOdontogramasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>(OdontogramasDocument, options);
        }
export type OdontogramasQueryHookResult = ReturnType<typeof useOdontogramasQuery>;
export type OdontogramasLazyQueryHookResult = ReturnType<typeof useOdontogramasLazyQuery>;
export type OdontogramasSuspenseQueryHookResult = ReturnType<typeof useOdontogramasSuspenseQuery>;
export type OdontogramasQueryResult = Apollo.QueryResult<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>;
export const PeriodoOdontogramaSelectDocument = gql`
    query PeriodoOdontogramaSelect($input: OdontogramasQueryInput!) {
  odontogramas(input: $input) {
    content {
      id
      atendimentoProfissionalOdonto {
        id
        atendimentoProfissional {
          id
          finalizadoEm
          iniciadoEm
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePeriodoOdontogramaSelectQuery__
 *
 * To run a query within a React component, call `usePeriodoOdontogramaSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodoOdontogramaSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodoOdontogramaSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePeriodoOdontogramaSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables> & ({ variables: Types.PeriodoOdontogramaSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>(PeriodoOdontogramaSelectDocument, options);
      }
export function usePeriodoOdontogramaSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>(PeriodoOdontogramaSelectDocument, options);
        }
export function usePeriodoOdontogramaSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>(PeriodoOdontogramaSelectDocument, options);
        }
export type PeriodoOdontogramaSelectQueryHookResult = ReturnType<typeof usePeriodoOdontogramaSelectQuery>;
export type PeriodoOdontogramaSelectLazyQueryHookResult = ReturnType<typeof usePeriodoOdontogramaSelectLazyQuery>;
export type PeriodoOdontogramaSelectSuspenseQueryHookResult = ReturnType<typeof usePeriodoOdontogramaSelectSuspenseQuery>;
export type PeriodoOdontogramaSelectQueryResult = Apollo.QueryResult<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>;
export const HistoricoEvolucoesOdontoTableDocument = gql`
    query HistoricoEvolucoesOdontoTable($input: EvolucoesProcedimentoOdontoInput!) {
  evolucoesProcedimentoOdonto(input: $input) {
    content {
      id
      atendimentoProfissionalOdonto {
        id
        atendimentoProfissional {
          id
          iniciadoEm
          lotacao {
            id
            profissional {
              id
              nome
            }
            cbo {
              id
              nome
            }
          }
        }
      }
      procedimentos {
        ... on Procedimento {
          id
          codigo
          descricao
        }
      }
      partesBucais {
        id
        tipoParteBucal
        descricao
        parteBucalEnum
      }
      observacao
      descricaoParteBucal
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useHistoricoEvolucoesOdontoTableQuery__
 *
 * To run a query within a React component, call `useHistoricoEvolucoesOdontoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoEvolucoesOdontoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoEvolucoesOdontoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoEvolucoesOdontoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables> & ({ variables: Types.HistoricoEvolucoesOdontoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>(HistoricoEvolucoesOdontoTableDocument, options);
      }
export function useHistoricoEvolucoesOdontoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>(HistoricoEvolucoesOdontoTableDocument, options);
        }
export function useHistoricoEvolucoesOdontoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>(HistoricoEvolucoesOdontoTableDocument, options);
        }
export type HistoricoEvolucoesOdontoTableQueryHookResult = ReturnType<typeof useHistoricoEvolucoesOdontoTableQuery>;
export type HistoricoEvolucoesOdontoTableLazyQueryHookResult = ReturnType<typeof useHistoricoEvolucoesOdontoTableLazyQuery>;
export type HistoricoEvolucoesOdontoTableSuspenseQueryHookResult = ReturnType<typeof useHistoricoEvolucoesOdontoTableSuspenseQuery>;
export type HistoricoEvolucoesOdontoTableQueryResult = Apollo.QueryResult<Types.HistoricoEvolucoesOdontoTableQuery, Types.HistoricoEvolucoesOdontoTableQueryVariables>;
export const PeriogramasCompletoDocument = gql`
    query PeriogramasCompleto($input: PeriogramaCompletoQueryInput!) {
  periogramasCompleto(input: $input) {
    id
    dente {
      id
      parteBucalEnum
    }
    excluido
    profundidadeVestibular
    recessaoVestibular
    profundidadeInterna
    recessaoInterna
    placaDVestibular
    placaVVestibular
    placaMVestibular
    sangramentoDVestibular
    sangramentoVVestibular
    sangramentoMVestibular
    placaDInterna
    placaVInterna
    placaMInterna
    sangramentoDInterna
    sangramentoVInterna
    sangramentoMInterna
    mobilidade
    lesaoDeFurca
    atendimentoProfissionalOdonto {
      id
      observacaoRPC
      atendimentoProfissional {
        id
        iniciadoEm
        lotacao {
          id
          cbo {
            id
            nome
          }
          profissional {
            id
            nome
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePeriogramasCompletoQuery__
 *
 * To run a query within a React component, call `usePeriogramasCompletoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriogramasCompletoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriogramasCompletoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePeriogramasCompletoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables> & ({ variables: Types.PeriogramasCompletoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>(PeriogramasCompletoDocument, options);
      }
export function usePeriogramasCompletoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>(PeriogramasCompletoDocument, options);
        }
export function usePeriogramasCompletoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>(PeriogramasCompletoDocument, options);
        }
export type PeriogramasCompletoQueryHookResult = ReturnType<typeof usePeriogramasCompletoQuery>;
export type PeriogramasCompletoLazyQueryHookResult = ReturnType<typeof usePeriogramasCompletoLazyQuery>;
export type PeriogramasCompletoSuspenseQueryHookResult = ReturnType<typeof usePeriogramasCompletoSuspenseQuery>;
export type PeriogramasCompletoQueryResult = Apollo.QueryResult<Types.PeriogramasCompletoQuery, Types.PeriogramasCompletoQueryVariables>;
export const HistoricoPeriogramaSimplificadoDocument = gql`
    query HistoricoPeriogramaSimplificado($input: PeriogramaSimplificadoQueryInput!) {
  periogramasSimplificados(input: $input) {
    content {
      id
      avaliacaoSextante1
      avaliacaoSextante2
      avaliacaoSextante3
      avaliacaoSextante4
      avaliacaoSextante5
      avaliacaoSextante5
      avaliacaoSextante6
      observacao
      atendimentoProfissionalOdonto {
        id
        atendimentoProfissional {
          id
          iniciadoEm
          lotacao {
            id
            cbo {
              id
              nome
            }
            profissional {
              id
              nome
            }
          }
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useHistoricoPeriogramaSimplificadoQuery__
 *
 * To run a query within a React component, call `useHistoricoPeriogramaSimplificadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPeriogramaSimplificadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPeriogramaSimplificadoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPeriogramaSimplificadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables> & ({ variables: Types.HistoricoPeriogramaSimplificadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>(HistoricoPeriogramaSimplificadoDocument, options);
      }
export function useHistoricoPeriogramaSimplificadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>(HistoricoPeriogramaSimplificadoDocument, options);
        }
export function useHistoricoPeriogramaSimplificadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>(HistoricoPeriogramaSimplificadoDocument, options);
        }
export type HistoricoPeriogramaSimplificadoQueryHookResult = ReturnType<typeof useHistoricoPeriogramaSimplificadoQuery>;
export type HistoricoPeriogramaSimplificadoLazyQueryHookResult = ReturnType<typeof useHistoricoPeriogramaSimplificadoLazyQuery>;
export type HistoricoPeriogramaSimplificadoSuspenseQueryHookResult = ReturnType<typeof useHistoricoPeriogramaSimplificadoSuspenseQuery>;
export type HistoricoPeriogramaSimplificadoQueryResult = Apollo.QueryResult<Types.HistoricoPeriogramaSimplificadoQuery, Types.HistoricoPeriogramaSimplificadoQueryVariables>;
export const HistoricoTecidosMolesDocument = gql`
    query HistoricoTecidosMoles($input: TecidosMolesQueryInput!) {
  tecidosMoles(input: $input) {
    content {
      id
      parteBucal {
        id
        descricao
      }
      cid10 {
        ...Cid10
      }
      caracteristicasLesao {
        id
        caracteristicaLesao
      }
      evolucaoProcedimentoOdonto {
        id
        procedimentos {
          ... on Procedimento {
            id
            codigo
            descricao
          }
        }
        observacao
      }
      descricaoSintomatologia
      atendimentoProfissionalOdonto {
        id
        atendimentoProfissional {
          id
          iniciadoEm
          lotacao {
            id
            profissional {
              id
              nome
            }
            cbo {
              id
              nome
            }
          }
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid10FragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useHistoricoTecidosMolesQuery__
 *
 * To run a query within a React component, call `useHistoricoTecidosMolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoTecidosMolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoTecidosMolesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoTecidosMolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables> & ({ variables: Types.HistoricoTecidosMolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>(HistoricoTecidosMolesDocument, options);
      }
export function useHistoricoTecidosMolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>(HistoricoTecidosMolesDocument, options);
        }
export function useHistoricoTecidosMolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>(HistoricoTecidosMolesDocument, options);
        }
export type HistoricoTecidosMolesQueryHookResult = ReturnType<typeof useHistoricoTecidosMolesQuery>;
export type HistoricoTecidosMolesLazyQueryHookResult = ReturnType<typeof useHistoricoTecidosMolesLazyQuery>;
export type HistoricoTecidosMolesSuspenseQueryHookResult = ReturnType<typeof useHistoricoTecidosMolesSuspenseQuery>;
export type HistoricoTecidosMolesQueryResult = Apollo.QueryResult<Types.HistoricoTecidosMolesQuery, Types.HistoricoTecidosMolesQueryVariables>;
export const GruposExamesDocument = gql`
    query GruposExames($input: GrupoExameQueryInput!) {
  gruposExame(input: $input) {
    content {
      id
      nome
      idadeMinima
      idadeMaxima
      procedimentos {
        id
        descricao
        codigo
        idadeMinima
        idadeMaxima
        idadeAplicavel
        sexo
        ativo
        procedimentoReferencia {
          id
          descricao
          codigo
        }
      }
    }
  }
}
    `;

/**
 * __useGruposExamesQuery__
 *
 * To run a query within a React component, call `useGruposExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGruposExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGruposExamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGruposExamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GruposExamesQuery, Types.GruposExamesQueryVariables> & ({ variables: Types.GruposExamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>(GruposExamesDocument, options);
      }
export function useGruposExamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>(GruposExamesDocument, options);
        }
export function useGruposExamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>(GruposExamesDocument, options);
        }
export type GruposExamesQueryHookResult = ReturnType<typeof useGruposExamesQuery>;
export type GruposExamesLazyQueryHookResult = ReturnType<typeof useGruposExamesLazyQuery>;
export type GruposExamesSuspenseQueryHookResult = ReturnType<typeof useGruposExamesSuspenseQuery>;
export type GruposExamesQueryResult = Apollo.QueryResult<Types.GruposExamesQuery, Types.GruposExamesQueryVariables>;
export const UltimoExameCitopatologicoDocument = gql`
    query UltimoExameCitopatologico($input: ID!) {
  ultimaSolicitacaoCitopatologicoUtero(prontuarioId: $input) {
    id
    requisicaoExameId
    respostas {
      pergunta
      opcao
      descricao
      data
    }
  }
}
    `;

/**
 * __useUltimoExameCitopatologicoQuery__
 *
 * To run a query within a React component, call `useUltimoExameCitopatologicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoExameCitopatologicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoExameCitopatologicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimoExameCitopatologicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables> & ({ variables: Types.UltimoExameCitopatologicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>(UltimoExameCitopatologicoDocument, options);
      }
export function useUltimoExameCitopatologicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>(UltimoExameCitopatologicoDocument, options);
        }
export function useUltimoExameCitopatologicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>(UltimoExameCitopatologicoDocument, options);
        }
export type UltimoExameCitopatologicoQueryHookResult = ReturnType<typeof useUltimoExameCitopatologicoQuery>;
export type UltimoExameCitopatologicoLazyQueryHookResult = ReturnType<typeof useUltimoExameCitopatologicoLazyQuery>;
export type UltimoExameCitopatologicoSuspenseQueryHookResult = ReturnType<typeof useUltimoExameCitopatologicoSuspenseQuery>;
export type UltimoExameCitopatologicoQueryResult = Apollo.QueryResult<Types.UltimoExameCitopatologicoQuery, Types.UltimoExameCitopatologicoQueryVariables>;
export const HistoricoPlanosDeCuidadoDocument = gql`
    query HistoricoPlanosDeCuidado($atendProfId: ID!) {
  planosDeCuidado(atendProfId: $atendProfId) {
    id
    atendimentoProfissionalObservacao {
      id
      atendimentoProfissional {
        id
        lotacao {
          id
          profissional {
            id
            nome
          }
          cbo {
            id
            nome
          }
        }
      }
      atendimentoObservacao {
        id
        atendimentoProfissionalIniciador {
          id
          iniciadoEm
          lotacao {
            id
            profissional {
              id
              nome
            }
          }
        }
      }
    }
    descricao
    dataDescricao
  }
}
    `;

/**
 * __useHistoricoPlanosDeCuidadoQuery__
 *
 * To run a query within a React component, call `useHistoricoPlanosDeCuidadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPlanosDeCuidadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPlanosDeCuidadoQuery({
 *   variables: {
 *      atendProfId: // value for 'atendProfId'
 *   },
 * });
 */
export function useHistoricoPlanosDeCuidadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables> & ({ variables: Types.HistoricoPlanosDeCuidadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>(HistoricoPlanosDeCuidadoDocument, options);
      }
export function useHistoricoPlanosDeCuidadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>(HistoricoPlanosDeCuidadoDocument, options);
        }
export function useHistoricoPlanosDeCuidadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>(HistoricoPlanosDeCuidadoDocument, options);
        }
export type HistoricoPlanosDeCuidadoQueryHookResult = ReturnType<typeof useHistoricoPlanosDeCuidadoQuery>;
export type HistoricoPlanosDeCuidadoLazyQueryHookResult = ReturnType<typeof useHistoricoPlanosDeCuidadoLazyQuery>;
export type HistoricoPlanosDeCuidadoSuspenseQueryHookResult = ReturnType<typeof useHistoricoPlanosDeCuidadoSuspenseQuery>;
export type HistoricoPlanosDeCuidadoQueryResult = Apollo.QueryResult<Types.HistoricoPlanosDeCuidadoQuery, Types.HistoricoPlanosDeCuidadoQueryVariables>;
export const OrientacoesDocument = gql`
    query Orientacoes($orientacaoQueryInput: OrientacaoQueryInput!) {
  orientacoes(input: $orientacaoQueryInput) {
    id
    descricao
    atendimentoProfissional {
      id
      iniciadoEm
      atendimento {
        id
        localAtendimento {
          id
          localAtendimentoExibicao
        }
      }
      tipoAtendimento
      lotacao {
        id
        profissional {
          id
          nome
          numeroConselhoClasse
          conselhoClasse {
            id
            sigla
          }
          ufEmissoraConselhoClasse {
            id
            nome
            sigla
          }
        }
        municipio {
          id
          nome
          uf {
            id
            sigla
            nome
          }
        }
        unidadeSaude {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useOrientacoesQuery__
 *
 * To run a query within a React component, call `useOrientacoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrientacoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrientacoesQuery({
 *   variables: {
 *      orientacaoQueryInput: // value for 'orientacaoQueryInput'
 *   },
 * });
 */
export function useOrientacoesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.OrientacoesQuery, Types.OrientacoesQueryVariables> & ({ variables: Types.OrientacoesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>(OrientacoesDocument, options);
      }
export function useOrientacoesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>(OrientacoesDocument, options);
        }
export function useOrientacoesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>(OrientacoesDocument, options);
        }
export type OrientacoesQueryHookResult = ReturnType<typeof useOrientacoesQuery>;
export type OrientacoesLazyQueryHookResult = ReturnType<typeof useOrientacoesLazyQuery>;
export type OrientacoesSuspenseQueryHookResult = ReturnType<typeof useOrientacoesSuspenseQuery>;
export type OrientacoesQueryResult = Apollo.QueryResult<Types.OrientacoesQuery, Types.OrientacoesQueryVariables>;
export const AuditaImpressaoOrientacaoDocument = gql`
    mutation auditaImpressaoOrientacao($prontuarioId: ID!, $atendimentoId: ID, $orientacaoId: ID) {
  auditaImpressaoOrientacao(
    prontuarioId: $prontuarioId
    atendimentoId: $atendimentoId
    orientacaoId: $orientacaoId
  )
}
    `;
export type AuditaImpressaoOrientacaoMutationFn = Apollo.MutationFunction<Types.AuditaImpressaoOrientacaoMutation, Types.AuditaImpressaoOrientacaoMutationVariables>;

/**
 * __useAuditaImpressaoOrientacaoMutation__
 *
 * To run a mutation, you first call `useAuditaImpressaoOrientacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditaImpressaoOrientacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditaImpressaoOrientacaoMutation, { data, loading, error }] = useAuditaImpressaoOrientacaoMutation({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *      atendimentoId: // value for 'atendimentoId'
 *      orientacaoId: // value for 'orientacaoId'
 *   },
 * });
 */
export function useAuditaImpressaoOrientacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AuditaImpressaoOrientacaoMutation, Types.AuditaImpressaoOrientacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AuditaImpressaoOrientacaoMutation, Types.AuditaImpressaoOrientacaoMutationVariables>(AuditaImpressaoOrientacaoDocument, options);
      }
export type AuditaImpressaoOrientacaoMutationHookResult = ReturnType<typeof useAuditaImpressaoOrientacaoMutation>;
export type AuditaImpressaoOrientacaoMutationResult = Apollo.MutationResult<Types.AuditaImpressaoOrientacaoMutation>;
export type AuditaImpressaoOrientacaoMutationOptions = Apollo.BaseMutationOptions<Types.AuditaImpressaoOrientacaoMutation, Types.AuditaImpressaoOrientacaoMutationVariables>;
export const PrincipiosAtivosAlergiasDocument = gql`
    query PrincipiosAtivosAlergias($prontuarioId: ID!) {
  principiosAtivosAlergias(prontuarioId: $prontuarioId) {
    id
    nome
  }
}
    `;

/**
 * __usePrincipiosAtivosAlergiasQuery__
 *
 * To run a query within a React component, call `usePrincipiosAtivosAlergiasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrincipiosAtivosAlergiasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrincipiosAtivosAlergiasQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function usePrincipiosAtivosAlergiasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables> & ({ variables: Types.PrincipiosAtivosAlergiasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>(PrincipiosAtivosAlergiasDocument, options);
      }
export function usePrincipiosAtivosAlergiasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>(PrincipiosAtivosAlergiasDocument, options);
        }
export function usePrincipiosAtivosAlergiasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>(PrincipiosAtivosAlergiasDocument, options);
        }
export type PrincipiosAtivosAlergiasQueryHookResult = ReturnType<typeof usePrincipiosAtivosAlergiasQuery>;
export type PrincipiosAtivosAlergiasLazyQueryHookResult = ReturnType<typeof usePrincipiosAtivosAlergiasLazyQuery>;
export type PrincipiosAtivosAlergiasSuspenseQueryHookResult = ReturnType<typeof usePrincipiosAtivosAlergiasSuspenseQuery>;
export type PrincipiosAtivosAlergiasQueryResult = Apollo.QueryResult<Types.PrincipiosAtivosAlergiasQuery, Types.PrincipiosAtivosAlergiasQueryVariables>;
export const HistoricoPrescricaoDocument = gql`
    query HistoricoPrescricao($input: HistoricoPrescricaoQueryInput!) {
  historicoPrescricao(input: $input) {
    content {
      id
      versao
      versaoAnterior
      finalizadoEm
      lotacao {
        id
        profissional {
          id
          nome
          numeroConselhoClasse
          ufEmissoraConselhoClasse {
            id
            sigla
          }
          conselhoClasse {
            id
            sigla
          }
        }
      }
      receitaMedicamento {
        id
        medicamento {
          id
          principioAtivo
          concentracao
          unidadeFornecimento
          medicamentoCatmat {
            id
            ativo
            volume
            codigoCatMat
            codigoObm
            codigoRename
            unidadeFornecimento {
              id
              nome
              nomePlural
            }
            principioAtivo {
              id
              nome
              listaMaterial {
                id
                tipo
                tipoReceita
              }
            }
          }
          formaFarmaceutica {
            id
            nome
          }
        }
        aplicacaoMedicamento {
          id
          nome
        }
        quantidadeReceitada
        recomendacoes
        dose
        qtDose
        qtDoseManha
        qtDoseTarde
        qtDoseNoite
        unidadeMedidaDose {
          id
          nome
          nomePlural
        }
        frequenciaDose
        posologia
        tipoFrequenciaDose
        qtPeriodoFrequencia
        medidaTempoFrequencia
        dtInicioTratamento
        dtFimTratamento
        qtDuracaoTratamento
        medidaTempoTratamento
        usoContinuo
        registroManual
        doseUnica
        tipoReceita
        tratamentoInterrompido
        justificativaInterrupcao
        dtInterrupcao
        receitaUsoContinuoGrupo {
          id
          dtInicioTratamento
        }
        cid10 {
          ...Cid10
          ativo
        }
        ciap {
          ...Ciap
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useHistoricoPrescricaoQuery__
 *
 * To run a query within a React component, call `useHistoricoPrescricaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPrescricaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPrescricaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPrescricaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables> & ({ variables: Types.HistoricoPrescricaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>(HistoricoPrescricaoDocument, options);
      }
export function useHistoricoPrescricaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>(HistoricoPrescricaoDocument, options);
        }
export function useHistoricoPrescricaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>(HistoricoPrescricaoDocument, options);
        }
export type HistoricoPrescricaoQueryHookResult = ReturnType<typeof useHistoricoPrescricaoQuery>;
export type HistoricoPrescricaoLazyQueryHookResult = ReturnType<typeof useHistoricoPrescricaoLazyQuery>;
export type HistoricoPrescricaoSuspenseQueryHookResult = ReturnType<typeof useHistoricoPrescricaoSuspenseQuery>;
export type HistoricoPrescricaoQueryResult = Apollo.QueryResult<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>;
export const ConexaoHorusDocument = gql`
    query ConexaoHorus {
  conexao {
    internet {
      habilitado
    }
    horus {
      id
      habilitado
    }
  }
}
    `;

/**
 * __useConexaoHorusQuery__
 *
 * To run a query within a React component, call `useConexaoHorusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConexaoHorusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConexaoHorusQuery({
 *   variables: {
 *   },
 * });
 */
export function useConexaoHorusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>(ConexaoHorusDocument, options);
      }
export function useConexaoHorusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>(ConexaoHorusDocument, options);
        }
export function useConexaoHorusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>(ConexaoHorusDocument, options);
        }
export type ConexaoHorusQueryHookResult = ReturnType<typeof useConexaoHorusQuery>;
export type ConexaoHorusLazyQueryHookResult = ReturnType<typeof useConexaoHorusLazyQuery>;
export type ConexaoHorusSuspenseQueryHookResult = ReturnType<typeof useConexaoHorusSuspenseQuery>;
export type ConexaoHorusQueryResult = Apollo.QueryResult<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>;
export const ConsultaEstoqueHorusDocument = gql`
    query ConsultaEstoqueHorus($filter: ConsultaEstoqueHorusQueryInput!) {
  consultaEstoqueHorus(input: $filter)
}
    `;

/**
 * __useConsultaEstoqueHorusQuery__
 *
 * To run a query within a React component, call `useConsultaEstoqueHorusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultaEstoqueHorusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultaEstoqueHorusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultaEstoqueHorusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables> & ({ variables: Types.ConsultaEstoqueHorusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>(ConsultaEstoqueHorusDocument, options);
      }
export function useConsultaEstoqueHorusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>(ConsultaEstoqueHorusDocument, options);
        }
export function useConsultaEstoqueHorusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>(ConsultaEstoqueHorusDocument, options);
        }
export type ConsultaEstoqueHorusQueryHookResult = ReturnType<typeof useConsultaEstoqueHorusQuery>;
export type ConsultaEstoqueHorusLazyQueryHookResult = ReturnType<typeof useConsultaEstoqueHorusLazyQuery>;
export type ConsultaEstoqueHorusSuspenseQueryHookResult = ReturnType<typeof useConsultaEstoqueHorusSuspenseQuery>;
export type ConsultaEstoqueHorusQueryResult = Apollo.QueryResult<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>;
export const BundlesFhirComAssinaturaPendenteDocument = gql`
    query BundlesFhirComAssinaturaPendente($atendProfId: ID!) {
  bundlesFhirComAssinaturaPendente(atendProfId: $atendProfId) {
    id
    tipoRegistroRndsEnum
    descricao
  }
}
    `;

/**
 * __useBundlesFhirComAssinaturaPendenteQuery__
 *
 * To run a query within a React component, call `useBundlesFhirComAssinaturaPendenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundlesFhirComAssinaturaPendenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundlesFhirComAssinaturaPendenteQuery({
 *   variables: {
 *      atendProfId: // value for 'atendProfId'
 *   },
 * });
 */
export function useBundlesFhirComAssinaturaPendenteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables> & ({ variables: Types.BundlesFhirComAssinaturaPendenteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>(BundlesFhirComAssinaturaPendenteDocument, options);
      }
export function useBundlesFhirComAssinaturaPendenteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>(BundlesFhirComAssinaturaPendenteDocument, options);
        }
export function useBundlesFhirComAssinaturaPendenteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>(BundlesFhirComAssinaturaPendenteDocument, options);
        }
export type BundlesFhirComAssinaturaPendenteQueryHookResult = ReturnType<typeof useBundlesFhirComAssinaturaPendenteQuery>;
export type BundlesFhirComAssinaturaPendenteLazyQueryHookResult = ReturnType<typeof useBundlesFhirComAssinaturaPendenteLazyQuery>;
export type BundlesFhirComAssinaturaPendenteSuspenseQueryHookResult = ReturnType<typeof useBundlesFhirComAssinaturaPendenteSuspenseQuery>;
export type BundlesFhirComAssinaturaPendenteQueryResult = Apollo.QueryResult<Types.BundlesFhirComAssinaturaPendenteQuery, Types.BundlesFhirComAssinaturaPendenteQueryVariables>;
export const MarcarBundlesComoNaoEnviadoDocument = gql`
    mutation MarcarBundlesComoNaoEnviado($atendProfId: ID!) {
  marcarBundlesComoNaoEnviado(atendProfId: $atendProfId)
}
    `;
export type MarcarBundlesComoNaoEnviadoMutationFn = Apollo.MutationFunction<Types.MarcarBundlesComoNaoEnviadoMutation, Types.MarcarBundlesComoNaoEnviadoMutationVariables>;

/**
 * __useMarcarBundlesComoNaoEnviadoMutation__
 *
 * To run a mutation, you first call `useMarcarBundlesComoNaoEnviadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarcarBundlesComoNaoEnviadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marcarBundlesComoNaoEnviadoMutation, { data, loading, error }] = useMarcarBundlesComoNaoEnviadoMutation({
 *   variables: {
 *      atendProfId: // value for 'atendProfId'
 *   },
 * });
 */
export function useMarcarBundlesComoNaoEnviadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.MarcarBundlesComoNaoEnviadoMutation, Types.MarcarBundlesComoNaoEnviadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.MarcarBundlesComoNaoEnviadoMutation, Types.MarcarBundlesComoNaoEnviadoMutationVariables>(MarcarBundlesComoNaoEnviadoDocument, options);
      }
export type MarcarBundlesComoNaoEnviadoMutationHookResult = ReturnType<typeof useMarcarBundlesComoNaoEnviadoMutation>;
export type MarcarBundlesComoNaoEnviadoMutationResult = Apollo.MutationResult<Types.MarcarBundlesComoNaoEnviadoMutation>;
export type MarcarBundlesComoNaoEnviadoMutationOptions = Apollo.BaseMutationOptions<Types.MarcarBundlesComoNaoEnviadoMutation, Types.MarcarBundlesComoNaoEnviadoMutationVariables>;
export const CategoriasMedicamentosDocument = gql`
    query CategoriasMedicamentos {
  categoriasMedicamentos {
    id
    nome
    disponivelParaPrescricaoDigital
    categoriasCompativeis
  }
}
    `;

/**
 * __useCategoriasMedicamentosQuery__
 *
 * To run a query within a React component, call `useCategoriasMedicamentosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriasMedicamentosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriasMedicamentosQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriasMedicamentosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>(CategoriasMedicamentosDocument, options);
      }
export function useCategoriasMedicamentosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>(CategoriasMedicamentosDocument, options);
        }
export function useCategoriasMedicamentosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>(CategoriasMedicamentosDocument, options);
        }
export type CategoriasMedicamentosQueryHookResult = ReturnType<typeof useCategoriasMedicamentosQuery>;
export type CategoriasMedicamentosLazyQueryHookResult = ReturnType<typeof useCategoriasMedicamentosLazyQuery>;
export type CategoriasMedicamentosSuspenseQueryHookResult = ReturnType<typeof useCategoriasMedicamentosSuspenseQuery>;
export type CategoriasMedicamentosQueryResult = Apollo.QueryResult<Types.CategoriasMedicamentosQuery, Types.CategoriasMedicamentosQueryVariables>;
export const CidadaoEmailUpdateDocument = gql`
    mutation CidadaoEmailUpdate($input: AtualizarEmailCidadaoInput!) {
  atualizarEmailCidadao(input: $input) {
    id
    email
  }
}
    `;
export type CidadaoEmailUpdateMutationFn = Apollo.MutationFunction<Types.CidadaoEmailUpdateMutation, Types.CidadaoEmailUpdateMutationVariables>;

/**
 * __useCidadaoEmailUpdateMutation__
 *
 * To run a mutation, you first call `useCidadaoEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCidadaoEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cidadaoEmailUpdateMutation, { data, loading, error }] = useCidadaoEmailUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoEmailUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CidadaoEmailUpdateMutation, Types.CidadaoEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CidadaoEmailUpdateMutation, Types.CidadaoEmailUpdateMutationVariables>(CidadaoEmailUpdateDocument, options);
      }
export type CidadaoEmailUpdateMutationHookResult = ReturnType<typeof useCidadaoEmailUpdateMutation>;
export type CidadaoEmailUpdateMutationResult = Apollo.MutationResult<Types.CidadaoEmailUpdateMutation>;
export type CidadaoEmailUpdateMutationOptions = Apollo.BaseMutationOptions<Types.CidadaoEmailUpdateMutation, Types.CidadaoEmailUpdateMutationVariables>;
export const CidadaoInformacoesContatoDocument = gql`
    query CidadaoInformacoesContato($id: ID!) {
  contatoCidadao(id: $id) {
    id
    email
  }
}
    `;

/**
 * __useCidadaoInformacoesContatoQuery__
 *
 * To run a query within a React component, call `useCidadaoInformacoesContatoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoInformacoesContatoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoInformacoesContatoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoInformacoesContatoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables> & ({ variables: Types.CidadaoInformacoesContatoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>(CidadaoInformacoesContatoDocument, options);
      }
export function useCidadaoInformacoesContatoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>(CidadaoInformacoesContatoDocument, options);
        }
export function useCidadaoInformacoesContatoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>(CidadaoInformacoesContatoDocument, options);
        }
export type CidadaoInformacoesContatoQueryHookResult = ReturnType<typeof useCidadaoInformacoesContatoQuery>;
export type CidadaoInformacoesContatoLazyQueryHookResult = ReturnType<typeof useCidadaoInformacoesContatoLazyQuery>;
export type CidadaoInformacoesContatoSuspenseQueryHookResult = ReturnType<typeof useCidadaoInformacoesContatoSuspenseQuery>;
export type CidadaoInformacoesContatoQueryResult = Apollo.QueryResult<Types.CidadaoInformacoesContatoQuery, Types.CidadaoInformacoesContatoQueryVariables>;
export const TiposReceitaProibidosDocument = gql`
    query TiposReceitaProibidos {
  tiposReceitaProibidos
}
    `;

/**
 * __useTiposReceitaProibidosQuery__
 *
 * To run a query within a React component, call `useTiposReceitaProibidosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiposReceitaProibidosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiposReceitaProibidosQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiposReceitaProibidosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>(TiposReceitaProibidosDocument, options);
      }
export function useTiposReceitaProibidosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>(TiposReceitaProibidosDocument, options);
        }
export function useTiposReceitaProibidosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>(TiposReceitaProibidosDocument, options);
        }
export type TiposReceitaProibidosQueryHookResult = ReturnType<typeof useTiposReceitaProibidosQuery>;
export type TiposReceitaProibidosLazyQueryHookResult = ReturnType<typeof useTiposReceitaProibidosLazyQuery>;
export type TiposReceitaProibidosSuspenseQueryHookResult = ReturnType<typeof useTiposReceitaProibidosSuspenseQuery>;
export type TiposReceitaProibidosQueryResult = Apollo.QueryResult<Types.TiposReceitaProibidosQuery, Types.TiposReceitaProibidosQueryVariables>;
export const EscutaInicialSaveDocument = gql`
    mutation EscutaInicialSave($input: EscutaInicialInput!) {
  salvarEscutaInicial(input: $input) {
    id
  }
}
    `;
export type EscutaInicialSaveMutationFn = Apollo.MutationFunction<Types.EscutaInicialSaveMutation, Types.EscutaInicialSaveMutationVariables>;

/**
 * __useEscutaInicialSaveMutation__
 *
 * To run a mutation, you first call `useEscutaInicialSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEscutaInicialSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [escutaInicialSaveMutation, { data, loading, error }] = useEscutaInicialSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscutaInicialSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EscutaInicialSaveMutation, Types.EscutaInicialSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EscutaInicialSaveMutation, Types.EscutaInicialSaveMutationVariables>(EscutaInicialSaveDocument, options);
      }
export type EscutaInicialSaveMutationHookResult = ReturnType<typeof useEscutaInicialSaveMutation>;
export type EscutaInicialSaveMutationResult = Apollo.MutationResult<Types.EscutaInicialSaveMutation>;
export type EscutaInicialSaveMutationOptions = Apollo.BaseMutationOptions<Types.EscutaInicialSaveMutation, Types.EscutaInicialSaveMutationVariables>;
export const EscutaInicialViewDocument = gql`
    query EscutaInicialView($atendimentoId: ID!) {
  atendimento(id: $atendimentoId) {
    id
    statusAtendimento
    cidadao {
      id
      cns
      cpf
      nome
      nomeSocial
      dataNascimento
      sexo
      identidadeGeneroDbEnum
    }
    prontuario {
      id
      gestacoes {
        id
        inicio
        fim
      }
      preNatalAtivo {
        id
        ultimaDum
      }
    }
    iniciadoEm
    tiposServico {
      id
    }
    isAgendado
    atendimentoProfissional {
      id
      tipo
      iniciadoEm
      rascunho
      estagio {
        id
      }
      lotacao {
        id
        profissional {
          id
          cpf
          cns
          nome
        }
        cbo {
          id
          nome
          cbo2002
        }
        unidadeSaude {
          id
          nome
          cnes
        }
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
      }
    }
  }
  procedimentosAutomaticos {
    ...Procedimento
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useEscutaInicialViewQuery__
 *
 * To run a query within a React component, call `useEscutaInicialViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEscutaInicialViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEscutaInicialViewQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useEscutaInicialViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables> & ({ variables: Types.EscutaInicialViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>(EscutaInicialViewDocument, options);
      }
export function useEscutaInicialViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>(EscutaInicialViewDocument, options);
        }
export function useEscutaInicialViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>(EscutaInicialViewDocument, options);
        }
export type EscutaInicialViewQueryHookResult = ReturnType<typeof useEscutaInicialViewQuery>;
export type EscutaInicialViewLazyQueryHookResult = ReturnType<typeof useEscutaInicialViewLazyQuery>;
export type EscutaInicialViewSuspenseQueryHookResult = ReturnType<typeof useEscutaInicialViewSuspenseQuery>;
export type EscutaInicialViewQueryResult = Apollo.QueryResult<Types.EscutaInicialViewQuery, Types.EscutaInicialViewQueryVariables>;
export const SalvarEscutaInicialParaAprovacaoDocument = gql`
    mutation SalvarEscutaInicialParaAprovacao($input: EscutaInicialAprovacaoInput!) {
  salvarEscutaInicialParaAprovacao(input: $input)
}
    `;
export type SalvarEscutaInicialParaAprovacaoMutationFn = Apollo.MutationFunction<Types.SalvarEscutaInicialParaAprovacaoMutation, Types.SalvarEscutaInicialParaAprovacaoMutationVariables>;

/**
 * __useSalvarEscutaInicialParaAprovacaoMutation__
 *
 * To run a mutation, you first call `useSalvarEscutaInicialParaAprovacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarEscutaInicialParaAprovacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarEscutaInicialParaAprovacaoMutation, { data, loading, error }] = useSalvarEscutaInicialParaAprovacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarEscutaInicialParaAprovacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarEscutaInicialParaAprovacaoMutation, Types.SalvarEscutaInicialParaAprovacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarEscutaInicialParaAprovacaoMutation, Types.SalvarEscutaInicialParaAprovacaoMutationVariables>(SalvarEscutaInicialParaAprovacaoDocument, options);
      }
export type SalvarEscutaInicialParaAprovacaoMutationHookResult = ReturnType<typeof useSalvarEscutaInicialParaAprovacaoMutation>;
export type SalvarEscutaInicialParaAprovacaoMutationResult = Apollo.MutationResult<Types.SalvarEscutaInicialParaAprovacaoMutation>;
export type SalvarEscutaInicialParaAprovacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarEscutaInicialParaAprovacaoMutation, Types.SalvarEscutaInicialParaAprovacaoMutationVariables>;
export const EscutaInicialDetailDocument = gql`
    query EscutaInicialDetail($input: HistoricoDetailQueryInput!) {
  escutaInicialDetail(input: $input) {
    id
    ...HistoricoSubjetivoPecFragment
    evolucaoSubjetivo {
      id
      acompanhadoEspecialidade
    }
    classificacaoRisco
    medicoes {
      ...MedicoesFragment
      valorImc
    }
    procedimentosAtendimento {
      id
      procedimento {
        id
        descricao
        codigo
        tipoProcedimento
      }
      obrigatorio
      automatico
    }
    ...HistoricoDesfechoPecFragment
    ...HistoricoInfoAdministrativasPecFragment
  }
}
    ${HistoricoSubjetivoPecFragmentFragmentDoc}
${MedicoesFragmentFragmentDoc}
${HistoricoDesfechoPecFragmentFragmentDoc}
${HistoricoInfoAdministrativasPecFragmentFragmentDoc}`;

/**
 * __useEscutaInicialDetailQuery__
 *
 * To run a query within a React component, call `useEscutaInicialDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEscutaInicialDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEscutaInicialDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscutaInicialDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables> & ({ variables: Types.EscutaInicialDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>(EscutaInicialDetailDocument, options);
      }
export function useEscutaInicialDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>(EscutaInicialDetailDocument, options);
        }
export function useEscutaInicialDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>(EscutaInicialDetailDocument, options);
        }
export type EscutaInicialDetailQueryHookResult = ReturnType<typeof useEscutaInicialDetailQuery>;
export type EscutaInicialDetailLazyQueryHookResult = ReturnType<typeof useEscutaInicialDetailLazyQuery>;
export type EscutaInicialDetailSuspenseQueryHookResult = ReturnType<typeof useEscutaInicialDetailSuspenseQuery>;
export type EscutaInicialDetailQueryResult = Apollo.QueryResult<Types.EscutaInicialDetailQuery, Types.EscutaInicialDetailQueryVariables>;
export const EscutaInicialVisualizarDocument = gql`
    query EscutaInicialVisualizar($atendimentoId: ID!) {
  atendimento(id: $atendimentoId) {
    id
    cidadao {
      id
    }
    isAgendado
    escutaInicialAtendProf {
      id
      iniciadoEm
    }
  }
}
    `;

/**
 * __useEscutaInicialVisualizarQuery__
 *
 * To run a query within a React component, call `useEscutaInicialVisualizarQuery` and pass it any options that fit your needs.
 * When your component renders, `useEscutaInicialVisualizarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEscutaInicialVisualizarQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useEscutaInicialVisualizarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables> & ({ variables: Types.EscutaInicialVisualizarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>(EscutaInicialVisualizarDocument, options);
      }
export function useEscutaInicialVisualizarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>(EscutaInicialVisualizarDocument, options);
        }
export function useEscutaInicialVisualizarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>(EscutaInicialVisualizarDocument, options);
        }
export type EscutaInicialVisualizarQueryHookResult = ReturnType<typeof useEscutaInicialVisualizarQuery>;
export type EscutaInicialVisualizarLazyQueryHookResult = ReturnType<typeof useEscutaInicialVisualizarLazyQuery>;
export type EscutaInicialVisualizarSuspenseQueryHookResult = ReturnType<typeof useEscutaInicialVisualizarSuspenseQuery>;
export type EscutaInicialVisualizarQueryResult = Apollo.QueryResult<Types.EscutaInicialVisualizarQuery, Types.EscutaInicialVisualizarQueryVariables>;
export const EquipeAtendimentoDocument = gql`
    query EquipeAtendimento($id: ID!) {
  equipe(id: $id) {
    id
    nome
    ine
    tipoEquipe {
      id
      nome
      sigla
    }
  }
}
    `;

/**
 * __useEquipeAtendimentoQuery__
 *
 * To run a query within a React component, call `useEquipeAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeAtendimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipeAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables> & ({ variables: Types.EquipeAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>(EquipeAtendimentoDocument, options);
      }
export function useEquipeAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>(EquipeAtendimentoDocument, options);
        }
export function useEquipeAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>(EquipeAtendimentoDocument, options);
        }
export type EquipeAtendimentoQueryHookResult = ReturnType<typeof useEquipeAtendimentoQuery>;
export type EquipeAtendimentoLazyQueryHookResult = ReturnType<typeof useEquipeAtendimentoLazyQuery>;
export type EquipeAtendimentoSuspenseQueryHookResult = ReturnType<typeof useEquipeAtendimentoSuspenseQuery>;
export type EquipeAtendimentoQueryResult = Apollo.QueryResult<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>;
export const ExcluirAtendimentoDocument = gql`
    mutation ExcluirAtendimento($atendimento: ID!) {
  excluirAtendimento(atendimento: $atendimento)
}
    `;
export type ExcluirAtendimentoMutationFn = Apollo.MutationFunction<Types.ExcluirAtendimentoMutation, Types.ExcluirAtendimentoMutationVariables>;

/**
 * __useExcluirAtendimentoMutation__
 *
 * To run a mutation, you first call `useExcluirAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirAtendimentoMutation, { data, loading, error }] = useExcluirAtendimentoMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useExcluirAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirAtendimentoMutation, Types.ExcluirAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirAtendimentoMutation, Types.ExcluirAtendimentoMutationVariables>(ExcluirAtendimentoDocument, options);
      }
export type ExcluirAtendimentoMutationHookResult = ReturnType<typeof useExcluirAtendimentoMutation>;
export type ExcluirAtendimentoMutationResult = Apollo.MutationResult<Types.ExcluirAtendimentoMutation>;
export type ExcluirAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirAtendimentoMutation, Types.ExcluirAtendimentoMutationVariables>;
export const ListaAtendimentoDocument = gql`
    query ListaAtendimento($input: AtendimentosQueryInput!) {
  atendimentos(input: $input) {
    content {
      id
      prontuarioId
      cidadao {
        id
        nome
        nomeSocial
        dataNascimento
      }
      iniciadoEm
      encaminhadoEm
      statusAtendimento
      statusRevisaoAtendimento
      agendado {
        id
        horarioInicial
        situacao
        lotacaoAgendada {
          id
          profissional {
            id
            nome
          }
        }
        lotacaoParticipante {
          id
          profissional {
            id
            nome
            nomeSocial
          }
        }
        videochamada {
          id
        }
      }
      classificacaoRisco
      tiposServico {
        id
        nome
      }
      equipe {
        id
        nome
        area
      }
      responsavel {
        ... on Acesso {
          id
          profissional {
            id
            nome
            nomeSocial
          }
        }
        ... on Lotacao {
          cbo {
            id
            nome
            cbo2002
          }
        }
        ... on Estagio {
          cbo {
            id
            nome
            cbo2002
          }
        }
      }
      ultimaAlteracaoStatusEm
      hasTagNaoFinalizado
      actions {
        atender {
          hint
          enabled
        }
        revisarRetificar {
          hint
          enabled
        }
        escutaInicial {
          hint
          enabled
        }
        vacinacao {
          hint
          enabled
        }
        informarAusencia {
          hint
          enabled
        }
        cancelarAusencia {
          hint
          enabled
        }
        visualizarProntuario {
          hint
          enabled
        }
        visualizarEscutaInicial {
          hint
          enabled
        }
        editar {
          hint
          enabled
        }
        excluir {
          hint
          enabled
        }
        atendimentosDia {
          hint
          enabled
        }
        declaracaoComparecimento {
          hint
          enabled
        }
        cancelarRegistro {
          hint
          enabled
        }
        tornarResponsavelObservacao {
          hint
          enabled
        }
        gerarAutorizacaoRetiradaAbsorventes {
          hint
          enabled
        }
        chamarCidadaoPainel {
          hint
          enabled
        }
      }
      ultimoResponsavelObservacao {
        ...ResponsavelAtendimentoObservacao
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ResponsavelAtendimentoObservacaoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useListaAtendimentoQuery__
 *
 * To run a query within a React component, call `useListaAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaAtendimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables> & ({ variables: Types.ListaAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>(ListaAtendimentoDocument, options);
      }
export function useListaAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>(ListaAtendimentoDocument, options);
        }
export function useListaAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>(ListaAtendimentoDocument, options);
        }
export type ListaAtendimentoQueryHookResult = ReturnType<typeof useListaAtendimentoQuery>;
export type ListaAtendimentoLazyQueryHookResult = ReturnType<typeof useListaAtendimentoLazyQuery>;
export type ListaAtendimentoSuspenseQueryHookResult = ReturnType<typeof useListaAtendimentoSuspenseQuery>;
export type ListaAtendimentoQueryResult = Apollo.QueryResult<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>;
export const PossuiAtendimentosNaoFinalizadosDocument = gql`
    query PossuiAtendimentosNaoFinalizados($input: PossuiAtendimentosNaoFinalizadosInput!) {
  possuiAtendimentosNaoFinalizados(input: $input)
}
    `;

/**
 * __usePossuiAtendimentosNaoFinalizadosQuery__
 *
 * To run a query within a React component, call `usePossuiAtendimentosNaoFinalizadosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossuiAtendimentosNaoFinalizadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossuiAtendimentosNaoFinalizadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePossuiAtendimentosNaoFinalizadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables> & ({ variables: Types.PossuiAtendimentosNaoFinalizadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>(PossuiAtendimentosNaoFinalizadosDocument, options);
      }
export function usePossuiAtendimentosNaoFinalizadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>(PossuiAtendimentosNaoFinalizadosDocument, options);
        }
export function usePossuiAtendimentosNaoFinalizadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>(PossuiAtendimentosNaoFinalizadosDocument, options);
        }
export type PossuiAtendimentosNaoFinalizadosQueryHookResult = ReturnType<typeof usePossuiAtendimentosNaoFinalizadosQuery>;
export type PossuiAtendimentosNaoFinalizadosLazyQueryHookResult = ReturnType<typeof usePossuiAtendimentosNaoFinalizadosLazyQuery>;
export type PossuiAtendimentosNaoFinalizadosSuspenseQueryHookResult = ReturnType<typeof usePossuiAtendimentosNaoFinalizadosSuspenseQuery>;
export type PossuiAtendimentosNaoFinalizadosQueryResult = Apollo.QueryResult<Types.PossuiAtendimentosNaoFinalizadosQuery, Types.PossuiAtendimentosNaoFinalizadosQueryVariables>;
export const SalvarAtendimentoDocument = gql`
    mutation SalvarAtendimento($input: AtendimentoInput!) {
  salvarAtendimento(input: $input) {
    id
    cidadao {
      id
      nome
      nomeSocial
    }
  }
}
    `;
export type SalvarAtendimentoMutationFn = Apollo.MutationFunction<Types.SalvarAtendimentoMutation, Types.SalvarAtendimentoMutationVariables>;

/**
 * __useSalvarAtendimentoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoMutation, { data, loading, error }] = useSalvarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtendimentoMutation, Types.SalvarAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtendimentoMutation, Types.SalvarAtendimentoMutationVariables>(SalvarAtendimentoDocument, options);
      }
export type SalvarAtendimentoMutationHookResult = ReturnType<typeof useSalvarAtendimentoMutation>;
export type SalvarAtendimentoMutationResult = Apollo.MutationResult<Types.SalvarAtendimentoMutation>;
export type SalvarAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtendimentoMutation, Types.SalvarAtendimentoMutationVariables>;
export const SalvarJustificativaAutomaticaVisualizarEscutaInicialDocument = gql`
    mutation SalvarJustificativaAutomaticaVisualizarEscutaInicial($prontuarioId: ID!) {
  salvarJustificativaAutomaticaVisualizarEscutaInicial(
    prontuarioId: $prontuarioId
  )
}
    `;
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationFn = Apollo.MutationFunction<Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation, Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables>;

/**
 * __useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation__
 *
 * To run a mutation, you first call `useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarJustificativaAutomaticaVisualizarEscutaInicialMutation, { data, loading, error }] = useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation, Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation, Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables>(SalvarJustificativaAutomaticaVisualizarEscutaInicialDocument, options);
      }
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationHookResult = ReturnType<typeof useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation>;
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationResult = Apollo.MutationResult<Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation>;
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationOptions = Apollo.BaseMutationOptions<Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation, Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables>;
export const TornarLotacaoAtualResponsavelAtendimentoObservacaoDocument = gql`
    mutation TornarLotacaoAtualResponsavelAtendimentoObservacao($atendimentoId: ID!) {
  tornarLotacaoAtualResponsavelAtendimentoObservacao(
    atendimentoId: $atendimentoId
  )
}
    `;
export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationFn = Apollo.MutationFunction<Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation, Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationVariables>;

/**
 * __useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation__
 *
 * To run a mutation, you first call `useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tornarLotacaoAtualResponsavelAtendimentoObservacaoMutation, { data, loading, error }] = useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation, Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation, Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationVariables>(TornarLotacaoAtualResponsavelAtendimentoObservacaoDocument, options);
      }
export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationHookResult = ReturnType<typeof useTornarLotacaoAtualResponsavelAtendimentoObservacaoMutation>;
export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationResult = Apollo.MutationResult<Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation>;
export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationOptions = Apollo.BaseMutationOptions<Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation, Types.TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationVariables>;
export const AtenderDocument = gql`
    mutation Atender($atendimento: ID!) {
  realizarAtendimentoIndividual(atendimento: $atendimento) {
    id
    statusAtendimento
    cidadao {
      id
    }
    atendimentoProfissional {
      id
    }
  }
}
    `;
export type AtenderMutationFn = Apollo.MutationFunction<Types.AtenderMutation, Types.AtenderMutationVariables>;

/**
 * __useAtenderMutation__
 *
 * To run a mutation, you first call `useAtenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atenderMutation, { data, loading, error }] = useAtenderMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useAtenderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtenderMutation, Types.AtenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtenderMutation, Types.AtenderMutationVariables>(AtenderDocument, options);
      }
export type AtenderMutationHookResult = ReturnType<typeof useAtenderMutation>;
export type AtenderMutationResult = Apollo.MutationResult<Types.AtenderMutation>;
export type AtenderMutationOptions = Apollo.BaseMutationOptions<Types.AtenderMutation, Types.AtenderMutationVariables>;
export const CancelarAusenciaDocument = gql`
    mutation CancelarAusencia($atendimento: ID!) {
  cancelarCidadaoNaoAguardou(atendimento: $atendimento) {
    id
  }
}
    `;
export type CancelarAusenciaMutationFn = Apollo.MutationFunction<Types.CancelarAusenciaMutation, Types.CancelarAusenciaMutationVariables>;

/**
 * __useCancelarAusenciaMutation__
 *
 * To run a mutation, you first call `useCancelarAusenciaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarAusenciaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarAusenciaMutation, { data, loading, error }] = useCancelarAusenciaMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useCancelarAusenciaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelarAusenciaMutation, Types.CancelarAusenciaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelarAusenciaMutation, Types.CancelarAusenciaMutationVariables>(CancelarAusenciaDocument, options);
      }
export type CancelarAusenciaMutationHookResult = ReturnType<typeof useCancelarAusenciaMutation>;
export type CancelarAusenciaMutationResult = Apollo.MutationResult<Types.CancelarAusenciaMutation>;
export type CancelarAusenciaMutationOptions = Apollo.BaseMutationOptions<Types.CancelarAusenciaMutation, Types.CancelarAusenciaMutationVariables>;
export const InformarAusenciaDocument = gql`
    mutation InformarAusencia($atendimento: ID!) {
  informarCidadaoNaoAguardou(atendimento: $atendimento) {
    id
  }
}
    `;
export type InformarAusenciaMutationFn = Apollo.MutationFunction<Types.InformarAusenciaMutation, Types.InformarAusenciaMutationVariables>;

/**
 * __useInformarAusenciaMutation__
 *
 * To run a mutation, you first call `useInformarAusenciaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInformarAusenciaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [informarAusenciaMutation, { data, loading, error }] = useInformarAusenciaMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useInformarAusenciaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InformarAusenciaMutation, Types.InformarAusenciaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InformarAusenciaMutation, Types.InformarAusenciaMutationVariables>(InformarAusenciaDocument, options);
      }
export type InformarAusenciaMutationHookResult = ReturnType<typeof useInformarAusenciaMutation>;
export type InformarAusenciaMutationResult = Apollo.MutationResult<Types.InformarAusenciaMutation>;
export type InformarAusenciaMutationOptions = Apollo.BaseMutationOptions<Types.InformarAusenciaMutation, Types.InformarAusenciaMutationVariables>;
export const RealizarAtendimentoVacinacaoDocument = gql`
    mutation RealizarAtendimentoVacinacao($atendimento: ID!) {
  realizarAtendimentoVacinacao(atendimento: $atendimento) {
    id
    cidadao {
      id
    }
    atendimentoProfissional {
      id
    }
  }
}
    `;
export type RealizarAtendimentoVacinacaoMutationFn = Apollo.MutationFunction<Types.RealizarAtendimentoVacinacaoMutation, Types.RealizarAtendimentoVacinacaoMutationVariables>;

/**
 * __useRealizarAtendimentoVacinacaoMutation__
 *
 * To run a mutation, you first call `useRealizarAtendimentoVacinacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRealizarAtendimentoVacinacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [realizarAtendimentoVacinacaoMutation, { data, loading, error }] = useRealizarAtendimentoVacinacaoMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useRealizarAtendimentoVacinacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RealizarAtendimentoVacinacaoMutation, Types.RealizarAtendimentoVacinacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RealizarAtendimentoVacinacaoMutation, Types.RealizarAtendimentoVacinacaoMutationVariables>(RealizarAtendimentoVacinacaoDocument, options);
      }
export type RealizarAtendimentoVacinacaoMutationHookResult = ReturnType<typeof useRealizarAtendimentoVacinacaoMutation>;
export type RealizarAtendimentoVacinacaoMutationResult = Apollo.MutationResult<Types.RealizarAtendimentoVacinacaoMutation>;
export type RealizarAtendimentoVacinacaoMutationOptions = Apollo.BaseMutationOptions<Types.RealizarAtendimentoVacinacaoMutation, Types.RealizarAtendimentoVacinacaoMutationVariables>;
export const RealizarEscutaInicialDocument = gql`
    mutation RealizarEscutaInicial($atendimento: ID!) {
  realizarEscutaInicial(atendimento: $atendimento) {
    id
    cidadao {
      id
    }
    atendimentoProfissional {
      id
    }
  }
}
    `;
export type RealizarEscutaInicialMutationFn = Apollo.MutationFunction<Types.RealizarEscutaInicialMutation, Types.RealizarEscutaInicialMutationVariables>;

/**
 * __useRealizarEscutaInicialMutation__
 *
 * To run a mutation, you first call `useRealizarEscutaInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRealizarEscutaInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [realizarEscutaInicialMutation, { data, loading, error }] = useRealizarEscutaInicialMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useRealizarEscutaInicialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RealizarEscutaInicialMutation, Types.RealizarEscutaInicialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RealizarEscutaInicialMutation, Types.RealizarEscutaInicialMutationVariables>(RealizarEscutaInicialDocument, options);
      }
export type RealizarEscutaInicialMutationHookResult = ReturnType<typeof useRealizarEscutaInicialMutation>;
export type RealizarEscutaInicialMutationResult = Apollo.MutationResult<Types.RealizarEscutaInicialMutation>;
export type RealizarEscutaInicialMutationOptions = Apollo.BaseMutationOptions<Types.RealizarEscutaInicialMutation, Types.RealizarEscutaInicialMutationVariables>;
export const AtendimentosDoDiaDocument = gql`
    query AtendimentosDoDia($id: ID!) {
  atendimentosDoDia(id: $id) {
    content {
      id
      iniciadoEm
      finalizadoEm
      lotacao {
        id
        profissional {
          id
          nome
        }
        cbo {
          id
          nome
        }
      }
      tipo
      atendimento {
        id
        iniciadoEm
        cidadao {
          id
          nome
          cpf
          cns
          dataNascimento
          nomeSocial
        }
        dataCriacaoRegistro
      }
    }
  }
}
    `;

/**
 * __useAtendimentosDoDiaQuery__
 *
 * To run a query within a React component, call `useAtendimentosDoDiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentosDoDiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentosDoDiaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentosDoDiaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables> & ({ variables: Types.AtendimentosDoDiaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>(AtendimentosDoDiaDocument, options);
      }
export function useAtendimentosDoDiaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>(AtendimentosDoDiaDocument, options);
        }
export function useAtendimentosDoDiaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>(AtendimentosDoDiaDocument, options);
        }
export type AtendimentosDoDiaQueryHookResult = ReturnType<typeof useAtendimentosDoDiaQuery>;
export type AtendimentosDoDiaLazyQueryHookResult = ReturnType<typeof useAtendimentosDoDiaLazyQuery>;
export type AtendimentosDoDiaSuspenseQueryHookResult = ReturnType<typeof useAtendimentosDoDiaSuspenseQuery>;
export type AtendimentosDoDiaQueryResult = Apollo.QueryResult<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>;
export const ChamarPainelDocument = gql`
    mutation ChamarPainel($input: ChamarPainelInput!) {
  chamarPainel(input: $input)
}
    `;
export type ChamarPainelMutationFn = Apollo.MutationFunction<Types.ChamarPainelMutation, Types.ChamarPainelMutationVariables>;

/**
 * __useChamarPainelMutation__
 *
 * To run a mutation, you first call `useChamarPainelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChamarPainelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chamarPainelMutation, { data, loading, error }] = useChamarPainelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChamarPainelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ChamarPainelMutation, Types.ChamarPainelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ChamarPainelMutation, Types.ChamarPainelMutationVariables>(ChamarPainelDocument, options);
      }
export type ChamarPainelMutationHookResult = ReturnType<typeof useChamarPainelMutation>;
export type ChamarPainelMutationResult = Apollo.MutationResult<Types.ChamarPainelMutation>;
export type ChamarPainelMutationOptions = Apollo.BaseMutationOptions<Types.ChamarPainelMutation, Types.ChamarPainelMutationVariables>;
export const CidadaoPainelChamadasDocument = gql`
    query CidadaoPainelChamadas($id: ID!) {
  atendimento(id: $id) {
    id
    cidadao {
      id
      nome
      nomeSocial
    }
  }
}
    `;

/**
 * __useCidadaoPainelChamadasQuery__
 *
 * To run a query within a React component, call `useCidadaoPainelChamadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoPainelChamadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoPainelChamadasQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoPainelChamadasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables> & ({ variables: Types.CidadaoPainelChamadasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>(CidadaoPainelChamadasDocument, options);
      }
export function useCidadaoPainelChamadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>(CidadaoPainelChamadasDocument, options);
        }
export function useCidadaoPainelChamadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>(CidadaoPainelChamadasDocument, options);
        }
export type CidadaoPainelChamadasQueryHookResult = ReturnType<typeof useCidadaoPainelChamadasQuery>;
export type CidadaoPainelChamadasLazyQueryHookResult = ReturnType<typeof useCidadaoPainelChamadasLazyQuery>;
export type CidadaoPainelChamadasSuspenseQueryHookResult = ReturnType<typeof useCidadaoPainelChamadasSuspenseQuery>;
export type CidadaoPainelChamadasQueryResult = Apollo.QueryResult<Types.CidadaoPainelChamadasQuery, Types.CidadaoPainelChamadasQueryVariables>;
export const CidadaoDeclaracaoComparecimentoDocument = gql`
    query CidadaoDeclaracaoComparecimento($id: ID!) {
  atendimento(id: $id) {
    id
    dataCriacaoRegistro
    iniciadoEm
    isRegistroTardio
    responsavel {
      ... on Acesso {
        id
        profissional {
          id
          nome
        }
      }
    }
    cidadao {
      id
      cpf
      cns
      dataNascimento
      nome
      nomeSocial
    }
    unidadeSaude {
      id
      nome
      endereco {
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCidadaoDeclaracaoComparecimentoQuery__
 *
 * To run a query within a React component, call `useCidadaoDeclaracaoComparecimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoDeclaracaoComparecimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoDeclaracaoComparecimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoDeclaracaoComparecimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables> & ({ variables: Types.CidadaoDeclaracaoComparecimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>(CidadaoDeclaracaoComparecimentoDocument, options);
      }
export function useCidadaoDeclaracaoComparecimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>(CidadaoDeclaracaoComparecimentoDocument, options);
        }
export function useCidadaoDeclaracaoComparecimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>(CidadaoDeclaracaoComparecimentoDocument, options);
        }
export type CidadaoDeclaracaoComparecimentoQueryHookResult = ReturnType<typeof useCidadaoDeclaracaoComparecimentoQuery>;
export type CidadaoDeclaracaoComparecimentoLazyQueryHookResult = ReturnType<typeof useCidadaoDeclaracaoComparecimentoLazyQuery>;
export type CidadaoDeclaracaoComparecimentoSuspenseQueryHookResult = ReturnType<typeof useCidadaoDeclaracaoComparecimentoSuspenseQuery>;
export type CidadaoDeclaracaoComparecimentoQueryResult = Apollo.QueryResult<Types.CidadaoDeclaracaoComparecimentoQuery, Types.CidadaoDeclaracaoComparecimentoQueryVariables>;
export const AtendimentoDocument = gql`
    query Atendimento($id: ID!) {
  atendimento(id: $id) {
    id
    agendado {
      id
    }
    cidadao {
      id
      nome
      nomeSocial
      dataNascimento
      sexo
      racaCor {
        id
        nome
        codigoMS
        codigoCadsus
        racaCorDbEnum
      }
    }
    responsavel {
      ... on Acesso {
        id
        profissional {
          id
          nome
          cpf
        }
      }
      ... on Lotacao {
        ...ResponsavelAtendimentoLotacao
      }
      ... on Estagio {
        ...ResponsavelAtendimentoEstagio
      }
    }
    equipe {
      id
      ine
      nome
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    tiposServico {
      id
      nome
    }
  }
}
    ${ResponsavelAtendimentoLotacaoFragmentDoc}
${ResponsavelAtendimentoEstagioFragmentDoc}`;

/**
 * __useAtendimentoQuery__
 *
 * To run a query within a React component, call `useAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoQuery, Types.AtendimentoQueryVariables> & ({ variables: Types.AtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>(AtendimentoDocument, options);
      }
export function useAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>(AtendimentoDocument, options);
        }
export function useAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>(AtendimentoDocument, options);
        }
export type AtendimentoQueryHookResult = ReturnType<typeof useAtendimentoQuery>;
export type AtendimentoLazyQueryHookResult = ReturnType<typeof useAtendimentoLazyQuery>;
export type AtendimentoSuspenseQueryHookResult = ReturnType<typeof useAtendimentoSuspenseQuery>;
export type AtendimentoQueryResult = Apollo.QueryResult<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>;
export const EditarAtendimentoDocument = gql`
    mutation EditarAtendimento($input: AtendimentoEditInput!) {
  editarAtendimento(input: $input) {
    id
    cidadao {
      id
      nome
      nomeSocial
    }
  }
}
    `;
export type EditarAtendimentoMutationFn = Apollo.MutationFunction<Types.EditarAtendimentoMutation, Types.EditarAtendimentoMutationVariables>;

/**
 * __useEditarAtendimentoMutation__
 *
 * To run a mutation, you first call `useEditarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarAtendimentoMutation, { data, loading, error }] = useEditarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarAtendimentoMutation, Types.EditarAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarAtendimentoMutation, Types.EditarAtendimentoMutationVariables>(EditarAtendimentoDocument, options);
      }
export type EditarAtendimentoMutationHookResult = ReturnType<typeof useEditarAtendimentoMutation>;
export type EditarAtendimentoMutationResult = Apollo.MutationResult<Types.EditarAtendimentoMutation>;
export type EditarAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.EditarAtendimentoMutation, Types.EditarAtendimentoMutationVariables>;
export const AtividadeColetivaGrupoDetalhesDocument = gql`
    query AtividadeColetivaGrupoDetalhes($grupoId: ID!) {
  grupoParticipanteAtividadeColetiva(
    grupoParticipanteAtividadeColetivaId: $grupoId
  ) {
    id
    lotacoesEnvolvidas {
      ...LotacaoBasico
    }
    cidadaosParticipantes {
      id
      nome
      nomeSocial
      cpf
      cns
      dataNascimento
      sexo
      dataObito
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaGrupoDetalhesQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaGrupoDetalhesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaGrupoDetalhesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaGrupoDetalhesQuery({
 *   variables: {
 *      grupoId: // value for 'grupoId'
 *   },
 * });
 */
export function useAtividadeColetivaGrupoDetalhesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables> & ({ variables: Types.AtividadeColetivaGrupoDetalhesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>(AtividadeColetivaGrupoDetalhesDocument, options);
      }
export function useAtividadeColetivaGrupoDetalhesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>(AtividadeColetivaGrupoDetalhesDocument, options);
        }
export function useAtividadeColetivaGrupoDetalhesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>(AtividadeColetivaGrupoDetalhesDocument, options);
        }
export type AtividadeColetivaGrupoDetalhesQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoDetalhesQuery>;
export type AtividadeColetivaGrupoDetalhesLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoDetalhesLazyQuery>;
export type AtividadeColetivaGrupoDetalhesSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoDetalhesSuspenseQuery>;
export type AtividadeColetivaGrupoDetalhesQueryResult = Apollo.QueryResult<Types.AtividadeColetivaGrupoDetalhesQuery, Types.AtividadeColetivaGrupoDetalhesQueryVariables>;
export const AtividadeColetivaGrupoSelectDocument = gql`
    query AtividadeColetivaGrupoSelect($input: GrupoParticipanteAtividadeColetivaQueryInput!) {
  gruposParticipantesAtividadeColetiva(input: $input) {
    content {
      id
      nome
      unidadeSaude {
        id
        nome
      }
      lotacoesEnvolvidas {
        id
        profissional {
          id
        }
        equipe {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useAtividadeColetivaGrupoSelectQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaGrupoSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaGrupoSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaGrupoSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtividadeColetivaGrupoSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables> & ({ variables: Types.AtividadeColetivaGrupoSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>(AtividadeColetivaGrupoSelectDocument, options);
      }
export function useAtividadeColetivaGrupoSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>(AtividadeColetivaGrupoSelectDocument, options);
        }
export function useAtividadeColetivaGrupoSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>(AtividadeColetivaGrupoSelectDocument, options);
        }
export type AtividadeColetivaGrupoSelectQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoSelectQuery>;
export type AtividadeColetivaGrupoSelectLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoSelectLazyQuery>;
export type AtividadeColetivaGrupoSelectSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoSelectSuspenseQuery>;
export type AtividadeColetivaGrupoSelectQueryResult = Apollo.QueryResult<Types.AtividadeColetivaGrupoSelectQuery, Types.AtividadeColetivaGrupoSelectQueryVariables>;
export const AtividadeColetivaTableDocument = gql`
    query AtividadeColetivaTable($input: AtividadeColetivaQueryInput!) {
  atividadesColetivas(input: $input) {
    content {
      id
      dataAtividade
      tipoAtividade
      lotacaoResponsavel {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        cbo {
          id
          nome
        }
      }
      numeroParticipantes
      registroEnviado
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAtividadeColetivaTableQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtividadeColetivaTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables> & ({ variables: Types.AtividadeColetivaTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>(AtividadeColetivaTableDocument, options);
      }
export function useAtividadeColetivaTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>(AtividadeColetivaTableDocument, options);
        }
export function useAtividadeColetivaTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>(AtividadeColetivaTableDocument, options);
        }
export type AtividadeColetivaTableQueryHookResult = ReturnType<typeof useAtividadeColetivaTableQuery>;
export type AtividadeColetivaTableLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaTableLazyQuery>;
export type AtividadeColetivaTableSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaTableSuspenseQuery>;
export type AtividadeColetivaTableQueryResult = Apollo.QueryResult<Types.AtividadeColetivaTableQuery, Types.AtividadeColetivaTableQueryVariables>;
export const FatoAtividadeColetivaTableDocument = gql`
    query FatoAtividadeColetivaTable($input: AtividadeColetivaQueryInput!) {
  fatoAtividadesColetivas(input: $input) {
    content {
      id
      dataRegistro
      origem
      dimensaoTipoAtividade {
        id
        nuIdentificador
      }
      dimensaoProfissional {
        id
        nome
      }
      dimensaoCbo {
        id
        nome
      }
      nuParticipantes
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useFatoAtividadeColetivaTableQuery__
 *
 * To run a query within a React component, call `useFatoAtividadeColetivaTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFatoAtividadeColetivaTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFatoAtividadeColetivaTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFatoAtividadeColetivaTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables> & ({ variables: Types.FatoAtividadeColetivaTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>(FatoAtividadeColetivaTableDocument, options);
      }
export function useFatoAtividadeColetivaTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>(FatoAtividadeColetivaTableDocument, options);
        }
export function useFatoAtividadeColetivaTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>(FatoAtividadeColetivaTableDocument, options);
        }
export type FatoAtividadeColetivaTableQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaTableQuery>;
export type FatoAtividadeColetivaTableLazyQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaTableLazyQuery>;
export type FatoAtividadeColetivaTableSuspenseQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaTableSuspenseQuery>;
export type FatoAtividadeColetivaTableQueryResult = Apollo.QueryResult<Types.FatoAtividadeColetivaTableQuery, Types.FatoAtividadeColetivaTableQueryVariables>;
export const ExcluirAtividadeColetivaDocument = gql`
    mutation ExcluirAtividadeColetiva($atividadeColetivaId: Long!) {
  excluirAtividadeColetiva(atividadeColetivaId: $atividadeColetivaId)
}
    `;
export type ExcluirAtividadeColetivaMutationFn = Apollo.MutationFunction<Types.ExcluirAtividadeColetivaMutation, Types.ExcluirAtividadeColetivaMutationVariables>;

/**
 * __useExcluirAtividadeColetivaMutation__
 *
 * To run a mutation, you first call `useExcluirAtividadeColetivaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirAtividadeColetivaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirAtividadeColetivaMutation, { data, loading, error }] = useExcluirAtividadeColetivaMutation({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *   },
 * });
 */
export function useExcluirAtividadeColetivaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirAtividadeColetivaMutation, Types.ExcluirAtividadeColetivaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirAtividadeColetivaMutation, Types.ExcluirAtividadeColetivaMutationVariables>(ExcluirAtividadeColetivaDocument, options);
      }
export type ExcluirAtividadeColetivaMutationHookResult = ReturnType<typeof useExcluirAtividadeColetivaMutation>;
export type ExcluirAtividadeColetivaMutationResult = Apollo.MutationResult<Types.ExcluirAtividadeColetivaMutation>;
export type ExcluirAtividadeColetivaMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirAtividadeColetivaMutation, Types.ExcluirAtividadeColetivaMutationVariables>;
export const VerificaCidadaoCadastradoDocument = gql`
    query VerificaCidadaoCadastrado($cpf: String, $cns: String) {
  cpfJaCadastrado(cpf: $cpf)
  cnsJaCadastrado(cns: $cns)
}
    `;

/**
 * __useVerificaCidadaoCadastradoQuery__
 *
 * To run a query within a React component, call `useVerificaCidadaoCadastradoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificaCidadaoCadastradoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificaCidadaoCadastradoQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      cns: // value for 'cns'
 *   },
 * });
 */
export function useVerificaCidadaoCadastradoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>(VerificaCidadaoCadastradoDocument, options);
      }
export function useVerificaCidadaoCadastradoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>(VerificaCidadaoCadastradoDocument, options);
        }
export function useVerificaCidadaoCadastradoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>(VerificaCidadaoCadastradoDocument, options);
        }
export type VerificaCidadaoCadastradoQueryHookResult = ReturnType<typeof useVerificaCidadaoCadastradoQuery>;
export type VerificaCidadaoCadastradoLazyQueryHookResult = ReturnType<typeof useVerificaCidadaoCadastradoLazyQuery>;
export type VerificaCidadaoCadastradoSuspenseQueryHookResult = ReturnType<typeof useVerificaCidadaoCadastradoSuspenseQuery>;
export type VerificaCidadaoCadastradoQueryResult = Apollo.QueryResult<Types.VerificaCidadaoCadastradoQuery, Types.VerificaCidadaoCadastradoQueryVariables>;
export const SalvarAtividadeColetivaDocument = gql`
    mutation SalvarAtividadeColetiva($input: AtividadeColetivaInput!) {
  salvarAtividadeColetiva(input: $input)
}
    `;
export type SalvarAtividadeColetivaMutationFn = Apollo.MutationFunction<Types.SalvarAtividadeColetivaMutation, Types.SalvarAtividadeColetivaMutationVariables>;

/**
 * __useSalvarAtividadeColetivaMutation__
 *
 * To run a mutation, you first call `useSalvarAtividadeColetivaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtividadeColetivaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtividadeColetivaMutation, { data, loading, error }] = useSalvarAtividadeColetivaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtividadeColetivaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtividadeColetivaMutation, Types.SalvarAtividadeColetivaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtividadeColetivaMutation, Types.SalvarAtividadeColetivaMutationVariables>(SalvarAtividadeColetivaDocument, options);
      }
export type SalvarAtividadeColetivaMutationHookResult = ReturnType<typeof useSalvarAtividadeColetivaMutation>;
export type SalvarAtividadeColetivaMutationResult = Apollo.MutationResult<Types.SalvarAtividadeColetivaMutation>;
export type SalvarAtividadeColetivaMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtividadeColetivaMutation, Types.SalvarAtividadeColetivaMutationVariables>;
export const AtividadeColetivaGrupoTableDocument = gql`
    query AtividadeColetivaGrupoTable($input: GrupoParticipanteAtividadeColetivaQueryInput!) {
  gruposParticipantesAtividadeColetiva(input: $input) {
    content {
      id
      nome
      tipoGrupo
      unidadeSaude {
        id
        nome
      }
      lotacoesEnvolvidas {
        id
        equipe {
          id
          nome
        }
      }
      quantidadeIntegrantes
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAtividadeColetivaGrupoTableQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaGrupoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaGrupoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaGrupoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtividadeColetivaGrupoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables> & ({ variables: Types.AtividadeColetivaGrupoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>(AtividadeColetivaGrupoTableDocument, options);
      }
export function useAtividadeColetivaGrupoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>(AtividadeColetivaGrupoTableDocument, options);
        }
export function useAtividadeColetivaGrupoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>(AtividadeColetivaGrupoTableDocument, options);
        }
export type AtividadeColetivaGrupoTableQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoTableQuery>;
export type AtividadeColetivaGrupoTableLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoTableLazyQuery>;
export type AtividadeColetivaGrupoTableSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaGrupoTableSuspenseQuery>;
export type AtividadeColetivaGrupoTableQueryResult = Apollo.QueryResult<Types.AtividadeColetivaGrupoTableQuery, Types.AtividadeColetivaGrupoTableQueryVariables>;
export const AtividadeColetivaGruposDocument = gql`
    query AtividadeColetivaGrupos($atividadeColetivaGrupoId: ID!) {
  grupoParticipanteAtividadeColetiva(
    grupoParticipanteAtividadeColetivaId: $atividadeColetivaGrupoId
  ) {
    id
    nome
    tipoGrupo
    ativo
    quantidadeIntegrantes
    dataUltimaAtualizacao
    dataAtualizacaoStatusAtivo
    lotacaoAtualizacaoStatusAtivo {
      id
      profissional {
        id
        nome
        nomeSocial
      }
      cbo {
        id
        nome
      }
    }
    unidadeSaude {
      id
      nome
    }
    lotacoesEnvolvidas {
      ...LotacaoBasico
      equipe {
        id
        isAD
      }
    }
    cidadaosParticipantes {
      id
      cpf
      cns
      nome
      nomeSocial
      dataNascimento
      sexo
      faleceu
      unificado
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaGruposQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaGruposQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaGruposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaGruposQuery({
 *   variables: {
 *      atividadeColetivaGrupoId: // value for 'atividadeColetivaGrupoId'
 *   },
 * });
 */
export function useAtividadeColetivaGruposQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables> & ({ variables: Types.AtividadeColetivaGruposQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>(AtividadeColetivaGruposDocument, options);
      }
export function useAtividadeColetivaGruposLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>(AtividadeColetivaGruposDocument, options);
        }
export function useAtividadeColetivaGruposSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>(AtividadeColetivaGruposDocument, options);
        }
export type AtividadeColetivaGruposQueryHookResult = ReturnType<typeof useAtividadeColetivaGruposQuery>;
export type AtividadeColetivaGruposLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaGruposLazyQuery>;
export type AtividadeColetivaGruposSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaGruposSuspenseQuery>;
export type AtividadeColetivaGruposQueryResult = Apollo.QueryResult<Types.AtividadeColetivaGruposQuery, Types.AtividadeColetivaGruposQueryVariables>;
export const ExcluirGrupoParticipanteAtividadeColetivaDocument = gql`
    mutation ExcluirGrupoParticipanteAtividadeColetiva($grupoParticipanteAtividadeColetivaId: ID!) {
  excluirGrupoParticipanteAtividadeColetiva(
    grupoParticipanteAtividadeColetivaId: $grupoParticipanteAtividadeColetivaId
  )
}
    `;
export type ExcluirGrupoParticipanteAtividadeColetivaMutationFn = Apollo.MutationFunction<Types.ExcluirGrupoParticipanteAtividadeColetivaMutation, Types.ExcluirGrupoParticipanteAtividadeColetivaMutationVariables>;

/**
 * __useExcluirGrupoParticipanteAtividadeColetivaMutation__
 *
 * To run a mutation, you first call `useExcluirGrupoParticipanteAtividadeColetivaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirGrupoParticipanteAtividadeColetivaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirGrupoParticipanteAtividadeColetivaMutation, { data, loading, error }] = useExcluirGrupoParticipanteAtividadeColetivaMutation({
 *   variables: {
 *      grupoParticipanteAtividadeColetivaId: // value for 'grupoParticipanteAtividadeColetivaId'
 *   },
 * });
 */
export function useExcluirGrupoParticipanteAtividadeColetivaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirGrupoParticipanteAtividadeColetivaMutation, Types.ExcluirGrupoParticipanteAtividadeColetivaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirGrupoParticipanteAtividadeColetivaMutation, Types.ExcluirGrupoParticipanteAtividadeColetivaMutationVariables>(ExcluirGrupoParticipanteAtividadeColetivaDocument, options);
      }
export type ExcluirGrupoParticipanteAtividadeColetivaMutationHookResult = ReturnType<typeof useExcluirGrupoParticipanteAtividadeColetivaMutation>;
export type ExcluirGrupoParticipanteAtividadeColetivaMutationResult = Apollo.MutationResult<Types.ExcluirGrupoParticipanteAtividadeColetivaMutation>;
export type ExcluirGrupoParticipanteAtividadeColetivaMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirGrupoParticipanteAtividadeColetivaMutation, Types.ExcluirGrupoParticipanteAtividadeColetivaMutationVariables>;
export const SalvarAtividadeColetivaGruposDocument = gql`
    mutation SalvarAtividadeColetivaGrupos($input: GrupoParticipanteAtividadeColetivaInput!) {
  salvarGrupoParticipanteAtividadeColetiva(input: $input)
}
    `;
export type SalvarAtividadeColetivaGruposMutationFn = Apollo.MutationFunction<Types.SalvarAtividadeColetivaGruposMutation, Types.SalvarAtividadeColetivaGruposMutationVariables>;

/**
 * __useSalvarAtividadeColetivaGruposMutation__
 *
 * To run a mutation, you first call `useSalvarAtividadeColetivaGruposMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtividadeColetivaGruposMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtividadeColetivaGruposMutation, { data, loading, error }] = useSalvarAtividadeColetivaGruposMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtividadeColetivaGruposMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAtividadeColetivaGruposMutation, Types.SalvarAtividadeColetivaGruposMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAtividadeColetivaGruposMutation, Types.SalvarAtividadeColetivaGruposMutationVariables>(SalvarAtividadeColetivaGruposDocument, options);
      }
export type SalvarAtividadeColetivaGruposMutationHookResult = ReturnType<typeof useSalvarAtividadeColetivaGruposMutation>;
export type SalvarAtividadeColetivaGruposMutationResult = Apollo.MutationResult<Types.SalvarAtividadeColetivaGruposMutation>;
export type SalvarAtividadeColetivaGruposMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAtividadeColetivaGruposMutation, Types.SalvarAtividadeColetivaGruposMutationVariables>;
export const UpdateStatusAtivoGrupoParticipanteAtividadeColetivaDocument = gql`
    mutation UpdateStatusAtivoGrupoParticipanteAtividadeColetiva($grupoParticipanteAtividadeColetivaId: ID!, $ativo: Boolean!) {
  updateStatusAtivoGrupoParticipanteAtividadeColetiva(
    grupoParticipanteAtividadeColetivaId: $grupoParticipanteAtividadeColetivaId
    ativo: $ativo
  )
}
    `;
export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationFn = Apollo.MutationFunction<Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation, Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationVariables>;

/**
 * __useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation__
 *
 * To run a mutation, you first call `useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusAtivoGrupoParticipanteAtividadeColetivaMutation, { data, loading, error }] = useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation({
 *   variables: {
 *      grupoParticipanteAtividadeColetivaId: // value for 'grupoParticipanteAtividadeColetivaId'
 *      ativo: // value for 'ativo'
 *   },
 * });
 */
export function useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation, Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation, Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationVariables>(UpdateStatusAtivoGrupoParticipanteAtividadeColetivaDocument, options);
      }
export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationHookResult = ReturnType<typeof useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation>;
export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationResult = Apollo.MutationResult<Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation>;
export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationOptions = Apollo.BaseMutationOptions<Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation, Types.UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationVariables>;
export const AtividadeColetivaEditarReuniaoDocument = gql`
    query AtividadeColetivaEditarReuniao($atividadeColetivaId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    registroEnviado
    tipoAtividade
    lotacaoResponsavel {
      ...LotacaoBasico
      ...Cbo
      profissional {
        id
        email
        nomeSocial
      }
      equipe {
        id
        isAD
      }
    }
    turno
    atividadeSaudePse
    inepLocalAtividade {
      id
      dsInep
      nomeEstabelecimento
    }
    unidadeSaudeLocalAtividade {
      ...UnidadeSaudeBasico
    }
    temasReuniao
    temasSaude
    lotacoesEnvolvidas {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
      equipe {
        id
        isAD
      }
    }
    dataAtividade
    numeroParticipantes
    outraLocalidade
    anotacoes
    observacoes {
      id
      cidadao {
        id
        nome
        nomeSocial
        cns
        cpf
        sexo
      }
      observacao
    }
  }
}
    ${LotacaoBasicoFragmentDoc}
${CboFragmentDoc}
${UnidadeSaudeBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaEditarReuniaoQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaEditarReuniaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaEditarReuniaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaEditarReuniaoQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *   },
 * });
 */
export function useAtividadeColetivaEditarReuniaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables> & ({ variables: Types.AtividadeColetivaEditarReuniaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>(AtividadeColetivaEditarReuniaoDocument, options);
      }
export function useAtividadeColetivaEditarReuniaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>(AtividadeColetivaEditarReuniaoDocument, options);
        }
export function useAtividadeColetivaEditarReuniaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>(AtividadeColetivaEditarReuniaoDocument, options);
        }
export type AtividadeColetivaEditarReuniaoQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarReuniaoQuery>;
export type AtividadeColetivaEditarReuniaoLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarReuniaoLazyQuery>;
export type AtividadeColetivaEditarReuniaoSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarReuniaoSuspenseQuery>;
export type AtividadeColetivaEditarReuniaoQueryResult = Apollo.QueryResult<Types.AtividadeColetivaEditarReuniaoQuery, Types.AtividadeColetivaEditarReuniaoQueryVariables>;
export const AtividadeColetivaVisualizarReuniaoDocument = gql`
    query AtividadeColetivaVisualizarReuniao($atividadeColetivaId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    tipoAtividade
    atividadeSaudePse
    lotacaoResponsavel {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
    }
    turno
    inepLocalAtividade {
      id
      nomeEstabelecimento
      dsInep
    }
    unidadeSaudeLocalAtividade {
      id
      cnes
      nome
    }
    temasReuniao
    temasSaude
    lotacoesEnvolvidas {
      id
      profissional {
        id
        nome
        nomeSocial
      }
      cbo {
        id
        nome
      }
      equipe {
        id
        nome
      }
    }
    dataAtividade
    numeroParticipantes
    outraLocalidade
    anotacoes
    atividadeEducacaoPse
    atividadeSaudePse
    observacoes {
      id
      cidadao {
        id
        nome
        nomeSocial
        cns
        cpf
        sexo
        dataNascimento
      }
      observacao
    }
    inepLocalAtividade {
      id
      nomeEstabelecimento
      dsInep
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaVisualizarReuniaoQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaVisualizarReuniaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaVisualizarReuniaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaVisualizarReuniaoQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *   },
 * });
 */
export function useAtividadeColetivaVisualizarReuniaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables> & ({ variables: Types.AtividadeColetivaVisualizarReuniaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>(AtividadeColetivaVisualizarReuniaoDocument, options);
      }
export function useAtividadeColetivaVisualizarReuniaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>(AtividadeColetivaVisualizarReuniaoDocument, options);
        }
export function useAtividadeColetivaVisualizarReuniaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>(AtividadeColetivaVisualizarReuniaoDocument, options);
        }
export type AtividadeColetivaVisualizarReuniaoQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarReuniaoQuery>;
export type AtividadeColetivaVisualizarReuniaoLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarReuniaoLazyQuery>;
export type AtividadeColetivaVisualizarReuniaoSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarReuniaoSuspenseQuery>;
export type AtividadeColetivaVisualizarReuniaoQueryResult = Apollo.QueryResult<Types.AtividadeColetivaVisualizarReuniaoQuery, Types.AtividadeColetivaVisualizarReuniaoQueryVariables>;
export const FatoAtividadeColetivaReuniaoDocument = gql`
    query FatoAtividadeColetivaReuniao($input: ID!) {
  fatoAtividadeColetiva(input: $input) {
    ...FatoAtividadeColetivaFragment
    nuAvaliacoesAlteradas
    temasReuniao
    temasSaude
    stPseSaude
    stPseEducacao
    origem
    dimensaoInep {
      id
      nuIdentificador
      noEstabelecimento
    }
    fatoAtividadeColetivaParticipantes {
      id
      nuCpfParticipante
      nuCnsParticipante
      dtNascimentoParticipante
      dimensaoSexo {
        id
        identificador
      }
      fatoCidadaoPec {
        id
        nome
        nomeSocial
        cns
        cpf
        dataNascimento
        dimensaoSexo {
          id
          identificador
        }
      }
      fatoAtividadeColetiva {
        id
      }
    }
  }
}
    ${FatoAtividadeColetivaFragmentFragmentDoc}`;

/**
 * __useFatoAtividadeColetivaReuniaoQuery__
 *
 * To run a query within a React component, call `useFatoAtividadeColetivaReuniaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFatoAtividadeColetivaReuniaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFatoAtividadeColetivaReuniaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFatoAtividadeColetivaReuniaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables> & ({ variables: Types.FatoAtividadeColetivaReuniaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>(FatoAtividadeColetivaReuniaoDocument, options);
      }
export function useFatoAtividadeColetivaReuniaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>(FatoAtividadeColetivaReuniaoDocument, options);
        }
export function useFatoAtividadeColetivaReuniaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>(FatoAtividadeColetivaReuniaoDocument, options);
        }
export type FatoAtividadeColetivaReuniaoQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaReuniaoQuery>;
export type FatoAtividadeColetivaReuniaoLazyQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaReuniaoLazyQuery>;
export type FatoAtividadeColetivaReuniaoSuspenseQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaReuniaoSuspenseQuery>;
export type FatoAtividadeColetivaReuniaoQueryResult = Apollo.QueryResult<Types.FatoAtividadeColetivaReuniaoQuery, Types.FatoAtividadeColetivaReuniaoQueryVariables>;
export const AtividadeColetivaEditarSaudeDocument = gql`
    query AtividadeColetivaEditarSaude($atividadeColetivaId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    tipoAtividade
    lotacaoResponsavel {
      ...LotacaoBasico
      ...Cbo
      profissional {
        id
        email
        nomeSocial
      }
      equipe {
        id
        isAD
      }
    }
    turno
    inepLocalAtividade {
      id
      dsInep
      nomeEstabelecimento
    }
    unidadeSaudeLocalAtividade {
      ...UnidadeSaudeBasico
    }
    temasSaude
    praticasSaude
    publicoAlvo
    procedimento {
      id
      descricao
      codigo
    }
    lotacoesEnvolvidas {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
      equipe {
        id
        isAD
      }
    }
    dataAtividade
    numeroParticipantes
    outraLocalidade
    anotacoes
    atividadeEducacaoPse
    atividadeSaudePse
    registroEnviado
    participantes {
      id
      cidadao {
        id
        nome
        nomeSocial
        dataNascimento
        sexo
        cpf
        cns
        dataObito
      }
      cidadaoParticipante {
        id
        nome
        dataNascimento
        sexo
        cpf
        cns
        stNaoPossuiCpf
        justificativaNaoPossuiCpf
      }
      peso
      altura
      avaliacaoAlterada
      pnctAbandonouGrupo
      pnctCessouHabitoFumar
    }
  }
}
    ${LotacaoBasicoFragmentDoc}
${CboFragmentDoc}
${UnidadeSaudeBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaEditarSaudeQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaEditarSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaEditarSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaEditarSaudeQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *   },
 * });
 */
export function useAtividadeColetivaEditarSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables> & ({ variables: Types.AtividadeColetivaEditarSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>(AtividadeColetivaEditarSaudeDocument, options);
      }
export function useAtividadeColetivaEditarSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>(AtividadeColetivaEditarSaudeDocument, options);
        }
export function useAtividadeColetivaEditarSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>(AtividadeColetivaEditarSaudeDocument, options);
        }
export type AtividadeColetivaEditarSaudeQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarSaudeQuery>;
export type AtividadeColetivaEditarSaudeLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarSaudeLazyQuery>;
export type AtividadeColetivaEditarSaudeSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaEditarSaudeSuspenseQuery>;
export type AtividadeColetivaEditarSaudeQueryResult = Apollo.QueryResult<Types.AtividadeColetivaEditarSaudeQuery, Types.AtividadeColetivaEditarSaudeQueryVariables>;
export const AtividadeColetivaVisualizarSaudeDocument = gql`
    query AtividadeColetivaVisualizarSaude($atividadeColetivaId: Long!) {
  atividadeColetiva(atividadeColetivaId: $atividadeColetivaId) {
    id
    tipoAtividade
    lotacaoResponsavel {
      ...LotacaoBasico
      profissional {
        id
        nomeSocial
      }
    }
    turno
    inepLocalAtividade {
      id
      nomeEstabelecimento
      dsInep
    }
    unidadeSaudeLocalAtividade {
      id
      cnes
      nome
    }
    temasSaude
    praticasSaude
    publicoAlvo
    procedimento {
      id
      descricao
      codigo
    }
    lotacoesEnvolvidas {
      id
      profissional {
        id
        nome
        nomeSocial
      }
      cbo {
        id
        nome
      }
      equipe {
        id
        nome
      }
    }
    dataAtividade
    numeroParticipantes
    numeroAvaliacoesAlteradas
    outraLocalidade
    anotacoes
    atividadeEducacaoPse
    atividadeSaudePse
    participantes {
      id
      atividadeColetivaId
      cidadaoParticipante {
        id
        nome
        cpf
        cns
        dataNascimento
        sexo
      }
      cidadao {
        id
        nome
        nomeSocial
        cpf
        cns
        dataNascimento
        sexo
      }
      peso
      altura
      avaliacaoAlterada
      pnctAbandonouGrupo
      pnctCessouHabitoFumar
    }
  }
}
    ${LotacaoBasicoFragmentDoc}`;

/**
 * __useAtividadeColetivaVisualizarSaudeQuery__
 *
 * To run a query within a React component, call `useAtividadeColetivaVisualizarSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtividadeColetivaVisualizarSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtividadeColetivaVisualizarSaudeQuery({
 *   variables: {
 *      atividadeColetivaId: // value for 'atividadeColetivaId'
 *   },
 * });
 */
export function useAtividadeColetivaVisualizarSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables> & ({ variables: Types.AtividadeColetivaVisualizarSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>(AtividadeColetivaVisualizarSaudeDocument, options);
      }
export function useAtividadeColetivaVisualizarSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>(AtividadeColetivaVisualizarSaudeDocument, options);
        }
export function useAtividadeColetivaVisualizarSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>(AtividadeColetivaVisualizarSaudeDocument, options);
        }
export type AtividadeColetivaVisualizarSaudeQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarSaudeQuery>;
export type AtividadeColetivaVisualizarSaudeLazyQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarSaudeLazyQuery>;
export type AtividadeColetivaVisualizarSaudeSuspenseQueryHookResult = ReturnType<typeof useAtividadeColetivaVisualizarSaudeSuspenseQuery>;
export type AtividadeColetivaVisualizarSaudeQueryResult = Apollo.QueryResult<Types.AtividadeColetivaVisualizarSaudeQuery, Types.AtividadeColetivaVisualizarSaudeQueryVariables>;
export const FatoAtividadeColetivaSaudeDocument = gql`
    query FatoAtividadeColetivaSaude($input: ID!) {
  fatoAtividadeColetiva(input: $input) {
    ...FatoAtividadeColetivaFragment
    nuAvaliacoesAlteradas
    temasSaude
    praticasSaude
    publicoAlvo
    origem
    dimensaoInep {
      id
      nuIdentificador
      noEstabelecimento
    }
    dimensaoProcedimento {
      id
      descricaoProcedimento
      codigoProcedimento
    }
    fatoAtividadeColetivaParticipantes {
      id
      stAvaliacaoAlterada
      nuPesoParticipante
      nuAlturaParticipante
      stPnctAbandonouGrupo
      stPnctCessouHabitoFumar
      nuCpfParticipante
      nuCnsParticipante
      dtNascimentoParticipante
      dimensaoSexo {
        id
        identificador
      }
      fatoCidadaoPec {
        id
        nome
        nomeSocial
        cns
        cpf
        dataNascimento
        dimensaoSexo {
          id
          identificador
        }
      }
      fatoAtividadeColetiva {
        id
      }
    }
  }
}
    ${FatoAtividadeColetivaFragmentFragmentDoc}`;

/**
 * __useFatoAtividadeColetivaSaudeQuery__
 *
 * To run a query within a React component, call `useFatoAtividadeColetivaSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFatoAtividadeColetivaSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFatoAtividadeColetivaSaudeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFatoAtividadeColetivaSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables> & ({ variables: Types.FatoAtividadeColetivaSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>(FatoAtividadeColetivaSaudeDocument, options);
      }
export function useFatoAtividadeColetivaSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>(FatoAtividadeColetivaSaudeDocument, options);
        }
export function useFatoAtividadeColetivaSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>(FatoAtividadeColetivaSaudeDocument, options);
        }
export type FatoAtividadeColetivaSaudeQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaSaudeQuery>;
export type FatoAtividadeColetivaSaudeLazyQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaSaudeLazyQuery>;
export type FatoAtividadeColetivaSaudeSuspenseQueryHookResult = ReturnType<typeof useFatoAtividadeColetivaSaudeSuspenseQuery>;
export type FatoAtividadeColetivaSaudeQueryResult = Apollo.QueryResult<Types.FatoAtividadeColetivaSaudeQuery, Types.FatoAtividadeColetivaSaudeQueryVariables>;
export const AuditoriaHistoricoTableDocument = gql`
    query AuditoriaHistoricoTable($input: AuditoriaHistoricoQueryInput!) {
  auditoriaHistorico(input: $input) {
    content {
      id
      dataInicio
      dataFim
      dataSolicitacao
      status
      csv
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAuditoriaHistoricoTableQuery__
 *
 * To run a query within a React component, call `useAuditoriaHistoricoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditoriaHistoricoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditoriaHistoricoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditoriaHistoricoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables> & ({ variables: Types.AuditoriaHistoricoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>(AuditoriaHistoricoTableDocument, options);
      }
export function useAuditoriaHistoricoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>(AuditoriaHistoricoTableDocument, options);
        }
export function useAuditoriaHistoricoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>(AuditoriaHistoricoTableDocument, options);
        }
export type AuditoriaHistoricoTableQueryHookResult = ReturnType<typeof useAuditoriaHistoricoTableQuery>;
export type AuditoriaHistoricoTableLazyQueryHookResult = ReturnType<typeof useAuditoriaHistoricoTableLazyQuery>;
export type AuditoriaHistoricoTableSuspenseQueryHookResult = ReturnType<typeof useAuditoriaHistoricoTableSuspenseQuery>;
export type AuditoriaHistoricoTableQueryResult = Apollo.QueryResult<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>;
export const ProcessarAuditoriaDocument = gql`
    mutation ProcessarAuditoria($input: AuditoriaInput!) {
  processAuditoria(input: $input)
}
    `;
export type ProcessarAuditoriaMutationFn = Apollo.MutationFunction<Types.ProcessarAuditoriaMutation, Types.ProcessarAuditoriaMutationVariables>;

/**
 * __useProcessarAuditoriaMutation__
 *
 * To run a mutation, you first call `useProcessarAuditoriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessarAuditoriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processarAuditoriaMutation, { data, loading, error }] = useProcessarAuditoriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessarAuditoriaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ProcessarAuditoriaMutation, Types.ProcessarAuditoriaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ProcessarAuditoriaMutation, Types.ProcessarAuditoriaMutationVariables>(ProcessarAuditoriaDocument, options);
      }
export type ProcessarAuditoriaMutationHookResult = ReturnType<typeof useProcessarAuditoriaMutation>;
export type ProcessarAuditoriaMutationResult = Apollo.MutationResult<Types.ProcessarAuditoriaMutation>;
export type ProcessarAuditoriaMutationOptions = Apollo.BaseMutationOptions<Types.ProcessarAuditoriaMutation, Types.ProcessarAuditoriaMutationVariables>;
export const AutorizarMunicipioConfigAgendaPadraoDocument = gql`
    query AutorizarMunicipioConfigAgendaPadrao {
  duracaoAtendimentoPadraoMunicipio {
    duracaoAtendimentoPadraoMunicipio
  }
  configuracaoHorariosMunicipio {
    id
    configuracaoHorarioAgenda {
      configuracaoDiasSemana {
        diaSemana
        periodos {
          periodo
          horarioInicial
          horarioFinal
        }
      }
    }
  }
}
    `;

/**
 * __useAutorizarMunicipioConfigAgendaPadraoQuery__
 *
 * To run a query within a React component, call `useAutorizarMunicipioConfigAgendaPadraoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutorizarMunicipioConfigAgendaPadraoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutorizarMunicipioConfigAgendaPadraoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutorizarMunicipioConfigAgendaPadraoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>(AutorizarMunicipioConfigAgendaPadraoDocument, options);
      }
export function useAutorizarMunicipioConfigAgendaPadraoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>(AutorizarMunicipioConfigAgendaPadraoDocument, options);
        }
export function useAutorizarMunicipioConfigAgendaPadraoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>(AutorizarMunicipioConfigAgendaPadraoDocument, options);
        }
export type AutorizarMunicipioConfigAgendaPadraoQueryHookResult = ReturnType<typeof useAutorizarMunicipioConfigAgendaPadraoQuery>;
export type AutorizarMunicipioConfigAgendaPadraoLazyQueryHookResult = ReturnType<typeof useAutorizarMunicipioConfigAgendaPadraoLazyQuery>;
export type AutorizarMunicipioConfigAgendaPadraoSuspenseQueryHookResult = ReturnType<typeof useAutorizarMunicipioConfigAgendaPadraoSuspenseQuery>;
export type AutorizarMunicipioConfigAgendaPadraoQueryResult = Apollo.QueryResult<Types.AutorizarMunicipioConfigAgendaPadraoQuery, Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables>;
export const SalvaAutorizarMunicipioConfiguracaoAgendaPadraoDocument = gql`
    mutation SalvaAutorizarMunicipioConfiguracaoAgendaPadrao($duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput!, $configuracaoAgendaMunicipalInput: ConfiguracaoAgendaMunicipalInput) {
  alterarDuracaoPadraoAtendimento(
    duracaoAtendimentoPadraoMunicipioInput: $duracaoAtendimentoPadraoMunicipioInput
  ) {
    duracaoAtendimentoPadraoMunicipio
  }
  salvarConfiguracaoHorariosMunicipio(
    configuracaoAgendaMunicipalInput: $configuracaoAgendaMunicipalInput
  ) {
    id
    configuracaoHorarioAgenda {
      configuracaoDiasSemana {
        diaSemana
        periodos {
          periodo
          horarioInicial
          horarioFinal
        }
      }
    }
  }
}
    `;
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationFn = Apollo.MutationFunction<Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables>;

/**
 * __useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation__
 *
 * To run a mutation, you first call `useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, { data, loading, error }] = useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation({
 *   variables: {
 *      duracaoAtendimentoPadraoMunicipioInput: // value for 'duracaoAtendimentoPadraoMunicipioInput'
 *      configuracaoAgendaMunicipalInput: // value for 'configuracaoAgendaMunicipalInput'
 *   },
 * });
 */
export function useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables>(SalvaAutorizarMunicipioConfiguracaoAgendaPadraoDocument, options);
      }
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationHookResult = ReturnType<typeof useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation>;
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationResult = Apollo.MutationResult<Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation>;
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationOptions = Apollo.BaseMutationOptions<Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables>;
export const SaveAutorizarMunicipioDocument = gql`
    mutation SaveAutorizarMunicipio($input: AutorizarMunicipioInput!) {
  autorizarMunicipio(input: $input) {
    id
    autorizado
  }
}
    `;
export type SaveAutorizarMunicipioMutationFn = Apollo.MutationFunction<Types.SaveAutorizarMunicipioMutation, Types.SaveAutorizarMunicipioMutationVariables>;

/**
 * __useSaveAutorizarMunicipioMutation__
 *
 * To run a mutation, you first call `useSaveAutorizarMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAutorizarMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAutorizarMunicipioMutation, { data, loading, error }] = useSaveAutorizarMunicipioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAutorizarMunicipioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SaveAutorizarMunicipioMutation, Types.SaveAutorizarMunicipioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SaveAutorizarMunicipioMutation, Types.SaveAutorizarMunicipioMutationVariables>(SaveAutorizarMunicipioDocument, options);
      }
export type SaveAutorizarMunicipioMutationHookResult = ReturnType<typeof useSaveAutorizarMunicipioMutation>;
export type SaveAutorizarMunicipioMutationResult = Apollo.MutationResult<Types.SaveAutorizarMunicipioMutation>;
export type SaveAutorizarMunicipioMutationOptions = Apollo.BaseMutationOptions<Types.SaveAutorizarMunicipioMutation, Types.SaveAutorizarMunicipioMutationVariables>;
export const AutorizarMunicipioDocument = gql`
    query AutorizarMunicipio($acessoId: ID!) {
  acesso(id: $acessoId) {
    __typename
    id
    profissional {
      id
      nome
      cpf
    }
    municipio {
      id
      nome
      uf {
        id
        nome
        sigla
      }
    }
    ... on AdministradorMunicipal {
      autorizado
      chaveMunicipio
    }
  }
}
    `;

/**
 * __useAutorizarMunicipioQuery__
 *
 * To run a query within a React component, call `useAutorizarMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutorizarMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutorizarMunicipioQuery({
 *   variables: {
 *      acessoId: // value for 'acessoId'
 *   },
 * });
 */
export function useAutorizarMunicipioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables> & ({ variables: Types.AutorizarMunicipioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>(AutorizarMunicipioDocument, options);
      }
export function useAutorizarMunicipioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>(AutorizarMunicipioDocument, options);
        }
export function useAutorizarMunicipioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>(AutorizarMunicipioDocument, options);
        }
export type AutorizarMunicipioQueryHookResult = ReturnType<typeof useAutorizarMunicipioQuery>;
export type AutorizarMunicipioLazyQueryHookResult = ReturnType<typeof useAutorizarMunicipioLazyQuery>;
export type AutorizarMunicipioSuspenseQueryHookResult = ReturnType<typeof useAutorizarMunicipioSuspenseQuery>;
export type AutorizarMunicipioQueryResult = Apollo.QueryResult<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>;
export const ConcluirConfiguracaoMunicipioDocument = gql`
    mutation ConcluirConfiguracaoMunicipio {
  concluirConfiguracaoMunicipio {
    id
    habilitado
  }
}
    `;
export type ConcluirConfiguracaoMunicipioMutationFn = Apollo.MutationFunction<Types.ConcluirConfiguracaoMunicipioMutation, Types.ConcluirConfiguracaoMunicipioMutationVariables>;

/**
 * __useConcluirConfiguracaoMunicipioMutation__
 *
 * To run a mutation, you first call `useConcluirConfiguracaoMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcluirConfiguracaoMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concluirConfiguracaoMunicipioMutation, { data, loading, error }] = useConcluirConfiguracaoMunicipioMutation({
 *   variables: {
 *   },
 * });
 */
export function useConcluirConfiguracaoMunicipioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ConcluirConfiguracaoMunicipioMutation, Types.ConcluirConfiguracaoMunicipioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ConcluirConfiguracaoMunicipioMutation, Types.ConcluirConfiguracaoMunicipioMutationVariables>(ConcluirConfiguracaoMunicipioDocument, options);
      }
export type ConcluirConfiguracaoMunicipioMutationHookResult = ReturnType<typeof useConcluirConfiguracaoMunicipioMutation>;
export type ConcluirConfiguracaoMunicipioMutationResult = Apollo.MutationResult<Types.ConcluirConfiguracaoMunicipioMutation>;
export type ConcluirConfiguracaoMunicipioMutationOptions = Apollo.BaseMutationOptions<Types.ConcluirConfiguracaoMunicipioMutation, Types.ConcluirConfiguracaoMunicipioMutationVariables>;
export const ImportacoesBolsaFamiliaDocument = gql`
    query ImportacoesBolsaFamilia($input: ImportacaoBolsaFamiliaQueryInput!) {
  importacoesBolsaFamilia(input: $input) {
    content {
      id
      dataImportacaoInicio
      profissionalResponsavel {
        id
        nome
      }
      municipio {
        id
        nome
      }
      statusImportacao
      vigencia
      complementar
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useImportacoesBolsaFamiliaQuery__
 *
 * To run a query within a React component, call `useImportacoesBolsaFamiliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportacoesBolsaFamiliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportacoesBolsaFamiliaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportacoesBolsaFamiliaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables> & ({ variables: Types.ImportacoesBolsaFamiliaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>(ImportacoesBolsaFamiliaDocument, options);
      }
export function useImportacoesBolsaFamiliaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>(ImportacoesBolsaFamiliaDocument, options);
        }
export function useImportacoesBolsaFamiliaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>(ImportacoesBolsaFamiliaDocument, options);
        }
export type ImportacoesBolsaFamiliaQueryHookResult = ReturnType<typeof useImportacoesBolsaFamiliaQuery>;
export type ImportacoesBolsaFamiliaLazyQueryHookResult = ReturnType<typeof useImportacoesBolsaFamiliaLazyQuery>;
export type ImportacoesBolsaFamiliaSuspenseQueryHookResult = ReturnType<typeof useImportacoesBolsaFamiliaSuspenseQuery>;
export type ImportacoesBolsaFamiliaQueryResult = Apollo.QueryResult<Types.ImportacoesBolsaFamiliaQuery, Types.ImportacoesBolsaFamiliaQueryVariables>;
export const VigenciaMaisRecenteBolsaFamiliaDocument = gql`
    query VigenciaMaisRecenteBolsaFamilia {
  vigenciaMaisRecente {
    id
    vigencia
  }
}
    `;

/**
 * __useVigenciaMaisRecenteBolsaFamiliaQuery__
 *
 * To run a query within a React component, call `useVigenciaMaisRecenteBolsaFamiliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useVigenciaMaisRecenteBolsaFamiliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVigenciaMaisRecenteBolsaFamiliaQuery({
 *   variables: {
 *   },
 * });
 */
export function useVigenciaMaisRecenteBolsaFamiliaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>(VigenciaMaisRecenteBolsaFamiliaDocument, options);
      }
export function useVigenciaMaisRecenteBolsaFamiliaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>(VigenciaMaisRecenteBolsaFamiliaDocument, options);
        }
export function useVigenciaMaisRecenteBolsaFamiliaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>(VigenciaMaisRecenteBolsaFamiliaDocument, options);
        }
export type VigenciaMaisRecenteBolsaFamiliaQueryHookResult = ReturnType<typeof useVigenciaMaisRecenteBolsaFamiliaQuery>;
export type VigenciaMaisRecenteBolsaFamiliaLazyQueryHookResult = ReturnType<typeof useVigenciaMaisRecenteBolsaFamiliaLazyQuery>;
export type VigenciaMaisRecenteBolsaFamiliaSuspenseQueryHookResult = ReturnType<typeof useVigenciaMaisRecenteBolsaFamiliaSuspenseQuery>;
export type VigenciaMaisRecenteBolsaFamiliaQueryResult = Apollo.QueryResult<Types.VigenciaMaisRecenteBolsaFamiliaQuery, Types.VigenciaMaisRecenteBolsaFamiliaQueryVariables>;
export const BuscaAtivaVacinacaoDocument = gql`
    query BuscaAtivaVacinacao($input: BuscaAtivaVacinacaoInput!) {
  buscaAtivaVacinacao(input: $input) {
    content {
      id
      cidadaoId
      nomeSocialOuNomeCidadao
      cpfCidadao
      cnsCidadao
      dataNascimentoCidadao
      telefoneResidencial
      telefoneCelular
      telefoneContato
      endereco
      vacinasAtrasadas {
        cidadaoId
        nome
        siglaDose
        imunobiologicoId
        doseId
      }
      vacinasNoPrazo {
        cidadaoId
        nome
        siglaDose
        imunobiologicoId
        doseId
      }
      vacinasAplicadas {
        cidadaoId
        nome
        siglaDose
        dataAplicacaoVacina
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useBuscaAtivaVacinacaoQuery__
 *
 * To run a query within a React component, call `useBuscaAtivaVacinacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaAtivaVacinacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaAtivaVacinacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaAtivaVacinacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables> & ({ variables: Types.BuscaAtivaVacinacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>(BuscaAtivaVacinacaoDocument, options);
      }
export function useBuscaAtivaVacinacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>(BuscaAtivaVacinacaoDocument, options);
        }
export function useBuscaAtivaVacinacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>(BuscaAtivaVacinacaoDocument, options);
        }
export type BuscaAtivaVacinacaoQueryHookResult = ReturnType<typeof useBuscaAtivaVacinacaoQuery>;
export type BuscaAtivaVacinacaoLazyQueryHookResult = ReturnType<typeof useBuscaAtivaVacinacaoLazyQuery>;
export type BuscaAtivaVacinacaoSuspenseQueryHookResult = ReturnType<typeof useBuscaAtivaVacinacaoSuspenseQuery>;
export type BuscaAtivaVacinacaoQueryResult = Apollo.QueryResult<Types.BuscaAtivaVacinacaoQuery, Types.BuscaAtivaVacinacaoQueryVariables>;
export const CidadaosCadastroImovelDocument = gql`
    query CidadaosCadastroImovel($input: [ID!]!) {
  cidadaosTerritorio(cidadaosIds: $input) {
    id
    cns
    cpf
    justificativaNaoPossuiCpf
    stNaoPossuiCpf
    dataNascimento
    nome
    nomeSocial
    sexo
    telefoneCelular
    racaCorDbEnum
    etniaId
    nomeMae
    nomePai
    desconheceNomePai
    desconheceNomeMae
    nacionalidadeDbEnum
    paisNascimentoId
    localidadeNascimentoId
    dataNaturalizacao
    portariaNaturalizacao
    dataEntradaBrasil
    dataObito
    numeroDocumentoObito
    ufNascimentoId
    cidadaoAldeadoId
    permissaoSalvarImovel {
      enabled
      hint
    }
    cidadaoNucleoFamiliar {
      id
      grauParentescoResponsavelFamiliar
    }
  }
}
    `;

/**
 * __useCidadaosCadastroImovelQuery__
 *
 * To run a query within a React component, call `useCidadaosCadastroImovelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaosCadastroImovelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaosCadastroImovelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaosCadastroImovelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables> & ({ variables: Types.CidadaosCadastroImovelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>(CidadaosCadastroImovelDocument, options);
      }
export function useCidadaosCadastroImovelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>(CidadaosCadastroImovelDocument, options);
        }
export function useCidadaosCadastroImovelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>(CidadaosCadastroImovelDocument, options);
        }
export type CidadaosCadastroImovelQueryHookResult = ReturnType<typeof useCidadaosCadastroImovelQuery>;
export type CidadaosCadastroImovelLazyQueryHookResult = ReturnType<typeof useCidadaosCadastroImovelLazyQuery>;
export type CidadaosCadastroImovelSuspenseQueryHookResult = ReturnType<typeof useCidadaosCadastroImovelSuspenseQuery>;
export type CidadaosCadastroImovelQueryResult = Apollo.QueryResult<Types.CidadaosCadastroImovelQuery, Types.CidadaosCadastroImovelQueryVariables>;
export const ImoveisCadastrosDuplicadosDocument = gql`
    query ImoveisCadastrosDuplicados($input: TerritorioMicroareaQueryInput!) {
  territorioLogradouro(input: $input) {
    id
    unidadeSaude {
      id
      nome
    }
    equipe {
      id
      nome
      ine
    }
    complemento
    microarea
    numero
    logradouro
    familias(
      input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true}
    ) {
      id
    }
    isCadastroCompleto
    stAtivo
    dataUltimaAtualizacao
    poloBase {
      id
      nome
    }
    dsei {
      id
      nome
    }
    numeroResidenciaIndigena
  }
}
    `;

/**
 * __useImoveisCadastrosDuplicadosQuery__
 *
 * To run a query within a React component, call `useImoveisCadastrosDuplicadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useImoveisCadastrosDuplicadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImoveisCadastrosDuplicadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImoveisCadastrosDuplicadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables> & ({ variables: Types.ImoveisCadastrosDuplicadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>(ImoveisCadastrosDuplicadosDocument, options);
      }
export function useImoveisCadastrosDuplicadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>(ImoveisCadastrosDuplicadosDocument, options);
        }
export function useImoveisCadastrosDuplicadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>(ImoveisCadastrosDuplicadosDocument, options);
        }
export type ImoveisCadastrosDuplicadosQueryHookResult = ReturnType<typeof useImoveisCadastrosDuplicadosQuery>;
export type ImoveisCadastrosDuplicadosLazyQueryHookResult = ReturnType<typeof useImoveisCadastrosDuplicadosLazyQuery>;
export type ImoveisCadastrosDuplicadosSuspenseQueryHookResult = ReturnType<typeof useImoveisCadastrosDuplicadosSuspenseQuery>;
export type ImoveisCadastrosDuplicadosQueryResult = Apollo.QueryResult<Types.ImoveisCadastrosDuplicadosQuery, Types.ImoveisCadastrosDuplicadosQueryVariables>;
export const ImovelCadastroDocument = gql`
    query ImovelCadastro($input: ID!) {
  imovel(imovelId: $input) {
    id
    unidadeSaude {
      id
      nome
      cnes
      endereco {
        municipio {
          id
        }
      }
    }
    equipe {
      id
      nome
      ine
      isAD
    }
    profissional {
      id
      nome
      cns
      cpf
    }
    cbo {
      id
      nome
      cbo2002
      actions {
        cadastroDomiciliar {
          enabled
          hint
        }
        cadastroIndividual {
          enabled
          hint
        }
        atividadeColetiva {
          enabled
          hint
        }
      }
    }
    tipoEndereco
    complemento
    pontoReferencia
    cep
    telefoneContato
    telefoneResidencial
    microarea
    statusRecusa
    numero
    semNumero
    bairro
    logradouro
    tipoLogradouro {
      id
      nome
      numeroDne
    }
    tipoImovel
    uf {
      id
      nome
      sigla
    }
    municipio {
      id
      nome
      ibge
    }
    latitude
    longitude
    ...CondicoesMoradiaFragment
    ...AnimaisDomicilioFragment
    numeroMoradores
    nomeInstituicaoPermanencia
    possuiOutrosProfsVinculados
    responsavelTecnico {
      id
      nome
      contato
      cns
      cargo
    }
    familias(
      input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true}
    ) {
      id
      numeroProntuarioFamiliar
      numeroMembros
      rendaFamiliar
      resideDesde
      cpfCnsResponsavel
      isResponsavelCadastrado
      isResponsavelDeclarado
      cidadaosTerritorioBasico {
        id
        nome
        nomeSocial
        sexo
        cpf
        cns
        dataNascimento
        cidadaoNucleoFamiliar {
          id
          grauParentescoResponsavelFamiliar
        }
      }
    }
    aldeia {
      id
      nome
      poloBase {
        ...PoloBase
      }
      municipio {
        ...Municipio
      }
    }
    poloBase {
      ...PoloBase
    }
    dsei {
      id
      nome
    }
    municipioAldeia {
      ...Municipio
    }
    ufAldeia {
      id
      nome
      sigla
    }
    numeroResidenciaIndigena
    statusMicroareaPoloBase
    stAtivo
  }
}
    ${CondicoesMoradiaFragmentFragmentDoc}
${AnimaisDomicilioFragmentFragmentDoc}
${PoloBaseFragmentDoc}
${MunicipioFragmentDoc}`;

/**
 * __useImovelCadastroQuery__
 *
 * To run a query within a React component, call `useImovelCadastroQuery` and pass it any options that fit your needs.
 * When your component renders, `useImovelCadastroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImovelCadastroQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImovelCadastroQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables> & ({ variables: Types.ImovelCadastroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>(ImovelCadastroDocument, options);
      }
export function useImovelCadastroLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>(ImovelCadastroDocument, options);
        }
export function useImovelCadastroSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>(ImovelCadastroDocument, options);
        }
export type ImovelCadastroQueryHookResult = ReturnType<typeof useImovelCadastroQuery>;
export type ImovelCadastroLazyQueryHookResult = ReturnType<typeof useImovelCadastroLazyQuery>;
export type ImovelCadastroSuspenseQueryHookResult = ReturnType<typeof useImovelCadastroSuspenseQuery>;
export type ImovelCadastroQueryResult = Apollo.QueryResult<Types.ImovelCadastroQuery, Types.ImovelCadastroQueryVariables>;
export const IsLotacaoActiveDocument = gql`
    query IsLotacaoActive($input: IsLotacaoActiveInput!) {
  isLotacaoActive(isLotacaoActiveInput: $input)
}
    `;

/**
 * __useIsLotacaoActiveQuery__
 *
 * To run a query within a React component, call `useIsLotacaoActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLotacaoActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLotacaoActiveQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsLotacaoActiveQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables> & ({ variables: Types.IsLotacaoActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>(IsLotacaoActiveDocument, options);
      }
export function useIsLotacaoActiveLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>(IsLotacaoActiveDocument, options);
        }
export function useIsLotacaoActiveSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>(IsLotacaoActiveDocument, options);
        }
export type IsLotacaoActiveQueryHookResult = ReturnType<typeof useIsLotacaoActiveQuery>;
export type IsLotacaoActiveLazyQueryHookResult = ReturnType<typeof useIsLotacaoActiveLazyQuery>;
export type IsLotacaoActiveSuspenseQueryHookResult = ReturnType<typeof useIsLotacaoActiveSuspenseQuery>;
export type IsLotacaoActiveQueryResult = Apollo.QueryResult<Types.IsLotacaoActiveQuery, Types.IsLotacaoActiveQueryVariables>;
export const SalvarImovelDocument = gql`
    mutation SalvarImovel($input: ImovelInput!) {
  salvarImovel(input: $input)
}
    `;
export type SalvarImovelMutationFn = Apollo.MutationFunction<Types.SalvarImovelMutation, Types.SalvarImovelMutationVariables>;

/**
 * __useSalvarImovelMutation__
 *
 * To run a mutation, you first call `useSalvarImovelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarImovelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarImovelMutation, { data, loading, error }] = useSalvarImovelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarImovelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarImovelMutation, Types.SalvarImovelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarImovelMutation, Types.SalvarImovelMutationVariables>(SalvarImovelDocument, options);
      }
export type SalvarImovelMutationHookResult = ReturnType<typeof useSalvarImovelMutation>;
export type SalvarImovelMutationResult = Apollo.MutationResult<Types.SalvarImovelMutation>;
export type SalvarImovelMutationOptions = Apollo.BaseMutationOptions<Types.SalvarImovelMutation, Types.SalvarImovelMutationVariables>;
export const AlterarDuracaoCboDocument = gql`
    mutation AlterarDuracaoCbo($cboDuracaoForm: CboDuracaoFormInput!) {
  alterarDuracaoCbo(input: $cboDuracaoForm) {
    cbo {
      id
    }
  }
}
    `;
export type AlterarDuracaoCboMutationFn = Apollo.MutationFunction<Types.AlterarDuracaoCboMutation, Types.AlterarDuracaoCboMutationVariables>;

/**
 * __useAlterarDuracaoCboMutation__
 *
 * To run a mutation, you first call `useAlterarDuracaoCboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarDuracaoCboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarDuracaoCboMutation, { data, loading, error }] = useAlterarDuracaoCboMutation({
 *   variables: {
 *      cboDuracaoForm: // value for 'cboDuracaoForm'
 *   },
 * });
 */
export function useAlterarDuracaoCboMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarDuracaoCboMutation, Types.AlterarDuracaoCboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarDuracaoCboMutation, Types.AlterarDuracaoCboMutationVariables>(AlterarDuracaoCboDocument, options);
      }
export type AlterarDuracaoCboMutationHookResult = ReturnType<typeof useAlterarDuracaoCboMutation>;
export type AlterarDuracaoCboMutationResult = Apollo.MutationResult<Types.AlterarDuracaoCboMutation>;
export type AlterarDuracaoCboMutationOptions = Apollo.BaseMutationOptions<Types.AlterarDuracaoCboMutation, Types.AlterarDuracaoCboMutationVariables>;
export const DisponibilizarCboDocument = gql`
    mutation DisponibilizarCbo($cboDisponibilizarForm: CboDisponibilizarFormInput!) {
  disponibilizarCbo(input: $cboDisponibilizarForm) {
    cbo {
      id
    }
  }
}
    `;
export type DisponibilizarCboMutationFn = Apollo.MutationFunction<Types.DisponibilizarCboMutation, Types.DisponibilizarCboMutationVariables>;

/**
 * __useDisponibilizarCboMutation__
 *
 * To run a mutation, you first call `useDisponibilizarCboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisponibilizarCboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disponibilizarCboMutation, { data, loading, error }] = useDisponibilizarCboMutation({
 *   variables: {
 *      cboDisponibilizarForm: // value for 'cboDisponibilizarForm'
 *   },
 * });
 */
export function useDisponibilizarCboMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DisponibilizarCboMutation, Types.DisponibilizarCboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DisponibilizarCboMutation, Types.DisponibilizarCboMutationVariables>(DisponibilizarCboDocument, options);
      }
export type DisponibilizarCboMutationHookResult = ReturnType<typeof useDisponibilizarCboMutation>;
export type DisponibilizarCboMutationResult = Apollo.MutationResult<Types.DisponibilizarCboMutation>;
export type DisponibilizarCboMutationOptions = Apollo.BaseMutationOptions<Types.DisponibilizarCboMutation, Types.DisponibilizarCboMutationVariables>;
export const CboEditComponentDocument = gql`
    query CboEditComponent {
  conexao {
    agendaOnline {
      ativa
    }
  }
}
    `;

/**
 * __useCboEditComponentQuery__
 *
 * To run a query within a React component, call `useCboEditComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboEditComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboEditComponentQuery({
 *   variables: {
 *   },
 * });
 */
export function useCboEditComponentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>(CboEditComponentDocument, options);
      }
export function useCboEditComponentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>(CboEditComponentDocument, options);
        }
export function useCboEditComponentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>(CboEditComponentDocument, options);
        }
export type CboEditComponentQueryHookResult = ReturnType<typeof useCboEditComponentQuery>;
export type CboEditComponentLazyQueryHookResult = ReturnType<typeof useCboEditComponentLazyQuery>;
export type CboEditComponentSuspenseQueryHookResult = ReturnType<typeof useCboEditComponentSuspenseQuery>;
export type CboEditComponentQueryResult = Apollo.QueryResult<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>;
export const CboTableDocument = gql`
    query CboTable($input: CbosQueryInput!) {
  cbos(input: $input) {
    content {
      disponivelLotacao
      duracao
      duracaoPadrao
      cbo {
        id
        nome
        cbo2002
      }
      possuiLotacaoComAgendaOnline
      actions {
        inativar {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCboTableQuery__
 *
 * To run a query within a React component, call `useCboTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CboTableQuery, Types.CboTableQueryVariables> & ({ variables: Types.CboTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboTableQuery, Types.CboTableQueryVariables>(CboTableDocument, options);
      }
export function useCboTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboTableQuery, Types.CboTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboTableQuery, Types.CboTableQueryVariables>(CboTableDocument, options);
        }
export function useCboTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboTableQuery, Types.CboTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboTableQuery, Types.CboTableQueryVariables>(CboTableDocument, options);
        }
export type CboTableQueryHookResult = ReturnType<typeof useCboTableQuery>;
export type CboTableLazyQueryHookResult = ReturnType<typeof useCboTableLazyQuery>;
export type CboTableSuspenseQueryHookResult = ReturnType<typeof useCboTableSuspenseQuery>;
export type CboTableQueryResult = Apollo.QueryResult<Types.CboTableQuery, Types.CboTableQueryVariables>;
export const CriarSalaUnidadeSaudeDocument = gql`
    mutation CriarSalaUnidadeSaude($input: CriarSalaUnidadeSaudeInput!) {
  criarSalaUnidadeSaude(input: $input) {
    id
  }
}
    `;
export type CriarSalaUnidadeSaudeMutationFn = Apollo.MutationFunction<Types.CriarSalaUnidadeSaudeMutation, Types.CriarSalaUnidadeSaudeMutationVariables>;

/**
 * __useCriarSalaUnidadeSaudeMutation__
 *
 * To run a mutation, you first call `useCriarSalaUnidadeSaudeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarSalaUnidadeSaudeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarSalaUnidadeSaudeMutation, { data, loading, error }] = useCriarSalaUnidadeSaudeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarSalaUnidadeSaudeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarSalaUnidadeSaudeMutation, Types.CriarSalaUnidadeSaudeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CriarSalaUnidadeSaudeMutation, Types.CriarSalaUnidadeSaudeMutationVariables>(CriarSalaUnidadeSaudeDocument, options);
      }
export type CriarSalaUnidadeSaudeMutationHookResult = ReturnType<typeof useCriarSalaUnidadeSaudeMutation>;
export type CriarSalaUnidadeSaudeMutationResult = Apollo.MutationResult<Types.CriarSalaUnidadeSaudeMutation>;
export type CriarSalaUnidadeSaudeMutationOptions = Apollo.BaseMutationOptions<Types.CriarSalaUnidadeSaudeMutation, Types.CriarSalaUnidadeSaudeMutationVariables>;
export const DesabilitarPainelChamadasDocument = gql`
    mutation DesabilitarPainelChamadas($unidadeSaudeId: ID!) {
  desabilitarPainelChamadas(unidadeSaudeId: $unidadeSaudeId)
}
    `;
export type DesabilitarPainelChamadasMutationFn = Apollo.MutationFunction<Types.DesabilitarPainelChamadasMutation, Types.DesabilitarPainelChamadasMutationVariables>;

/**
 * __useDesabilitarPainelChamadasMutation__
 *
 * To run a mutation, you first call `useDesabilitarPainelChamadasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesabilitarPainelChamadasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desabilitarPainelChamadasMutation, { data, loading, error }] = useDesabilitarPainelChamadasMutation({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useDesabilitarPainelChamadasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DesabilitarPainelChamadasMutation, Types.DesabilitarPainelChamadasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DesabilitarPainelChamadasMutation, Types.DesabilitarPainelChamadasMutationVariables>(DesabilitarPainelChamadasDocument, options);
      }
export type DesabilitarPainelChamadasMutationHookResult = ReturnType<typeof useDesabilitarPainelChamadasMutation>;
export type DesabilitarPainelChamadasMutationResult = Apollo.MutationResult<Types.DesabilitarPainelChamadasMutation>;
export type DesabilitarPainelChamadasMutationOptions = Apollo.BaseMutationOptions<Types.DesabilitarPainelChamadasMutation, Types.DesabilitarPainelChamadasMutationVariables>;
export const DispositivosPareadosUnidadeSaudeDocument = gql`
    query DispositivosPareadosUnidadeSaude($unidadeSaudeId: ID!) {
  dispositivosPareadosUnidadeSaude(unidadeSaudeId: $unidadeSaudeId) {
    id
    nome
    dataPareamento
  }
}
    `;

/**
 * __useDispositivosPareadosUnidadeSaudeQuery__
 *
 * To run a query within a React component, call `useDispositivosPareadosUnidadeSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositivosPareadosUnidadeSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositivosPareadosUnidadeSaudeQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useDispositivosPareadosUnidadeSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables> & ({ variables: Types.DispositivosPareadosUnidadeSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>(DispositivosPareadosUnidadeSaudeDocument, options);
      }
export function useDispositivosPareadosUnidadeSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>(DispositivosPareadosUnidadeSaudeDocument, options);
        }
export function useDispositivosPareadosUnidadeSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>(DispositivosPareadosUnidadeSaudeDocument, options);
        }
export type DispositivosPareadosUnidadeSaudeQueryHookResult = ReturnType<typeof useDispositivosPareadosUnidadeSaudeQuery>;
export type DispositivosPareadosUnidadeSaudeLazyQueryHookResult = ReturnType<typeof useDispositivosPareadosUnidadeSaudeLazyQuery>;
export type DispositivosPareadosUnidadeSaudeSuspenseQueryHookResult = ReturnType<typeof useDispositivosPareadosUnidadeSaudeSuspenseQuery>;
export type DispositivosPareadosUnidadeSaudeQueryResult = Apollo.QueryResult<Types.DispositivosPareadosUnidadeSaudeQuery, Types.DispositivosPareadosUnidadeSaudeQueryVariables>;
export const HabilitarPainelChamadasDocument = gql`
    mutation HabilitarPainelChamadas($unidadeSaudeId: ID!) {
  habilitarPainelChamadas(unidadeSaudeId: $unidadeSaudeId)
}
    `;
export type HabilitarPainelChamadasMutationFn = Apollo.MutationFunction<Types.HabilitarPainelChamadasMutation, Types.HabilitarPainelChamadasMutationVariables>;

/**
 * __useHabilitarPainelChamadasMutation__
 *
 * To run a mutation, you first call `useHabilitarPainelChamadasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHabilitarPainelChamadasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [habilitarPainelChamadasMutation, { data, loading, error }] = useHabilitarPainelChamadasMutation({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useHabilitarPainelChamadasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.HabilitarPainelChamadasMutation, Types.HabilitarPainelChamadasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.HabilitarPainelChamadasMutation, Types.HabilitarPainelChamadasMutationVariables>(HabilitarPainelChamadasDocument, options);
      }
export type HabilitarPainelChamadasMutationHookResult = ReturnType<typeof useHabilitarPainelChamadasMutation>;
export type HabilitarPainelChamadasMutationResult = Apollo.MutationResult<Types.HabilitarPainelChamadasMutation>;
export type HabilitarPainelChamadasMutationOptions = Apollo.BaseMutationOptions<Types.HabilitarPainelChamadasMutation, Types.HabilitarPainelChamadasMutationVariables>;
export const IsPainelChamadasHabilitadoDocument = gql`
    query IsPainelChamadasHabilitado($unidadeSaudeId: ID!) {
  isPainelChamadasHabilitado(unidadeSaudeId: $unidadeSaudeId)
}
    `;

/**
 * __useIsPainelChamadasHabilitadoQuery__
 *
 * To run a query within a React component, call `useIsPainelChamadasHabilitadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPainelChamadasHabilitadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPainelChamadasHabilitadoQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useIsPainelChamadasHabilitadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables> & ({ variables: Types.IsPainelChamadasHabilitadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>(IsPainelChamadasHabilitadoDocument, options);
      }
export function useIsPainelChamadasHabilitadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>(IsPainelChamadasHabilitadoDocument, options);
        }
export function useIsPainelChamadasHabilitadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>(IsPainelChamadasHabilitadoDocument, options);
        }
export type IsPainelChamadasHabilitadoQueryHookResult = ReturnType<typeof useIsPainelChamadasHabilitadoQuery>;
export type IsPainelChamadasHabilitadoLazyQueryHookResult = ReturnType<typeof useIsPainelChamadasHabilitadoLazyQuery>;
export type IsPainelChamadasHabilitadoSuspenseQueryHookResult = ReturnType<typeof useIsPainelChamadasHabilitadoSuspenseQuery>;
export type IsPainelChamadasHabilitadoQueryResult = Apollo.QueryResult<Types.IsPainelChamadasHabilitadoQuery, Types.IsPainelChamadasHabilitadoQueryVariables>;
export const ParearDispositivoPainelDocument = gql`
    mutation ParearDispositivoPainel($input: ParearDispositivoPainelInput!) {
  parearDispositivoPainel(input: $input)
}
    `;
export type ParearDispositivoPainelMutationFn = Apollo.MutationFunction<Types.ParearDispositivoPainelMutation, Types.ParearDispositivoPainelMutationVariables>;

/**
 * __useParearDispositivoPainelMutation__
 *
 * To run a mutation, you first call `useParearDispositivoPainelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParearDispositivoPainelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parearDispositivoPainelMutation, { data, loading, error }] = useParearDispositivoPainelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useParearDispositivoPainelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ParearDispositivoPainelMutation, Types.ParearDispositivoPainelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ParearDispositivoPainelMutation, Types.ParearDispositivoPainelMutationVariables>(ParearDispositivoPainelDocument, options);
      }
export type ParearDispositivoPainelMutationHookResult = ReturnType<typeof useParearDispositivoPainelMutation>;
export type ParearDispositivoPainelMutationResult = Apollo.MutationResult<Types.ParearDispositivoPainelMutation>;
export type ParearDispositivoPainelMutationOptions = Apollo.BaseMutationOptions<Types.ParearDispositivoPainelMutation, Types.ParearDispositivoPainelMutationVariables>;
export const PermissaoPainelChamadasDocument = gql`
    query PermissaoPainelChamadas($unidadeSaudeId: ID!) {
  unidadeSaude(id: $unidadeSaudeId) {
    id
    actions {
      permissaoPainelChamadas {
        enabled
        hint
      }
    }
  }
}
    `;

/**
 * __usePermissaoPainelChamadasQuery__
 *
 * To run a query within a React component, call `usePermissaoPainelChamadasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissaoPainelChamadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissaoPainelChamadasQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function usePermissaoPainelChamadasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables> & ({ variables: Types.PermissaoPainelChamadasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>(PermissaoPainelChamadasDocument, options);
      }
export function usePermissaoPainelChamadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>(PermissaoPainelChamadasDocument, options);
        }
export function usePermissaoPainelChamadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>(PermissaoPainelChamadasDocument, options);
        }
export type PermissaoPainelChamadasQueryHookResult = ReturnType<typeof usePermissaoPainelChamadasQuery>;
export type PermissaoPainelChamadasLazyQueryHookResult = ReturnType<typeof usePermissaoPainelChamadasLazyQuery>;
export type PermissaoPainelChamadasSuspenseQueryHookResult = ReturnType<typeof usePermissaoPainelChamadasSuspenseQuery>;
export type PermissaoPainelChamadasQueryResult = Apollo.QueryResult<Types.PermissaoPainelChamadasQuery, Types.PermissaoPainelChamadasQueryVariables>;
export const RemoverDispositivoPainelDocument = gql`
    mutation RemoverDispositivoPainel($id: ID!) {
  removerDispositivoPainel(id: $id)
}
    `;
export type RemoverDispositivoPainelMutationFn = Apollo.MutationFunction<Types.RemoverDispositivoPainelMutation, Types.RemoverDispositivoPainelMutationVariables>;

/**
 * __useRemoverDispositivoPainelMutation__
 *
 * To run a mutation, you first call `useRemoverDispositivoPainelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverDispositivoPainelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerDispositivoPainelMutation, { data, loading, error }] = useRemoverDispositivoPainelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoverDispositivoPainelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverDispositivoPainelMutation, Types.RemoverDispositivoPainelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverDispositivoPainelMutation, Types.RemoverDispositivoPainelMutationVariables>(RemoverDispositivoPainelDocument, options);
      }
export type RemoverDispositivoPainelMutationHookResult = ReturnType<typeof useRemoverDispositivoPainelMutation>;
export type RemoverDispositivoPainelMutationResult = Apollo.MutationResult<Types.RemoverDispositivoPainelMutation>;
export type RemoverDispositivoPainelMutationOptions = Apollo.BaseMutationOptions<Types.RemoverDispositivoPainelMutation, Types.RemoverDispositivoPainelMutationVariables>;
export const RemoverSalaUnidadeSaudeDocument = gql`
    mutation RemoverSalaUnidadeSaude($id: ID!) {
  removerSalaUnidadeSaude(id: $id)
}
    `;
export type RemoverSalaUnidadeSaudeMutationFn = Apollo.MutationFunction<Types.RemoverSalaUnidadeSaudeMutation, Types.RemoverSalaUnidadeSaudeMutationVariables>;

/**
 * __useRemoverSalaUnidadeSaudeMutation__
 *
 * To run a mutation, you first call `useRemoverSalaUnidadeSaudeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverSalaUnidadeSaudeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerSalaUnidadeSaudeMutation, { data, loading, error }] = useRemoverSalaUnidadeSaudeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoverSalaUnidadeSaudeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverSalaUnidadeSaudeMutation, Types.RemoverSalaUnidadeSaudeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverSalaUnidadeSaudeMutation, Types.RemoverSalaUnidadeSaudeMutationVariables>(RemoverSalaUnidadeSaudeDocument, options);
      }
export type RemoverSalaUnidadeSaudeMutationHookResult = ReturnType<typeof useRemoverSalaUnidadeSaudeMutation>;
export type RemoverSalaUnidadeSaudeMutationResult = Apollo.MutationResult<Types.RemoverSalaUnidadeSaudeMutation>;
export type RemoverSalaUnidadeSaudeMutationOptions = Apollo.BaseMutationOptions<Types.RemoverSalaUnidadeSaudeMutation, Types.RemoverSalaUnidadeSaudeMutationVariables>;
export const SalasUnidadeSaudeDocument = gql`
    query SalasUnidadeSaude($unidadeSaudeId: ID!) {
  salasUnidadeSaude(unidadeSaudeId: $unidadeSaudeId) {
    id
    nome
  }
}
    `;

/**
 * __useSalasUnidadeSaudeQuery__
 *
 * To run a query within a React component, call `useSalasUnidadeSaudeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalasUnidadeSaudeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalasUnidadeSaudeQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useSalasUnidadeSaudeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables> & ({ variables: Types.SalasUnidadeSaudeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>(SalasUnidadeSaudeDocument, options);
      }
export function useSalasUnidadeSaudeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>(SalasUnidadeSaudeDocument, options);
        }
export function useSalasUnidadeSaudeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>(SalasUnidadeSaudeDocument, options);
        }
export type SalasUnidadeSaudeQueryHookResult = ReturnType<typeof useSalasUnidadeSaudeQuery>;
export type SalasUnidadeSaudeLazyQueryHookResult = ReturnType<typeof useSalasUnidadeSaudeLazyQuery>;
export type SalasUnidadeSaudeSuspenseQueryHookResult = ReturnType<typeof useSalasUnidadeSaudeSuspenseQuery>;
export type SalasUnidadeSaudeQueryResult = Apollo.QueryResult<Types.SalasUnidadeSaudeQuery, Types.SalasUnidadeSaudeQueryVariables>;
export const AtualizarContatoCidadaoDocument = gql`
    mutation AtualizarContatoCidadao($input: AtualizarContatoCidadaoInput!) {
  atualizarContatoCidadao(input: $input) {
    id
  }
}
    `;
export type AtualizarContatoCidadaoMutationFn = Apollo.MutationFunction<Types.AtualizarContatoCidadaoMutation, Types.AtualizarContatoCidadaoMutationVariables>;

/**
 * __useAtualizarContatoCidadaoMutation__
 *
 * To run a mutation, you first call `useAtualizarContatoCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarContatoCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarContatoCidadaoMutation, { data, loading, error }] = useAtualizarContatoCidadaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarContatoCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtualizarContatoCidadaoMutation, Types.AtualizarContatoCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtualizarContatoCidadaoMutation, Types.AtualizarContatoCidadaoMutationVariables>(AtualizarContatoCidadaoDocument, options);
      }
export type AtualizarContatoCidadaoMutationHookResult = ReturnType<typeof useAtualizarContatoCidadaoMutation>;
export type AtualizarContatoCidadaoMutationResult = Apollo.MutationResult<Types.AtualizarContatoCidadaoMutation>;
export type AtualizarContatoCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.AtualizarContatoCidadaoMutation, Types.AtualizarContatoCidadaoMutationVariables>;
export const BuscaCidadaoCadsusPollingDocument = gql`
    query BuscaCidadaoCadsusPolling($uuid: String!) {
  buscaCidadaosCadsusCompletoPolling(uuid: $uuid) {
    usuario
    uuid
    resultCadsus
    cidadaos {
      cpf
      cns
      nome
      nomeSocial
      nomeMae
      nomePai
      racaCor {
        id
        nome
        racaCorDbEnum
      }
      etnia {
        id
        nome
      }
      telefoneContato
      telefoneResidencial
      telefoneCelular
      dataNascimento
      dataObito
      obito
      sexo
      email
      nacionalidade {
        id
        nacionalidadeDbEnum
      }
      municipioNascimento {
        id
        ibge
        nome
        uf {
          id
          nome
          sigla
        }
      }
      paisNascimento {
        id
        nome
      }
      portariaNaturalizacao
      dataEntradaBrasil
      dataNaturalizacao
      endereco {
        bairro
        cep
        complemento
        logradouro
        municipio {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        numero
        pontoReferencia
        semNumero
        tipoLogradouro {
          id
          nome
          numeroDne
        }
        uf {
          id
          nome
          sigla
        }
      }
      paisResidencia {
        id
        nome
      }
      municipioResidenciaExterior
      numeroPisPasep
      cpfOuCnsJaCadastradoBaseLocal
    }
  }
}
    `;

/**
 * __useBuscaCidadaoCadsusPollingQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoCadsusPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCadsusPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCadsusPollingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useBuscaCidadaoCadsusPollingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables> & ({ variables: Types.BuscaCidadaoCadsusPollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>(BuscaCidadaoCadsusPollingDocument, options);
      }
export function useBuscaCidadaoCadsusPollingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>(BuscaCidadaoCadsusPollingDocument, options);
        }
export function useBuscaCidadaoCadsusPollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>(BuscaCidadaoCadsusPollingDocument, options);
        }
export type BuscaCidadaoCadsusPollingQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusPollingQuery>;
export type BuscaCidadaoCadsusPollingLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusPollingLazyQuery>;
export type BuscaCidadaoCadsusPollingSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusPollingSuspenseQuery>;
export type BuscaCidadaoCadsusPollingQueryResult = Apollo.QueryResult<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>;
export const BuscaCidadaoCadsusDocument = gql`
    query BuscaCidadaoCadsus($filter: BuscaListaCidadaoCadsusInput!) {
  buscaCidadaosCadsus(filtro: $filter)
}
    `;

/**
 * __useBuscaCidadaoCadsusQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCadsusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBuscaCidadaoCadsusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables> & ({ variables: Types.BuscaCidadaoCadsusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>(BuscaCidadaoCadsusDocument, options);
      }
export function useBuscaCidadaoCadsusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>(BuscaCidadaoCadsusDocument, options);
        }
export function useBuscaCidadaoCadsusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>(BuscaCidadaoCadsusDocument, options);
        }
export type BuscaCidadaoCadsusQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusQuery>;
export type BuscaCidadaoCadsusLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusLazyQuery>;
export type BuscaCidadaoCadsusSuspenseQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusSuspenseQuery>;
export type BuscaCidadaoCadsusQueryResult = Apollo.QueryResult<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>;
export const BuscaDetailCidadaoDocument = gql`
    query BuscaDetailCidadao($id: ID!) {
  cidadao(id: $id) {
    id
    cpf
    cns
    nisPisPasep
    nome
    nomeSocial
    dataNascimento
    dataAtualizado
    dataObito
    numeroDocumentoObito
    sexo
    nomeMae
    nomePai
    telefoneResidencial
    telefoneCelular
    telefoneContato
    email
    area
    microArea
    endereco {
      cep
      uf {
        id
        nome
      }
      municipio {
        id
        nome
      }
      bairro
      tipoLogradouro {
        id
        nome
      }
      logradouro
      numero
      semNumero
      complemento
      pontoReferencia
    }
    localidadeExterior
    prontuario {
      id
    }
    identidadeGeneroDbEnum
    etnia {
      id
      nome
    }
    racaCor {
      id
      nome
      racaCorDbEnum
    }
    area
    microArea
    cbo {
      id
      nome
    }
    escolaridade {
      id
      nome
    }
    ativo
    localidadeNascimento {
      id
      nome
      uf {
        id
        sigla
      }
    }
    faleceu
    possuiAgendamento
    prontuario {
      id
      gestacoes {
        id
        inicio
        fim
      }
      preNatalAtivo {
        id
        altoRisco
        fonteIdadeGestacional
        tipoGravidez {
          id
          descricao
        }
        gravidezPlanejada
        ultimaDum
      }
      puerpera
    }
    unificado
    unificacaoBase
    cidadaoVinculacaoEquipe {
      id
      tpCdsOrigem
      utilizarCadastroIndividual
      unidadeSaude {
        id
        nome
      }
      equipe {
        id
        nome
        ine
      }
    }
    tipoSanguineoEnum
    orientacaoSexualDbEnum
    estadoCivil {
      id
      nome
    }
    paisExterior {
      id
      nome
    }
    localidadeExterior
    nacionalidade {
      id
      nacionalidadeDbEnum
    }
    portariaNaturalizacao
    dataNaturalizacao
    paisNascimento {
      id
      nome
    }
    dataEntradaBrasil
    stCompartilhaProntuario
    periodoAusenciaList {
      id
      dtAusencia
      dtRetorno
    }
    cidadaoAldeado {
      id
      aldeiaNascimento {
        id
        nome
      }
      funcaoSocial {
        id
        nome
      }
      localOcorrencia {
        id
        nome
      }
      beneficios
      nomeTradicional
      responsavelLegal
      stChefeFamilia
      unidadeFunai
      livro
      folha
      cadastroUnico
      ufNascimento {
        id
        sigla
      }
      dtEmissao
      dtReconhecimento
    }
    enderecoIndigena {
      aldeiaResidencia {
        id
        nome
      }
      poloBaseResidencia {
        id
        nome
      }
      dseiResidencia {
        id
        nome
      }
      municipio {
        id
        nome
      }
      uf {
        id
        sigla
      }
      numero
    }
    numeroFamilia
    tipoEndereco
    tipoLocalNascimento
  }
}
    `;

/**
 * __useBuscaDetailCidadaoQuery__
 *
 * To run a query within a React component, call `useBuscaDetailCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaDetailCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaDetailCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuscaDetailCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables> & ({ variables: Types.BuscaDetailCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>(BuscaDetailCidadaoDocument, options);
      }
export function useBuscaDetailCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>(BuscaDetailCidadaoDocument, options);
        }
export function useBuscaDetailCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>(BuscaDetailCidadaoDocument, options);
        }
export type BuscaDetailCidadaoQueryHookResult = ReturnType<typeof useBuscaDetailCidadaoQuery>;
export type BuscaDetailCidadaoLazyQueryHookResult = ReturnType<typeof useBuscaDetailCidadaoLazyQuery>;
export type BuscaDetailCidadaoSuspenseQueryHookResult = ReturnType<typeof useBuscaDetailCidadaoSuspenseQuery>;
export type BuscaDetailCidadaoQueryResult = Apollo.QueryResult<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>;
export const CidadaoAtualizacaoDocument = gql`
    query CidadaoAtualizacao($id: ID!) {
  cidadao(id: $id) {
    id
    cpf
    cns
    stNaoPossuiCpf
    justificativaNaoPossuiCpf
    numeroDnv
    nisPisPasep
    nome
    nomeSocial
    dataNascimento
    sexo
    faleceu
    dataObito
    numeroDocumentoObito
    microArea
    statusForaArea
    cidadaoNucleoFamiliar {
      id
      mudouSe
      unidadeSaude {
        id
        nome
        cnes
        tipo {
          id
          isTipoAps
        }
        endereco {
          municipio {
            id
          }
        }
      }
      profissional {
        id
        nome
        nomeSocial
        cpf
        cns
      }
      equipe {
        id
        nome
        ine
        isAD
      }
      cbo {
        id
        nome
        cbo2002
        actions {
          cadastroDomiciliar {
            enabled
            hint
          }
          cadastroIndividual {
            enabled
            hint
          }
          atividadeColetiva {
            enabled
            hint
          }
        }
      }
      isResponsavel
      cpfCnsResponsavel
      responsavelFamiliar {
        id
        nome
        nomeSocial
        cpf
        cns
        uuidUltimaFicha
        statusResponsavelFamiliar
      }
      grauParentescoResponsavelFamiliar
    }
    escolaridade {
      id
      nome
    }
    estadoCivil {
      id
      nome
    }
    tipoSanguineoEnum
    racaCor {
      id
      nome
      racaCorDbEnum
    }
    etnia {
      id
      nome
    }
    nomeMae
    desconheceNomeMae
    nomePai
    desconheceNomePai
    desejaInformarIdentidadeGenero
    identidadeGeneroDbEnum
    desejaInformarOrientacaoSexual
    orientacaoSexualDbEnum
    nacionalidade {
      id
      nacionalidadeDbEnum
    }
    localidadeNascimento {
      id
      nome
      uf {
        id
        nome
        sigla
      }
      ibge
    }
    portariaNaturalizacao
    dataNaturalizacao
    paisNascimento {
      id
      nome
    }
    dataEntradaBrasil
    telefoneResidencial
    telefoneCelular
    telefoneContato
    email
    endereco {
      bairro
      cep
      complemento
      logradouro
      municipio {
        id
        nome
      }
      numero
      pontoReferencia
      semNumero
      tipoLogradouro {
        id
        nome
      }
      uf {
        id
        nome
        sigla
      }
    }
    paisExterior {
      id
      nome
    }
    localidadeExterior
    stCompartilhaProntuario
    informacoesSocioEconomicas {
      id
      statusAlimentosAcabaramAntesTerDinheiroComprarMais
      statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou
    }
    informacoesSociodemograficas {
      id
      frequentaEscolaOuCreche
      criancas0a9anosComQuemFica
      situacaoMercadoTrabalho
      possuiPlanoSaudePrivado
      frequentaCuidadorTradicional
      participaAlgumGrupoComunitario
      isMembroComunidadeTradicional
      povoComunidadeTradicional
      possuiDeficiencia
      deficiencias
      isAtendimentoSocioeducativo
      tipoAtendimentoSocioeducativo
      tempoAtendimentoSocioeducativo
    }
    cbo {
      id
      nome
      cbo2002
    }
    condicoesSaudeAutorreferidas {
      id
      stGestante
      maternidadeReferencia
      autodenominacaoPeso
      stAcamado
      stDomiciliar
      stFumante
      stUsoAlcool
      stUsoOutrasDrogas
      stPraticasComplementares
      stProblemaSaudeMental
      stHipertensaoArterial
      stDiabetes
      stCancer
      stDerrame
      stInfarto
      stHanseniase
      stTuberculose
      stDoencaCardiaca
      doencaCardiaca
      stProblemaRins
      doencaRins
      stDoencaRespiratoria
      doencasRespiratorias
      stInternacaoUltimos12Meses
      causaInternacaoUltimos12Meses
      stPlantasMedicinais
      plantasMedicinais
      condicaoSaude1
      condicaoSaude2
      condicaoSaude3
    }
    situacaoDeRua {
      id
      stSituacaoDeRua
      tempoSituacaoDeRua
      recebeAlgumBeneficio
      possuiReferenciaFamiliar
      quantidadeAlimentacaoDiaria
      origemAlimentacao
      stAcompanhadoOutraInstituicao
      instituicaoAcompanhamento
      stAcessoHigienePessoal
      higienePessoal
      stVisitaFamiliarComFrequencia
      grauParentescoVisitaFamiliar
    }
    tipoLocalNascimento
    cidadaoAldeado {
      id
      aldeiaNascimento {
        id
        nome
        poloBase {
          id
          nome
          dsei {
            id
            nome
          }
        }
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
      }
      funcaoSocial {
        id
        nome
      }
      localOcorrencia {
        id
        nome
      }
      nomeTradicional
      responsavelLegal
      stChefeFamilia
      dtReconhecimento
      unidadeFunai
      livro
      folha
      cadastroUnico
      dtEmissao
      ufNascimento {
        id
        nome
        sigla
      }
      beneficios
    }
    tipoEndereco
    enderecoIndigena {
      dseiResidencia {
        id
        nome
      }
      poloBaseResidencia {
        id
        nome
      }
      aldeiaResidencia {
        id
        nome
      }
      municipio {
        id
        nome
      }
      uf {
        id
        nome
        sigla
      }
      numero
    }
    numeroFamilia
    periodoAusenciaList {
      id
      dtAusencia
      dtRetorno
    }
    isCpfCadsus
    stRegistroCadsus
    documentosAssociados
  }
}
    `;

/**
 * __useCidadaoAtualizacaoQuery__
 *
 * To run a query within a React component, call `useCidadaoAtualizacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtualizacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtualizacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoAtualizacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables> & ({ variables: Types.CidadaoAtualizacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>(CidadaoAtualizacaoDocument, options);
      }
export function useCidadaoAtualizacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>(CidadaoAtualizacaoDocument, options);
        }
export function useCidadaoAtualizacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>(CidadaoAtualizacaoDocument, options);
        }
export type CidadaoAtualizacaoQueryHookResult = ReturnType<typeof useCidadaoAtualizacaoQuery>;
export type CidadaoAtualizacaoLazyQueryHookResult = ReturnType<typeof useCidadaoAtualizacaoLazyQuery>;
export type CidadaoAtualizacaoSuspenseQueryHookResult = ReturnType<typeof useCidadaoAtualizacaoSuspenseQuery>;
export type CidadaoAtualizacaoQueryResult = Apollo.QueryResult<Types.CidadaoAtualizacaoQuery, Types.CidadaoAtualizacaoQueryVariables>;
export const CidadaoBuscaCpfCnsDnvNisDocument = gql`
    query CidadaoBuscaCpfCnsDnvNis($filtro: FiltroDocumentosCidadaoInput!) {
  cidadaosByDocumentos(input: $filtro) {
    id
    nome
    nomeSocial
    cpf
    cns
    numeroDnv
    nisPisPasep
    sexo
    dataNascimento
    nomeMae
    localidadeNascimento {
      id
      nome
      uf {
        id
        sigla
      }
    }
    cidadaoVinculacaoEquipe {
      id
      unidadeSaude {
        id
        nome
      }
      equipe {
        id
        nome
        ine
      }
    }
    dataAtualizado
  }
}
    `;

/**
 * __useCidadaoBuscaCpfCnsDnvNisQuery__
 *
 * To run a query within a React component, call `useCidadaoBuscaCpfCnsDnvNisQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoBuscaCpfCnsDnvNisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoBuscaCpfCnsDnvNisQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useCidadaoBuscaCpfCnsDnvNisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables> & ({ variables: Types.CidadaoBuscaCpfCnsDnvNisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>(CidadaoBuscaCpfCnsDnvNisDocument, options);
      }
export function useCidadaoBuscaCpfCnsDnvNisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>(CidadaoBuscaCpfCnsDnvNisDocument, options);
        }
export function useCidadaoBuscaCpfCnsDnvNisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>(CidadaoBuscaCpfCnsDnvNisDocument, options);
        }
export type CidadaoBuscaCpfCnsDnvNisQueryHookResult = ReturnType<typeof useCidadaoBuscaCpfCnsDnvNisQuery>;
export type CidadaoBuscaCpfCnsDnvNisLazyQueryHookResult = ReturnType<typeof useCidadaoBuscaCpfCnsDnvNisLazyQuery>;
export type CidadaoBuscaCpfCnsDnvNisSuspenseQueryHookResult = ReturnType<typeof useCidadaoBuscaCpfCnsDnvNisSuspenseQuery>;
export type CidadaoBuscaCpfCnsDnvNisQueryResult = Apollo.QueryResult<Types.CidadaoBuscaCpfCnsDnvNisQuery, Types.CidadaoBuscaCpfCnsDnvNisQueryVariables>;
export const CidadaoEditDocument = gql`
    query CidadaoEdit($input: BuscaCidadaoCadsusInput!) {
  buscaCidadaoCadsusAtualizado(buscaCidadaoCadsusInput: $input)
}
    `;

/**
 * __useCidadaoEditQuery__
 *
 * To run a query within a React component, call `useCidadaoEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoEditQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables> & ({ variables: Types.CidadaoEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>(CidadaoEditDocument, options);
      }
export function useCidadaoEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>(CidadaoEditDocument, options);
        }
export function useCidadaoEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>(CidadaoEditDocument, options);
        }
export type CidadaoEditQueryHookResult = ReturnType<typeof useCidadaoEditQuery>;
export type CidadaoEditLazyQueryHookResult = ReturnType<typeof useCidadaoEditLazyQuery>;
export type CidadaoEditSuspenseQueryHookResult = ReturnType<typeof useCidadaoEditSuspenseQuery>;
export type CidadaoEditQueryResult = Apollo.QueryResult<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>;
export const CidadaoListingDocument = gql`
    query CidadaoListing($filtro: CidadaosQueryInput!) {
  cidadaos(input: $filtro) {
    content {
      id
      nome
      nomeSocial
      cpf
      cns
      nomeMae
      dataNascimento
      telefoneCelular
      telefoneResidencial
      sexo
      identidadeGeneroDbEnum
      dataAtualizado
      ativo
      unificado
      unificacaoBase
      prontuario {
        id
      }
      possuiAgendamento
      localidadeNascimento {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      faleceu
      cidadaoVinculacaoEquipe {
        id
        unidadeSaude {
          id
          nome
        }
      }
      enderecoIndigena {
        aldeiaResidencia {
          id
          nome
        }
        poloBaseResidencia {
          id
          nome
        }
        dseiResidencia {
          id
          nome
        }
      }
      cidadaoAldeado {
        id
        nomeTradicional
      }
    }
  }
}
    `;

/**
 * __useCidadaoListingQuery__
 *
 * To run a query within a React component, call `useCidadaoListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListingQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useCidadaoListingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables> & ({ variables: Types.CidadaoListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>(CidadaoListingDocument, options);
      }
export function useCidadaoListingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>(CidadaoListingDocument, options);
        }
export function useCidadaoListingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>(CidadaoListingDocument, options);
        }
export type CidadaoListingQueryHookResult = ReturnType<typeof useCidadaoListingQuery>;
export type CidadaoListingLazyQueryHookResult = ReturnType<typeof useCidadaoListingLazyQuery>;
export type CidadaoListingSuspenseQueryHookResult = ReturnType<typeof useCidadaoListingSuspenseQuery>;
export type CidadaoListingQueryResult = Apollo.QueryResult<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>;
export const CidadaoDocument = gql`
    query Cidadao($id: ID!) {
  cidadao(id: $id) {
    id
    nome
    nomeSocial
    cpf
    cns
    nomeMae
    dataNascimento
    sexo
    identidadeGeneroDbEnum
    faleceu
    isCidadaoAusente
  }
}
    `;

/**
 * __useCidadaoQuery__
 *
 * To run a query within a React component, call `useCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoQuery, Types.CidadaoQueryVariables> & ({ variables: Types.CidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoQuery, Types.CidadaoQueryVariables>(CidadaoDocument, options);
      }
export function useCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoQuery, Types.CidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoQuery, Types.CidadaoQueryVariables>(CidadaoDocument, options);
        }
export function useCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoQuery, Types.CidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoQuery, Types.CidadaoQueryVariables>(CidadaoDocument, options);
        }
export type CidadaoQueryHookResult = ReturnType<typeof useCidadaoQuery>;
export type CidadaoLazyQueryHookResult = ReturnType<typeof useCidadaoLazyQuery>;
export type CidadaoSuspenseQueryHookResult = ReturnType<typeof useCidadaoSuspenseQuery>;
export type CidadaoQueryResult = Apollo.QueryResult<Types.CidadaoQuery, Types.CidadaoQueryVariables>;
export const CidadaoVisualizacaoDocument = gql`
    query CidadaoVisualizacao($id: ID!) {
  cidadao(id: $id) {
    id
    cpf
    cns
    justificativaNaoPossuiCpf
    numeroDnv
    nome
    nomeSocial
    dataNascimento
    sexo
    microArea
    cidadaoNucleoFamiliar {
      id
      cpfCnsResponsavel
      mudouSe
      grauParentescoResponsavelFamiliar
      isResponsavel
      responsavelFamiliar {
        id
        nome
        nomeSocial
      }
      unidadeSaude {
        id
        nome
        cnes
        tipo {
          id
          isTipoAps
        }
      }
      profissional {
        id
        nome
        nomeSocial
      }
      equipe {
        id
        nome
        ine
      }
      cbo {
        id
        nome
        cbo2002
      }
    }
    racaCor {
      id
      nome
      racaCorDbEnum
    }
    etnia {
      id
      nome
    }
    nomeMae
    desconheceNomeMae
    nomePai
    desconheceNomePai
    nacionalidade {
      id
      nacionalidadeDbEnum
    }
    localidadeNascimento {
      id
      nome
      uf {
        id
        nome
        sigla
      }
    }
    portariaNaturalizacao
    dataNaturalizacao
    paisNascimento {
      id
      nome
    }
    dataEntradaBrasil
    escolaridade {
      id
      nome
    }
    cbo {
      id
      nome
      cbo2002
    }
    informacoesSociodemograficas {
      id
      frequentaEscolaOuCreche
      criancas0a9anosComQuemFica
      situacaoMercadoTrabalho
      possuiPlanoSaudePrivado
      frequentaCuidadorTradicional
      participaAlgumGrupoComunitario
      isMembroComunidadeTradicional
      povoComunidadeTradicional
      possuiDeficiencia
      deficiencias
      isAtendimentoSocioeducativo
      tipoAtendimentoSocioeducativo
      tempoAtendimentoSocioeducativo
    }
    informacoesSocioEconomicas {
      id
      statusAlimentosAcabaramAntesTerDinheiroComprarMais
      statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou
    }
    estadoCivil {
      id
      nome
    }
    condicoesSaudeAutorreferidas {
      id
      stGestante
      maternidadeReferencia
      autodenominacaoPeso
      stAcamado
      stDomiciliar
      stFumante
      stUsoAlcool
      stUsoOutrasDrogas
      stPraticasComplementares
      stProblemaSaudeMental
      stHipertensaoArterial
      stDiabetes
      stCancer
      stDerrame
      stInfarto
      stHanseniase
      stTuberculose
      stDoencaCardiaca
      doencaCardiaca
      stProblemaRins
      doencaRins
      stDoencaRespiratoria
      doencasRespiratorias
      stInternacaoUltimos12Meses
      causaInternacaoUltimos12Meses
      stPlantasMedicinais
      plantasMedicinais
      condicaoSaude1
      condicaoSaude2
      condicaoSaude3
    }
    situacaoDeRua {
      id
      stSituacaoDeRua
      tempoSituacaoDeRua
      recebeAlgumBeneficio
      possuiReferenciaFamiliar
      quantidadeAlimentacaoDiaria
      origemAlimentacao
      stAcompanhadoOutraInstituicao
      instituicaoAcompanhamento
      stAcessoHigienePessoal
      higienePessoal
      stVisitaFamiliarComFrequencia
      grauParentescoVisitaFamiliar
    }
    tipoSanguineoEnum
    identidadeGeneroDbEnum
    orientacaoSexualDbEnum
    nisPisPasep
    telefoneResidencial
    telefoneCelular
    telefoneContato
    email
    dataUltimaRecusa
    dataObito
    numeroDocumentoObito
    endereco {
      bairro
      cep
      complemento
      logradouro
      municipio {
        id
        nome
      }
      numero
      pontoReferencia
      semNumero
      tipoLogradouro {
        id
        nome
      }
      uf {
        id
        nome
      }
    }
    paisExterior {
      id
      nome
    }
    localidadeExterior
    stCompartilhaProntuario
    tipoLocalNascimento
    cidadaoAldeado {
      id
      aldeiaNascimento {
        id
        nome
        poloBase {
          id
          nome
        }
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
      }
      funcaoSocial {
        id
        nome
      }
      localOcorrencia {
        id
        nome
      }
      nomeTradicional
      responsavelLegal
      stChefeFamilia
      dtReconhecimento
      unidadeFunai
      livro
      folha
      cadastroUnico
      dtEmissao
      ufNascimento {
        id
        nome
        sigla
      }
      beneficios
    }
    tipoEndereco
    enderecoIndigena {
      dseiResidencia {
        id
        nome
      }
      poloBaseResidencia {
        id
        nome
      }
      aldeiaResidencia {
        id
        nome
      }
      municipio {
        id
        nome
      }
      uf {
        id
        nome
        sigla
      }
      numero
    }
    numeroFamilia
    periodoAusenciaList {
      id
      dtAusencia
      dtRetorno
    }
  }
}
    `;

/**
 * __useCidadaoVisualizacaoQuery__
 *
 * To run a query within a React component, call `useCidadaoVisualizacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoVisualizacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoVisualizacaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoVisualizacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables> & ({ variables: Types.CidadaoVisualizacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>(CidadaoVisualizacaoDocument, options);
      }
export function useCidadaoVisualizacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>(CidadaoVisualizacaoDocument, options);
        }
export function useCidadaoVisualizacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>(CidadaoVisualizacaoDocument, options);
        }
export type CidadaoVisualizacaoQueryHookResult = ReturnType<typeof useCidadaoVisualizacaoQuery>;
export type CidadaoVisualizacaoLazyQueryHookResult = ReturnType<typeof useCidadaoVisualizacaoLazyQuery>;
export type CidadaoVisualizacaoSuspenseQueryHookResult = ReturnType<typeof useCidadaoVisualizacaoSuspenseQuery>;
export type CidadaoVisualizacaoQueryResult = Apollo.QueryResult<Types.CidadaoVisualizacaoQuery, Types.CidadaoVisualizacaoQueryVariables>;
export const CondicoesAutorreferidasDocument = gql`
    query CondicoesAutorreferidas($cidadaoId: ID!) {
  condicoesAutorreferidas(cidadaoId: $cidadaoId) {
    descricao
  }
}
    `;

/**
 * __useCondicoesAutorreferidasQuery__
 *
 * To run a query within a React component, call `useCondicoesAutorreferidasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCondicoesAutorreferidasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCondicoesAutorreferidasQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useCondicoesAutorreferidasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables> & ({ variables: Types.CondicoesAutorreferidasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>(CondicoesAutorreferidasDocument, options);
      }
export function useCondicoesAutorreferidasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>(CondicoesAutorreferidasDocument, options);
        }
export function useCondicoesAutorreferidasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>(CondicoesAutorreferidasDocument, options);
        }
export type CondicoesAutorreferidasQueryHookResult = ReturnType<typeof useCondicoesAutorreferidasQuery>;
export type CondicoesAutorreferidasLazyQueryHookResult = ReturnType<typeof useCondicoesAutorreferidasLazyQuery>;
export type CondicoesAutorreferidasSuspenseQueryHookResult = ReturnType<typeof useCondicoesAutorreferidasSuspenseQuery>;
export type CondicoesAutorreferidasQueryResult = Apollo.QueryResult<Types.CondicoesAutorreferidasQuery, Types.CondicoesAutorreferidasQueryVariables>;
export const ConfiguracaoCadsusDocument = gql`
    query ConfiguracaoCadsus {
  conexao {
    internet {
      habilitado
    }
    cadsus {
      id
      habilitado
    }
  }
  configuracaoCertificadoHabilitado {
    id
    cadsusHabilitado
  }
}
    `;

/**
 * __useConfiguracaoCadsusQuery__
 *
 * To run a query within a React component, call `useConfiguracaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoCadsusQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoCadsusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>(ConfiguracaoCadsusDocument, options);
      }
export function useConfiguracaoCadsusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>(ConfiguracaoCadsusDocument, options);
        }
export function useConfiguracaoCadsusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>(ConfiguracaoCadsusDocument, options);
        }
export type ConfiguracaoCadsusQueryHookResult = ReturnType<typeof useConfiguracaoCadsusQuery>;
export type ConfiguracaoCadsusLazyQueryHookResult = ReturnType<typeof useConfiguracaoCadsusLazyQuery>;
export type ConfiguracaoCadsusSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoCadsusSuspenseQuery>;
export type ConfiguracaoCadsusQueryResult = Apollo.QueryResult<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>;
export const ConfiguracaoCertificadoDocument = gql`
    query ConfiguracaoCertificado {
  configuracaoCertificadoHabilitado {
    id
    cadsusHabilitado
  }
}
    `;

/**
 * __useConfiguracaoCertificadoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoCertificadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoCertificadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoCertificadoQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoCertificadoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>(ConfiguracaoCertificadoDocument, options);
      }
export function useConfiguracaoCertificadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>(ConfiguracaoCertificadoDocument, options);
        }
export function useConfiguracaoCertificadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>(ConfiguracaoCertificadoDocument, options);
        }
export type ConfiguracaoCertificadoQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoQuery>;
export type ConfiguracaoCertificadoLazyQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoLazyQuery>;
export type ConfiguracaoCertificadoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoSuspenseQuery>;
export type ConfiguracaoCertificadoQueryResult = Apollo.QueryResult<Types.ConfiguracaoCertificadoQuery, Types.ConfiguracaoCertificadoQueryVariables>;
export const CreateCidadaoCadsusDocument = gql`
    mutation CreateCidadaoCadsus($input: SincronizaCidadaoCadsusInput!) {
  createCidadaoCadsus(input: $input)
}
    `;
export type CreateCidadaoCadsusMutationFn = Apollo.MutationFunction<Types.CreateCidadaoCadsusMutation, Types.CreateCidadaoCadsusMutationVariables>;

/**
 * __useCreateCidadaoCadsusMutation__
 *
 * To run a mutation, you first call `useCreateCidadaoCadsusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCidadaoCadsusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCidadaoCadsusMutation, { data, loading, error }] = useCreateCidadaoCadsusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCidadaoCadsusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateCidadaoCadsusMutation, Types.CreateCidadaoCadsusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateCidadaoCadsusMutation, Types.CreateCidadaoCadsusMutationVariables>(CreateCidadaoCadsusDocument, options);
      }
export type CreateCidadaoCadsusMutationHookResult = ReturnType<typeof useCreateCidadaoCadsusMutation>;
export type CreateCidadaoCadsusMutationResult = Apollo.MutationResult<Types.CreateCidadaoCadsusMutation>;
export type CreateCidadaoCadsusMutationOptions = Apollo.BaseMutationOptions<Types.CreateCidadaoCadsusMutation, Types.CreateCidadaoCadsusMutationVariables>;
export const ExcluirCidadaoDocument = gql`
    mutation ExcluirCidadao($cidadaoId: ID!) {
  excluirCidadao(cidadaoId: $cidadaoId)
}
    `;
export type ExcluirCidadaoMutationFn = Apollo.MutationFunction<Types.ExcluirCidadaoMutation, Types.ExcluirCidadaoMutationVariables>;

/**
 * __useExcluirCidadaoMutation__
 *
 * To run a mutation, you first call `useExcluirCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirCidadaoMutation, { data, loading, error }] = useExcluirCidadaoMutation({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useExcluirCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirCidadaoMutation, Types.ExcluirCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirCidadaoMutation, Types.ExcluirCidadaoMutationVariables>(ExcluirCidadaoDocument, options);
      }
export type ExcluirCidadaoMutationHookResult = ReturnType<typeof useExcluirCidadaoMutation>;
export type ExcluirCidadaoMutationResult = Apollo.MutationResult<Types.ExcluirCidadaoMutation>;
export type ExcluirCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirCidadaoMutation, Types.ExcluirCidadaoMutationVariables>;
export const ForcaAtualizacaoCidadaoCadsusDocument = gql`
    query ForcaAtualizacaoCidadaoCadsus($input: BuscaCidadaoCadsusInput!) {
  buscaCidadaoCadsusAtualizadoForcado(buscaCidadaoCadsusInput: $input)
}
    `;

/**
 * __useForcaAtualizacaoCidadaoCadsusQuery__
 *
 * To run a query within a React component, call `useForcaAtualizacaoCidadaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useForcaAtualizacaoCidadaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForcaAtualizacaoCidadaoCadsusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForcaAtualizacaoCidadaoCadsusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables> & ({ variables: Types.ForcaAtualizacaoCidadaoCadsusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>(ForcaAtualizacaoCidadaoCadsusDocument, options);
      }
export function useForcaAtualizacaoCidadaoCadsusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>(ForcaAtualizacaoCidadaoCadsusDocument, options);
        }
export function useForcaAtualizacaoCidadaoCadsusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>(ForcaAtualizacaoCidadaoCadsusDocument, options);
        }
export type ForcaAtualizacaoCidadaoCadsusQueryHookResult = ReturnType<typeof useForcaAtualizacaoCidadaoCadsusQuery>;
export type ForcaAtualizacaoCidadaoCadsusLazyQueryHookResult = ReturnType<typeof useForcaAtualizacaoCidadaoCadsusLazyQuery>;
export type ForcaAtualizacaoCidadaoCadsusSuspenseQueryHookResult = ReturnType<typeof useForcaAtualizacaoCidadaoCadsusSuspenseQuery>;
export type ForcaAtualizacaoCidadaoCadsusQueryResult = Apollo.QueryResult<Types.ForcaAtualizacaoCidadaoCadsusQuery, Types.ForcaAtualizacaoCidadaoCadsusQueryVariables>;
export const HasCidadaoAgendamentoFuturoDocument = gql`
    query HasCidadaoAgendamentoFuturo($input: CidadaoPossuiAgendamentoFuturoQueryInput!) {
  hasAgendamentoFuturo(input: $input)
}
    `;

/**
 * __useHasCidadaoAgendamentoFuturoQuery__
 *
 * To run a query within a React component, call `useHasCidadaoAgendamentoFuturoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasCidadaoAgendamentoFuturoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasCidadaoAgendamentoFuturoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasCidadaoAgendamentoFuturoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables> & ({ variables: Types.HasCidadaoAgendamentoFuturoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>(HasCidadaoAgendamentoFuturoDocument, options);
      }
export function useHasCidadaoAgendamentoFuturoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>(HasCidadaoAgendamentoFuturoDocument, options);
        }
export function useHasCidadaoAgendamentoFuturoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>(HasCidadaoAgendamentoFuturoDocument, options);
        }
export type HasCidadaoAgendamentoFuturoQueryHookResult = ReturnType<typeof useHasCidadaoAgendamentoFuturoQuery>;
export type HasCidadaoAgendamentoFuturoLazyQueryHookResult = ReturnType<typeof useHasCidadaoAgendamentoFuturoLazyQuery>;
export type HasCidadaoAgendamentoFuturoSuspenseQueryHookResult = ReturnType<typeof useHasCidadaoAgendamentoFuturoSuspenseQuery>;
export type HasCidadaoAgendamentoFuturoQueryResult = Apollo.QueryResult<Types.HasCidadaoAgendamentoFuturoQuery, Types.HasCidadaoAgendamentoFuturoQueryVariables>;
export const IsCidadaoPresenteOutroAtendimentoNaListaDocument = gql`
    query IsCidadaoPresenteOutroAtendimentoNaLista($input: CidadaoPresenteOutroAtendimentoNaListaQueryInput!) {
  presenteOutroAtendimentoNaLista(input: $input)
}
    `;

/**
 * __useIsCidadaoPresenteOutroAtendimentoNaListaQuery__
 *
 * To run a query within a React component, call `useIsCidadaoPresenteOutroAtendimentoNaListaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCidadaoPresenteOutroAtendimentoNaListaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCidadaoPresenteOutroAtendimentoNaListaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsCidadaoPresenteOutroAtendimentoNaListaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables> & ({ variables: Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>(IsCidadaoPresenteOutroAtendimentoNaListaDocument, options);
      }
export function useIsCidadaoPresenteOutroAtendimentoNaListaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>(IsCidadaoPresenteOutroAtendimentoNaListaDocument, options);
        }
export function useIsCidadaoPresenteOutroAtendimentoNaListaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>(IsCidadaoPresenteOutroAtendimentoNaListaDocument, options);
        }
export type IsCidadaoPresenteOutroAtendimentoNaListaQueryHookResult = ReturnType<typeof useIsCidadaoPresenteOutroAtendimentoNaListaQuery>;
export type IsCidadaoPresenteOutroAtendimentoNaListaLazyQueryHookResult = ReturnType<typeof useIsCidadaoPresenteOutroAtendimentoNaListaLazyQuery>;
export type IsCidadaoPresenteOutroAtendimentoNaListaSuspenseQueryHookResult = ReturnType<typeof useIsCidadaoPresenteOutroAtendimentoNaListaSuspenseQuery>;
export type IsCidadaoPresenteOutroAtendimentoNaListaQueryResult = Apollo.QueryResult<Types.IsCidadaoPresenteOutroAtendimentoNaListaQuery, Types.IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables>;
export const ReativarCidadaoDocument = gql`
    mutation ReativarCidadao($cidadaoId: ID!) {
  reativarCidadao(cidadaoId: $cidadaoId) {
    id
  }
}
    `;
export type ReativarCidadaoMutationFn = Apollo.MutationFunction<Types.ReativarCidadaoMutation, Types.ReativarCidadaoMutationVariables>;

/**
 * __useReativarCidadaoMutation__
 *
 * To run a mutation, you first call `useReativarCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReativarCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reativarCidadaoMutation, { data, loading, error }] = useReativarCidadaoMutation({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useReativarCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ReativarCidadaoMutation, Types.ReativarCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ReativarCidadaoMutation, Types.ReativarCidadaoMutationVariables>(ReativarCidadaoDocument, options);
      }
export type ReativarCidadaoMutationHookResult = ReturnType<typeof useReativarCidadaoMutation>;
export type ReativarCidadaoMutationResult = Apollo.MutationResult<Types.ReativarCidadaoMutation>;
export type ReativarCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.ReativarCidadaoMutation, Types.ReativarCidadaoMutationVariables>;
export const RecusarCadastroCidadaoDocument = gql`
    mutation RecusarCadastroCidadao($cidadaoId: ID) {
  recusarCadastro(cidadaoId: $cidadaoId)
}
    `;
export type RecusarCadastroCidadaoMutationFn = Apollo.MutationFunction<Types.RecusarCadastroCidadaoMutation, Types.RecusarCadastroCidadaoMutationVariables>;

/**
 * __useRecusarCadastroCidadaoMutation__
 *
 * To run a mutation, you first call `useRecusarCadastroCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecusarCadastroCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recusarCadastroCidadaoMutation, { data, loading, error }] = useRecusarCadastroCidadaoMutation({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useRecusarCadastroCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RecusarCadastroCidadaoMutation, Types.RecusarCadastroCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RecusarCadastroCidadaoMutation, Types.RecusarCadastroCidadaoMutationVariables>(RecusarCadastroCidadaoDocument, options);
      }
export type RecusarCadastroCidadaoMutationHookResult = ReturnType<typeof useRecusarCadastroCidadaoMutation>;
export type RecusarCadastroCidadaoMutationResult = Apollo.MutationResult<Types.RecusarCadastroCidadaoMutation>;
export type RecusarCadastroCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.RecusarCadastroCidadaoMutation, Types.RecusarCadastroCidadaoMutationVariables>;
export const SalvarCidadaoDocument = gql`
    mutation SalvarCidadao($input: CidadaoInput!) {
  salvarCidadao(input: $input) {
    id
    cns
  }
}
    `;
export type SalvarCidadaoMutationFn = Apollo.MutationFunction<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>;

/**
 * __useSalvarCidadaoMutation__
 *
 * To run a mutation, you first call `useSalvarCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarCidadaoMutation, { data, loading, error }] = useSalvarCidadaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>(SalvarCidadaoDocument, options);
      }
export type SalvarCidadaoMutationHookResult = ReturnType<typeof useSalvarCidadaoMutation>;
export type SalvarCidadaoMutationResult = Apollo.MutationResult<Types.SalvarCidadaoMutation>;
export type SalvarCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>;
export const SincronizaCidadaoCadsusPollingDocument = gql`
    query SincronizaCidadaoCadsusPolling($uuid: String!) {
  sincronizacaoCadsusPolling(uuid: $uuid) {
    result
    errors
    uuid
    camposAlterados {
      campo
      conteudo
    }
    cidadaoCadsus {
      cns
      cpf
    }
    cidadaosDuplicados {
      id
      nome
      cpf
      cns
    }
    cidadaoLocal {
      id
      cpf
      cns
      nisPisPasep
      nome
      nomeSocial
      dataNascimento
      dataObito
      numeroDocumentoObito
      sexo
      desconheceNomeMae
      nomeMae
      desconheceNomePai
      nomePai
      telefoneResidencial
      telefoneCelular
      telefoneContato
      email
      area
      microArea
      statusForaArea
      endereco {
        bairro
        cep
        complemento
        logradouro
        numero
        pontoReferencia
        municipio {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        semNumero
        tipoLogradouro {
          id
          nome
          numeroDne
        }
        uf {
          id
          nome
          sigla
        }
      }
      etnia {
        id
        nome
      }
      racaCor {
        id
        nome
        racaCorDbEnum
      }
      cbo {
        id
        nome
        cbo2002
      }
      escolaridade {
        id
        nome
      }
      localidadeNascimento {
        uf {
          id
          nome
          sigla
        }
        id
        nome
      }
      faleceu
      tipoSanguineoEnum
      desejaInformarIdentidadeGenero
      identidadeGeneroDbEnum
      desejaInformarOrientacaoSexual
      orientacaoSexualDbEnum
      estadoCivil {
        id
        nome
      }
      paisExterior {
        id
        nome
      }
      localidadeExterior
      nacionalidade {
        id
        nacionalidadeDbEnum
      }
      portariaNaturalizacao
      dataNaturalizacao
      paisNascimento {
        id
        nome
      }
      dataEntradaBrasil
      stCompartilhaProntuario
      uuidUltimaFicha
      cidadaoVinculacaoEquipe {
        id
        utilizarCadastroIndividual
        unidadeSaude {
          id
          nome
          cnes
        }
        equipe {
          id
          nome
          ine
          tipoEquipe {
            id
            nome
            sigla
          }
        }
      }
      periodoAusenciaList {
        id
        dtAusencia
        dtRetorno
      }
      cidadaoAldeado {
        id
        aldeiaNascimento {
          id
          nome
        }
        funcaoSocial {
          id
          nome
        }
        localOcorrencia {
          id
          nome
        }
        nomeTradicional
        responsavelLegal
        stChefeFamilia
        beneficios
        unidadeFunai
        livro
        folha
        cadastroUnico
        ufNascimento {
          id
          nome
          sigla
        }
        dtEmissao
        dtReconhecimento
      }
      enderecoIndigena {
        aldeiaResidencia {
          id
          nome
          poloBase {
            ...PoloBase
          }
          municipio {
            ...Municipio
          }
        }
        poloBaseResidencia {
          ...PoloBase
        }
        dseiResidencia {
          id
          nome
        }
        municipio {
          ...Municipio
        }
        uf {
          id
          nome
          sigla
        }
        numero
      }
      numeroFamilia
      tipoEndereco
      tipoLocalNascimento
      stRegistroCadsus
      isCpfCadsus
    }
  }
}
    ${PoloBaseFragmentDoc}
${MunicipioFragmentDoc}`;

/**
 * __useSincronizaCidadaoCadsusPollingQuery__
 *
 * To run a query within a React component, call `useSincronizaCidadaoCadsusPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSincronizaCidadaoCadsusPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSincronizaCidadaoCadsusPollingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSincronizaCidadaoCadsusPollingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables> & ({ variables: Types.SincronizaCidadaoCadsusPollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>(SincronizaCidadaoCadsusPollingDocument, options);
      }
export function useSincronizaCidadaoCadsusPollingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>(SincronizaCidadaoCadsusPollingDocument, options);
        }
export function useSincronizaCidadaoCadsusPollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>(SincronizaCidadaoCadsusPollingDocument, options);
        }
export type SincronizaCidadaoCadsusPollingQueryHookResult = ReturnType<typeof useSincronizaCidadaoCadsusPollingQuery>;
export type SincronizaCidadaoCadsusPollingLazyQueryHookResult = ReturnType<typeof useSincronizaCidadaoCadsusPollingLazyQuery>;
export type SincronizaCidadaoCadsusPollingSuspenseQueryHookResult = ReturnType<typeof useSincronizaCidadaoCadsusPollingSuspenseQuery>;
export type SincronizaCidadaoCadsusPollingQueryResult = Apollo.QueryResult<Types.SincronizaCidadaoCadsusPollingQuery, Types.SincronizaCidadaoCadsusPollingQueryVariables>;
export const UnificacoesCidadaoDocument = gql`
    query UnificacoesCidadao($id: ID!) {
  unificacoesCidadao(cidadaoId: $id) {
    id
    nomeProfissional
    dataUnificacao
    cidadaos {
      id
      cpf
      cns
      nome
      nomeSocial
      dataNascimento
      identidadeGeneroDbEnum
      sexo
      nomeMae
      localidadeNascimento {
        id
        nome
        uf {
          id
          sigla
        }
      }
    }
  }
}
    `;

/**
 * __useUnificacoesCidadaoQuery__
 *
 * To run a query within a React component, call `useUnificacoesCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacoesCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacoesCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnificacoesCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables> & ({ variables: Types.UnificacoesCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>(UnificacoesCidadaoDocument, options);
      }
export function useUnificacoesCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>(UnificacoesCidadaoDocument, options);
        }
export function useUnificacoesCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>(UnificacoesCidadaoDocument, options);
        }
export type UnificacoesCidadaoQueryHookResult = ReturnType<typeof useUnificacoesCidadaoQuery>;
export type UnificacoesCidadaoLazyQueryHookResult = ReturnType<typeof useUnificacoesCidadaoLazyQuery>;
export type UnificacoesCidadaoSuspenseQueryHookResult = ReturnType<typeof useUnificacoesCidadaoSuspenseQuery>;
export type UnificacoesCidadaoQueryResult = Apollo.QueryResult<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>;
export const ImportacoesCnesDocument = gql`
    query ImportacoesCnes($input: ImportacoesCnesQueryInput!) {
  importacoesCnes(input: $input) {
    content {
      id
      dataImportacao
      equipesNovas
      equipesAtualizadas
      lotacoesNovas
      lotacoesAtualizadas
      processo {
        id
        status
      }
      profissional {
        id
        nome
        nomeSocial
      }
      profissionaisNovos
      profissionaisAtualizados
      unidadesSaudeNovas
      unidadesSaudeAtualizadas
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useImportacoesCnesQuery__
 *
 * To run a query within a React component, call `useImportacoesCnesQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportacoesCnesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportacoesCnesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportacoesCnesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables> & ({ variables: Types.ImportacoesCnesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>(ImportacoesCnesDocument, options);
      }
export function useImportacoesCnesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>(ImportacoesCnesDocument, options);
        }
export function useImportacoesCnesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>(ImportacoesCnesDocument, options);
        }
export type ImportacoesCnesQueryHookResult = ReturnType<typeof useImportacoesCnesQuery>;
export type ImportacoesCnesLazyQueryHookResult = ReturnType<typeof useImportacoesCnesLazyQuery>;
export type ImportacoesCnesSuspenseQueryHookResult = ReturnType<typeof useImportacoesCnesSuspenseQuery>;
export type ImportacoesCnesQueryResult = Apollo.QueryResult<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>;
export const DetalhesImportacaoCnesViewDocument = gql`
    query DetalhesImportacaoCnesView($id: ID!) {
  importacaoCnes(id: $id) {
    id
    dataImportacao
    detalhes
    equipesNovas
    equipesAtualizadas
    lotacoesNovas
    lotacoesAtualizadas
    profissionaisNovos
    profissionaisAtualizados
    unidadesSaudeNovas
    unidadesSaudeAtualizadas
    vinculacoesEquipesNovas
    vinculacoesEquipesAtualizadas
    municipio {
      id
      nome
    }
  }
}
    `;

/**
 * __useDetalhesImportacaoCnesViewQuery__
 *
 * To run a query within a React component, call `useDetalhesImportacaoCnesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetalhesImportacaoCnesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetalhesImportacaoCnesViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetalhesImportacaoCnesViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables> & ({ variables: Types.DetalhesImportacaoCnesViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>(DetalhesImportacaoCnesViewDocument, options);
      }
export function useDetalhesImportacaoCnesViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>(DetalhesImportacaoCnesViewDocument, options);
        }
export function useDetalhesImportacaoCnesViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>(DetalhesImportacaoCnesViewDocument, options);
        }
export type DetalhesImportacaoCnesViewQueryHookResult = ReturnType<typeof useDetalhesImportacaoCnesViewQuery>;
export type DetalhesImportacaoCnesViewLazyQueryHookResult = ReturnType<typeof useDetalhesImportacaoCnesViewLazyQuery>;
export type DetalhesImportacaoCnesViewSuspenseQueryHookResult = ReturnType<typeof useDetalhesImportacaoCnesViewSuspenseQuery>;
export type DetalhesImportacaoCnesViewQueryResult = Apollo.QueryResult<Types.DetalhesImportacaoCnesViewQuery, Types.DetalhesImportacaoCnesViewQueryVariables>;
export const AnexoArquivosDocument = gql`
    query AnexoArquivos {
  anexoArquivos {
    id
    habilitado
    diretorio
  }
}
    `;

/**
 * __useAnexoArquivosQuery__
 *
 * To run a query within a React component, call `useAnexoArquivosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnexoArquivosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnexoArquivosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnexoArquivosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>(AnexoArquivosDocument, options);
      }
export function useAnexoArquivosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>(AnexoArquivosDocument, options);
        }
export function useAnexoArquivosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>(AnexoArquivosDocument, options);
        }
export type AnexoArquivosQueryHookResult = ReturnType<typeof useAnexoArquivosQuery>;
export type AnexoArquivosLazyQueryHookResult = ReturnType<typeof useAnexoArquivosLazyQuery>;
export type AnexoArquivosSuspenseQueryHookResult = ReturnType<typeof useAnexoArquivosSuspenseQuery>;
export type AnexoArquivosQueryResult = Apollo.QueryResult<Types.AnexoArquivosQuery, Types.AnexoArquivosQueryVariables>;
export const IsAnexoArquivoEverEnabledDocument = gql`
    query IsAnexoArquivoEverEnabled {
  isAnexoArquivoEverEnabled
}
    `;

/**
 * __useIsAnexoArquivoEverEnabledQuery__
 *
 * To run a query within a React component, call `useIsAnexoArquivoEverEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAnexoArquivoEverEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAnexoArquivoEverEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsAnexoArquivoEverEnabledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>(IsAnexoArquivoEverEnabledDocument, options);
      }
export function useIsAnexoArquivoEverEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>(IsAnexoArquivoEverEnabledDocument, options);
        }
export function useIsAnexoArquivoEverEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>(IsAnexoArquivoEverEnabledDocument, options);
        }
export type IsAnexoArquivoEverEnabledQueryHookResult = ReturnType<typeof useIsAnexoArquivoEverEnabledQuery>;
export type IsAnexoArquivoEverEnabledLazyQueryHookResult = ReturnType<typeof useIsAnexoArquivoEverEnabledLazyQuery>;
export type IsAnexoArquivoEverEnabledSuspenseQueryHookResult = ReturnType<typeof useIsAnexoArquivoEverEnabledSuspenseQuery>;
export type IsAnexoArquivoEverEnabledQueryResult = Apollo.QueryResult<Types.IsAnexoArquivoEverEnabledQuery, Types.IsAnexoArquivoEverEnabledQueryVariables>;
export const IsDiretorioAnexoArquivosValidoDocument = gql`
    query IsDiretorioAnexoArquivosValido($diretorio: String!) {
  isDiretorioAnexoArquivosValido(diretorio: $diretorio)
}
    `;

/**
 * __useIsDiretorioAnexoArquivosValidoQuery__
 *
 * To run a query within a React component, call `useIsDiretorioAnexoArquivosValidoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDiretorioAnexoArquivosValidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDiretorioAnexoArquivosValidoQuery({
 *   variables: {
 *      diretorio: // value for 'diretorio'
 *   },
 * });
 */
export function useIsDiretorioAnexoArquivosValidoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables> & ({ variables: Types.IsDiretorioAnexoArquivosValidoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>(IsDiretorioAnexoArquivosValidoDocument, options);
      }
export function useIsDiretorioAnexoArquivosValidoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>(IsDiretorioAnexoArquivosValidoDocument, options);
        }
export function useIsDiretorioAnexoArquivosValidoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>(IsDiretorioAnexoArquivosValidoDocument, options);
        }
export type IsDiretorioAnexoArquivosValidoQueryHookResult = ReturnType<typeof useIsDiretorioAnexoArquivosValidoQuery>;
export type IsDiretorioAnexoArquivosValidoLazyQueryHookResult = ReturnType<typeof useIsDiretorioAnexoArquivosValidoLazyQuery>;
export type IsDiretorioAnexoArquivosValidoSuspenseQueryHookResult = ReturnType<typeof useIsDiretorioAnexoArquivosValidoSuspenseQuery>;
export type IsDiretorioAnexoArquivosValidoQueryResult = Apollo.QueryResult<Types.IsDiretorioAnexoArquivosValidoQuery, Types.IsDiretorioAnexoArquivosValidoQueryVariables>;
export const AlterarConfiguracaoAnexoArquivosDocument = gql`
    mutation AlterarConfiguracaoAnexoArquivos($input: AlterarConfiguracaoAnexoArquivosInput!) {
  alterarConfiguracaoAnexoArquivos(input: $input) {
    id
    habilitado
    diretorio
  }
}
    `;
export type AlterarConfiguracaoAnexoArquivosMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoAnexoArquivosMutation, Types.AlterarConfiguracaoAnexoArquivosMutationVariables>;

/**
 * __useAlterarConfiguracaoAnexoArquivosMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoAnexoArquivosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoAnexoArquivosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoAnexoArquivosMutation, { data, loading, error }] = useAlterarConfiguracaoAnexoArquivosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarConfiguracaoAnexoArquivosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoAnexoArquivosMutation, Types.AlterarConfiguracaoAnexoArquivosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoAnexoArquivosMutation, Types.AlterarConfiguracaoAnexoArquivosMutationVariables>(AlterarConfiguracaoAnexoArquivosDocument, options);
      }
export type AlterarConfiguracaoAnexoArquivosMutationHookResult = ReturnType<typeof useAlterarConfiguracaoAnexoArquivosMutation>;
export type AlterarConfiguracaoAnexoArquivosMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoAnexoArquivosMutation>;
export type AlterarConfiguracaoAnexoArquivosMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoAnexoArquivosMutation, Types.AlterarConfiguracaoAnexoArquivosMutationVariables>;
export const ConfiguracoesAvancadasDocument = gql`
    query ConfiguracoesAvancadas {
  avancada {
    performance {
      qtdRequisicoesSimultaneas
      buscaCidadaoPorPropriedades {
        id
        habilitado
      }
    }
    cadastroDomiciliarViaCds {
      id
      habilitado
    }
    cadastroIndividualViaCds {
      id
      habilitado
    }
  }
}
    `;

/**
 * __useConfiguracoesAvancadasQuery__
 *
 * To run a query within a React component, call `useConfiguracoesAvancadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracoesAvancadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracoesAvancadasQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracoesAvancadasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>(ConfiguracoesAvancadasDocument, options);
      }
export function useConfiguracoesAvancadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>(ConfiguracoesAvancadasDocument, options);
        }
export function useConfiguracoesAvancadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>(ConfiguracoesAvancadasDocument, options);
        }
export type ConfiguracoesAvancadasQueryHookResult = ReturnType<typeof useConfiguracoesAvancadasQuery>;
export type ConfiguracoesAvancadasLazyQueryHookResult = ReturnType<typeof useConfiguracoesAvancadasLazyQuery>;
export type ConfiguracoesAvancadasSuspenseQueryHookResult = ReturnType<typeof useConfiguracoesAvancadasSuspenseQuery>;
export type ConfiguracoesAvancadasQueryResult = Apollo.QueryResult<Types.ConfiguracoesAvancadasQuery, Types.ConfiguracoesAvancadasQueryVariables>;
export const AlterarBuscaCidadaoPorPropriedadesDocument = gql`
    mutation AlterarBuscaCidadaoPorPropriedades($input: Boolean!) {
  alterarBuscaCidadaoPorPropriedades(habilitado: $input) {
    id
    habilitado
  }
}
    `;
export type AlterarBuscaCidadaoPorPropriedadesMutationFn = Apollo.MutationFunction<Types.AlterarBuscaCidadaoPorPropriedadesMutation, Types.AlterarBuscaCidadaoPorPropriedadesMutationVariables>;

/**
 * __useAlterarBuscaCidadaoPorPropriedadesMutation__
 *
 * To run a mutation, you first call `useAlterarBuscaCidadaoPorPropriedadesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarBuscaCidadaoPorPropriedadesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarBuscaCidadaoPorPropriedadesMutation, { data, loading, error }] = useAlterarBuscaCidadaoPorPropriedadesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarBuscaCidadaoPorPropriedadesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarBuscaCidadaoPorPropriedadesMutation, Types.AlterarBuscaCidadaoPorPropriedadesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarBuscaCidadaoPorPropriedadesMutation, Types.AlterarBuscaCidadaoPorPropriedadesMutationVariables>(AlterarBuscaCidadaoPorPropriedadesDocument, options);
      }
export type AlterarBuscaCidadaoPorPropriedadesMutationHookResult = ReturnType<typeof useAlterarBuscaCidadaoPorPropriedadesMutation>;
export type AlterarBuscaCidadaoPorPropriedadesMutationResult = Apollo.MutationResult<Types.AlterarBuscaCidadaoPorPropriedadesMutation>;
export type AlterarBuscaCidadaoPorPropriedadesMutationOptions = Apollo.BaseMutationOptions<Types.AlterarBuscaCidadaoPorPropriedadesMutation, Types.AlterarBuscaCidadaoPorPropriedadesMutationVariables>;
export const AlterarQtdRequisicoesDocument = gql`
    mutation AlterarQtdRequisicoes($qtdRequisicoesSimultaneas: Int) {
  alterarQtdRequisicoes(qtdRequisicoesSimultaneas: $qtdRequisicoesSimultaneas) {
    qtdRequisicoesSimultaneas
  }
}
    `;
export type AlterarQtdRequisicoesMutationFn = Apollo.MutationFunction<Types.AlterarQtdRequisicoesMutation, Types.AlterarQtdRequisicoesMutationVariables>;

/**
 * __useAlterarQtdRequisicoesMutation__
 *
 * To run a mutation, you first call `useAlterarQtdRequisicoesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarQtdRequisicoesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarQtdRequisicoesMutation, { data, loading, error }] = useAlterarQtdRequisicoesMutation({
 *   variables: {
 *      qtdRequisicoesSimultaneas: // value for 'qtdRequisicoesSimultaneas'
 *   },
 * });
 */
export function useAlterarQtdRequisicoesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarQtdRequisicoesMutation, Types.AlterarQtdRequisicoesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarQtdRequisicoesMutation, Types.AlterarQtdRequisicoesMutationVariables>(AlterarQtdRequisicoesDocument, options);
      }
export type AlterarQtdRequisicoesMutationHookResult = ReturnType<typeof useAlterarQtdRequisicoesMutation>;
export type AlterarQtdRequisicoesMutationResult = Apollo.MutationResult<Types.AlterarQtdRequisicoesMutation>;
export type AlterarQtdRequisicoesMutationOptions = Apollo.BaseMutationOptions<Types.AlterarQtdRequisicoesMutation, Types.AlterarQtdRequisicoesMutationVariables>;
export const ConexaoDocument = gql`
    query Conexao($assinaturaEletronicaEnabled: Boolean! = false, $podeConfigurarPrescricaoDigital: Boolean! = false) {
  conexao {
    internet {
      habilitado
      dataUltimoTeste
      resultadoUltimoTeste
    }
    cadsus {
      id
      habilitado
      desabilitadoAteData
      intervalo
    }
    horus {
      id
      habilitado
      desabilitadoAteData
      intervalo
    }
    videochamadas {
      id
      habilitado
    }
    agendaOnline {
      ativa
      detalhesAtivacao {
        profissional {
          id
          nome
        }
        dataEvento
      }
      testeConexao {
        sucesso
        dataEvento
      }
    }
    assinaturaDigital @include(if: $podeConfigurarPrescricaoDigital) {
      id
      habilitado
      usuario
      senha
      documentosEnvioCidadao {
        id
        habilitado
      }
      assinaturaRegistros @include(if: $assinaturaEletronicaEnabled) {
        id
        habilitado
      }
      documentosRnds {
        id
        habilitado
      }
    }
  }
}
    `;

/**
 * __useConexaoQuery__
 *
 * To run a query within a React component, call `useConexaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConexaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConexaoQuery({
 *   variables: {
 *      assinaturaEletronicaEnabled: // value for 'assinaturaEletronicaEnabled'
 *      podeConfigurarPrescricaoDigital: // value for 'podeConfigurarPrescricaoDigital'
 *   },
 * });
 */
export function useConexaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConexaoQuery, Types.ConexaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConexaoQuery, Types.ConexaoQueryVariables>(ConexaoDocument, options);
      }
export function useConexaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConexaoQuery, Types.ConexaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConexaoQuery, Types.ConexaoQueryVariables>(ConexaoDocument, options);
        }
export function useConexaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConexaoQuery, Types.ConexaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConexaoQuery, Types.ConexaoQueryVariables>(ConexaoDocument, options);
        }
export type ConexaoQueryHookResult = ReturnType<typeof useConexaoQuery>;
export type ConexaoLazyQueryHookResult = ReturnType<typeof useConexaoLazyQuery>;
export type ConexaoSuspenseQueryHookResult = ReturnType<typeof useConexaoSuspenseQuery>;
export type ConexaoQueryResult = Apollo.QueryResult<Types.ConexaoQuery, Types.ConexaoQueryVariables>;
export const AlternarConexaoInternetDocument = gql`
    mutation AlternarConexaoInternet($habilitado: Boolean) {
  alternarInternet(habilitado: $habilitado) {
    habilitado
  }
}
    `;
export type AlternarConexaoInternetMutationFn = Apollo.MutationFunction<Types.AlternarConexaoInternetMutation, Types.AlternarConexaoInternetMutationVariables>;

/**
 * __useAlternarConexaoInternetMutation__
 *
 * To run a mutation, you first call `useAlternarConexaoInternetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlternarConexaoInternetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alternarConexaoInternetMutation, { data, loading, error }] = useAlternarConexaoInternetMutation({
 *   variables: {
 *      habilitado: // value for 'habilitado'
 *   },
 * });
 */
export function useAlternarConexaoInternetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlternarConexaoInternetMutation, Types.AlternarConexaoInternetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlternarConexaoInternetMutation, Types.AlternarConexaoInternetMutationVariables>(AlternarConexaoInternetDocument, options);
      }
export type AlternarConexaoInternetMutationHookResult = ReturnType<typeof useAlternarConexaoInternetMutation>;
export type AlternarConexaoInternetMutationResult = Apollo.MutationResult<Types.AlternarConexaoInternetMutation>;
export type AlternarConexaoInternetMutationOptions = Apollo.BaseMutationOptions<Types.AlternarConexaoInternetMutation, Types.AlternarConexaoInternetMutationVariables>;
export const TestarConexaoInternetDocument = gql`
    mutation TestarConexaoInternet {
  testarConexaoInternet {
    habilitado
    dataUltimoTeste
    resultadoUltimoTeste
  }
}
    `;
export type TestarConexaoInternetMutationFn = Apollo.MutationFunction<Types.TestarConexaoInternetMutation, Types.TestarConexaoInternetMutationVariables>;

/**
 * __useTestarConexaoInternetMutation__
 *
 * To run a mutation, you first call `useTestarConexaoInternetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoInternetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoInternetMutation, { data, loading, error }] = useTestarConexaoInternetMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestarConexaoInternetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TestarConexaoInternetMutation, Types.TestarConexaoInternetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TestarConexaoInternetMutation, Types.TestarConexaoInternetMutationVariables>(TestarConexaoInternetDocument, options);
      }
export type TestarConexaoInternetMutationHookResult = ReturnType<typeof useTestarConexaoInternetMutation>;
export type TestarConexaoInternetMutationResult = Apollo.MutationResult<Types.TestarConexaoInternetMutation>;
export type TestarConexaoInternetMutationOptions = Apollo.BaseMutationOptions<Types.TestarConexaoInternetMutation, Types.TestarConexaoInternetMutationVariables>;
export const GerarChaveAtivacaoAgendaOnlineDocument = gql`
    mutation GerarChaveAtivacaoAgendaOnline {
  gerarChaveAtivacaoAgendaOnline
}
    `;
export type GerarChaveAtivacaoAgendaOnlineMutationFn = Apollo.MutationFunction<Types.GerarChaveAtivacaoAgendaOnlineMutation, Types.GerarChaveAtivacaoAgendaOnlineMutationVariables>;

/**
 * __useGerarChaveAtivacaoAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useGerarChaveAtivacaoAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarChaveAtivacaoAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarChaveAtivacaoAgendaOnlineMutation, { data, loading, error }] = useGerarChaveAtivacaoAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useGerarChaveAtivacaoAgendaOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GerarChaveAtivacaoAgendaOnlineMutation, Types.GerarChaveAtivacaoAgendaOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GerarChaveAtivacaoAgendaOnlineMutation, Types.GerarChaveAtivacaoAgendaOnlineMutationVariables>(GerarChaveAtivacaoAgendaOnlineDocument, options);
      }
export type GerarChaveAtivacaoAgendaOnlineMutationHookResult = ReturnType<typeof useGerarChaveAtivacaoAgendaOnlineMutation>;
export type GerarChaveAtivacaoAgendaOnlineMutationResult = Apollo.MutationResult<Types.GerarChaveAtivacaoAgendaOnlineMutation>;
export type GerarChaveAtivacaoAgendaOnlineMutationOptions = Apollo.BaseMutationOptions<Types.GerarChaveAtivacaoAgendaOnlineMutation, Types.GerarChaveAtivacaoAgendaOnlineMutationVariables>;
export const AtivarAgendaOnlineDocument = gql`
    mutation AtivarAgendaOnline($ativacaoAgendaOnlineInput: AtivacaoAgendaOnlineInput!) {
  ativarAgendaOnline(ativacaoAgendaOnlineInput: $ativacaoAgendaOnlineInput) {
    ativa
    detalhesAtivacao {
      profissional {
        id
        nome
      }
      dataEvento
    }
  }
}
    `;
export type AtivarAgendaOnlineMutationFn = Apollo.MutationFunction<Types.AtivarAgendaOnlineMutation, Types.AtivarAgendaOnlineMutationVariables>;

/**
 * __useAtivarAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useAtivarAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarAgendaOnlineMutation, { data, loading, error }] = useAtivarAgendaOnlineMutation({
 *   variables: {
 *      ativacaoAgendaOnlineInput: // value for 'ativacaoAgendaOnlineInput'
 *   },
 * });
 */
export function useAtivarAgendaOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtivarAgendaOnlineMutation, Types.AtivarAgendaOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtivarAgendaOnlineMutation, Types.AtivarAgendaOnlineMutationVariables>(AtivarAgendaOnlineDocument, options);
      }
export type AtivarAgendaOnlineMutationHookResult = ReturnType<typeof useAtivarAgendaOnlineMutation>;
export type AtivarAgendaOnlineMutationResult = Apollo.MutationResult<Types.AtivarAgendaOnlineMutation>;
export type AtivarAgendaOnlineMutationOptions = Apollo.BaseMutationOptions<Types.AtivarAgendaOnlineMutation, Types.AtivarAgendaOnlineMutationVariables>;
export const TestarConexaoAgendaOnlineDocument = gql`
    mutation TestarConexaoAgendaOnline {
  testarConexaoAgendaOnline {
    sucesso
    dataEvento
  }
}
    `;
export type TestarConexaoAgendaOnlineMutationFn = Apollo.MutationFunction<Types.TestarConexaoAgendaOnlineMutation, Types.TestarConexaoAgendaOnlineMutationVariables>;

/**
 * __useTestarConexaoAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useTestarConexaoAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoAgendaOnlineMutation, { data, loading, error }] = useTestarConexaoAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestarConexaoAgendaOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TestarConexaoAgendaOnlineMutation, Types.TestarConexaoAgendaOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TestarConexaoAgendaOnlineMutation, Types.TestarConexaoAgendaOnlineMutationVariables>(TestarConexaoAgendaOnlineDocument, options);
      }
export type TestarConexaoAgendaOnlineMutationHookResult = ReturnType<typeof useTestarConexaoAgendaOnlineMutation>;
export type TestarConexaoAgendaOnlineMutationResult = Apollo.MutationResult<Types.TestarConexaoAgendaOnlineMutation>;
export type TestarConexaoAgendaOnlineMutationOptions = Apollo.BaseMutationOptions<Types.TestarConexaoAgendaOnlineMutation, Types.TestarConexaoAgendaOnlineMutationVariables>;
export const CfgLotacaoAgendaOnlineDocument = gql`
    query CfgLotacaoAgendaOnline {
  conexao {
    agendaOnline {
      ativa
    }
    hasLotacoesConfiguradasOnline
    lotacoesAgendaOnlineComDuracaoPadrao
  }
}
    `;

/**
 * __useCfgLotacaoAgendaOnlineQuery__
 *
 * To run a query within a React component, call `useCfgLotacaoAgendaOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCfgLotacaoAgendaOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCfgLotacaoAgendaOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useCfgLotacaoAgendaOnlineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>(CfgLotacaoAgendaOnlineDocument, options);
      }
export function useCfgLotacaoAgendaOnlineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>(CfgLotacaoAgendaOnlineDocument, options);
        }
export function useCfgLotacaoAgendaOnlineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>(CfgLotacaoAgendaOnlineDocument, options);
        }
export type CfgLotacaoAgendaOnlineQueryHookResult = ReturnType<typeof useCfgLotacaoAgendaOnlineQuery>;
export type CfgLotacaoAgendaOnlineLazyQueryHookResult = ReturnType<typeof useCfgLotacaoAgendaOnlineLazyQuery>;
export type CfgLotacaoAgendaOnlineSuspenseQueryHookResult = ReturnType<typeof useCfgLotacaoAgendaOnlineSuspenseQuery>;
export type CfgLotacaoAgendaOnlineQueryResult = Apollo.QueryResult<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>;
export const DesativarAgendaOnlineDocument = gql`
    mutation DesativarAgendaOnline {
  desativarAgendaOnline {
    ativa
    detalhesAtivacao {
      profissional {
        id
        nome
      }
      dataEvento
    }
  }
}
    `;
export type DesativarAgendaOnlineMutationFn = Apollo.MutationFunction<Types.DesativarAgendaOnlineMutation, Types.DesativarAgendaOnlineMutationVariables>;

/**
 * __useDesativarAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useDesativarAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarAgendaOnlineMutation, { data, loading, error }] = useDesativarAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useDesativarAgendaOnlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DesativarAgendaOnlineMutation, Types.DesativarAgendaOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DesativarAgendaOnlineMutation, Types.DesativarAgendaOnlineMutationVariables>(DesativarAgendaOnlineDocument, options);
      }
export type DesativarAgendaOnlineMutationHookResult = ReturnType<typeof useDesativarAgendaOnlineMutation>;
export type DesativarAgendaOnlineMutationResult = Apollo.MutationResult<Types.DesativarAgendaOnlineMutation>;
export type DesativarAgendaOnlineMutationOptions = Apollo.BaseMutationOptions<Types.DesativarAgendaOnlineMutation, Types.DesativarAgendaOnlineMutationVariables>;
export const UnificacaoBaseAtivaDocument = gql`
    query unificacaoBaseAtiva {
  pedidoEnvioBaseAtivo {
    id
  }
  unificacoesBase {
    id
    status
  }
}
    `;

/**
 * __useUnificacaoBaseAtivaQuery__
 *
 * To run a query within a React component, call `useUnificacaoBaseAtivaQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacaoBaseAtivaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacaoBaseAtivaQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnificacaoBaseAtivaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>(UnificacaoBaseAtivaDocument, options);
      }
export function useUnificacaoBaseAtivaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>(UnificacaoBaseAtivaDocument, options);
        }
export function useUnificacaoBaseAtivaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>(UnificacaoBaseAtivaDocument, options);
        }
export type UnificacaoBaseAtivaQueryHookResult = ReturnType<typeof useUnificacaoBaseAtivaQuery>;
export type UnificacaoBaseAtivaLazyQueryHookResult = ReturnType<typeof useUnificacaoBaseAtivaLazyQuery>;
export type UnificacaoBaseAtivaSuspenseQueryHookResult = ReturnType<typeof useUnificacaoBaseAtivaSuspenseQuery>;
export type UnificacaoBaseAtivaQueryResult = Apollo.QueryResult<Types.UnificacaoBaseAtivaQuery, Types.UnificacaoBaseAtivaQueryVariables>;
export const AlterarConfiguracaoAssinaturaDigitalDocument = gql`
    mutation AlterarConfiguracaoAssinaturaDigital($input: AlterarConfiguracaoAssinaturaDigitalInput!) {
  alterarConfiguracaoAssinaturaDigital(input: $input) {
    id
    habilitado
    usuario
    senha
  }
}
    `;
export type AlterarConfiguracaoAssinaturaDigitalMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoAssinaturaDigitalMutation, Types.AlterarConfiguracaoAssinaturaDigitalMutationVariables>;

/**
 * __useAlterarConfiguracaoAssinaturaDigitalMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoAssinaturaDigitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoAssinaturaDigitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoAssinaturaDigitalMutation, { data, loading, error }] = useAlterarConfiguracaoAssinaturaDigitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarConfiguracaoAssinaturaDigitalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoAssinaturaDigitalMutation, Types.AlterarConfiguracaoAssinaturaDigitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoAssinaturaDigitalMutation, Types.AlterarConfiguracaoAssinaturaDigitalMutationVariables>(AlterarConfiguracaoAssinaturaDigitalDocument, options);
      }
export type AlterarConfiguracaoAssinaturaDigitalMutationHookResult = ReturnType<typeof useAlterarConfiguracaoAssinaturaDigitalMutation>;
export type AlterarConfiguracaoAssinaturaDigitalMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoAssinaturaDigitalMutation>;
export type AlterarConfiguracaoAssinaturaDigitalMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoAssinaturaDigitalMutation, Types.AlterarConfiguracaoAssinaturaDigitalMutationVariables>;
export const AlterarConfiguracaoAssinaturaRegistrosDocument = gql`
    mutation AlterarConfiguracaoAssinaturaRegistros($habilitado: Boolean!) {
  alterarConfiguracaoAssinaturaRegistros(habilitado: $habilitado) {
    id
    habilitado
  }
}
    `;
export type AlterarConfiguracaoAssinaturaRegistrosMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoAssinaturaRegistrosMutation, Types.AlterarConfiguracaoAssinaturaRegistrosMutationVariables>;

/**
 * __useAlterarConfiguracaoAssinaturaRegistrosMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoAssinaturaRegistrosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoAssinaturaRegistrosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoAssinaturaRegistrosMutation, { data, loading, error }] = useAlterarConfiguracaoAssinaturaRegistrosMutation({
 *   variables: {
 *      habilitado: // value for 'habilitado'
 *   },
 * });
 */
export function useAlterarConfiguracaoAssinaturaRegistrosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoAssinaturaRegistrosMutation, Types.AlterarConfiguracaoAssinaturaRegistrosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoAssinaturaRegistrosMutation, Types.AlterarConfiguracaoAssinaturaRegistrosMutationVariables>(AlterarConfiguracaoAssinaturaRegistrosDocument, options);
      }
export type AlterarConfiguracaoAssinaturaRegistrosMutationHookResult = ReturnType<typeof useAlterarConfiguracaoAssinaturaRegistrosMutation>;
export type AlterarConfiguracaoAssinaturaRegistrosMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoAssinaturaRegistrosMutation>;
export type AlterarConfiguracaoAssinaturaRegistrosMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoAssinaturaRegistrosMutation, Types.AlterarConfiguracaoAssinaturaRegistrosMutationVariables>;
export const AlterarConfiguracaoDocumentosEnvioCidadaoDocument = gql`
    mutation AlterarConfiguracaoDocumentosEnvioCidadao($habilitado: Boolean!) {
  alterarConfiguracaoDocumentosEnvioCidadao(habilitado: $habilitado) {
    id
    habilitado
  }
}
    `;
export type AlterarConfiguracaoDocumentosEnvioCidadaoMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutation, Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutationVariables>;

/**
 * __useAlterarConfiguracaoDocumentosEnvioCidadaoMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoDocumentosEnvioCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoDocumentosEnvioCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoDocumentosEnvioCidadaoMutation, { data, loading, error }] = useAlterarConfiguracaoDocumentosEnvioCidadaoMutation({
 *   variables: {
 *      habilitado: // value for 'habilitado'
 *   },
 * });
 */
export function useAlterarConfiguracaoDocumentosEnvioCidadaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutation, Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutation, Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutationVariables>(AlterarConfiguracaoDocumentosEnvioCidadaoDocument, options);
      }
export type AlterarConfiguracaoDocumentosEnvioCidadaoMutationHookResult = ReturnType<typeof useAlterarConfiguracaoDocumentosEnvioCidadaoMutation>;
export type AlterarConfiguracaoDocumentosEnvioCidadaoMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutation>;
export type AlterarConfiguracaoDocumentosEnvioCidadaoMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutation, Types.AlterarConfiguracaoDocumentosEnvioCidadaoMutationVariables>;
export const AlterarConfiguracaoDocumentosRndsDocument = gql`
    mutation AlterarConfiguracaoDocumentosRnds($habilitado: Boolean!) {
  alterarConfiguracaoDocumentosRnds(habilitado: $habilitado) {
    id
    habilitado
  }
}
    `;
export type AlterarConfiguracaoDocumentosRndsMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoDocumentosRndsMutation, Types.AlterarConfiguracaoDocumentosRndsMutationVariables>;

/**
 * __useAlterarConfiguracaoDocumentosRndsMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoDocumentosRndsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoDocumentosRndsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoDocumentosRndsMutation, { data, loading, error }] = useAlterarConfiguracaoDocumentosRndsMutation({
 *   variables: {
 *      habilitado: // value for 'habilitado'
 *   },
 * });
 */
export function useAlterarConfiguracaoDocumentosRndsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoDocumentosRndsMutation, Types.AlterarConfiguracaoDocumentosRndsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoDocumentosRndsMutation, Types.AlterarConfiguracaoDocumentosRndsMutationVariables>(AlterarConfiguracaoDocumentosRndsDocument, options);
      }
export type AlterarConfiguracaoDocumentosRndsMutationHookResult = ReturnType<typeof useAlterarConfiguracaoDocumentosRndsMutation>;
export type AlterarConfiguracaoDocumentosRndsMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoDocumentosRndsMutation>;
export type AlterarConfiguracaoDocumentosRndsMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoDocumentosRndsMutation, Types.AlterarConfiguracaoDocumentosRndsMutationVariables>;
export const AlterarCadsusDocument = gql`
    mutation AlterarCadsus($alterarCadsusInput: AlterarCadsusInput!) {
  alterarCadsus(alterarCadsusInput: $alterarCadsusInput) {
    id
    habilitado
    intervalo
    desabilitadoAteData
  }
}
    `;
export type AlterarCadsusMutationFn = Apollo.MutationFunction<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>;

/**
 * __useAlterarCadsusMutation__
 *
 * To run a mutation, you first call `useAlterarCadsusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarCadsusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarCadsusMutation, { data, loading, error }] = useAlterarCadsusMutation({
 *   variables: {
 *      alterarCadsusInput: // value for 'alterarCadsusInput'
 *   },
 * });
 */
export function useAlterarCadsusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>(AlterarCadsusDocument, options);
      }
export type AlterarCadsusMutationHookResult = ReturnType<typeof useAlterarCadsusMutation>;
export type AlterarCadsusMutationResult = Apollo.MutationResult<Types.AlterarCadsusMutation>;
export type AlterarCadsusMutationOptions = Apollo.BaseMutationOptions<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>;
export const AlterarHorusDocument = gql`
    mutation AlterarHorus($alterarHorusInput: AlterarHorusInput!) {
  alterarHorus(alterarHorusInput: $alterarHorusInput) {
    id
    habilitado
    intervalo
    desabilitadoAteData
  }
}
    `;
export type AlterarHorusMutationFn = Apollo.MutationFunction<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>;

/**
 * __useAlterarHorusMutation__
 *
 * To run a mutation, you first call `useAlterarHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarHorusMutation, { data, loading, error }] = useAlterarHorusMutation({
 *   variables: {
 *      alterarHorusInput: // value for 'alterarHorusInput'
 *   },
 * });
 */
export function useAlterarHorusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>(AlterarHorusDocument, options);
      }
export type AlterarHorusMutationHookResult = ReturnType<typeof useAlterarHorusMutation>;
export type AlterarHorusMutationResult = Apollo.MutationResult<Types.AlterarHorusMutation>;
export type AlterarHorusMutationOptions = Apollo.BaseMutationOptions<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>;
export const AlterarVideochamadaDocument = gql`
    mutation AlterarVideochamada($input: AlterarConfiguracaoVideochamadasInput!) {
  alterarConfiguracaoVideochamadas(input: $input) {
    id
    habilitado
  }
}
    `;
export type AlterarVideochamadaMutationFn = Apollo.MutationFunction<Types.AlterarVideochamadaMutation, Types.AlterarVideochamadaMutationVariables>;

/**
 * __useAlterarVideochamadaMutation__
 *
 * To run a mutation, you first call `useAlterarVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarVideochamadaMutation, { data, loading, error }] = useAlterarVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarVideochamadaMutation, Types.AlterarVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarVideochamadaMutation, Types.AlterarVideochamadaMutationVariables>(AlterarVideochamadaDocument, options);
      }
export type AlterarVideochamadaMutationHookResult = ReturnType<typeof useAlterarVideochamadaMutation>;
export type AlterarVideochamadaMutationResult = Apollo.MutationResult<Types.AlterarVideochamadaMutation>;
export type AlterarVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.AlterarVideochamadaMutation, Types.AlterarVideochamadaMutationVariables>;
export const AlterarConfiguracaoCadastroDomiciliarViaCdsDocument = gql`
    mutation AlterarConfiguracaoCadastroDomiciliarViaCds($input: Boolean!) {
  alterarConfiguracaoCadastroDomiciliarViaCds(habilitado: $input) {
    id
    habilitado
  }
}
    `;
export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutation, Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutationVariables>;

/**
 * __useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoCadastroDomiciliarViaCdsMutation, { data, loading, error }] = useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutation, Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutation, Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutationVariables>(AlterarConfiguracaoCadastroDomiciliarViaCdsDocument, options);
      }
export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutationHookResult = ReturnType<typeof useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation>;
export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutation>;
export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutation, Types.AlterarConfiguracaoCadastroDomiciliarViaCdsMutationVariables>;
export const AlterarConfiguracaoCadastroIndividualViaCdsDocument = gql`
    mutation AlterarConfiguracaoCadastroIndividualViaCds($input: Boolean!) {
  alterarConfiguracaoCadastroIndividualViaCds(habilitado: $input) {
    id
    habilitado
  }
}
    `;
export type AlterarConfiguracaoCadastroIndividualViaCdsMutationFn = Apollo.MutationFunction<Types.AlterarConfiguracaoCadastroIndividualViaCdsMutation, Types.AlterarConfiguracaoCadastroIndividualViaCdsMutationVariables>;

/**
 * __useAlterarConfiguracaoCadastroIndividualViaCdsMutation__
 *
 * To run a mutation, you first call `useAlterarConfiguracaoCadastroIndividualViaCdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarConfiguracaoCadastroIndividualViaCdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarConfiguracaoCadastroIndividualViaCdsMutation, { data, loading, error }] = useAlterarConfiguracaoCadastroIndividualViaCdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarConfiguracaoCadastroIndividualViaCdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarConfiguracaoCadastroIndividualViaCdsMutation, Types.AlterarConfiguracaoCadastroIndividualViaCdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarConfiguracaoCadastroIndividualViaCdsMutation, Types.AlterarConfiguracaoCadastroIndividualViaCdsMutationVariables>(AlterarConfiguracaoCadastroIndividualViaCdsDocument, options);
      }
export type AlterarConfiguracaoCadastroIndividualViaCdsMutationHookResult = ReturnType<typeof useAlterarConfiguracaoCadastroIndividualViaCdsMutation>;
export type AlterarConfiguracaoCadastroIndividualViaCdsMutationResult = Apollo.MutationResult<Types.AlterarConfiguracaoCadastroIndividualViaCdsMutation>;
export type AlterarConfiguracaoCadastroIndividualViaCdsMutationOptions = Apollo.BaseMutationOptions<Types.AlterarConfiguracaoCadastroIndividualViaCdsMutation, Types.AlterarConfiguracaoCadastroIndividualViaCdsMutationVariables>;
export const HasMunicipioAtivoDocument = gql`
    query HasMunicipioAtivo {
  hasMunicipioAtivo
}
    `;

/**
 * __useHasMunicipioAtivoQuery__
 *
 * To run a query within a React component, call `useHasMunicipioAtivoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasMunicipioAtivoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasMunicipioAtivoQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasMunicipioAtivoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>(HasMunicipioAtivoDocument, options);
      }
export function useHasMunicipioAtivoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>(HasMunicipioAtivoDocument, options);
        }
export function useHasMunicipioAtivoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>(HasMunicipioAtivoDocument, options);
        }
export type HasMunicipioAtivoQueryHookResult = ReturnType<typeof useHasMunicipioAtivoQuery>;
export type HasMunicipioAtivoLazyQueryHookResult = ReturnType<typeof useHasMunicipioAtivoLazyQuery>;
export type HasMunicipioAtivoSuspenseQueryHookResult = ReturnType<typeof useHasMunicipioAtivoSuspenseQuery>;
export type HasMunicipioAtivoQueryResult = Apollo.QueryResult<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>;
export const MunicipiosResponsaveisDocument = gql`
    query MunicipiosResponsaveis($input: MunicipioResponsavelFiltroInput!) {
  municipiosResponsaveis(input: $input) {
    content {
      id
      profissional {
        id
        nome
        nomeSocial
      }
      municipio {
        id
        nome
        uf {
          id
          sigla
        }
      }
      habilitado
      ativo
      dataAdicao
      dataInativacao
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useMunicipiosResponsaveisQuery__
 *
 * To run a query within a React component, call `useMunicipiosResponsaveisQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipiosResponsaveisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipiosResponsaveisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipiosResponsaveisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables> & ({ variables: Types.MunicipiosResponsaveisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>(MunicipiosResponsaveisDocument, options);
      }
export function useMunicipiosResponsaveisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>(MunicipiosResponsaveisDocument, options);
        }
export function useMunicipiosResponsaveisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>(MunicipiosResponsaveisDocument, options);
        }
export type MunicipiosResponsaveisQueryHookResult = ReturnType<typeof useMunicipiosResponsaveisQuery>;
export type MunicipiosResponsaveisLazyQueryHookResult = ReturnType<typeof useMunicipiosResponsaveisLazyQuery>;
export type MunicipiosResponsaveisSuspenseQueryHookResult = ReturnType<typeof useMunicipiosResponsaveisSuspenseQuery>;
export type MunicipiosResponsaveisQueryResult = Apollo.QueryResult<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>;
export const InserirMunicipioResponsavelDocument = gql`
    mutation InserirMunicipioResponsavel($input: MunicipioResponsavelInput!) {
  inserirMunicipioResponsavel(input: $input) {
    id
    profissional {
      id
      nome
    }
    municipio {
      id
      nome
    }
    habilitado
    ativo
    dataAdicao
    dataInativacao
  }
}
    `;
export type InserirMunicipioResponsavelMutationFn = Apollo.MutationFunction<Types.InserirMunicipioResponsavelMutation, Types.InserirMunicipioResponsavelMutationVariables>;

/**
 * __useInserirMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useInserirMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInserirMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inserirMunicipioResponsavelMutation, { data, loading, error }] = useInserirMunicipioResponsavelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInserirMunicipioResponsavelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InserirMunicipioResponsavelMutation, Types.InserirMunicipioResponsavelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InserirMunicipioResponsavelMutation, Types.InserirMunicipioResponsavelMutationVariables>(InserirMunicipioResponsavelDocument, options);
      }
export type InserirMunicipioResponsavelMutationHookResult = ReturnType<typeof useInserirMunicipioResponsavelMutation>;
export type InserirMunicipioResponsavelMutationResult = Apollo.MutationResult<Types.InserirMunicipioResponsavelMutation>;
export type InserirMunicipioResponsavelMutationOptions = Apollo.BaseMutationOptions<Types.InserirMunicipioResponsavelMutation, Types.InserirMunicipioResponsavelMutationVariables>;
export const AtualizarMunicipioResponsavelDocument = gql`
    mutation AtualizarMunicipioResponsavel($input: MunicipioResponsavelUpdateInput!) {
  atualizarMunicipioResponsavel(input: $input) {
    id
    profissional {
      id
      nome
    }
    municipio {
      id
      nome
      uf {
        id
        sigla
      }
    }
    habilitado
    ativo
    dataAdicao
    dataInativacao
  }
}
    `;
export type AtualizarMunicipioResponsavelMutationFn = Apollo.MutationFunction<Types.AtualizarMunicipioResponsavelMutation, Types.AtualizarMunicipioResponsavelMutationVariables>;

/**
 * __useAtualizarMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useAtualizarMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarMunicipioResponsavelMutation, { data, loading, error }] = useAtualizarMunicipioResponsavelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarMunicipioResponsavelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtualizarMunicipioResponsavelMutation, Types.AtualizarMunicipioResponsavelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtualizarMunicipioResponsavelMutation, Types.AtualizarMunicipioResponsavelMutationVariables>(AtualizarMunicipioResponsavelDocument, options);
      }
export type AtualizarMunicipioResponsavelMutationHookResult = ReturnType<typeof useAtualizarMunicipioResponsavelMutation>;
export type AtualizarMunicipioResponsavelMutationResult = Apollo.MutationResult<Types.AtualizarMunicipioResponsavelMutation>;
export type AtualizarMunicipioResponsavelMutationOptions = Apollo.BaseMutationOptions<Types.AtualizarMunicipioResponsavelMutation, Types.AtualizarMunicipioResponsavelMutationVariables>;
export const ExcluirMunicipioResponsavelDocument = gql`
    mutation ExcluirMunicipioResponsavel($id: ID!) {
  excluirMunicipioResponsavel(id: $id)
}
    `;
export type ExcluirMunicipioResponsavelMutationFn = Apollo.MutationFunction<Types.ExcluirMunicipioResponsavelMutation, Types.ExcluirMunicipioResponsavelMutationVariables>;

/**
 * __useExcluirMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useExcluirMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirMunicipioResponsavelMutation, { data, loading, error }] = useExcluirMunicipioResponsavelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirMunicipioResponsavelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirMunicipioResponsavelMutation, Types.ExcluirMunicipioResponsavelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirMunicipioResponsavelMutation, Types.ExcluirMunicipioResponsavelMutationVariables>(ExcluirMunicipioResponsavelDocument, options);
      }
export type ExcluirMunicipioResponsavelMutationHookResult = ReturnType<typeof useExcluirMunicipioResponsavelMutation>;
export type ExcluirMunicipioResponsavelMutationResult = Apollo.MutationResult<Types.ExcluirMunicipioResponsavelMutation>;
export type ExcluirMunicipioResponsavelMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirMunicipioResponsavelMutation, Types.ExcluirMunicipioResponsavelMutationVariables>;
export const AlterarNumeroTentativasLoginDocument = gql`
    mutation AlterarNumeroTentativasLogin($tentativas: Int) {
  alterarNumeroTentativasLogin(tentativas: $tentativas) {
    tentativasLogin
  }
}
    `;
export type AlterarNumeroTentativasLoginMutationFn = Apollo.MutationFunction<Types.AlterarNumeroTentativasLoginMutation, Types.AlterarNumeroTentativasLoginMutationVariables>;

/**
 * __useAlterarNumeroTentativasLoginMutation__
 *
 * To run a mutation, you first call `useAlterarNumeroTentativasLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarNumeroTentativasLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarNumeroTentativasLoginMutation, { data, loading, error }] = useAlterarNumeroTentativasLoginMutation({
 *   variables: {
 *      tentativas: // value for 'tentativas'
 *   },
 * });
 */
export function useAlterarNumeroTentativasLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarNumeroTentativasLoginMutation, Types.AlterarNumeroTentativasLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarNumeroTentativasLoginMutation, Types.AlterarNumeroTentativasLoginMutationVariables>(AlterarNumeroTentativasLoginDocument, options);
      }
export type AlterarNumeroTentativasLoginMutationHookResult = ReturnType<typeof useAlterarNumeroTentativasLoginMutation>;
export type AlterarNumeroTentativasLoginMutationResult = Apollo.MutationResult<Types.AlterarNumeroTentativasLoginMutation>;
export type AlterarNumeroTentativasLoginMutationOptions = Apollo.BaseMutationOptions<Types.AlterarNumeroTentativasLoginMutation, Types.AlterarNumeroTentativasLoginMutationVariables>;
export const AlterarPeriodoInatividadeDocument = gql`
    mutation AlterarPeriodoInatividade($periodo: Int) {
  alterarPeriodoInatividade(periodo: $periodo) {
    periodoInatividade
  }
}
    `;
export type AlterarPeriodoInatividadeMutationFn = Apollo.MutationFunction<Types.AlterarPeriodoInatividadeMutation, Types.AlterarPeriodoInatividadeMutationVariables>;

/**
 * __useAlterarPeriodoInatividadeMutation__
 *
 * To run a mutation, you first call `useAlterarPeriodoInatividadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarPeriodoInatividadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarPeriodoInatividadeMutation, { data, loading, error }] = useAlterarPeriodoInatividadeMutation({
 *   variables: {
 *      periodo: // value for 'periodo'
 *   },
 * });
 */
export function useAlterarPeriodoInatividadeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarPeriodoInatividadeMutation, Types.AlterarPeriodoInatividadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarPeriodoInatividadeMutation, Types.AlterarPeriodoInatividadeMutationVariables>(AlterarPeriodoInatividadeDocument, options);
      }
export type AlterarPeriodoInatividadeMutationHookResult = ReturnType<typeof useAlterarPeriodoInatividadeMutation>;
export type AlterarPeriodoInatividadeMutationResult = Apollo.MutationResult<Types.AlterarPeriodoInatividadeMutation>;
export type AlterarPeriodoInatividadeMutationOptions = Apollo.BaseMutationOptions<Types.AlterarPeriodoInatividadeMutation, Types.AlterarPeriodoInatividadeMutationVariables>;
export const AlterarPeriodoRedefinicaoSenhaDocument = gql`
    mutation AlterarPeriodoRedefinicaoSenha($periodo: Int) {
  alterarPeriodoRedefinicaoSenha(periodo: $periodo) {
    redefinicaoSenha
  }
}
    `;
export type AlterarPeriodoRedefinicaoSenhaMutationFn = Apollo.MutationFunction<Types.AlterarPeriodoRedefinicaoSenhaMutation, Types.AlterarPeriodoRedefinicaoSenhaMutationVariables>;

/**
 * __useAlterarPeriodoRedefinicaoSenhaMutation__
 *
 * To run a mutation, you first call `useAlterarPeriodoRedefinicaoSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarPeriodoRedefinicaoSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarPeriodoRedefinicaoSenhaMutation, { data, loading, error }] = useAlterarPeriodoRedefinicaoSenhaMutation({
 *   variables: {
 *      periodo: // value for 'periodo'
 *   },
 * });
 */
export function useAlterarPeriodoRedefinicaoSenhaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarPeriodoRedefinicaoSenhaMutation, Types.AlterarPeriodoRedefinicaoSenhaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarPeriodoRedefinicaoSenhaMutation, Types.AlterarPeriodoRedefinicaoSenhaMutationVariables>(AlterarPeriodoRedefinicaoSenhaDocument, options);
      }
export type AlterarPeriodoRedefinicaoSenhaMutationHookResult = ReturnType<typeof useAlterarPeriodoRedefinicaoSenhaMutation>;
export type AlterarPeriodoRedefinicaoSenhaMutationResult = Apollo.MutationResult<Types.AlterarPeriodoRedefinicaoSenhaMutation>;
export type AlterarPeriodoRedefinicaoSenhaMutationOptions = Apollo.BaseMutationOptions<Types.AlterarPeriodoRedefinicaoSenhaMutation, Types.AlterarPeriodoRedefinicaoSenhaMutationVariables>;
export const ForcarRedefinirSenhasDocument = gql`
    mutation ForcarRedefinirSenhas {
  forcarRedefinirSenhas {
    redefinicaoSenha
  }
}
    `;
export type ForcarRedefinirSenhasMutationFn = Apollo.MutationFunction<Types.ForcarRedefinirSenhasMutation, Types.ForcarRedefinirSenhasMutationVariables>;

/**
 * __useForcarRedefinirSenhasMutation__
 *
 * To run a mutation, you first call `useForcarRedefinirSenhasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForcarRedefinirSenhasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forcarRedefinirSenhasMutation, { data, loading, error }] = useForcarRedefinirSenhasMutation({
 *   variables: {
 *   },
 * });
 */
export function useForcarRedefinirSenhasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ForcarRedefinirSenhasMutation, Types.ForcarRedefinirSenhasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ForcarRedefinirSenhasMutation, Types.ForcarRedefinirSenhasMutationVariables>(ForcarRedefinirSenhasDocument, options);
      }
export type ForcarRedefinirSenhasMutationHookResult = ReturnType<typeof useForcarRedefinirSenhasMutation>;
export type ForcarRedefinirSenhasMutationResult = Apollo.MutationResult<Types.ForcarRedefinirSenhasMutation>;
export type ForcarRedefinirSenhasMutationOptions = Apollo.BaseMutationOptions<Types.ForcarRedefinirSenhasMutation, Types.ForcarRedefinirSenhasMutationVariables>;
export const SegurancaDocument = gql`
    query Seguranca {
  seguranca {
    periodoEmMesesParaRedefinir {
      redefinicaoSenha
    }
    periodoEmMinutosInatividade {
      periodoInatividade
    }
    loginNumeroTentativas {
      tentativasLogin
    }
  }
}
    `;

/**
 * __useSegurancaQuery__
 *
 * To run a query within a React component, call `useSegurancaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegurancaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegurancaQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegurancaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SegurancaQuery, Types.SegurancaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SegurancaQuery, Types.SegurancaQueryVariables>(SegurancaDocument, options);
      }
export function useSegurancaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SegurancaQuery, Types.SegurancaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SegurancaQuery, Types.SegurancaQueryVariables>(SegurancaDocument, options);
        }
export function useSegurancaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SegurancaQuery, Types.SegurancaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SegurancaQuery, Types.SegurancaQueryVariables>(SegurancaDocument, options);
        }
export type SegurancaQueryHookResult = ReturnType<typeof useSegurancaQuery>;
export type SegurancaLazyQueryHookResult = ReturnType<typeof useSegurancaLazyQuery>;
export type SegurancaSuspenseQueryHookResult = ReturnType<typeof useSegurancaSuspenseQuery>;
export type SegurancaQueryResult = Apollo.QueryResult<Types.SegurancaQuery, Types.SegurancaQueryVariables>;
export const AlterarDadosServidorInstalacaoDocument = gql`
    mutation AlterarDadosServidorInstalacao($input: ConfiguracaoDadosServidorInput!) {
  alterarDadosServidor(input: $input) {
    nomeInstalacao
    linkInstalacao
  }
}
    `;
export type AlterarDadosServidorInstalacaoMutationFn = Apollo.MutationFunction<Types.AlterarDadosServidorInstalacaoMutation, Types.AlterarDadosServidorInstalacaoMutationVariables>;

/**
 * __useAlterarDadosServidorInstalacaoMutation__
 *
 * To run a mutation, you first call `useAlterarDadosServidorInstalacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarDadosServidorInstalacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarDadosServidorInstalacaoMutation, { data, loading, error }] = useAlterarDadosServidorInstalacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarDadosServidorInstalacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarDadosServidorInstalacaoMutation, Types.AlterarDadosServidorInstalacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarDadosServidorInstalacaoMutation, Types.AlterarDadosServidorInstalacaoMutationVariables>(AlterarDadosServidorInstalacaoDocument, options);
      }
export type AlterarDadosServidorInstalacaoMutationHookResult = ReturnType<typeof useAlterarDadosServidorInstalacaoMutation>;
export type AlterarDadosServidorInstalacaoMutationResult = Apollo.MutationResult<Types.AlterarDadosServidorInstalacaoMutation>;
export type AlterarDadosServidorInstalacaoMutationOptions = Apollo.BaseMutationOptions<Types.AlterarDadosServidorInstalacaoMutation, Types.AlterarDadosServidorInstalacaoMutationVariables>;
export const AlterarServidorSmtpDocument = gql`
    mutation AlterarServidorSMTP($input: ConfiguracaoSMTPInput!) {
  alterarServidorSMTP(input: $input) {
    id
    email
    senha
    usuario
    endereco
    porta
  }
}
    `;
export type AlterarServidorSmtpMutationFn = Apollo.MutationFunction<Types.AlterarServidorSmtpMutation, Types.AlterarServidorSmtpMutationVariables>;

/**
 * __useAlterarServidorSmtpMutation__
 *
 * To run a mutation, you first call `useAlterarServidorSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarServidorSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarServidorSmtpMutation, { data, loading, error }] = useAlterarServidorSmtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarServidorSmtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarServidorSmtpMutation, Types.AlterarServidorSmtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarServidorSmtpMutation, Types.AlterarServidorSmtpMutationVariables>(AlterarServidorSmtpDocument, options);
      }
export type AlterarServidorSmtpMutationHookResult = ReturnType<typeof useAlterarServidorSmtpMutation>;
export type AlterarServidorSmtpMutationResult = Apollo.MutationResult<Types.AlterarServidorSmtpMutation>;
export type AlterarServidorSmtpMutationOptions = Apollo.BaseMutationOptions<Types.AlterarServidorSmtpMutation, Types.AlterarServidorSmtpMutationVariables>;
export const DesabilitarConexaoSmtpDocument = gql`
    mutation DesabilitarConexaoSMTP {
  desabilitarConexaoSMTP
}
    `;
export type DesabilitarConexaoSmtpMutationFn = Apollo.MutationFunction<Types.DesabilitarConexaoSmtpMutation, Types.DesabilitarConexaoSmtpMutationVariables>;

/**
 * __useDesabilitarConexaoSmtpMutation__
 *
 * To run a mutation, you first call `useDesabilitarConexaoSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesabilitarConexaoSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desabilitarConexaoSmtpMutation, { data, loading, error }] = useDesabilitarConexaoSmtpMutation({
 *   variables: {
 *   },
 * });
 */
export function useDesabilitarConexaoSmtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DesabilitarConexaoSmtpMutation, Types.DesabilitarConexaoSmtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DesabilitarConexaoSmtpMutation, Types.DesabilitarConexaoSmtpMutationVariables>(DesabilitarConexaoSmtpDocument, options);
      }
export type DesabilitarConexaoSmtpMutationHookResult = ReturnType<typeof useDesabilitarConexaoSmtpMutation>;
export type DesabilitarConexaoSmtpMutationResult = Apollo.MutationResult<Types.DesabilitarConexaoSmtpMutation>;
export type DesabilitarConexaoSmtpMutationOptions = Apollo.BaseMutationOptions<Types.DesabilitarConexaoSmtpMutation, Types.DesabilitarConexaoSmtpMutationVariables>;
export const DadosServidoresDocument = gql`
    query DadosServidores {
  servidores {
    internet {
      habilitado
    }
    dadosServidor {
      nomeInstalacao
      linkInstalacao
    }
    servidorSMTP {
      id
      email
      senha
      usuario
      endereco
      porta
      ativo
      dataRegistro
    }
  }
}
    `;

/**
 * __useDadosServidoresQuery__
 *
 * To run a query within a React component, call `useDadosServidoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDadosServidoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDadosServidoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useDadosServidoresQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>(DadosServidoresDocument, options);
      }
export function useDadosServidoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>(DadosServidoresDocument, options);
        }
export function useDadosServidoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>(DadosServidoresDocument, options);
        }
export type DadosServidoresQueryHookResult = ReturnType<typeof useDadosServidoresQuery>;
export type DadosServidoresLazyQueryHookResult = ReturnType<typeof useDadosServidoresLazyQuery>;
export type DadosServidoresSuspenseQueryHookResult = ReturnType<typeof useDadosServidoresSuspenseQuery>;
export type DadosServidoresQueryResult = Apollo.QueryResult<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>;
export const ConfiguracaoInternetDocument = gql`
    query ConfiguracaoInternet {
  conexao {
    internet {
      habilitado
    }
    agendaOnline {
      ativa
    }
  }
}
    `;

/**
 * __useConfiguracaoInternetQuery__
 *
 * To run a query within a React component, call `useConfiguracaoInternetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoInternetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoInternetQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoInternetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>(ConfiguracaoInternetDocument, options);
      }
export function useConfiguracaoInternetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>(ConfiguracaoInternetDocument, options);
        }
export function useConfiguracaoInternetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>(ConfiguracaoInternetDocument, options);
        }
export type ConfiguracaoInternetQueryHookResult = ReturnType<typeof useConfiguracaoInternetQuery>;
export type ConfiguracaoInternetLazyQueryHookResult = ReturnType<typeof useConfiguracaoInternetLazyQuery>;
export type ConfiguracaoInternetSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoInternetSuspenseQuery>;
export type ConfiguracaoInternetQueryResult = Apollo.QueryResult<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>;
export const PedidoEnvioBaseAtivoDocument = gql`
    query PedidoEnvioBaseAtivo {
  pedidoEnvioBaseAtivo {
    id
    nomeInstalacao
    chaveAutenticacao
    linkInstalacao
    status
    loginAtivo
  }
}
    `;

/**
 * __usePedidoEnvioBaseAtivoQuery__
 *
 * To run a query within a React component, call `usePedidoEnvioBaseAtivoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePedidoEnvioBaseAtivoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePedidoEnvioBaseAtivoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePedidoEnvioBaseAtivoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>(PedidoEnvioBaseAtivoDocument, options);
      }
export function usePedidoEnvioBaseAtivoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>(PedidoEnvioBaseAtivoDocument, options);
        }
export function usePedidoEnvioBaseAtivoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>(PedidoEnvioBaseAtivoDocument, options);
        }
export type PedidoEnvioBaseAtivoQueryHookResult = ReturnType<typeof usePedidoEnvioBaseAtivoQuery>;
export type PedidoEnvioBaseAtivoLazyQueryHookResult = ReturnType<typeof usePedidoEnvioBaseAtivoLazyQuery>;
export type PedidoEnvioBaseAtivoSuspenseQueryHookResult = ReturnType<typeof usePedidoEnvioBaseAtivoSuspenseQuery>;
export type PedidoEnvioBaseAtivoQueryResult = Apollo.QueryResult<Types.PedidoEnvioBaseAtivoQuery, Types.PedidoEnvioBaseAtivoQueryVariables>;
export const PedidosEnvioBaseDocument = gql`
    query PedidosEnvioBase {
  pedidosEnvioBase {
    id
    linkInstalacao
    status
    dataSolicitacao
    dataFimUnificacao
    loginAtivo
  }
}
    `;

/**
 * __usePedidosEnvioBaseQuery__
 *
 * To run a query within a React component, call `usePedidosEnvioBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePedidosEnvioBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePedidosEnvioBaseQuery({
 *   variables: {
 *   },
 * });
 */
export function usePedidosEnvioBaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>(PedidosEnvioBaseDocument, options);
      }
export function usePedidosEnvioBaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>(PedidosEnvioBaseDocument, options);
        }
export function usePedidosEnvioBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>(PedidosEnvioBaseDocument, options);
        }
export type PedidosEnvioBaseQueryHookResult = ReturnType<typeof usePedidosEnvioBaseQuery>;
export type PedidosEnvioBaseLazyQueryHookResult = ReturnType<typeof usePedidosEnvioBaseLazyQuery>;
export type PedidosEnvioBaseSuspenseQueryHookResult = ReturnType<typeof usePedidosEnvioBaseSuspenseQuery>;
export type PedidosEnvioBaseQueryResult = Apollo.QueryResult<Types.PedidosEnvioBaseQuery, Types.PedidosEnvioBaseQueryVariables>;
export const UnificacoesBaseDocument = gql`
    query UnificacoesBase {
  unificacoesBase {
    id
    nomeInstalacao
    status
    dataSolicitacao
    dataFimUnificacao
  }
}
    `;

/**
 * __useUnificacoesBaseQuery__
 *
 * To run a query within a React component, call `useUnificacoesBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacoesBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacoesBaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnificacoesBaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>(UnificacoesBaseDocument, options);
      }
export function useUnificacoesBaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>(UnificacoesBaseDocument, options);
        }
export function useUnificacoesBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>(UnificacoesBaseDocument, options);
        }
export type UnificacoesBaseQueryHookResult = ReturnType<typeof useUnificacoesBaseQuery>;
export type UnificacoesBaseLazyQueryHookResult = ReturnType<typeof useUnificacoesBaseLazyQuery>;
export type UnificacoesBaseSuspenseQueryHookResult = ReturnType<typeof useUnificacoesBaseSuspenseQuery>;
export type UnificacoesBaseQueryResult = Apollo.QueryResult<Types.UnificacoesBaseQuery, Types.UnificacoesBaseQueryVariables>;
export const AceitarSolicitacaoDocument = gql`
    mutation aceitarSolicitacao($id: ID!) {
  aceitarSolicitacao(id: $id)
}
    `;
export type AceitarSolicitacaoMutationFn = Apollo.MutationFunction<Types.AceitarSolicitacaoMutation, Types.AceitarSolicitacaoMutationVariables>;

/**
 * __useAceitarSolicitacaoMutation__
 *
 * To run a mutation, you first call `useAceitarSolicitacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAceitarSolicitacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aceitarSolicitacaoMutation, { data, loading, error }] = useAceitarSolicitacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAceitarSolicitacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AceitarSolicitacaoMutation, Types.AceitarSolicitacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AceitarSolicitacaoMutation, Types.AceitarSolicitacaoMutationVariables>(AceitarSolicitacaoDocument, options);
      }
export type AceitarSolicitacaoMutationHookResult = ReturnType<typeof useAceitarSolicitacaoMutation>;
export type AceitarSolicitacaoMutationResult = Apollo.MutationResult<Types.AceitarSolicitacaoMutation>;
export type AceitarSolicitacaoMutationOptions = Apollo.BaseMutationOptions<Types.AceitarSolicitacaoMutation, Types.AceitarSolicitacaoMutationVariables>;
export const CadastrarEnderecoEnvioDocument = gql`
    mutation cadastrarEnderecoEnvio($input: InfoCadastroEnvioInput!) {
  cadastrarEnderecoEnvio(input: $input) {
    pedidoEnvioBase {
      id
    }
    errorLogin
    errorImportacaoCnes {
      instalacaoCentral
      instalacaoLocal
    }
  }
}
    `;
export type CadastrarEnderecoEnvioMutationFn = Apollo.MutationFunction<Types.CadastrarEnderecoEnvioMutation, Types.CadastrarEnderecoEnvioMutationVariables>;

/**
 * __useCadastrarEnderecoEnvioMutation__
 *
 * To run a mutation, you first call `useCadastrarEnderecoEnvioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCadastrarEnderecoEnvioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cadastrarEnderecoEnvioMutation, { data, loading, error }] = useCadastrarEnderecoEnvioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCadastrarEnderecoEnvioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CadastrarEnderecoEnvioMutation, Types.CadastrarEnderecoEnvioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CadastrarEnderecoEnvioMutation, Types.CadastrarEnderecoEnvioMutationVariables>(CadastrarEnderecoEnvioDocument, options);
      }
export type CadastrarEnderecoEnvioMutationHookResult = ReturnType<typeof useCadastrarEnderecoEnvioMutation>;
export type CadastrarEnderecoEnvioMutationResult = Apollo.MutationResult<Types.CadastrarEnderecoEnvioMutation>;
export type CadastrarEnderecoEnvioMutationOptions = Apollo.BaseMutationOptions<Types.CadastrarEnderecoEnvioMutation, Types.CadastrarEnderecoEnvioMutationVariables>;
export const CancelarSolicitacaoEnvioDocument = gql`
    mutation cancelarSolicitacaoEnvio($input: CancelarSolicitacaoEnvioInput!) {
  cancelarSolicitacaoEnvio(input: $input)
}
    `;
export type CancelarSolicitacaoEnvioMutationFn = Apollo.MutationFunction<Types.CancelarSolicitacaoEnvioMutation, Types.CancelarSolicitacaoEnvioMutationVariables>;

/**
 * __useCancelarSolicitacaoEnvioMutation__
 *
 * To run a mutation, you first call `useCancelarSolicitacaoEnvioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarSolicitacaoEnvioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarSolicitacaoEnvioMutation, { data, loading, error }] = useCancelarSolicitacaoEnvioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelarSolicitacaoEnvioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelarSolicitacaoEnvioMutation, Types.CancelarSolicitacaoEnvioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelarSolicitacaoEnvioMutation, Types.CancelarSolicitacaoEnvioMutationVariables>(CancelarSolicitacaoEnvioDocument, options);
      }
export type CancelarSolicitacaoEnvioMutationHookResult = ReturnType<typeof useCancelarSolicitacaoEnvioMutation>;
export type CancelarSolicitacaoEnvioMutationResult = Apollo.MutationResult<Types.CancelarSolicitacaoEnvioMutation>;
export type CancelarSolicitacaoEnvioMutationOptions = Apollo.BaseMutationOptions<Types.CancelarSolicitacaoEnvioMutation, Types.CancelarSolicitacaoEnvioMutationVariables>;
export const HasImpressaoDocumentosDuplicadosDocument = gql`
    query hasImpressaoDocumentosDuplicados($id: ID!) {
  hasDocumentosDuplicados(unificacaoBaseId: $id)
}
    `;

/**
 * __useHasImpressaoDocumentosDuplicadosQuery__
 *
 * To run a query within a React component, call `useHasImpressaoDocumentosDuplicadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasImpressaoDocumentosDuplicadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasImpressaoDocumentosDuplicadosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHasImpressaoDocumentosDuplicadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables> & ({ variables: Types.HasImpressaoDocumentosDuplicadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>(HasImpressaoDocumentosDuplicadosDocument, options);
      }
export function useHasImpressaoDocumentosDuplicadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>(HasImpressaoDocumentosDuplicadosDocument, options);
        }
export function useHasImpressaoDocumentosDuplicadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>(HasImpressaoDocumentosDuplicadosDocument, options);
        }
export type HasImpressaoDocumentosDuplicadosQueryHookResult = ReturnType<typeof useHasImpressaoDocumentosDuplicadosQuery>;
export type HasImpressaoDocumentosDuplicadosLazyQueryHookResult = ReturnType<typeof useHasImpressaoDocumentosDuplicadosLazyQuery>;
export type HasImpressaoDocumentosDuplicadosSuspenseQueryHookResult = ReturnType<typeof useHasImpressaoDocumentosDuplicadosSuspenseQuery>;
export type HasImpressaoDocumentosDuplicadosQueryResult = Apollo.QueryResult<Types.HasImpressaoDocumentosDuplicadosQuery, Types.HasImpressaoDocumentosDuplicadosQueryVariables>;
export const InicarUnificacaoBaseDocument = gql`
    mutation inicarUnificacaoBase {
  iniciarUnificacaoBase
}
    `;
export type InicarUnificacaoBaseMutationFn = Apollo.MutationFunction<Types.InicarUnificacaoBaseMutation, Types.InicarUnificacaoBaseMutationVariables>;

/**
 * __useInicarUnificacaoBaseMutation__
 *
 * To run a mutation, you first call `useInicarUnificacaoBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInicarUnificacaoBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inicarUnificacaoBaseMutation, { data, loading, error }] = useInicarUnificacaoBaseMutation({
 *   variables: {
 *   },
 * });
 */
export function useInicarUnificacaoBaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InicarUnificacaoBaseMutation, Types.InicarUnificacaoBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InicarUnificacaoBaseMutation, Types.InicarUnificacaoBaseMutationVariables>(InicarUnificacaoBaseDocument, options);
      }
export type InicarUnificacaoBaseMutationHookResult = ReturnType<typeof useInicarUnificacaoBaseMutation>;
export type InicarUnificacaoBaseMutationResult = Apollo.MutationResult<Types.InicarUnificacaoBaseMutation>;
export type InicarUnificacaoBaseMutationOptions = Apollo.BaseMutationOptions<Types.InicarUnificacaoBaseMutation, Types.InicarUnificacaoBaseMutationVariables>;
export const NegarSolicitacaoDocument = gql`
    mutation negarSolicitacao($id: ID!) {
  negarSolicitacao(id: $id)
}
    `;
export type NegarSolicitacaoMutationFn = Apollo.MutationFunction<Types.NegarSolicitacaoMutation, Types.NegarSolicitacaoMutationVariables>;

/**
 * __useNegarSolicitacaoMutation__
 *
 * To run a mutation, you first call `useNegarSolicitacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNegarSolicitacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [negarSolicitacaoMutation, { data, loading, error }] = useNegarSolicitacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNegarSolicitacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.NegarSolicitacaoMutation, Types.NegarSolicitacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.NegarSolicitacaoMutation, Types.NegarSolicitacaoMutationVariables>(NegarSolicitacaoDocument, options);
      }
export type NegarSolicitacaoMutationHookResult = ReturnType<typeof useNegarSolicitacaoMutation>;
export type NegarSolicitacaoMutationResult = Apollo.MutationResult<Types.NegarSolicitacaoMutation>;
export type NegarSolicitacaoMutationOptions = Apollo.BaseMutationOptions<Types.NegarSolicitacaoMutation, Types.NegarSolicitacaoMutationVariables>;
export const RefazerLoginDocument = gql`
    mutation refazerLogin($senha: String!) {
  refazLoginExpirado(senha: $senha)
}
    `;
export type RefazerLoginMutationFn = Apollo.MutationFunction<Types.RefazerLoginMutation, Types.RefazerLoginMutationVariables>;

/**
 * __useRefazerLoginMutation__
 *
 * To run a mutation, you first call `useRefazerLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefazerLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refazerLoginMutation, { data, loading, error }] = useRefazerLoginMutation({
 *   variables: {
 *      senha: // value for 'senha'
 *   },
 * });
 */
export function useRefazerLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RefazerLoginMutation, Types.RefazerLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RefazerLoginMutation, Types.RefazerLoginMutationVariables>(RefazerLoginDocument, options);
      }
export type RefazerLoginMutationHookResult = ReturnType<typeof useRefazerLoginMutation>;
export type RefazerLoginMutationResult = Apollo.MutationResult<Types.RefazerLoginMutation>;
export type RefazerLoginMutationOptions = Apollo.BaseMutationOptions<Types.RefazerLoginMutation, Types.RefazerLoginMutationVariables>;
export const CadsusHabilitadoInstalacaoDocument = gql`
    query CadsusHabilitadoInstalacao {
  conexao {
    cadsus {
      id
      habilitado
    }
  }
}
    `;

/**
 * __useCadsusHabilitadoInstalacaoQuery__
 *
 * To run a query within a React component, call `useCadsusHabilitadoInstalacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCadsusHabilitadoInstalacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCadsusHabilitadoInstalacaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCadsusHabilitadoInstalacaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>(CadsusHabilitadoInstalacaoDocument, options);
      }
export function useCadsusHabilitadoInstalacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>(CadsusHabilitadoInstalacaoDocument, options);
        }
export function useCadsusHabilitadoInstalacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>(CadsusHabilitadoInstalacaoDocument, options);
        }
export type CadsusHabilitadoInstalacaoQueryHookResult = ReturnType<typeof useCadsusHabilitadoInstalacaoQuery>;
export type CadsusHabilitadoInstalacaoLazyQueryHookResult = ReturnType<typeof useCadsusHabilitadoInstalacaoLazyQuery>;
export type CadsusHabilitadoInstalacaoSuspenseQueryHookResult = ReturnType<typeof useCadsusHabilitadoInstalacaoSuspenseQuery>;
export type CadsusHabilitadoInstalacaoQueryResult = Apollo.QueryResult<Types.CadsusHabilitadoInstalacaoQuery, Types.CadsusHabilitadoInstalacaoQueryVariables>;
export const CertificadoSelectDocument = gql`
    query CertificadoSelect($input: CertificadoQueryInput!) {
  certificados(input: $input) {
    content {
      path
      nome
    }
  }
}
    `;

/**
 * __useCertificadoSelectQuery__
 *
 * To run a query within a React component, call `useCertificadoSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificadoSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificadoSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCertificadoSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables> & ({ variables: Types.CertificadoSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>(CertificadoSelectDocument, options);
      }
export function useCertificadoSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>(CertificadoSelectDocument, options);
        }
export function useCertificadoSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>(CertificadoSelectDocument, options);
        }
export type CertificadoSelectQueryHookResult = ReturnType<typeof useCertificadoSelectQuery>;
export type CertificadoSelectLazyQueryHookResult = ReturnType<typeof useCertificadoSelectLazyQuery>;
export type CertificadoSelectSuspenseQueryHookResult = ReturnType<typeof useCertificadoSelectSuspenseQuery>;
export type CertificadoSelectQueryResult = Apollo.QueryResult<Types.CertificadoSelectQuery, Types.CertificadoSelectQueryVariables>;
export const SalvarConfiguracaoCertificadoDocument = gql`
    mutation SalvarConfiguracaoCertificado($configuracaoCertificadoInput: ConfiguracaoCertificadoInput!) {
  salvarConfiguracaoCertificado(
    configuracaoCertificadoInput: $configuracaoCertificadoInput
  ) {
    id
    dataInclusao
    admMunicipal {
      id
      profissional {
        id
        nome
      }
    }
    dataHabilitacao
    dataValidadeCertificado
    rndsHabilitado
    cadsusHabilitado
    farmaciaHabilitado
    error
  }
}
    `;
export type SalvarConfiguracaoCertificadoMutationFn = Apollo.MutationFunction<Types.SalvarConfiguracaoCertificadoMutation, Types.SalvarConfiguracaoCertificadoMutationVariables>;

/**
 * __useSalvarConfiguracaoCertificadoMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoCertificadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoCertificadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoCertificadoMutation, { data, loading, error }] = useSalvarConfiguracaoCertificadoMutation({
 *   variables: {
 *      configuracaoCertificadoInput: // value for 'configuracaoCertificadoInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoCertificadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarConfiguracaoCertificadoMutation, Types.SalvarConfiguracaoCertificadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarConfiguracaoCertificadoMutation, Types.SalvarConfiguracaoCertificadoMutationVariables>(SalvarConfiguracaoCertificadoDocument, options);
      }
export type SalvarConfiguracaoCertificadoMutationHookResult = ReturnType<typeof useSalvarConfiguracaoCertificadoMutation>;
export type SalvarConfiguracaoCertificadoMutationResult = Apollo.MutationResult<Types.SalvarConfiguracaoCertificadoMutation>;
export type SalvarConfiguracaoCertificadoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarConfiguracaoCertificadoMutation, Types.SalvarConfiguracaoCertificadoMutationVariables>;
export const ConfiguracaoCertificadoHabilitadoDocument = gql`
    query ConfiguracaoCertificadoHabilitado {
  configuracaoCertificadoHabilitado {
    id
    dataInclusao
    admMunicipal {
      id
      profissional {
        id
        nome
      }
    }
    dataHabilitacao
    dataValidadeCertificado
    rndsHabilitado
    cadsusHabilitado
    farmaciaHabilitado
    error
  }
  conexao {
    internet {
      habilitado
    }
  }
}
    `;

/**
 * __useConfiguracaoCertificadoHabilitadoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoCertificadoHabilitadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoCertificadoHabilitadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoCertificadoHabilitadoQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoCertificadoHabilitadoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>(ConfiguracaoCertificadoHabilitadoDocument, options);
      }
export function useConfiguracaoCertificadoHabilitadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>(ConfiguracaoCertificadoHabilitadoDocument, options);
        }
export function useConfiguracaoCertificadoHabilitadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>(ConfiguracaoCertificadoHabilitadoDocument, options);
        }
export type ConfiguracaoCertificadoHabilitadoQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoHabilitadoQuery>;
export type ConfiguracaoCertificadoHabilitadoLazyQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoHabilitadoLazyQuery>;
export type ConfiguracaoCertificadoHabilitadoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoHabilitadoSuspenseQuery>;
export type ConfiguracaoCertificadoHabilitadoQueryResult = Apollo.QueryResult<Types.ConfiguracaoCertificadoHabilitadoQuery, Types.ConfiguracaoCertificadoHabilitadoQueryVariables>;
export const ContraChaveAtivacaoMunicipioDocument = gql`
    query ContraChaveAtivacaoMunicipio {
  contraChaveAtivacaoMunicipio
}
    `;

/**
 * __useContraChaveAtivacaoMunicipioQuery__
 *
 * To run a query within a React component, call `useContraChaveAtivacaoMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useContraChaveAtivacaoMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContraChaveAtivacaoMunicipioQuery({
 *   variables: {
 *   },
 * });
 */
export function useContraChaveAtivacaoMunicipioQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>(ContraChaveAtivacaoMunicipioDocument, options);
      }
export function useContraChaveAtivacaoMunicipioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>(ContraChaveAtivacaoMunicipioDocument, options);
        }
export function useContraChaveAtivacaoMunicipioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>(ContraChaveAtivacaoMunicipioDocument, options);
        }
export type ContraChaveAtivacaoMunicipioQueryHookResult = ReturnType<typeof useContraChaveAtivacaoMunicipioQuery>;
export type ContraChaveAtivacaoMunicipioLazyQueryHookResult = ReturnType<typeof useContraChaveAtivacaoMunicipioLazyQuery>;
export type ContraChaveAtivacaoMunicipioSuspenseQueryHookResult = ReturnType<typeof useContraChaveAtivacaoMunicipioSuspenseQuery>;
export type ContraChaveAtivacaoMunicipioQueryResult = Apollo.QueryResult<Types.ContraChaveAtivacaoMunicipioQuery, Types.ContraChaveAtivacaoMunicipioQueryVariables>;
export const ExcluirConfiguracaoCertificadoDocument = gql`
    mutation ExcluirConfiguracaoCertificado($configuracaoCertificadoId: ID!) {
  excluirConfiguracaoCertificado(
    configuracaoCertificadoId: $configuracaoCertificadoId
  )
}
    `;
export type ExcluirConfiguracaoCertificadoMutationFn = Apollo.MutationFunction<Types.ExcluirConfiguracaoCertificadoMutation, Types.ExcluirConfiguracaoCertificadoMutationVariables>;

/**
 * __useExcluirConfiguracaoCertificadoMutation__
 *
 * To run a mutation, you first call `useExcluirConfiguracaoCertificadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfiguracaoCertificadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfiguracaoCertificadoMutation, { data, loading, error }] = useExcluirConfiguracaoCertificadoMutation({
 *   variables: {
 *      configuracaoCertificadoId: // value for 'configuracaoCertificadoId'
 *   },
 * });
 */
export function useExcluirConfiguracaoCertificadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirConfiguracaoCertificadoMutation, Types.ExcluirConfiguracaoCertificadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirConfiguracaoCertificadoMutation, Types.ExcluirConfiguracaoCertificadoMutationVariables>(ExcluirConfiguracaoCertificadoDocument, options);
      }
export type ExcluirConfiguracaoCertificadoMutationHookResult = ReturnType<typeof useExcluirConfiguracaoCertificadoMutation>;
export type ExcluirConfiguracaoCertificadoMutationResult = Apollo.MutationResult<Types.ExcluirConfiguracaoCertificadoMutation>;
export type ExcluirConfiguracaoCertificadoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirConfiguracaoCertificadoMutation, Types.ExcluirConfiguracaoCertificadoMutationVariables>;
export const ValidarConfiguracaoCertificadoDocument = gql`
    mutation ValidarConfiguracaoCertificado($configuracaoCertificadoInput: ConfiguracaoCertificadoInput!) {
  validarConfiguracaoCertificado(
    configuracaoCertificadoInput: $configuracaoCertificadoInput
  )
}
    `;
export type ValidarConfiguracaoCertificadoMutationFn = Apollo.MutationFunction<Types.ValidarConfiguracaoCertificadoMutation, Types.ValidarConfiguracaoCertificadoMutationVariables>;

/**
 * __useValidarConfiguracaoCertificadoMutation__
 *
 * To run a mutation, you first call `useValidarConfiguracaoCertificadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidarConfiguracaoCertificadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validarConfiguracaoCertificadoMutation, { data, loading, error }] = useValidarConfiguracaoCertificadoMutation({
 *   variables: {
 *      configuracaoCertificadoInput: // value for 'configuracaoCertificadoInput'
 *   },
 * });
 */
export function useValidarConfiguracaoCertificadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ValidarConfiguracaoCertificadoMutation, Types.ValidarConfiguracaoCertificadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ValidarConfiguracaoCertificadoMutation, Types.ValidarConfiguracaoCertificadoMutationVariables>(ValidarConfiguracaoCertificadoDocument, options);
      }
export type ValidarConfiguracaoCertificadoMutationHookResult = ReturnType<typeof useValidarConfiguracaoCertificadoMutation>;
export type ValidarConfiguracaoCertificadoMutationResult = Apollo.MutationResult<Types.ValidarConfiguracaoCertificadoMutation>;
export type ValidarConfiguracaoCertificadoMutationOptions = Apollo.BaseMutationOptions<Types.ValidarConfiguracaoCertificadoMutation, Types.ValidarConfiguracaoCertificadoMutationVariables>;
export const ConfiguracaoAgendaMunicipioDocument = gql`
    query ConfiguracaoAgendaMunicipio {
  duracaoAtendimentoPadraoMunicipio {
    duracaoAtendimentoPadraoMunicipio
  }
  configuracaoHorariosMunicipio {
    id
    configuracaoHorarioAgenda {
      configuracaoDiasSemana {
        diaSemana
        periodos {
          periodo
          horarioInicial
          horarioFinal
        }
      }
    }
  }
}
    `;

/**
 * __useConfiguracaoAgendaMunicipioQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaMunicipioQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoAgendaMunicipioQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>(ConfiguracaoAgendaMunicipioDocument, options);
      }
export function useConfiguracaoAgendaMunicipioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>(ConfiguracaoAgendaMunicipioDocument, options);
        }
export function useConfiguracaoAgendaMunicipioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>(ConfiguracaoAgendaMunicipioDocument, options);
        }
export type ConfiguracaoAgendaMunicipioQueryHookResult = ReturnType<typeof useConfiguracaoAgendaMunicipioQuery>;
export type ConfiguracaoAgendaMunicipioLazyQueryHookResult = ReturnType<typeof useConfiguracaoAgendaMunicipioLazyQuery>;
export type ConfiguracaoAgendaMunicipioSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoAgendaMunicipioSuspenseQuery>;
export type ConfiguracaoAgendaMunicipioQueryResult = Apollo.QueryResult<Types.ConfiguracaoAgendaMunicipioQuery, Types.ConfiguracaoAgendaMunicipioQueryVariables>;
export const SalvarConfiguracaoHorariosMunicipioDocument = gql`
    mutation SalvarConfiguracaoHorariosMunicipio($configuracaoAgendaMunicipalInput: ConfiguracaoAgendaMunicipalInput) {
  salvarConfiguracaoHorariosMunicipio(
    configuracaoAgendaMunicipalInput: $configuracaoAgendaMunicipalInput
  ) {
    id
    configuracaoHorarioAgenda {
      configuracaoDiasSemana {
        diaSemana
        periodos {
          periodo
          horarioInicial
          horarioFinal
        }
      }
    }
  }
}
    `;
export type SalvarConfiguracaoHorariosMunicipioMutationFn = Apollo.MutationFunction<Types.SalvarConfiguracaoHorariosMunicipioMutation, Types.SalvarConfiguracaoHorariosMunicipioMutationVariables>;

/**
 * __useSalvarConfiguracaoHorariosMunicipioMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoHorariosMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoHorariosMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoHorariosMunicipioMutation, { data, loading, error }] = useSalvarConfiguracaoHorariosMunicipioMutation({
 *   variables: {
 *      configuracaoAgendaMunicipalInput: // value for 'configuracaoAgendaMunicipalInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoHorariosMunicipioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarConfiguracaoHorariosMunicipioMutation, Types.SalvarConfiguracaoHorariosMunicipioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarConfiguracaoHorariosMunicipioMutation, Types.SalvarConfiguracaoHorariosMunicipioMutationVariables>(SalvarConfiguracaoHorariosMunicipioDocument, options);
      }
export type SalvarConfiguracaoHorariosMunicipioMutationHookResult = ReturnType<typeof useSalvarConfiguracaoHorariosMunicipioMutation>;
export type SalvarConfiguracaoHorariosMunicipioMutationResult = Apollo.MutationResult<Types.SalvarConfiguracaoHorariosMunicipioMutation>;
export type SalvarConfiguracaoHorariosMunicipioMutationOptions = Apollo.BaseMutationOptions<Types.SalvarConfiguracaoHorariosMunicipioMutation, Types.SalvarConfiguracaoHorariosMunicipioMutationVariables>;
export const SalvarConfiguracaoDuracaoAtendimentoMunicipioDocument = gql`
    mutation SalvarConfiguracaoDuracaoAtendimentoMunicipio($duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput!) {
  alterarDuracaoPadraoAtendimento(
    duracaoAtendimentoPadraoMunicipioInput: $duracaoAtendimentoPadraoMunicipioInput
  ) {
    duracaoAtendimentoPadraoMunicipio
  }
}
    `;
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationFn = Apollo.MutationFunction<Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation, Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables>;

/**
 * __useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoDuracaoAtendimentoMunicipioMutation, { data, loading, error }] = useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation({
 *   variables: {
 *      duracaoAtendimentoPadraoMunicipioInput: // value for 'duracaoAtendimentoPadraoMunicipioInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation, Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation, Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables>(SalvarConfiguracaoDuracaoAtendimentoMunicipioDocument, options);
      }
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationHookResult = ReturnType<typeof useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation>;
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationResult = Apollo.MutationResult<Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation>;
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationOptions = Apollo.BaseMutationOptions<Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation, Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables>;
export const ExcluirGrupoExameDocument = gql`
    mutation ExcluirGrupoExame($id: ID!) {
  excluirGrupoExame(id: $id)
}
    `;
export type ExcluirGrupoExameMutationFn = Apollo.MutationFunction<Types.ExcluirGrupoExameMutation, Types.ExcluirGrupoExameMutationVariables>;

/**
 * __useExcluirGrupoExameMutation__
 *
 * To run a mutation, you first call `useExcluirGrupoExameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirGrupoExameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirGrupoExameMutation, { data, loading, error }] = useExcluirGrupoExameMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirGrupoExameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirGrupoExameMutation, Types.ExcluirGrupoExameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirGrupoExameMutation, Types.ExcluirGrupoExameMutationVariables>(ExcluirGrupoExameDocument, options);
      }
export type ExcluirGrupoExameMutationHookResult = ReturnType<typeof useExcluirGrupoExameMutation>;
export type ExcluirGrupoExameMutationResult = Apollo.MutationResult<Types.ExcluirGrupoExameMutation>;
export type ExcluirGrupoExameMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirGrupoExameMutation, Types.ExcluirGrupoExameMutationVariables>;
export const GrupoExamesDocument = gql`
    query GrupoExames($id: ID!) {
  grupoExame(id: $id) {
    id
    nome
    procedimentos {
      ...Procedimento
    }
  }
}
    ${ProcedimentoFragmentDoc}`;

/**
 * __useGrupoExamesQuery__
 *
 * To run a query within a React component, call `useGrupoExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoExamesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGrupoExamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables> & ({ variables: Types.GrupoExamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>(GrupoExamesDocument, options);
      }
export function useGrupoExamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>(GrupoExamesDocument, options);
        }
export function useGrupoExamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>(GrupoExamesDocument, options);
        }
export type GrupoExamesQueryHookResult = ReturnType<typeof useGrupoExamesQuery>;
export type GrupoExamesLazyQueryHookResult = ReturnType<typeof useGrupoExamesLazyQuery>;
export type GrupoExamesSuspenseQueryHookResult = ReturnType<typeof useGrupoExamesSuspenseQuery>;
export type GrupoExamesQueryResult = Apollo.QueryResult<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>;
export const SalvarGrupoExameDocument = gql`
    mutation SalvarGrupoExame($input: GrupoExameInput!) {
  salvarGrupoExame(input: $input) {
    id
    nome
    procedimentos {
      ...Procedimento
    }
  }
}
    ${ProcedimentoFragmentDoc}`;
export type SalvarGrupoExameMutationFn = Apollo.MutationFunction<Types.SalvarGrupoExameMutation, Types.SalvarGrupoExameMutationVariables>;

/**
 * __useSalvarGrupoExameMutation__
 *
 * To run a mutation, you first call `useSalvarGrupoExameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarGrupoExameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarGrupoExameMutation, { data, loading, error }] = useSalvarGrupoExameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarGrupoExameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarGrupoExameMutation, Types.SalvarGrupoExameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarGrupoExameMutation, Types.SalvarGrupoExameMutationVariables>(SalvarGrupoExameDocument, options);
      }
export type SalvarGrupoExameMutationHookResult = ReturnType<typeof useSalvarGrupoExameMutation>;
export type SalvarGrupoExameMutationResult = Apollo.MutationResult<Types.SalvarGrupoExameMutation>;
export type SalvarGrupoExameMutationOptions = Apollo.BaseMutationOptions<Types.SalvarGrupoExameMutation, Types.SalvarGrupoExameMutationVariables>;
export const GrupoExameTableDocument = gql`
    query GrupoExameTable($input: GrupoExameQueryInput!) {
  gruposExame(input: $input) {
    content {
      id
      nome
      quantidadeProcedimentos
      hasProcedimentosInativos
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGrupoExameTableQuery__
 *
 * To run a query within a React component, call `useGrupoExameTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoExameTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoExameTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrupoExameTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables> & ({ variables: Types.GrupoExameTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>(GrupoExameTableDocument, options);
      }
export function useGrupoExameTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>(GrupoExameTableDocument, options);
        }
export function useGrupoExameTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>(GrupoExameTableDocument, options);
        }
export type GrupoExameTableQueryHookResult = ReturnType<typeof useGrupoExameTableQuery>;
export type GrupoExameTableLazyQueryHookResult = ReturnType<typeof useGrupoExameTableLazyQuery>;
export type GrupoExameTableSuspenseQueryHookResult = ReturnType<typeof useGrupoExameTableSuspenseQuery>;
export type GrupoExameTableQueryResult = Apollo.QueryResult<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>;
export const GerarRelatorioRndsCsvDocument = gql`
    mutation GerarRelatorioRndsCsv($input: GerarRelatorioRndsCsvInput!) {
  gerarRelatorioRndsCsv(input: $input)
}
    `;
export type GerarRelatorioRndsCsvMutationFn = Apollo.MutationFunction<Types.GerarRelatorioRndsCsvMutation, Types.GerarRelatorioRndsCsvMutationVariables>;

/**
 * __useGerarRelatorioRndsCsvMutation__
 *
 * To run a mutation, you first call `useGerarRelatorioRndsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarRelatorioRndsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarRelatorioRndsCsvMutation, { data, loading, error }] = useGerarRelatorioRndsCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGerarRelatorioRndsCsvMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GerarRelatorioRndsCsvMutation, Types.GerarRelatorioRndsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GerarRelatorioRndsCsvMutation, Types.GerarRelatorioRndsCsvMutationVariables>(GerarRelatorioRndsCsvDocument, options);
      }
export type GerarRelatorioRndsCsvMutationHookResult = ReturnType<typeof useGerarRelatorioRndsCsvMutation>;
export type GerarRelatorioRndsCsvMutationResult = Apollo.MutationResult<Types.GerarRelatorioRndsCsvMutation>;
export type GerarRelatorioRndsCsvMutationOptions = Apollo.BaseMutationOptions<Types.GerarRelatorioRndsCsvMutation, Types.GerarRelatorioRndsCsvMutationVariables>;
export const CertificadoRndsDocument = gql`
    query CertificadoRnds {
  configuracaoCertificadoHabilitado {
    id
    rndsHabilitado
  }
  conexao {
    internet {
      habilitado
    }
  }
}
    `;

/**
 * __useCertificadoRndsQuery__
 *
 * To run a query within a React component, call `useCertificadoRndsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificadoRndsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificadoRndsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificadoRndsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>(CertificadoRndsDocument, options);
      }
export function useCertificadoRndsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>(CertificadoRndsDocument, options);
        }
export function useCertificadoRndsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>(CertificadoRndsDocument, options);
        }
export type CertificadoRndsQueryHookResult = ReturnType<typeof useCertificadoRndsQuery>;
export type CertificadoRndsLazyQueryHookResult = ReturnType<typeof useCertificadoRndsLazyQuery>;
export type CertificadoRndsSuspenseQueryHookResult = ReturnType<typeof useCertificadoRndsSuspenseQuery>;
export type CertificadoRndsQueryResult = Apollo.QueryResult<Types.CertificadoRndsQuery, Types.CertificadoRndsQueryVariables>;
export const ResumoEnviosRndsDocument = gql`
    query ResumoEnviosRnds($input: TipoRegistroRndsEnum!) {
  resumoEnviosRnds(input: $input) {
    qtdEnviado
    qtdNaoEnviado
    qtdFalhaConexao
    qtdDadosInvalidos
    qtdErro
  }
}
    `;

/**
 * __useResumoEnviosRndsQuery__
 *
 * To run a query within a React component, call `useResumoEnviosRndsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumoEnviosRndsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumoEnviosRndsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumoEnviosRndsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables> & ({ variables: Types.ResumoEnviosRndsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>(ResumoEnviosRndsDocument, options);
      }
export function useResumoEnviosRndsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>(ResumoEnviosRndsDocument, options);
        }
export function useResumoEnviosRndsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>(ResumoEnviosRndsDocument, options);
        }
export type ResumoEnviosRndsQueryHookResult = ReturnType<typeof useResumoEnviosRndsQuery>;
export type ResumoEnviosRndsLazyQueryHookResult = ReturnType<typeof useResumoEnviosRndsLazyQuery>;
export type ResumoEnviosRndsSuspenseQueryHookResult = ReturnType<typeof useResumoEnviosRndsSuspenseQuery>;
export type ResumoEnviosRndsQueryResult = Apollo.QueryResult<Types.ResumoEnviosRndsQuery, Types.ResumoEnviosRndsQueryVariables>;
export const StatusConexaoRndsDocument = gql`
    query StatusConexaoRnds {
  statusConexaoRnds
}
    `;

/**
 * __useStatusConexaoRndsQuery__
 *
 * To run a query within a React component, call `useStatusConexaoRndsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusConexaoRndsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusConexaoRndsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatusConexaoRndsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>(StatusConexaoRndsDocument, options);
      }
export function useStatusConexaoRndsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>(StatusConexaoRndsDocument, options);
        }
export function useStatusConexaoRndsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>(StatusConexaoRndsDocument, options);
        }
export type StatusConexaoRndsQueryHookResult = ReturnType<typeof useStatusConexaoRndsQuery>;
export type StatusConexaoRndsLazyQueryHookResult = ReturnType<typeof useStatusConexaoRndsLazyQuery>;
export type StatusConexaoRndsSuspenseQueryHookResult = ReturnType<typeof useStatusConexaoRndsSuspenseQuery>;
export type StatusConexaoRndsQueryResult = Apollo.QueryResult<Types.StatusConexaoRndsQuery, Types.StatusConexaoRndsQueryVariables>;
export const EquipeEMultiVinculacoesTableDocument = gql`
    query EquipeEMultiVinculacoesTable($input: TodasVinculacoesEquipesInput!) {
  todasVinculacoesEquipeEmulti(input: $input) {
    content {
      equipeEmulti {
        id
        nome
        ine
      }
      vinculacoesPorEstabelecimento {
        estabelecimento {
          id
          nome
          cnes
        }
        equipes {
          id
          nome
          ine
        }
      }
      quantidadeVinculacoes
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipeEMultiVinculacoesTableQuery__
 *
 * To run a query within a React component, call `useEquipeEMultiVinculacoesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeEMultiVinculacoesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeEMultiVinculacoesTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeEMultiVinculacoesTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables> & ({ variables: Types.EquipeEMultiVinculacoesTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>(EquipeEMultiVinculacoesTableDocument, options);
      }
export function useEquipeEMultiVinculacoesTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>(EquipeEMultiVinculacoesTableDocument, options);
        }
export function useEquipeEMultiVinculacoesTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>(EquipeEMultiVinculacoesTableDocument, options);
        }
export type EquipeEMultiVinculacoesTableQueryHookResult = ReturnType<typeof useEquipeEMultiVinculacoesTableQuery>;
export type EquipeEMultiVinculacoesTableLazyQueryHookResult = ReturnType<typeof useEquipeEMultiVinculacoesTableLazyQuery>;
export type EquipeEMultiVinculacoesTableSuspenseQueryHookResult = ReturnType<typeof useEquipeEMultiVinculacoesTableSuspenseQuery>;
export type EquipeEMultiVinculacoesTableQueryResult = Apollo.QueryResult<Types.EquipeEMultiVinculacoesTableQuery, Types.EquipeEMultiVinculacoesTableQueryVariables>;
export const ExcluirVinculacaoServicoDocument = gql`
    mutation ExcluirVinculacaoServico($referenciaId: Long!) {
  excluirVinculacaoServico(referenciaId: $referenciaId)
}
    `;
export type ExcluirVinculacaoServicoMutationFn = Apollo.MutationFunction<Types.ExcluirVinculacaoServicoMutation, Types.ExcluirVinculacaoServicoMutationVariables>;

/**
 * __useExcluirVinculacaoServicoMutation__
 *
 * To run a mutation, you first call `useExcluirVinculacaoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirVinculacaoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirVinculacaoServicoMutation, { data, loading, error }] = useExcluirVinculacaoServicoMutation({
 *   variables: {
 *      referenciaId: // value for 'referenciaId'
 *   },
 * });
 */
export function useExcluirVinculacaoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirVinculacaoServicoMutation, Types.ExcluirVinculacaoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirVinculacaoServicoMutation, Types.ExcluirVinculacaoServicoMutationVariables>(ExcluirVinculacaoServicoDocument, options);
      }
export type ExcluirVinculacaoServicoMutationHookResult = ReturnType<typeof useExcluirVinculacaoServicoMutation>;
export type ExcluirVinculacaoServicoMutationResult = Apollo.MutationResult<Types.ExcluirVinculacaoServicoMutation>;
export type ExcluirVinculacaoServicoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirVinculacaoServicoMutation, Types.ExcluirVinculacaoServicoMutationVariables>;
export const SalvarVinculacaoServicoDocument = gql`
    mutation SalvarVinculacaoServico($input: SalvarVinculacaoServicoInput!) {
  salvarVinculacaoServico(input: $input)
}
    `;
export type SalvarVinculacaoServicoMutationFn = Apollo.MutationFunction<Types.SalvarVinculacaoServicoMutation, Types.SalvarVinculacaoServicoMutationVariables>;

/**
 * __useSalvarVinculacaoServicoMutation__
 *
 * To run a mutation, you first call `useSalvarVinculacaoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarVinculacaoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarVinculacaoServicoMutation, { data, loading, error }] = useSalvarVinculacaoServicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarVinculacaoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarVinculacaoServicoMutation, Types.SalvarVinculacaoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarVinculacaoServicoMutation, Types.SalvarVinculacaoServicoMutationVariables>(SalvarVinculacaoServicoDocument, options);
      }
export type SalvarVinculacaoServicoMutationHookResult = ReturnType<typeof useSalvarVinculacaoServicoMutation>;
export type SalvarVinculacaoServicoMutationResult = Apollo.MutationResult<Types.SalvarVinculacaoServicoMutation>;
export type SalvarVinculacaoServicoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarVinculacaoServicoMutation, Types.SalvarVinculacaoServicoMutationVariables>;
export const UnidadesSaudeByTipoVinculacaoServicoDocument = gql`
    query UnidadesSaudeByTipoVinculacaoServico($input: UnidadesSaudeByTipoVinculacaoServicoInput!) {
  unidadesSaudeByTipoVinculacaoServico(input: $input) {
    id
    nome
    cnes
    hasVinculacaoServico
  }
}
    `;

/**
 * __useUnidadesSaudeByTipoVinculacaoServicoQuery__
 *
 * To run a query within a React component, call `useUnidadesSaudeByTipoVinculacaoServicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadesSaudeByTipoVinculacaoServicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadesSaudeByTipoVinculacaoServicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadesSaudeByTipoVinculacaoServicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables> & ({ variables: Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>(UnidadesSaudeByTipoVinculacaoServicoDocument, options);
      }
export function useUnidadesSaudeByTipoVinculacaoServicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>(UnidadesSaudeByTipoVinculacaoServicoDocument, options);
        }
export function useUnidadesSaudeByTipoVinculacaoServicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>(UnidadesSaudeByTipoVinculacaoServicoDocument, options);
        }
export type UnidadesSaudeByTipoVinculacaoServicoQueryHookResult = ReturnType<typeof useUnidadesSaudeByTipoVinculacaoServicoQuery>;
export type UnidadesSaudeByTipoVinculacaoServicoLazyQueryHookResult = ReturnType<typeof useUnidadesSaudeByTipoVinculacaoServicoLazyQuery>;
export type UnidadesSaudeByTipoVinculacaoServicoSuspenseQueryHookResult = ReturnType<typeof useUnidadesSaudeByTipoVinculacaoServicoSuspenseQuery>;
export type UnidadesSaudeByTipoVinculacaoServicoQueryResult = Apollo.QueryResult<Types.UnidadesSaudeByTipoVinculacaoServicoQuery, Types.UnidadesSaudeByTipoVinculacaoServicoQueryVariables>;
export const VinculacoesEstabelecimentosTableDocument = gql`
    query VinculacoesEstabelecimentosTable($input: VinculacaoServicosInput!) {
  vinculacoesServico(input: $input) {
    content {
      referencia {
        id
        nome
        cnes
      }
      vinculacoes {
        id
        nome
        cnes
      }
      quantidadeVinculacoes
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useVinculacoesEstabelecimentosTableQuery__
 *
 * To run a query within a React component, call `useVinculacoesEstabelecimentosTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useVinculacoesEstabelecimentosTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVinculacoesEstabelecimentosTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVinculacoesEstabelecimentosTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables> & ({ variables: Types.VinculacoesEstabelecimentosTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>(VinculacoesEstabelecimentosTableDocument, options);
      }
export function useVinculacoesEstabelecimentosTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>(VinculacoesEstabelecimentosTableDocument, options);
        }
export function useVinculacoesEstabelecimentosTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>(VinculacoesEstabelecimentosTableDocument, options);
        }
export type VinculacoesEstabelecimentosTableQueryHookResult = ReturnType<typeof useVinculacoesEstabelecimentosTableQuery>;
export type VinculacoesEstabelecimentosTableLazyQueryHookResult = ReturnType<typeof useVinculacoesEstabelecimentosTableLazyQuery>;
export type VinculacoesEstabelecimentosTableSuspenseQueryHookResult = ReturnType<typeof useVinculacoesEstabelecimentosTableSuspenseQuery>;
export type VinculacoesEstabelecimentosTableQueryResult = Apollo.QueryResult<Types.VinculacoesEstabelecimentosTableQuery, Types.VinculacoesEstabelecimentosTableQueryVariables>;
export const VinculacaoServicoDocument = gql`
    query VinculacaoServico($referenciaId: Long!) {
  vinculacaoServico(referenciaId: $referenciaId) {
    referencia {
      id
      nome
      cnes
    }
    vinculacoes {
      id
      nome
      cnes
    }
  }
}
    `;

/**
 * __useVinculacaoServicoQuery__
 *
 * To run a query within a React component, call `useVinculacaoServicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVinculacaoServicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVinculacaoServicoQuery({
 *   variables: {
 *      referenciaId: // value for 'referenciaId'
 *   },
 * });
 */
export function useVinculacaoServicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables> & ({ variables: Types.VinculacaoServicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>(VinculacaoServicoDocument, options);
      }
export function useVinculacaoServicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>(VinculacaoServicoDocument, options);
        }
export function useVinculacaoServicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>(VinculacaoServicoDocument, options);
        }
export type VinculacaoServicoQueryHookResult = ReturnType<typeof useVinculacaoServicoQuery>;
export type VinculacaoServicoLazyQueryHookResult = ReturnType<typeof useVinculacaoServicoLazyQuery>;
export type VinculacaoServicoSuspenseQueryHookResult = ReturnType<typeof useVinculacaoServicoSuspenseQuery>;
export type VinculacaoServicoQueryResult = Apollo.QueryResult<Types.VinculacaoServicoQuery, Types.VinculacaoServicoQueryVariables>;
export const TipoServicoCheckDocument = gql`
    query TipoServicoCheck($input: TipoServicoQueryInput!) {
  tiposServico(input: $input) {
    content {
      id
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTipoServicoCheckQuery__
 *
 * To run a query within a React component, call `useTipoServicoCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoCheckQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables> & ({ variables: Types.TipoServicoCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>(TipoServicoCheckDocument, options);
      }
export function useTipoServicoCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>(TipoServicoCheckDocument, options);
        }
export function useTipoServicoCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>(TipoServicoCheckDocument, options);
        }
export type TipoServicoCheckQueryHookResult = ReturnType<typeof useTipoServicoCheckQuery>;
export type TipoServicoCheckLazyQueryHookResult = ReturnType<typeof useTipoServicoCheckLazyQuery>;
export type TipoServicoCheckSuspenseQueryHookResult = ReturnType<typeof useTipoServicoCheckSuspenseQuery>;
export type TipoServicoCheckQueryResult = Apollo.QueryResult<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>;
export const TipoServicoTableDocument = gql`
    query TipoServicoTable($input: TipoServicoQueryInput!) {
  tiposServico(input: $input) {
    content {
      id
      nome
      tiposEstabelecimento
      municipio {
        id
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTipoServicoTableQuery__
 *
 * To run a query within a React component, call `useTipoServicoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables> & ({ variables: Types.TipoServicoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>(TipoServicoTableDocument, options);
      }
export function useTipoServicoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>(TipoServicoTableDocument, options);
        }
export function useTipoServicoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>(TipoServicoTableDocument, options);
        }
export type TipoServicoTableQueryHookResult = ReturnType<typeof useTipoServicoTableQuery>;
export type TipoServicoTableLazyQueryHookResult = ReturnType<typeof useTipoServicoTableLazyQuery>;
export type TipoServicoTableSuspenseQueryHookResult = ReturnType<typeof useTipoServicoTableSuspenseQuery>;
export type TipoServicoTableQueryResult = Apollo.QueryResult<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>;
export const AlterarTipoServicoDocument = gql`
    mutation AlterarTipoServico($input: TipoServicoUpdateInput!) {
  alterarTipoServico(input: $input) {
    id
    nome
  }
}
    `;
export type AlterarTipoServicoMutationFn = Apollo.MutationFunction<Types.AlterarTipoServicoMutation, Types.AlterarTipoServicoMutationVariables>;

/**
 * __useAlterarTipoServicoMutation__
 *
 * To run a mutation, you first call `useAlterarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarTipoServicoMutation, { data, loading, error }] = useAlterarTipoServicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarTipoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarTipoServicoMutation, Types.AlterarTipoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarTipoServicoMutation, Types.AlterarTipoServicoMutationVariables>(AlterarTipoServicoDocument, options);
      }
export type AlterarTipoServicoMutationHookResult = ReturnType<typeof useAlterarTipoServicoMutation>;
export type AlterarTipoServicoMutationResult = Apollo.MutationResult<Types.AlterarTipoServicoMutation>;
export type AlterarTipoServicoMutationOptions = Apollo.BaseMutationOptions<Types.AlterarTipoServicoMutation, Types.AlterarTipoServicoMutationVariables>;
export const SalvarTipoServicoDocument = gql`
    mutation SalvarTipoServico($input: TipoServicoInput!) {
  salvarTipoServico(input: $input) {
    id
    nome
  }
}
    `;
export type SalvarTipoServicoMutationFn = Apollo.MutationFunction<Types.SalvarTipoServicoMutation, Types.SalvarTipoServicoMutationVariables>;

/**
 * __useSalvarTipoServicoMutation__
 *
 * To run a mutation, you first call `useSalvarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarTipoServicoMutation, { data, loading, error }] = useSalvarTipoServicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarTipoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarTipoServicoMutation, Types.SalvarTipoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarTipoServicoMutation, Types.SalvarTipoServicoMutationVariables>(SalvarTipoServicoDocument, options);
      }
export type SalvarTipoServicoMutationHookResult = ReturnType<typeof useSalvarTipoServicoMutation>;
export type SalvarTipoServicoMutationResult = Apollo.MutationResult<Types.SalvarTipoServicoMutation>;
export type SalvarTipoServicoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarTipoServicoMutation, Types.SalvarTipoServicoMutationVariables>;
export const ExcluirTipoServicoDocument = gql`
    mutation ExcluirTipoServico($id: ID!) {
  excluirTipoServico(id: $id)
}
    `;
export type ExcluirTipoServicoMutationFn = Apollo.MutationFunction<Types.ExcluirTipoServicoMutation, Types.ExcluirTipoServicoMutationVariables>;

/**
 * __useExcluirTipoServicoMutation__
 *
 * To run a mutation, you first call `useExcluirTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirTipoServicoMutation, { data, loading, error }] = useExcluirTipoServicoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirTipoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirTipoServicoMutation, Types.ExcluirTipoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirTipoServicoMutation, Types.ExcluirTipoServicoMutationVariables>(ExcluirTipoServicoDocument, options);
      }
export type ExcluirTipoServicoMutationHookResult = ReturnType<typeof useExcluirTipoServicoMutation>;
export type ExcluirTipoServicoMutationResult = Apollo.MutationResult<Types.ExcluirTipoServicoMutation>;
export type ExcluirTipoServicoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirTipoServicoMutation, Types.ExcluirTipoServicoMutationVariables>;
export const CuidadoCompartilhadoFinalizacoesDocument = gql`
    query cuidadoCompartilhadoFinalizacoes($input: CuidadoCompartilhadoEvolucoesQueryInput!) {
  cuidadoCompartilhadoFinalizacoes(input: $input) {
    content {
      id
      dataFinalizado
      dataReaberto
      sequenciaEvolucao
    }
  }
}
    `;

/**
 * __useCuidadoCompartilhadoFinalizacoesQuery__
 *
 * To run a query within a React component, call `useCuidadoCompartilhadoFinalizacoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuidadoCompartilhadoFinalizacoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuidadoCompartilhadoFinalizacoesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCuidadoCompartilhadoFinalizacoesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables> & ({ variables: Types.CuidadoCompartilhadoFinalizacoesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>(CuidadoCompartilhadoFinalizacoesDocument, options);
      }
export function useCuidadoCompartilhadoFinalizacoesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>(CuidadoCompartilhadoFinalizacoesDocument, options);
        }
export function useCuidadoCompartilhadoFinalizacoesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>(CuidadoCompartilhadoFinalizacoesDocument, options);
        }
export type CuidadoCompartilhadoFinalizacoesQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoFinalizacoesQuery>;
export type CuidadoCompartilhadoFinalizacoesLazyQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoFinalizacoesLazyQuery>;
export type CuidadoCompartilhadoFinalizacoesSuspenseQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoFinalizacoesSuspenseQuery>;
export type CuidadoCompartilhadoFinalizacoesQueryResult = Apollo.QueryResult<Types.CuidadoCompartilhadoFinalizacoesQuery, Types.CuidadoCompartilhadoFinalizacoesQueryVariables>;
export const CuidadoCompartilhadoDocument = gql`
    query CuidadoCompartilhado($id: ID!) {
  cuidadoCompartilhado(id: $id) {
    id
    iniciadoEm
    classificacaoPrioridadeAtual
    cidadaoAceitaAtendTic
    discussao
    status
    tempoDecorridoUltimaEvolucao
    cid10 {
      ...Cid10
    }
    ciap {
      ...Ciap
    }
    lotacaoExecutanteAtual {
      id
      profissional {
        id
        nome
        nomeCivil
        nomeSocial
        telefone
        email
      }
      cbo {
        id
        nome
      }
      equipe {
        id
        nome
        ine
      }
      unidadeSaude {
        id
        nome
      }
    }
    cboExecutanteAtual {
      id
      nome
    }
    unidadeSaudeExecutanteAtual {
      id
      nome
      tipo {
        id
        codigoMs
      }
      subtipo {
        id
        codigoMs
      }
    }
    lotacaoSolicitante {
      id
      profissional {
        id
        nome
        nomeCivil
        nomeSocial
        telefone
        email
      }
      cbo {
        id
        nome
      }
      equipe {
        id
        nome
        ine
      }
      unidadeSaude {
        id
        nome
      }
    }
    cidadao {
      id
      cpf
      cns
      nome
      nomeSocial
      dataNascimento
      dataAtualizado
      sexo
      nomeMae
      telefoneResidencial
      telefoneCelular
      telefoneContato
      email
      identidadeGeneroDbEnum
      ativo
      faleceu
      possuiAgendamento
      unificado
      unificacaoBase
      prontuario {
        id
        preNatalAtivo {
          id
          ultimaDum
        }
        gestacoes {
          id
          inicio
          fim
        }
      }
      cidadaoVinculacaoEquipe {
        id
        tpCdsOrigem
        unidadeSaude {
          id
          nome
        }
        equipe {
          id
          nome
          ine
        }
      }
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}`;

/**
 * __useCuidadoCompartilhadoQuery__
 *
 * To run a query within a React component, call `useCuidadoCompartilhadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuidadoCompartilhadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuidadoCompartilhadoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCuidadoCompartilhadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables> & ({ variables: Types.CuidadoCompartilhadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>(CuidadoCompartilhadoDocument, options);
      }
export function useCuidadoCompartilhadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>(CuidadoCompartilhadoDocument, options);
        }
export function useCuidadoCompartilhadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>(CuidadoCompartilhadoDocument, options);
        }
export type CuidadoCompartilhadoQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoQuery>;
export type CuidadoCompartilhadoLazyQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoLazyQuery>;
export type CuidadoCompartilhadoSuspenseQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoSuspenseQuery>;
export type CuidadoCompartilhadoQueryResult = Apollo.QueryResult<Types.CuidadoCompartilhadoQuery, Types.CuidadoCompartilhadoQueryVariables>;
export const SalvarCuidadoCompartilhadoDocument = gql`
    mutation SalvarCuidadoCompartilhado($input: SalvarCuidadoCompartilhadoInput!) {
  salvarCuidadoCompartilhado(input: $input) {
    id
  }
}
    `;
export type SalvarCuidadoCompartilhadoMutationFn = Apollo.MutationFunction<Types.SalvarCuidadoCompartilhadoMutation, Types.SalvarCuidadoCompartilhadoMutationVariables>;

/**
 * __useSalvarCuidadoCompartilhadoMutation__
 *
 * To run a mutation, you first call `useSalvarCuidadoCompartilhadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarCuidadoCompartilhadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarCuidadoCompartilhadoMutation, { data, loading, error }] = useSalvarCuidadoCompartilhadoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarCuidadoCompartilhadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarCuidadoCompartilhadoMutation, Types.SalvarCuidadoCompartilhadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarCuidadoCompartilhadoMutation, Types.SalvarCuidadoCompartilhadoMutationVariables>(SalvarCuidadoCompartilhadoDocument, options);
      }
export type SalvarCuidadoCompartilhadoMutationHookResult = ReturnType<typeof useSalvarCuidadoCompartilhadoMutation>;
export type SalvarCuidadoCompartilhadoMutationResult = Apollo.MutationResult<Types.SalvarCuidadoCompartilhadoMutation>;
export type SalvarCuidadoCompartilhadoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarCuidadoCompartilhadoMutation, Types.SalvarCuidadoCompartilhadoMutationVariables>;
export const CboTrocaExecutanteSelectFieldDocument = gql`
    query CboTrocaExecutanteSelectField($input: CbosTrocaExecutanteCuidadoCompartilhadoQueryInput!) {
  cbosTrocaExecutante(input: $input) {
    content {
      id
      nome
      cbo2002
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCboTrocaExecutanteSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboTrocaExecutanteSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboTrocaExecutanteSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboTrocaExecutanteSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboTrocaExecutanteSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables> & ({ variables: Types.CboTrocaExecutanteSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>(CboTrocaExecutanteSelectFieldDocument, options);
      }
export function useCboTrocaExecutanteSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>(CboTrocaExecutanteSelectFieldDocument, options);
        }
export function useCboTrocaExecutanteSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>(CboTrocaExecutanteSelectFieldDocument, options);
        }
export type CboTrocaExecutanteSelectFieldQueryHookResult = ReturnType<typeof useCboTrocaExecutanteSelectFieldQuery>;
export type CboTrocaExecutanteSelectFieldLazyQueryHookResult = ReturnType<typeof useCboTrocaExecutanteSelectFieldLazyQuery>;
export type CboTrocaExecutanteSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCboTrocaExecutanteSelectFieldSuspenseQuery>;
export type CboTrocaExecutanteSelectFieldQueryResult = Apollo.QueryResult<Types.CboTrocaExecutanteSelectFieldQuery, Types.CboTrocaExecutanteSelectFieldQueryVariables>;
export const CuidadoCompartilhadoEvolucoesDocument = gql`
    query CuidadoCompartilhadoEvolucoes($input: CuidadoCompartilhadoEvolucoesQueryInput!) {
  cuidadoCompartilhadoEvolucoes(input: $input) {
    content {
      id
      dataEvolucao
      conduta
      descricao
      classificacaoPrioridade
      reclassificacaoPrioridade
      enviarGarantiaAcesso
      codigoSequencialEvolucao
      lotacao {
        id
        profissional {
          id
          nome
        }
      }
      lotacaoExecutante {
        id
      }
      lotacaoAfetada {
        id
        profissional {
          id
          nome
        }
        cbo {
          id
          nome
        }
        equipe {
          id
          nome
        }
        unidadeSaude {
          id
          nome
        }
      }
      agenda {
        id
        horarioInicial
        situacao
        observacao
        justificativaCancelamento {
          id
          justificativa
        }
      }
      cuidadoCompartilhado {
        id
        lotacaoSolicitante {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCuidadoCompartilhadoEvolucoesQuery__
 *
 * To run a query within a React component, call `useCuidadoCompartilhadoEvolucoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuidadoCompartilhadoEvolucoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuidadoCompartilhadoEvolucoesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCuidadoCompartilhadoEvolucoesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables> & ({ variables: Types.CuidadoCompartilhadoEvolucoesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>(CuidadoCompartilhadoEvolucoesDocument, options);
      }
export function useCuidadoCompartilhadoEvolucoesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>(CuidadoCompartilhadoEvolucoesDocument, options);
        }
export function useCuidadoCompartilhadoEvolucoesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>(CuidadoCompartilhadoEvolucoesDocument, options);
        }
export type CuidadoCompartilhadoEvolucoesQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoEvolucoesQuery>;
export type CuidadoCompartilhadoEvolucoesLazyQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoEvolucoesLazyQuery>;
export type CuidadoCompartilhadoEvolucoesSuspenseQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoEvolucoesSuspenseQuery>;
export type CuidadoCompartilhadoEvolucoesQueryResult = Apollo.QueryResult<Types.CuidadoCompartilhadoEvolucoesQuery, Types.CuidadoCompartilhadoEvolucoesQueryVariables>;
export const VisualizarCuidadoCompartilhadoDocument = gql`
    mutation VisualizarCuidadoCompartilhado($input: VisualizarCuidadoCompartilhadoInput!) {
  visualizarCuidadoCompartilhado(input: $input)
}
    `;
export type VisualizarCuidadoCompartilhadoMutationFn = Apollo.MutationFunction<Types.VisualizarCuidadoCompartilhadoMutation, Types.VisualizarCuidadoCompartilhadoMutationVariables>;

/**
 * __useVisualizarCuidadoCompartilhadoMutation__
 *
 * To run a mutation, you first call `useVisualizarCuidadoCompartilhadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisualizarCuidadoCompartilhadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visualizarCuidadoCompartilhadoMutation, { data, loading, error }] = useVisualizarCuidadoCompartilhadoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisualizarCuidadoCompartilhadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.VisualizarCuidadoCompartilhadoMutation, Types.VisualizarCuidadoCompartilhadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.VisualizarCuidadoCompartilhadoMutation, Types.VisualizarCuidadoCompartilhadoMutationVariables>(VisualizarCuidadoCompartilhadoDocument, options);
      }
export type VisualizarCuidadoCompartilhadoMutationHookResult = ReturnType<typeof useVisualizarCuidadoCompartilhadoMutation>;
export type VisualizarCuidadoCompartilhadoMutationResult = Apollo.MutationResult<Types.VisualizarCuidadoCompartilhadoMutation>;
export type VisualizarCuidadoCompartilhadoMutationOptions = Apollo.BaseMutationOptions<Types.VisualizarCuidadoCompartilhadoMutation, Types.VisualizarCuidadoCompartilhadoMutationVariables>;
export const CuidadoCompartilhadoNotificacaoDocument = gql`
    query CuidadoCompartilhadoNotificacao($input: CuidadosCompartilhadoQueryInput!) {
  cuidadosCompartilhado(input: $input) {
    content {
      id
      lotacaoExecutanteAtual {
        id
      }
      lotacaoSolicitante {
        id
      }
    }
  }
}
    `;

/**
 * __useCuidadoCompartilhadoNotificacaoQuery__
 *
 * To run a query within a React component, call `useCuidadoCompartilhadoNotificacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuidadoCompartilhadoNotificacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuidadoCompartilhadoNotificacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCuidadoCompartilhadoNotificacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables> & ({ variables: Types.CuidadoCompartilhadoNotificacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>(CuidadoCompartilhadoNotificacaoDocument, options);
      }
export function useCuidadoCompartilhadoNotificacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>(CuidadoCompartilhadoNotificacaoDocument, options);
        }
export function useCuidadoCompartilhadoNotificacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>(CuidadoCompartilhadoNotificacaoDocument, options);
        }
export type CuidadoCompartilhadoNotificacaoQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoNotificacaoQuery>;
export type CuidadoCompartilhadoNotificacaoLazyQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoNotificacaoLazyQuery>;
export type CuidadoCompartilhadoNotificacaoSuspenseQueryHookResult = ReturnType<typeof useCuidadoCompartilhadoNotificacaoSuspenseQuery>;
export type CuidadoCompartilhadoNotificacaoQueryResult = Apollo.QueryResult<Types.CuidadoCompartilhadoNotificacaoQuery, Types.CuidadoCompartilhadoNotificacaoQueryVariables>;
export const IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoDocument = gql`
    query IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServico($tipoCoMs: Long!) {
  isTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServico(tipoCoMs: $tipoCoMs)
}
    `;

/**
 * __useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery__
 *
 * To run a query within a React component, call `useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery({
 *   variables: {
 *      tipoCoMs: // value for 'tipoCoMs'
 *   },
 * });
 */
export function useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables> & ({ variables: Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>(IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoDocument, options);
      }
export function useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>(IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoDocument, options);
        }
export function useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>(IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoDocument, options);
        }
export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryHookResult = ReturnType<typeof useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery>;
export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoLazyQueryHookResult = ReturnType<typeof useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoLazyQuery>;
export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoSuspenseQueryHookResult = ReturnType<typeof useIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoSuspenseQuery>;
export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryResult = Apollo.QueryResult<Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery, Types.IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables>;
export const ListaCuidadoCompartilhadoDocument = gql`
    query ListaCuidadoCompartilhado($input: CuidadosCompartilhadoQueryInput!) {
  cuidadosCompartilhado(input: $input) {
    content {
      id
      iniciadoEm
      cidadao {
        id
        dataNascimento
        nomeSocial
        nome
      }
      classificacaoPrioridadeAtual
      lotacaoExecutanteAtual {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        equipe {
          id
          nome
        }
      }
      cboExecutanteAtual {
        id
        nome
      }
      unidadeSaudeExecutanteAtual {
        id
        nome
      }
      lotacaoSolicitante {
        id
        profissional {
          id
          nome
          nomeSocial
        }
        cbo {
          id
          nome
        }
        equipe {
          id
          nome
        }
        unidadeSaude {
          id
          nome
        }
      }
      status
      discussao
      tempoDecorridoUltimaEvolucao
      cid10 {
        ...Cid10
      }
      ciap {
        ...Ciap
      }
      actions {
        discutirCasoSolicitante {
          enabled
          hint
        }
        discutirCasoExecutante {
          enabled
          hint
        }
        visualizarDiscussao {
          enabled
          hint
        }
        tornarseExecutante {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useListaCuidadoCompartilhadoQuery__
 *
 * To run a query within a React component, call `useListaCuidadoCompartilhadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaCuidadoCompartilhadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaCuidadoCompartilhadoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaCuidadoCompartilhadoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables> & ({ variables: Types.ListaCuidadoCompartilhadoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>(ListaCuidadoCompartilhadoDocument, options);
      }
export function useListaCuidadoCompartilhadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>(ListaCuidadoCompartilhadoDocument, options);
        }
export function useListaCuidadoCompartilhadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>(ListaCuidadoCompartilhadoDocument, options);
        }
export type ListaCuidadoCompartilhadoQueryHookResult = ReturnType<typeof useListaCuidadoCompartilhadoQuery>;
export type ListaCuidadoCompartilhadoLazyQueryHookResult = ReturnType<typeof useListaCuidadoCompartilhadoLazyQuery>;
export type ListaCuidadoCompartilhadoSuspenseQueryHookResult = ReturnType<typeof useListaCuidadoCompartilhadoSuspenseQuery>;
export type ListaCuidadoCompartilhadoQueryResult = Apollo.QueryResult<Types.ListaCuidadoCompartilhadoQuery, Types.ListaCuidadoCompartilhadoQueryVariables>;
export const CbosCuidadoCompartilhadoSelectFieldDocument = gql`
    query CbosCuidadoCompartilhadoSelectField($input: CbosListaCuidadoCompartilhadoQueryInput!) {
  cbosListaCuidadoCompartilhado(input: $input) {
    id
    nome
    cbo2002
  }
}
    `;

/**
 * __useCbosCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCbosCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbosCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCbosCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCbosCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>(CbosCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useCbosCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>(CbosCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useCbosCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>(CbosCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type CbosCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useCbosCuidadoCompartilhadoSelectFieldQuery>;
export type CbosCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useCbosCuidadoCompartilhadoSelectFieldLazyQuery>;
export type CbosCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useCbosCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type CbosCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.CbosCuidadoCompartilhadoSelectFieldQuery, Types.CbosCuidadoCompartilhadoSelectFieldQueryVariables>;
export const EquipeCuidadoCompartilhadoSelectFieldDocument = gql`
    query EquipeCuidadoCompartilhadoSelectField($input: EquipesListaCuidadoCompartilhadoQueryInput!) {
  equipesListaCuidadoCompartilhado(input: $input) {
    id
    nome
    ine
    tipoEquipe {
      id
      sigla
    }
  }
}
    `;

/**
 * __useEquipeCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>(EquipeCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useEquipeCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>(EquipeCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useEquipeCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>(EquipeCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type EquipeCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useEquipeCuidadoCompartilhadoSelectFieldQuery>;
export type EquipeCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeCuidadoCompartilhadoSelectFieldLazyQuery>;
export type EquipeCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEquipeCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type EquipeCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.EquipeCuidadoCompartilhadoSelectFieldQuery, Types.EquipeCuidadoCompartilhadoSelectFieldQueryVariables>;
export const UnidadeSaudeCuidadoCompartilhadoSelectFieldDocument = gql`
    query UnidadeSaudeCuidadoCompartilhadoSelectField($input: EstabelecimentosListaCuidadoCompartilhadoQueryInput!) {
  estabelecimentosListaCuidadoCompartilhado(input: $input) {
    id
    nome
    cnes
  }
}
    `;

/**
 * __useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>(UnidadeSaudeCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useUnidadeSaudeCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>(UnidadeSaudeCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useUnidadeSaudeCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>(UnidadeSaudeCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useUnidadeSaudeCuidadoCompartilhadoSelectFieldQuery>;
export type UnidadeSaudeCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeCuidadoCompartilhadoSelectFieldLazyQuery>;
export type UnidadeSaudeCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useUnidadeSaudeCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery, Types.UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables>;
export const ProfissionaisCuidadoCompartilhadoSelectFieldDocument = gql`
    query ProfissionaisCuidadoCompartilhadoSelectField($input: ProfissionaisListaCuidadoCompartilhadoQueryInput!) {
  profissionaisListaCuidadoCompartilhado(input: $input) {
    id
    nome
    cpf
  }
}
    `;

/**
 * __useProfissionaisCuidadoCompartilhadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProfissionaisCuidadoCompartilhadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionaisCuidadoCompartilhadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionaisCuidadoCompartilhadoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionaisCuidadoCompartilhadoSelectFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables> & ({ variables: Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>(ProfissionaisCuidadoCompartilhadoSelectFieldDocument, options);
      }
export function useProfissionaisCuidadoCompartilhadoSelectFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>(ProfissionaisCuidadoCompartilhadoSelectFieldDocument, options);
        }
export function useProfissionaisCuidadoCompartilhadoSelectFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>(ProfissionaisCuidadoCompartilhadoSelectFieldDocument, options);
        }
export type ProfissionaisCuidadoCompartilhadoSelectFieldQueryHookResult = ReturnType<typeof useProfissionaisCuidadoCompartilhadoSelectFieldQuery>;
export type ProfissionaisCuidadoCompartilhadoSelectFieldLazyQueryHookResult = ReturnType<typeof useProfissionaisCuidadoCompartilhadoSelectFieldLazyQuery>;
export type ProfissionaisCuidadoCompartilhadoSelectFieldSuspenseQueryHookResult = ReturnType<typeof useProfissionaisCuidadoCompartilhadoSelectFieldSuspenseQuery>;
export type ProfissionaisCuidadoCompartilhadoSelectFieldQueryResult = Apollo.QueryResult<Types.ProfissionaisCuidadoCompartilhadoSelectFieldQuery, Types.ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables>;
export const TornarseExecutanteCuidadoCompartilhadoDocument = gql`
    mutation TornarseExecutanteCuidadoCompartilhado($id: ID!) {
  tornarseExecutanteCuidadoCompartilhado(id: $id) {
    id
  }
}
    `;
export type TornarseExecutanteCuidadoCompartilhadoMutationFn = Apollo.MutationFunction<Types.TornarseExecutanteCuidadoCompartilhadoMutation, Types.TornarseExecutanteCuidadoCompartilhadoMutationVariables>;

/**
 * __useTornarseExecutanteCuidadoCompartilhadoMutation__
 *
 * To run a mutation, you first call `useTornarseExecutanteCuidadoCompartilhadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTornarseExecutanteCuidadoCompartilhadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tornarseExecutanteCuidadoCompartilhadoMutation, { data, loading, error }] = useTornarseExecutanteCuidadoCompartilhadoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTornarseExecutanteCuidadoCompartilhadoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TornarseExecutanteCuidadoCompartilhadoMutation, Types.TornarseExecutanteCuidadoCompartilhadoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TornarseExecutanteCuidadoCompartilhadoMutation, Types.TornarseExecutanteCuidadoCompartilhadoMutationVariables>(TornarseExecutanteCuidadoCompartilhadoDocument, options);
      }
export type TornarseExecutanteCuidadoCompartilhadoMutationHookResult = ReturnType<typeof useTornarseExecutanteCuidadoCompartilhadoMutation>;
export type TornarseExecutanteCuidadoCompartilhadoMutationResult = Apollo.MutationResult<Types.TornarseExecutanteCuidadoCompartilhadoMutation>;
export type TornarseExecutanteCuidadoCompartilhadoMutationOptions = Apollo.BaseMutationOptions<Types.TornarseExecutanteCuidadoCompartilhadoMutation, Types.TornarseExecutanteCuidadoCompartilhadoMutationVariables>;
export const AutorizacaoRetiradaAbsorventesDocument = gql`
    query AutorizacaoRetiradaAbsorventes($cidadaoId: ID!) {
  autorizacaoRetiradaAbsorventeByCidadaoId(id: $cidadaoId) {
    autorizacao {
      id
      hash
      codigoRms
      ufRms
      cidadao {
        id
        cns
        dataNascimento
        nome
        nomeMae
      }
    }
    status
  }
}
    `;

/**
 * __useAutorizacaoRetiradaAbsorventesQuery__
 *
 * To run a query within a React component, call `useAutorizacaoRetiradaAbsorventesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutorizacaoRetiradaAbsorventesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutorizacaoRetiradaAbsorventesQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useAutorizacaoRetiradaAbsorventesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables> & ({ variables: Types.AutorizacaoRetiradaAbsorventesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>(AutorizacaoRetiradaAbsorventesDocument, options);
      }
export function useAutorizacaoRetiradaAbsorventesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>(AutorizacaoRetiradaAbsorventesDocument, options);
        }
export function useAutorizacaoRetiradaAbsorventesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>(AutorizacaoRetiradaAbsorventesDocument, options);
        }
export type AutorizacaoRetiradaAbsorventesQueryHookResult = ReturnType<typeof useAutorizacaoRetiradaAbsorventesQuery>;
export type AutorizacaoRetiradaAbsorventesLazyQueryHookResult = ReturnType<typeof useAutorizacaoRetiradaAbsorventesLazyQuery>;
export type AutorizacaoRetiradaAbsorventesSuspenseQueryHookResult = ReturnType<typeof useAutorizacaoRetiradaAbsorventesSuspenseQuery>;
export type AutorizacaoRetiradaAbsorventesQueryResult = Apollo.QueryResult<Types.AutorizacaoRetiradaAbsorventesQuery, Types.AutorizacaoRetiradaAbsorventesQueryVariables>;
export const ConfiguracaoCertificadoDignidadeMenstrualDocument = gql`
    query configuracaoCertificadoDignidadeMenstrual {
  configuracaoCertificadoHabilitado {
    id
    farmaciaHabilitado
  }
}
    `;

/**
 * __useConfiguracaoCertificadoDignidadeMenstrualQuery__
 *
 * To run a query within a React component, call `useConfiguracaoCertificadoDignidadeMenstrualQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoCertificadoDignidadeMenstrualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoCertificadoDignidadeMenstrualQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoCertificadoDignidadeMenstrualQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>(ConfiguracaoCertificadoDignidadeMenstrualDocument, options);
      }
export function useConfiguracaoCertificadoDignidadeMenstrualLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>(ConfiguracaoCertificadoDignidadeMenstrualDocument, options);
        }
export function useConfiguracaoCertificadoDignidadeMenstrualSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>(ConfiguracaoCertificadoDignidadeMenstrualDocument, options);
        }
export type ConfiguracaoCertificadoDignidadeMenstrualQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoDignidadeMenstrualQuery>;
export type ConfiguracaoCertificadoDignidadeMenstrualLazyQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoDignidadeMenstrualLazyQuery>;
export type ConfiguracaoCertificadoDignidadeMenstrualSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoCertificadoDignidadeMenstrualSuspenseQuery>;
export type ConfiguracaoCertificadoDignidadeMenstrualQueryResult = Apollo.QueryResult<Types.ConfiguracaoCertificadoDignidadeMenstrualQuery, Types.ConfiguracaoCertificadoDignidadeMenstrualQueryVariables>;
export const EquipeDetailDocument = gql`
    query EquipeDetail($id: ID!) {
  equipe(id: $id) {
    id
    nome
    ine
    area
    ativo
    tipoEquipe {
      id
      nome
      sigla
    }
  }
}
    `;

/**
 * __useEquipeDetailQuery__
 *
 * To run a query within a React component, call `useEquipeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipeDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables> & ({ variables: Types.EquipeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>(EquipeDetailDocument, options);
      }
export function useEquipeDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>(EquipeDetailDocument, options);
        }
export function useEquipeDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>(EquipeDetailDocument, options);
        }
export type EquipeDetailQueryHookResult = ReturnType<typeof useEquipeDetailQuery>;
export type EquipeDetailLazyQueryHookResult = ReturnType<typeof useEquipeDetailLazyQuery>;
export type EquipeDetailSuspenseQueryHookResult = ReturnType<typeof useEquipeDetailSuspenseQuery>;
export type EquipeDetailQueryResult = Apollo.QueryResult<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>;
export const EquipeTableDocument = gql`
    query EquipeTable($input: EquipesQueryInput!) {
  equipes(input: $input) {
    content {
      id
      nome
      ine
      area
      tipoEquipe {
        id
        nome
        sigla
      }
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipeTableQuery__
 *
 * To run a query within a React component, call `useEquipeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipeTableQuery, Types.EquipeTableQueryVariables> & ({ variables: Types.EquipeTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>(EquipeTableDocument, options);
      }
export function useEquipeTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>(EquipeTableDocument, options);
        }
export function useEquipeTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>(EquipeTableDocument, options);
        }
export type EquipeTableQueryHookResult = ReturnType<typeof useEquipeTableQuery>;
export type EquipeTableLazyQueryHookResult = ReturnType<typeof useEquipeTableLazyQuery>;
export type EquipeTableSuspenseQueryHookResult = ReturnType<typeof useEquipeTableSuspenseQuery>;
export type EquipeTableQueryResult = Apollo.QueryResult<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>;
export const ErratasNotasComplementaresByAtendimentoProfissionalIdDocument = gql`
    query ErratasNotasComplementaresByAtendimentoProfissionalId($atendimentoProfissionalId: ID!) {
  erratasNotasComplementaresByAtendimentoProfissionalId(
    atendimentoProfissionalId: $atendimentoProfissionalId
  ) {
    id
    atendimentoProfissional {
      id
    }
    lotacao {
      id
      cbo {
        id
        nome
        cbo2002
      }
      profissional {
        id
        nome
        nomeSocial
      }
      equipe {
        id
        ine
        nome
      }
    }
    data
    justificativa
    descricaoErrataNotaComplementar
  }
}
    `;

/**
 * __useErratasNotasComplementaresByAtendimentoProfissionalIdQuery__
 *
 * To run a query within a React component, call `useErratasNotasComplementaresByAtendimentoProfissionalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useErratasNotasComplementaresByAtendimentoProfissionalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErratasNotasComplementaresByAtendimentoProfissionalIdQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useErratasNotasComplementaresByAtendimentoProfissionalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables> & ({ variables: Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>(ErratasNotasComplementaresByAtendimentoProfissionalIdDocument, options);
      }
export function useErratasNotasComplementaresByAtendimentoProfissionalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>(ErratasNotasComplementaresByAtendimentoProfissionalIdDocument, options);
        }
export function useErratasNotasComplementaresByAtendimentoProfissionalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>(ErratasNotasComplementaresByAtendimentoProfissionalIdDocument, options);
        }
export type ErratasNotasComplementaresByAtendimentoProfissionalIdQueryHookResult = ReturnType<typeof useErratasNotasComplementaresByAtendimentoProfissionalIdQuery>;
export type ErratasNotasComplementaresByAtendimentoProfissionalIdLazyQueryHookResult = ReturnType<typeof useErratasNotasComplementaresByAtendimentoProfissionalIdLazyQuery>;
export type ErratasNotasComplementaresByAtendimentoProfissionalIdSuspenseQueryHookResult = ReturnType<typeof useErratasNotasComplementaresByAtendimentoProfissionalIdSuspenseQuery>;
export type ErratasNotasComplementaresByAtendimentoProfissionalIdQueryResult = Apollo.QueryResult<Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQuery, Types.ErratasNotasComplementaresByAtendimentoProfissionalIdQueryVariables>;
export const SalvarErrataNotaComplementarDocument = gql`
    mutation SalvarErrataNotaComplementar($errataNotaComplementarInput: ErrataNotaComplementarInput!) {
  salvarErrataNotaComplementar(
    errataNotaComplementarInput: $errataNotaComplementarInput
  ) {
    id
  }
}
    `;
export type SalvarErrataNotaComplementarMutationFn = Apollo.MutationFunction<Types.SalvarErrataNotaComplementarMutation, Types.SalvarErrataNotaComplementarMutationVariables>;

/**
 * __useSalvarErrataNotaComplementarMutation__
 *
 * To run a mutation, you first call `useSalvarErrataNotaComplementarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarErrataNotaComplementarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarErrataNotaComplementarMutation, { data, loading, error }] = useSalvarErrataNotaComplementarMutation({
 *   variables: {
 *      errataNotaComplementarInput: // value for 'errataNotaComplementarInput'
 *   },
 * });
 */
export function useSalvarErrataNotaComplementarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarErrataNotaComplementarMutation, Types.SalvarErrataNotaComplementarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarErrataNotaComplementarMutation, Types.SalvarErrataNotaComplementarMutationVariables>(SalvarErrataNotaComplementarDocument, options);
      }
export type SalvarErrataNotaComplementarMutationHookResult = ReturnType<typeof useSalvarErrataNotaComplementarMutation>;
export type SalvarErrataNotaComplementarMutationResult = Apollo.MutationResult<Types.SalvarErrataNotaComplementarMutation>;
export type SalvarErrataNotaComplementarMutationOptions = Apollo.BaseMutationOptions<Types.SalvarErrataNotaComplementarMutation, Types.SalvarErrataNotaComplementarMutationVariables>;
export const CriarEstagioDocument = gql`
    mutation CriarEstagio($input: EstagioCreateInput!) {
  createEstagio(input: $input) {
    id
  }
}
    `;
export type CriarEstagioMutationFn = Apollo.MutationFunction<Types.CriarEstagioMutation, Types.CriarEstagioMutationVariables>;

/**
 * __useCriarEstagioMutation__
 *
 * To run a mutation, you first call `useCriarEstagioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarEstagioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarEstagioMutation, { data, loading, error }] = useCriarEstagioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarEstagioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarEstagioMutation, Types.CriarEstagioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CriarEstagioMutation, Types.CriarEstagioMutationVariables>(CriarEstagioDocument, options);
      }
export type CriarEstagioMutationHookResult = ReturnType<typeof useCriarEstagioMutation>;
export type CriarEstagioMutationResult = Apollo.MutationResult<Types.CriarEstagioMutation>;
export type CriarEstagioMutationOptions = Apollo.BaseMutationOptions<Types.CriarEstagioMutation, Types.CriarEstagioMutationVariables>;
export const DeleteEstagioDocument = gql`
    mutation DeleteEstagio($estagioId: ID!) {
  deleteEstagio(estagioId: $estagioId)
}
    `;
export type DeleteEstagioMutationFn = Apollo.MutationFunction<Types.DeleteEstagioMutation, Types.DeleteEstagioMutationVariables>;

/**
 * __useDeleteEstagioMutation__
 *
 * To run a mutation, you first call `useDeleteEstagioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstagioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstagioMutation, { data, loading, error }] = useDeleteEstagioMutation({
 *   variables: {
 *      estagioId: // value for 'estagioId'
 *   },
 * });
 */
export function useDeleteEstagioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteEstagioMutation, Types.DeleteEstagioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteEstagioMutation, Types.DeleteEstagioMutationVariables>(DeleteEstagioDocument, options);
      }
export type DeleteEstagioMutationHookResult = ReturnType<typeof useDeleteEstagioMutation>;
export type DeleteEstagioMutationResult = Apollo.MutationResult<Types.DeleteEstagioMutation>;
export type DeleteEstagioMutationOptions = Apollo.BaseMutationOptions<Types.DeleteEstagioMutation, Types.DeleteEstagioMutationVariables>;
export const EstagioEditViewDocument = gql`
    query EstagioEditView($id: ID!) {
  estagio(id: $id) {
    id
    ativo
    dataInicioVigencia
    dataFimVigencia
    instituicaoEnsino
    nivelTecnico
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      ine
      nome
    }
    lotacaoSupervisora {
      id
      profissional {
        id
        cpf
        nome
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        ine
        nome
      }
    }
    profissional {
      id
      cpf
      nome
    }
    perfis {
      id
      nome
      ativo
    }
    unidadeSaude {
      id
      nome
      cnes
    }
    actions {
      permissaoEdicao {
        enabled
      }
    }
  }
}
    `;

/**
 * __useEstagioEditViewQuery__
 *
 * To run a query within a React component, call `useEstagioEditViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstagioEditViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstagioEditViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstagioEditViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables> & ({ variables: Types.EstagioEditViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>(EstagioEditViewDocument, options);
      }
export function useEstagioEditViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>(EstagioEditViewDocument, options);
        }
export function useEstagioEditViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>(EstagioEditViewDocument, options);
        }
export type EstagioEditViewQueryHookResult = ReturnType<typeof useEstagioEditViewQuery>;
export type EstagioEditViewLazyQueryHookResult = ReturnType<typeof useEstagioEditViewLazyQuery>;
export type EstagioEditViewSuspenseQueryHookResult = ReturnType<typeof useEstagioEditViewSuspenseQuery>;
export type EstagioEditViewQueryResult = Apollo.QueryResult<Types.EstagioEditViewQuery, Types.EstagioEditViewQueryVariables>;
export const ProfissionalEstagioDocument = gql`
    query ProfissionalEstagio($id: ID!) {
  profissional(id: $id) {
    id
    nome
  }
}
    `;

/**
 * __useProfissionalEstagioQuery__
 *
 * To run a query within a React component, call `useProfissionalEstagioQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalEstagioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalEstagioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfissionalEstagioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables> & ({ variables: Types.ProfissionalEstagioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>(ProfissionalEstagioDocument, options);
      }
export function useProfissionalEstagioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>(ProfissionalEstagioDocument, options);
        }
export function useProfissionalEstagioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>(ProfissionalEstagioDocument, options);
        }
export type ProfissionalEstagioQueryHookResult = ReturnType<typeof useProfissionalEstagioQuery>;
export type ProfissionalEstagioLazyQueryHookResult = ReturnType<typeof useProfissionalEstagioLazyQuery>;
export type ProfissionalEstagioSuspenseQueryHookResult = ReturnType<typeof useProfissionalEstagioSuspenseQuery>;
export type ProfissionalEstagioQueryResult = Apollo.QueryResult<Types.ProfissionalEstagioQuery, Types.ProfissionalEstagioQueryVariables>;
export const UpdateEstagioDocument = gql`
    mutation UpdateEstagio($input: EstagioUpdateInput!) {
  updateEstagio(input: $input) {
    id
  }
}
    `;
export type UpdateEstagioMutationFn = Apollo.MutationFunction<Types.UpdateEstagioMutation, Types.UpdateEstagioMutationVariables>;

/**
 * __useUpdateEstagioMutation__
 *
 * To run a mutation, you first call `useUpdateEstagioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstagioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstagioMutation, { data, loading, error }] = useUpdateEstagioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEstagioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateEstagioMutation, Types.UpdateEstagioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateEstagioMutation, Types.UpdateEstagioMutationVariables>(UpdateEstagioDocument, options);
      }
export type UpdateEstagioMutationHookResult = ReturnType<typeof useUpdateEstagioMutation>;
export type UpdateEstagioMutationResult = Apollo.MutationResult<Types.UpdateEstagioMutation>;
export type UpdateEstagioMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEstagioMutation, Types.UpdateEstagioMutationVariables>;
export const ListaRegulacaoDocument = gql`
    query ListaRegulacao($input: ListaRegulacaoQueryInput!) {
  listaRegulacao(input: $input) {
    content {
      id
      uuid
      tipoRegulacao
      exame {
        id
        dataSolicitacao
        observacao
        exame {
          id
          codigo
          descricao
        }
        atendimentoProfissionalSolicitacao {
          id
          finalizadoEm
        }
        solicitacao {
          id
          justificativa
          observacoes
          cid10 {
            ...Cid10
          }
        }
      }
      guiaEncaminhamento {
        id
        cbo {
          id
          nome
        }
        cid10 {
          ...Cid10
        }
        ciap {
          ...Ciap
        }
        atendimentoProfissional {
          id
          finalizadoEm
        }
        classificacaoPrioridade
        discussao
      }
      lotacao {
        id
        cbo {
          id
          nome
        }
        unidadeSaude {
          id
          nome
        }
        profissional {
          id
          nome
        }
        equipe {
          id
          nome
        }
      }
      prontuario {
        id
        cidadao {
          id
          nome
          nomeSocial
          dataNascimento
          cidadaoVinculacaoEquipe {
            id
            unidadeSaude(mostrarInativas: true) {
              id
              nome
            }
            equipe(mostrarInativas: true) {
              id
              nome
            }
          }
        }
      }
      ultimaEvolucao {
        id
        dataEvolucao
        statusRegulacao
        prioridade
        observacao
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${Cid10FragmentDoc}
${CiapFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useListaRegulacaoQuery__
 *
 * To run a query within a React component, call `useListaRegulacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaRegulacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaRegulacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaRegulacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables> & ({ variables: Types.ListaRegulacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>(ListaRegulacaoDocument, options);
      }
export function useListaRegulacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>(ListaRegulacaoDocument, options);
        }
export function useListaRegulacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>(ListaRegulacaoDocument, options);
        }
export type ListaRegulacaoQueryHookResult = ReturnType<typeof useListaRegulacaoQuery>;
export type ListaRegulacaoLazyQueryHookResult = ReturnType<typeof useListaRegulacaoLazyQuery>;
export type ListaRegulacaoSuspenseQueryHookResult = ReturnType<typeof useListaRegulacaoSuspenseQuery>;
export type ListaRegulacaoQueryResult = Apollo.QueryResult<Types.ListaRegulacaoQuery, Types.ListaRegulacaoQueryVariables>;
export const HistoricoRegulacaoEvolucaoDocument = gql`
    query HistoricoRegulacaoEvolucao($id: ID!) {
  evolucoesRegulacao(id: $id) {
    id
    dataEvolucao
    statusRegulacao
    observacao
    prioridade
  }
}
    `;

/**
 * __useHistoricoRegulacaoEvolucaoQuery__
 *
 * To run a query within a React component, call `useHistoricoRegulacaoEvolucaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoRegulacaoEvolucaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoRegulacaoEvolucaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHistoricoRegulacaoEvolucaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables> & ({ variables: Types.HistoricoRegulacaoEvolucaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>(HistoricoRegulacaoEvolucaoDocument, options);
      }
export function useHistoricoRegulacaoEvolucaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>(HistoricoRegulacaoEvolucaoDocument, options);
        }
export function useHistoricoRegulacaoEvolucaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>(HistoricoRegulacaoEvolucaoDocument, options);
        }
export type HistoricoRegulacaoEvolucaoQueryHookResult = ReturnType<typeof useHistoricoRegulacaoEvolucaoQuery>;
export type HistoricoRegulacaoEvolucaoLazyQueryHookResult = ReturnType<typeof useHistoricoRegulacaoEvolucaoLazyQuery>;
export type HistoricoRegulacaoEvolucaoSuspenseQueryHookResult = ReturnType<typeof useHistoricoRegulacaoEvolucaoSuspenseQuery>;
export type HistoricoRegulacaoEvolucaoQueryResult = Apollo.QueryResult<Types.HistoricoRegulacaoEvolucaoQuery, Types.HistoricoRegulacaoEvolucaoQueryVariables>;
export const HistoricoAcessoTableDocument = gql`
    query HistoricoAcessoTable($input: HistoricoAcessoQueryInput!) {
  historicoAcessos(input: $input) {
    content {
      id
      sucesso
      data
      cliente
      local
      ip
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useHistoricoAcessoTableQuery__
 *
 * To run a query within a React component, call `useHistoricoAcessoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoAcessoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoAcessoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoAcessoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables> & ({ variables: Types.HistoricoAcessoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>(HistoricoAcessoTableDocument, options);
      }
export function useHistoricoAcessoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>(HistoricoAcessoTableDocument, options);
        }
export function useHistoricoAcessoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>(HistoricoAcessoTableDocument, options);
        }
export type HistoricoAcessoTableQueryHookResult = ReturnType<typeof useHistoricoAcessoTableQuery>;
export type HistoricoAcessoTableLazyQueryHookResult = ReturnType<typeof useHistoricoAcessoTableLazyQuery>;
export type HistoricoAcessoTableSuspenseQueryHookResult = ReturnType<typeof useHistoricoAcessoTableSuspenseQuery>;
export type HistoricoAcessoTableQueryResult = Apollo.QueryResult<Types.HistoricoAcessoTableQuery, Types.HistoricoAcessoTableQueryVariables>;
export const UltimoAcessoDocument = gql`
    query UltimoAcesso {
  ultimoAcesso {
    id
    data
  }
}
    `;

/**
 * __useUltimoAcessoQuery__
 *
 * To run a query within a React component, call `useUltimoAcessoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoAcessoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoAcessoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUltimoAcessoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>(UltimoAcessoDocument, options);
      }
export function useUltimoAcessoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>(UltimoAcessoDocument, options);
        }
export function useUltimoAcessoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>(UltimoAcessoDocument, options);
        }
export type UltimoAcessoQueryHookResult = ReturnType<typeof useUltimoAcessoQuery>;
export type UltimoAcessoLazyQueryHookResult = ReturnType<typeof useUltimoAcessoLazyQuery>;
export type UltimoAcessoSuspenseQueryHookResult = ReturnType<typeof useUltimoAcessoSuspenseQuery>;
export type UltimoAcessoQueryResult = Apollo.QueryResult<Types.UltimoAcessoQuery, Types.UltimoAcessoQueryVariables>;
export const AlterarUnidadePadraoHorusDocument = gql`
    mutation AlterarUnidadePadraoHorus($input: UnidadeConsultaHorusIds!) {
  alterarUnidadePadraoHorus(input: $input) {
    id
    nome
  }
}
    `;
export type AlterarUnidadePadraoHorusMutationFn = Apollo.MutationFunction<Types.AlterarUnidadePadraoHorusMutation, Types.AlterarUnidadePadraoHorusMutationVariables>;

/**
 * __useAlterarUnidadePadraoHorusMutation__
 *
 * To run a mutation, you first call `useAlterarUnidadePadraoHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarUnidadePadraoHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarUnidadePadraoHorusMutation, { data, loading, error }] = useAlterarUnidadePadraoHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarUnidadePadraoHorusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarUnidadePadraoHorusMutation, Types.AlterarUnidadePadraoHorusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarUnidadePadraoHorusMutation, Types.AlterarUnidadePadraoHorusMutationVariables>(AlterarUnidadePadraoHorusDocument, options);
      }
export type AlterarUnidadePadraoHorusMutationHookResult = ReturnType<typeof useAlterarUnidadePadraoHorusMutation>;
export type AlterarUnidadePadraoHorusMutationResult = Apollo.MutationResult<Types.AlterarUnidadePadraoHorusMutation>;
export type AlterarUnidadePadraoHorusMutationOptions = Apollo.BaseMutationOptions<Types.AlterarUnidadePadraoHorusMutation, Types.AlterarUnidadePadraoHorusMutationVariables>;
export const CadastroUnidadeConsultaHorusDocument = gql`
    mutation CadastroUnidadeConsultaHorus($input: UnidadeConsultaHorusIds!) {
  adicionarUnidadeConsultaHorus(input: $input) {
    id
    nome
  }
}
    `;
export type CadastroUnidadeConsultaHorusMutationFn = Apollo.MutationFunction<Types.CadastroUnidadeConsultaHorusMutation, Types.CadastroUnidadeConsultaHorusMutationVariables>;

/**
 * __useCadastroUnidadeConsultaHorusMutation__
 *
 * To run a mutation, you first call `useCadastroUnidadeConsultaHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCadastroUnidadeConsultaHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cadastroUnidadeConsultaHorusMutation, { data, loading, error }] = useCadastroUnidadeConsultaHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCadastroUnidadeConsultaHorusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CadastroUnidadeConsultaHorusMutation, Types.CadastroUnidadeConsultaHorusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CadastroUnidadeConsultaHorusMutation, Types.CadastroUnidadeConsultaHorusMutationVariables>(CadastroUnidadeConsultaHorusDocument, options);
      }
export type CadastroUnidadeConsultaHorusMutationHookResult = ReturnType<typeof useCadastroUnidadeConsultaHorusMutation>;
export type CadastroUnidadeConsultaHorusMutationResult = Apollo.MutationResult<Types.CadastroUnidadeConsultaHorusMutation>;
export type CadastroUnidadeConsultaHorusMutationOptions = Apollo.BaseMutationOptions<Types.CadastroUnidadeConsultaHorusMutation, Types.CadastroUnidadeConsultaHorusMutationVariables>;
export const HorusListViewDocument = gql`
    query HorusListView($unidadeSaudeId: ID!) {
  unidadesConsultaHorus(id: $unidadeSaudeId) {
    unidadeSaude {
      id
      nome
      cnes
    }
    unidadePadrao
  }
  unidadeSaude(id: $unidadeSaudeId) {
    id
    actions {
      permissaoConexaoHorus {
        enabled
        hint
      }
    }
  }
  conexao {
    horus {
      id
      habilitado
    }
  }
}
    `;

/**
 * __useHorusListViewQuery__
 *
 * To run a query within a React component, call `useHorusListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorusListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorusListViewQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useHorusListViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HorusListViewQuery, Types.HorusListViewQueryVariables> & ({ variables: Types.HorusListViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>(HorusListViewDocument, options);
      }
export function useHorusListViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>(HorusListViewDocument, options);
        }
export function useHorusListViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>(HorusListViewDocument, options);
        }
export type HorusListViewQueryHookResult = ReturnType<typeof useHorusListViewQuery>;
export type HorusListViewLazyQueryHookResult = ReturnType<typeof useHorusListViewLazyQuery>;
export type HorusListViewSuspenseQueryHookResult = ReturnType<typeof useHorusListViewSuspenseQuery>;
export type HorusListViewQueryResult = Apollo.QueryResult<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>;
export const RemoverUnidadeConsultaHorusDocument = gql`
    mutation RemoverUnidadeConsultaHorus($input: UnidadeConsultaHorusIds!) {
  removerUnidadeConsultaHorus(input: $input) {
    id
    nome
  }
}
    `;
export type RemoverUnidadeConsultaHorusMutationFn = Apollo.MutationFunction<Types.RemoverUnidadeConsultaHorusMutation, Types.RemoverUnidadeConsultaHorusMutationVariables>;

/**
 * __useRemoverUnidadeConsultaHorusMutation__
 *
 * To run a mutation, you first call `useRemoverUnidadeConsultaHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverUnidadeConsultaHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerUnidadeConsultaHorusMutation, { data, loading, error }] = useRemoverUnidadeConsultaHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoverUnidadeConsultaHorusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverUnidadeConsultaHorusMutation, Types.RemoverUnidadeConsultaHorusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverUnidadeConsultaHorusMutation, Types.RemoverUnidadeConsultaHorusMutationVariables>(RemoverUnidadeConsultaHorusDocument, options);
      }
export type RemoverUnidadeConsultaHorusMutationHookResult = ReturnType<typeof useRemoverUnidadeConsultaHorusMutation>;
export type RemoverUnidadeConsultaHorusMutationResult = Apollo.MutationResult<Types.RemoverUnidadeConsultaHorusMutation>;
export type RemoverUnidadeConsultaHorusMutationOptions = Apollo.BaseMutationOptions<Types.RemoverUnidadeConsultaHorusMutation, Types.RemoverUnidadeConsultaHorusMutationVariables>;
export const InativarImoveisDocument = gql`
    mutation InativarImoveis($input: InativarImoveisInput!) {
  inativarImoveis(input: $input)
}
    `;
export type InativarImoveisMutationFn = Apollo.MutationFunction<Types.InativarImoveisMutation, Types.InativarImoveisMutationVariables>;

/**
 * __useInativarImoveisMutation__
 *
 * To run a mutation, you first call `useInativarImoveisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarImoveisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarImoveisMutation, { data, loading, error }] = useInativarImoveisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInativarImoveisMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarImoveisMutation, Types.InativarImoveisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarImoveisMutation, Types.InativarImoveisMutationVariables>(InativarImoveisDocument, options);
      }
export type InativarImoveisMutationHookResult = ReturnType<typeof useInativarImoveisMutation>;
export type InativarImoveisMutationResult = Apollo.MutationResult<Types.InativarImoveisMutation>;
export type InativarImoveisMutationOptions = Apollo.BaseMutationOptions<Types.InativarImoveisMutation, Types.InativarImoveisMutationVariables>;
export const LoadImoveisDuplicadosDocument = gql`
    query LoadImoveisDuplicados($input: ImoveisDuplicadosQueryInput!) {
  imoveisDuplicados(input: $input) {
    content {
      ...ImovelInativacaoFields
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ImovelInativacaoFieldsFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useLoadImoveisDuplicadosQuery__
 *
 * To run a query within a React component, call `useLoadImoveisDuplicadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadImoveisDuplicadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadImoveisDuplicadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadImoveisDuplicadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables> & ({ variables: Types.LoadImoveisDuplicadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>(LoadImoveisDuplicadosDocument, options);
      }
export function useLoadImoveisDuplicadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>(LoadImoveisDuplicadosDocument, options);
        }
export function useLoadImoveisDuplicadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>(LoadImoveisDuplicadosDocument, options);
        }
export type LoadImoveisDuplicadosQueryHookResult = ReturnType<typeof useLoadImoveisDuplicadosQuery>;
export type LoadImoveisDuplicadosLazyQueryHookResult = ReturnType<typeof useLoadImoveisDuplicadosLazyQuery>;
export type LoadImoveisDuplicadosSuspenseQueryHookResult = ReturnType<typeof useLoadImoveisDuplicadosSuspenseQuery>;
export type LoadImoveisDuplicadosQueryResult = Apollo.QueryResult<Types.LoadImoveisDuplicadosQuery, Types.LoadImoveisDuplicadosQueryVariables>;
export const LoadImoveisInativacaoDocument = gql`
    query LoadImoveisInativacao($input: ImoveisQueryInput!) {
  imoveis(input: $input) {
    content {
      ...ImovelInativacaoFields
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ImovelInativacaoFieldsFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useLoadImoveisInativacaoQuery__
 *
 * To run a query within a React component, call `useLoadImoveisInativacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadImoveisInativacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadImoveisInativacaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadImoveisInativacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables> & ({ variables: Types.LoadImoveisInativacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>(LoadImoveisInativacaoDocument, options);
      }
export function useLoadImoveisInativacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>(LoadImoveisInativacaoDocument, options);
        }
export function useLoadImoveisInativacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>(LoadImoveisInativacaoDocument, options);
        }
export type LoadImoveisInativacaoQueryHookResult = ReturnType<typeof useLoadImoveisInativacaoQuery>;
export type LoadImoveisInativacaoLazyQueryHookResult = ReturnType<typeof useLoadImoveisInativacaoLazyQuery>;
export type LoadImoveisInativacaoSuspenseQueryHookResult = ReturnType<typeof useLoadImoveisInativacaoSuspenseQuery>;
export type LoadImoveisInativacaoQueryResult = Apollo.QueryResult<Types.LoadImoveisInativacaoQuery, Types.LoadImoveisInativacaoQueryVariables>;
export const InstalarDocument = gql`
    mutation Instalar($input: InstalacaoInput!) {
  instalar(input: $input)
}
    `;
export type InstalarMutationFn = Apollo.MutationFunction<Types.InstalarMutation, Types.InstalarMutationVariables>;

/**
 * __useInstalarMutation__
 *
 * To run a mutation, you first call `useInstalarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstalarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instalarMutation, { data, loading, error }] = useInstalarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstalarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InstalarMutation, Types.InstalarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InstalarMutation, Types.InstalarMutationVariables>(InstalarDocument, options);
      }
export type InstalarMutationHookResult = ReturnType<typeof useInstalarMutation>;
export type InstalarMutationResult = Apollo.MutationResult<Types.InstalarMutation>;
export type InstalarMutationOptions = Apollo.BaseMutationOptions<Types.InstalarMutation, Types.InstalarMutationVariables>;
export const CredenciaisIntegracaoDocument = gql`
    query CredenciaisIntegracao($input: CredencialIntegracaoQueryInput!) {
  credenciaisIntegracao(input: $input) {
    content {
      id
      nomeResponsavel
      nomeCredencial
      dataCriacao
      email
      ativo
      tipoPessoa
      cpfCnpj
      recursos
      urlWebhookRegulacao
      municipiosVinculados {
        id
        nome
        uf {
          id
          sigla
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCredenciaisIntegracaoQuery__
 *
 * To run a query within a React component, call `useCredenciaisIntegracaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCredenciaisIntegracaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCredenciaisIntegracaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCredenciaisIntegracaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables> & ({ variables: Types.CredenciaisIntegracaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>(CredenciaisIntegracaoDocument, options);
      }
export function useCredenciaisIntegracaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>(CredenciaisIntegracaoDocument, options);
        }
export function useCredenciaisIntegracaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>(CredenciaisIntegracaoDocument, options);
        }
export type CredenciaisIntegracaoQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoQuery>;
export type CredenciaisIntegracaoLazyQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoLazyQuery>;
export type CredenciaisIntegracaoSuspenseQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoSuspenseQuery>;
export type CredenciaisIntegracaoQueryResult = Apollo.QueryResult<Types.CredenciaisIntegracaoQuery, Types.CredenciaisIntegracaoQueryVariables>;
export const InativarCredencialIntegracaoDocument = gql`
    mutation inativarCredencialIntegracao($id: ID!) {
  inativarCredencialIntegracao(id: $id) {
    id
  }
}
    `;
export type InativarCredencialIntegracaoMutationFn = Apollo.MutationFunction<Types.InativarCredencialIntegracaoMutation, Types.InativarCredencialIntegracaoMutationVariables>;

/**
 * __useInativarCredencialIntegracaoMutation__
 *
 * To run a mutation, you first call `useInativarCredencialIntegracaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarCredencialIntegracaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarCredencialIntegracaoMutation, { data, loading, error }] = useInativarCredencialIntegracaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInativarCredencialIntegracaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarCredencialIntegracaoMutation, Types.InativarCredencialIntegracaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarCredencialIntegracaoMutation, Types.InativarCredencialIntegracaoMutationVariables>(InativarCredencialIntegracaoDocument, options);
      }
export type InativarCredencialIntegracaoMutationHookResult = ReturnType<typeof useInativarCredencialIntegracaoMutation>;
export type InativarCredencialIntegracaoMutationResult = Apollo.MutationResult<Types.InativarCredencialIntegracaoMutation>;
export type InativarCredencialIntegracaoMutationOptions = Apollo.BaseMutationOptions<Types.InativarCredencialIntegracaoMutation, Types.InativarCredencialIntegracaoMutationVariables>;
export const IsCredencialIntegracaoRegulacaoJaCriadaDocument = gql`
    query IsCredencialIntegracaoRegulacaoJaCriada {
  isCredencialIntegracaoRegulacaoJaCriada
}
    `;

/**
 * __useIsCredencialIntegracaoRegulacaoJaCriadaQuery__
 *
 * To run a query within a React component, call `useIsCredencialIntegracaoRegulacaoJaCriadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCredencialIntegracaoRegulacaoJaCriadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCredencialIntegracaoRegulacaoJaCriadaQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsCredencialIntegracaoRegulacaoJaCriadaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>(IsCredencialIntegracaoRegulacaoJaCriadaDocument, options);
      }
export function useIsCredencialIntegracaoRegulacaoJaCriadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>(IsCredencialIntegracaoRegulacaoJaCriadaDocument, options);
        }
export function useIsCredencialIntegracaoRegulacaoJaCriadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>(IsCredencialIntegracaoRegulacaoJaCriadaDocument, options);
        }
export type IsCredencialIntegracaoRegulacaoJaCriadaQueryHookResult = ReturnType<typeof useIsCredencialIntegracaoRegulacaoJaCriadaQuery>;
export type IsCredencialIntegracaoRegulacaoJaCriadaLazyQueryHookResult = ReturnType<typeof useIsCredencialIntegracaoRegulacaoJaCriadaLazyQuery>;
export type IsCredencialIntegracaoRegulacaoJaCriadaSuspenseQueryHookResult = ReturnType<typeof useIsCredencialIntegracaoRegulacaoJaCriadaSuspenseQuery>;
export type IsCredencialIntegracaoRegulacaoJaCriadaQueryResult = Apollo.QueryResult<Types.IsCredencialIntegracaoRegulacaoJaCriadaQuery, Types.IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables>;
export const SalvarCredencialIntegracaoDocument = gql`
    mutation salvarCredencialIntegracao($input: CredencialIntegracaoInput!) {
  salvarCredencialIntegracao(input: $input) {
    userPassword {
      user
      password
    }
  }
}
    `;
export type SalvarCredencialIntegracaoMutationFn = Apollo.MutationFunction<Types.SalvarCredencialIntegracaoMutation, Types.SalvarCredencialIntegracaoMutationVariables>;

/**
 * __useSalvarCredencialIntegracaoMutation__
 *
 * To run a mutation, you first call `useSalvarCredencialIntegracaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarCredencialIntegracaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarCredencialIntegracaoMutation, { data, loading, error }] = useSalvarCredencialIntegracaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarCredencialIntegracaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarCredencialIntegracaoMutation, Types.SalvarCredencialIntegracaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarCredencialIntegracaoMutation, Types.SalvarCredencialIntegracaoMutationVariables>(SalvarCredencialIntegracaoDocument, options);
      }
export type SalvarCredencialIntegracaoMutationHookResult = ReturnType<typeof useSalvarCredencialIntegracaoMutation>;
export type SalvarCredencialIntegracaoMutationResult = Apollo.MutationResult<Types.SalvarCredencialIntegracaoMutation>;
export type SalvarCredencialIntegracaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarCredencialIntegracaoMutation, Types.SalvarCredencialIntegracaoMutationVariables>;
export const InativarSistemaExternoDocument = gql`
    mutation inativarSistemaExterno($id: ID!) {
  inativarSistemaExterno(id: $id) {
    id
  }
}
    `;
export type InativarSistemaExternoMutationFn = Apollo.MutationFunction<Types.InativarSistemaExternoMutation, Types.InativarSistemaExternoMutationVariables>;

/**
 * __useInativarSistemaExternoMutation__
 *
 * To run a mutation, you first call `useInativarSistemaExternoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarSistemaExternoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarSistemaExternoMutation, { data, loading, error }] = useInativarSistemaExternoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInativarSistemaExternoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarSistemaExternoMutation, Types.InativarSistemaExternoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarSistemaExternoMutation, Types.InativarSistemaExternoMutationVariables>(InativarSistemaExternoDocument, options);
      }
export type InativarSistemaExternoMutationHookResult = ReturnType<typeof useInativarSistemaExternoMutation>;
export type InativarSistemaExternoMutationResult = Apollo.MutationResult<Types.InativarSistemaExternoMutation>;
export type InativarSistemaExternoMutationOptions = Apollo.BaseMutationOptions<Types.InativarSistemaExternoMutation, Types.InativarSistemaExternoMutationVariables>;
export const SalvarSistemaExternoDocument = gql`
    mutation salvarSistemaExterno($input: SalvarSistemaExternoInput!) {
  salvarSistemaExterno(input: $input) {
    chaveAssinatura
  }
}
    `;
export type SalvarSistemaExternoMutationFn = Apollo.MutationFunction<Types.SalvarSistemaExternoMutation, Types.SalvarSistemaExternoMutationVariables>;

/**
 * __useSalvarSistemaExternoMutation__
 *
 * To run a mutation, you first call `useSalvarSistemaExternoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarSistemaExternoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarSistemaExternoMutation, { data, loading, error }] = useSalvarSistemaExternoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarSistemaExternoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarSistemaExternoMutation, Types.SalvarSistemaExternoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarSistemaExternoMutation, Types.SalvarSistemaExternoMutationVariables>(SalvarSistemaExternoDocument, options);
      }
export type SalvarSistemaExternoMutationHookResult = ReturnType<typeof useSalvarSistemaExternoMutation>;
export type SalvarSistemaExternoMutationResult = Apollo.MutationResult<Types.SalvarSistemaExternoMutation>;
export type SalvarSistemaExternoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarSistemaExternoMutation, Types.SalvarSistemaExternoMutationVariables>;
export const SistemasExternosDocument = gql`
    query sistemasExternos($input: SistemaExternoQueryInput!) {
  sistemasExternos(input: $input) {
    content {
      id
      nome
      url
      nomeResponsavel
      email
      ativo
      tipoPessoa
      cpfCnpj
      tipo
      municipios {
        id
        nome
      }
      perfis {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useSistemasExternosQuery__
 *
 * To run a query within a React component, call `useSistemasExternosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSistemasExternosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSistemasExternosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSistemasExternosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables> & ({ variables: Types.SistemasExternosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>(SistemasExternosDocument, options);
      }
export function useSistemasExternosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>(SistemasExternosDocument, options);
        }
export function useSistemasExternosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>(SistemasExternosDocument, options);
        }
export type SistemasExternosQueryHookResult = ReturnType<typeof useSistemasExternosQuery>;
export type SistemasExternosLazyQueryHookResult = ReturnType<typeof useSistemasExternosLazyQuery>;
export type SistemasExternosSuspenseQueryHookResult = ReturnType<typeof useSistemasExternosSuspenseQuery>;
export type SistemasExternosQueryResult = Apollo.QueryResult<Types.SistemasExternosQuery, Types.SistemasExternosQueryVariables>;
export const GarantiaAcessoCidadaoDocument = gql`
    query GarantiaAcessoCidadao($id: ID!) {
  cidadao(id: $id) {
    id
    nome
    nomeSocial
    cpf
    cns
    nomeMae
    dataNascimento
    sexo
    identidadeGeneroDbEnum
    faleceu
    cidadaoVinculacaoEquipe {
      id
      unidadeSaude {
        id
      }
      equipe {
        id
        ine
        nome
        tipoEquipe {
          id
          nome
          sigla
        }
      }
    }
  }
}
    `;

/**
 * __useGarantiaAcessoCidadaoQuery__
 *
 * To run a query within a React component, call `useGarantiaAcessoCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarantiaAcessoCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarantiaAcessoCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGarantiaAcessoCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables> & ({ variables: Types.GarantiaAcessoCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>(GarantiaAcessoCidadaoDocument, options);
      }
export function useGarantiaAcessoCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>(GarantiaAcessoCidadaoDocument, options);
        }
export function useGarantiaAcessoCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>(GarantiaAcessoCidadaoDocument, options);
        }
export type GarantiaAcessoCidadaoQueryHookResult = ReturnType<typeof useGarantiaAcessoCidadaoQuery>;
export type GarantiaAcessoCidadaoLazyQueryHookResult = ReturnType<typeof useGarantiaAcessoCidadaoLazyQuery>;
export type GarantiaAcessoCidadaoSuspenseQueryHookResult = ReturnType<typeof useGarantiaAcessoCidadaoSuspenseQuery>;
export type GarantiaAcessoCidadaoQueryResult = Apollo.QueryResult<Types.GarantiaAcessoCidadaoQuery, Types.GarantiaAcessoCidadaoQueryVariables>;
export const GarantiaAcessoDocument = gql`
    query GarantiaAcesso($input: ID!) {
  garantiaAcessoItemById(input: $input) {
    id
    cidadao {
      id
      nome
      nomeSocial
      cpf
      cns
      telefoneResidencial
      telefoneCelular
      telefoneContato
      faleceu
    }
    equipe {
      id
      ine
      nome
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    motivoEspera
    tipoAtendimento
    tipoServico {
      id
      nome
    }
    dataEntrada
    cuidadoCompartilhadoEvolucao {
      id
      cuidadoCompartilhado {
        id
        lotacaoSolicitante {
          id
          ativo
          importada
          profissional {
            id
            nome
            cpf
            email
          }
          cbo {
            id
            nome
            cbo2002
          }
        }
      }
      lotacaoExecutante {
        id
        ativo
        importada
        profissional {
          id
          nome
          cpf
          email
        }
        cbo {
          id
          nome
          cbo2002
        }
      }
      condutaAgendamento: enviarGarantiaAcesso
    }
  }
}
    `;

/**
 * __useGarantiaAcessoQuery__
 *
 * To run a query within a React component, call `useGarantiaAcessoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarantiaAcessoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarantiaAcessoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGarantiaAcessoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables> & ({ variables: Types.GarantiaAcessoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>(GarantiaAcessoDocument, options);
      }
export function useGarantiaAcessoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>(GarantiaAcessoDocument, options);
        }
export function useGarantiaAcessoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>(GarantiaAcessoDocument, options);
        }
export type GarantiaAcessoQueryHookResult = ReturnType<typeof useGarantiaAcessoQuery>;
export type GarantiaAcessoLazyQueryHookResult = ReturnType<typeof useGarantiaAcessoLazyQuery>;
export type GarantiaAcessoSuspenseQueryHookResult = ReturnType<typeof useGarantiaAcessoSuspenseQuery>;
export type GarantiaAcessoQueryResult = Apollo.QueryResult<Types.GarantiaAcessoQuery, Types.GarantiaAcessoQueryVariables>;
export const GarantiaAcessoTableDocument = gql`
    query GarantiaAcessoTable($input: GarantiaAcessoFilter!) {
  garantiaAcessoByUnidadeSaudeId(input: $input) {
    content {
      id
      cidadao {
        id
        nome
        nomeSocial
        dataNascimento
        cpf
        cns
        telefoneResidencial
        telefoneCelular
        telefoneContato
        faleceu
        prontuario {
          id
        }
      }
      unidadeSaude {
        id
      }
      equipe {
        id
        nome
        area
      }
      motivoEspera
      dataEntrada
      dataSaida
      tipoAtendimento
      tipoServico {
        id
        nome
      }
      qtdCidadaoPresente
      cuidadoCompartilhadoEvolucao {
        ...CuidadoCompartilhadoEvolucaoGarantiaAcessoFragment
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${CuidadoCompartilhadoEvolucaoGarantiaAcessoFragmentFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGarantiaAcessoTableQuery__
 *
 * To run a query within a React component, call `useGarantiaAcessoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarantiaAcessoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarantiaAcessoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGarantiaAcessoTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables> & ({ variables: Types.GarantiaAcessoTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>(GarantiaAcessoTableDocument, options);
      }
export function useGarantiaAcessoTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>(GarantiaAcessoTableDocument, options);
        }
export function useGarantiaAcessoTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>(GarantiaAcessoTableDocument, options);
        }
export type GarantiaAcessoTableQueryHookResult = ReturnType<typeof useGarantiaAcessoTableQuery>;
export type GarantiaAcessoTableLazyQueryHookResult = ReturnType<typeof useGarantiaAcessoTableLazyQuery>;
export type GarantiaAcessoTableSuspenseQueryHookResult = ReturnType<typeof useGarantiaAcessoTableSuspenseQuery>;
export type GarantiaAcessoTableQueryResult = Apollo.QueryResult<Types.GarantiaAcessoTableQuery, Types.GarantiaAcessoTableQueryVariables>;
export const UnidadesSaudeByGarantiaAcessoCidadaoDocument = gql`
    query UnidadesSaudeByGarantiaAcessoCidadao($input: UnidadesSaudeByGarantiaAcessoCidadaoInput!) {
  unidadesSaudeByGarantiaAcessoCidadao(input: $input) {
    id
    nome
  }
}
    `;

/**
 * __useUnidadesSaudeByGarantiaAcessoCidadaoQuery__
 *
 * To run a query within a React component, call `useUnidadesSaudeByGarantiaAcessoCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadesSaudeByGarantiaAcessoCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadesSaudeByGarantiaAcessoCidadaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadesSaudeByGarantiaAcessoCidadaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables> & ({ variables: Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>(UnidadesSaudeByGarantiaAcessoCidadaoDocument, options);
      }
export function useUnidadesSaudeByGarantiaAcessoCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>(UnidadesSaudeByGarantiaAcessoCidadaoDocument, options);
        }
export function useUnidadesSaudeByGarantiaAcessoCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>(UnidadesSaudeByGarantiaAcessoCidadaoDocument, options);
        }
export type UnidadesSaudeByGarantiaAcessoCidadaoQueryHookResult = ReturnType<typeof useUnidadesSaudeByGarantiaAcessoCidadaoQuery>;
export type UnidadesSaudeByGarantiaAcessoCidadaoLazyQueryHookResult = ReturnType<typeof useUnidadesSaudeByGarantiaAcessoCidadaoLazyQuery>;
export type UnidadesSaudeByGarantiaAcessoCidadaoSuspenseQueryHookResult = ReturnType<typeof useUnidadesSaudeByGarantiaAcessoCidadaoSuspenseQuery>;
export type UnidadesSaudeByGarantiaAcessoCidadaoQueryResult = Apollo.QueryResult<Types.UnidadesSaudeByGarantiaAcessoCidadaoQuery, Types.UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables>;
export const AgendarConsultaGarantiaAcessoDocument = gql`
    mutation AgendarConsultaGarantiaAcesso($input: GarantiaAcessoAgendarConsultaInput!) {
  agendarConsultaGarantiaAcesso(input: $input)
}
    `;
export type AgendarConsultaGarantiaAcessoMutationFn = Apollo.MutationFunction<Types.AgendarConsultaGarantiaAcessoMutation, Types.AgendarConsultaGarantiaAcessoMutationVariables>;

/**
 * __useAgendarConsultaGarantiaAcessoMutation__
 *
 * To run a mutation, you first call `useAgendarConsultaGarantiaAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgendarConsultaGarantiaAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agendarConsultaGarantiaAcessoMutation, { data, loading, error }] = useAgendarConsultaGarantiaAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendarConsultaGarantiaAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AgendarConsultaGarantiaAcessoMutation, Types.AgendarConsultaGarantiaAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AgendarConsultaGarantiaAcessoMutation, Types.AgendarConsultaGarantiaAcessoMutationVariables>(AgendarConsultaGarantiaAcessoDocument, options);
      }
export type AgendarConsultaGarantiaAcessoMutationHookResult = ReturnType<typeof useAgendarConsultaGarantiaAcessoMutation>;
export type AgendarConsultaGarantiaAcessoMutationResult = Apollo.MutationResult<Types.AgendarConsultaGarantiaAcessoMutation>;
export type AgendarConsultaGarantiaAcessoMutationOptions = Apollo.BaseMutationOptions<Types.AgendarConsultaGarantiaAcessoMutation, Types.AgendarConsultaGarantiaAcessoMutationVariables>;
export const AdicionarGarantiaAcessoCeoDocument = gql`
    mutation AdicionarGarantiaAcessoCeo($input: GarantiaAcessoItemCreateInput!) {
  adicionarCidadaoGarantiaAcessoCeo(input: $input)
}
    `;
export type AdicionarGarantiaAcessoCeoMutationFn = Apollo.MutationFunction<Types.AdicionarGarantiaAcessoCeoMutation, Types.AdicionarGarantiaAcessoCeoMutationVariables>;

/**
 * __useAdicionarGarantiaAcessoCeoMutation__
 *
 * To run a mutation, you first call `useAdicionarGarantiaAcessoCeoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdicionarGarantiaAcessoCeoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adicionarGarantiaAcessoCeoMutation, { data, loading, error }] = useAdicionarGarantiaAcessoCeoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdicionarGarantiaAcessoCeoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AdicionarGarantiaAcessoCeoMutation, Types.AdicionarGarantiaAcessoCeoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AdicionarGarantiaAcessoCeoMutation, Types.AdicionarGarantiaAcessoCeoMutationVariables>(AdicionarGarantiaAcessoCeoDocument, options);
      }
export type AdicionarGarantiaAcessoCeoMutationHookResult = ReturnType<typeof useAdicionarGarantiaAcessoCeoMutation>;
export type AdicionarGarantiaAcessoCeoMutationResult = Apollo.MutationResult<Types.AdicionarGarantiaAcessoCeoMutation>;
export type AdicionarGarantiaAcessoCeoMutationOptions = Apollo.BaseMutationOptions<Types.AdicionarGarantiaAcessoCeoMutation, Types.AdicionarGarantiaAcessoCeoMutationVariables>;
export const AdicionarGarantiaAcessoDocument = gql`
    mutation AdicionarGarantiaAcesso($input: GarantiaAcessoItemCreateInput!) {
  adicionarCidadaoGarantiaAcesso(input: $input)
}
    `;
export type AdicionarGarantiaAcessoMutationFn = Apollo.MutationFunction<Types.AdicionarGarantiaAcessoMutation, Types.AdicionarGarantiaAcessoMutationVariables>;

/**
 * __useAdicionarGarantiaAcessoMutation__
 *
 * To run a mutation, you first call `useAdicionarGarantiaAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdicionarGarantiaAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adicionarGarantiaAcessoMutation, { data, loading, error }] = useAdicionarGarantiaAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdicionarGarantiaAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AdicionarGarantiaAcessoMutation, Types.AdicionarGarantiaAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AdicionarGarantiaAcessoMutation, Types.AdicionarGarantiaAcessoMutationVariables>(AdicionarGarantiaAcessoDocument, options);
      }
export type AdicionarGarantiaAcessoMutationHookResult = ReturnType<typeof useAdicionarGarantiaAcessoMutation>;
export type AdicionarGarantiaAcessoMutationResult = Apollo.MutationResult<Types.AdicionarGarantiaAcessoMutation>;
export type AdicionarGarantiaAcessoMutationOptions = Apollo.BaseMutationOptions<Types.AdicionarGarantiaAcessoMutation, Types.AdicionarGarantiaAcessoMutationVariables>;
export const EditarCidadaoGarantiaAcessoDocument = gql`
    mutation EditarCidadaoGarantiaAcesso($input: GarantiaAcessoItemUpdateInput!) {
  editarCidadaoGarantiaAcesso(input: $input)
}
    `;
export type EditarCidadaoGarantiaAcessoMutationFn = Apollo.MutationFunction<Types.EditarCidadaoGarantiaAcessoMutation, Types.EditarCidadaoGarantiaAcessoMutationVariables>;

/**
 * __useEditarCidadaoGarantiaAcessoMutation__
 *
 * To run a mutation, you first call `useEditarCidadaoGarantiaAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarCidadaoGarantiaAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarCidadaoGarantiaAcessoMutation, { data, loading, error }] = useEditarCidadaoGarantiaAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarCidadaoGarantiaAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarCidadaoGarantiaAcessoMutation, Types.EditarCidadaoGarantiaAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarCidadaoGarantiaAcessoMutation, Types.EditarCidadaoGarantiaAcessoMutationVariables>(EditarCidadaoGarantiaAcessoDocument, options);
      }
export type EditarCidadaoGarantiaAcessoMutationHookResult = ReturnType<typeof useEditarCidadaoGarantiaAcessoMutation>;
export type EditarCidadaoGarantiaAcessoMutationResult = Apollo.MutationResult<Types.EditarCidadaoGarantiaAcessoMutation>;
export type EditarCidadaoGarantiaAcessoMutationOptions = Apollo.BaseMutationOptions<Types.EditarCidadaoGarantiaAcessoMutation, Types.EditarCidadaoGarantiaAcessoMutationVariables>;
export const RemoverCidadaoGarantiaAcessoDocument = gql`
    mutation RemoverCidadaoGarantiaAcesso($input: GarantiaAcessoItemDeleteInput!) {
  removerCidadaoGarantiaAcesso(input: $input)
}
    `;
export type RemoverCidadaoGarantiaAcessoMutationFn = Apollo.MutationFunction<Types.RemoverCidadaoGarantiaAcessoMutation, Types.RemoverCidadaoGarantiaAcessoMutationVariables>;

/**
 * __useRemoverCidadaoGarantiaAcessoMutation__
 *
 * To run a mutation, you first call `useRemoverCidadaoGarantiaAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverCidadaoGarantiaAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerCidadaoGarantiaAcessoMutation, { data, loading, error }] = useRemoverCidadaoGarantiaAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoverCidadaoGarantiaAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RemoverCidadaoGarantiaAcessoMutation, Types.RemoverCidadaoGarantiaAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RemoverCidadaoGarantiaAcessoMutation, Types.RemoverCidadaoGarantiaAcessoMutationVariables>(RemoverCidadaoGarantiaAcessoDocument, options);
      }
export type RemoverCidadaoGarantiaAcessoMutationHookResult = ReturnType<typeof useRemoverCidadaoGarantiaAcessoMutation>;
export type RemoverCidadaoGarantiaAcessoMutationResult = Apollo.MutationResult<Types.RemoverCidadaoGarantiaAcessoMutation>;
export type RemoverCidadaoGarantiaAcessoMutationOptions = Apollo.BaseMutationOptions<Types.RemoverCidadaoGarantiaAcessoMutation, Types.RemoverCidadaoGarantiaAcessoMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    success
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<Types.LoginMutation, Types.LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.LoginMutation, Types.LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.LoginMutation, Types.LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<Types.LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables>;
export const AcessoEstagioDocument = gql`
    query AcessoEstagio($id: ID!) {
  estagio(id: $id) {
    id
    ativo
    lotacaoSupervisora {
      id
      profissional {
        id
        nome
      }
    }
    equipe {
      id
      nome
      ine
      tipoEquipe {
        id
        descricao
      }
    }
    cbo {
      id
      nome
      cbo2002
    }
    unidadeSaude {
      id
      nome
    }
  }
}
    `;

/**
 * __useAcessoEstagioQuery__
 *
 * To run a query within a React component, call `useAcessoEstagioQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoEstagioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoEstagioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcessoEstagioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables> & ({ variables: Types.AcessoEstagioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>(AcessoEstagioDocument, options);
      }
export function useAcessoEstagioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>(AcessoEstagioDocument, options);
        }
export function useAcessoEstagioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>(AcessoEstagioDocument, options);
        }
export type AcessoEstagioQueryHookResult = ReturnType<typeof useAcessoEstagioQuery>;
export type AcessoEstagioLazyQueryHookResult = ReturnType<typeof useAcessoEstagioLazyQuery>;
export type AcessoEstagioSuspenseQueryHookResult = ReturnType<typeof useAcessoEstagioSuspenseQuery>;
export type AcessoEstagioQueryResult = Apollo.QueryResult<Types.AcessoEstagioQuery, Types.AcessoEstagioQueryVariables>;
export const SelecionarAcessoDocument = gql`
    mutation SelecionarAcesso($input: SelecionarAcessoInput!) {
  selecionarAcesso(input: $input) {
    id
    profissional {
      id
      nome
    }
    acesso {
      id
      moduloInicial
    }
    recursos
  }
}
    `;
export type SelecionarAcessoMutationFn = Apollo.MutationFunction<Types.SelecionarAcessoMutation, Types.SelecionarAcessoMutationVariables>;

/**
 * __useSelecionarAcessoMutation__
 *
 * To run a mutation, you first call `useSelecionarAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelecionarAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selecionarAcessoMutation, { data, loading, error }] = useSelecionarAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelecionarAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SelecionarAcessoMutation, Types.SelecionarAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SelecionarAcessoMutation, Types.SelecionarAcessoMutationVariables>(SelecionarAcessoDocument, options);
      }
export type SelecionarAcessoMutationHookResult = ReturnType<typeof useSelecionarAcessoMutation>;
export type SelecionarAcessoMutationResult = Apollo.MutationResult<Types.SelecionarAcessoMutation>;
export type SelecionarAcessoMutationOptions = Apollo.BaseMutationOptions<Types.SelecionarAcessoMutation, Types.SelecionarAcessoMutationVariables>;
export const ImunobiologicoComboDocument = gql`
    query ImunobiologicoCombo($input: ImunobiologicoQueryInput!) {
  imunobiologicos(input: $input) {
    content {
      id
      sigla
      nome
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useImunobiologicoComboQuery__
 *
 * To run a query within a React component, call `useImunobiologicoComboQuery` and pass it any options that fit your needs.
 * When your component renders, `useImunobiologicoComboQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImunobiologicoComboQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImunobiologicoComboQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables> & ({ variables: Types.ImunobiologicoComboQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>(ImunobiologicoComboDocument, options);
      }
export function useImunobiologicoComboLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>(ImunobiologicoComboDocument, options);
        }
export function useImunobiologicoComboSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>(ImunobiologicoComboDocument, options);
        }
export type ImunobiologicoComboQueryHookResult = ReturnType<typeof useImunobiologicoComboQuery>;
export type ImunobiologicoComboLazyQueryHookResult = ReturnType<typeof useImunobiologicoComboLazyQuery>;
export type ImunobiologicoComboSuspenseQueryHookResult = ReturnType<typeof useImunobiologicoComboSuspenseQuery>;
export type ImunobiologicoComboQueryResult = Apollo.QueryResult<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>;
export const LoteHasCadastroDocument = gql`
    query LoteHasCadastro($input: LoteImunobiologicoInput!) {
  loteHasCadastro(input: $input)
}
    `;

/**
 * __useLoteHasCadastroQuery__
 *
 * To run a query within a React component, call `useLoteHasCadastroQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteHasCadastroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteHasCadastroQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteHasCadastroQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables> & ({ variables: Types.LoteHasCadastroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>(LoteHasCadastroDocument, options);
      }
export function useLoteHasCadastroLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>(LoteHasCadastroDocument, options);
        }
export function useLoteHasCadastroSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>(LoteHasCadastroDocument, options);
        }
export type LoteHasCadastroQueryHookResult = ReturnType<typeof useLoteHasCadastroQuery>;
export type LoteHasCadastroLazyQueryHookResult = ReturnType<typeof useLoteHasCadastroLazyQuery>;
export type LoteHasCadastroSuspenseQueryHookResult = ReturnType<typeof useLoteHasCadastroSuspenseQuery>;
export type LoteHasCadastroQueryResult = Apollo.QueryResult<Types.LoteHasCadastroQuery, Types.LoteHasCadastroQueryVariables>;
export const ExcluirLoteImunobiologicoDocument = gql`
    mutation excluirLoteImunobiologico($idLote: ID!) {
  excluirLoteImunobiologico(idLote: $idLote)
}
    `;
export type ExcluirLoteImunobiologicoMutationFn = Apollo.MutationFunction<Types.ExcluirLoteImunobiologicoMutation, Types.ExcluirLoteImunobiologicoMutationVariables>;

/**
 * __useExcluirLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useExcluirLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirLoteImunobiologicoMutation, { data, loading, error }] = useExcluirLoteImunobiologicoMutation({
 *   variables: {
 *      idLote: // value for 'idLote'
 *   },
 * });
 */
export function useExcluirLoteImunobiologicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirLoteImunobiologicoMutation, Types.ExcluirLoteImunobiologicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirLoteImunobiologicoMutation, Types.ExcluirLoteImunobiologicoMutationVariables>(ExcluirLoteImunobiologicoDocument, options);
      }
export type ExcluirLoteImunobiologicoMutationHookResult = ReturnType<typeof useExcluirLoteImunobiologicoMutation>;
export type ExcluirLoteImunobiologicoMutationResult = Apollo.MutationResult<Types.ExcluirLoteImunobiologicoMutation>;
export type ExcluirLoteImunobiologicoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirLoteImunobiologicoMutation, Types.ExcluirLoteImunobiologicoMutationVariables>;
export const LoteImunobiologicoFabricanteDocument = gql`
    query LoteImunobiologicoFabricante($input: ImunobiologicoFabricanteQueryInput!) {
  fabricantesImunobiologico(input: $input) {
    content {
      id
      nome
      codigoRnds
      sigla
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLoteImunobiologicoFabricanteQuery__
 *
 * To run a query within a React component, call `useLoteImunobiologicoFabricanteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteImunobiologicoFabricanteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteImunobiologicoFabricanteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteImunobiologicoFabricanteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables> & ({ variables: Types.LoteImunobiologicoFabricanteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>(LoteImunobiologicoFabricanteDocument, options);
      }
export function useLoteImunobiologicoFabricanteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>(LoteImunobiologicoFabricanteDocument, options);
        }
export function useLoteImunobiologicoFabricanteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>(LoteImunobiologicoFabricanteDocument, options);
        }
export type LoteImunobiologicoFabricanteQueryHookResult = ReturnType<typeof useLoteImunobiologicoFabricanteQuery>;
export type LoteImunobiologicoFabricanteLazyQueryHookResult = ReturnType<typeof useLoteImunobiologicoFabricanteLazyQuery>;
export type LoteImunobiologicoFabricanteSuspenseQueryHookResult = ReturnType<typeof useLoteImunobiologicoFabricanteSuspenseQuery>;
export type LoteImunobiologicoFabricanteQueryResult = Apollo.QueryResult<Types.LoteImunobiologicoFabricanteQuery, Types.LoteImunobiologicoFabricanteQueryVariables>;
export const LoteImunobiologicoDocument = gql`
    query LoteImunobiologico($input: LoteImunobiologicoQueryInput!) {
  lotesImunobiologico(input: $input) {
    content {
      id
      lote
      fabricante {
        id
        nome
        codigoRnds
      }
      imunobiologico {
        id
        nome
        sigla
      }
      validade
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLoteImunobiologicoQuery__
 *
 * To run a query within a React component, call `useLoteImunobiologicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteImunobiologicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteImunobiologicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteImunobiologicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables> & ({ variables: Types.LoteImunobiologicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>(LoteImunobiologicoDocument, options);
      }
export function useLoteImunobiologicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>(LoteImunobiologicoDocument, options);
        }
export function useLoteImunobiologicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>(LoteImunobiologicoDocument, options);
        }
export type LoteImunobiologicoQueryHookResult = ReturnType<typeof useLoteImunobiologicoQuery>;
export type LoteImunobiologicoLazyQueryHookResult = ReturnType<typeof useLoteImunobiologicoLazyQuery>;
export type LoteImunobiologicoSuspenseQueryHookResult = ReturnType<typeof useLoteImunobiologicoSuspenseQuery>;
export type LoteImunobiologicoQueryResult = Apollo.QueryResult<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>;
export const SetStatusLoteImunobiologicoDocument = gql`
    mutation setStatusLoteImunobiologico($input: LoteImunobiologicoInput!, $ativado: Boolean) {
  setStatusLoteImunobiologico(input: $input, status: $ativado)
}
    `;
export type SetStatusLoteImunobiologicoMutationFn = Apollo.MutationFunction<Types.SetStatusLoteImunobiologicoMutation, Types.SetStatusLoteImunobiologicoMutationVariables>;

/**
 * __useSetStatusLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useSetStatusLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStatusLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStatusLoteImunobiologicoMutation, { data, loading, error }] = useSetStatusLoteImunobiologicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ativado: // value for 'ativado'
 *   },
 * });
 */
export function useSetStatusLoteImunobiologicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SetStatusLoteImunobiologicoMutation, Types.SetStatusLoteImunobiologicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SetStatusLoteImunobiologicoMutation, Types.SetStatusLoteImunobiologicoMutationVariables>(SetStatusLoteImunobiologicoDocument, options);
      }
export type SetStatusLoteImunobiologicoMutationHookResult = ReturnType<typeof useSetStatusLoteImunobiologicoMutation>;
export type SetStatusLoteImunobiologicoMutationResult = Apollo.MutationResult<Types.SetStatusLoteImunobiologicoMutation>;
export type SetStatusLoteImunobiologicoMutationOptions = Apollo.BaseMutationOptions<Types.SetStatusLoteImunobiologicoMutation, Types.SetStatusLoteImunobiologicoMutationVariables>;
export const SalvarLoteImunobiologicoDocument = gql`
    mutation SalvarLoteImunobiologico($input: LoteImunobiologicoInput!) {
  salvarLoteImunobiologico(input: $input) {
    id
  }
}
    `;
export type SalvarLoteImunobiologicoMutationFn = Apollo.MutationFunction<Types.SalvarLoteImunobiologicoMutation, Types.SalvarLoteImunobiologicoMutationVariables>;

/**
 * __useSalvarLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useSalvarLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarLoteImunobiologicoMutation, { data, loading, error }] = useSalvarLoteImunobiologicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarLoteImunobiologicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarLoteImunobiologicoMutation, Types.SalvarLoteImunobiologicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarLoteImunobiologicoMutation, Types.SalvarLoteImunobiologicoMutationVariables>(SalvarLoteImunobiologicoDocument, options);
      }
export type SalvarLoteImunobiologicoMutationHookResult = ReturnType<typeof useSalvarLoteImunobiologicoMutation>;
export type SalvarLoteImunobiologicoMutationResult = Apollo.MutationResult<Types.SalvarLoteImunobiologicoMutation>;
export type SalvarLoteImunobiologicoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarLoteImunobiologicoMutation, Types.SalvarLoteImunobiologicoMutationVariables>;
export const ExibirNotificacaoNovidadesDocument = gql`
    mutation ExibirNotificacaoNovidades {
  exibirNotificacaoNovidades {
    id
    notificaNovidadesVersao
  }
}
    `;
export type ExibirNotificacaoNovidadesMutationFn = Apollo.MutationFunction<Types.ExibirNotificacaoNovidadesMutation, Types.ExibirNotificacaoNovidadesMutationVariables>;

/**
 * __useExibirNotificacaoNovidadesMutation__
 *
 * To run a mutation, you first call `useExibirNotificacaoNovidadesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExibirNotificacaoNovidadesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exibirNotificacaoNovidadesMutation, { data, loading, error }] = useExibirNotificacaoNovidadesMutation({
 *   variables: {
 *   },
 * });
 */
export function useExibirNotificacaoNovidadesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExibirNotificacaoNovidadesMutation, Types.ExibirNotificacaoNovidadesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExibirNotificacaoNovidadesMutation, Types.ExibirNotificacaoNovidadesMutationVariables>(ExibirNotificacaoNovidadesDocument, options);
      }
export type ExibirNotificacaoNovidadesMutationHookResult = ReturnType<typeof useExibirNotificacaoNovidadesMutation>;
export type ExibirNotificacaoNovidadesMutationResult = Apollo.MutationResult<Types.ExibirNotificacaoNovidadesMutation>;
export type ExibirNotificacaoNovidadesMutationOptions = Apollo.BaseMutationOptions<Types.ExibirNotificacaoNovidadesMutation, Types.ExibirNotificacaoNovidadesMutationVariables>;
export const VisualizouNovidadesDocument = gql`
    mutation VisualizouNovidades {
  visualizarNovidades
}
    `;
export type VisualizouNovidadesMutationFn = Apollo.MutationFunction<Types.VisualizouNovidadesMutation, Types.VisualizouNovidadesMutationVariables>;

/**
 * __useVisualizouNovidadesMutation__
 *
 * To run a mutation, you first call `useVisualizouNovidadesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisualizouNovidadesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visualizouNovidadesMutation, { data, loading, error }] = useVisualizouNovidadesMutation({
 *   variables: {
 *   },
 * });
 */
export function useVisualizouNovidadesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.VisualizouNovidadesMutation, Types.VisualizouNovidadesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.VisualizouNovidadesMutation, Types.VisualizouNovidadesMutationVariables>(VisualizouNovidadesDocument, options);
      }
export type VisualizouNovidadesMutationHookResult = ReturnType<typeof useVisualizouNovidadesMutation>;
export type VisualizouNovidadesMutationResult = Apollo.MutationResult<Types.VisualizouNovidadesMutation>;
export type VisualizouNovidadesMutationOptions = Apollo.BaseMutationOptions<Types.VisualizouNovidadesMutation, Types.VisualizouNovidadesMutationVariables>;
export const VisualizarNovidadesDocument = gql`
    query VisualizarNovidades {
  sessao {
    id
    profissional {
      id
      usuario {
        id
        visualizouNovidades
      }
    }
  }
}
    `;

/**
 * __useVisualizarNovidadesQuery__
 *
 * To run a query within a React component, call `useVisualizarNovidadesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizarNovidadesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizarNovidadesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVisualizarNovidadesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>(VisualizarNovidadesDocument, options);
      }
export function useVisualizarNovidadesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>(VisualizarNovidadesDocument, options);
        }
export function useVisualizarNovidadesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>(VisualizarNovidadesDocument, options);
        }
export type VisualizarNovidadesQueryHookResult = ReturnType<typeof useVisualizarNovidadesQuery>;
export type VisualizarNovidadesLazyQueryHookResult = ReturnType<typeof useVisualizarNovidadesLazyQuery>;
export type VisualizarNovidadesSuspenseQueryHookResult = ReturnType<typeof useVisualizarNovidadesSuspenseQuery>;
export type VisualizarNovidadesQueryResult = Apollo.QueryResult<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>;
export const MarcarNotificacaoComoLidaDocument = gql`
    mutation MarcarNotificacaoComoLida($codigoExterno: ID!, $tipoTopico: TipoTopicoNotificacaoEnum!) {
  marcarNotificacaoComoLida(
    codigoExterno: $codigoExterno
    tipoTopico: $tipoTopico
  )
}
    `;
export type MarcarNotificacaoComoLidaMutationFn = Apollo.MutationFunction<Types.MarcarNotificacaoComoLidaMutation, Types.MarcarNotificacaoComoLidaMutationVariables>;

/**
 * __useMarcarNotificacaoComoLidaMutation__
 *
 * To run a mutation, you first call `useMarcarNotificacaoComoLidaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarcarNotificacaoComoLidaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marcarNotificacaoComoLidaMutation, { data, loading, error }] = useMarcarNotificacaoComoLidaMutation({
 *   variables: {
 *      codigoExterno: // value for 'codigoExterno'
 *      tipoTopico: // value for 'tipoTopico'
 *   },
 * });
 */
export function useMarcarNotificacaoComoLidaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.MarcarNotificacaoComoLidaMutation, Types.MarcarNotificacaoComoLidaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.MarcarNotificacaoComoLidaMutation, Types.MarcarNotificacaoComoLidaMutationVariables>(MarcarNotificacaoComoLidaDocument, options);
      }
export type MarcarNotificacaoComoLidaMutationHookResult = ReturnType<typeof useMarcarNotificacaoComoLidaMutation>;
export type MarcarNotificacaoComoLidaMutationResult = Apollo.MutationResult<Types.MarcarNotificacaoComoLidaMutation>;
export type MarcarNotificacaoComoLidaMutationOptions = Apollo.BaseMutationOptions<Types.MarcarNotificacaoComoLidaMutation, Types.MarcarNotificacaoComoLidaMutationVariables>;
export const VisualizarTodasNotificacoesByTipoTopicoDocument = gql`
    mutation VisualizarTodasNotificacoesByTipoTopico($tipoTopico: TipoTopicoNotificacaoEnum!) {
  visualizarTodasNotificacoesByTipoTopico(tipoTopico: $tipoTopico)
}
    `;
export type VisualizarTodasNotificacoesByTipoTopicoMutationFn = Apollo.MutationFunction<Types.VisualizarTodasNotificacoesByTipoTopicoMutation, Types.VisualizarTodasNotificacoesByTipoTopicoMutationVariables>;

/**
 * __useVisualizarTodasNotificacoesByTipoTopicoMutation__
 *
 * To run a mutation, you first call `useVisualizarTodasNotificacoesByTipoTopicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisualizarTodasNotificacoesByTipoTopicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visualizarTodasNotificacoesByTipoTopicoMutation, { data, loading, error }] = useVisualizarTodasNotificacoesByTipoTopicoMutation({
 *   variables: {
 *      tipoTopico: // value for 'tipoTopico'
 *   },
 * });
 */
export function useVisualizarTodasNotificacoesByTipoTopicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.VisualizarTodasNotificacoesByTipoTopicoMutation, Types.VisualizarTodasNotificacoesByTipoTopicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.VisualizarTodasNotificacoesByTipoTopicoMutation, Types.VisualizarTodasNotificacoesByTipoTopicoMutationVariables>(VisualizarTodasNotificacoesByTipoTopicoDocument, options);
      }
export type VisualizarTodasNotificacoesByTipoTopicoMutationHookResult = ReturnType<typeof useVisualizarTodasNotificacoesByTipoTopicoMutation>;
export type VisualizarTodasNotificacoesByTipoTopicoMutationResult = Apollo.MutationResult<Types.VisualizarTodasNotificacoesByTipoTopicoMutation>;
export type VisualizarTodasNotificacoesByTipoTopicoMutationOptions = Apollo.BaseMutationOptions<Types.VisualizarTodasNotificacoesByTipoTopicoMutation, Types.VisualizarTodasNotificacoesByTipoTopicoMutationVariables>;
export const AtivarPerfilDocument = gql`
    mutation AtivarPerfil($id: ID!) {
  ativarPerfil(id: $id) {
    id
    ativo
  }
}
    `;
export type AtivarPerfilMutationFn = Apollo.MutationFunction<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>;

/**
 * __useAtivarPerfilMutation__
 *
 * To run a mutation, you first call `useAtivarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarPerfilMutation, { data, loading, error }] = useAtivarPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtivarPerfilMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>(AtivarPerfilDocument, options);
      }
export type AtivarPerfilMutationHookResult = ReturnType<typeof useAtivarPerfilMutation>;
export type AtivarPerfilMutationResult = Apollo.MutationResult<Types.AtivarPerfilMutation>;
export type AtivarPerfilMutationOptions = Apollo.BaseMutationOptions<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>;
export const CriarPerfilDocument = gql`
    mutation CriarPerfil($input: PerfilInput!) {
  criarPerfil(input: $input) {
    id
    nome
    ativo
  }
}
    `;
export type CriarPerfilMutationFn = Apollo.MutationFunction<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>;

/**
 * __useCriarPerfilMutation__
 *
 * To run a mutation, you first call `useCriarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarPerfilMutation, { data, loading, error }] = useCriarPerfilMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarPerfilMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>(CriarPerfilDocument, options);
      }
export type CriarPerfilMutationHookResult = ReturnType<typeof useCriarPerfilMutation>;
export type CriarPerfilMutationResult = Apollo.MutationResult<Types.CriarPerfilMutation>;
export type CriarPerfilMutationOptions = Apollo.BaseMutationOptions<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>;
export const ExcluirPerfilDocument = gql`
    mutation ExcluirPerfil($id: ID!) {
  excluirPerfil(id: $id) {
    id
  }
}
    `;
export type ExcluirPerfilMutationFn = Apollo.MutationFunction<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>;

/**
 * __useExcluirPerfilMutation__
 *
 * To run a mutation, you first call `useExcluirPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirPerfilMutation, { data, loading, error }] = useExcluirPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirPerfilMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>(ExcluirPerfilDocument, options);
      }
export type ExcluirPerfilMutationHookResult = ReturnType<typeof useExcluirPerfilMutation>;
export type ExcluirPerfilMutationResult = Apollo.MutationResult<Types.ExcluirPerfilMutation>;
export type ExcluirPerfilMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>;
export const InativarPerfilDocument = gql`
    mutation InativarPerfil($id: ID!) {
  inativarPerfil(id: $id) {
    id
    ativo
  }
}
    `;
export type InativarPerfilMutationFn = Apollo.MutationFunction<Types.InativarPerfilMutation, Types.InativarPerfilMutationVariables>;

/**
 * __useInativarPerfilMutation__
 *
 * To run a mutation, you first call `useInativarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarPerfilMutation, { data, loading, error }] = useInativarPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInativarPerfilMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarPerfilMutation, Types.InativarPerfilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarPerfilMutation, Types.InativarPerfilMutationVariables>(InativarPerfilDocument, options);
      }
export type InativarPerfilMutationHookResult = ReturnType<typeof useInativarPerfilMutation>;
export type InativarPerfilMutationResult = Apollo.MutationResult<Types.InativarPerfilMutation>;
export type InativarPerfilMutationOptions = Apollo.BaseMutationOptions<Types.InativarPerfilMutation, Types.InativarPerfilMutationVariables>;
export const RecursosDocument = gql`
    query Recursos($tipoAcesso: TipoAcesso!) {
  recursos(tipoAcesso: $tipoAcesso)
}
    `;

/**
 * __useRecursosQuery__
 *
 * To run a query within a React component, call `useRecursosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecursosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecursosQuery({
 *   variables: {
 *      tipoAcesso: // value for 'tipoAcesso'
 *   },
 * });
 */
export function useRecursosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RecursosQuery, Types.RecursosQueryVariables> & ({ variables: Types.RecursosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RecursosQuery, Types.RecursosQueryVariables>(RecursosDocument, options);
      }
export function useRecursosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RecursosQuery, Types.RecursosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RecursosQuery, Types.RecursosQueryVariables>(RecursosDocument, options);
        }
export function useRecursosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RecursosQuery, Types.RecursosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RecursosQuery, Types.RecursosQueryVariables>(RecursosDocument, options);
        }
export type RecursosQueryHookResult = ReturnType<typeof useRecursosQuery>;
export type RecursosLazyQueryHookResult = ReturnType<typeof useRecursosLazyQuery>;
export type RecursosSuspenseQueryHookResult = ReturnType<typeof useRecursosSuspenseQuery>;
export type RecursosQueryResult = Apollo.QueryResult<Types.RecursosQuery, Types.RecursosQueryVariables>;
export const PerfilDetailDocument = gql`
    query PerfilDetail($perfilId: ID!) {
  perfil(id: $perfilId) {
    id
    nome
    tipoPerfil
    recursos
    perfilPadrao
  }
}
    `;

/**
 * __usePerfilDetailQuery__
 *
 * To run a query within a React component, call `usePerfilDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilDetailQuery({
 *   variables: {
 *      perfilId: // value for 'perfilId'
 *   },
 * });
 */
export function usePerfilDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables> & ({ variables: Types.PerfilDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>(PerfilDetailDocument, options);
      }
export function usePerfilDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>(PerfilDetailDocument, options);
        }
export function usePerfilDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>(PerfilDetailDocument, options);
        }
export type PerfilDetailQueryHookResult = ReturnType<typeof usePerfilDetailQuery>;
export type PerfilDetailLazyQueryHookResult = ReturnType<typeof usePerfilDetailLazyQuery>;
export type PerfilDetailSuspenseQueryHookResult = ReturnType<typeof usePerfilDetailSuspenseQuery>;
export type PerfilDetailQueryResult = Apollo.QueryResult<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>;
export const AtualizarPerfilDocument = gql`
    mutation AtualizarPerfil($input: PerfilInput!) {
  atualizarPerfil(input: $input) {
    id
    nome
    ativo
  }
}
    `;
export type AtualizarPerfilMutationFn = Apollo.MutationFunction<Types.AtualizarPerfilMutation, Types.AtualizarPerfilMutationVariables>;

/**
 * __useAtualizarPerfilMutation__
 *
 * To run a mutation, you first call `useAtualizarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarPerfilMutation, { data, loading, error }] = useAtualizarPerfilMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarPerfilMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtualizarPerfilMutation, Types.AtualizarPerfilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtualizarPerfilMutation, Types.AtualizarPerfilMutationVariables>(AtualizarPerfilDocument, options);
      }
export type AtualizarPerfilMutationHookResult = ReturnType<typeof useAtualizarPerfilMutation>;
export type AtualizarPerfilMutationResult = Apollo.MutationResult<Types.AtualizarPerfilMutation>;
export type AtualizarPerfilMutationOptions = Apollo.BaseMutationOptions<Types.AtualizarPerfilMutation, Types.AtualizarPerfilMutationVariables>;
export const PerfilEditDocument = gql`
    query PerfilEdit($perfilId: ID!) {
  perfil(id: $perfilId) {
    id
    nome
    tipoPerfil
    recursos
    perfilPadrao
  }
}
    `;

/**
 * __usePerfilEditQuery__
 *
 * To run a query within a React component, call `usePerfilEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilEditQuery({
 *   variables: {
 *      perfilId: // value for 'perfilId'
 *   },
 * });
 */
export function usePerfilEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PerfilEditQuery, Types.PerfilEditQueryVariables> & ({ variables: Types.PerfilEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>(PerfilEditDocument, options);
      }
export function usePerfilEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>(PerfilEditDocument, options);
        }
export function usePerfilEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>(PerfilEditDocument, options);
        }
export type PerfilEditQueryHookResult = ReturnType<typeof usePerfilEditQuery>;
export type PerfilEditLazyQueryHookResult = ReturnType<typeof usePerfilEditLazyQuery>;
export type PerfilEditSuspenseQueryHookResult = ReturnType<typeof usePerfilEditSuspenseQuery>;
export type PerfilEditQueryResult = Apollo.QueryResult<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>;
export const PerfilTableDocument = gql`
    query PerfilTable($input: PerfisQueryInput!) {
  perfis(input: $input) {
    content {
      id
      nome
      ativo
      tipoPerfil
      perfilPadrao
      actions {
        excluir {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePerfilTableQuery__
 *
 * To run a query within a React component, call `usePerfilTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerfilTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PerfilTableQuery, Types.PerfilTableQueryVariables> & ({ variables: Types.PerfilTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>(PerfilTableDocument, options);
      }
export function usePerfilTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>(PerfilTableDocument, options);
        }
export function usePerfilTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>(PerfilTableDocument, options);
        }
export type PerfilTableQueryHookResult = ReturnType<typeof usePerfilTableQuery>;
export type PerfilTableLazyQueryHookResult = ReturnType<typeof usePerfilTableLazyQuery>;
export type PerfilTableSuspenseQueryHookResult = ReturnType<typeof usePerfilTableSuspenseQuery>;
export type PerfilTableQueryResult = Apollo.QueryResult<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>;
export const ResponderPesquisaSatisfacaoDocument = gql`
    mutation responderPesquisaSatisfacao($input: RespostaPesquisa!) {
  responderPesquisaSatisfacao(input: $input) {
    id
    mostrarPesquisaSatisfacao
  }
}
    `;
export type ResponderPesquisaSatisfacaoMutationFn = Apollo.MutationFunction<Types.ResponderPesquisaSatisfacaoMutation, Types.ResponderPesquisaSatisfacaoMutationVariables>;

/**
 * __useResponderPesquisaSatisfacaoMutation__
 *
 * To run a mutation, you first call `useResponderPesquisaSatisfacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponderPesquisaSatisfacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responderPesquisaSatisfacaoMutation, { data, loading, error }] = useResponderPesquisaSatisfacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponderPesquisaSatisfacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ResponderPesquisaSatisfacaoMutation, Types.ResponderPesquisaSatisfacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ResponderPesquisaSatisfacaoMutation, Types.ResponderPesquisaSatisfacaoMutationVariables>(ResponderPesquisaSatisfacaoDocument, options);
      }
export type ResponderPesquisaSatisfacaoMutationHookResult = ReturnType<typeof useResponderPesquisaSatisfacaoMutation>;
export type ResponderPesquisaSatisfacaoMutationResult = Apollo.MutationResult<Types.ResponderPesquisaSatisfacaoMutation>;
export type ResponderPesquisaSatisfacaoMutationOptions = Apollo.BaseMutationOptions<Types.ResponderPesquisaSatisfacaoMutation, Types.ResponderPesquisaSatisfacaoMutationVariables>;
export const ProfissionalEditDocument = gql`
    query ProfissionalEdit($id: ID!) {
  profissional(id: $id) {
    id
    nomeCivil
    nomeSocial
    numeroConselhoClasse
    sexo
    telefone
    cns
    cpf
    dataNascimento
    email
    conselhoClasse {
      id
      descricao
      sigla
    }
    ufEmissoraConselhoClasse {
      id
      nome
      sigla
    }
    endereco {
      bairro
      cep
      complemento
      logradouro
      numero
      pontoReferencia
      municipio {
        id
        ibge
        nome
        uf {
          id
          nome
          sigla
        }
      }
      semNumero
      tipoLogradouro {
        id
        nome
        numeroDne
      }
      uf {
        id
        nome
        sigla
      }
    }
    lotacoes {
      id
      ativo
    }
    estagios {
      id
      ativo
    }
  }
}
    `;

/**
 * __useProfissionalEditQuery__
 *
 * To run a query within a React component, call `useProfissionalEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfissionalEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables> & ({ variables: Types.ProfissionalEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>(ProfissionalEditDocument, options);
      }
export function useProfissionalEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>(ProfissionalEditDocument, options);
        }
export function useProfissionalEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>(ProfissionalEditDocument, options);
        }
export type ProfissionalEditQueryHookResult = ReturnType<typeof useProfissionalEditQuery>;
export type ProfissionalEditLazyQueryHookResult = ReturnType<typeof useProfissionalEditLazyQuery>;
export type ProfissionalEditSuspenseQueryHookResult = ReturnType<typeof useProfissionalEditSuspenseQuery>;
export type ProfissionalEditQueryResult = Apollo.QueryResult<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>;
export const SalvarProfissionalDocument = gql`
    mutation SalvarProfissional($input: ProfissionalInput!) {
  salvarProfissional(input: $input) {
    id
    nome
  }
}
    `;
export type SalvarProfissionalMutationFn = Apollo.MutationFunction<Types.SalvarProfissionalMutation, Types.SalvarProfissionalMutationVariables>;

/**
 * __useSalvarProfissionalMutation__
 *
 * To run a mutation, you first call `useSalvarProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarProfissionalMutation, { data, loading, error }] = useSalvarProfissionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarProfissionalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarProfissionalMutation, Types.SalvarProfissionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarProfissionalMutation, Types.SalvarProfissionalMutationVariables>(SalvarProfissionalDocument, options);
      }
export type SalvarProfissionalMutationHookResult = ReturnType<typeof useSalvarProfissionalMutation>;
export type SalvarProfissionalMutationResult = Apollo.MutationResult<Types.SalvarProfissionalMutation>;
export type SalvarProfissionalMutationOptions = Apollo.BaseMutationOptions<Types.SalvarProfissionalMutation, Types.SalvarProfissionalMutationVariables>;
export const ConfiguracaoAgendaOnlineLotacaoDocument = gql`
    query ConfiguracaoAgendaOnlineLotacao($lotacaoId: ID!) {
  lotacao(id: $lotacaoId) {
    id
    hasConfiguracaoAgendaOnline
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      ine
      nome
    }
    unidadeSaude {
      id
      nome
    }
    profissional {
      id
      nome
    }
    gradeConfiguracaoAgendaOnline {
      horariosConsolidados
      configuracoesSemana {
        diaSemana
        configuracoes {
          horario
          ativo
        }
      }
    }
    actions {
      permissaoConfigurarAgendaOnline {
        enabled
      }
    }
  }
}
    `;

/**
 * __useConfiguracaoAgendaOnlineLotacaoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaOnlineLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaOnlineLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaOnlineLotacaoQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useConfiguracaoAgendaOnlineLotacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables> & ({ variables: Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>(ConfiguracaoAgendaOnlineLotacaoDocument, options);
      }
export function useConfiguracaoAgendaOnlineLotacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>(ConfiguracaoAgendaOnlineLotacaoDocument, options);
        }
export function useConfiguracaoAgendaOnlineLotacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>(ConfiguracaoAgendaOnlineLotacaoDocument, options);
        }
export type ConfiguracaoAgendaOnlineLotacaoQueryHookResult = ReturnType<typeof useConfiguracaoAgendaOnlineLotacaoQuery>;
export type ConfiguracaoAgendaOnlineLotacaoLazyQueryHookResult = ReturnType<typeof useConfiguracaoAgendaOnlineLotacaoLazyQuery>;
export type ConfiguracaoAgendaOnlineLotacaoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoAgendaOnlineLotacaoSuspenseQuery>;
export type ConfiguracaoAgendaOnlineLotacaoQueryResult = Apollo.QueryResult<Types.ConfiguracaoAgendaOnlineLotacaoQuery, Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables>;
export const SalvarConfiguracaoAgendaOnlineLotacaoDocument = gql`
    mutation SalvarConfiguracaoAgendaOnlineLotacao($configuracaoAgendaOnlineLotacaoInput: ConfiguracaoAgendaOnlineLotacaoInput!) {
  salvarConfiguracaoAgendaOnlineLotacao(
    configuracaoAgendaOnlineLotacaoInput: $configuracaoAgendaOnlineLotacaoInput
  )
}
    `;
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationFn = Apollo.MutationFunction<Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation, Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables>;

/**
 * __useSalvarConfiguracaoAgendaOnlineLotacaoMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoAgendaOnlineLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoAgendaOnlineLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoAgendaOnlineLotacaoMutation, { data, loading, error }] = useSalvarConfiguracaoAgendaOnlineLotacaoMutation({
 *   variables: {
 *      configuracaoAgendaOnlineLotacaoInput: // value for 'configuracaoAgendaOnlineLotacaoInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoAgendaOnlineLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation, Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation, Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables>(SalvarConfiguracaoAgendaOnlineLotacaoDocument, options);
      }
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationHookResult = ReturnType<typeof useSalvarConfiguracaoAgendaOnlineLotacaoMutation>;
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationResult = Apollo.MutationResult<Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation>;
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation, Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables>;
export const ConfiguracaoAgendaLotacaoDocument = gql`
    query ConfiguracaoAgendaLotacao($lotacaoId: ID!) {
  lotacao(id: $lotacaoId) {
    id
    hasConfiguracaoAgenda
    hasConfiguracaoAgendaOnline
    hasAgendamentoFuturo
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      ine
      nome
    }
    unidadeSaude {
      id
      nome
      cnes
    }
    profissional {
      id
      nome
    }
    configuracaoAgenda {
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
    actions {
      permissaoConfigurarAgenda {
        enabled
      }
      permissaoFecharAgenda {
        enabled
      }
    }
  }
  conexao {
    agendaOnline {
      ativa
    }
  }
  duracaoAtendimentoPadraoMunicipio {
    duracaoAtendimentoPadraoMunicipio
  }
  configuracaoHorariosMunicipio {
    id
    configuracaoHorarioAgenda {
      configuracaoDiasSemana {
        diaSemana
        periodos {
          periodo
          horarioInicial
          horarioFinal
        }
      }
    }
  }
}
    `;

/**
 * __useConfiguracaoAgendaLotacaoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaLotacaoQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useConfiguracaoAgendaLotacaoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables> & ({ variables: Types.ConfiguracaoAgendaLotacaoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>(ConfiguracaoAgendaLotacaoDocument, options);
      }
export function useConfiguracaoAgendaLotacaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>(ConfiguracaoAgendaLotacaoDocument, options);
        }
export function useConfiguracaoAgendaLotacaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>(ConfiguracaoAgendaLotacaoDocument, options);
        }
export type ConfiguracaoAgendaLotacaoQueryHookResult = ReturnType<typeof useConfiguracaoAgendaLotacaoQuery>;
export type ConfiguracaoAgendaLotacaoLazyQueryHookResult = ReturnType<typeof useConfiguracaoAgendaLotacaoLazyQuery>;
export type ConfiguracaoAgendaLotacaoSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoAgendaLotacaoSuspenseQuery>;
export type ConfiguracaoAgendaLotacaoQueryResult = Apollo.QueryResult<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>;
export const DesativarConfiguracaoAgendaOnlineLotacaoDocument = gql`
    mutation DesativarConfiguracaoAgendaOnlineLotacao($id: ID!) {
  desativarConfiguracaoAgendaOnlineLotacao(id: $id)
}
    `;
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationFn = Apollo.MutationFunction<Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation, Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables>;

/**
 * __useDesativarConfiguracaoAgendaOnlineLotacaoMutation__
 *
 * To run a mutation, you first call `useDesativarConfiguracaoAgendaOnlineLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarConfiguracaoAgendaOnlineLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarConfiguracaoAgendaOnlineLotacaoMutation, { data, loading, error }] = useDesativarConfiguracaoAgendaOnlineLotacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDesativarConfiguracaoAgendaOnlineLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation, Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation, Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables>(DesativarConfiguracaoAgendaOnlineLotacaoDocument, options);
      }
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationHookResult = ReturnType<typeof useDesativarConfiguracaoAgendaOnlineLotacaoMutation>;
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationResult = Apollo.MutationResult<Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation>;
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation, Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables>;
export const ExcluirConfiguracaoAgendaLotacaoDocument = gql`
    mutation ExcluirConfiguracaoAgendaLotacao($id: ID!) {
  excluirConfiguracaoAgendaLotacao(id: $id)
}
    `;
export type ExcluirConfiguracaoAgendaLotacaoMutationFn = Apollo.MutationFunction<Types.ExcluirConfiguracaoAgendaLotacaoMutation, Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables>;

/**
 * __useExcluirConfiguracaoAgendaLotacaoMutation__
 *
 * To run a mutation, you first call `useExcluirConfiguracaoAgendaLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfiguracaoAgendaLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfiguracaoAgendaLotacaoMutation, { data, loading, error }] = useExcluirConfiguracaoAgendaLotacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirConfiguracaoAgendaLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirConfiguracaoAgendaLotacaoMutation, Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirConfiguracaoAgendaLotacaoMutation, Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables>(ExcluirConfiguracaoAgendaLotacaoDocument, options);
      }
export type ExcluirConfiguracaoAgendaLotacaoMutationHookResult = ReturnType<typeof useExcluirConfiguracaoAgendaLotacaoMutation>;
export type ExcluirConfiguracaoAgendaLotacaoMutationResult = Apollo.MutationResult<Types.ExcluirConfiguracaoAgendaLotacaoMutation>;
export type ExcluirConfiguracaoAgendaLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirConfiguracaoAgendaLotacaoMutation, Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables>;
export const SalvarConfiguracaoAgendaLotacaoDocument = gql`
    mutation SalvarConfiguracaoAgendaLotacao($configuracaoAgendaLotacaoInput: ConfiguracaoAgendaLotacaoInput!) {
  salvarConfiguracaoAgendaLotacao(
    configuracaoAgendaLotacaoInput: $configuracaoAgendaLotacaoInput
  )
}
    `;
export type SalvarConfiguracaoAgendaLotacaoMutationFn = Apollo.MutationFunction<Types.SalvarConfiguracaoAgendaLotacaoMutation, Types.SalvarConfiguracaoAgendaLotacaoMutationVariables>;

/**
 * __useSalvarConfiguracaoAgendaLotacaoMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoAgendaLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoAgendaLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoAgendaLotacaoMutation, { data, loading, error }] = useSalvarConfiguracaoAgendaLotacaoMutation({
 *   variables: {
 *      configuracaoAgendaLotacaoInput: // value for 'configuracaoAgendaLotacaoInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoAgendaLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarConfiguracaoAgendaLotacaoMutation, Types.SalvarConfiguracaoAgendaLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarConfiguracaoAgendaLotacaoMutation, Types.SalvarConfiguracaoAgendaLotacaoMutationVariables>(SalvarConfiguracaoAgendaLotacaoDocument, options);
      }
export type SalvarConfiguracaoAgendaLotacaoMutationHookResult = ReturnType<typeof useSalvarConfiguracaoAgendaLotacaoMutation>;
export type SalvarConfiguracaoAgendaLotacaoMutationResult = Apollo.MutationResult<Types.SalvarConfiguracaoAgendaLotacaoMutation>;
export type SalvarConfiguracaoAgendaLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarConfiguracaoAgendaLotacaoMutation, Types.SalvarConfiguracaoAgendaLotacaoMutationVariables>;
export const ExcluirFechamentoAgendaDocument = gql`
    mutation ExcluirFechamentoAgenda($id: ID!) {
  excluirFechamento(id: $id)
}
    `;
export type ExcluirFechamentoAgendaMutationFn = Apollo.MutationFunction<Types.ExcluirFechamentoAgendaMutation, Types.ExcluirFechamentoAgendaMutationVariables>;

/**
 * __useExcluirFechamentoAgendaMutation__
 *
 * To run a mutation, you first call `useExcluirFechamentoAgendaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirFechamentoAgendaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirFechamentoAgendaMutation, { data, loading, error }] = useExcluirFechamentoAgendaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirFechamentoAgendaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirFechamentoAgendaMutation, Types.ExcluirFechamentoAgendaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirFechamentoAgendaMutation, Types.ExcluirFechamentoAgendaMutationVariables>(ExcluirFechamentoAgendaDocument, options);
      }
export type ExcluirFechamentoAgendaMutationHookResult = ReturnType<typeof useExcluirFechamentoAgendaMutation>;
export type ExcluirFechamentoAgendaMutationResult = Apollo.MutationResult<Types.ExcluirFechamentoAgendaMutation>;
export type ExcluirFechamentoAgendaMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirFechamentoAgendaMutation, Types.ExcluirFechamentoAgendaMutationVariables>;
export const FechamentoAgendaTableDocument = gql`
    query FechamentoAgendaTable($input: FechamentoAgendaQueryInput!) {
  fechamentos(input: $input) {
    content {
      id
      dataInicial
      dataFinal
      motivo
      especifique
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useFechamentoAgendaTableQuery__
 *
 * To run a query within a React component, call `useFechamentoAgendaTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFechamentoAgendaTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFechamentoAgendaTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFechamentoAgendaTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables> & ({ variables: Types.FechamentoAgendaTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>(FechamentoAgendaTableDocument, options);
      }
export function useFechamentoAgendaTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>(FechamentoAgendaTableDocument, options);
        }
export function useFechamentoAgendaTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>(FechamentoAgendaTableDocument, options);
        }
export type FechamentoAgendaTableQueryHookResult = ReturnType<typeof useFechamentoAgendaTableQuery>;
export type FechamentoAgendaTableLazyQueryHookResult = ReturnType<typeof useFechamentoAgendaTableLazyQuery>;
export type FechamentoAgendaTableSuspenseQueryHookResult = ReturnType<typeof useFechamentoAgendaTableSuspenseQuery>;
export type FechamentoAgendaTableQueryResult = Apollo.QueryResult<Types.FechamentoAgendaTableQuery, Types.FechamentoAgendaTableQueryVariables>;
export const SalvarFechamentoAgendaDocument = gql`
    mutation SalvarFechamentoAgenda($input: FechamentoAgendaInput!) {
  salvarFechamento(input: $input) {
    id
  }
}
    `;
export type SalvarFechamentoAgendaMutationFn = Apollo.MutationFunction<Types.SalvarFechamentoAgendaMutation, Types.SalvarFechamentoAgendaMutationVariables>;

/**
 * __useSalvarFechamentoAgendaMutation__
 *
 * To run a mutation, you first call `useSalvarFechamentoAgendaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarFechamentoAgendaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarFechamentoAgendaMutation, { data, loading, error }] = useSalvarFechamentoAgendaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarFechamentoAgendaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarFechamentoAgendaMutation, Types.SalvarFechamentoAgendaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarFechamentoAgendaMutation, Types.SalvarFechamentoAgendaMutationVariables>(SalvarFechamentoAgendaDocument, options);
      }
export type SalvarFechamentoAgendaMutationHookResult = ReturnType<typeof useSalvarFechamentoAgendaMutation>;
export type SalvarFechamentoAgendaMutationResult = Apollo.MutationResult<Types.SalvarFechamentoAgendaMutation>;
export type SalvarFechamentoAgendaMutationOptions = Apollo.BaseMutationOptions<Types.SalvarFechamentoAgendaMutation, Types.SalvarFechamentoAgendaMutationVariables>;
export const ProfissionalAcessosDocument = gql`
    query ProfissionalAcessos($profissionalId: ID!) {
  profissional(id: $profissionalId) {
    id
    cns
    acessos(input: {mostrarInativos: true}) {
      id
      tipo
      ativo
      perfis {
        id
        nome
        ativo
      }
      actions {
        permissaoEdicao {
          enabled
          hint
        }
        permissaoExclusao {
          enabled
          hint
        }
        permissaoAtivacaoInativacao {
          enabled
          hint
        }
        ... on LotacaoActions {
          permissaoConfigurarAgenda {
            enabled
            hint
          }
          permissaoConfigurarAgendaOnline {
            enabled
            hint
          }
          permissaoFecharAgenda {
            enabled
            hint
          }
        }
      }
      ... on AdministradorMunicipal {
        municipio {
          id
          nome
        }
      }
      ... on GestorEstadual {
        uf {
          id
          nome
        }
      }
      ... on GestorMunicipal {
        municipio {
          id
          nome
        }
      }
      ... on Lotacao {
        importada
        hasConfiguracaoAgenda
        hasConfiguracaoAgendaOnline
        hasAgendamentoFuturo
        cbo {
          id
          nome
          cbo2002
        }
        equipe {
          id
          nome
          ine
          tipoEquipe {
            id
            descricao
          }
        }
        unidadeSaude {
          id
          nome
        }
      }
      ... on Estagio {
        nivelTecnico
        dataFimVigencia
        instituicaoEnsino
        dataInicioVigencia
        lotacaoSupervisora {
          id
          profissional {
            id
            nome
          }
          cbo {
            id
            nome
            cbo2002
          }
        }
        cbo {
          id
          nome
          cbo2002
        }
        equipe {
          id
          nome
          ine
          tipoEquipe {
            id
            descricao
          }
        }
        unidadeSaude {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useProfissionalAcessosQuery__
 *
 * To run a query within a React component, call `useProfissionalAcessosQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAcessosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAcessosQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useProfissionalAcessosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables> & ({ variables: Types.ProfissionalAcessosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>(ProfissionalAcessosDocument, options);
      }
export function useProfissionalAcessosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>(ProfissionalAcessosDocument, options);
        }
export function useProfissionalAcessosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>(ProfissionalAcessosDocument, options);
        }
export type ProfissionalAcessosQueryHookResult = ReturnType<typeof useProfissionalAcessosQuery>;
export type ProfissionalAcessosLazyQueryHookResult = ReturnType<typeof useProfissionalAcessosLazyQuery>;
export type ProfissionalAcessosSuspenseQueryHookResult = ReturnType<typeof useProfissionalAcessosSuspenseQuery>;
export type ProfissionalAcessosQueryResult = Apollo.QueryResult<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>;
export const ProfissionalDetailDocument = gql`
    query profissionalDetail($id: ID!) {
  profissional(id: $id) {
    lotacoes {
      ativo
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        ine
        nome
        tipoEquipe {
          id
          nome
          sigla
        }
      }
      id
      unidadeSaude {
        id
        nome
        cnes
      }
    }
    ...ProfissionalDetail
  }
}
    ${ProfissionalDetailFragmentDoc}`;

/**
 * __useProfissionalDetailQuery__
 *
 * To run a query within a React component, call `useProfissionalDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfissionalDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables> & ({ variables: Types.ProfissionalDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>(ProfissionalDetailDocument, options);
      }
export function useProfissionalDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>(ProfissionalDetailDocument, options);
        }
export function useProfissionalDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>(ProfissionalDetailDocument, options);
        }
export type ProfissionalDetailQueryHookResult = ReturnType<typeof useProfissionalDetailQuery>;
export type ProfissionalDetailLazyQueryHookResult = ReturnType<typeof useProfissionalDetailLazyQuery>;
export type ProfissionalDetailSuspenseQueryHookResult = ReturnType<typeof useProfissionalDetailSuspenseQuery>;
export type ProfissionalDetailQueryResult = Apollo.QueryResult<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>;
export const AcessoCreateDocument = gql`
    query AcessoCreate($profissionalId: ID!) {
  profissional(id: $profissionalId) {
    id
    nome
  }
}
    `;

/**
 * __useAcessoCreateQuery__
 *
 * To run a query within a React component, call `useAcessoCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoCreateQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useAcessoCreateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables> & ({ variables: Types.AcessoCreateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>(AcessoCreateDocument, options);
      }
export function useAcessoCreateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>(AcessoCreateDocument, options);
        }
export function useAcessoCreateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>(AcessoCreateDocument, options);
        }
export type AcessoCreateQueryHookResult = ReturnType<typeof useAcessoCreateQuery>;
export type AcessoCreateLazyQueryHookResult = ReturnType<typeof useAcessoCreateLazyQuery>;
export type AcessoCreateSuspenseQueryHookResult = ReturnType<typeof useAcessoCreateSuspenseQuery>;
export type AcessoCreateQueryResult = Apollo.QueryResult<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>;
export const AcessoEditDocument = gql`
    query AcessoEdit($acessoId: ID!, $profissionalId: ID!) {
  acesso(id: $acessoId) {
    id
    tipo
    actions {
      permissaoEdicao {
        enabled
      }
    }
    perfis {
      id
      nome
      ativo
    }
    ... on GestorEstadual {
      uf {
        id
        nome
        sigla
      }
    }
    ... on GestorMunicipal {
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
    }
  }
  profissional(id: $profissionalId) {
    id
    nome
  }
}
    `;

/**
 * __useAcessoEditQuery__
 *
 * To run a query within a React component, call `useAcessoEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoEditQuery({
 *   variables: {
 *      acessoId: // value for 'acessoId'
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useAcessoEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AcessoEditQuery, Types.AcessoEditQueryVariables> & ({ variables: Types.AcessoEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>(AcessoEditDocument, options);
      }
export function useAcessoEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>(AcessoEditDocument, options);
        }
export function useAcessoEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>(AcessoEditDocument, options);
        }
export type AcessoEditQueryHookResult = ReturnType<typeof useAcessoEditQuery>;
export type AcessoEditLazyQueryHookResult = ReturnType<typeof useAcessoEditLazyQuery>;
export type AcessoEditSuspenseQueryHookResult = ReturnType<typeof useAcessoEditSuspenseQuery>;
export type AcessoEditQueryResult = Apollo.QueryResult<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>;
export const SalvarAcessoDocument = gql`
    mutation SalvarAcesso($input: OutroAcessoInput!) {
  salvarOutroAcesso(input: $input) {
    id
  }
}
    `;
export type SalvarAcessoMutationFn = Apollo.MutationFunction<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>;

/**
 * __useSalvarAcessoMutation__
 *
 * To run a mutation, you first call `useSalvarAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAcessoMutation, { data, loading, error }] = useSalvarAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>(SalvarAcessoDocument, options);
      }
export type SalvarAcessoMutationHookResult = ReturnType<typeof useSalvarAcessoMutation>;
export type SalvarAcessoMutationResult = Apollo.MutationResult<Types.SalvarAcessoMutation>;
export type SalvarAcessoMutationOptions = Apollo.BaseMutationOptions<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>;
export const AgendaEmConflitoDocument = gql`
    query AgendaEmConflito($id: ID!) {
  agendaEmConflito(lotacaoId: $id)
}
    `;

/**
 * __useAgendaEmConflitoQuery__
 *
 * To run a query within a React component, call `useAgendaEmConflitoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaEmConflitoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaEmConflitoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgendaEmConflitoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables> & ({ variables: Types.AgendaEmConflitoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>(AgendaEmConflitoDocument, options);
      }
export function useAgendaEmConflitoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>(AgendaEmConflitoDocument, options);
        }
export function useAgendaEmConflitoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>(AgendaEmConflitoDocument, options);
        }
export type AgendaEmConflitoQueryHookResult = ReturnType<typeof useAgendaEmConflitoQuery>;
export type AgendaEmConflitoLazyQueryHookResult = ReturnType<typeof useAgendaEmConflitoLazyQuery>;
export type AgendaEmConflitoSuspenseQueryHookResult = ReturnType<typeof useAgendaEmConflitoSuspenseQuery>;
export type AgendaEmConflitoQueryResult = Apollo.QueryResult<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>;
export const ExcluirLotacaoDocument = gql`
    mutation ExcluirLotacao($lotacaoId: ID!) {
  excluirLotacao(lotacaoId: $lotacaoId)
}
    `;
export type ExcluirLotacaoMutationFn = Apollo.MutationFunction<Types.ExcluirLotacaoMutation, Types.ExcluirLotacaoMutationVariables>;

/**
 * __useExcluirLotacaoMutation__
 *
 * To run a mutation, you first call `useExcluirLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirLotacaoMutation, { data, loading, error }] = useExcluirLotacaoMutation({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useExcluirLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirLotacaoMutation, Types.ExcluirLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirLotacaoMutation, Types.ExcluirLotacaoMutationVariables>(ExcluirLotacaoDocument, options);
      }
export type ExcluirLotacaoMutationHookResult = ReturnType<typeof useExcluirLotacaoMutation>;
export type ExcluirLotacaoMutationResult = Apollo.MutationResult<Types.ExcluirLotacaoMutation>;
export type ExcluirLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirLotacaoMutation, Types.ExcluirLotacaoMutationVariables>;
export const ProfissionaisLotacoesSectionDocument = gql`
    query ProfissionaisLotacoesSection {
  conexao {
    agendaOnline {
      ativa
    }
  }
}
    `;

/**
 * __useProfissionaisLotacoesSectionQuery__
 *
 * To run a query within a React component, call `useProfissionaisLotacoesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionaisLotacoesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionaisLotacoesSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfissionaisLotacoesSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>(ProfissionaisLotacoesSectionDocument, options);
      }
export function useProfissionaisLotacoesSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>(ProfissionaisLotacoesSectionDocument, options);
        }
export function useProfissionaisLotacoesSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>(ProfissionaisLotacoesSectionDocument, options);
        }
export type ProfissionaisLotacoesSectionQueryHookResult = ReturnType<typeof useProfissionaisLotacoesSectionQuery>;
export type ProfissionaisLotacoesSectionLazyQueryHookResult = ReturnType<typeof useProfissionaisLotacoesSectionLazyQuery>;
export type ProfissionaisLotacoesSectionSuspenseQueryHookResult = ReturnType<typeof useProfissionaisLotacoesSectionSuspenseQuery>;
export type ProfissionaisLotacoesSectionQueryResult = Apollo.QueryResult<Types.ProfissionaisLotacoesSectionQuery, Types.ProfissionaisLotacoesSectionQueryVariables>;
export const AlterarLotacaoDocument = gql`
    mutation AlterarLotacao($input: AlterarLotacaoInput!) {
  alterarLotacao(input: $input) {
    id
  }
}
    `;
export type AlterarLotacaoMutationFn = Apollo.MutationFunction<Types.AlterarLotacaoMutation, Types.AlterarLotacaoMutationVariables>;

/**
 * __useAlterarLotacaoMutation__
 *
 * To run a mutation, you first call `useAlterarLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarLotacaoMutation, { data, loading, error }] = useAlterarLotacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarLotacaoMutation, Types.AlterarLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarLotacaoMutation, Types.AlterarLotacaoMutationVariables>(AlterarLotacaoDocument, options);
      }
export type AlterarLotacaoMutationHookResult = ReturnType<typeof useAlterarLotacaoMutation>;
export type AlterarLotacaoMutationResult = Apollo.MutationResult<Types.AlterarLotacaoMutation>;
export type AlterarLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.AlterarLotacaoMutation, Types.AlterarLotacaoMutationVariables>;
export const CriarLotacaoDocument = gql`
    mutation CriarLotacao($input: LotacaoInput!) {
  criarLotacao(input: $input) {
    id
  }
}
    `;
export type CriarLotacaoMutationFn = Apollo.MutationFunction<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>;

/**
 * __useCriarLotacaoMutation__
 *
 * To run a mutation, you first call `useCriarLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarLotacaoMutation, { data, loading, error }] = useCriarLotacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarLotacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>(CriarLotacaoDocument, options);
      }
export type CriarLotacaoMutationHookResult = ReturnType<typeof useCriarLotacaoMutation>;
export type CriarLotacaoMutationResult = Apollo.MutationResult<Types.CriarLotacaoMutation>;
export type CriarLotacaoMutationOptions = Apollo.BaseMutationOptions<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>;
export const LotacaoCreateDocument = gql`
    query LotacaoCreate($profissionalId: ID!) {
  profissional(id: $profissionalId) {
    id
    nome
  }
}
    `;

/**
 * __useLotacaoCreateQuery__
 *
 * To run a query within a React component, call `useLotacaoCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoCreateQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useLotacaoCreateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables> & ({ variables: Types.LotacaoCreateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>(LotacaoCreateDocument, options);
      }
export function useLotacaoCreateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>(LotacaoCreateDocument, options);
        }
export function useLotacaoCreateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>(LotacaoCreateDocument, options);
        }
export type LotacaoCreateQueryHookResult = ReturnType<typeof useLotacaoCreateQuery>;
export type LotacaoCreateLazyQueryHookResult = ReturnType<typeof useLotacaoCreateLazyQuery>;
export type LotacaoCreateSuspenseQueryHookResult = ReturnType<typeof useLotacaoCreateSuspenseQuery>;
export type LotacaoCreateQueryResult = Apollo.QueryResult<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>;
export const LotacaoEditViewDocument = gql`
    query LotacaoEditView($id: ID!) {
  lotacao(id: $id) {
    id
    importada
    hasConfiguracaoAgenda
    atualizaPerfil
    ativo
    profissional {
      id
      nome
    }
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      nome
      ine
      tipoEquipe {
        id
        nome
        sigla
      }
    }
    perfis {
      id
      nome
      ativo
    }
    unidadeSaude {
      id
      nome
      cnes
    }
    actions {
      permissaoEdicao {
        enabled
      }
    }
  }
}
    `;

/**
 * __useLotacaoEditViewQuery__
 *
 * To run a query within a React component, call `useLotacaoEditViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoEditViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoEditViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLotacaoEditViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables> & ({ variables: Types.LotacaoEditViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>(LotacaoEditViewDocument, options);
      }
export function useLotacaoEditViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>(LotacaoEditViewDocument, options);
        }
export function useLotacaoEditViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>(LotacaoEditViewDocument, options);
        }
export type LotacaoEditViewQueryHookResult = ReturnType<typeof useLotacaoEditViewQuery>;
export type LotacaoEditViewLazyQueryHookResult = ReturnType<typeof useLotacaoEditViewLazyQuery>;
export type LotacaoEditViewSuspenseQueryHookResult = ReturnType<typeof useLotacaoEditViewSuspenseQuery>;
export type LotacaoEditViewQueryResult = Apollo.QueryResult<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>;
export const AlterarAtivacaoAcessoDocument = gql`
    mutation AlterarAtivacaoAcesso($id: ID!) {
  alterarAtivacaoAcesso(id: $id)
}
    `;
export type AlterarAtivacaoAcessoMutationFn = Apollo.MutationFunction<Types.AlterarAtivacaoAcessoMutation, Types.AlterarAtivacaoAcessoMutationVariables>;

/**
 * __useAlterarAtivacaoAcessoMutation__
 *
 * To run a mutation, you first call `useAlterarAtivacaoAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarAtivacaoAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarAtivacaoAcessoMutation, { data, loading, error }] = useAlterarAtivacaoAcessoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlterarAtivacaoAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarAtivacaoAcessoMutation, Types.AlterarAtivacaoAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarAtivacaoAcessoMutation, Types.AlterarAtivacaoAcessoMutationVariables>(AlterarAtivacaoAcessoDocument, options);
      }
export type AlterarAtivacaoAcessoMutationHookResult = ReturnType<typeof useAlterarAtivacaoAcessoMutation>;
export type AlterarAtivacaoAcessoMutationResult = Apollo.MutationResult<Types.AlterarAtivacaoAcessoMutation>;
export type AlterarAtivacaoAcessoMutationOptions = Apollo.BaseMutationOptions<Types.AlterarAtivacaoAcessoMutation, Types.AlterarAtivacaoAcessoMutationVariables>;
export const ExcluirAcessoDocument = gql`
    mutation ExcluirAcesso($id: ID!) {
  excluirAcesso(id: $id)
}
    `;
export type ExcluirAcessoMutationFn = Apollo.MutationFunction<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>;

/**
 * __useExcluirAcessoMutation__
 *
 * To run a mutation, you first call `useExcluirAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirAcessoMutation, { data, loading, error }] = useExcluirAcessoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirAcessoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>(ExcluirAcessoDocument, options);
      }
export type ExcluirAcessoMutationHookResult = ReturnType<typeof useExcluirAcessoMutation>;
export type ExcluirAcessoMutationResult = Apollo.MutationResult<Types.ExcluirAcessoMutation>;
export type ExcluirAcessoMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>;
export const DefinirSenhaProvisoriaDocument = gql`
    mutation DefinirSenhaProvisoria($input: DefinirSenhaProvisoriaInput!) {
  definirSenhaProvisoria(input: $input)
}
    `;
export type DefinirSenhaProvisoriaMutationFn = Apollo.MutationFunction<Types.DefinirSenhaProvisoriaMutation, Types.DefinirSenhaProvisoriaMutationVariables>;

/**
 * __useDefinirSenhaProvisoriaMutation__
 *
 * To run a mutation, you first call `useDefinirSenhaProvisoriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefinirSenhaProvisoriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [definirSenhaProvisoriaMutation, { data, loading, error }] = useDefinirSenhaProvisoriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefinirSenhaProvisoriaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DefinirSenhaProvisoriaMutation, Types.DefinirSenhaProvisoriaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DefinirSenhaProvisoriaMutation, Types.DefinirSenhaProvisoriaMutationVariables>(DefinirSenhaProvisoriaDocument, options);
      }
export type DefinirSenhaProvisoriaMutationHookResult = ReturnType<typeof useDefinirSenhaProvisoriaMutation>;
export type DefinirSenhaProvisoriaMutationResult = Apollo.MutationResult<Types.DefinirSenhaProvisoriaMutation>;
export type DefinirSenhaProvisoriaMutationOptions = Apollo.BaseMutationOptions<Types.DefinirSenhaProvisoriaMutation, Types.DefinirSenhaProvisoriaMutationVariables>;
export const ExcluirProfissionalDocument = gql`
    mutation ExcluirProfissional($profissionalId: ID!) {
  excluirProfissional(profissionalId: $profissionalId)
}
    `;
export type ExcluirProfissionalMutationFn = Apollo.MutationFunction<Types.ExcluirProfissionalMutation, Types.ExcluirProfissionalMutationVariables>;

/**
 * __useExcluirProfissionalMutation__
 *
 * To run a mutation, you first call `useExcluirProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirProfissionalMutation, { data, loading, error }] = useExcluirProfissionalMutation({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useExcluirProfissionalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirProfissionalMutation, Types.ExcluirProfissionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirProfissionalMutation, Types.ExcluirProfissionalMutationVariables>(ExcluirProfissionalDocument, options);
      }
export type ExcluirProfissionalMutationHookResult = ReturnType<typeof useExcluirProfissionalMutation>;
export type ExcluirProfissionalMutationResult = Apollo.MutationResult<Types.ExcluirProfissionalMutation>;
export type ExcluirProfissionalMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirProfissionalMutation, Types.ExcluirProfissionalMutationVariables>;
export const ProfissionalTableDocument = gql`
    query ProfissionalTable($input: ProfissionaisQueryInput!) {
  profissionais(input: $input) {
    content {
      id
      nome
      nomeSocial
      cpf
      cns
      lotacoes {
        id
        ativo
        cbo {
          id
          nome
        }
      }
      estagios {
        id
        cbo {
          id
          nome
        }
        ativo
      }
      usuario {
        id
        bloqueado
      }
      actions {
        redefinirSenha {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProfissionalTableQuery__
 *
 * To run a query within a React component, call `useProfissionalTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables> & ({ variables: Types.ProfissionalTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>(ProfissionalTableDocument, options);
      }
export function useProfissionalTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>(ProfissionalTableDocument, options);
        }
export function useProfissionalTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>(ProfissionalTableDocument, options);
        }
export type ProfissionalTableQueryHookResult = ReturnType<typeof useProfissionalTableQuery>;
export type ProfissionalTableLazyQueryHookResult = ReturnType<typeof useProfissionalTableLazyQuery>;
export type ProfissionalTableSuspenseQueryHookResult = ReturnType<typeof useProfissionalTableSuspenseQuery>;
export type ProfissionalTableQueryResult = Apollo.QueryResult<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>;
export const SolicitarRedefinicaoSenhaDocument = gql`
    mutation SolicitarRedefinicaoSenha($input: SolicitarRecuperacaoSenhaInput!) {
  solicitarRedefinicaoSenha(input: $input) {
    value
    base64PngImage
  }
}
    `;
export type SolicitarRedefinicaoSenhaMutationFn = Apollo.MutationFunction<Types.SolicitarRedefinicaoSenhaMutation, Types.SolicitarRedefinicaoSenhaMutationVariables>;

/**
 * __useSolicitarRedefinicaoSenhaMutation__
 *
 * To run a mutation, you first call `useSolicitarRedefinicaoSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolicitarRedefinicaoSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solicitarRedefinicaoSenhaMutation, { data, loading, error }] = useSolicitarRedefinicaoSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitarRedefinicaoSenhaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SolicitarRedefinicaoSenhaMutation, Types.SolicitarRedefinicaoSenhaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SolicitarRedefinicaoSenhaMutation, Types.SolicitarRedefinicaoSenhaMutationVariables>(SolicitarRedefinicaoSenhaDocument, options);
      }
export type SolicitarRedefinicaoSenhaMutationHookResult = ReturnType<typeof useSolicitarRedefinicaoSenhaMutation>;
export type SolicitarRedefinicaoSenhaMutationResult = Apollo.MutationResult<Types.SolicitarRedefinicaoSenhaMutation>;
export type SolicitarRedefinicaoSenhaMutationOptions = Apollo.BaseMutationOptions<Types.SolicitarRedefinicaoSenhaMutation, Types.SolicitarRedefinicaoSenhaMutationVariables>;
export const SalvarJustificativaVisualizarProntuarioDocument = gql`
    mutation SalvarJustificativaVisualizarProntuario($input: JustificativaVisualizarProntuarioInput!) {
  salvarJustificativaVisualizarProntuario(input: $input)
}
    `;
export type SalvarJustificativaVisualizarProntuarioMutationFn = Apollo.MutationFunction<Types.SalvarJustificativaVisualizarProntuarioMutation, Types.SalvarJustificativaVisualizarProntuarioMutationVariables>;

/**
 * __useSalvarJustificativaVisualizarProntuarioMutation__
 *
 * To run a mutation, you first call `useSalvarJustificativaVisualizarProntuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarJustificativaVisualizarProntuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarJustificativaVisualizarProntuarioMutation, { data, loading, error }] = useSalvarJustificativaVisualizarProntuarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarJustificativaVisualizarProntuarioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarJustificativaVisualizarProntuarioMutation, Types.SalvarJustificativaVisualizarProntuarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarJustificativaVisualizarProntuarioMutation, Types.SalvarJustificativaVisualizarProntuarioMutationVariables>(SalvarJustificativaVisualizarProntuarioDocument, options);
      }
export type SalvarJustificativaVisualizarProntuarioMutationHookResult = ReturnType<typeof useSalvarJustificativaVisualizarProntuarioMutation>;
export type SalvarJustificativaVisualizarProntuarioMutationResult = Apollo.MutationResult<Types.SalvarJustificativaVisualizarProntuarioMutation>;
export type SalvarJustificativaVisualizarProntuarioMutationOptions = Apollo.BaseMutationOptions<Types.SalvarJustificativaVisualizarProntuarioMutation, Types.SalvarJustificativaVisualizarProntuarioMutationVariables>;
export const RecuperarSenhaBloqueadoDocument = gql`
    query RecuperarSenhaBloqueado {
  recuperarSenhaBloqueado
}
    `;

/**
 * __useRecuperarSenhaBloqueadoQuery__
 *
 * To run a query within a React component, call `useRecuperarSenhaBloqueadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecuperarSenhaBloqueadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecuperarSenhaBloqueadoQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecuperarSenhaBloqueadoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>(RecuperarSenhaBloqueadoDocument, options);
      }
export function useRecuperarSenhaBloqueadoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>(RecuperarSenhaBloqueadoDocument, options);
        }
export function useRecuperarSenhaBloqueadoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>(RecuperarSenhaBloqueadoDocument, options);
        }
export type RecuperarSenhaBloqueadoQueryHookResult = ReturnType<typeof useRecuperarSenhaBloqueadoQuery>;
export type RecuperarSenhaBloqueadoLazyQueryHookResult = ReturnType<typeof useRecuperarSenhaBloqueadoLazyQuery>;
export type RecuperarSenhaBloqueadoSuspenseQueryHookResult = ReturnType<typeof useRecuperarSenhaBloqueadoSuspenseQuery>;
export type RecuperarSenhaBloqueadoQueryResult = Apollo.QueryResult<Types.RecuperarSenhaBloqueadoQuery, Types.RecuperarSenhaBloqueadoQueryVariables>;
export const RedefinirSenhaDocument = gql`
    mutation RedefinirSenha($input: RedefinirSenhaInput!) {
  redefinirSenha(input: $input)
}
    `;
export type RedefinirSenhaMutationFn = Apollo.MutationFunction<Types.RedefinirSenhaMutation, Types.RedefinirSenhaMutationVariables>;

/**
 * __useRedefinirSenhaMutation__
 *
 * To run a mutation, you first call `useRedefinirSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedefinirSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redefinirSenhaMutation, { data, loading, error }] = useRedefinirSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedefinirSenhaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RedefinirSenhaMutation, Types.RedefinirSenhaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RedefinirSenhaMutation, Types.RedefinirSenhaMutationVariables>(RedefinirSenhaDocument, options);
      }
export type RedefinirSenhaMutationHookResult = ReturnType<typeof useRedefinirSenhaMutation>;
export type RedefinirSenhaMutationResult = Apollo.MutationResult<Types.RedefinirSenhaMutation>;
export type RedefinirSenhaMutationOptions = Apollo.BaseMutationOptions<Types.RedefinirSenhaMutation, Types.RedefinirSenhaMutationVariables>;
export const SolicitacaoRecuperarSenhaDocument = gql`
    mutation SolicitacaoRecuperarSenha($input: SolicitarRecuperacaoSenhaInput!) {
  solicitarRecuperarSenha(input: $input)
}
    `;
export type SolicitacaoRecuperarSenhaMutationFn = Apollo.MutationFunction<Types.SolicitacaoRecuperarSenhaMutation, Types.SolicitacaoRecuperarSenhaMutationVariables>;

/**
 * __useSolicitacaoRecuperarSenhaMutation__
 *
 * To run a mutation, you first call `useSolicitacaoRecuperarSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolicitacaoRecuperarSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solicitacaoRecuperarSenhaMutation, { data, loading, error }] = useSolicitacaoRecuperarSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitacaoRecuperarSenhaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SolicitacaoRecuperarSenhaMutation, Types.SolicitacaoRecuperarSenhaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SolicitacaoRecuperarSenhaMutation, Types.SolicitacaoRecuperarSenhaMutationVariables>(SolicitacaoRecuperarSenhaDocument, options);
      }
export type SolicitacaoRecuperarSenhaMutationHookResult = ReturnType<typeof useSolicitacaoRecuperarSenhaMutation>;
export type SolicitacaoRecuperarSenhaMutationResult = Apollo.MutationResult<Types.SolicitacaoRecuperarSenhaMutation>;
export type SolicitacaoRecuperarSenhaMutationOptions = Apollo.BaseMutationOptions<Types.SolicitacaoRecuperarSenhaMutation, Types.SolicitacaoRecuperarSenhaMutationVariables>;
export const AtendimentoRegistroTardioDocument = gql`
    query AtendimentoRegistroTardio($id: ID!) {
  atendimento(id: $id) {
    id
    cidadao {
      id
      nome
      nomeSocial
      dataNascimento
    }
    responsavel {
      ... on Acesso {
        id
        profissional {
          id
          nome
        }
      }
      ... on Lotacao {
        cbo {
          id
          nome
          cbo2002
        }
      }
      ... on Estagio {
        cbo {
          id
          nome
          cbo2002
        }
      }
    }
    actions {
      editar {
        enabled
      }
    }
    localAtendimento {
      id
      localAtendimentoExibicao
    }
    justificativa
    iniciadoEm
  }
}
    `;

/**
 * __useAtendimentoRegistroTardioQuery__
 *
 * To run a query within a React component, call `useAtendimentoRegistroTardioQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoRegistroTardioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoRegistroTardioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentoRegistroTardioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables> & ({ variables: Types.AtendimentoRegistroTardioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>(AtendimentoRegistroTardioDocument, options);
      }
export function useAtendimentoRegistroTardioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>(AtendimentoRegistroTardioDocument, options);
        }
export function useAtendimentoRegistroTardioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>(AtendimentoRegistroTardioDocument, options);
        }
export type AtendimentoRegistroTardioQueryHookResult = ReturnType<typeof useAtendimentoRegistroTardioQuery>;
export type AtendimentoRegistroTardioLazyQueryHookResult = ReturnType<typeof useAtendimentoRegistroTardioLazyQuery>;
export type AtendimentoRegistroTardioSuspenseQueryHookResult = ReturnType<typeof useAtendimentoRegistroTardioSuspenseQuery>;
export type AtendimentoRegistroTardioQueryResult = Apollo.QueryResult<Types.AtendimentoRegistroTardioQuery, Types.AtendimentoRegistroTardioQueryVariables>;
export const EditarRegistroTardioDocument = gql`
    mutation EditarRegistroTardio($input: RegistroTardioInput!) {
  editarRegistroTardio(input: $input) {
    id
  }
}
    `;
export type EditarRegistroTardioMutationFn = Apollo.MutationFunction<Types.EditarRegistroTardioMutation, Types.EditarRegistroTardioMutationVariables>;

/**
 * __useEditarRegistroTardioMutation__
 *
 * To run a mutation, you first call `useEditarRegistroTardioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarRegistroTardioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarRegistroTardioMutation, { data, loading, error }] = useEditarRegistroTardioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarRegistroTardioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarRegistroTardioMutation, Types.EditarRegistroTardioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarRegistroTardioMutation, Types.EditarRegistroTardioMutationVariables>(EditarRegistroTardioDocument, options);
      }
export type EditarRegistroTardioMutationHookResult = ReturnType<typeof useEditarRegistroTardioMutation>;
export type EditarRegistroTardioMutationResult = Apollo.MutationResult<Types.EditarRegistroTardioMutation>;
export type EditarRegistroTardioMutationOptions = Apollo.BaseMutationOptions<Types.EditarRegistroTardioMutation, Types.EditarRegistroTardioMutationVariables>;
export const SalvarRegistroTardioDocument = gql`
    mutation SalvarRegistroTardio($input: RegistroTardioInput!) {
  salvarRegistroTardio(input: $input) {
    id
  }
}
    `;
export type SalvarRegistroTardioMutationFn = Apollo.MutationFunction<Types.SalvarRegistroTardioMutation, Types.SalvarRegistroTardioMutationVariables>;

/**
 * __useSalvarRegistroTardioMutation__
 *
 * To run a mutation, you first call `useSalvarRegistroTardioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarRegistroTardioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarRegistroTardioMutation, { data, loading, error }] = useSalvarRegistroTardioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarRegistroTardioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarRegistroTardioMutation, Types.SalvarRegistroTardioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarRegistroTardioMutation, Types.SalvarRegistroTardioMutationVariables>(SalvarRegistroTardioDocument, options);
      }
export type SalvarRegistroTardioMutationHookResult = ReturnType<typeof useSalvarRegistroTardioMutation>;
export type SalvarRegistroTardioMutationResult = Apollo.MutationResult<Types.SalvarRegistroTardioMutation>;
export type SalvarRegistroTardioMutationOptions = Apollo.BaseMutationOptions<Types.SalvarRegistroTardioMutation, Types.SalvarRegistroTardioMutationVariables>;
export const UltimoAtendimentoProfissionalCidadaoDocument = gql`
    query UltimoAtendimentoProfissionalCidadao($input: UltimoAtendimentoProfissionalFinalizadoQueryInput) {
  ultimoAtendimentoProfissionalCidadao(input: $input) {
    id
    finalizadoEm
    lotacao {
      id
      cbo {
        id
        nome
      }
      profissional {
        id
        nome
      }
    }
  }
}
    `;

/**
 * __useUltimoAtendimentoProfissionalCidadaoQuery__
 *
 * To run a query within a React component, call `useUltimoAtendimentoProfissionalCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimoAtendimentoProfissionalCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimoAtendimentoProfissionalCidadaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUltimoAtendimentoProfissionalCidadaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>(UltimoAtendimentoProfissionalCidadaoDocument, options);
      }
export function useUltimoAtendimentoProfissionalCidadaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>(UltimoAtendimentoProfissionalCidadaoDocument, options);
        }
export function useUltimoAtendimentoProfissionalCidadaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>(UltimoAtendimentoProfissionalCidadaoDocument, options);
        }
export type UltimoAtendimentoProfissionalCidadaoQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalCidadaoQuery>;
export type UltimoAtendimentoProfissionalCidadaoLazyQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalCidadaoLazyQuery>;
export type UltimoAtendimentoProfissionalCidadaoSuspenseQueryHookResult = ReturnType<typeof useUltimoAtendimentoProfissionalCidadaoSuspenseQuery>;
export type UltimoAtendimentoProfissionalCidadaoQueryResult = Apollo.QueryResult<Types.UltimoAtendimentoProfissionalCidadaoQuery, Types.UltimoAtendimentoProfissionalCidadaoQueryVariables>;
export const AbsenteismosDocument = gql`
    query Absenteismos($input: RelatorioGerencialAbsenteismoInput!) {
  absenteismos(input: $input) {
    id
    municipio
    unidadeSaude
    equipe
    nomeProfissional
    nomeSituacaoAgendamento
    categoriaProfissional
    turno
    intervaloAgendamento
    faixaEtaria
    cbo
    producoes
  }
}
    `;

/**
 * __useAbsenteismosQuery__
 *
 * To run a query within a React component, call `useAbsenteismosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsenteismosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsenteismosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbsenteismosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables> & ({ variables: Types.AbsenteismosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>(AbsenteismosDocument, options);
      }
export function useAbsenteismosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>(AbsenteismosDocument, options);
        }
export function useAbsenteismosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>(AbsenteismosDocument, options);
        }
export type AbsenteismosQueryHookResult = ReturnType<typeof useAbsenteismosQuery>;
export type AbsenteismosLazyQueryHookResult = ReturnType<typeof useAbsenteismosLazyQuery>;
export type AbsenteismosSuspenseQueryHookResult = ReturnType<typeof useAbsenteismosSuspenseQuery>;
export type AbsenteismosQueryResult = Apollo.QueryResult<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>;
export const ModeloPersonalizadoRelatorioGerencialDocument = gql`
    query ModeloPersonalizadoRelatorioGerencial($id: ID!) {
  modeloPersonalizadoRelatorioGerencialById(id: $id) {
    id
    nome
    isPublico
    tipoModulo
    atorPapelCriadorId
    modelo {
      unidadePeriodo
      opcaoSelecionada
      ciaps {
        ...Ciap
      }
      cids {
        ...Cid10
      }
      gruposCondicoes {
        id
        grupo
        ciaps {
          ...Ciap
        }
        cids {
          ...Cid10
        }
      }
      tipoAgrupamento
      campos {
        key
        posicao
        items
      }
      aggregator
    }
  }
}
    ${CiapFragmentDoc}
${Cid10FragmentDoc}`;

/**
 * __useModeloPersonalizadoRelatorioGerencialQuery__
 *
 * To run a query within a React component, call `useModeloPersonalizadoRelatorioGerencialQuery` and pass it any options that fit your needs.
 * When your component renders, `useModeloPersonalizadoRelatorioGerencialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModeloPersonalizadoRelatorioGerencialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModeloPersonalizadoRelatorioGerencialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables> & ({ variables: Types.ModeloPersonalizadoRelatorioGerencialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>(ModeloPersonalizadoRelatorioGerencialDocument, options);
      }
export function useModeloPersonalizadoRelatorioGerencialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>(ModeloPersonalizadoRelatorioGerencialDocument, options);
        }
export function useModeloPersonalizadoRelatorioGerencialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>(ModeloPersonalizadoRelatorioGerencialDocument, options);
        }
export type ModeloPersonalizadoRelatorioGerencialQueryHookResult = ReturnType<typeof useModeloPersonalizadoRelatorioGerencialQuery>;
export type ModeloPersonalizadoRelatorioGerencialLazyQueryHookResult = ReturnType<typeof useModeloPersonalizadoRelatorioGerencialLazyQuery>;
export type ModeloPersonalizadoRelatorioGerencialSuspenseQueryHookResult = ReturnType<typeof useModeloPersonalizadoRelatorioGerencialSuspenseQuery>;
export type ModeloPersonalizadoRelatorioGerencialQueryResult = Apollo.QueryResult<Types.ModeloPersonalizadoRelatorioGerencialQuery, Types.ModeloPersonalizadoRelatorioGerencialQueryVariables>;
export const ModelosByTipoDocument = gql`
    query ModelosByTipo($tipoModulo: TipoModuloEnum!) {
  modelosPersonalizadosByTipoModulo(tipoModulo: $tipoModulo) {
    id
    nome
    isPublico
  }
}
    `;

/**
 * __useModelosByTipoQuery__
 *
 * To run a query within a React component, call `useModelosByTipoQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelosByTipoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelosByTipoQuery({
 *   variables: {
 *      tipoModulo: // value for 'tipoModulo'
 *   },
 * });
 */
export function useModelosByTipoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables> & ({ variables: Types.ModelosByTipoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>(ModelosByTipoDocument, options);
      }
export function useModelosByTipoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>(ModelosByTipoDocument, options);
        }
export function useModelosByTipoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>(ModelosByTipoDocument, options);
        }
export type ModelosByTipoQueryHookResult = ReturnType<typeof useModelosByTipoQuery>;
export type ModelosByTipoLazyQueryHookResult = ReturnType<typeof useModelosByTipoLazyQuery>;
export type ModelosByTipoSuspenseQueryHookResult = ReturnType<typeof useModelosByTipoSuspenseQuery>;
export type ModelosByTipoQueryResult = Apollo.QueryResult<Types.ModelosByTipoQuery, Types.ModelosByTipoQueryVariables>;
export const EditarModeloPersonalizadoRelatorioGerencialDocument = gql`
    mutation EditarModeloPersonalizadoRelatorioGerencial($input: EditarModeloRelatorioGerencialInput!) {
  editarModeloPersonalizadoRelatorioGerencial(input: $input) {
    id
    nome
    isPublico
    tipoModulo
    modelo
  }
}
    `;
export type EditarModeloPersonalizadoRelatorioGerencialMutationFn = Apollo.MutationFunction<Types.EditarModeloPersonalizadoRelatorioGerencialMutation, Types.EditarModeloPersonalizadoRelatorioGerencialMutationVariables>;

/**
 * __useEditarModeloPersonalizadoRelatorioGerencialMutation__
 *
 * To run a mutation, you first call `useEditarModeloPersonalizadoRelatorioGerencialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarModeloPersonalizadoRelatorioGerencialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarModeloPersonalizadoRelatorioGerencialMutation, { data, loading, error }] = useEditarModeloPersonalizadoRelatorioGerencialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarModeloPersonalizadoRelatorioGerencialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditarModeloPersonalizadoRelatorioGerencialMutation, Types.EditarModeloPersonalizadoRelatorioGerencialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditarModeloPersonalizadoRelatorioGerencialMutation, Types.EditarModeloPersonalizadoRelatorioGerencialMutationVariables>(EditarModeloPersonalizadoRelatorioGerencialDocument, options);
      }
export type EditarModeloPersonalizadoRelatorioGerencialMutationHookResult = ReturnType<typeof useEditarModeloPersonalizadoRelatorioGerencialMutation>;
export type EditarModeloPersonalizadoRelatorioGerencialMutationResult = Apollo.MutationResult<Types.EditarModeloPersonalizadoRelatorioGerencialMutation>;
export type EditarModeloPersonalizadoRelatorioGerencialMutationOptions = Apollo.BaseMutationOptions<Types.EditarModeloPersonalizadoRelatorioGerencialMutation, Types.EditarModeloPersonalizadoRelatorioGerencialMutationVariables>;
export const ExcluirModeloPersonalizadoRelatorioGerencialDocument = gql`
    mutation ExcluirModeloPersonalizadoRelatorioGerencial($input: ExcluirModeloRelatorioGerencialInput!) {
  excluirModeloPersonalizadoRelatorioGerencial(input: $input)
}
    `;
export type ExcluirModeloPersonalizadoRelatorioGerencialMutationFn = Apollo.MutationFunction<Types.ExcluirModeloPersonalizadoRelatorioGerencialMutation, Types.ExcluirModeloPersonalizadoRelatorioGerencialMutationVariables>;

/**
 * __useExcluirModeloPersonalizadoRelatorioGerencialMutation__
 *
 * To run a mutation, you first call `useExcluirModeloPersonalizadoRelatorioGerencialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirModeloPersonalizadoRelatorioGerencialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirModeloPersonalizadoRelatorioGerencialMutation, { data, loading, error }] = useExcluirModeloPersonalizadoRelatorioGerencialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExcluirModeloPersonalizadoRelatorioGerencialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirModeloPersonalizadoRelatorioGerencialMutation, Types.ExcluirModeloPersonalizadoRelatorioGerencialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirModeloPersonalizadoRelatorioGerencialMutation, Types.ExcluirModeloPersonalizadoRelatorioGerencialMutationVariables>(ExcluirModeloPersonalizadoRelatorioGerencialDocument, options);
      }
export type ExcluirModeloPersonalizadoRelatorioGerencialMutationHookResult = ReturnType<typeof useExcluirModeloPersonalizadoRelatorioGerencialMutation>;
export type ExcluirModeloPersonalizadoRelatorioGerencialMutationResult = Apollo.MutationResult<Types.ExcluirModeloPersonalizadoRelatorioGerencialMutation>;
export type ExcluirModeloPersonalizadoRelatorioGerencialMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirModeloPersonalizadoRelatorioGerencialMutation, Types.ExcluirModeloPersonalizadoRelatorioGerencialMutationVariables>;
export const SalvarModeloPersonalizadoRelatorioGerencialDocument = gql`
    mutation SalvarModeloPersonalizadoRelatorioGerencial($input: SalvarModeloRelatorioGerencialInput!) {
  salvarModeloPersonalizadoRelatorioGerencial(input: $input) {
    id
    nome
    isPublico
    tipoModulo
    modelo
  }
}
    `;
export type SalvarModeloPersonalizadoRelatorioGerencialMutationFn = Apollo.MutationFunction<Types.SalvarModeloPersonalizadoRelatorioGerencialMutation, Types.SalvarModeloPersonalizadoRelatorioGerencialMutationVariables>;

/**
 * __useSalvarModeloPersonalizadoRelatorioGerencialMutation__
 *
 * To run a mutation, you first call `useSalvarModeloPersonalizadoRelatorioGerencialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarModeloPersonalizadoRelatorioGerencialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarModeloPersonalizadoRelatorioGerencialMutation, { data, loading, error }] = useSalvarModeloPersonalizadoRelatorioGerencialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarModeloPersonalizadoRelatorioGerencialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarModeloPersonalizadoRelatorioGerencialMutation, Types.SalvarModeloPersonalizadoRelatorioGerencialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarModeloPersonalizadoRelatorioGerencialMutation, Types.SalvarModeloPersonalizadoRelatorioGerencialMutationVariables>(SalvarModeloPersonalizadoRelatorioGerencialDocument, options);
      }
export type SalvarModeloPersonalizadoRelatorioGerencialMutationHookResult = ReturnType<typeof useSalvarModeloPersonalizadoRelatorioGerencialMutation>;
export type SalvarModeloPersonalizadoRelatorioGerencialMutationResult = Apollo.MutationResult<Types.SalvarModeloPersonalizadoRelatorioGerencialMutation>;
export type SalvarModeloPersonalizadoRelatorioGerencialMutationOptions = Apollo.BaseMutationOptions<Types.SalvarModeloPersonalizadoRelatorioGerencialMutation, Types.SalvarModeloPersonalizadoRelatorioGerencialMutationVariables>;
export const DataUltimoProcessamentoDocument = gql`
    query DataUltimoProcessamento {
  dataUltimoProcessamento
}
    `;

/**
 * __useDataUltimoProcessamentoQuery__
 *
 * To run a query within a React component, call `useDataUltimoProcessamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataUltimoProcessamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataUltimoProcessamentoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataUltimoProcessamentoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>(DataUltimoProcessamentoDocument, options);
      }
export function useDataUltimoProcessamentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>(DataUltimoProcessamentoDocument, options);
        }
export function useDataUltimoProcessamentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>(DataUltimoProcessamentoDocument, options);
        }
export type DataUltimoProcessamentoQueryHookResult = ReturnType<typeof useDataUltimoProcessamentoQuery>;
export type DataUltimoProcessamentoLazyQueryHookResult = ReturnType<typeof useDataUltimoProcessamentoLazyQuery>;
export type DataUltimoProcessamentoSuspenseQueryHookResult = ReturnType<typeof useDataUltimoProcessamentoSuspenseQuery>;
export type DataUltimoProcessamentoQueryResult = Apollo.QueryResult<Types.DataUltimoProcessamentoQuery, Types.DataUltimoProcessamentoQueryVariables>;
export const InfoProfissionalCpfDocument = gql`
    query InfoProfissionalCpf($input: CpfContraChaveInput!) {
  profissionalByCpfContraChave(input: $input) {
    id
  }
}
    `;

/**
 * __useInfoProfissionalCpfQuery__
 *
 * To run a query within a React component, call `useInfoProfissionalCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoProfissionalCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoProfissionalCpfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInfoProfissionalCpfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables> & ({ variables: Types.InfoProfissionalCpfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>(InfoProfissionalCpfDocument, options);
      }
export function useInfoProfissionalCpfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>(InfoProfissionalCpfDocument, options);
        }
export function useInfoProfissionalCpfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>(InfoProfissionalCpfDocument, options);
        }
export type InfoProfissionalCpfQueryHookResult = ReturnType<typeof useInfoProfissionalCpfQuery>;
export type InfoProfissionalCpfLazyQueryHookResult = ReturnType<typeof useInfoProfissionalCpfLazyQuery>;
export type InfoProfissionalCpfSuspenseQueryHookResult = ReturnType<typeof useInfoProfissionalCpfSuspenseQuery>;
export type InfoProfissionalCpfQueryResult = Apollo.QueryResult<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>;
export const RedefinirSenhaAdminInstalacaoDocument = gql`
    mutation RedefinirSenhaAdminInstalacao($input: RedefinirSenhaAdminInstalacaoInput!) {
  redefinirSenhaAdminInstalacao(input: $input)
}
    `;
export type RedefinirSenhaAdminInstalacaoMutationFn = Apollo.MutationFunction<Types.RedefinirSenhaAdminInstalacaoMutation, Types.RedefinirSenhaAdminInstalacaoMutationVariables>;

/**
 * __useRedefinirSenhaAdminInstalacaoMutation__
 *
 * To run a mutation, you first call `useRedefinirSenhaAdminInstalacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedefinirSenhaAdminInstalacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redefinirSenhaAdminInstalacaoMutation, { data, loading, error }] = useRedefinirSenhaAdminInstalacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedefinirSenhaAdminInstalacaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RedefinirSenhaAdminInstalacaoMutation, Types.RedefinirSenhaAdminInstalacaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RedefinirSenhaAdminInstalacaoMutation, Types.RedefinirSenhaAdminInstalacaoMutationVariables>(RedefinirSenhaAdminInstalacaoDocument, options);
      }
export type RedefinirSenhaAdminInstalacaoMutationHookResult = ReturnType<typeof useRedefinirSenhaAdminInstalacaoMutation>;
export type RedefinirSenhaAdminInstalacaoMutationResult = Apollo.MutationResult<Types.RedefinirSenhaAdminInstalacaoMutation>;
export type RedefinirSenhaAdminInstalacaoMutationOptions = Apollo.BaseMutationOptions<Types.RedefinirSenhaAdminInstalacaoMutation, Types.RedefinirSenhaAdminInstalacaoMutationVariables>;
export const SaveAdminProfissionalDocument = gql`
    mutation SaveAdminProfissional($input: ProfissionalContraChaveInput!) {
  salvarProfissionalContraChave(input: $input) {
    id
  }
}
    `;
export type SaveAdminProfissionalMutationFn = Apollo.MutationFunction<Types.SaveAdminProfissionalMutation, Types.SaveAdminProfissionalMutationVariables>;

/**
 * __useSaveAdminProfissionalMutation__
 *
 * To run a mutation, you first call `useSaveAdminProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdminProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdminProfissionalMutation, { data, loading, error }] = useSaveAdminProfissionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAdminProfissionalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SaveAdminProfissionalMutation, Types.SaveAdminProfissionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SaveAdminProfissionalMutation, Types.SaveAdminProfissionalMutationVariables>(SaveAdminProfissionalDocument, options);
      }
export type SaveAdminProfissionalMutationHookResult = ReturnType<typeof useSaveAdminProfissionalMutation>;
export type SaveAdminProfissionalMutationResult = Apollo.MutationResult<Types.SaveAdminProfissionalMutation>;
export type SaveAdminProfissionalMutationOptions = Apollo.BaseMutationOptions<Types.SaveAdminProfissionalMutation, Types.SaveAdminProfissionalMutationVariables>;
export const ValidateNovoAdminDocument = gql`
    query validateNovoAdmin($input: ValidateNovoAdminInput!) {
  validatePermissaoNovoAdmin(input: $input)
}
    `;

/**
 * __useValidateNovoAdminQuery__
 *
 * To run a query within a React component, call `useValidateNovoAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateNovoAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateNovoAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateNovoAdminQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables> & ({ variables: Types.ValidateNovoAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>(ValidateNovoAdminDocument, options);
      }
export function useValidateNovoAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>(ValidateNovoAdminDocument, options);
        }
export function useValidateNovoAdminSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>(ValidateNovoAdminDocument, options);
        }
export type ValidateNovoAdminQueryHookResult = ReturnType<typeof useValidateNovoAdminQuery>;
export type ValidateNovoAdminLazyQueryHookResult = ReturnType<typeof useValidateNovoAdminLazyQuery>;
export type ValidateNovoAdminSuspenseQueryHookResult = ReturnType<typeof useValidateNovoAdminSuspenseQuery>;
export type ValidateNovoAdminQueryResult = Apollo.QueryResult<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>;
export const ValidateResetAdminDocument = gql`
    query ValidateResetAdmin($input: CpfContraChaveInput!) {
  validateResetAdmin(input: $input)
}
    `;

/**
 * __useValidateResetAdminQuery__
 *
 * To run a query within a React component, call `useValidateResetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateResetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateResetAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateResetAdminQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables> & ({ variables: Types.ValidateResetAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>(ValidateResetAdminDocument, options);
      }
export function useValidateResetAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>(ValidateResetAdminDocument, options);
        }
export function useValidateResetAdminSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>(ValidateResetAdminDocument, options);
        }
export type ValidateResetAdminQueryHookResult = ReturnType<typeof useValidateResetAdminQuery>;
export type ValidateResetAdminLazyQueryHookResult = ReturnType<typeof useValidateResetAdminLazyQuery>;
export type ValidateResetAdminSuspenseQueryHookResult = ReturnType<typeof useValidateResetAdminSuspenseQuery>;
export type ValidateResetAdminQueryResult = Apollo.QueryResult<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>;
export const AlteraAdminDocument = gql`
    mutation AlteraAdmin($input: ValidateNovoAdminInput!) {
  denifinirNovoAdministrador(input: $input)
}
    `;
export type AlteraAdminMutationFn = Apollo.MutationFunction<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>;

/**
 * __useAlteraAdminMutation__
 *
 * To run a mutation, you first call `useAlteraAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlteraAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alteraAdminMutation, { data, loading, error }] = useAlteraAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlteraAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>(AlteraAdminDocument, options);
      }
export type AlteraAdminMutationHookResult = ReturnType<typeof useAlteraAdminMutation>;
export type AlteraAdminMutationResult = Apollo.MutationResult<Types.AlteraAdminMutation>;
export type AlteraAdminMutationOptions = Apollo.BaseMutationOptions<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>;
export const ChaveByCpfDocument = gql`
    query chaveByCpf($cpf: String!) {
  chaveByCpf(cpf: $cpf)
}
    `;

/**
 * __useChaveByCpfQuery__
 *
 * To run a query within a React component, call `useChaveByCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useChaveByCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChaveByCpfQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useChaveByCpfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables> & ({ variables: Types.ChaveByCpfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>(ChaveByCpfDocument, options);
      }
export function useChaveByCpfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>(ChaveByCpfDocument, options);
        }
export function useChaveByCpfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>(ChaveByCpfDocument, options);
        }
export type ChaveByCpfQueryHookResult = ReturnType<typeof useChaveByCpfQuery>;
export type ChaveByCpfLazyQueryHookResult = ReturnType<typeof useChaveByCpfLazyQuery>;
export type ChaveByCpfSuspenseQueryHookResult = ReturnType<typeof useChaveByCpfSuspenseQuery>;
export type ChaveByCpfQueryResult = Apollo.QueryResult<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>;
export const ProfissionalAdminDetailDocument = gql`
    query profissionalAdminDetail($input: CpfContraChaveInput!) {
  profissionalByCpfContraChave(input: $input) {
    ...ProfissionalDetail
    usuario {
      id
    }
  }
}
    ${ProfissionalDetailFragmentDoc}`;

/**
 * __useProfissionalAdminDetailQuery__
 *
 * To run a query within a React component, call `useProfissionalAdminDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAdminDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAdminDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalAdminDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables> & ({ variables: Types.ProfissionalAdminDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>(ProfissionalAdminDetailDocument, options);
      }
export function useProfissionalAdminDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>(ProfissionalAdminDetailDocument, options);
        }
export function useProfissionalAdminDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>(ProfissionalAdminDetailDocument, options);
        }
export type ProfissionalAdminDetailQueryHookResult = ReturnType<typeof useProfissionalAdminDetailQuery>;
export type ProfissionalAdminDetailLazyQueryHookResult = ReturnType<typeof useProfissionalAdminDetailLazyQuery>;
export type ProfissionalAdminDetailSuspenseQueryHookResult = ReturnType<typeof useProfissionalAdminDetailSuspenseQuery>;
export type ProfissionalAdminDetailQueryResult = Apollo.QueryResult<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>;
export const LoadImoveisDocument = gql`
    query LoadImoveis($input: ImoveisQueryInput!) {
  imoveis(input: $input) {
    content {
      id
      tipoLogradouro {
        id
        nome
      }
      logradouro
      bairro
      microarea
      equipe {
        id
        nome
        ine
        ativo
      }
      unidadeSaude {
        id
        nome
        cnes
        ativo
      }
      numero
      cep
      complemento
      familias(
        input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true, isResponsavelAindaReside: true, isResponsavelCadastrado: true, isResponsavelDeclarado: true, isResponsavelUnico: true, isResponsavelVivo: true}
      ) {
        id
        cidadaosTerritorioBasico {
          id
          permissaoReterritorializar {
            enabled
            hint
          }
          ultimaFichaCadastrada {
            id
            isProcessado
          }
        }
        responsavel {
          id
          nome
          nomeSocial
        }
      }
      permissaoReterritorializar {
        enabled
        hint
      }
      responsavelTecnico {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLoadImoveisQuery__
 *
 * To run a query within a React component, call `useLoadImoveisQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadImoveisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadImoveisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadImoveisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables> & ({ variables: Types.LoadImoveisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>(LoadImoveisDocument, options);
      }
export function useLoadImoveisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>(LoadImoveisDocument, options);
        }
export function useLoadImoveisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>(LoadImoveisDocument, options);
        }
export type LoadImoveisQueryHookResult = ReturnType<typeof useLoadImoveisQuery>;
export type LoadImoveisLazyQueryHookResult = ReturnType<typeof useLoadImoveisLazyQuery>;
export type LoadImoveisSuspenseQueryHookResult = ReturnType<typeof useLoadImoveisSuspenseQuery>;
export type LoadImoveisQueryResult = Apollo.QueryResult<Types.LoadImoveisQuery, Types.LoadImoveisQueryVariables>;
export const IsProcessTerritorioRunningDocument = gql`
    query IsProcessTerritorioRunning($input: ID!) {
  isProcessamentoTerritorioRunning(token: $input)
}
    `;

/**
 * __useIsProcessTerritorioRunningQuery__
 *
 * To run a query within a React component, call `useIsProcessTerritorioRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProcessTerritorioRunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProcessTerritorioRunningQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsProcessTerritorioRunningQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables> & ({ variables: Types.IsProcessTerritorioRunningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>(IsProcessTerritorioRunningDocument, options);
      }
export function useIsProcessTerritorioRunningLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>(IsProcessTerritorioRunningDocument, options);
        }
export function useIsProcessTerritorioRunningSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>(IsProcessTerritorioRunningDocument, options);
        }
export type IsProcessTerritorioRunningQueryHookResult = ReturnType<typeof useIsProcessTerritorioRunningQuery>;
export type IsProcessTerritorioRunningLazyQueryHookResult = ReturnType<typeof useIsProcessTerritorioRunningLazyQuery>;
export type IsProcessTerritorioRunningSuspenseQueryHookResult = ReturnType<typeof useIsProcessTerritorioRunningSuspenseQuery>;
export type IsProcessTerritorioRunningQueryResult = Apollo.QueryResult<Types.IsProcessTerritorioRunningQuery, Types.IsProcessTerritorioRunningQueryVariables>;
export const ReterritorializarDocument = gql`
    mutation Reterritorializar($input: ReterritorializarInput!) {
  reterritorializar(input: $input)
}
    `;
export type ReterritorializarMutationFn = Apollo.MutationFunction<Types.ReterritorializarMutation, Types.ReterritorializarMutationVariables>;

/**
 * __useReterritorializarMutation__
 *
 * To run a mutation, you first call `useReterritorializarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReterritorializarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reterritorializarMutation, { data, loading, error }] = useReterritorializarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReterritorializarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ReterritorializarMutation, Types.ReterritorializarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ReterritorializarMutation, Types.ReterritorializarMutationVariables>(ReterritorializarDocument, options);
      }
export type ReterritorializarMutationHookResult = ReturnType<typeof useReterritorializarMutation>;
export type ReterritorializarMutationResult = Apollo.MutationResult<Types.ReterritorializarMutation>;
export type ReterritorializarMutationOptions = Apollo.BaseMutationOptions<Types.ReterritorializarMutation, Types.ReterritorializarMutationVariables>;
export const AtendimentoIndividualRetificacaoViewDocument = gql`
    query AtendimentoIndividualRetificacaoView($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    evolucaoObjetivo {
      id
      descricao
    }
    ivcf {
      id
      resultado
      dimensoesAlteradas
      dataResultado
      riscoVulnerabilidade
      aplicacao {
        id
        pergunta
        resposta
      }
    }
    marcadorConsumoAlimentar {
      id
      categoria
      respostas {
        pergunta
        opcoesSelecionadas
      }
    }
    medicoes {
      ...MedicoesFragment
      dataMedicao
      medicaoAnterior
      valorVacinacaoEmDia
    }
    evolucaoPlano {
      id
      descricao
      intervencoesProcedimentos {
        id
        nota
        ciap {
          ...Ciap
        }
        procedimento {
          ...Procedimento
          idadeMinima
          idadeMaxima
          sexo
        }
        automatico
      }
    }
    orientacoes {
      id
      descricao
    }
    evolucaoSubjetivo {
      id
      descricao
      ciaps {
        id
        ciap {
          ...Ciap
        }
        nota
      }
    }
    procedimentosAtendimento {
      id
      procedimento {
        id
        descricao
        codigo
      }
      automatico
    }
    notificacoesCasoSuspeito {
      id
      notificacao {
        id
        nomeNotificacao
      }
    }
    lotacaoAtendimentoCompartilhado {
      ...LotacaoAtendimentoCompartilhado
    }
    tipoAtendimento
    tipoParticipacaoCidadao
    tipoParticipacaoProfissionalConvidado
    racionalidadeSaude
    condutas
    arquivosAnexados {
      id
      titulo
      observacao
      categoria
      arquivo {
        id
        uuid
        dataCriacao
      }
    }
    atestados {
      id
      descricao
      tipo
      assinadoDigitalmente
      dias
      cid10 {
        ...Cid10
      }
      dataHorarioAfastamento
    }
  }
}
    ${MedicoesFragmentFragmentDoc}
${CiapFragmentDoc}
${ProcedimentoFragmentDoc}
${LotacaoAtendimentoCompartilhadoFragmentDoc}
${Cid10FragmentDoc}`;

/**
 * __useAtendimentoIndividualRetificacaoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoIndividualRetificacaoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoIndividualRetificacaoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoIndividualRetificacaoViewQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoIndividualRetificacaoViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables> & ({ variables: Types.AtendimentoIndividualRetificacaoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>(AtendimentoIndividualRetificacaoViewDocument, options);
      }
export function useAtendimentoIndividualRetificacaoViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>(AtendimentoIndividualRetificacaoViewDocument, options);
        }
export function useAtendimentoIndividualRetificacaoViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>(AtendimentoIndividualRetificacaoViewDocument, options);
        }
export type AtendimentoIndividualRetificacaoViewQueryHookResult = ReturnType<typeof useAtendimentoIndividualRetificacaoViewQuery>;
export type AtendimentoIndividualRetificacaoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoIndividualRetificacaoViewLazyQuery>;
export type AtendimentoIndividualRetificacaoViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoIndividualRetificacaoViewSuspenseQuery>;
export type AtendimentoIndividualRetificacaoViewQueryResult = Apollo.QueryResult<Types.AtendimentoIndividualRetificacaoViewQuery, Types.AtendimentoIndividualRetificacaoViewQueryVariables>;
export const InativarAtendimentoDocument = gql`
    mutation InativarAtendimento($input: InativarAtendimentoInput!) {
  inativarAtendimento(input: $input)
}
    `;
export type InativarAtendimentoMutationFn = Apollo.MutationFunction<Types.InativarAtendimentoMutation, Types.InativarAtendimentoMutationVariables>;

/**
 * __useInativarAtendimentoMutation__
 *
 * To run a mutation, you first call `useInativarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarAtendimentoMutation, { data, loading, error }] = useInativarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInativarAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarAtendimentoMutation, Types.InativarAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarAtendimentoMutation, Types.InativarAtendimentoMutationVariables>(InativarAtendimentoDocument, options);
      }
export type InativarAtendimentoMutationHookResult = ReturnType<typeof useInativarAtendimentoMutation>;
export type InativarAtendimentoMutationResult = Apollo.MutationResult<Types.InativarAtendimentoMutation>;
export type InativarAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.InativarAtendimentoMutation, Types.InativarAtendimentoMutationVariables>;
export const RetificarAtendimentoDocument = gql`
    mutation RetificarAtendimento($input: RetificacaoAtendimentoInput!) {
  retificarAtendimento(input: $input)
}
    `;
export type RetificarAtendimentoMutationFn = Apollo.MutationFunction<Types.RetificarAtendimentoMutation, Types.RetificarAtendimentoMutationVariables>;

/**
 * __useRetificarAtendimentoMutation__
 *
 * To run a mutation, you first call `useRetificarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetificarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retificarAtendimentoMutation, { data, loading, error }] = useRetificarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetificarAtendimentoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RetificarAtendimentoMutation, Types.RetificarAtendimentoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RetificarAtendimentoMutation, Types.RetificarAtendimentoMutationVariables>(RetificarAtendimentoDocument, options);
      }
export type RetificarAtendimentoMutationHookResult = ReturnType<typeof useRetificarAtendimentoMutation>;
export type RetificarAtendimentoMutationResult = Apollo.MutationResult<Types.RetificarAtendimentoMutation>;
export type RetificarAtendimentoMutationOptions = Apollo.BaseMutationOptions<Types.RetificarAtendimentoMutation, Types.RetificarAtendimentoMutationVariables>;
export const AtendimentoVacinacaoRetificacaoViewDocument = gql`
    query AtendimentoVacinacaoRetificacaoView($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    finalizadoEm
    vacinacao {
      id
      condicaoMaternal
      isViajante
      isComunicanteHanseniase
      registrosVacinacao {
        id
        uuid
        imunobiologico {
          id
          nome
          sigla
        }
        doseImunobiologico {
          id
          nome
          sigla
        }
        loteImunobiologico {
          id
          lote
          fabricante {
            id
            nome
          }
          validade
        }
        viaAdministracao {
          id
          nome
        }
        localAplicacaoVacinacao {
          id
          nome
        }
        tipoRegistroVacinacao {
          id
          identificador
        }
        isRegistroAnterior
        estrategiaVacinacao {
          id
          nome
          codigo
          estrategiaVacinacaoDbEnum
        }
        grupoAtendimento {
          id
          nome
        }
        dataAprazamento
        dataAplicacao
        observacoes
        isAplicadoExterior
        cboPrescritor {
          id
          nome
          cbo2002
        }
        cid10MotivoIndicacao {
          id
          nome
          codigo
        }
        isPesquisaClinica
        anvisaProtocoloEstudo
        anvisaProtocoloVersao
        anvisaNumeroRegistro
      }
    }
  }
}
    `;

/**
 * __useAtendimentoVacinacaoRetificacaoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoVacinacaoRetificacaoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoVacinacaoRetificacaoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoVacinacaoRetificacaoViewQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useAtendimentoVacinacaoRetificacaoViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables> & ({ variables: Types.AtendimentoVacinacaoRetificacaoViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>(AtendimentoVacinacaoRetificacaoViewDocument, options);
      }
export function useAtendimentoVacinacaoRetificacaoViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>(AtendimentoVacinacaoRetificacaoViewDocument, options);
        }
export function useAtendimentoVacinacaoRetificacaoViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>(AtendimentoVacinacaoRetificacaoViewDocument, options);
        }
export type AtendimentoVacinacaoRetificacaoViewQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoRetificacaoViewQuery>;
export type AtendimentoVacinacaoRetificacaoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoRetificacaoViewLazyQuery>;
export type AtendimentoVacinacaoRetificacaoViewSuspenseQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoRetificacaoViewSuspenseQuery>;
export type AtendimentoVacinacaoRetificacaoViewQueryResult = Apollo.QueryResult<Types.AtendimentoVacinacaoRetificacaoViewQuery, Types.AtendimentoVacinacaoRetificacaoViewQueryVariables>;
export const CabecalhoModalRetificacaoAtendimentoDocument = gql`
    query CabecalhoModalRetificacaoAtendimento($cidadaoId: ID!) {
  cidadao(id: $cidadaoId) {
    id
    cpf
    cns
    nome
    nomeSocial
    nomeMae
    dataNascimento
  }
}
    `;

/**
 * __useCabecalhoModalRetificacaoAtendimentoQuery__
 *
 * To run a query within a React component, call `useCabecalhoModalRetificacaoAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCabecalhoModalRetificacaoAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCabecalhoModalRetificacaoAtendimentoQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useCabecalhoModalRetificacaoAtendimentoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables> & ({ variables: Types.CabecalhoModalRetificacaoAtendimentoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>(CabecalhoModalRetificacaoAtendimentoDocument, options);
      }
export function useCabecalhoModalRetificacaoAtendimentoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>(CabecalhoModalRetificacaoAtendimentoDocument, options);
        }
export function useCabecalhoModalRetificacaoAtendimentoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>(CabecalhoModalRetificacaoAtendimentoDocument, options);
        }
export type CabecalhoModalRetificacaoAtendimentoQueryHookResult = ReturnType<typeof useCabecalhoModalRetificacaoAtendimentoQuery>;
export type CabecalhoModalRetificacaoAtendimentoLazyQueryHookResult = ReturnType<typeof useCabecalhoModalRetificacaoAtendimentoLazyQuery>;
export type CabecalhoModalRetificacaoAtendimentoSuspenseQueryHookResult = ReturnType<typeof useCabecalhoModalRetificacaoAtendimentoSuspenseQuery>;
export type CabecalhoModalRetificacaoAtendimentoQueryResult = Apollo.QueryResult<Types.CabecalhoModalRetificacaoAtendimentoQuery, Types.CabecalhoModalRetificacaoAtendimentoQueryVariables>;
export const RetificacaoAtendimentoModalDocument = gql`
    query RetificacaoAtendimentoModal($atendimentoProfissionalId: ID!) {
  atendimentoIndividual(id: $atendimentoProfissionalId) {
    id
    atendimento {
      id
      isRegistroTardio
    }
  }
}
    `;

/**
 * __useRetificacaoAtendimentoModalQuery__
 *
 * To run a query within a React component, call `useRetificacaoAtendimentoModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetificacaoAtendimentoModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetificacaoAtendimentoModalQuery({
 *   variables: {
 *      atendimentoProfissionalId: // value for 'atendimentoProfissionalId'
 *   },
 * });
 */
export function useRetificacaoAtendimentoModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables> & ({ variables: Types.RetificacaoAtendimentoModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>(RetificacaoAtendimentoModalDocument, options);
      }
export function useRetificacaoAtendimentoModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>(RetificacaoAtendimentoModalDocument, options);
        }
export function useRetificacaoAtendimentoModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>(RetificacaoAtendimentoModalDocument, options);
        }
export type RetificacaoAtendimentoModalQueryHookResult = ReturnType<typeof useRetificacaoAtendimentoModalQuery>;
export type RetificacaoAtendimentoModalLazyQueryHookResult = ReturnType<typeof useRetificacaoAtendimentoModalLazyQuery>;
export type RetificacaoAtendimentoModalSuspenseQueryHookResult = ReturnType<typeof useRetificacaoAtendimentoModalSuspenseQuery>;
export type RetificacaoAtendimentoModalQueryResult = Apollo.QueryResult<Types.RetificacaoAtendimentoModalQuery, Types.RetificacaoAtendimentoModalQueryVariables>;
export const SistemasExternosMenuLateralDocument = gql`
    query SistemasExternosMenuLateral {
  iframes(input: {tipoSistemaExterno: MENU_LATERAL}) {
    id
    providerId
    nome
  }
}
    `;

/**
 * __useSistemasExternosMenuLateralQuery__
 *
 * To run a query within a React component, call `useSistemasExternosMenuLateralQuery` and pass it any options that fit your needs.
 * When your component renders, `useSistemasExternosMenuLateralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSistemasExternosMenuLateralQuery({
 *   variables: {
 *   },
 * });
 */
export function useSistemasExternosMenuLateralQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>(SistemasExternosMenuLateralDocument, options);
      }
export function useSistemasExternosMenuLateralLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>(SistemasExternosMenuLateralDocument, options);
        }
export function useSistemasExternosMenuLateralSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>(SistemasExternosMenuLateralDocument, options);
        }
export type SistemasExternosMenuLateralQueryHookResult = ReturnType<typeof useSistemasExternosMenuLateralQuery>;
export type SistemasExternosMenuLateralLazyQueryHookResult = ReturnType<typeof useSistemasExternosMenuLateralLazyQuery>;
export type SistemasExternosMenuLateralSuspenseQueryHookResult = ReturnType<typeof useSistemasExternosMenuLateralSuspenseQuery>;
export type SistemasExternosMenuLateralQueryResult = Apollo.QueryResult<Types.SistemasExternosMenuLateralQuery, Types.SistemasExternosMenuLateralQueryVariables>;
export const SobreDocument = gql`
    query Sobre {
  info {
    id
    commit
    competenciaSigtap
    databaseVendor
    databaseSchemaVersion
    recursosDisponiveis
    versao
    internetHabilitada
    smtpConfigurado
    govBREnabled
  }
}
    `;

/**
 * __useSobreQuery__
 *
 * To run a query within a React component, call `useSobreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSobreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSobreQuery({
 *   variables: {
 *   },
 * });
 */
export function useSobreQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SobreQuery, Types.SobreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SobreQuery, Types.SobreQueryVariables>(SobreDocument, options);
      }
export function useSobreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SobreQuery, Types.SobreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SobreQuery, Types.SobreQueryVariables>(SobreDocument, options);
        }
export function useSobreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.SobreQuery, Types.SobreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.SobreQuery, Types.SobreQueryVariables>(SobreDocument, options);
        }
export type SobreQueryHookResult = ReturnType<typeof useSobreQuery>;
export type SobreLazyQueryHookResult = ReturnType<typeof useSobreLazyQuery>;
export type SobreSuspenseQueryHookResult = ReturnType<typeof useSobreSuspenseQuery>;
export type SobreQueryResult = Apollo.QueryResult<Types.SobreQuery, Types.SobreQueryVariables>;
export const AceitarTermosUsoDocument = gql`
    mutation AceitarTermosUso {
  aceitarTermosUso {
    id
    forcarTrocaSenha
    aceitouTermosUso
  }
}
    `;
export type AceitarTermosUsoMutationFn = Apollo.MutationFunction<Types.AceitarTermosUsoMutation, Types.AceitarTermosUsoMutationVariables>;

/**
 * __useAceitarTermosUsoMutation__
 *
 * To run a mutation, you first call `useAceitarTermosUsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAceitarTermosUsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aceitarTermosUsoMutation, { data, loading, error }] = useAceitarTermosUsoMutation({
 *   variables: {
 *   },
 * });
 */
export function useAceitarTermosUsoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AceitarTermosUsoMutation, Types.AceitarTermosUsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AceitarTermosUsoMutation, Types.AceitarTermosUsoMutationVariables>(AceitarTermosUsoDocument, options);
      }
export type AceitarTermosUsoMutationHookResult = ReturnType<typeof useAceitarTermosUsoMutation>;
export type AceitarTermosUsoMutationResult = Apollo.MutationResult<Types.AceitarTermosUsoMutation>;
export type AceitarTermosUsoMutationOptions = Apollo.BaseMutationOptions<Types.AceitarTermosUsoMutation, Types.AceitarTermosUsoMutationVariables>;
export const AlternarTransmissaoLinkDocument = gql`
    mutation AlternarTransmissaoLink($id: ID!) {
  alternarTransmissaoLink(id: $id)
}
    `;
export type AlternarTransmissaoLinkMutationFn = Apollo.MutationFunction<Types.AlternarTransmissaoLinkMutation, Types.AlternarTransmissaoLinkMutationVariables>;

/**
 * __useAlternarTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useAlternarTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlternarTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alternarTransmissaoLinkMutation, { data, loading, error }] = useAlternarTransmissaoLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlternarTransmissaoLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlternarTransmissaoLinkMutation, Types.AlternarTransmissaoLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlternarTransmissaoLinkMutation, Types.AlternarTransmissaoLinkMutationVariables>(AlternarTransmissaoLinkDocument, options);
      }
export type AlternarTransmissaoLinkMutationHookResult = ReturnType<typeof useAlternarTransmissaoLinkMutation>;
export type AlternarTransmissaoLinkMutationResult = Apollo.MutationResult<Types.AlternarTransmissaoLinkMutation>;
export type AlternarTransmissaoLinkMutationOptions = Apollo.BaseMutationOptions<Types.AlternarTransmissaoLinkMutation, Types.AlternarTransmissaoLinkMutationVariables>;
export const ExcluirTransmissaoLinkDocument = gql`
    mutation ExcluirTransmissaoLink($id: ID!) {
  excluirTransmissaoLink(id: $id)
}
    `;
export type ExcluirTransmissaoLinkMutationFn = Apollo.MutationFunction<Types.ExcluirTransmissaoLinkMutation, Types.ExcluirTransmissaoLinkMutationVariables>;

/**
 * __useExcluirTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useExcluirTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirTransmissaoLinkMutation, { data, loading, error }] = useExcluirTransmissaoLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirTransmissaoLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirTransmissaoLinkMutation, Types.ExcluirTransmissaoLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcluirTransmissaoLinkMutation, Types.ExcluirTransmissaoLinkMutationVariables>(ExcluirTransmissaoLinkDocument, options);
      }
export type ExcluirTransmissaoLinkMutationHookResult = ReturnType<typeof useExcluirTransmissaoLinkMutation>;
export type ExcluirTransmissaoLinkMutationResult = Apollo.MutationResult<Types.ExcluirTransmissaoLinkMutation>;
export type ExcluirTransmissaoLinkMutationOptions = Apollo.BaseMutationOptions<Types.ExcluirTransmissaoLinkMutation, Types.ExcluirTransmissaoLinkMutationVariables>;
export const InserirTransmissaoLinkDocument = gql`
    mutation InserirTransmissaoLink($form: TransmissaoLinkInsertDto!) {
  inserirTransmissaoLink(form: $form)
}
    `;
export type InserirTransmissaoLinkMutationFn = Apollo.MutationFunction<Types.InserirTransmissaoLinkMutation, Types.InserirTransmissaoLinkMutationVariables>;

/**
 * __useInserirTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useInserirTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInserirTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inserirTransmissaoLinkMutation, { data, loading, error }] = useInserirTransmissaoLinkMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useInserirTransmissaoLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InserirTransmissaoLinkMutation, Types.InserirTransmissaoLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InserirTransmissaoLinkMutation, Types.InserirTransmissaoLinkMutationVariables>(InserirTransmissaoLinkDocument, options);
      }
export type InserirTransmissaoLinkMutationHookResult = ReturnType<typeof useInserirTransmissaoLinkMutation>;
export type InserirTransmissaoLinkMutationResult = Apollo.MutationResult<Types.InserirTransmissaoLinkMutation>;
export type InserirTransmissaoLinkMutationOptions = Apollo.BaseMutationOptions<Types.InserirTransmissaoLinkMutation, Types.InserirTransmissaoLinkMutationVariables>;
export const TransmissaoLinkDocument = gql`
    query TransmissaoLink($input: TransmissaoLinkPagingQueryFiltroDto!) {
  transmissaoLink(input: $input) {
    content {
      id
      hostname
      name
      ativo
      statusConexao
      dataTesteConexao
      actions {
        alternarAtivacao {
          enabled
          hint
        }
        excluir {
          enabled
          hint
        }
        editar {
          enabled
          hint
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTransmissaoLinkQuery__
 *
 * To run a query within a React component, call `useTransmissaoLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables> & ({ variables: Types.TransmissaoLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>(TransmissaoLinkDocument, options);
      }
export function useTransmissaoLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>(TransmissaoLinkDocument, options);
        }
export function useTransmissaoLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>(TransmissaoLinkDocument, options);
        }
export type TransmissaoLinkQueryHookResult = ReturnType<typeof useTransmissaoLinkQuery>;
export type TransmissaoLinkLazyQueryHookResult = ReturnType<typeof useTransmissaoLinkLazyQuery>;
export type TransmissaoLinkSuspenseQueryHookResult = ReturnType<typeof useTransmissaoLinkSuspenseQuery>;
export type TransmissaoLinkQueryResult = Apollo.QueryResult<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>;
export const TestarConexaoLinkTransmissaoDocument = gql`
    mutation TestarConexaoLinkTransmissao($id: ID!) {
  testarConexaoLinkTransmissao(id: $id) {
    link {
      id
      hostname
      name
      ativo
      statusConexao
      dataTesteConexao
    }
    validationDescription
  }
}
    `;
export type TestarConexaoLinkTransmissaoMutationFn = Apollo.MutationFunction<Types.TestarConexaoLinkTransmissaoMutation, Types.TestarConexaoLinkTransmissaoMutationVariables>;

/**
 * __useTestarConexaoLinkTransmissaoMutation__
 *
 * To run a mutation, you first call `useTestarConexaoLinkTransmissaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoLinkTransmissaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoLinkTransmissaoMutation, { data, loading, error }] = useTestarConexaoLinkTransmissaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestarConexaoLinkTransmissaoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.TestarConexaoLinkTransmissaoMutation, Types.TestarConexaoLinkTransmissaoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.TestarConexaoLinkTransmissaoMutation, Types.TestarConexaoLinkTransmissaoMutationVariables>(TestarConexaoLinkTransmissaoDocument, options);
      }
export type TestarConexaoLinkTransmissaoMutationHookResult = ReturnType<typeof useTestarConexaoLinkTransmissaoMutation>;
export type TestarConexaoLinkTransmissaoMutationResult = Apollo.MutationResult<Types.TestarConexaoLinkTransmissaoMutation>;
export type TestarConexaoLinkTransmissaoMutationOptions = Apollo.BaseMutationOptions<Types.TestarConexaoLinkTransmissaoMutation, Types.TestarConexaoLinkTransmissaoMutationVariables>;
export const UpdateTransmissaoLinkDocument = gql`
    mutation UpdateTransmissaoLink($form: TransmissaoLinkUpdateDto!) {
  updateTransmissaoLink(form: $form)
}
    `;
export type UpdateTransmissaoLinkMutationFn = Apollo.MutationFunction<Types.UpdateTransmissaoLinkMutation, Types.UpdateTransmissaoLinkMutationVariables>;

/**
 * __useUpdateTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useUpdateTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransmissaoLinkMutation, { data, loading, error }] = useUpdateTransmissaoLinkMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateTransmissaoLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateTransmissaoLinkMutation, Types.UpdateTransmissaoLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateTransmissaoLinkMutation, Types.UpdateTransmissaoLinkMutationVariables>(UpdateTransmissaoLinkDocument, options);
      }
export type UpdateTransmissaoLinkMutationHookResult = ReturnType<typeof useUpdateTransmissaoLinkMutation>;
export type UpdateTransmissaoLinkMutationResult = Apollo.MutationResult<Types.UpdateTransmissaoLinkMutation>;
export type UpdateTransmissaoLinkMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTransmissaoLinkMutation, Types.UpdateTransmissaoLinkMutationVariables>;
export const TransmissaoRecebimentoLotesDocument = gql`
    query TransmissaoRecebimentoLotes($input: TransmissaoRecebimentoLoteFiltro!) {
  transmissaoRecebimentoLotes(input: $input) {
    content {
      id
      numeroLote
      responsavel
      processado
      data
      counts {
        fichasValidas
        fichasInvalidas
        totalFichas
        fichasRepetidas
      }
      origemLote {
        id
        descricao
      }
      credencialIntegracao {
        id
        nomeResponsavel
      }
      possuiInconsistencia
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTransmissaoRecebimentoLotesQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoLotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoLotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoLotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoLotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables> & ({ variables: Types.TransmissaoRecebimentoLotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>(TransmissaoRecebimentoLotesDocument, options);
      }
export function useTransmissaoRecebimentoLotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>(TransmissaoRecebimentoLotesDocument, options);
        }
export function useTransmissaoRecebimentoLotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>(TransmissaoRecebimentoLotesDocument, options);
        }
export type TransmissaoRecebimentoLotesQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoLotesQuery>;
export type TransmissaoRecebimentoLotesLazyQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoLotesLazyQuery>;
export type TransmissaoRecebimentoLotesSuspenseQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoLotesSuspenseQuery>;
export type TransmissaoRecebimentoLotesQueryResult = Apollo.QueryResult<Types.TransmissaoRecebimentoLotesQuery, Types.TransmissaoRecebimentoLotesQueryVariables>;
export const CredenciaisIntegracaoOldDocument = gql`
    query CredenciaisIntegracaoOld($input: CredencialIntegracaoQueryInput!) {
  credenciaisIntegracao(input: $input) {
    content {
      id
      nomeResponsavel
      nomeCredencial
      dataCriacao
      email
      ativo
      tipoPessoa
      cpfCnpj
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCredenciaisIntegracaoOldQuery__
 *
 * To run a query within a React component, call `useCredenciaisIntegracaoOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCredenciaisIntegracaoOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCredenciaisIntegracaoOldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCredenciaisIntegracaoOldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables> & ({ variables: Types.CredenciaisIntegracaoOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>(CredenciaisIntegracaoOldDocument, options);
      }
export function useCredenciaisIntegracaoOldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>(CredenciaisIntegracaoOldDocument, options);
        }
export function useCredenciaisIntegracaoOldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>(CredenciaisIntegracaoOldDocument, options);
        }
export type CredenciaisIntegracaoOldQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoOldQuery>;
export type CredenciaisIntegracaoOldLazyQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoOldLazyQuery>;
export type CredenciaisIntegracaoOldSuspenseQueryHookResult = ReturnType<typeof useCredenciaisIntegracaoOldSuspenseQuery>;
export type CredenciaisIntegracaoOldQueryResult = Apollo.QueryResult<Types.CredenciaisIntegracaoOldQuery, Types.CredenciaisIntegracaoOldQueryVariables>;
export const InativarCredencialIntegracaoOldDocument = gql`
    mutation inativarCredencialIntegracaoOld($id: ID!) {
  inativarCredencialIntegracao(id: $id) {
    id
  }
}
    `;
export type InativarCredencialIntegracaoOldMutationFn = Apollo.MutationFunction<Types.InativarCredencialIntegracaoOldMutation, Types.InativarCredencialIntegracaoOldMutationVariables>;

/**
 * __useInativarCredencialIntegracaoOldMutation__
 *
 * To run a mutation, you first call `useInativarCredencialIntegracaoOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarCredencialIntegracaoOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarCredencialIntegracaoOldMutation, { data, loading, error }] = useInativarCredencialIntegracaoOldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInativarCredencialIntegracaoOldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InativarCredencialIntegracaoOldMutation, Types.InativarCredencialIntegracaoOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.InativarCredencialIntegracaoOldMutation, Types.InativarCredencialIntegracaoOldMutationVariables>(InativarCredencialIntegracaoOldDocument, options);
      }
export type InativarCredencialIntegracaoOldMutationHookResult = ReturnType<typeof useInativarCredencialIntegracaoOldMutation>;
export type InativarCredencialIntegracaoOldMutationResult = Apollo.MutationResult<Types.InativarCredencialIntegracaoOldMutation>;
export type InativarCredencialIntegracaoOldMutationOptions = Apollo.BaseMutationOptions<Types.InativarCredencialIntegracaoOldMutation, Types.InativarCredencialIntegracaoOldMutationVariables>;
export const SalvarCredencialIntegracaoOldDocument = gql`
    mutation salvarCredencialIntegracaoOld($input: CredencialIntegracaoInput!) {
  salvarCredencialIntegracao(input: $input) {
    userPassword {
      user
      password
    }
  }
}
    `;
export type SalvarCredencialIntegracaoOldMutationFn = Apollo.MutationFunction<Types.SalvarCredencialIntegracaoOldMutation, Types.SalvarCredencialIntegracaoOldMutationVariables>;

/**
 * __useSalvarCredencialIntegracaoOldMutation__
 *
 * To run a mutation, you first call `useSalvarCredencialIntegracaoOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarCredencialIntegracaoOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarCredencialIntegracaoOldMutation, { data, loading, error }] = useSalvarCredencialIntegracaoOldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarCredencialIntegracaoOldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarCredencialIntegracaoOldMutation, Types.SalvarCredencialIntegracaoOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SalvarCredencialIntegracaoOldMutation, Types.SalvarCredencialIntegracaoOldMutationVariables>(SalvarCredencialIntegracaoOldDocument, options);
      }
export type SalvarCredencialIntegracaoOldMutationHookResult = ReturnType<typeof useSalvarCredencialIntegracaoOldMutation>;
export type SalvarCredencialIntegracaoOldMutationResult = Apollo.MutationResult<Types.SalvarCredencialIntegracaoOldMutation>;
export type SalvarCredencialIntegracaoOldMutationOptions = Apollo.BaseMutationOptions<Types.SalvarCredencialIntegracaoOldMutation, Types.SalvarCredencialIntegracaoOldMutationVariables>;
export const AlterarHorarioGeracaoLotesProcessamentoFichasDocument = gql`
    mutation AlterarHorarioGeracaoLotesProcessamentoFichas($horario: LocalTime!) {
  alterarHorarioGeracaoLotesProcessamentoFichas(horario: $horario)
}
    `;
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationFn = Apollo.MutationFunction<Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation, Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables>;

/**
 * __useAlterarHorarioGeracaoLotesProcessamentoFichasMutation__
 *
 * To run a mutation, you first call `useAlterarHorarioGeracaoLotesProcessamentoFichasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarHorarioGeracaoLotesProcessamentoFichasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarHorarioGeracaoLotesProcessamentoFichasMutation, { data, loading, error }] = useAlterarHorarioGeracaoLotesProcessamentoFichasMutation({
 *   variables: {
 *      horario: // value for 'horario'
 *   },
 * });
 */
export function useAlterarHorarioGeracaoLotesProcessamentoFichasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation, Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation, Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables>(AlterarHorarioGeracaoLotesProcessamentoFichasDocument, options);
      }
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationHookResult = ReturnType<typeof useAlterarHorarioGeracaoLotesProcessamentoFichasMutation>;
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationResult = Apollo.MutationResult<Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation>;
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationOptions = Apollo.BaseMutationOptions<Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation, Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables>;
export const LoadHorarioGeracaoLotesProcessamentoFichasDocument = gql`
    query LoadHorarioGeracaoLotesProcessamentoFichas {
  loadHorarioGeracaoLotesProcessamentoFichas
}
    `;

/**
 * __useLoadHorarioGeracaoLotesProcessamentoFichasQuery__
 *
 * To run a query within a React component, call `useLoadHorarioGeracaoLotesProcessamentoFichasQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadHorarioGeracaoLotesProcessamentoFichasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadHorarioGeracaoLotesProcessamentoFichasQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadHorarioGeracaoLotesProcessamentoFichasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>(LoadHorarioGeracaoLotesProcessamentoFichasDocument, options);
      }
export function useLoadHorarioGeracaoLotesProcessamentoFichasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>(LoadHorarioGeracaoLotesProcessamentoFichasDocument, options);
        }
export function useLoadHorarioGeracaoLotesProcessamentoFichasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>(LoadHorarioGeracaoLotesProcessamentoFichasDocument, options);
        }
export type LoadHorarioGeracaoLotesProcessamentoFichasQueryHookResult = ReturnType<typeof useLoadHorarioGeracaoLotesProcessamentoFichasQuery>;
export type LoadHorarioGeracaoLotesProcessamentoFichasLazyQueryHookResult = ReturnType<typeof useLoadHorarioGeracaoLotesProcessamentoFichasLazyQuery>;
export type LoadHorarioGeracaoLotesProcessamentoFichasSuspenseQueryHookResult = ReturnType<typeof useLoadHorarioGeracaoLotesProcessamentoFichasSuspenseQuery>;
export type LoadHorarioGeracaoLotesProcessamentoFichasQueryResult = Apollo.QueryResult<Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery, Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables>;
export const LoteEnvioDocument = gql`
    query LoteEnvio($idLote: ID!, $filtroHistorico: HistoricoExportacaoFiltro!) {
  loteEnvio(idLote: $idLote) {
    id
    dataCriacao
    quantidadeFichas
    nodos {
      id
      dataEnvio
      nodeNome
      statusEnvio
    }
    historicoExportacao(filtro: $filtroHistorico) {
      content {
        id
        nomeProfissional
        dataExportacao
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLoteEnvioQuery__
 *
 * To run a query within a React component, call `useLoteEnvioQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteEnvioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteEnvioQuery({
 *   variables: {
 *      idLote: // value for 'idLote'
 *      filtroHistorico: // value for 'filtroHistorico'
 *   },
 * });
 */
export function useLoteEnvioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables> & ({ variables: Types.LoteEnvioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>(LoteEnvioDocument, options);
      }
export function useLoteEnvioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>(LoteEnvioDocument, options);
        }
export function useLoteEnvioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>(LoteEnvioDocument, options);
        }
export type LoteEnvioQueryHookResult = ReturnType<typeof useLoteEnvioQuery>;
export type LoteEnvioLazyQueryHookResult = ReturnType<typeof useLoteEnvioLazyQuery>;
export type LoteEnvioSuspenseQueryHookResult = ReturnType<typeof useLoteEnvioSuspenseQuery>;
export type LoteEnvioQueryResult = Apollo.QueryResult<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>;
export const GerarLotesDocument = gql`
    mutation GerarLotes {
  gerarLote
}
    `;
export type GerarLotesMutationFn = Apollo.MutationFunction<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>;

/**
 * __useGerarLotesMutation__
 *
 * To run a mutation, you first call `useGerarLotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarLotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarLotesMutation, { data, loading, error }] = useGerarLotesMutation({
 *   variables: {
 *   },
 * });
 */
export function useGerarLotesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>(GerarLotesDocument, options);
      }
export type GerarLotesMutationHookResult = ReturnType<typeof useGerarLotesMutation>;
export type GerarLotesMutationResult = Apollo.MutationResult<Types.GerarLotesMutation>;
export type GerarLotesMutationOptions = Apollo.BaseMutationOptions<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>;
export const LotesEnvioDocument = gql`
    query LotesEnvio($input: LotesEnvioFiltro!) {
  lotesEnvio(input: $input) {
    content {
      id
      statusEnvio
      dataCriacao
      quantidadeFichas
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useLotesEnvioQuery__
 *
 * To run a query within a React component, call `useLotesEnvioQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotesEnvioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotesEnvioQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotesEnvioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables> & ({ variables: Types.LotesEnvioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>(LotesEnvioDocument, options);
      }
export function useLotesEnvioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>(LotesEnvioDocument, options);
        }
export function useLotesEnvioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>(LotesEnvioDocument, options);
        }
export type LotesEnvioQueryHookResult = ReturnType<typeof useLotesEnvioQuery>;
export type LotesEnvioLazyQueryHookResult = ReturnType<typeof useLotesEnvioLazyQuery>;
export type LotesEnvioSuspenseQueryHookResult = ReturnType<typeof useLotesEnvioSuspenseQuery>;
export type LotesEnvioQueryResult = Apollo.QueryResult<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>;
export const TransmissaoRecebimentoCnesDetailItemsDocument = gql`
    query TransmissaoRecebimentoCnesDetailItems($input: TransmissaoRecebimentoCnesDetailFiltro!) {
  transmissaoRecebimentoCnesDetailItems(input: $input) {
    nomeEstabelecimento
    tipoFicha
    quantidade
  }
}
    `;

/**
 * __useTransmissaoRecebimentoCnesDetailItemsQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoCnesDetailItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoCnesDetailItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoCnesDetailItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoCnesDetailItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables> & ({ variables: Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>(TransmissaoRecebimentoCnesDetailItemsDocument, options);
      }
export function useTransmissaoRecebimentoCnesDetailItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>(TransmissaoRecebimentoCnesDetailItemsDocument, options);
        }
export function useTransmissaoRecebimentoCnesDetailItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>(TransmissaoRecebimentoCnesDetailItemsDocument, options);
        }
export type TransmissaoRecebimentoCnesDetailItemsQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesDetailItemsQuery>;
export type TransmissaoRecebimentoCnesDetailItemsLazyQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesDetailItemsLazyQuery>;
export type TransmissaoRecebimentoCnesDetailItemsSuspenseQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesDetailItemsSuspenseQuery>;
export type TransmissaoRecebimentoCnesDetailItemsQueryResult = Apollo.QueryResult<Types.TransmissaoRecebimentoCnesDetailItemsQuery, Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables>;
export const TransmissaoRecebimentoCnesDocument = gql`
    query TransmissaoRecebimentoCnes($input: TransmissaoRecebimentoCnesFiltro!) {
  transmissaoRecebimentoCnes(input: $input) {
    content {
      numCnes
      mesRecebimento
      anoRecebimento
      fichasRecebidas
      estabelecimentoOrigem
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useTransmissaoRecebimentoCnesQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoCnesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoCnesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoCnesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoCnesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables> & ({ variables: Types.TransmissaoRecebimentoCnesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>(TransmissaoRecebimentoCnesDocument, options);
      }
export function useTransmissaoRecebimentoCnesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>(TransmissaoRecebimentoCnesDocument, options);
        }
export function useTransmissaoRecebimentoCnesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>(TransmissaoRecebimentoCnesDocument, options);
        }
export type TransmissaoRecebimentoCnesQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesQuery>;
export type TransmissaoRecebimentoCnesLazyQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesLazyQuery>;
export type TransmissaoRecebimentoCnesSuspenseQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesSuspenseQuery>;
export type TransmissaoRecebimentoCnesQueryResult = Apollo.QueryResult<Types.TransmissaoRecebimentoCnesQuery, Types.TransmissaoRecebimentoCnesQueryVariables>;
export const ExistemFichasParaProcessarDocument = gql`
    query ExistemFichasParaProcessar {
  existemFichasParaProcessar
}
    `;

/**
 * __useExistemFichasParaProcessarQuery__
 *
 * To run a query within a React component, call `useExistemFichasParaProcessarQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistemFichasParaProcessarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistemFichasParaProcessarQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistemFichasParaProcessarQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>(ExistemFichasParaProcessarDocument, options);
      }
export function useExistemFichasParaProcessarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>(ExistemFichasParaProcessarDocument, options);
        }
export function useExistemFichasParaProcessarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>(ExistemFichasParaProcessarDocument, options);
        }
export type ExistemFichasParaProcessarQueryHookResult = ReturnType<typeof useExistemFichasParaProcessarQuery>;
export type ExistemFichasParaProcessarLazyQueryHookResult = ReturnType<typeof useExistemFichasParaProcessarLazyQuery>;
export type ExistemFichasParaProcessarSuspenseQueryHookResult = ReturnType<typeof useExistemFichasParaProcessarSuspenseQuery>;
export type ExistemFichasParaProcessarQueryResult = Apollo.QueryResult<Types.ExistemFichasParaProcessarQuery, Types.ExistemFichasParaProcessarQueryVariables>;
export const TransmissaoDocument = gql`
    query Transmissao {
  transmissao {
    id
    importacaoArquivo {
      dataEvento
      status
      message
    }
  }
}
    `;

/**
 * __useTransmissaoQuery__
 *
 * To run a query within a React component, call `useTransmissaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransmissaoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>(TransmissaoDocument, options);
      }
export function useTransmissaoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>(TransmissaoDocument, options);
        }
export function useTransmissaoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>(TransmissaoDocument, options);
        }
export type TransmissaoQueryHookResult = ReturnType<typeof useTransmissaoQuery>;
export type TransmissaoLazyQueryHookResult = ReturnType<typeof useTransmissaoLazyQuery>;
export type TransmissaoSuspenseQueryHookResult = ReturnType<typeof useTransmissaoSuspenseQuery>;
export type TransmissaoQueryResult = Apollo.QueryResult<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>;
export const AtivarTipoServicoDocument = gql`
    mutation AtivarTipoServico($unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput!) {
  ativarTipoServico(
    unidadeSaudeTipoServicoFormInput: $unidadeSaudeTipoServicoFormInput
  ) {
    unidadeSaudeId
    tipoServicoId
  }
}
    `;
export type AtivarTipoServicoMutationFn = Apollo.MutationFunction<Types.AtivarTipoServicoMutation, Types.AtivarTipoServicoMutationVariables>;

/**
 * __useAtivarTipoServicoMutation__
 *
 * To run a mutation, you first call `useAtivarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarTipoServicoMutation, { data, loading, error }] = useAtivarTipoServicoMutation({
 *   variables: {
 *      unidadeSaudeTipoServicoFormInput: // value for 'unidadeSaudeTipoServicoFormInput'
 *   },
 * });
 */
export function useAtivarTipoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtivarTipoServicoMutation, Types.AtivarTipoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtivarTipoServicoMutation, Types.AtivarTipoServicoMutationVariables>(AtivarTipoServicoDocument, options);
      }
export type AtivarTipoServicoMutationHookResult = ReturnType<typeof useAtivarTipoServicoMutation>;
export type AtivarTipoServicoMutationResult = Apollo.MutationResult<Types.AtivarTipoServicoMutation>;
export type AtivarTipoServicoMutationOptions = Apollo.BaseMutationOptions<Types.AtivarTipoServicoMutation, Types.AtivarTipoServicoMutationVariables>;
export const DesativarTipoServicoDocument = gql`
    mutation DesativarTipoServico($unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput!) {
  desativarTipoServico(
    unidadeSaudeTipoServicoFormInput: $unidadeSaudeTipoServicoFormInput
  ) {
    unidadeSaudeId
    tipoServicoId
  }
}
    `;
export type DesativarTipoServicoMutationFn = Apollo.MutationFunction<Types.DesativarTipoServicoMutation, Types.DesativarTipoServicoMutationVariables>;

/**
 * __useDesativarTipoServicoMutation__
 *
 * To run a mutation, you first call `useDesativarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarTipoServicoMutation, { data, loading, error }] = useDesativarTipoServicoMutation({
 *   variables: {
 *      unidadeSaudeTipoServicoFormInput: // value for 'unidadeSaudeTipoServicoFormInput'
 *   },
 * });
 */
export function useDesativarTipoServicoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DesativarTipoServicoMutation, Types.DesativarTipoServicoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DesativarTipoServicoMutation, Types.DesativarTipoServicoMutationVariables>(DesativarTipoServicoDocument, options);
      }
export type DesativarTipoServicoMutationHookResult = ReturnType<typeof useDesativarTipoServicoMutation>;
export type DesativarTipoServicoMutationResult = Apollo.MutationResult<Types.DesativarTipoServicoMutation>;
export type DesativarTipoServicoMutationOptions = Apollo.BaseMutationOptions<Types.DesativarTipoServicoMutation, Types.DesativarTipoServicoMutationVariables>;
export const UnidadeSaudeDetailDocument = gql`
    query UnidadeSaudeDetail($id: ID!) {
  unidadeSaude(id: $id) {
    id
    nome
    cnes
    cnpj
    email
    telefone1
    telefone2
    fax
    tipo {
      id
      descricao
    }
    subtipo {
      id
      codigoMs
      tipoUnidadeSaude {
        id
      }
      descricao
    }
    tipoEstabelecimento
    complexidades {
      id
      nome
    }
    ativo
    endereco {
      cep
      municipio {
        id
        nome
      }
      uf {
        id
        sigla
      }
      tipoLogradouro {
        id
        nome
      }
      logradouro
      numero
      semNumero
      complemento
      pontoReferencia
      bairro
    }
    actions {
      permissaoAtivarInativarTipoServico {
        enabled
        hint
      }
    }
  }
}
    `;

/**
 * __useUnidadeSaudeDetailQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnidadeSaudeDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables> & ({ variables: Types.UnidadeSaudeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>(UnidadeSaudeDetailDocument, options);
      }
export function useUnidadeSaudeDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>(UnidadeSaudeDetailDocument, options);
        }
export function useUnidadeSaudeDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>(UnidadeSaudeDetailDocument, options);
        }
export type UnidadeSaudeDetailQueryHookResult = ReturnType<typeof useUnidadeSaudeDetailQuery>;
export type UnidadeSaudeDetailLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeDetailLazyQuery>;
export type UnidadeSaudeDetailSuspenseQueryHookResult = ReturnType<typeof useUnidadeSaudeDetailSuspenseQuery>;
export type UnidadeSaudeDetailQueryResult = Apollo.QueryResult<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>;
export const UnidadeSaudeTipoServicoDocument = gql`
    query UnidadeSaudeTipoServico($input: UnidadeSaudeTipoServicoQueryInput!) {
  unidadeSaudeTiposServico(input: $input) {
    content {
      tipoServico {
        id
        nome
      }
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useUnidadeSaudeTipoServicoQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeTipoServicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeTipoServicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeTipoServicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeTipoServicoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables> & ({ variables: Types.UnidadeSaudeTipoServicoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>(UnidadeSaudeTipoServicoDocument, options);
      }
export function useUnidadeSaudeTipoServicoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>(UnidadeSaudeTipoServicoDocument, options);
        }
export function useUnidadeSaudeTipoServicoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>(UnidadeSaudeTipoServicoDocument, options);
        }
export type UnidadeSaudeTipoServicoQueryHookResult = ReturnType<typeof useUnidadeSaudeTipoServicoQuery>;
export type UnidadeSaudeTipoServicoLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeTipoServicoLazyQuery>;
export type UnidadeSaudeTipoServicoSuspenseQueryHookResult = ReturnType<typeof useUnidadeSaudeTipoServicoSuspenseQuery>;
export type UnidadeSaudeTipoServicoQueryResult = Apollo.QueryResult<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>;
export const UnidadeSaudeTableDocument = gql`
    query UnidadeSaudeTable($input: UnidadesSaudeQueryInput!) {
  unidadesSaude(input: $input) {
    content {
      id
      cnes
      nome
      telefone1
      telefone2
      endereco {
        bairro
      }
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useUnidadeSaudeTableQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables> & ({ variables: Types.UnidadeSaudeTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>(UnidadeSaudeTableDocument, options);
      }
export function useUnidadeSaudeTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>(UnidadeSaudeTableDocument, options);
        }
export function useUnidadeSaudeTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>(UnidadeSaudeTableDocument, options);
        }
export type UnidadeSaudeTableQueryHookResult = ReturnType<typeof useUnidadeSaudeTableQuery>;
export type UnidadeSaudeTableLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeTableLazyQuery>;
export type UnidadeSaudeTableSuspenseQueryHookResult = ReturnType<typeof useUnidadeSaudeTableSuspenseQuery>;
export type UnidadeSaudeTableQueryResult = Apollo.QueryResult<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>;
export const NomesInstalacoesUnificacaoBaseDocument = gql`
    query NomesInstalacoesUnificacaoBase {
  nomesInstalacoes {
    nomeInstalacaoCentral
    nomesInstalacoesUnificadas
  }
}
    `;

/**
 * __useNomesInstalacoesUnificacaoBaseQuery__
 *
 * To run a query within a React component, call `useNomesInstalacoesUnificacaoBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useNomesInstalacoesUnificacaoBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNomesInstalacoesUnificacaoBaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useNomesInstalacoesUnificacaoBaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>(NomesInstalacoesUnificacaoBaseDocument, options);
      }
export function useNomesInstalacoesUnificacaoBaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>(NomesInstalacoesUnificacaoBaseDocument, options);
        }
export function useNomesInstalacoesUnificacaoBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>(NomesInstalacoesUnificacaoBaseDocument, options);
        }
export type NomesInstalacoesUnificacaoBaseQueryHookResult = ReturnType<typeof useNomesInstalacoesUnificacaoBaseQuery>;
export type NomesInstalacoesUnificacaoBaseLazyQueryHookResult = ReturnType<typeof useNomesInstalacoesUnificacaoBaseLazyQuery>;
export type NomesInstalacoesUnificacaoBaseSuspenseQueryHookResult = ReturnType<typeof useNomesInstalacoesUnificacaoBaseSuspenseQuery>;
export type NomesInstalacoesUnificacaoBaseQueryResult = Apollo.QueryResult<Types.NomesInstalacoesUnificacaoBaseQuery, Types.NomesInstalacoesUnificacaoBaseQueryVariables>;
export const UnificacaoBaseCadastrosDuplicadosDocument = gql`
    query UnificacaoBaseCadastrosDuplicados($input: CidadaoUnificacaoBaseInput!) {
  cadastrosDuplicados(input: $input) {
    content {
      id
      cpf
      cns
      cidadao {
        id
        nome
        nomeSocial
        nomeMae
        dataNascimento
        sexo
        identidadeGeneroDbEnum
        ativo
        faleceu
        unificado
        unificacaoBase
        localidadeNascimento {
          id
          nome
          uf {
            id
            sigla
          }
        }
        cidadaoVinculacaoEquipe {
          id
          unidadeSaude {
            id
            nome
          }
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useUnificacaoBaseCadastrosDuplicadosQuery__
 *
 * To run a query within a React component, call `useUnificacaoBaseCadastrosDuplicadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacaoBaseCadastrosDuplicadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacaoBaseCadastrosDuplicadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnificacaoBaseCadastrosDuplicadosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables> & ({ variables: Types.UnificacaoBaseCadastrosDuplicadosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>(UnificacaoBaseCadastrosDuplicadosDocument, options);
      }
export function useUnificacaoBaseCadastrosDuplicadosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>(UnificacaoBaseCadastrosDuplicadosDocument, options);
        }
export function useUnificacaoBaseCadastrosDuplicadosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>(UnificacaoBaseCadastrosDuplicadosDocument, options);
        }
export type UnificacaoBaseCadastrosDuplicadosQueryHookResult = ReturnType<typeof useUnificacaoBaseCadastrosDuplicadosQuery>;
export type UnificacaoBaseCadastrosDuplicadosLazyQueryHookResult = ReturnType<typeof useUnificacaoBaseCadastrosDuplicadosLazyQuery>;
export type UnificacaoBaseCadastrosDuplicadosSuspenseQueryHookResult = ReturnType<typeof useUnificacaoBaseCadastrosDuplicadosSuspenseQuery>;
export type UnificacaoBaseCadastrosDuplicadosQueryResult = Apollo.QueryResult<Types.UnificacaoBaseCadastrosDuplicadosQuery, Types.UnificacaoBaseCadastrosDuplicadosQueryVariables>;
export const UnificaCadastrosDocument = gql`
    mutation UnificaCadastros($input: UnificacaoCadastroInput!) {
  unificaCadastros(input: $input)
}
    `;
export type UnificaCadastrosMutationFn = Apollo.MutationFunction<Types.UnificaCadastrosMutation, Types.UnificaCadastrosMutationVariables>;

/**
 * __useUnificaCadastrosMutation__
 *
 * To run a mutation, you first call `useUnificaCadastrosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnificaCadastrosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unificaCadastrosMutation, { data, loading, error }] = useUnificaCadastrosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnificaCadastrosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UnificaCadastrosMutation, Types.UnificaCadastrosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UnificaCadastrosMutation, Types.UnificaCadastrosMutationVariables>(UnificaCadastrosDocument, options);
      }
export type UnificaCadastrosMutationHookResult = ReturnType<typeof useUnificaCadastrosMutation>;
export type UnificaCadastrosMutationResult = Apollo.MutationResult<Types.UnificaCadastrosMutation>;
export type UnificaCadastrosMutationOptions = Apollo.BaseMutationOptions<Types.UnificaCadastrosMutation, Types.UnificaCadastrosMutationVariables>;
export const UnificacaoCidadaosListingDocument = gql`
    query UnificacaoCidadaosListing($input: CidadaosQueryInput!) {
  listagemCidadaos(input: $input) {
    content {
      id
      nome
      nomeSocial
      cpf
      cns
      nomeMae
      dataNascimento
      telefoneCelular
      telefoneResidencial
      sexo
      identidadeGeneroDbEnum
      dataAtualizado
      ativo
      unificado
      unificacaoBase
      faleceu
      prontuario {
        id
      }
      localidadeNascimento {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      cidadaoVinculacaoEquipe {
        id
        dataAtualizacaoCadastro
        unidadeSaude {
          id
          nome
        }
        equipe {
          id
          nome
          ine
        }
      }
      uuidUltimaFicha
    }
  }
}
    `;

/**
 * __useUnificacaoCidadaosListingQuery__
 *
 * To run a query within a React component, call `useUnificacaoCidadaosListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacaoCidadaosListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacaoCidadaosListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnificacaoCidadaosListingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables> & ({ variables: Types.UnificacaoCidadaosListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>(UnificacaoCidadaosListingDocument, options);
      }
export function useUnificacaoCidadaosListingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>(UnificacaoCidadaosListingDocument, options);
        }
export function useUnificacaoCidadaosListingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>(UnificacaoCidadaosListingDocument, options);
        }
export type UnificacaoCidadaosListingQueryHookResult = ReturnType<typeof useUnificacaoCidadaosListingQuery>;
export type UnificacaoCidadaosListingLazyQueryHookResult = ReturnType<typeof useUnificacaoCidadaosListingLazyQuery>;
export type UnificacaoCidadaosListingSuspenseQueryHookResult = ReturnType<typeof useUnificacaoCidadaosListingSuspenseQuery>;
export type UnificacaoCidadaosListingQueryResult = Apollo.QueryResult<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>;
export const CancelarSolicitacaoEntradaVideochamadaDocument = gql`
    mutation CancelarSolicitacaoEntradaVideochamada($input: CancelarSolicitacaoEntradaVideochamadaInput!) {
  cancelarSolicitacaoEntradaVideochamada(input: $input)
}
    `;
export type CancelarSolicitacaoEntradaVideochamadaMutationFn = Apollo.MutationFunction<Types.CancelarSolicitacaoEntradaVideochamadaMutation, Types.CancelarSolicitacaoEntradaVideochamadaMutationVariables>;

/**
 * __useCancelarSolicitacaoEntradaVideochamadaMutation__
 *
 * To run a mutation, you first call `useCancelarSolicitacaoEntradaVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarSolicitacaoEntradaVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarSolicitacaoEntradaVideochamadaMutation, { data, loading, error }] = useCancelarSolicitacaoEntradaVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelarSolicitacaoEntradaVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelarSolicitacaoEntradaVideochamadaMutation, Types.CancelarSolicitacaoEntradaVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelarSolicitacaoEntradaVideochamadaMutation, Types.CancelarSolicitacaoEntradaVideochamadaMutationVariables>(CancelarSolicitacaoEntradaVideochamadaDocument, options);
      }
export type CancelarSolicitacaoEntradaVideochamadaMutationHookResult = ReturnType<typeof useCancelarSolicitacaoEntradaVideochamadaMutation>;
export type CancelarSolicitacaoEntradaVideochamadaMutationResult = Apollo.MutationResult<Types.CancelarSolicitacaoEntradaVideochamadaMutation>;
export type CancelarSolicitacaoEntradaVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.CancelarSolicitacaoEntradaVideochamadaMutation, Types.CancelarSolicitacaoEntradaVideochamadaMutationVariables>;
export const EncerrarMinhasVideochamadasDocument = gql`
    mutation encerrarMinhasVideochamadas {
  encerrarMinhasVideochamadas
}
    `;
export type EncerrarMinhasVideochamadasMutationFn = Apollo.MutationFunction<Types.EncerrarMinhasVideochamadasMutation, Types.EncerrarMinhasVideochamadasMutationVariables>;

/**
 * __useEncerrarMinhasVideochamadasMutation__
 *
 * To run a mutation, you first call `useEncerrarMinhasVideochamadasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEncerrarMinhasVideochamadasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [encerrarMinhasVideochamadasMutation, { data, loading, error }] = useEncerrarMinhasVideochamadasMutation({
 *   variables: {
 *   },
 * });
 */
export function useEncerrarMinhasVideochamadasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EncerrarMinhasVideochamadasMutation, Types.EncerrarMinhasVideochamadasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EncerrarMinhasVideochamadasMutation, Types.EncerrarMinhasVideochamadasMutationVariables>(EncerrarMinhasVideochamadasDocument, options);
      }
export type EncerrarMinhasVideochamadasMutationHookResult = ReturnType<typeof useEncerrarMinhasVideochamadasMutation>;
export type EncerrarMinhasVideochamadasMutationResult = Apollo.MutationResult<Types.EncerrarMinhasVideochamadasMutation>;
export type EncerrarMinhasVideochamadasMutationOptions = Apollo.BaseMutationOptions<Types.EncerrarMinhasVideochamadasMutation, Types.EncerrarMinhasVideochamadasMutationVariables>;
export const EncerrarVideochamadaDocument = gql`
    mutation encerrarVideochamada($videochamadaUuid: String!) {
  encerrarVideochamada(videochamadaUuid: $videochamadaUuid)
}
    `;
export type EncerrarVideochamadaMutationFn = Apollo.MutationFunction<Types.EncerrarVideochamadaMutation, Types.EncerrarVideochamadaMutationVariables>;

/**
 * __useEncerrarVideochamadaMutation__
 *
 * To run a mutation, you first call `useEncerrarVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEncerrarVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [encerrarVideochamadaMutation, { data, loading, error }] = useEncerrarVideochamadaMutation({
 *   variables: {
 *      videochamadaUuid: // value for 'videochamadaUuid'
 *   },
 * });
 */
export function useEncerrarVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EncerrarVideochamadaMutation, Types.EncerrarVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EncerrarVideochamadaMutation, Types.EncerrarVideochamadaMutationVariables>(EncerrarVideochamadaDocument, options);
      }
export type EncerrarVideochamadaMutationHookResult = ReturnType<typeof useEncerrarVideochamadaMutation>;
export type EncerrarVideochamadaMutationResult = Apollo.MutationResult<Types.EncerrarVideochamadaMutation>;
export type EncerrarVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.EncerrarVideochamadaMutation, Types.EncerrarVideochamadaMutationVariables>;
export const IniciarVideochamadaDocument = gql`
    mutation IniciarVideochamada($input: IniciarVideochamadaInput!) {
  iniciarVideochamada(input: $input)
}
    `;
export type IniciarVideochamadaMutationFn = Apollo.MutationFunction<Types.IniciarVideochamadaMutation, Types.IniciarVideochamadaMutationVariables>;

/**
 * __useIniciarVideochamadaMutation__
 *
 * To run a mutation, you first call `useIniciarVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIniciarVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [iniciarVideochamadaMutation, { data, loading, error }] = useIniciarVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIniciarVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.IniciarVideochamadaMutation, Types.IniciarVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.IniciarVideochamadaMutation, Types.IniciarVideochamadaMutationVariables>(IniciarVideochamadaDocument, options);
      }
export type IniciarVideochamadaMutationHookResult = ReturnType<typeof useIniciarVideochamadaMutation>;
export type IniciarVideochamadaMutationResult = Apollo.MutationResult<Types.IniciarVideochamadaMutation>;
export type IniciarVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.IniciarVideochamadaMutation, Types.IniciarVideochamadaMutationVariables>;
export const ResponderSolicitacaoEntradaVideochamadaDocument = gql`
    mutation ResponderSolicitacaoEntradaVideochamada($input: ResponderSolicitacaoEntradaVideochamadaInput!) {
  responderSolicitacaoEntradaVideochamada(input: $input)
}
    `;
export type ResponderSolicitacaoEntradaVideochamadaMutationFn = Apollo.MutationFunction<Types.ResponderSolicitacaoEntradaVideochamadaMutation, Types.ResponderSolicitacaoEntradaVideochamadaMutationVariables>;

/**
 * __useResponderSolicitacaoEntradaVideochamadaMutation__
 *
 * To run a mutation, you first call `useResponderSolicitacaoEntradaVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponderSolicitacaoEntradaVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responderSolicitacaoEntradaVideochamadaMutation, { data, loading, error }] = useResponderSolicitacaoEntradaVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponderSolicitacaoEntradaVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ResponderSolicitacaoEntradaVideochamadaMutation, Types.ResponderSolicitacaoEntradaVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ResponderSolicitacaoEntradaVideochamadaMutation, Types.ResponderSolicitacaoEntradaVideochamadaMutationVariables>(ResponderSolicitacaoEntradaVideochamadaDocument, options);
      }
export type ResponderSolicitacaoEntradaVideochamadaMutationHookResult = ReturnType<typeof useResponderSolicitacaoEntradaVideochamadaMutation>;
export type ResponderSolicitacaoEntradaVideochamadaMutationResult = Apollo.MutationResult<Types.ResponderSolicitacaoEntradaVideochamadaMutation>;
export type ResponderSolicitacaoEntradaVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.ResponderSolicitacaoEntradaVideochamadaMutation, Types.ResponderSolicitacaoEntradaVideochamadaMutationVariables>;
export const VideochamadaViewDocument = gql`
    query VideochamadaView($uuid: String!) {
  videochamada(uuid: $uuid) {
    id
    dataInicio
    dataFim
    agendamento {
      id
      horarioInicial
    }
    owner {
      id
      profissional {
        id
        nome
        cpf
      }
      ... on Lotacao {
        cbo {
          id
          nome
        }
      }
      ... on Estagio {
        cbo {
          id
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useVideochamadaViewQuery__
 *
 * To run a query within a React component, call `useVideochamadaViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideochamadaViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideochamadaViewQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useVideochamadaViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables> & ({ variables: Types.VideochamadaViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>(VideochamadaViewDocument, options);
      }
export function useVideochamadaViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>(VideochamadaViewDocument, options);
        }
export function useVideochamadaViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>(VideochamadaViewDocument, options);
        }
export type VideochamadaViewQueryHookResult = ReturnType<typeof useVideochamadaViewQuery>;
export type VideochamadaViewLazyQueryHookResult = ReturnType<typeof useVideochamadaViewLazyQuery>;
export type VideochamadaViewSuspenseQueryHookResult = ReturnType<typeof useVideochamadaViewSuspenseQuery>;
export type VideochamadaViewQueryResult = Apollo.QueryResult<Types.VideochamadaViewQuery, Types.VideochamadaViewQueryVariables>;
export const SolicitarEntradaVideochamadaDocument = gql`
    mutation SolicitarEntradaVideochamada($input: SolicitarEntradaVideochamadaInput!) {
  solicitarEntradaVideochamada(input: $input) {
    id
    nome
    cpf
  }
}
    `;
export type SolicitarEntradaVideochamadaMutationFn = Apollo.MutationFunction<Types.SolicitarEntradaVideochamadaMutation, Types.SolicitarEntradaVideochamadaMutationVariables>;

/**
 * __useSolicitarEntradaVideochamadaMutation__
 *
 * To run a mutation, you first call `useSolicitarEntradaVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolicitarEntradaVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solicitarEntradaVideochamadaMutation, { data, loading, error }] = useSolicitarEntradaVideochamadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitarEntradaVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SolicitarEntradaVideochamadaMutation, Types.SolicitarEntradaVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SolicitarEntradaVideochamadaMutation, Types.SolicitarEntradaVideochamadaMutationVariables>(SolicitarEntradaVideochamadaDocument, options);
      }
export type SolicitarEntradaVideochamadaMutationHookResult = ReturnType<typeof useSolicitarEntradaVideochamadaMutation>;
export type SolicitarEntradaVideochamadaMutationResult = Apollo.MutationResult<Types.SolicitarEntradaVideochamadaMutation>;
export type SolicitarEntradaVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.SolicitarEntradaVideochamadaMutation, Types.SolicitarEntradaVideochamadaMutationVariables>;
export const ConfiguracaoVideochamadasDocument = gql`
    query ConfiguracaoVideochamadas {
  conexao {
    videochamadas {
      id
      habilitado
    }
  }
}
    `;

/**
 * __useConfiguracaoVideochamadasQuery__
 *
 * To run a query within a React component, call `useConfiguracaoVideochamadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoVideochamadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoVideochamadasQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoVideochamadasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>(ConfiguracaoVideochamadasDocument, options);
      }
export function useConfiguracaoVideochamadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>(ConfiguracaoVideochamadasDocument, options);
        }
export function useConfiguracaoVideochamadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>(ConfiguracaoVideochamadasDocument, options);
        }
export type ConfiguracaoVideochamadasQueryHookResult = ReturnType<typeof useConfiguracaoVideochamadasQuery>;
export type ConfiguracaoVideochamadasLazyQueryHookResult = ReturnType<typeof useConfiguracaoVideochamadasLazyQuery>;
export type ConfiguracaoVideochamadasSuspenseQueryHookResult = ReturnType<typeof useConfiguracaoVideochamadasSuspenseQuery>;
export type ConfiguracaoVideochamadasQueryResult = Apollo.QueryResult<Types.ConfiguracaoVideochamadasQuery, Types.ConfiguracaoVideochamadasQueryVariables>;
export const ConfiguracoesIceServersDocument = gql`
    query ConfiguracoesIceServers($input: IceServersConfigurationInput!) {
  iceServersConfiguration(input: $input) {
    urls
    user
    password
  }
}
    `;

/**
 * __useConfiguracoesIceServersQuery__
 *
 * To run a query within a React component, call `useConfiguracoesIceServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracoesIceServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracoesIceServersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfiguracoesIceServersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables> & ({ variables: Types.ConfiguracoesIceServersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>(ConfiguracoesIceServersDocument, options);
      }
export function useConfiguracoesIceServersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>(ConfiguracoesIceServersDocument, options);
        }
export function useConfiguracoesIceServersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>(ConfiguracoesIceServersDocument, options);
        }
export type ConfiguracoesIceServersQueryHookResult = ReturnType<typeof useConfiguracoesIceServersQuery>;
export type ConfiguracoesIceServersLazyQueryHookResult = ReturnType<typeof useConfiguracoesIceServersLazyQuery>;
export type ConfiguracoesIceServersSuspenseQueryHookResult = ReturnType<typeof useConfiguracoesIceServersSuspenseQuery>;
export type ConfiguracoesIceServersQueryResult = Apollo.QueryResult<Types.ConfiguracoesIceServersQuery, Types.ConfiguracoesIceServersQueryVariables>;
export const IsParticipantePermitidoVideochamadaDocument = gql`
    query IsParticipantePermitidoVideochamada($input: VerificarParticipantePermitidoVideochamadaInput!) {
  isParticipantePermitidoVideochamada(input: $input)
}
    `;

/**
 * __useIsParticipantePermitidoVideochamadaQuery__
 *
 * To run a query within a React component, call `useIsParticipantePermitidoVideochamadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsParticipantePermitidoVideochamadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsParticipantePermitidoVideochamadaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsParticipantePermitidoVideochamadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables> & ({ variables: Types.IsParticipantePermitidoVideochamadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>(IsParticipantePermitidoVideochamadaDocument, options);
      }
export function useIsParticipantePermitidoVideochamadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>(IsParticipantePermitidoVideochamadaDocument, options);
        }
export function useIsParticipantePermitidoVideochamadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>(IsParticipantePermitidoVideochamadaDocument, options);
        }
export type IsParticipantePermitidoVideochamadaQueryHookResult = ReturnType<typeof useIsParticipantePermitidoVideochamadaQuery>;
export type IsParticipantePermitidoVideochamadaLazyQueryHookResult = ReturnType<typeof useIsParticipantePermitidoVideochamadaLazyQuery>;
export type IsParticipantePermitidoVideochamadaSuspenseQueryHookResult = ReturnType<typeof useIsParticipantePermitidoVideochamadaSuspenseQuery>;
export type IsParticipantePermitidoVideochamadaQueryResult = Apollo.QueryResult<Types.IsParticipantePermitidoVideochamadaQuery, Types.IsParticipantePermitidoVideochamadaQueryVariables>;
export const NotificarConexaoVideochamadaFalhouDocument = gql`
    mutation NotificarConexaoVideochamadaFalhou($videochamadaUuid: String!) {
  notifyConexaoVideochamadaFalhou(videochamadaUuid: $videochamadaUuid)
}
    `;
export type NotificarConexaoVideochamadaFalhouMutationFn = Apollo.MutationFunction<Types.NotificarConexaoVideochamadaFalhouMutation, Types.NotificarConexaoVideochamadaFalhouMutationVariables>;

/**
 * __useNotificarConexaoVideochamadaFalhouMutation__
 *
 * To run a mutation, you first call `useNotificarConexaoVideochamadaFalhouMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificarConexaoVideochamadaFalhouMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificarConexaoVideochamadaFalhouMutation, { data, loading, error }] = useNotificarConexaoVideochamadaFalhouMutation({
 *   variables: {
 *      videochamadaUuid: // value for 'videochamadaUuid'
 *   },
 * });
 */
export function useNotificarConexaoVideochamadaFalhouMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.NotificarConexaoVideochamadaFalhouMutation, Types.NotificarConexaoVideochamadaFalhouMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.NotificarConexaoVideochamadaFalhouMutation, Types.NotificarConexaoVideochamadaFalhouMutationVariables>(NotificarConexaoVideochamadaFalhouDocument, options);
      }
export type NotificarConexaoVideochamadaFalhouMutationHookResult = ReturnType<typeof useNotificarConexaoVideochamadaFalhouMutation>;
export type NotificarConexaoVideochamadaFalhouMutationResult = Apollo.MutationResult<Types.NotificarConexaoVideochamadaFalhouMutation>;
export type NotificarConexaoVideochamadaFalhouMutationOptions = Apollo.BaseMutationOptions<Types.NotificarConexaoVideochamadaFalhouMutation, Types.NotificarConexaoVideochamadaFalhouMutationVariables>;
export const NotificarEntradaParticipanteVideochamadaDocument = gql`
    mutation NotificarEntradaParticipanteVideochamada($videochamadaUuid: String!, $participanteId: ID!, $nomeParticipante: String!) {
  notifyEntradaParticipanteVideochamada(
    videochamadaUuid: $videochamadaUuid
    participanteId: $participanteId
    nomeParticipante: $nomeParticipante
  )
}
    `;
export type NotificarEntradaParticipanteVideochamadaMutationFn = Apollo.MutationFunction<Types.NotificarEntradaParticipanteVideochamadaMutation, Types.NotificarEntradaParticipanteVideochamadaMutationVariables>;

/**
 * __useNotificarEntradaParticipanteVideochamadaMutation__
 *
 * To run a mutation, you first call `useNotificarEntradaParticipanteVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificarEntradaParticipanteVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificarEntradaParticipanteVideochamadaMutation, { data, loading, error }] = useNotificarEntradaParticipanteVideochamadaMutation({
 *   variables: {
 *      videochamadaUuid: // value for 'videochamadaUuid'
 *      participanteId: // value for 'participanteId'
 *      nomeParticipante: // value for 'nomeParticipante'
 *   },
 * });
 */
export function useNotificarEntradaParticipanteVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.NotificarEntradaParticipanteVideochamadaMutation, Types.NotificarEntradaParticipanteVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.NotificarEntradaParticipanteVideochamadaMutation, Types.NotificarEntradaParticipanteVideochamadaMutationVariables>(NotificarEntradaParticipanteVideochamadaDocument, options);
      }
export type NotificarEntradaParticipanteVideochamadaMutationHookResult = ReturnType<typeof useNotificarEntradaParticipanteVideochamadaMutation>;
export type NotificarEntradaParticipanteVideochamadaMutationResult = Apollo.MutationResult<Types.NotificarEntradaParticipanteVideochamadaMutation>;
export type NotificarEntradaParticipanteVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.NotificarEntradaParticipanteVideochamadaMutation, Types.NotificarEntradaParticipanteVideochamadaMutationVariables>;
export const NotificarSaidaDonoVideochamadaDocument = gql`
    mutation NotificarSaidaDonoVideochamada($videochamadaUuid: String!) {
  notifySaidaDonoVideochamada(videochamadaUuid: $videochamadaUuid)
}
    `;
export type NotificarSaidaDonoVideochamadaMutationFn = Apollo.MutationFunction<Types.NotificarSaidaDonoVideochamadaMutation, Types.NotificarSaidaDonoVideochamadaMutationVariables>;

/**
 * __useNotificarSaidaDonoVideochamadaMutation__
 *
 * To run a mutation, you first call `useNotificarSaidaDonoVideochamadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificarSaidaDonoVideochamadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificarSaidaDonoVideochamadaMutation, { data, loading, error }] = useNotificarSaidaDonoVideochamadaMutation({
 *   variables: {
 *      videochamadaUuid: // value for 'videochamadaUuid'
 *   },
 * });
 */
export function useNotificarSaidaDonoVideochamadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.NotificarSaidaDonoVideochamadaMutation, Types.NotificarSaidaDonoVideochamadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.NotificarSaidaDonoVideochamadaMutation, Types.NotificarSaidaDonoVideochamadaMutationVariables>(NotificarSaidaDonoVideochamadaDocument, options);
      }
export type NotificarSaidaDonoVideochamadaMutationHookResult = ReturnType<typeof useNotificarSaidaDonoVideochamadaMutation>;
export type NotificarSaidaDonoVideochamadaMutationResult = Apollo.MutationResult<Types.NotificarSaidaDonoVideochamadaMutation>;
export type NotificarSaidaDonoVideochamadaMutationOptions = Apollo.BaseMutationOptions<Types.NotificarSaidaDonoVideochamadaMutation, Types.NotificarSaidaDonoVideochamadaMutationVariables>;
export const NotificarVideochamadaLotadaDocument = gql`
    mutation NotificarVideochamadaLotada($videochamadaUuid: String!, $lotada: Boolean!) {
  notifyVideochamadaLotada(videochamadaUuid: $videochamadaUuid, lotada: $lotada)
}
    `;
export type NotificarVideochamadaLotadaMutationFn = Apollo.MutationFunction<Types.NotificarVideochamadaLotadaMutation, Types.NotificarVideochamadaLotadaMutationVariables>;

/**
 * __useNotificarVideochamadaLotadaMutation__
 *
 * To run a mutation, you first call `useNotificarVideochamadaLotadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificarVideochamadaLotadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificarVideochamadaLotadaMutation, { data, loading, error }] = useNotificarVideochamadaLotadaMutation({
 *   variables: {
 *      videochamadaUuid: // value for 'videochamadaUuid'
 *      lotada: // value for 'lotada'
 *   },
 * });
 */
export function useNotificarVideochamadaLotadaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.NotificarVideochamadaLotadaMutation, Types.NotificarVideochamadaLotadaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.NotificarVideochamadaLotadaMutation, Types.NotificarVideochamadaLotadaMutationVariables>(NotificarVideochamadaLotadaDocument, options);
      }
export type NotificarVideochamadaLotadaMutationHookResult = ReturnType<typeof useNotificarVideochamadaLotadaMutation>;
export type NotificarVideochamadaLotadaMutationResult = Apollo.MutationResult<Types.NotificarVideochamadaLotadaMutation>;
export type NotificarVideochamadaLotadaMutationOptions = Apollo.BaseMutationOptions<Types.NotificarVideochamadaLotadaMutation, Types.NotificarVideochamadaLotadaMutationVariables>;
export const StatusVideochamadaDocument = gql`
    query StatusVideochamada($uuid: String!) {
  videochamada(uuid: $uuid) {
    id
    status
  }
}
    `;

/**
 * __useStatusVideochamadaQuery__
 *
 * To run a query within a React component, call `useStatusVideochamadaQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusVideochamadaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusVideochamadaQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useStatusVideochamadaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables> & ({ variables: Types.StatusVideochamadaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>(StatusVideochamadaDocument, options);
      }
export function useStatusVideochamadaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>(StatusVideochamadaDocument, options);
        }
export function useStatusVideochamadaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>(StatusVideochamadaDocument, options);
        }
export type StatusVideochamadaQueryHookResult = ReturnType<typeof useStatusVideochamadaQuery>;
export type StatusVideochamadaLazyQueryHookResult = ReturnType<typeof useStatusVideochamadaLazyQuery>;
export type StatusVideochamadaSuspenseQueryHookResult = ReturnType<typeof useStatusVideochamadaSuspenseQuery>;
export type StatusVideochamadaQueryResult = Apollo.QueryResult<Types.StatusVideochamadaQuery, Types.StatusVideochamadaQueryVariables>;
export const EquipesVinculadasTableDocument = gql`
    query EquipesVinculadasTable($input: EquipesQueryInput!) {
  equipesVinculadas(input: $input) {
    content {
      id
      nome
      ine
      area
      tipoEquipe {
        id
        nome
        sigla
      }
      ativo
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useEquipesVinculadasTableQuery__
 *
 * To run a query within a React component, call `useEquipesVinculadasTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipesVinculadasTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipesVinculadasTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipesVinculadasTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables> & ({ variables: Types.EquipesVinculadasTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>(EquipesVinculadasTableDocument, options);
      }
export function useEquipesVinculadasTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>(EquipesVinculadasTableDocument, options);
        }
export function useEquipesVinculadasTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>(EquipesVinculadasTableDocument, options);
        }
export type EquipesVinculadasTableQueryHookResult = ReturnType<typeof useEquipesVinculadasTableQuery>;
export type EquipesVinculadasTableLazyQueryHookResult = ReturnType<typeof useEquipesVinculadasTableLazyQuery>;
export type EquipesVinculadasTableSuspenseQueryHookResult = ReturnType<typeof useEquipesVinculadasTableSuspenseQuery>;
export type EquipesVinculadasTableQueryResult = Apollo.QueryResult<Types.EquipesVinculadasTableQuery, Types.EquipesVinculadasTableQueryVariables>;
export const HasEquipesVinculadasDocument = gql`
    query HasEquipesVinculadas($equipePrincipalId: ID!) {
  hasEquipesVinculadas(equipePrincipalId: $equipePrincipalId)
}
    `;

/**
 * __useHasEquipesVinculadasQuery__
 *
 * To run a query within a React component, call `useHasEquipesVinculadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasEquipesVinculadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasEquipesVinculadasQuery({
 *   variables: {
 *      equipePrincipalId: // value for 'equipePrincipalId'
 *   },
 * });
 */
export function useHasEquipesVinculadasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables> & ({ variables: Types.HasEquipesVinculadasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>(HasEquipesVinculadasDocument, options);
      }
export function useHasEquipesVinculadasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>(HasEquipesVinculadasDocument, options);
        }
export function useHasEquipesVinculadasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>(HasEquipesVinculadasDocument, options);
        }
export type HasEquipesVinculadasQueryHookResult = ReturnType<typeof useHasEquipesVinculadasQuery>;
export type HasEquipesVinculadasLazyQueryHookResult = ReturnType<typeof useHasEquipesVinculadasLazyQuery>;
export type HasEquipesVinculadasSuspenseQueryHookResult = ReturnType<typeof useHasEquipesVinculadasSuspenseQuery>;
export type HasEquipesVinculadasQueryResult = Apollo.QueryResult<Types.HasEquipesVinculadasQuery, Types.HasEquipesVinculadasQueryVariables>;
export const FamiliasImovelDocument = gql`
    query FamiliasImovel($input: ID!) {
  imovel(imovelId: $input) {
    id
    familias {
      id
      cnes
      ine
      numeroProntuarioFamiliar
      rendaFamiliar
      resideDesde
      equipe {
        id
        nome
      }
      numeroMembros
      cpfCnsResponsavel
      isResponsavelCadastrado
      isResponsavelDeclarado
      isResponsavelVivo
      isResponsavelUnico
      isResponsavelAindaReside
      isFamiliaAindaReside
      isInformacaoSuficiente
      isDomicilioAtivo
      cidadaosTerritorioBasico(input: {mostrarInconsistentes: true}) {
        id
        nome
        nomeSocial
        sexo
        dataNascimento
        cpf
        cns
        telefoneCelular
        telefoneContato
        isFaleceu
        ultimaFichaCadastrada {
          id
          isProcessado
        }
        cidadaoNucleoFamiliar {
          id
          grauParentescoResponsavelFamiliar
        }
      }
    }
  }
}
    `;

/**
 * __useFamiliasImovelQuery__
 *
 * To run a query within a React component, call `useFamiliasImovelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFamiliasImovelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFamiliasImovelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFamiliasImovelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables> & ({ variables: Types.FamiliasImovelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>(FamiliasImovelDocument, options);
      }
export function useFamiliasImovelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>(FamiliasImovelDocument, options);
        }
export function useFamiliasImovelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>(FamiliasImovelDocument, options);
        }
export type FamiliasImovelQueryHookResult = ReturnType<typeof useFamiliasImovelQuery>;
export type FamiliasImovelLazyQueryHookResult = ReturnType<typeof useFamiliasImovelLazyQuery>;
export type FamiliasImovelSuspenseQueryHookResult = ReturnType<typeof useFamiliasImovelSuspenseQuery>;
export type FamiliasImovelQueryResult = Apollo.QueryResult<Types.FamiliasImovelQuery, Types.FamiliasImovelQueryVariables>;
export const ImovelInformacoesCadastraisDocument = gql`
    query ImovelInformacoesCadastrais($input: ID!) {
  imovel(imovelId: $input) {
    id
    tipoImovel
    telefoneContato
    telefoneResidencial
    dataUltimaVisita
    unidadeSaude {
      id
      nome
      cnes
    }
    equipe {
      id
      nome
      ine
      isAD
    }
    profissional {
      id
      nome
      nomeSocial
      cns
      cpf
    }
    cbo {
      id
      nome
      cbo2002
    }
    microarea
    ultimaVisitaComAnotacao {
      id
      anotacoes
      dataVisita
    }
    ...CondicoesMoradiaFragment
    ...AnimaisDomicilioFragment
    ultimaFichaCadastrada {
      id
      isProcessado
    }
    responsavelTecnico {
      id
      nome
      contato
      cns
      cargo
    }
    nomeInstituicaoPermanencia
    statusRecusa
    tipoEndereco
  }
}
    ${CondicoesMoradiaFragmentFragmentDoc}
${AnimaisDomicilioFragmentFragmentDoc}`;

/**
 * __useImovelInformacoesCadastraisQuery__
 *
 * To run a query within a React component, call `useImovelInformacoesCadastraisQuery` and pass it any options that fit your needs.
 * When your component renders, `useImovelInformacoesCadastraisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImovelInformacoesCadastraisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImovelInformacoesCadastraisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables> & ({ variables: Types.ImovelInformacoesCadastraisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>(ImovelInformacoesCadastraisDocument, options);
      }
export function useImovelInformacoesCadastraisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>(ImovelInformacoesCadastraisDocument, options);
        }
export function useImovelInformacoesCadastraisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>(ImovelInformacoesCadastraisDocument, options);
        }
export type ImovelInformacoesCadastraisQueryHookResult = ReturnType<typeof useImovelInformacoesCadastraisQuery>;
export type ImovelInformacoesCadastraisLazyQueryHookResult = ReturnType<typeof useImovelInformacoesCadastraisLazyQuery>;
export type ImovelInformacoesCadastraisSuspenseQueryHookResult = ReturnType<typeof useImovelInformacoesCadastraisSuspenseQuery>;
export type ImovelInformacoesCadastraisQueryResult = Apollo.QueryResult<Types.ImovelInformacoesCadastraisQuery, Types.ImovelInformacoesCadastraisQueryVariables>;
export const VisualizarImovelHeaderDocument = gql`
    query VisualizarImovelHeader($input: ID!) {
  imovel(imovelId: $input) {
    id
    tipoImovel
    condicoesMoradia {
      id
      tipoLocalizacao
      tipoDomicilio
    }
    tipoLogradouro {
      id
      nome
    }
    logradouro
    numero
    semNumero
    complemento
    bairro
    cep
    microarea
    telefoneResidencial
    telefoneContato
    dataUltimaAtualizacao
    isCadastroCompleto
    latitude
    longitude
    municipio {
      id
      nome
      uf {
        id
        sigla
      }
    }
    aldeia {
      id
      nome
    }
    poloBase {
      id
      nome
    }
    dsei {
      id
      nome
    }
    tipoEndereco
    numeroResidenciaIndigena
    statusRecusa
    stAtivo
  }
}
    `;

/**
 * __useVisualizarImovelHeaderQuery__
 *
 * To run a query within a React component, call `useVisualizarImovelHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizarImovelHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizarImovelHeaderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisualizarImovelHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables> & ({ variables: Types.VisualizarImovelHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>(VisualizarImovelHeaderDocument, options);
      }
export function useVisualizarImovelHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>(VisualizarImovelHeaderDocument, options);
        }
export function useVisualizarImovelHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>(VisualizarImovelHeaderDocument, options);
        }
export type VisualizarImovelHeaderQueryHookResult = ReturnType<typeof useVisualizarImovelHeaderQuery>;
export type VisualizarImovelHeaderLazyQueryHookResult = ReturnType<typeof useVisualizarImovelHeaderLazyQuery>;
export type VisualizarImovelHeaderSuspenseQueryHookResult = ReturnType<typeof useVisualizarImovelHeaderSuspenseQuery>;
export type VisualizarImovelHeaderQueryResult = Apollo.QueryResult<Types.VisualizarImovelHeaderQuery, Types.VisualizarImovelHeaderQueryVariables>;
export const ImovelUltimasVisitasDocument = gql`
    query ImovelUltimasVisitas($input: VisitasQueryInput!, $imovelId: ID!) {
  visitas(input: $input) {
    content {
      id
      nuUuidFicha
      dataVisita
      dimensaoProfissional {
        id
        nome
      }
      dimensaoEquipe {
        id
        nome
        ine
      }
      dimensaoCbo {
        id
        nome
        cbo
      }
      motivoVisita
      buscaAtiva
      acompanhamento
      controleAmbiental
      dimensaoDesfechoVisita {
        id
        numeroIdentificador
        descricao
      }
      tipoOrigem {
        id
        nome
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
  imovel(imovelId: $imovelId) {
    id
    tipoImovel
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useImovelUltimasVisitasQuery__
 *
 * To run a query within a React component, call `useImovelUltimasVisitasQuery` and pass it any options that fit your needs.
 * When your component renders, `useImovelUltimasVisitasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImovelUltimasVisitasQuery({
 *   variables: {
 *      input: // value for 'input'
 *      imovelId: // value for 'imovelId'
 *   },
 * });
 */
export function useImovelUltimasVisitasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables> & ({ variables: Types.ImovelUltimasVisitasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>(ImovelUltimasVisitasDocument, options);
      }
export function useImovelUltimasVisitasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>(ImovelUltimasVisitasDocument, options);
        }
export function useImovelUltimasVisitasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>(ImovelUltimasVisitasDocument, options);
        }
export type ImovelUltimasVisitasQueryHookResult = ReturnType<typeof useImovelUltimasVisitasQuery>;
export type ImovelUltimasVisitasLazyQueryHookResult = ReturnType<typeof useImovelUltimasVisitasLazyQuery>;
export type ImovelUltimasVisitasSuspenseQueryHookResult = ReturnType<typeof useImovelUltimasVisitasSuspenseQuery>;
export type ImovelUltimasVisitasQueryResult = Apollo.QueryResult<Types.ImovelUltimasVisitasQuery, Types.ImovelUltimasVisitasQueryVariables>;
export const ImovelVisitaDocument = gql`
    query ImovelVisita($input: ID!) {
  visita(id: $input) {
    id
    nuUuidFicha
    dataVisita
    cpfCidadao
    cnsCidadao
    dimensaoSexo {
      id
      descricao
    }
    dataNascimentoCidadao
    cidadaoPec {
      id
      nome
      nomeSocial
      cpf
      cns
      dimensaoSexo {
        id
        descricao
      }
      dataNascimento
    }
    dimensaoProfissional {
      id
      cns
      nome
    }
    dimensaoUnidadeSaude {
      id
      nome
      cnes
    }
    dimensaoEquipe {
      id
      nome
      ine
    }
    dimensaoCbo {
      id
      nome
      cbo
    }
    dimensaoTipoGlicemia {
      id
      descricao
      numeroIdentificador
    }
    tipoOrigem {
      id
      nome
    }
    turno {
      id
      descricao
    }
    motivoVisita
    dimensaoDesfechoVisita {
      id
      numeroIdentificador
      descricao
    }
    anotacoes
    buscaAtiva
    acompanhamento
    controleAmbiental
    peso
    altura
    temperatura
    medicaoGlicemia
    medicaoPressaoArterial
    stVisitaCompartilhada
    latitude
    longitude
  }
}
    `;

/**
 * __useImovelVisitaQuery__
 *
 * To run a query within a React component, call `useImovelVisitaQuery` and pass it any options that fit your needs.
 * When your component renders, `useImovelVisitaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImovelVisitaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImovelVisitaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables> & ({ variables: Types.ImovelVisitaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>(ImovelVisitaDocument, options);
      }
export function useImovelVisitaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>(ImovelVisitaDocument, options);
        }
export function useImovelVisitaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>(ImovelVisitaDocument, options);
        }
export type ImovelVisitaQueryHookResult = ReturnType<typeof useImovelVisitaQuery>;
export type ImovelVisitaLazyQueryHookResult = ReturnType<typeof useImovelVisitaLazyQuery>;
export type ImovelVisitaSuspenseQueryHookResult = ReturnType<typeof useImovelVisitaSuspenseQuery>;
export type ImovelVisitaQueryResult = Apollo.QueryResult<Types.ImovelVisitaQuery, Types.ImovelVisitaQueryVariables>;
export const ImoveisPermissaoAtualizarDocument = gql`
    query imoveisPermissaoAtualizar($input: TerritorioMicroareaQueryInput!) {
  imoveisPermissaoAtualizar(input: $input) {
    totalImoveisPermitidos
    totalImoveis
  }
}
    `;

/**
 * __useImoveisPermissaoAtualizarQuery__
 *
 * To run a query within a React component, call `useImoveisPermissaoAtualizarQuery` and pass it any options that fit your needs.
 * When your component renders, `useImoveisPermissaoAtualizarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImoveisPermissaoAtualizarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImoveisPermissaoAtualizarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables> & ({ variables: Types.ImoveisPermissaoAtualizarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>(ImoveisPermissaoAtualizarDocument, options);
      }
export function useImoveisPermissaoAtualizarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>(ImoveisPermissaoAtualizarDocument, options);
        }
export function useImoveisPermissaoAtualizarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>(ImoveisPermissaoAtualizarDocument, options);
        }
export type ImoveisPermissaoAtualizarQueryHookResult = ReturnType<typeof useImoveisPermissaoAtualizarQuery>;
export type ImoveisPermissaoAtualizarLazyQueryHookResult = ReturnType<typeof useImoveisPermissaoAtualizarLazyQuery>;
export type ImoveisPermissaoAtualizarSuspenseQueryHookResult = ReturnType<typeof useImoveisPermissaoAtualizarSuspenseQuery>;
export type ImoveisPermissaoAtualizarQueryResult = Apollo.QueryResult<Types.ImoveisPermissaoAtualizarQuery, Types.ImoveisPermissaoAtualizarQueryVariables>;
export const AtualizarEnderecoLogradouroDocument = gql`
    mutation AtualizarEnderecoLogradouro($input: AtualizarEnderecoTerritorioInput!) {
  atualizarEnderecoTerritorio(input: $input)
}
    `;
export type AtualizarEnderecoLogradouroMutationFn = Apollo.MutationFunction<Types.AtualizarEnderecoLogradouroMutation, Types.AtualizarEnderecoLogradouroMutationVariables>;

/**
 * __useAtualizarEnderecoLogradouroMutation__
 *
 * To run a mutation, you first call `useAtualizarEnderecoLogradouroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarEnderecoLogradouroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarEnderecoLogradouroMutation, { data, loading, error }] = useAtualizarEnderecoLogradouroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarEnderecoLogradouroMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtualizarEnderecoLogradouroMutation, Types.AtualizarEnderecoLogradouroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtualizarEnderecoLogradouroMutation, Types.AtualizarEnderecoLogradouroMutationVariables>(AtualizarEnderecoLogradouroDocument, options);
      }
export type AtualizarEnderecoLogradouroMutationHookResult = ReturnType<typeof useAtualizarEnderecoLogradouroMutation>;
export type AtualizarEnderecoLogradouroMutationResult = Apollo.MutationResult<Types.AtualizarEnderecoLogradouroMutation>;
export type AtualizarEnderecoLogradouroMutationOptions = Apollo.BaseMutationOptions<Types.AtualizarEnderecoLogradouroMutation, Types.AtualizarEnderecoLogradouroMutationVariables>;
export const PinosTerritorioDocument = gql`
    query PinosTerritorio($input: PinosTerritorioQueryInput!) {
  pinosTerritorio(input: $input) {
    total
    totalImoveisSemCoordenadas
    totalImoveisComCoordenadas
    content {
      id
      uuidDomicilio
      bairro
      logradouro
      complemento
      pontoReferencia
      cep
      microarea
      statusForaArea
      numero
      semNumero
      tipoImovel
      numeroMoradores
      dataUltimaAtualizacao
      nomeInstituicaoPermanencia
      possuiOutrosProfsVinculados
      isCadastroCompleto
      dataUltimaVisita
      latitude
      longitude
      statusRecusa
      possuiInconsistencia
      stAtivo
      tipoEndereco
      condicoesMoradia {
        id
        tipoDomicilio
      }
      municipio {
        id
        nome
      }
      uf {
        id
        nome
        sigla
      }
    }
  }
}
    `;

/**
 * __usePinosTerritorioQuery__
 *
 * To run a query within a React component, call `usePinosTerritorioQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinosTerritorioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinosTerritorioQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinosTerritorioQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables> & ({ variables: Types.PinosTerritorioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>(PinosTerritorioDocument, options);
      }
export function usePinosTerritorioLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>(PinosTerritorioDocument, options);
        }
export function usePinosTerritorioSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>(PinosTerritorioDocument, options);
        }
export type PinosTerritorioQueryHookResult = ReturnType<typeof usePinosTerritorioQuery>;
export type PinosTerritorioLazyQueryHookResult = ReturnType<typeof usePinosTerritorioLazyQuery>;
export type PinosTerritorioSuspenseQueryHookResult = ReturnType<typeof usePinosTerritorioSuspenseQuery>;
export type PinosTerritorioQueryResult = Apollo.QueryResult<Types.PinosTerritorioQuery, Types.PinosTerritorioQueryVariables>;
export const ProcessarUltimaFichaCidadaosTerritorioDocument = gql`
    mutation ProcessarUltimaFichaCidadaosTerritorio($input: [ID!]!) {
  processarCidadaosTerritorio(cidadaosIds: $input)
}
    `;
export type ProcessarUltimaFichaCidadaosTerritorioMutationFn = Apollo.MutationFunction<Types.ProcessarUltimaFichaCidadaosTerritorioMutation, Types.ProcessarUltimaFichaCidadaosTerritorioMutationVariables>;

/**
 * __useProcessarUltimaFichaCidadaosTerritorioMutation__
 *
 * To run a mutation, you first call `useProcessarUltimaFichaCidadaosTerritorioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessarUltimaFichaCidadaosTerritorioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processarUltimaFichaCidadaosTerritorioMutation, { data, loading, error }] = useProcessarUltimaFichaCidadaosTerritorioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessarUltimaFichaCidadaosTerritorioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ProcessarUltimaFichaCidadaosTerritorioMutation, Types.ProcessarUltimaFichaCidadaosTerritorioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ProcessarUltimaFichaCidadaosTerritorioMutation, Types.ProcessarUltimaFichaCidadaosTerritorioMutationVariables>(ProcessarUltimaFichaCidadaosTerritorioDocument, options);
      }
export type ProcessarUltimaFichaCidadaosTerritorioMutationHookResult = ReturnType<typeof useProcessarUltimaFichaCidadaosTerritorioMutation>;
export type ProcessarUltimaFichaCidadaosTerritorioMutationResult = Apollo.MutationResult<Types.ProcessarUltimaFichaCidadaosTerritorioMutation>;
export type ProcessarUltimaFichaCidadaosTerritorioMutationOptions = Apollo.BaseMutationOptions<Types.ProcessarUltimaFichaCidadaosTerritorioMutation, Types.ProcessarUltimaFichaCidadaosTerritorioMutationVariables>;
export const ProcessarUltimaFichaTerritorioDocument = gql`
    mutation ProcessarUltimaFichaTerritorio($input: ID!) {
  processarTerritorio(imovelId: $input)
}
    `;
export type ProcessarUltimaFichaTerritorioMutationFn = Apollo.MutationFunction<Types.ProcessarUltimaFichaTerritorioMutation, Types.ProcessarUltimaFichaTerritorioMutationVariables>;

/**
 * __useProcessarUltimaFichaTerritorioMutation__
 *
 * To run a mutation, you first call `useProcessarUltimaFichaTerritorioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessarUltimaFichaTerritorioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processarUltimaFichaTerritorioMutation, { data, loading, error }] = useProcessarUltimaFichaTerritorioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessarUltimaFichaTerritorioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ProcessarUltimaFichaTerritorioMutation, Types.ProcessarUltimaFichaTerritorioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ProcessarUltimaFichaTerritorioMutation, Types.ProcessarUltimaFichaTerritorioMutationVariables>(ProcessarUltimaFichaTerritorioDocument, options);
      }
export type ProcessarUltimaFichaTerritorioMutationHookResult = ReturnType<typeof useProcessarUltimaFichaTerritorioMutation>;
export type ProcessarUltimaFichaTerritorioMutationResult = Apollo.MutationResult<Types.ProcessarUltimaFichaTerritorioMutation>;
export type ProcessarUltimaFichaTerritorioMutationOptions = Apollo.BaseMutationOptions<Types.ProcessarUltimaFichaTerritorioMutation, Types.ProcessarUltimaFichaTerritorioMutationVariables>;
export const TerritorioMapaImovelDocument = gql`
    query TerritorioMapaImovel($id: ID!) {
  imovel(imovelId: $id) {
    id
    tipoImovel
    dataUltimaVisita
    numeroMoradores
    complemento
    possuiOutrosProfsVinculados
    ultimaFichaCadastrada {
      id
      isProcessado
    }
    dataUltimaAtualizacao
    condicoesMoradia {
      id
      tipoLocalizacao
      tipoDomicilio
    }
    tipoLogradouro {
      id
      nome
    }
    logradouro
    numero
    bairro
    cep
    telefoneContato
    telefoneResidencial
    familias {
      id
      numeroProntuarioFamiliar
      cpfCnsResponsavel
      isFamiliaAindaReside
      isInformacaoSuficiente
      isDomicilioAtivo
      cidadaosTerritorioBasico(input: {mostrarInconsistentes: true}) {
        id
        nome
        nomeSocial
        sexo
        dataNascimento
        cpf
        cns
        isFaleceu
        telefoneCelular
        telefoneContato
        ultimaFichaCadastrada {
          id
          isProcessado
        }
        cidadaoNucleoFamiliar {
          id
          grauParentescoResponsavelFamiliar
        }
      }
    }
  }
}
    `;

/**
 * __useTerritorioMapaImovelQuery__
 *
 * To run a query within a React component, call `useTerritorioMapaImovelQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerritorioMapaImovelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerritorioMapaImovelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTerritorioMapaImovelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables> & ({ variables: Types.TerritorioMapaImovelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>(TerritorioMapaImovelDocument, options);
      }
export function useTerritorioMapaImovelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>(TerritorioMapaImovelDocument, options);
        }
export function useTerritorioMapaImovelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>(TerritorioMapaImovelDocument, options);
        }
export type TerritorioMapaImovelQueryHookResult = ReturnType<typeof useTerritorioMapaImovelQuery>;
export type TerritorioMapaImovelLazyQueryHookResult = ReturnType<typeof useTerritorioMapaImovelLazyQuery>;
export type TerritorioMapaImovelSuspenseQueryHookResult = ReturnType<typeof useTerritorioMapaImovelSuspenseQuery>;
export type TerritorioMapaImovelQueryResult = Apollo.QueryResult<Types.TerritorioMapaImovelQuery, Types.TerritorioMapaImovelQueryVariables>;
export const TerritorioMicroareaDocument = gql`
    query TerritorioMicroarea($input: TerritorioMicroareaQueryInput!) {
  territorioMicroarea(input: $input) {
    id
    logradouros {
      content {
        id
        logradouro
        tipoLogradouroId
        tipoLogradouroNome
        tipoLogradouroDne
        municipio {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        bairro
        cep
        aldeia {
          id
          nome
          poloBase {
            ...PoloBase
          }
          municipio {
            ...Municipio
          }
        }
        poloBase {
          ...PoloBase
        }
        dsei {
          id
          nome
        }
        municipioAldeia {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        tipoEndereco
        numeroImoveis
      }
      pageInfo {
        ...PageInfo
      }
    }
    indices {
      quantidadeImoveisCadastroCompleto
      totalImoveisNaoRecusados
      quantidadeImoveisAtualizados
      totalImoveisAtualizados
      quantidadeDomiciliosAvaliados
      quantidadeDomiciliosVisitados
    }
  }
}
    ${PoloBaseFragmentDoc}
${MunicipioFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useTerritorioMicroareaQuery__
 *
 * To run a query within a React component, call `useTerritorioMicroareaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerritorioMicroareaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerritorioMicroareaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTerritorioMicroareaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables> & ({ variables: Types.TerritorioMicroareaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>(TerritorioMicroareaDocument, options);
      }
export function useTerritorioMicroareaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>(TerritorioMicroareaDocument, options);
        }
export function useTerritorioMicroareaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>(TerritorioMicroareaDocument, options);
        }
export type TerritorioMicroareaQueryHookResult = ReturnType<typeof useTerritorioMicroareaQuery>;
export type TerritorioMicroareaLazyQueryHookResult = ReturnType<typeof useTerritorioMicroareaLazyQuery>;
export type TerritorioMicroareaSuspenseQueryHookResult = ReturnType<typeof useTerritorioMicroareaSuspenseQuery>;
export type TerritorioMicroareaQueryResult = Apollo.QueryResult<Types.TerritorioMicroareaQuery, Types.TerritorioMicroareaQueryVariables>;
export const VisualizacaoTerritorialDocument = gql`
    query VisualizacaoTerritorial($input: TerritorioEquipeQueryInput!) {
  territorioEquipe(input: $input) {
    microareas
    poloBase {
      id
      nome
    }
    hasInativos
  }
}
    `;

/**
 * __useVisualizacaoTerritorialQuery__
 *
 * To run a query within a React component, call `useVisualizacaoTerritorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizacaoTerritorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizacaoTerritorialQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisualizacaoTerritorialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables> & ({ variables: Types.VisualizacaoTerritorialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>(VisualizacaoTerritorialDocument, options);
      }
export function useVisualizacaoTerritorialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>(VisualizacaoTerritorialDocument, options);
        }
export function useVisualizacaoTerritorialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>(VisualizacaoTerritorialDocument, options);
        }
export type VisualizacaoTerritorialQueryHookResult = ReturnType<typeof useVisualizacaoTerritorialQuery>;
export type VisualizacaoTerritorialLazyQueryHookResult = ReturnType<typeof useVisualizacaoTerritorialLazyQuery>;
export type VisualizacaoTerritorialSuspenseQueryHookResult = ReturnType<typeof useVisualizacaoTerritorialSuspenseQuery>;
export type VisualizacaoTerritorialQueryResult = Apollo.QueryResult<Types.VisualizacaoTerritorialQuery, Types.VisualizacaoTerritorialQueryVariables>;
export const VisualizarCidadaosImovelDocument = gql`
    query VisualizarCidadaosImovel($input: ID!) {
  imovel(imovelId: $input) {
    id
    uuidDomicilio
    ultimaFichaCadastrada {
      id
      isProcessado
    }
    dataUltimaVisita
    telefoneResidencial
    telefoneContato
    tipoLogradouro {
      id
      nome
    }
    tipoImovel
    logradouro
    numero
    complemento
    cep
    bairro
    familias {
      id
      cnes
      ine
      numeroProntuarioFamiliar
      cpfCnsResponsavel
      isResponsavelCadastrado
      isResponsavelDeclarado
      isResponsavelVivo
      isResponsavelUnico
      isResponsavelAindaReside
      isFamiliaAindaReside
      isInformacaoSuficiente
      isDomicilioAtivo
      cidadaosTerritorioBasico(input: {mostrarInconsistentes: true}) {
        id
        uuidCidadao
        nome
        nomeSocial
        sexo
        dataNascimento
        cpf
        cns
        telefoneCelular
        telefoneContato
        isFaleceu
        ultimaFichaCadastrada {
          id
          uuidFichaOrigem
          isProcessado
        }
      }
    }
    condicoesMoradia {
      id
      tipoLocalizacao
      tipoDomicilio
    }
    numeroMoradores
    dataUltimaAtualizacao
    responsavelTecnico {
      id
      nome
      contato
      cns
      cargo
    }
    aldeia {
      id
      nome
    }
    poloBase {
      id
      nome
    }
    dsei {
      id
      nome
    }
    tipoEndereco
    numeroResidenciaIndigena
  }
}
    `;

/**
 * __useVisualizarCidadaosImovelQuery__
 *
 * To run a query within a React component, call `useVisualizarCidadaosImovelQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizarCidadaosImovelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizarCidadaosImovelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisualizarCidadaosImovelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables> & ({ variables: Types.VisualizarCidadaosImovelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>(VisualizarCidadaosImovelDocument, options);
      }
export function useVisualizarCidadaosImovelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>(VisualizarCidadaosImovelDocument, options);
        }
export function useVisualizarCidadaosImovelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>(VisualizarCidadaosImovelDocument, options);
        }
export type VisualizarCidadaosImovelQueryHookResult = ReturnType<typeof useVisualizarCidadaosImovelQuery>;
export type VisualizarCidadaosImovelLazyQueryHookResult = ReturnType<typeof useVisualizarCidadaosImovelLazyQuery>;
export type VisualizarCidadaosImovelSuspenseQueryHookResult = ReturnType<typeof useVisualizarCidadaosImovelSuspenseQuery>;
export type VisualizarCidadaosImovelQueryResult = Apollo.QueryResult<Types.VisualizarCidadaosImovelQuery, Types.VisualizarCidadaosImovelQueryVariables>;
export const VisualizarImoveisDocument = gql`
    query VisualizarImoveis($input: TerritorioMicroareaQueryInput!) {
  territorioLogradouro(input: $input) {
    id
    uuidDomicilio
    numero
    complemento
    cep
    familias(
      input: {isDomicilioAtivo: true, isFamiliaAindaReside: true, isInformacaoSuficiente: true, isResponsavelAindaReside: true, isResponsavelCadastrado: true, isResponsavelDeclarado: true, isResponsavelUnico: true, isResponsavelVivo: true}
    ) {
      id
      responsavel {
        id
        nome
        nomeSocial
      }
      cidadaosTerritorioBasico {
        id
      }
    }
    tipoImovel
    responsavelTecnico {
      id
      nome
    }
    dataUltimaVisita
    ultimaFichaCadastrada {
      id
      isProcessado
    }
    condicoesMoradia {
      id
      tipoDomicilio
    }
    numeroMoradores
    dataUltimaAtualizacao
    isCadastroCompleto
    descricaoTipoDomicilio
    descricaoMaterialParede
    numeroResidenciaIndigena
    statusRecusa
    possuiInconsistencia
    stAtivo
  }
}
    `;

/**
 * __useVisualizarImoveisQuery__
 *
 * To run a query within a React component, call `useVisualizarImoveisQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizarImoveisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizarImoveisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisualizarImoveisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables> & ({ variables: Types.VisualizarImoveisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>(VisualizarImoveisDocument, options);
      }
export function useVisualizarImoveisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>(VisualizarImoveisDocument, options);
        }
export function useVisualizarImoveisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>(VisualizarImoveisDocument, options);
        }
export type VisualizarImoveisQueryHookResult = ReturnType<typeof useVisualizarImoveisQuery>;
export type VisualizarImoveisLazyQueryHookResult = ReturnType<typeof useVisualizarImoveisLazyQuery>;
export type VisualizarImoveisSuspenseQueryHookResult = ReturnType<typeof useVisualizarImoveisSuspenseQuery>;
export type VisualizarImoveisQueryResult = Apollo.QueryResult<Types.VisualizarImoveisQuery, Types.VisualizarImoveisQueryVariables>;